!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.1.0",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null!=a?a<0?this[a+this.length]:this[a]:f.call(this)},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=r.isArray(d)))?(e?(e=!1,f=c&&r.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=sa(function(a){return a.disabled===!0},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(a){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+ra(o[h]);r=o.join(","),s=$.test(a)&&pa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(a){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(a){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return function(b){return"label"in b&&b.disabled===a||"form"in b&&b.disabled===a||"form"in b&&b.disabled===!1&&(b.isDisabled===a||b.isDisabled!==!a&&("label"in b||!ea(b))!==a)}}function oa(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(a){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.escape=function(a){return(a+"").replace(ba,ca)},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return U.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:na(!1),disabled:na(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[c<0?c+b:c]}),even:oa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e)}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;d<e;d++)fa(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&xa(a.slice(i,e)),e<f&&xa(a=a.slice(e)),e<f&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=va(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(_,aa),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=V.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(_,aa),$.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return G.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||$.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext,B=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,C=/^.[^:#\[\.,]*$/;function D(a,b,c){if(r.isFunction(b))return r.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return r.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(C.test(b))return r.filter(b,a,c);b=r.filter(b,a)}return r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType})}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(D(this,a||[],!1))},not:function(a){return this.pushStack(D(this,a||[],!0))},is:function(a){return!!D(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var E,F=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,G=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||E,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:F.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),B.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};G.prototype=r.fn,E=r(d);var H=/^(?:parents|prev(?:Until|All))/,I={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function J(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return J(a,"nextSibling")},prev:function(a){return J(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return a.contentDocument||r.merge([],a.childNodes)}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(I[a]||r.uniqueSort(e),H.test(a)&&e.reverse()),this.pushStack(e)}});var K=/\S+/g;function L(a){var b={};return r.each(a.match(K)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?L(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function b(c){r.each(c,function(c,d){r.isFunction(d)?a.unique&&j.has(d)||f.push(d):d&&d.length&&"string"!==r.type(d)&&b(d)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function M(a){return a}function N(a){throw a}function O(a,b,c){var d;try{a&&r.isFunction(d=a.promise)?d.call(a).done(b).fail(c):a&&r.isFunction(d=a.then)?d.call(a,b,c):b.call(void 0,a)}catch(a){c.call(void 0,a)}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},catch:function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,M,e),g(f,c,N,e)):(f++,j.call(a,g(f,c,M,e),g(f,c,N,e),g(f,c,M,c.notifyWith))):(d!==M&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==N&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:M,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:M)),c[2][3].add(g(0,a,r.isFunction(d)?d:N))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(O(a,g.done(h(c)).resolve,g.reject),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)O(e[c],h(c),g.reject);return g.promise()}});var P=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&P.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var Q=r.Deferred();r.fn.ready=function(a){return Q.then(a).catch(function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,holdReady:function(a){a?r.readyWait++:r.ready(!0)},ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||Q.resolveWith(d,[r]))}}),r.ready.then=Q.then;function R(){d.removeEventListener("DOMContentLoaded",R),a.removeEventListener("load",R),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",R),a.addEventListener("load",R));var S=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)S(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,
r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},T=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function U(){this.expando=r.expando+U.uid++}U.uid=1,U.prototype={cache:function(a){var b=a[this.expando];return b||(b={},T(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){r.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(K)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var V=new U,W=new U,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Y=/[A-Z]/g;function Z(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Y,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c||"false"!==c&&("null"===c?null:+c+""===c?+c:X.test(c)?JSON.parse(c):c)}catch(a){}W.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return W.hasData(a)||V.hasData(a)},data:function(a,b,c){return W.access(a,b,c)},removeData:function(a,b){W.remove(a,b)},_data:function(a,b,c){return V.access(a,b,c)},_removeData:function(a,b){V.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=W.get(f),1===f.nodeType&&!V.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),Z(f,d,e[d])));V.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){W.set(this,a)}):S(this,function(b){var c;if(f&&void 0===b){if(c=W.get(f,a),void 0!==c)return c;if(c=Z(f,a),void 0!==c)return c}else this.each(function(){W.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){W.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=V.get(a,b),c&&(!d||r.isArray(c)?d=V.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return V.get(a,c)||V.access(a,c,{empty:r.Callbacks("once memory").add(function(){V.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=V.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var $=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,_=new RegExp("^(?:([+-])=|)("+$+")([a-z%]*)$","i"),aa=["Top","Right","Bottom","Left"],ba=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},ca=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function da(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&_.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ea={};function fa(a){var b,c=a.ownerDocument,d=a.nodeName,e=ea[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),ea[d]=e,e)}function ga(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=V.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&ba(d)&&(e[f]=fa(d))):"none"!==c&&(e[f]="none",V.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ga(this,!0)},hide:function(){return ga(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){ba(this)?r(this).show():r(this).hide()})}});var ha=/^(?:checkbox|radio)$/i,ia=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,ja=/^$|\/(?:java|ecma)script/i,ka={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ka.optgroup=ka.option,ka.tbody=ka.tfoot=ka.colgroup=ka.caption=ka.thead,ka.th=ka.td;function la(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&r.nodeName(a,b)?r.merge([a],c):c}function ma(a,b){for(var c=0,d=a.length;c<d;c++)V.set(a[c],"globalEval",!b||V.get(b[c],"globalEval"))}var na=/<|&#?\w+;/;function oa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(na.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ia.exec(f)||["",""])[1].toLowerCase(),i=ka[h]||ka._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=la(l.appendChild(f),"script"),j&&ma(g),c){k=0;while(f=g[k++])ja.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var pa=d.documentElement,qa=/^key/,ra=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,sa=/^([^.]*)(?:\.(.+)|)/;function ta(){return!0}function ua(){return!1}function va(){try{return d.activeElement}catch(a){}}function wa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)wa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ua;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(pa,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(K)||[""],j=b.length;while(j--)h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.hasData(a)&&V.get(a);if(q&&(i=q.events)){b=(b||"").match(K)||[""],j=b.length;while(j--)if(h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&V.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(V.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;c<h;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?r(e,this).index(i)>-1:r.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==va()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===va()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&r.nodeName(this,"input"))return this.click(),!1},_default:function(a){return r.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ta:ua,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:ua,isPropagationStopped:ua,isImmediatePropagationStopped:ua,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ta,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ta,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ta,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&qa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ra.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return wa(this,a,b,c,d)},one:function(a,b,c,d){return wa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ua),this.each(function(){r.event.remove(this,a,c,b)})}});var xa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ya=/<script|<style|<link/i,za=/checked\s*(?:[^=]|=\s*.checked.)/i,Aa=/^true\/(.*)/,Ba=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ca(a,b){return r.nodeName(a,"table")&&r.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function Da(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Ea(a){var b=Aa.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Fa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(V.hasData(a)&&(f=V.access(a),g=V.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}W.hasData(a)&&(h=W.access(a),i=r.extend({},h),W.set(b,i))}}function Ga(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ha.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ha(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&za.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ha(f,b,c,d)});if(m&&(e=oa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(la(e,"script"),Da),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,la(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ea),l=0;l<i;l++)j=h[l],ja.test(j.type||"")&&!V.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Ba,""),k))}return a}function Ia(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(la(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&ma(la(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(xa,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=la(h),f=la(a),d=0,e=f.length;d<e;d++)Ga(f[d],g[d]);if(b)if(c)for(f=f||la(a),g=g||la(h),d=0,e=f.length;d<e;d++)Fa(f[d],g[d]);else Fa(a,h);return g=la(h,"script"),g.length>0&&ma(g,!i&&la(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(T(c)){if(b=c[V.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[V.expando]=void 0}c[W.expando]&&(c[W.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ia(this,a,!0)},remove:function(a){return Ia(this,a)},text:function(a){return S(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.appendChild(a)}})},prepend:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(la(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return S(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!ya.test(a)&&!ka[(ia.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(la(b,!1)),b.innerHTML=a);b=0}catch(a){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ha(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(la(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var Ja=/^margin/,Ka=new RegExp("^("+$+")(?!px)[a-z%]+$","i"),La=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",pa.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,pa.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Ma(a,b,c){var d,e,f,g,h=a.style;return c=c||La(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ka.test(g)&&Ja.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Na(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Oa=/^(none|table(?!-c[ea]).+)/,Pa={position:"absolute",visibility:"hidden",display:"block"},Qa={letterSpacing:"0",fontWeight:"400"},Ra=["Webkit","Moz","ms"],Sa=d.createElement("div").style;function Ta(a){if(a in Sa)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ra.length;while(c--)if(a=Ra[c]+b,a in Sa)return a}function Ua(a,b,c){var d=_.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Va(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+aa[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+aa[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+aa[f]+"Width",!0,e))):(g+=r.css(a,"padding"+aa[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+aa[f]+"Width",!0,e)));return g}function Wa(a,b,c){var d,e=!0,f=La(a),g="border-box"===r.css(a,"boxSizing",!1,f);if(a.getClientRects().length&&(d=a.getBoundingClientRect()[b]),d<=0||null==d){if(d=Ma(a,b,f),(d<0||null==d)&&(d=a.style[b]),Ka.test(d))return d;e=g&&(o.boxSizingReliable()||d===a.style[b]),d=parseFloat(d)||0}return d+Va(a,b,c||(g?"border":"content"),e,f)+"px"}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ma(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{float:"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=a.style;return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=_.exec(c))&&e[1]&&(c=da(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b);return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Ma(a,b,d)),"normal"===e&&b in Qa&&(e=Qa[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Oa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?Wa(a,b,d):ca(a,Pa,function(){return Wa(a,b,d)})},set:function(a,c,d){var e,f=d&&La(a),g=d&&Va(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=_.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Ua(a,c,g)}}}),r.cssHooks.marginLeft=Na(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Ma(a,"marginLeft"))||a.getBoundingClientRect().left-ca(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+aa[d]+b]=f[d]||f[d-2]||f[0];return e}},Ja.test(a)||(r.cssHooks[a+b].set=Ua)}),r.fn.extend({css:function(a,b){return S(this,function(a,b,c){var d,e,f={},g=0;if(r.isArray(b)){for(d=La(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function Xa(a,b,c,d,e){return new Xa.prototype.init(a,b,c,d,e)}r.Tween=Xa,Xa.prototype={constructor:Xa,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=Xa.propHooks[this.prop];return a&&a.get?a.get(this):Xa.propHooks._default.get(this)},run:function(a){var b,c=Xa.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Xa.propHooks._default.set(this),this}},Xa.prototype.init.prototype=Xa.prototype,Xa.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},Xa.propHooks.scrollTop=Xa.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=Xa.prototype.init,r.fx.step={};var Ya,Za,$a=/^(?:toggle|show|hide)$/,_a=/queueHooks$/;function ab(){Za&&(a.requestAnimationFrame(ab),r.fx.tick())}function bb(){return a.setTimeout(function(){Ya=void 0}),Ya=r.now()}function cb(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=aa[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function db(a,b,c){for(var d,e=(gb.tweeners[b]||[]).concat(gb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function eb(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&ba(a),q=V.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],$a.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=V.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ga([a],!0),j=a.style.display||j,k=r.css(a,"display"),ga([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=V.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ga([a],!0),m.done(function(){p||ga([a]),V.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=db(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function fb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],r.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function gb(a,b,c){var d,e,f=0,g=gb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Ya||bb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:Ya||bb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(fb(k,j.opts.specialEasing);f<g;f++)if(d=gb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,db,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}r.Animation=r.extend(gb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return da(c.elem,a,_.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(K);for(var c,d=0,e=a.length;d<e;d++)c=a[d],gb.tweeners[c]=gb.tweeners[c]||[],gb.tweeners[c].unshift(b)},prefilters:[eb],prefilter:function(a,b){b?gb.prefilters.unshift(a):gb.prefilters.push(a)}}),r.speed=function(a,b,c){var e=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off||d.hidden?e.duration=0:e.duration="number"==typeof e.duration?e.duration:e.duration in r.fx.speeds?r.fx.speeds[e.duration]:r.fx.speeds._default,null!=e.queue&&e.queue!==!0||(e.queue="fx"),e.old=e.complete,e.complete=function(){r.isFunction(e.old)&&e.old.call(this),e.queue&&r.dequeue(this,e.queue)},e},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(ba).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=gb(this,r.extend({},a),f);(e||V.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=V.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&_a.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=V.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(cb(b,!0),a,d,e)}}),r.each({slideDown:cb("show"),slideUp:cb("hide"),slideToggle:cb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(Ya=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),Ya=void 0},r.fx.timer=function(a){r.timers.push(a),a()?r.fx.start():r.timers.pop()},r.fx.interval=13,r.fx.start=function(){Za||(Za=a.requestAnimationFrame?a.requestAnimationFrame(ab):a.setInterval(r.fx.tick,r.fx.interval))},r.fx.stop=function(){a.cancelAnimationFrame?a.cancelAnimationFrame(Za):a.clearInterval(Za),Za=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var hb,ib=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return S(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?hb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&r.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(K);
if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),hb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ib[b]||r.find.attr;ib[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=ib[g],ib[g]=e,e=null!=c(a,b,d)?g:null,ib[g]=f),e}});var jb=/^(?:input|select|textarea|button)$/i,kb=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return S(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):jb.test(a.nodeName)||kb.test(a.nodeName)&&a.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});var lb=/[\t\r\n\f]/g;function mb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,mb(this)))});if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,mb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,mb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(K)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=mb(this),b&&V.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":V.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+mb(c)+" ").replace(lb," ").indexOf(b)>-1)return!0;return!1}});var nb=/\r/g,ob=/[\x20\t\r\n\f]+/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":r.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(nb,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:r.trim(r.text(a)).replace(ob," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type,g=f?null:[],h=f?e+1:d.length,i=e<0?h:f?e:0;i<h;i++)if(c=d[i],(c.selected||i===e)&&!c.disabled&&(!c.parentNode.disabled||!r.nodeName(c.parentNode,"optgroup"))){if(b=r(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(r.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var pb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!pb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,pb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(V.get(h,"events")||{})[b.type]&&V.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&T(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!T(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=V.access(d,b);e||d.addEventListener(a,c,!0),V.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=V.access(d,b)-1;e?V.access(d,b,e):(d.removeEventListener(a,c,!0),V.remove(d,b))}}});var qb=a.location,rb=r.now(),sb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(a){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var tb=/\[\]$/,ub=/\r?\n/g,vb=/^(?:submit|button|image|reset|file)$/i,wb=/^(?:input|select|textarea|keygen)/i;function xb(a,b,c,d){var e;if(r.isArray(b))r.each(b,function(b,e){c||tb.test(a)?d(a,e):xb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)xb(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(r.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)xb(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&wb.test(this.nodeName)&&!vb.test(a)&&(this.checked||!ha.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:r.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(ub,"\r\n")}}):{name:b.name,value:c.replace(ub,"\r\n")}}).get()}});var yb=/%20/g,zb=/#.*$/,Ab=/([?&])_=[^&]*/,Bb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Cb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Db=/^(?:GET|HEAD)$/,Eb=/^\/\//,Fb={},Gb={},Hb="*/".concat("*"),Ib=d.createElement("a");Ib.href=qb.href;function Jb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(K)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Kb(a,b,c,d){var e={},f=a===Gb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Lb(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Mb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Nb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a.throws)b=g(b);else try{b=g(b)}catch(a){return{state:"parsererror",error:g?a:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:qb.href,type:"GET",isLocal:Cb.test(qb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Hb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Lb(Lb(a,r.ajaxSettings),b):Lb(r.ajaxSettings,a)},ajaxPrefilter:Jb(Fb),ajaxTransport:Jb(Gb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Bb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),z(0,b),this}};if(s.promise(y),o.url=((b||o.url||qb.href)+"").replace(Eb,qb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(K)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Ib.protocol+"//"+Ib.host!=j.protocol+"//"+j.host}catch(a){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Kb(Fb,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Db.test(o.type),f=o.url.replace(zb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(yb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(sb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Ab,""),n=(sb.test(f)?"&":"?")+"_="+rb++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Hb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Kb(Gb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,z)}catch(a){if(k)throw a;z(-1,a)}}else z(-1,"No Transport");function z(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Mb(o,y,d)),v=Nb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,throws:!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(a){}};var Ob={0:200,1223:204},Pb=r.ajaxSettings.xhr();o.cors=!!Pb&&"withCredentials"in Pb,o.ajax=Pb=!!Pb,r.ajaxTransport(function(b){var c,d;if(o.cors||Pb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Ob[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(a){if(c)throw a}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Qb=[],Rb=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Qb.pop()||r.expando+"_"+rb++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Rb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Rb.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Rb,"$1"+e):b.jsonp!==!1&&(b.url+=(sb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Qb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=B.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=oa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=r.trim(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length};function Sb(a){return r.isWindow(a)?a:9===a.nodeType&&a.defaultView}r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),d.width||d.height?(e=f.ownerDocument,c=Sb(e),b=e.documentElement,{top:d.top+c.pageYOffset-b.clientTop,left:d.left+c.pageXOffset-b.clientLeft}):d):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),r.nodeName(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||pa})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return S(this,function(a,d,e){var f=Sb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Na(o.pixelPosition,function(a,c){if(c)return c=Ma(a,b),Ka.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return S(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.parseJSON=JSON.parse,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Tb=a.jQuery,Ub=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Ub),b&&a.jQuery===r&&(a.jQuery=Tb),r},b||(a.jQuery=a.$=r),r}),function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){a.ui=a.ui||{};var b=a.ui.version="1.12.0",c=0,d=Array.prototype.slice;a.cleanData=function(b){return function(c){var d,e,f;for(f=0;null!=(e=c[f]);f++)try{d=a._data(e,"events"),d&&d.remove&&a(e).triggerHandler("remove")}catch(a){}b(c)}}(a.cleanData),a.widget=function(b,c,d){var e,f,g,h={},i=b.split(".")[0];b=b.split(".")[1];var j=i+"-"+b;return d||(d=c,c=a.Widget),a.isArray(d)&&(d=a.extend.apply(null,[{}].concat(d))),a.expr[":"][j.toLowerCase()]=function(b){return!!a.data(b,j)},a[i]=a[i]||{},e=a[i][b],f=a[i][b]=function(a,b){return this._createWidget?void(arguments.length&&this._createWidget(a,b)):new f(a,b)},a.extend(f,e,{version:d.version,_proto:a.extend({},d),_childConstructors:[]}),g=new c,g.options=a.widget.extend({},g.options),a.each(d,function(b,d){return a.isFunction(d)?void(h[b]=function(){function a(){return c.prototype[b].apply(this,arguments)}function e(a){return c.prototype[b].apply(this,a)}return function(){var b=this._super,c=this._superApply,f;return this._super=a,this._superApply=e,f=d.apply(this,arguments),this._super=b,this._superApply=c,f}}()):void(h[b]=d)}),f.prototype=a.widget.extend(g,{widgetEventPrefix:e?g.widgetEventPrefix||b:b},h,{constructor:f,namespace:i,widgetName:b,widgetFullName:j}),e?(a.each(e._childConstructors,function(b,c){var d=c.prototype;a.widget(d.namespace+"."+d.widgetName,f,c._proto)}),delete e._childConstructors):c._childConstructors.push(f),a.widget.bridge(b,f),f},a.widget.extend=function(b){for(var c=d.call(arguments,1),e=0,f=c.length,g,h;e<f;e++)for(g in c[e])h=c[e][g],c[e].hasOwnProperty(g)&&void 0!==h&&(a.isPlainObject(h)?b[g]=a.isPlainObject(b[g])?a.widget.extend({},b[g],h):a.widget.extend({},h):b[g]=h);return b},a.widget.bridge=function(b,c){var e=c.prototype.widgetFullName||b;a.fn[b]=function(f){var g="string"==typeof f,h=d.call(arguments,1),i=this;return g?this.each(function(){var c,d=a.data(this,e);return"instance"===f?(i=d,!1):d?a.isFunction(d[f])&&"_"!==f.charAt(0)?(c=d[f].apply(d,h),c!==d&&void 0!==c?(i=c&&c.jquery?i.pushStack(c.get()):c,!1):void 0):a.error("no such method '"+f+"' for "+b+" widget instance"):a.error("cannot call methods on "+b+" prior to initialization; attempted to call method '"+f+"'")}):(h.length&&(f=a.widget.extend.apply(null,[f].concat(h))),this.each(function(){var b=a.data(this,e);b?(b.option(f||{}),b._init&&b._init()):a.data(this,e,new c(f,this))})),i}},a.Widget=function(){},a.Widget._childConstructors=[],a.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(b,d){d=a(d||this.defaultElement||this)[0],this.element=a(d),this.uuid=c++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=a(),this.hoverable=a(),this.focusable=a(),this.classesElementLookup={},d!==this&&(a.data(d,this.widgetFullName,this),this._on(!0,this.element,{remove:function(a){a.target===d&&this.destroy()}}),this.document=a(d.style?d.ownerDocument:d.document||d),this.window=a(this.document[0].defaultView||this.document[0].parentWindow)),this.options=a.widget.extend({},this.options,this._getCreateOptions(),b),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:a.noop,_create:a.noop,_init:a.noop,destroy:function(){var b=this;this._destroy(),a.each(this.classesElementLookup,function(a,c){b._removeClass(c,a)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:a.noop,widget:function(){return this.element},option:function(b,c){var d=b,e,f,g;if(0===arguments.length)return a.widget.extend({},this.options);if("string"==typeof b)if(d={},e=b.split("."),b=e.shift(),e.length){for(f=d[b]=a.widget.extend({},this.options[b]),g=0;g<e.length-1;g++)f[e[g]]=f[e[g]]||{},f=f[e[g]];if(b=e.pop(),1===arguments.length)return void 0===f[b]?null:f[b];f[b]=c}else{if(1===arguments.length)return void 0===this.options[b]?null:this.options[b];d[b]=c}return this._setOptions(d),this},_setOptions:function(a){var b;for(b in a)this._setOption(b,a[b]);return this},_setOption:function(a,b){return"classes"===a&&this._setOptionClasses(b),this.options[a]=b,"disabled"===a&&this._setOptionDisabled(b),this},_setOptionClasses:function(b){var c,d,e;for(c in b)e=this.classesElementLookup[c],b[c]!==this.options.classes[c]&&e&&e.length&&(d=a(e.get()),this._removeClass(e,c),d.addClass(this._classes({element:d,keys:c,classes:b,add:!0})))},_setOptionDisabled:function(a){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!a),a&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(b){var c=[],d=this;b=a.extend({element:this.element,classes:this.options.classes||{}},b);function e(e,f){var g,h;for(h=0;h<e.length;h++)g=d.classesElementLookup[e[h]]||a(),g=a(b.add?a.unique(g.get().concat(b.element.get())):g.not(b.element).get()),d.classesElementLookup[e[h]]=g,c.push(e[h]),f&&b.classes[e[h]]&&c.push(b.classes[e[h]])}return b.keys&&e(b.keys.match(/\S+/g)||[],!0),b.extra&&e(b.extra.match(/\S+/g)||[]),c.join(" ")},_removeClass:function(a,b,c){return this._toggleClass(a,b,c,!1)},_addClass:function(a,b,c){return this._toggleClass(a,b,c,!0)},_toggleClass:function(a,b,c,d){d="boolean"==typeof d?d:c;var e="string"==typeof a||null===a,f={extra:e?b:c,keys:e?a:b,element:e?this.element:a,add:d};return f.element.toggleClass(this._classes(f),d),this},_on:function(b,c,d){var e,f=this;"boolean"!=typeof b&&(d=c,c=b,b=!1),d?(c=e=a(c),this.bindings=this.bindings.add(c)):(d=c,c=this.element,e=this.widget()),a.each(d,function(d,g){function h(){if(b||f.options.disabled!==!0&&!a(this).hasClass("ui-state-disabled"))return("string"==typeof g?f[g]:g).apply(f,arguments)}"string"!=typeof g&&(h.guid=g.guid=g.guid||h.guid||a.guid++);var i=d.match(/^([\w:-]*)\s*(.*)$/),j=i[1]+f.eventNamespace,k=i[2];k?e.on(j,k,h):c.on(j,h)})},_off:function(b,c){c=(c||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,b.off(c).off(c),this.bindings=a(this.bindings.not(b).get()),this.focusable=a(this.focusable.not(b).get()),this.hoverable=a(this.hoverable.not(b).get())},_delay:function(a,b){function c(){return("string"==typeof a?d[a]:a).apply(d,arguments)}var d=this;return setTimeout(c,b||0)},_hoverable:function(b){this.hoverable=this.hoverable.add(b),this._on(b,{mouseenter:function(b){this._addClass(a(b.currentTarget),null,"ui-state-hover")},mouseleave:function(b){this._removeClass(a(b.currentTarget),null,"ui-state-hover")}})},_focusable:function(b){this.focusable=this.focusable.add(b),this._on(b,{focusin:function(b){this._addClass(a(b.currentTarget),null,"ui-state-focus")},focusout:function(b){this._removeClass(a(b.currentTarget),null,"ui-state-focus")}})},_trigger:function(b,c,d){var e,f,g=this.options[b];if(d=d||{},c=a.Event(c),c.type=(b===this.widgetEventPrefix?b:this.widgetEventPrefix+b).toLowerCase(),c.target=this.element[0],f=c.originalEvent)for(e in f)e in c||(c[e]=f[e]);return this.element.trigger(c,d),!(a.isFunction(g)&&g.apply(this.element[0],[c].concat(d))===!1||c.isDefaultPrevented())}},a.each({show:"fadeIn",hide:"fadeOut"},function(b,c){a.Widget.prototype["_"+b]=function(d,e,f){"string"==typeof e&&(e={effect:e});var g,h=e?e===!0||"number"==typeof e?c:e.effect||c:b;e=e||{},"number"==typeof e&&(e={duration:e}),g=!a.isEmptyObject(e),e.complete=f,e.delay&&d.delay(e.delay),g&&a.effects&&a.effects.effect[h]?d[b](e):h!==b&&d[h]?d[h](e.duration,e.easing,f):d.queue(function(c){a(this)[b](),f&&f.call(d[0]),c()})}});var e=a.widget;!function(){var b,c,d=Math.max,e=Math.abs,f=Math.round,g=/left|center|right/,h=/top|center|bottom/,i=/[\+\-]\d+(\.[\d]+)?%?/,j=/^\w+/,k=/%$/,l=a.fn.position;c=function(){var b=a("<div>").css("position","absolute").appendTo("body").offset({top:1.5,left:1.5}),d=1.5===b.offset().top;return b.remove(),c=function(){return d},d};function m(a,b,c){return[parseFloat(a[0])*(k.test(a[0])?b/100:1),parseFloat(a[1])*(k.test(a[1])?c/100:1)]}function n(b,c){return parseInt(a.css(b,c),10)||0}function o(b){var c=b[0];return 9===c.nodeType?{width:b.width(),height:b.height(),offset:{top:0,left:0}}:a.isWindow(c)?{width:b.width(),height:b.height(),offset:{top:b.scrollTop(),left:b.scrollLeft()}}:c.preventDefault?{width:0,height:0,offset:{top:c.pageY,left:c.pageX}}:{width:b.outerWidth(),height:b.outerHeight(),offset:b.offset()}}a.position={scrollbarWidth:function(){if(void 0!==b)return b;var c,d,e=a("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),f=e.children()[0];return a("body").append(e),c=f.offsetWidth,e.css("overflow","scroll"),d=f.offsetWidth,c===d&&(d=e[0].clientWidth),e.remove(),b=c-d},getScrollInfo:function(b){var c=b.isWindow||b.isDocument?"":b.element.css("overflow-x"),d=b.isWindow||b.isDocument?"":b.element.css("overflow-y"),e="scroll"===c||"auto"===c&&b.width<b.element[0].scrollWidth,f="scroll"===d||"auto"===d&&b.height<b.element[0].scrollHeight;return{width:f?a.position.scrollbarWidth():0,height:e?a.position.scrollbarWidth():0}},getWithinInfo:function(b){var c=a(b||window),d=a.isWindow(c[0]),e=!!c[0]&&9===c[0].nodeType,f=!d&&!e;return{element:c,isWindow:d,isDocument:e,offset:f?a(b).offset():{left:0,top:0},scrollLeft:c.scrollLeft(),scrollTop:c.scrollTop(),width:c.outerWidth(),height:c.outerHeight()}}},a.fn.position=function(b){
if(!b||!b.of)return l.apply(this,arguments);b=a.extend({},b);var k,p,q,r,s,t,u=a(b.of),v=a.position.getWithinInfo(b.within),w=a.position.getScrollInfo(v),x=(b.collision||"flip").split(" "),y={};return t=o(u),u[0].preventDefault&&(b.at="left top"),p=t.width,q=t.height,r=t.offset,s=a.extend({},r),a.each(["my","at"],function(){var a=(b[this]||"").split(" "),c,d;1===a.length&&(a=g.test(a[0])?a.concat(["center"]):h.test(a[0])?["center"].concat(a):["center","center"]),a[0]=g.test(a[0])?a[0]:"center",a[1]=h.test(a[1])?a[1]:"center",c=i.exec(a[0]),d=i.exec(a[1]),y[this]=[c?c[0]:0,d?d[0]:0],b[this]=[j.exec(a[0])[0],j.exec(a[1])[0]]}),1===x.length&&(x[1]=x[0]),"right"===b.at[0]?s.left+=p:"center"===b.at[0]&&(s.left+=p/2),"bottom"===b.at[1]?s.top+=q:"center"===b.at[1]&&(s.top+=q/2),k=m(y.at,p,q),s.left+=k[0],s.top+=k[1],this.each(function(){var g,h,i=a(this),j=i.outerWidth(),l=i.outerHeight(),o=n(this,"marginLeft"),t=n(this,"marginTop"),z=j+o+n(this,"marginRight")+w.width,A=l+t+n(this,"marginBottom")+w.height,B=a.extend({},s),C=m(y.my,i.outerWidth(),i.outerHeight());"right"===b.my[0]?B.left-=j:"center"===b.my[0]&&(B.left-=j/2),"bottom"===b.my[1]?B.top-=l:"center"===b.my[1]&&(B.top-=l/2),B.left+=C[0],B.top+=C[1],c()||(B.left=f(B.left),B.top=f(B.top)),g={marginLeft:o,marginTop:t},a.each(["left","top"],function(c,d){a.ui.position[x[c]]&&a.ui.position[x[c]][d](B,{targetWidth:p,targetHeight:q,elemWidth:j,elemHeight:l,collisionPosition:g,collisionWidth:z,collisionHeight:A,offset:[k[0]+C[0],k[1]+C[1]],my:b.my,at:b.at,within:v,elem:i})}),b.using&&(h=function(a){var c=r.left-B.left,f=c+p-j,g=r.top-B.top,h=g+q-l,k={target:{element:u,left:r.left,top:r.top,width:p,height:q},element:{element:i,left:B.left,top:B.top,width:j,height:l},horizontal:f<0?"left":c>0?"right":"center",vertical:h<0?"top":g>0?"bottom":"middle"};p<j&&e(c+f)<p&&(k.horizontal="center"),q<l&&e(g+h)<q&&(k.vertical="middle"),d(e(c),e(f))>d(e(g),e(h))?k.important="horizontal":k.important="vertical",b.using.call(this,a,k)}),i.offset(a.extend(B,{using:h}))})},a.ui.position={fit:{left:function(a,b){var c=b.within,e=c.isWindow?c.scrollLeft:c.offset.left,f=c.width,g=a.left-b.collisionPosition.marginLeft,h=e-g,i=g+b.collisionWidth-f-e,j;b.collisionWidth>f?h>0&&i<=0?(j=a.left+h+b.collisionWidth-f-e,a.left+=h-j):i>0&&h<=0?a.left=e:h>i?a.left=e+f-b.collisionWidth:a.left=e:h>0?a.left+=h:i>0?a.left-=i:a.left=d(a.left-g,a.left)},top:function(a,b){var c=b.within,e=c.isWindow?c.scrollTop:c.offset.top,f=b.within.height,g=a.top-b.collisionPosition.marginTop,h=e-g,i=g+b.collisionHeight-f-e,j;b.collisionHeight>f?h>0&&i<=0?(j=a.top+h+b.collisionHeight-f-e,a.top+=h-j):i>0&&h<=0?a.top=e:h>i?a.top=e+f-b.collisionHeight:a.top=e:h>0?a.top+=h:i>0?a.top-=i:a.top=d(a.top-g,a.top)}},flip:{left:function(a,b){var c=b.within,d=c.offset.left+c.scrollLeft,f=c.width,g=c.isWindow?c.scrollLeft:c.offset.left,h=a.left-b.collisionPosition.marginLeft,i=h-g,j=h+b.collisionWidth-f-g,k="left"===b.my[0]?-b.elemWidth:"right"===b.my[0]?b.elemWidth:0,l="left"===b.at[0]?b.targetWidth:"right"===b.at[0]?-b.targetWidth:0,m=-2*b.offset[0],n,o;i<0?(n=a.left+k+l+m+b.collisionWidth-f-d,(n<0||n<e(i))&&(a.left+=k+l+m)):j>0&&(o=a.left-b.collisionPosition.marginLeft+k+l+m-g,(o>0||e(o)<j)&&(a.left+=k+l+m))},top:function(a,b){var c=b.within,d=c.offset.top+c.scrollTop,f=c.height,g=c.isWindow?c.scrollTop:c.offset.top,h=a.top-b.collisionPosition.marginTop,i=h-g,j=h+b.collisionHeight-f-g,k="top"===b.my[1],l=k?-b.elemHeight:"bottom"===b.my[1]?b.elemHeight:0,m="top"===b.at[1]?b.targetHeight:"bottom"===b.at[1]?-b.targetHeight:0,n=-2*b.offset[1],o,p;i<0?(p=a.top+l+m+n+b.collisionHeight-f-d,(p<0||p<e(i))&&(a.top+=l+m+n)):j>0&&(o=a.top-b.collisionPosition.marginTop+l+m+n-g,(o>0||e(o)<j)&&(a.top+=l+m+n))}},flipfit:{left:function(){a.ui.position.flip.left.apply(this,arguments),a.ui.position.fit.left.apply(this,arguments)},top:function(){a.ui.position.flip.top.apply(this,arguments),a.ui.position.fit.top.apply(this,arguments)}}}}();var f=a.ui.position,g=a.extend(a.expr[":"],{data:a.expr.createPseudo?a.expr.createPseudo(function(b){return function(c){return!!a.data(c,b)}}):function(b,c,d){return!!a.data(b,d[3])}}),h=a.fn.extend({disableSelection:function(){var a="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.on(a+".ui-disableSelection",function(a){a.preventDefault()})}}(),enableSelection:function(){return this.off(".ui-disableSelection")}}),i="ui-effects-",j="ui-effects-style",k="ui-effects-animated",l=a;a.effects={effect:{}},function(a,b){var c="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",d=/^([\-+])=\s*(\d+\.?\d*)/,e=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(a){return[a[1],a[2],a[3],a[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(a){return[2.55*a[1],2.55*a[2],2.55*a[3],a[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(a){return[parseInt(a[1],16),parseInt(a[2],16),parseInt(a[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(a){return[parseInt(a[1]+a[1],16),parseInt(a[2]+a[2],16),parseInt(a[3]+a[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(a){return[a[1],a[2]/100,a[3]/100,a[4]]}}],f=a.Color=function(b,c,d,e){return new a.Color.fn.parse(b,c,d,e)},g={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},h={byte:{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},i=f.support={},j=a("<p>")[0],k,l=a.each;j.style.cssText="background-color:rgba(1,1,1,.5)",i.rgba=j.style.backgroundColor.indexOf("rgba")>-1,l(g,function(a,b){b.cache="_"+a,b.props.alpha={idx:3,type:"percent",def:1}});function m(a,b,c){var d=h[b.type]||{};return null==a?c||!b.def?null:b.def:(a=d.floor?~~a:parseFloat(a),isNaN(a)?b.def:d.mod?(a+d.mod)%d.mod:0>a?0:d.max<a?d.max:a)}function n(b){var c=f(),d=c._rgba=[];return b=b.toLowerCase(),l(e,function(a,e){var f,h=e.re.exec(b),i=h&&e.parse(h),j=e.space||"rgba";if(i)return f=c[j](i),c[g[j].cache]=f[g[j].cache],d=c._rgba=f._rgba,!1}),d.length?("0,0,0,0"===d.join()&&a.extend(d,k.transparent),c):k[b]}f.fn=a.extend(f.prototype,{parse:function(c,d,e,h){if(c===b)return this._rgba=[null,null,null,null],this;(c.jquery||c.nodeType)&&(c=a(c).css(d),d=b);var i=this,j=a.type(c),o=this._rgba=[];return d!==b&&(c=[c,d,e,h],j="array"),"string"===j?this.parse(n(c)||k._default):"array"===j?(l(g.rgba.props,function(a,b){o[b.idx]=m(c[b.idx],b)}),this):"object"===j?(c instanceof f?l(g,function(a,b){c[b.cache]&&(i[b.cache]=c[b.cache].slice())}):l(g,function(b,d){var e=d.cache;l(d.props,function(a,b){if(!i[e]&&d.to){if("alpha"===a||null==c[a])return;i[e]=d.to(i._rgba)}i[e][b.idx]=m(c[a],b,!0)}),i[e]&&a.inArray(null,i[e].slice(0,3))<0&&(i[e][3]=1,d.from&&(i._rgba=d.from(i[e])))}),this):void 0},is:function(a){var b=f(a),c=!0,d=this;return l(g,function(a,e){var f,g=b[e.cache];return g&&(f=d[e.cache]||e.to&&e.to(d._rgba)||[],l(e.props,function(a,b){if(null!=g[b.idx])return c=g[b.idx]===f[b.idx]})),c}),c},_space:function(){var a=[],b=this;return l(g,function(c,d){b[d.cache]&&a.push(c)}),a.pop()},transition:function(a,b){var c=f(a),d=c._space(),e=g[d],i=0===this.alpha()?f("transparent"):this,j=i[e.cache]||e.to(i._rgba),k=j.slice();return c=c[e.cache],l(e.props,function(a,d){var e=d.idx,f=j[e],g=c[e],i=h[d.type]||{};null!==g&&(null===f?k[e]=g:(i.mod&&(g-f>i.mod/2?f+=i.mod:f-g>i.mod/2&&(f-=i.mod)),k[e]=m((g-f)*b+f,d)))}),this[d](k)},blend:function(b){if(1===this._rgba[3])return this;var c=this._rgba.slice(),d=c.pop(),e=f(b)._rgba;return f(a.map(c,function(a,b){return(1-d)*e[b]+d*a}))},toRgbaString:function(){var b="rgba(",c=a.map(this._rgba,function(a,b){return null==a?b>2?1:0:a});return 1===c[3]&&(c.pop(),b="rgb("),b+c.join()+")"},toHslaString:function(){var b="hsla(",c=a.map(this.hsla(),function(a,b){return null==a&&(a=b>2?1:0),b&&b<3&&(a=Math.round(100*a)+"%"),a});return 1===c[3]&&(c.pop(),b="hsl("),b+c.join()+")"},toHexString:function(b){var c=this._rgba.slice(),d=c.pop();return b&&c.push(~~(255*d)),"#"+a.map(c,function(a){return a=(a||0).toString(16),1===a.length?"0"+a:a}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),f.fn.parse.prototype=f.fn;function o(a,b,c){return c=(c+1)%1,6*c<1?a+(b-a)*c*6:2*c<1?b:3*c<2?a+(b-a)*(2/3-c)*6:a}g.hsla.to=function(a){if(null==a[0]||null==a[1]||null==a[2])return[null,null,null,a[3]];var b=a[0]/255,c=a[1]/255,d=a[2]/255,e=a[3],f=Math.max(b,c,d),g=Math.min(b,c,d),h=f-g,i=f+g,j=.5*i,k,l;return k=g===f?0:b===f?60*(c-d)/h+360:c===f?60*(d-b)/h+120:60*(b-c)/h+240,l=0===h?0:j<=.5?h/i:h/(2-i),[Math.round(k)%360,l,j,null==e?1:e]},g.hsla.from=function(a){if(null==a[0]||null==a[1]||null==a[2])return[null,null,null,a[3]];var b=a[0]/360,c=a[1],d=a[2],e=a[3],f=d<=.5?d*(1+c):d+c-d*c,g=2*d-f;return[Math.round(255*o(g,f,b+1/3)),Math.round(255*o(g,f,b)),Math.round(255*o(g,f,b-1/3)),e]},l(g,function(c,e){var g=e.props,h=e.cache,i=e.to,j=e.from;f.fn[c]=function(c){if(i&&!this[h]&&(this[h]=i(this._rgba)),c===b)return this[h].slice();var d,e=a.type(c),k="array"===e||"object"===e?c:arguments,n=this[h].slice();return l(g,function(a,b){var c=k["object"===e?a:b.idx];null==c&&(c=n[b.idx]),n[b.idx]=m(c,b)}),j?(d=f(j(n)),d[h]=n,d):f(n)},l(g,function(b,e){f.fn[b]||(f.fn[b]=function(f){var g=a.type(f),h="alpha"===b?this._hsla?"hsla":"rgba":c,i=this[h](),j=i[e.idx],k;return"undefined"===g?j:("function"===g&&(f=f.call(this,j),g=a.type(f)),null==f&&e.empty?this:("string"===g&&(k=d.exec(f),k&&(f=j+parseFloat(k[2])*("+"===k[1]?1:-1))),i[e.idx]=f,this[h](i)))})})}),f.hook=function(b){var c=b.split(" ");l(c,function(b,c){a.cssHooks[c]={set:function(b,d){var e,g,h="";if("transparent"!==d&&("string"!==a.type(d)||(e=n(d)))){if(d=f(e||d),!i.rgba&&1!==d._rgba[3]){g="backgroundColor"===c?b.parentNode:b;while((""===h||"transparent"===h)&&g&&g.style)try{h=a.css(g,"backgroundColor"),g=g.parentNode}catch(a){}d=d.blend(h&&"transparent"!==h?h:"_default")}d=d.toRgbaString()}try{b.style[c]=d}catch(a){}}},a.fx.step[c]=function(b){b.colorInit||(b.start=f(b.elem,c),b.end=f(b.end),b.colorInit=!0),a.cssHooks[c].set(b.elem,b.start.transition(b.end,b.pos))}})},f.hook(c),a.cssHooks.borderColor={expand:function(a){var b={};return l(["Top","Right","Bottom","Left"],function(c,d){b["border"+d+"Color"]=a}),b}},k=a.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(l),function(){var b=["add","remove","toggle"],c={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};a.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(b,c){a.fx.step[c]=function(a){("none"!==a.end&&!a.setAttr||1===a.pos&&!a.setAttr)&&(l.style(a.elem,c,a.end),a.setAttr=!0)}});function d(b){var c,d,e=b.ownerDocument.defaultView?b.ownerDocument.defaultView.getComputedStyle(b,null):b.currentStyle,f={};if(e&&e.length&&e[0]&&e[e[0]]){d=e.length;while(d--)c=e[d],"string"==typeof e[c]&&(f[a.camelCase(c)]=e[c])}else for(c in e)"string"==typeof e[c]&&(f[c]=e[c]);return f}function e(b,d){var e={},f,g;for(f in d)g=d[f],b[f]!==g&&(c[f]||!a.fx.step[f]&&isNaN(parseFloat(g))||(e[f]=g));return e}a.fn.addBack||(a.fn.addBack=function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}),a.effects.animateClass=function(c,f,g,h){var i=a.speed(f,g,h);return this.queue(function(){var f=a(this),g=f.attr("class")||"",h,j=i.children?f.find("*").addBack():f;j=j.map(function(){var b=a(this);return{el:b,start:d(this)}}),h=function(){a.each(b,function(a,b){c[b]&&f[b+"Class"](c[b])})},h(),j=j.map(function(){return this.end=d(this.el[0]),this.diff=e(this.start,this.end),this}),f.attr("class",g),j=j.map(function(){var b=this,c=a.Deferred(),d=a.extend({},i,{queue:!1,complete:function(){c.resolve(b)}});return this.el.animate(this.diff,d),c.promise()}),a.when.apply(a,j.get()).done(function(){h(),a.each(arguments,function(){var b=this.el;a.each(this.diff,function(a){b.css(a,"")})}),i.complete.call(f[0])})})},a.fn.extend({addClass:function(b){return function(c,d,e,f){return d?a.effects.animateClass.call(this,{add:c},d,e,f):b.apply(this,arguments)}}(a.fn.addClass),removeClass:function(b){return function(c,d,e,f){return arguments.length>1?a.effects.animateClass.call(this,{remove:c},d,e,f):b.apply(this,arguments)}}(a.fn.removeClass),toggleClass:function(b){return function(c,d,e,f,g){return"boolean"==typeof d||void 0===d?e?a.effects.animateClass.call(this,d?{add:c}:{remove:c},e,f,g):b.apply(this,arguments):a.effects.animateClass.call(this,{toggle:c},d,e,f)}}(a.fn.toggleClass),switchClass:function(b,c,d,e,f){return a.effects.animateClass.call(this,{add:c,remove:b},d,e,f)}})}(),function(){a.expr&&a.expr.filters&&a.expr.filters.animated&&(a.expr.filters.animated=function(b){return function(c){return!!a(c).data(k)||b(c)}}(a.expr.filters.animated)),a.uiBackCompat!==!1&&a.extend(a.effects,{save:function(a,b){for(var c=0,d=b.length;c<d;c++)null!==b[c]&&a.data(i+b[c],a[0].style[b[c]])},restore:function(a,b){for(var c,d=0,e=b.length;d<e;d++)null!==b[d]&&(c=a.data(i+b[d]),a.css(b[d],c))},setMode:function(a,b){return"toggle"===b&&(b=a.is(":hidden")?"show":"hide"),b},createWrapper:function(b){if(b.parent().is(".ui-effects-wrapper"))return b.parent();var c={width:b.outerWidth(!0),height:b.outerHeight(!0),float:b.css("float")},d=a("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),e={width:b.width(),height:b.height()},f=document.activeElement;try{f.id}catch(a){f=document.body}return b.wrap(d),(b[0]===f||a.contains(b[0],f))&&a(f).trigger("focus"),d=b.parent(),"static"===b.css("position")?(d.css({position:"relative"}),b.css({position:"relative"})):(a.extend(c,{position:b.css("position"),zIndex:b.css("z-index")}),a.each(["top","left","bottom","right"],function(a,d){c[d]=b.css(d),isNaN(parseInt(c[d],10))&&(c[d]="auto")}),b.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),b.css(e),d.css(c).show()},removeWrapper:function(b){var c=document.activeElement;return b.parent().is(".ui-effects-wrapper")&&(b.parent().replaceWith(b),(b[0]===c||a.contains(b[0],c))&&a(c).trigger("focus")),b}}),a.extend(a.effects,{version:"1.12.0",define:function(b,c,d){return d||(d=c,c="effect"),a.effects.effect[b]=d,a.effects.effect[b].mode=c,d},scaledDimensions:function(a,b,c){if(0===b)return{height:0,width:0,outerHeight:0,outerWidth:0};var d="horizontal"!==c?(b||100)/100:1,e="vertical"!==c?(b||100)/100:1;return{height:a.height()*e,width:a.width()*d,outerHeight:a.outerHeight()*e,outerWidth:a.outerWidth()*d}},clipToBox:function(a){return{width:a.clip.right-a.clip.left,height:a.clip.bottom-a.clip.top,left:a.clip.left,top:a.clip.top}},unshift:function(a,b,c){var d=a.queue();b>1&&d.splice.apply(d,[1,0].concat(d.splice(b,c))),a.dequeue()},saveStyle:function(a){a.data(j,a[0].style.cssText)},restoreStyle:function(a){a[0].style.cssText=a.data(j)||"",a.removeData(j)},mode:function(a,b){var c=a.is(":hidden");return"toggle"===b&&(b=c?"show":"hide"),(c?"hide"===b:"show"===b)&&(b="none"),b},getBaseline:function(a,b){var c,d;switch(a[0]){case"top":c=0;break;case"middle":c=.5;break;case"bottom":c=1;break;default:c=a[0]/b.height}switch(a[1]){case"left":d=0;break;case"center":d=.5;break;case"right":d=1;break;default:d=a[1]/b.width}return{x:d,y:c}},createPlaceholder:function(b){var c,d=b.css("position"),e=b.position();return b.css({marginTop:b.css("marginTop"),marginBottom:b.css("marginBottom"),marginLeft:b.css("marginLeft"),marginRight:b.css("marginRight")}).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()),/^(static|relative)/.test(d)&&(d="absolute",c=a("<"+b[0].nodeName+">").insertAfter(b).css({display:/^(inline|ruby)/.test(b.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:b.css("marginTop"),marginBottom:b.css("marginBottom"),marginLeft:b.css("marginLeft"),marginRight:b.css("marginRight"),float:b.css("float")}).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()).addClass("ui-effects-placeholder"),b.data(i+"placeholder",c)),b.css({position:d,left:e.left,top:e.top}),c},removePlaceholder:function(a){var b=i+"placeholder",c=a.data(b);c&&(c.remove(),a.removeData(b))},cleanUp:function(b){a.effects.restoreStyle(b),a.effects.removePlaceholder(b)},setTransition:function(b,c,d,e){return e=e||{},a.each(c,function(a,c){var f=b.cssUnit(c);f[0]>0&&(e[c]=f[0]*d+f[1])}),e}});function b(b,c,d,e){return a.isPlainObject(b)&&(c=b,b=b.effect),b={effect:b},null==c&&(c={}),a.isFunction(c)&&(e=c,d=null,c={}),("number"==typeof c||a.fx.speeds[c])&&(e=d,d=c,c={}),a.isFunction(d)&&(e=d,d=null),c&&a.extend(b,c),d=d||c.duration,b.duration=a.fx.off?0:"number"==typeof d?d:d in a.fx.speeds?a.fx.speeds[d]:a.fx.speeds._default,b.complete=e||c.complete,b}function c(b){return!(b&&"number"!=typeof b&&!a.fx.speeds[b])||("string"==typeof b&&!a.effects.effect[b]||(!!a.isFunction(b)||"object"==typeof b&&!b.effect))}a.fn.extend({effect:function(){var c=b.apply(this,arguments),d=a.effects.effect[c.effect],e=d.mode,f=c.queue,g=f||"fx",h=c.complete,i=c.mode,j=[],l=function(b){var c=a(this),d=a.effects.mode(c,i)||e;c.data(k,!0),j.push(d),e&&("show"===d||d===e&&"hide"===d)&&c.show(),e&&"none"===d||a.effects.saveStyle(c),a.isFunction(b)&&b()};if(a.fx.off||!d)return i?this[i](c.duration,h):this.each(function(){h&&h.call(this)});function m(b){var f=a(this);function g(){f.removeData(k),a.effects.cleanUp(f),"hide"===c.mode&&f.hide(),l()}function l(){a.isFunction(h)&&h.call(f[0]),a.isFunction(b)&&b()}c.mode=j.shift(),a.uiBackCompat===!1||e?"none"===c.mode?(f[i](),l()):d.call(f[0],c,g):(f.is(":hidden")?"hide"===i:"show"===i)?(f[i](),l()):d.call(f[0],c,l)}return f===!1?this.each(l).each(m):this.queue(g,l).queue(g,m)},show:function(a){return function(d){if(c(d))return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="show",this.effect.call(this,e)}}(a.fn.show),hide:function(a){return function(d){if(c(d))return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="hide",this.effect.call(this,e)}}(a.fn.hide),toggle:function(a){return function(d){if(c(d)||"boolean"==typeof d)return a.apply(this,arguments);var e=b.apply(this,arguments);return e.mode="toggle",this.effect.call(this,e)}}(a.fn.toggle),cssUnit:function(b){var c=this.css(b),d=[];return a.each(["em","px","%","pt"],function(a,b){c.indexOf(b)>0&&(d=[parseFloat(c),b])}),d},cssClip:function(a){return a?this.css("clip","rect("+a.top+"px "+a.right+"px "+a.bottom+"px "+a.left+"px)"):d(this.css("clip"),this)},transfer:function(b,c){var d=a(this),e=a(b.to),f="fixed"===e.css("position"),g=a("body"),h=f?g.scrollTop():0,i=f?g.scrollLeft():0,j=e.offset(),k={top:j.top-h,left:j.left-i,height:e.innerHeight(),width:e.innerWidth()},l=d.offset(),m=a("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(b.className).css({top:l.top-h,left:l.left-i,height:d.innerHeight(),width:d.innerWidth(),position:f?"fixed":"absolute"}).animate(k,b.duration,b.easing,function(){m.remove(),a.isFunction(c)&&c()})}});function d(a,b){var c=b.outerWidth(),d=b.outerHeight(),e=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,f=e.exec(a)||["",0,c,d,0];return{top:parseFloat(f[1])||0,right:"auto"===f[2]?c:parseFloat(f[2]),bottom:"auto"===f[3]?d:parseFloat(f[3]),left:parseFloat(f[4])||0}}a.fx.step.clip=function(b){b.clipInit||(b.start=a(b.elem).cssClip(),"string"==typeof b.end&&(b.end=d(b.end,b.elem)),b.clipInit=!0),a(b.elem).cssClip({top:b.pos*(b.end.top-b.start.top)+b.start.top,right:b.pos*(b.end.right-b.start.right)+b.start.right,bottom:b.pos*(b.end.bottom-b.start.bottom)+b.start.bottom,left:b.pos*(b.end.left-b.start.left)+b.start.left})}}(),function(){var b={};a.each(["Quad","Cubic","Quart","Quint","Expo"],function(a,c){b[c]=function(b){return Math.pow(b,a+2)}}),a.extend(b,{Sine:function(a){return 1-Math.cos(a*Math.PI/2)},Circ:function(a){return 1-Math.sqrt(1-a*a)},Elastic:function(a){return 0===a||1===a?a:-Math.pow(2,8*(a-1))*Math.sin((80*(a-1)-7.5)*Math.PI/15)},Back:function(a){return a*a*(3*a-2)},Bounce:function(a){var b,c=4;while(a<((b=Math.pow(2,--c))-1)/11);return 1/Math.pow(4,3-c)-7.5625*Math.pow((3*b-2)/22-a,2)}}),a.each(b,function(b,c){a.easing["easeIn"+b]=c,a.easing["easeOut"+b]=function(a){return 1-c(1-a)},a.easing["easeInOut"+b]=function(a){return a<.5?c(2*a)/2:1-c(a*-2+2)/2}})}();var m=a.effects,n=a.effects.define("blind","hide",function(b,c){var d={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},e=a(this),f=b.direction||"up",g=e.cssClip(),h={clip:a.extend({},g)},i=a.effects.createPlaceholder(e);h.clip[d[f][0]]=h.clip[d[f][1]],"show"===b.mode&&(e.cssClip(h.clip),i&&i.css(a.effects.clipToBox(h)),h.clip=g),i&&i.animate(a.effects.clipToBox(h),b.duration,b.easing),e.animate(h,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),o=a.effects.define("bounce",function(b,c){var d,e,f,g=a(this),h=b.mode,i="hide"===h,j="show"===h,k=b.direction||"up",l=b.distance,m=b.times||5,n=2*m+(j||i?1:0),o=b.duration/n,p=b.easing,q="up"===k||"down"===k?"top":"left",r="up"===k||"left"===k,s=0,t=g.queue().length;for(a.effects.createPlaceholder(g),f=g.css(q),l||(l=g["top"===q?"outerHeight":"outerWidth"]()/3),j&&(e={opacity:1},e[q]=f,g.css("opacity",0).css(q,r?2*-l:2*l).animate(e,o,p)),i&&(l/=Math.pow(2,m-1)),e={},e[q]=f;s<m;s++)d={},d[q]=(r?"-=":"+=")+l,g.animate(d,o,p).animate(e,o,p),l=i?2*l:l/2;i&&(d={opacity:0},d[q]=(r?"-=":"+=")+l,g.animate(d,o,p)),g.queue(c),a.effects.unshift(g,t,n+1)}),p=a.effects.define("clip","hide",function(b,c){var d,e={},f=a(this),g=b.direction||"vertical",h="both"===g,i=h||"horizontal"===g,j=h||"vertical"===g;d=f.cssClip(),e.clip={top:j?(d.bottom-d.top)/2:d.top,right:i?(d.right-d.left)/2:d.right,bottom:j?(d.bottom-d.top)/2:d.bottom,left:i?(d.right-d.left)/2:d.left},a.effects.createPlaceholder(f),"show"===b.mode&&(f.cssClip(e.clip),e.clip=d),f.animate(e,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),q=a.effects.define("drop","hide",function(b,c){var d,e=a(this),f=b.mode,g="show"===f,h=b.direction||"left",i="up"===h||"down"===h?"top":"left",j="up"===h||"left"===h?"-=":"+=",k="+="===j?"-=":"+=",l={opacity:0};a.effects.createPlaceholder(e),d=b.distance||e["top"===i?"outerHeight":"outerWidth"](!0)/2,l[i]=j+d,g&&(e.css(l),l[i]=k+d,l.opacity=1),e.animate(l,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),r=a.effects.define("explode","hide",function(b,c){var d,e,f,g,h,i,j=b.pieces?Math.round(Math.sqrt(b.pieces)):3,k=j,l=a(this),m=b.mode,n="show"===m,o=l.show().css("visibility","hidden").offset(),p=Math.ceil(l.outerWidth()/k),q=Math.ceil(l.outerHeight()/j),r=[];function s(){r.push(this),r.length===j*k&&t()}for(d=0;d<j;d++)for(g=o.top+d*q,i=d-(j-1)/2,e=0;e<k;e++)f=o.left+e*p,h=e-(k-1)/2,l.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-e*p,top:-d*q}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:p,height:q,left:f+(n?h*p:0),top:g+(n?i*q:0),opacity:n?0:1}).animate({left:f+(n?0:h*p),top:g+(n?0:i*q),opacity:n?1:0},b.duration||500,b.easing,s);function t(){l.css({visibility:"visible"}),a(r).remove(),c()}}),s=a.effects.define("fade","toggle",function(b,c){var d="show"===b.mode;a(this).css("opacity",d?0:1).animate({opacity:d?1:0},{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),t=a.effects.define("fold","hide",function(b,c){var d=a(this),e=b.mode,f="show"===e,g="hide"===e,h=b.size||15,i=/([0-9]+)%/.exec(h),j=!!b.horizFirst,k=j?["right","bottom"]:["bottom","right"],l=b.duration/2,m=a.effects.createPlaceholder(d),n=d.cssClip(),o={clip:a.extend({},n)},p={clip:a.extend({},n)},q=[n[k[0]],n[k[1]]],r=d.queue().length;i&&(h=parseInt(i[1],10)/100*q[g?0:1]),o.clip[k[0]]=h,p.clip[k[0]]=h,p.clip[k[1]]=0,f&&(d.cssClip(p.clip),m&&m.css(a.effects.clipToBox(p)),p.clip=n),d.queue(function(c){m&&m.animate(a.effects.clipToBox(o),l,b.easing).animate(a.effects.clipToBox(p),l,b.easing),c()}).animate(o,l,b.easing).animate(p,l,b.easing).queue(c),a.effects.unshift(d,r,4)}),u=a.effects.define("highlight","show",function(b,c){var d=a(this),e={backgroundColor:d.css("backgroundColor")};"hide"===b.mode&&(e.opacity=0),a.effects.saveStyle(d),d.css({backgroundImage:"none",backgroundColor:b.color||"#ffff99"}).animate(e,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),v=a.effects.define("size",function(b,c){var d,e,f,g=a(this),h=["fontSize"],i=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],j=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],k=b.mode,l="effect"!==k,m=b.scale||"both",n=b.origin||["middle","center"],o=g.css("position"),p=g.position(),q=a.effects.scaledDimensions(g),r=b.from||q,s=b.to||a.effects.scaledDimensions(g,0);a.effects.createPlaceholder(g),"show"===k&&(f=r,r=s,s=f),e={from:{y:r.height/q.height,x:r.width/q.width},to:{y:s.height/q.height,x:s.width/q.width}},"box"!==m&&"both"!==m||(e.from.y!==e.to.y&&(r=a.effects.setTransition(g,i,e.from.y,r),s=a.effects.setTransition(g,i,e.to.y,s)),e.from.x!==e.to.x&&(r=a.effects.setTransition(g,j,e.from.x,r),s=a.effects.setTransition(g,j,e.to.x,s))),"content"!==m&&"both"!==m||e.from.y!==e.to.y&&(r=a.effects.setTransition(g,h,e.from.y,r),s=a.effects.setTransition(g,h,e.to.y,s)),n&&(d=a.effects.getBaseline(n,q),r.top=(q.outerHeight-r.outerHeight)*d.y+p.top,r.left=(q.outerWidth-r.outerWidth)*d.x+p.left,s.top=(q.outerHeight-s.outerHeight)*d.y+p.top,s.left=(q.outerWidth-s.outerWidth)*d.x+p.left),g.css(r),"content"!==m&&"both"!==m||(i=i.concat(["marginTop","marginBottom"]).concat(h),j=j.concat(["marginLeft","marginRight"]),g.find("*[width]").each(function(){var c=a(this),d=a.effects.scaledDimensions(c),f={height:d.height*e.from.y,width:d.width*e.from.x,outerHeight:d.outerHeight*e.from.y,outerWidth:d.outerWidth*e.from.x},g={height:d.height*e.to.y,width:d.width*e.to.x,outerHeight:d.height*e.to.y,outerWidth:d.width*e.to.x};e.from.y!==e.to.y&&(f=a.effects.setTransition(c,i,e.from.y,f),g=a.effects.setTransition(c,i,e.to.y,g)),e.from.x!==e.to.x&&(f=a.effects.setTransition(c,j,e.from.x,f),g=a.effects.setTransition(c,j,e.to.x,g)),l&&a.effects.saveStyle(c),c.css(f),c.animate(g,b.duration,b.easing,function(){l&&a.effects.restoreStyle(c)})})),g.animate(s,{queue:!1,duration:b.duration,easing:b.easing,complete:function(){var b=g.offset();0===s.opacity&&g.css("opacity",r.opacity),l||(g.css("position","static"===o?"relative":o).offset(b),a.effects.saveStyle(g)),c()}})}),w=a.effects.define("scale",function(b,c){var d=a(this),e=b.mode,f=parseInt(b.percent,10)||(0===parseInt(b.percent,10)?0:"effect"!==e?0:100),g=a.extend(!0,{from:a.effects.scaledDimensions(d),to:a.effects.scaledDimensions(d,f,b.direction||"both"),origin:b.origin||["middle","center"]},b);b.fade&&(g.from.opacity=1,g.to.opacity=0),a.effects.effect.size.call(this,g,c)}),x=a.effects.define("puff","hide",function(b,c){var d=a.extend(!0,{},b,{fade:!0,percent:parseInt(b.percent,10)||150});a.effects.effect.scale.call(this,d,c)}),y=a.effects.define("pulsate","show",function(b,c){var d=a(this),e=b.mode,f="show"===e,g="hide"===e,h=f||g,i=2*(b.times||5)+(h?1:0),j=b.duration/i,k=0,l=1,m=d.queue().length;for(!f&&d.is(":visible")||(d.css("opacity",0).show(),k=1);l<i;l++)d.animate({opacity:k},j,b.easing),k=1-k;d.animate({opacity:k},j,b.easing),d.queue(c),a.effects.unshift(d,m,i+1)}),z=a.effects.define("shake",function(b,c){var d=1,e=a(this),f=b.direction||"left",g=b.distance||20,h=b.times||3,i=2*h+1,j=Math.round(b.duration/i),k="up"===f||"down"===f?"top":"left",l="up"===f||"left"===f,m={},n={},o={},p=e.queue().length;for(a.effects.createPlaceholder(e),m[k]=(l?"-=":"+=")+g,n[k]=(l?"+=":"-=")+2*g,o[k]=(l?"-=":"+=")+2*g,e.animate(m,j,b.easing);d<h;d++)e.animate(n,j,b.easing).animate(o,j,b.easing);e.animate(n,j,b.easing).animate(m,j/2,b.easing).queue(c),a.effects.unshift(e,p,i+1)}),A=a.effects.define("slide","show",function(b,c){var d,e,f=a(this),g={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},h=b.mode,i=b.direction||"left",j="up"===i||"down"===i?"top":"left",k="up"===i||"left"===i,l=b.distance||f["top"===j?"outerHeight":"outerWidth"](!0),m={};a.effects.createPlaceholder(f),d=f.cssClip(),e=f.position()[j],m[j]=(k?-1:1)*l+e,m.clip=f.cssClip(),m.clip[g[i][1]]=m.clip[g[i][0]],"show"===h&&(f.cssClip(m.clip),f.css(j,m[j]),m.clip=d,m[j]=e),f.animate(m,{queue:!1,duration:b.duration,easing:b.easing,complete:c})}),m;a.uiBackCompat!==!1&&(m=a.effects.define("transfer",function(b,c){a(this).transfer(b,c)}));var B=m;a.ui.focusable=function(b,c){var d,e,f,g,h,i=b.nodeName.toLowerCase();return"area"===i?(d=b.parentNode,e=d.name,!(!b.href||!e||"map"!==d.nodeName.toLowerCase())&&(f=a("img[usemap='#"+e+"']"),f.length>0&&f.is(":visible"))):(/^(input|select|textarea|button|object)$/.test(i)?(g=!b.disabled,g&&(h=a(b).closest("fieldset")[0],h&&(g=!h.disabled))):g="a"===i?b.href||c:c,g&&a(b).is(":visible")&&C(a(b)))};function C(a){var b=a.css("visibility");while("inherit"===b)a=a.parent(),b=a.css("visibility");return"hidden"!==b}a.extend(a.expr[":"],{focusable:function(b){return a.ui.focusable(b,null!=a.attr(b,"tabindex"))}});var D=a.ui.focusable,E=a.fn.form=function(){return"string"==typeof this[0].form?this.closest("form"):a(this[0].form)},F=a.ui.formResetMixin={_formResetHandler:function(){var b=a(this);setTimeout(function(){var c=b.data("ui-form-reset-instances");a.each(c,function(){this.refresh()})})},_bindFormResetHandler:function(){if(this.form=this.element.form(),this.form.length){var a=this.form.data("ui-form-reset-instances")||[];a.length||this.form.on("reset.ui-form-reset",this._formResetHandler),a.push(this),this.form.data("ui-form-reset-instances",a)}},_unbindFormResetHandler:function(){if(this.form.length){var b=this.form.data("ui-form-reset-instances");b.splice(a.inArray(this,b),1),b.length?this.form.data("ui-form-reset-instances",b):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")}}};"1.7"===a.fn.jquery.substring(0,3)&&(a.each(["Width","Height"],function(b,c){var d="Width"===c?["Left","Right"]:["Top","Bottom"],e=c.toLowerCase(),f={innerWidth:a.fn.innerWidth,innerHeight:a.fn.innerHeight,outerWidth:a.fn.outerWidth,outerHeight:a.fn.outerHeight};function g(b,c,e,f){return a.each(d,function(){c-=parseFloat(a.css(b,"padding"+this))||0,e&&(c-=parseFloat(a.css(b,"border"+this+"Width"))||0),f&&(c-=parseFloat(a.css(b,"margin"+this))||0)}),c}a.fn["inner"+c]=function(b){return void 0===b?f["inner"+c].call(this):this.each(function(){a(this).css(e,g(this,b)+"px")})},a.fn["outer"+c]=function(b,d){return"number"!=typeof b?f["outer"+c].call(this,b):this.each(function(){a(this).css(e,g(this,b,!0,d)+"px")})}}),a.fn.addBack=function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))});var G=a.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},H=a.ui.escapeSelector=function(){var a=/([!"#$%&'()*+,.\/:;<=>?@[\]^`{|}~])/g;return function(b){return b.replace(a,"\\$1")}}(),I=a.fn.labels=function(){var b,c,d,e,f;return this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(e=this.eq(0).parents("label"),d=this.attr("id"),d&&(b=this.eq(0).parents().last(),f=b.add(b.length?b.siblings():this.siblings()),
c="label[for='"+a.ui.escapeSelector(d)+"']",e=e.add(f.find(c).addBack(c))),this.pushStack(e))},J=a.fn.scrollParent=function(b){var c=this.css("position"),d="absolute"===c,e=b?/(auto|scroll|hidden)/:/(auto|scroll)/,f=this.parents().filter(function(){var b=a(this);return(!d||"static"!==b.css("position"))&&e.test(b.css("overflow")+b.css("overflow-y")+b.css("overflow-x"))}).eq(0);return"fixed"!==c&&f.length?f:a(this[0].ownerDocument||document)},K=a.extend(a.expr[":"],{tabbable:function(b){var c=a.attr(b,"tabindex"),d=null!=c;return(!d||c>=0)&&a.ui.focusable(b,d)}}),L=a.fn.extend({uniqueId:function(){var a=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++a)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&a(this).removeAttr("id")})}}),M=a.widget("ui.accordion",{version:"1.12.0",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:"> li > :first-child, > :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var b=this.options;this.prevShow=this.prevHide=a(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),b.collapsible||b.active!==!1&&null!=b.active||(b.active=0),this._processPanels(),b.active<0&&(b.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():a()}},_createIcons:function(){var b,c,d=this.options.icons;d&&(b=a("<span>"),this._addClass(b,"ui-accordion-header-icon","ui-icon "+d.header),b.prependTo(this.headers),c=this.active.children(".ui-accordion-header-icon"),this._removeClass(c,d.header)._addClass(c,null,d.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var a;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),a=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&a.css("height","")},_setOption:function(a,b){return"active"===a?void this._activate(b):("event"===a&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(b)),this._super(a,b),"collapsible"!==a||b||this.options.active!==!1||this._activate(0),void("icons"===a&&(this._destroyIcons(),b&&this._createIcons())))},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",a),this._toggleClass(null,"ui-state-disabled",!!a),this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!a)},_keydown:function(b){if(!b.altKey&&!b.ctrlKey){var c=a.ui.keyCode,d=this.headers.length,e=this.headers.index(b.target),f=!1;switch(b.keyCode){case c.RIGHT:case c.DOWN:f=this.headers[(e+1)%d];break;case c.LEFT:case c.UP:f=this.headers[(e-1+d)%d];break;case c.SPACE:case c.ENTER:this._eventHandler(b);break;case c.HOME:f=this.headers[0];break;case c.END:f=this.headers[d-1]}f&&(a(b.target).attr("tabIndex",-1),a(f).attr("tabIndex",0),a(f).trigger("focus"),b.preventDefault())}},_panelKeyDown:function(b){b.keyCode===a.ui.keyCode.UP&&b.ctrlKey&&a(b.currentTarget).prev().trigger("focus")},refresh:function(){var b=this.options;this._processPanels(),b.active===!1&&b.collapsible===!0||!this.headers.length?(b.active=!1,this.active=a()):b.active===!1?this._activate(0):this.active.length&&!a.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(b.active=!1,this.active=a()):this._activate(Math.max(0,b.active-1)):b.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var a=this.headers,b=this.panels;this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),b&&(this._off(a.not(this.headers)),this._off(b.not(this.panels)))},_refresh:function(){var b,c=this.options,d=c.heightStyle,e=this.element.parent();this.active=this._findActive(c.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var b=a(this),c=b.uniqueId().attr("id"),d=b.next(),e=d.uniqueId().attr("id");b.attr("aria-controls",e),d.attr("aria-labelledby",c)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(c.event),"fill"===d?(b=e.height(),this.element.siblings(":visible").each(function(){var c=a(this),d=c.css("position");"absolute"!==d&&"fixed"!==d&&(b-=c.outerHeight(!0))}),this.headers.each(function(){b-=a(this).outerHeight(!0)}),this.headers.next().each(function(){a(this).height(Math.max(0,b-a(this).innerHeight()+a(this).height()))}).css("overflow","auto")):"auto"===d&&(b=0,this.headers.next().each(function(){var c=a(this).is(":visible");c||a(this).show(),b=Math.max(b,a(this).css("height","").height()),c||a(this).hide()}).height(b))},_activate:function(b){var c=this._findActive(b)[0];c!==this.active[0]&&(c=c||this.active[0],this._eventHandler({target:c,currentTarget:c,preventDefault:a.noop}))},_findActive:function(b){return"number"==typeof b?this.headers.eq(b):a()},_setupEvents:function(b){var c={keydown:"_keydown"};b&&a.each(b.split(" "),function(a,b){c[b]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,c),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(b){var c,d,e=this.options,f=this.active,g=a(b.currentTarget),h=g[0]===f[0],i=h&&e.collapsible,j=i?a():g.next(),k=f.next(),l={oldHeader:f,oldPanel:k,newHeader:i?a():g,newPanel:j};b.preventDefault(),h&&!e.collapsible||this._trigger("beforeActivate",b,l)===!1||(e.active=!i&&this.headers.index(g),this.active=h?a():g,this._toggle(l),this._removeClass(f,"ui-accordion-header-active","ui-state-active"),e.icons&&(c=f.children(".ui-accordion-header-icon"),this._removeClass(c,null,e.icons.activeHeader)._addClass(c,null,e.icons.header)),h||(this._removeClass(g,"ui-accordion-header-collapsed")._addClass(g,"ui-accordion-header-active","ui-state-active"),e.icons&&(d=g.children(".ui-accordion-header-icon"),this._removeClass(d,null,e.icons.header)._addClass(d,null,e.icons.activeHeader)),this._addClass(g.next(),"ui-accordion-content-active")))},_toggle:function(b){var c=b.newPanel,d=this.prevShow.length?this.prevShow:b.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=c,this.prevHide=d,this.options.animate?this._animate(c,d,b):(d.hide(),c.show(),this._toggleComplete(b)),d.attr({"aria-hidden":"true"}),d.prev().attr({"aria-selected":"false","aria-expanded":"false"}),c.length&&d.length?d.prev().attr({tabIndex:-1,"aria-expanded":"false"}):c.length&&this.headers.filter(function(){return 0===parseInt(a(this).attr("tabIndex"),10)}).attr("tabIndex",-1),c.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(a,b,c){var d,e,f,g=this,h=0,i=a.css("box-sizing"),j=a.length&&(!b.length||a.index()<b.index()),k=this.options.animate||{},l=j&&k.down||k,m=function(){g._toggleComplete(c)};return"number"==typeof l&&(f=l),"string"==typeof l&&(e=l),e=e||l.easing||k.easing,f=f||l.duration||k.duration,b.length?a.length?(d=a.show().outerHeight(),b.animate(this.hideProps,{duration:f,easing:e,step:function(a,b){b.now=Math.round(a)}}),void a.hide().animate(this.showProps,{duration:f,easing:e,complete:m,step:function(a,c){c.now=Math.round(a),"height"!==c.prop?"content-box"===i&&(h+=c.now):"content"!==g.options.heightStyle&&(c.now=Math.round(d-b.outerHeight()-h),h=0)}})):b.animate(this.hideProps,f,e,m):a.animate(this.showProps,f,e,m)},_toggleComplete:function(a){var b=a.oldPanel,c=b.prev();this._removeClass(b,"ui-accordion-content-active"),this._removeClass(c,"ui-accordion-header-active")._addClass(c,"ui-accordion-header-collapsed"),b.length&&(b.parent()[0].className=b.parent()[0].className),this._trigger("activate",null,a)}}),N=a.ui.safeActiveElement=function(a){var b;try{b=a.activeElement}catch(c){b=a.body}return b||(b=a.body),b.nodeName||(b=a.body),b},O=a.widget("ui.menu",{version:"1.12.0",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(a){a.preventDefault()},"click .ui-menu-item":function(b){var c=a(b.target),d=a(a.ui.safeActiveElement(this.document[0]));!this.mouseHandled&&c.not(".ui-state-disabled").length&&(this.select(b),b.isPropagationStopped()||(this.mouseHandled=!0),c.has(".ui-menu").length?this.expand(b):!this.element.is(":focus")&&d.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(b){if(!this.previousFilter){var c=a(b.target).closest(".ui-menu-item"),d=a(b.currentTarget);c[0]===d[0]&&(this._removeClass(d.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(b,d))}},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(a,b){var c=this.active||this.element.find(this.options.items).eq(0);b||this.focus(a,c)},blur:function(b){this._delay(function(){var c=!a.contains(this.element[0],a.ui.safeActiveElement(this.document[0]));c&&this.collapseAll(b)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(a){this._closeOnDocumentClick(a)&&this.collapseAll(a),this.mouseHandled=!1}})},_destroy:function(){var b=this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),c=b.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),c.children().each(function(){var b=a(this);b.data("ui-menu-submenu-caret")&&b.remove()})},_keydown:function(b){var c,d,e,f,g=!0;switch(b.keyCode){case a.ui.keyCode.PAGE_UP:this.previousPage(b);break;case a.ui.keyCode.PAGE_DOWN:this.nextPage(b);break;case a.ui.keyCode.HOME:this._move("first","first",b);break;case a.ui.keyCode.END:this._move("last","last",b);break;case a.ui.keyCode.UP:this.previous(b);break;case a.ui.keyCode.DOWN:this.next(b);break;case a.ui.keyCode.LEFT:this.collapse(b);break;case a.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(b);break;case a.ui.keyCode.ENTER:case a.ui.keyCode.SPACE:this._activate(b);break;case a.ui.keyCode.ESCAPE:this.collapse(b);break;default:g=!1,d=this.previousFilter||"",e=String.fromCharCode(b.keyCode),f=!1,clearTimeout(this.filterTimer),e===d?f=!0:e=d+e,c=this._filterMenuItems(e),c=f&&c.index(this.active.next())!==-1?this.active.nextAll(".ui-menu-item"):c,c.length||(e=String.fromCharCode(b.keyCode),c=this._filterMenuItems(e)),c.length?(this.focus(b,c),this.previousFilter=e,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}g&&b.preventDefault()},_activate:function(a){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(a):this.select(a))},refresh:function(){var b,c,d,e,f,g=this,h=this.options.icons.submenu,i=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),d=i.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var b=a(this),c=b.prev(),d=a("<span>").data("ui-menu-submenu-caret",!0);g._addClass(d,"ui-menu-icon","ui-icon "+h),c.attr("aria-haspopup","true").prepend(d),b.attr("aria-labelledby",c.attr("id"))}),this._addClass(d,"ui-menu","ui-widget ui-widget-content ui-front"),b=i.add(this.element),c=b.find(this.options.items),c.not(".ui-menu-item").each(function(){var b=a(this);g._isDivider(b)&&g._addClass(b,"ui-menu-divider","ui-widget-content")}),e=c.not(".ui-menu-item, .ui-menu-divider"),f=e.children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(e,"ui-menu-item")._addClass(f,"ui-menu-item-wrapper"),c.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!a.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(a,b){if("icons"===a){var c=this.element.find(".ui-menu-icon");this._removeClass(c,null,this.options.icons.submenu)._addClass(c,null,b.submenu)}this._super(a,b)},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",String(a)),this._toggleClass(null,"ui-state-disabled",!!a)},focus:function(a,b){var c,d,e;this.blur(a,a&&"focus"===a.type),this._scrollIntoView(b),this.active=b.first(),d=this.active.children(".ui-menu-item-wrapper"),this._addClass(d,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",d.attr("id")),e=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(e,null,"ui-state-active"),a&&"keydown"===a.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),c=b.children(".ui-menu"),c.length&&a&&/^mouse/.test(a.type)&&this._startOpening(c),this.activeMenu=b.parent(),this._trigger("focus",a,{item:b})},_scrollIntoView:function(b){var c,d,e,f,g,h;this._hasScroll()&&(c=parseFloat(a.css(this.activeMenu[0],"borderTopWidth"))||0,d=parseFloat(a.css(this.activeMenu[0],"paddingTop"))||0,e=b.offset().top-this.activeMenu.offset().top-c-d,f=this.activeMenu.scrollTop(),g=this.activeMenu.height(),h=b.outerHeight(),e<0?this.activeMenu.scrollTop(f+e):e+h>g&&this.activeMenu.scrollTop(f+e-g+h))},blur:function(a,b){b||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",a,{item:this.active}),this.active=null)},_startOpening:function(a){clearTimeout(this.timer),"true"===a.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(a)},this.delay))},_open:function(b){var c=a.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(b.parents(".ui-menu")).hide().attr("aria-hidden","true"),b.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(c)},collapseAll:function(b,c){clearTimeout(this.timer),this.timer=this._delay(function(){var d=c?this.element:a(b&&b.target).closest(this.element.find(".ui-menu"));d.length||(d=this.element),this._close(d),this.blur(b),this._removeClass(d.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=d},this.delay)},_close:function(a){a||(a=this.active?this.active.parent():this.element),a.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(b){return!a(b.target).closest(".ui-menu").length},_isDivider:function(a){return!/[^\-\u2014\u2013\s]/.test(a.text())},collapse:function(a){var b=this.active&&this.active.parent().closest(".ui-menu-item",this.element);b&&b.length&&(this._close(),this.focus(a,b))},expand:function(a){var b=this.active&&this.active.children(".ui-menu ").find(this.options.items).first();b&&b.length&&(this._open(b.parent()),this._delay(function(){this.focus(a,b)}))},next:function(a){this._move("next","first",a)},previous:function(a){this._move("prev","last",a)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(a,b,c){var d;this.active&&(d="first"===a||"last"===a?this.active["first"===a?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[a+"All"](".ui-menu-item").eq(0)),d&&d.length&&this.active||(d=this.activeMenu.find(this.options.items)[b]()),this.focus(c,d)},nextPage:function(b){var c,d,e;return this.active?void(this.isLastItem()||(this._hasScroll()?(d=this.active.offset().top,e=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return c=a(this),c.offset().top-d-e<0}),this.focus(b,c)):this.focus(b,this.activeMenu.find(this.options.items)[this.active?"last":"first"]()))):void this.next(b)},previousPage:function(b){var c,d,e;return this.active?void(this.isFirstItem()||(this._hasScroll()?(d=this.active.offset().top,e=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return c=a(this),c.offset().top-d+e>0}),this.focus(b,c)):this.focus(b,this.activeMenu.find(this.options.items).first()))):void this.next(b)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(b){this.active=this.active||a(b.target).closest(".ui-menu-item");var c={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(b,!0),this._trigger("select",b,c)},_filterMenuItems:function(b){var c=b.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),d=new RegExp("^"+c,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return d.test(a.trim(a(this).children(".ui-menu-item-wrapper").text()))})}});a.widget("ui.autocomplete",{version:"1.12.0",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var b,c,d,e=this.element[0].nodeName.toLowerCase(),f="textarea"===e,g="input"===e;this.isMultiLine=f||!g&&this._isContentEditable(this.element),this.valueMethod=this.element[f||g?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(e){if(this.element.prop("readOnly"))return b=!0,d=!0,void(c=!0);b=!1,d=!1,c=!1;var f=a.ui.keyCode;switch(e.keyCode){case f.PAGE_UP:b=!0,this._move("previousPage",e);break;case f.PAGE_DOWN:b=!0,this._move("nextPage",e);break;case f.UP:b=!0,this._keyEvent("previous",e);break;case f.DOWN:b=!0,this._keyEvent("next",e);break;case f.ENTER:this.menu.active&&(b=!0,e.preventDefault(),this.menu.select(e));break;case f.TAB:this.menu.active&&this.menu.select(e);break;case f.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(e),e.preventDefault());break;default:c=!0,this._searchTimeout(e)}},keypress:function(d){if(b)return b=!1,void(this.isMultiLine&&!this.menu.element.is(":visible")||d.preventDefault());if(!c){var e=a.ui.keyCode;switch(d.keyCode){case e.PAGE_UP:this._move("previousPage",d);break;case e.PAGE_DOWN:this._move("nextPage",d);break;case e.UP:this._keyEvent("previous",d);break;case e.DOWN:this._keyEvent("next",d)}}},input:function(a){return d?(d=!1,void a.preventDefault()):void this._searchTimeout(a)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(a){return this.cancelBlur?void delete this.cancelBlur:(clearTimeout(this.searching),this.close(a),void this._change(a))}}),this._initSource(),this.menu=a("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(b){b.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,this.element[0]!==a.ui.safeActiveElement(this.document[0])&&this.element.trigger("focus")})},menufocus:function(b,c){var d,e;return this.isNewMenu&&(this.isNewMenu=!1,b.originalEvent&&/^mouse/.test(b.originalEvent.type))?(this.menu.blur(),void this.document.one("mousemove",function(){a(b.target).trigger(b.originalEvent)})):(e=c.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",b,{item:e})&&b.originalEvent&&/^key/.test(b.originalEvent.type)&&this._value(e.value),d=c.item.attr("aria-label")||e.value,void(d&&a.trim(d).length&&(this.liveRegion.children().hide(),a("<div>").text(d).appendTo(this.liveRegion))))},menuselect:function(b,c){var d=c.item.data("ui-autocomplete-item"),e=this.previous;this.element[0]!==a.ui.safeActiveElement(this.document[0])&&(this.element.trigger("focus"),this.previous=e,this._delay(function(){this.previous=e,this.selectedItem=d})),!1!==this._trigger("select",b,{item:d})&&this._value(d.value),this.term=this._value(),this.close(b),this.selectedItem=d}}),this.liveRegion=a("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(a,b){this._super(a,b),"source"===a&&this._initSource(),"appendTo"===a&&this.menu.element.appendTo(this._appendTo()),"disabled"===a&&b&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(b){var c=this.menu.element[0];return b.target===this.element[0]||b.target===c||a.contains(c,b.target)},_closeOnClickOutside:function(a){this._isEventTargetInWidget(a)||this.close()},_appendTo:function(){var b=this.options.appendTo;return b&&(b=b.jquery||b.nodeType?a(b):this.document.find(b).eq(0)),b&&b[0]||(b=this.element.closest(".ui-front, dialog")),b.length||(b=this.document[0].body),b},_initSource:function(){var b,c,d=this;a.isArray(this.options.source)?(b=this.options.source,this.source=function(c,d){d(a.ui.autocomplete.filter(b,c.term))}):"string"==typeof this.options.source?(c=this.options.source,this.source=function(b,e){d.xhr&&d.xhr.abort(),d.xhr=a.ajax({url:c,data:b,dataType:"json",success:function(a){e(a)},error:function(){e([])}})}):this.source=this.options.source},_searchTimeout:function(a){clearTimeout(this.searching),this.searching=this._delay(function(){var b=this.term===this._value(),c=this.menu.element.is(":visible"),d=a.altKey||a.ctrlKey||a.metaKey||a.shiftKey;b&&(!b||c||d)||(this.selectedItem=null,this.search(null,a))},this.options.delay)},search:function(a,b){return a=null!=a?a:this._value(),this.term=this._value(),a.length<this.options.minLength?this.close(b):this._trigger("search",b)!==!1?this._search(a):void 0},_search:function(a){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:a},this._response())},_response:function(){var b=++this.requestIndex;return a.proxy(function(a){b===this.requestIndex&&this.__response(a),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")},this)},__response:function(a){a&&(a=this._normalize(a)),this._trigger("response",null,{content:a}),!this.options.disabled&&a&&a.length&&!this.cancelSearch?(this._suggest(a),this._trigger("open")):this._close()},close:function(a){this.cancelSearch=!0,this._close(a)},_close:function(a){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",a))},_change:function(a){this.previous!==this._value()&&this._trigger("change",a,{item:this.selectedItem})},_normalize:function(b){return b.length&&b[0].label&&b[0].value?b:a.map(b,function(b){return"string"==typeof b?{label:b,value:b}:a.extend({},b,{label:b.label||b.value,value:b.value||b.label})})},_suggest:function(b){var c=this.menu.element.empty();this._renderMenu(c,b),this.isNewMenu=!0,this.menu.refresh(),c.show(),this._resizeMenu(),c.position(a.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var a=this.menu.element;a.outerWidth(Math.max(a.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(b,c){var d=this;a.each(c,function(a,c){d._renderItemData(b,c)})},_renderItemData:function(a,b){return this._renderItem(a,b).data("ui-autocomplete-item",b)},_renderItem:function(b,c){return a("<li>").append(a("<div>").text(c.label)).appendTo(b)},_move:function(a,b){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(a)||this.menu.isLastItem()&&/^next/.test(a)?(this.isMultiLine||this._value(this.term),void this.menu.blur()):void this.menu[a](b):void this.search(null,b)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(a,b){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(a,b),b.preventDefault())},_isContentEditable:function(a){if(!a.length)return!1;var b=a.prop("contentEditable");return"inherit"===b?this._isContentEditable(a.parent()):"true"===b}}),a.extend(a.ui.autocomplete,{escapeRegex:function(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(b,c){var d=new RegExp(a.ui.autocomplete.escapeRegex(c),"i");return a.grep(b,function(a){return d.test(a.label||a.value||a)})}}),a.widget("ui.autocomplete",a.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(a){return a+(a>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(b){var c;this._superApply(arguments),this.options.disabled||this.cancelSearch||(c=b&&b.length?this.options.messages.results(b.length):this.options.messages.noResults,this.liveRegion.children().hide(),a("<div>").text(c).appendTo(this.liveRegion))}});var P=a.ui.autocomplete,Q=/ui-corner-([a-z]){2,6}/g,R=a.widget("ui.controlgroup",{version:"1.12.0",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var b=this,c=[];a.each(this.options.items,function(d,e){var f,g={};if(e)return"controlgroupLabel"===d?(f=b.element.find(e),f.each(function(){var b=a(this);b.children(".ui-controlgroup-label-contents").length||b.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),b._addClass(f,null,"ui-widget ui-widget-content ui-state-default"),void(c=c.concat(f.get()))):void(a.fn[d]&&(b["_"+d+"Options"]&&(g=b["_"+d+"Options"]("middle")),b.element.find(e).each(function(){var e=a(this),f=e[d]("instance"),h=a.widget.extend({},g);if("button"!==d||!e.parent(".ui-spinner").length){f||(f=e[d]()[d]("instance")),f&&(h.classes=b._resolveClassesValues(h.classes,f)),e[d](h);var i=e[d]("widget");a.data(i[0],"ui-controlgroup-data",f?f:e[d]("instance")),c.push(i[0])}})))}),this.childWidgets=a(a.unique(c)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(b){this.childWidgets.each(function(){var c=a(this),d=c.data("ui-controlgroup-data");d&&d[b]&&d[b]()})},_updateCornerClass:function(a,b){var c="ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all",d=this._buildSimpleOptions(b,"label").classes.label;this._removeClass(a,null,c),this._addClass(a,null,d)},_buildSimpleOptions:function(a,b){var c="vertical"===this.options.direction,d={classes:{}};return d.classes[b]={middle:"",first:"ui-corner-"+(c?"top":"left"),last:"ui-corner-"+(c?"bottom":"right"),only:"ui-corner-all"}[a],d},_spinnerOptions:function(a){var b=this._buildSimpleOptions(a,"ui-spinner");return b.classes["ui-spinner-up"]="",b.classes["ui-spinner-down"]="",b},_buttonOptions:function(a){return this._buildSimpleOptions(a,"ui-button")},_checkboxradioOptions:function(a){return this._buildSimpleOptions(a,"ui-checkboxradio-label")},_selectmenuOptions:function(a){var b="vertical"===this.options.direction;return{width:!!b&&"auto",classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(b?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(b?"top":"left")},last:{"ui-selectmenu-button-open":b?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(b?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[a]}},_resolveClassesValues:function(b,c){var d={};return a.each(b,function(a){var e=c.options.classes[a]||"";e=e.replace(Q,"").trim(),d[a]=(e+" "+b[a]).replace(/\s+/g," ")}),d},_setOption:function(a,b){return"direction"===a&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(a,b),"disabled"===a?void this._callChildMethod(b?"disable":"enable"):void this.refresh()},refresh:function(){var b,c=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),b=this.childWidgets,this.options.onlyVisible&&(b=b.filter(":visible")),b.length&&(a.each(["first","last"],function(a,d){var e=b[d]().data("ui-controlgroup-data");if(e&&c["_"+e.widgetName+"Options"]){var f=c["_"+e.widgetName+"Options"](1===b.length?"only":d);f.classes=c._resolveClassesValues(f.classes,e),e.element[e.widgetName](f)}else c._updateCornerClass(b[d](),d)}),this._callChildMethod("refresh"))}});a.widget("ui.checkboxradio",[a.ui.formResetMixin,{version:"1.12.0",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var b,c,d=this,e=this._super()||{};return this._readType(),c=this.element.labels(),this.label=a(c[c.length-1]),this.label.length||a.error("No label found for checkboxradio widget"),this.originalLabel="",this.label.contents().not(this.element).each(function(){d.originalLabel+=3===this.nodeType?a(this).text():this.outerHTML}),this.originalLabel&&(e.label=this.originalLabel),b=this.element[0].disabled,null!=b&&(e.disabled=b),e},_create:function(){var a=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),
"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),a&&(this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this.icon&&this._addClass(this.icon,null,"ui-state-hover")),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var b=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===b&&/radio|checkbox/.test(this.type)||a.error("Can't create checkboxradio on element.nodeName="+b+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var b,c=this.element[0].name,d="input[name='"+a.ui.escapeSelector(c)+"']";return c?(b=this.form.length?a(this.form[0].elements).filter(d):a(d).filter(function(){return 0===a(this).form().length}),b.not(this.element)):a([])},_toggleClasses:function(){var b=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",b),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",b)._toggleClass(this.icon,null,"ui-icon-blank",!b),"radio"===this.type&&this._getRadioGroup().each(function(){var b=a(this).checkboxradio("instance");b&&b._removeClass(b.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(a,b){if("label"!==a||b)return this._super(a,b),"disabled"===a?(this._toggleClass(this.label,null,"ui-state-disabled",b),void(this.element[0].disabled=b)):void this.refresh()},_updateIcon:function(b){var c="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=a("<span>"),this.iconSpace=a("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(c+=b?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,b?"ui-icon-blank":"ui-icon-check")):c+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",c),b||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){this.label.contents().not(this.element.add(this.icon).add(this.iconSpace)).remove(),this.label.append(this.options.label)},refresh:function(){var a=this.element[0].checked,b=this.element[0].disabled;this._updateIcon(a),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",a),null!==this.options.label&&this._updateLabel(),b!==this.options.disabled&&this._setOptions({disabled:b})}}]);var S=a.ui.checkboxradio;a.widget("ui.button",{version:"1.12.0",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var a,b=this._super()||{};return this.isInput=this.element.is("input"),a=this.element[0].disabled,null!=a&&(b.disabled=a),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(b.label=this.originalLabel),b},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(b){b.keyCode===a.ui.keyCode.SPACE&&(b.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(b,c){var d="iconPosition"!==b,e=d?this.options.iconPosition:c,f="top"===e||"bottom"===e;this.icon?d&&this._removeClass(this.icon,null,this.options.icon):(this.icon=a("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),d&&this._addClass(this.icon,null,c),this._attachIcon(e),f?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=a("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(e))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(a){this.icon[/^(?:end|bottom)/.test(a)?"before":"after"](this.iconSpace)},_attachIcon:function(a){this.element[/^(?:end|bottom)/.test(a)?"append":"prepend"](this.icon)},_setOptions:function(a){var b=void 0===a.showLabel?this.options.showLabel:a.showLabel,c=void 0===a.icon?this.options.icon:a.icon;b||c||(a.showLabel=!0),this._super(a)},_setOption:function(a,b){"icon"===a&&(b?this._updateIcon(a,b):this.icon&&(this.icon.remove(),this.iconSpace&&this.iconSpace.remove())),"iconPosition"===a&&this._updateIcon(a,b),"showLabel"===a&&(this._toggleClass("ui-button-icon-only",null,!b),this._updateTooltip()),"label"===a&&(this.isInput?this.element.val(b):(this.element.html(b),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(a,b),"disabled"===a&&(this._toggleClass(null,"ui-state-disabled",b),this.element[0].disabled=b,b&&this.element.blur())},refresh:function(){var a=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");a!==this.options.disabled&&this._setOptions({disabled:a}),this._updateTooltip()}}),a.uiBackCompat!==!1&&(a.widget("ui.button",a.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(a,b){return"text"===a?void this._super("showLabel",b):("showLabel"===a&&(this.options.text=b),"icon"===a&&(this.options.icons.primary=b),"icons"===a&&(b.primary?(this._super("icon",b.primary),this._super("iconPosition","beginning")):b.secondary&&(this._super("icon",b.secondary),this._super("iconPosition","end"))),void this._superApply(arguments))}}),a.fn.button=function(b){return function(){return!this.length||this.length&&"INPUT"!==this[0].tagName||this.length&&"INPUT"===this[0].tagName&&"checkbox"!==this.attr("type")&&"radio"!==this.attr("type")?b.apply(this,arguments):(a.ui.checkboxradio||a.error("Checkboxradio widget missing"),0===arguments.length?this.checkboxradio({icon:!1}):this.checkboxradio.apply(this,arguments))}}(a.fn.button),a.fn.buttonset=function(){return a.ui.controlgroup||a.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))});var T=a.ui.button;a.extend(a.ui,{datepicker:{version:"1.12.0"}});var U;function V(a){var b,c;while(a.length&&a[0]!==document){if(b=a.css("position"),("absolute"===b||"relative"===b||"fixed"===b)&&(c=parseInt(a.css("zIndex"),10),!isNaN(c)&&0!==c))return c;a=a.parent()}return 0}function W(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},a.extend(this._defaults,this.regional[""]),this.regional.en=a.extend(!0,{},this.regional[""]),this.regional["en-US"]=a.extend(!0,{},this.regional.en),this.dpDiv=X(a("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}a.extend(W.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(a){return Z(this._defaults,a||{}),this},_attachDatepicker:function(b,c){var d,e,f;d=b.nodeName.toLowerCase(),e="div"===d||"span"===d,b.id||(this.uuid+=1,b.id="dp"+this.uuid),f=this._newInst(a(b),e),f.settings=a.extend({},c||{}),"input"===d?this._connectDatepicker(b,f):e&&this._inlineDatepicker(b,f)},_newInst:function(b,c){var d=b[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:d,input:b,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:c,dpDiv:c?X(a("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(b,c){var d=a(b);c.append=a([]),c.trigger=a([]),d.hasClass(this.markerClassName)||(this._attachments(d,c),d.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(c),a.data(b,"datepicker",c),c.settings.disabled&&this._disableDatepicker(b))},_attachments:function(b,c){var d,e,f,g=this._get(c,"appendText"),h=this._get(c,"isRTL");c.append&&c.append.remove(),g&&(c.append=a("<span class='"+this._appendClass+"'>"+g+"</span>"),b[h?"before":"after"](c.append)),b.off("focus",this._showDatepicker),c.trigger&&c.trigger.remove(),d=this._get(c,"showOn"),"focus"!==d&&"both"!==d||b.on("focus",this._showDatepicker),"button"!==d&&"both"!==d||(e=this._get(c,"buttonText"),f=this._get(c,"buttonImage"),c.trigger=a(this._get(c,"buttonImageOnly")?a("<img/>").addClass(this._triggerClass).attr({src:f,alt:e,title:e}):a("<button type='button'></button>").addClass(this._triggerClass).html(f?a("<img/>").attr({src:f,alt:e,title:e}):e)),b[h?"before":"after"](c.trigger),c.trigger.on("click",function(){return a.datepicker._datepickerShowing&&a.datepicker._lastInput===b[0]?a.datepicker._hideDatepicker():a.datepicker._datepickerShowing&&a.datepicker._lastInput!==b[0]?(a.datepicker._hideDatepicker(),a.datepicker._showDatepicker(b[0])):a.datepicker._showDatepicker(b[0]),!1}))},_autoSize:function(a){if(this._get(a,"autoSize")&&!a.inline){var b,c,d,e,f=new Date(2009,11,20),g=this._get(a,"dateFormat");g.match(/[DM]/)&&(b=function(a){for(c=0,d=0,e=0;e<a.length;e++)a[e].length>c&&(c=a[e].length,d=e);return d},f.setMonth(b(this._get(a,g.match(/MM/)?"monthNames":"monthNamesShort"))),f.setDate(b(this._get(a,g.match(/DD/)?"dayNames":"dayNamesShort"))+20-f.getDay())),a.input.attr("size",this._formatDate(a,f).length)}},_inlineDatepicker:function(b,c){var d=a(b);d.hasClass(this.markerClassName)||(d.addClass(this.markerClassName).append(c.dpDiv),a.data(b,"datepicker",c),this._setDate(c,this._getDefaultDate(c),!0),this._updateDatepicker(c),this._updateAlternate(c),c.settings.disabled&&this._disableDatepicker(b),c.dpDiv.css("display","block"))},_dialogDatepicker:function(b,c,d,e,f){var g,h,i,j,k,l=this._dialogInst;return l||(this.uuid+=1,g="dp"+this.uuid,this._dialogInput=a("<input type='text' id='"+g+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),a("body").append(this._dialogInput),l=this._dialogInst=this._newInst(this._dialogInput,!1),l.settings={},a.data(this._dialogInput[0],"datepicker",l)),Z(l.settings,e||{}),c=c&&c.constructor===Date?this._formatDate(l,c):c,this._dialogInput.val(c),this._pos=f?f.length?f:[f.pageX,f.pageY]:null,this._pos||(h=document.documentElement.clientWidth,i=document.documentElement.clientHeight,j=document.documentElement.scrollLeft||document.body.scrollLeft,k=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[h/2-100+j,i/2-150+k]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),l.settings.onSelect=d,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),a.blockUI&&a.blockUI(this.dpDiv),a.data(this._dialogInput[0],"datepicker",l),this},_destroyDatepicker:function(b){var c,d=a(b),e=a.data(b,"datepicker");d.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),a.removeData(b,"datepicker"),"input"===c?(e.append.remove(),e.trigger.remove(),d.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==c&&"span"!==c||d.removeClass(this.markerClassName).empty(),U===e&&(U=null))},_enableDatepicker:function(b){var c,d,e=a(b),f=a.data(b,"datepicker");e.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),"input"===c?(b.disabled=!1,f.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==c&&"span"!==c||(d=e.children("."+this._inlineClass),d.children().removeClass("ui-state-disabled"),d.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=a.map(this._disabledInputs,function(a){return a===b?null:a}))},_disableDatepicker:function(b){var c,d,e=a(b),f=a.data(b,"datepicker");e.hasClass(this.markerClassName)&&(c=b.nodeName.toLowerCase(),"input"===c?(b.disabled=!0,f.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==c&&"span"!==c||(d=e.children("."+this._inlineClass),d.children().addClass("ui-state-disabled"),d.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=a.map(this._disabledInputs,function(a){return a===b?null:a}),this._disabledInputs[this._disabledInputs.length]=b)},_isDisabledDatepicker:function(a){if(!a)return!1;for(var b=0;b<this._disabledInputs.length;b++)if(this._disabledInputs[b]===a)return!0;return!1},_getInst:function(b){try{return a.data(b,"datepicker")}catch(a){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(b,c,d){var e,f,g,h,i=this._getInst(b);return 2===arguments.length&&"string"==typeof c?"defaults"===c?a.extend({},a.datepicker._defaults):i?"all"===c?a.extend({},i.settings):this._get(i,c):null:(e=c||{},"string"==typeof c&&(e={},e[c]=d),void(i&&(this._curInst===i&&this._hideDatepicker(),f=this._getDateDatepicker(b,!0),g=this._getMinMaxDate(i,"min"),h=this._getMinMaxDate(i,"max"),Z(i.settings,e),null!==g&&void 0!==e.dateFormat&&void 0===e.minDate&&(i.settings.minDate=this._formatDate(i,g)),null!==h&&void 0!==e.dateFormat&&void 0===e.maxDate&&(i.settings.maxDate=this._formatDate(i,h)),"disabled"in e&&(e.disabled?this._disableDatepicker(b):this._enableDatepicker(b)),this._attachments(a(b),i),this._autoSize(i),this._setDate(i,f),this._updateAlternate(i),this._updateDatepicker(i))))},_changeDatepicker:function(a,b,c){this._optionDatepicker(a,b,c)},_refreshDatepicker:function(a){var b=this._getInst(a);b&&this._updateDatepicker(b)},_setDateDatepicker:function(a,b){var c=this._getInst(a);c&&(this._setDate(c,b),this._updateDatepicker(c),this._updateAlternate(c))},_getDateDatepicker:function(a,b){var c=this._getInst(a);return c&&!c.inline&&this._setDateFromField(c,b),c?this._getDate(c):null},_doKeyDown:function(b){var c,d,e,f=a.datepicker._getInst(b.target),g=!0,h=f.dpDiv.is(".ui-datepicker-rtl");if(f._keyEvent=!0,a.datepicker._datepickerShowing)switch(b.keyCode){case 9:a.datepicker._hideDatepicker(),g=!1;break;case 13:return e=a("td."+a.datepicker._dayOverClass+":not(."+a.datepicker._currentClass+")",f.dpDiv),e[0]&&a.datepicker._selectDay(b.target,f.selectedMonth,f.selectedYear,e[0]),c=a.datepicker._get(f,"onSelect"),c?(d=a.datepicker._formatDate(f),c.apply(f.input?f.input[0]:null,[d,f])):a.datepicker._hideDatepicker(),!1;case 27:a.datepicker._hideDatepicker();break;case 33:a.datepicker._adjustDate(b.target,b.ctrlKey?-a.datepicker._get(f,"stepBigMonths"):-a.datepicker._get(f,"stepMonths"),"M");break;case 34:a.datepicker._adjustDate(b.target,b.ctrlKey?+a.datepicker._get(f,"stepBigMonths"):+a.datepicker._get(f,"stepMonths"),"M");break;case 35:(b.ctrlKey||b.metaKey)&&a.datepicker._clearDate(b.target),g=b.ctrlKey||b.metaKey;break;case 36:(b.ctrlKey||b.metaKey)&&a.datepicker._gotoToday(b.target),g=b.ctrlKey||b.metaKey;break;case 37:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,h?1:-1,"D"),g=b.ctrlKey||b.metaKey,b.originalEvent.altKey&&a.datepicker._adjustDate(b.target,b.ctrlKey?-a.datepicker._get(f,"stepBigMonths"):-a.datepicker._get(f,"stepMonths"),"M");break;case 38:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,-7,"D"),g=b.ctrlKey||b.metaKey;break;case 39:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,h?-1:1,"D"),g=b.ctrlKey||b.metaKey,b.originalEvent.altKey&&a.datepicker._adjustDate(b.target,b.ctrlKey?+a.datepicker._get(f,"stepBigMonths"):+a.datepicker._get(f,"stepMonths"),"M");break;case 40:(b.ctrlKey||b.metaKey)&&a.datepicker._adjustDate(b.target,7,"D"),g=b.ctrlKey||b.metaKey;break;default:g=!1}else 36===b.keyCode&&b.ctrlKey?a.datepicker._showDatepicker(this):g=!1;g&&(b.preventDefault(),b.stopPropagation())},_doKeyPress:function(b){var c,d,e=a.datepicker._getInst(b.target);if(a.datepicker._get(e,"constrainInput"))return c=a.datepicker._possibleChars(a.datepicker._get(e,"dateFormat")),d=String.fromCharCode(null==b.charCode?b.keyCode:b.charCode),b.ctrlKey||b.metaKey||d<" "||!c||c.indexOf(d)>-1},_doKeyUp:function(b){var c,d=a.datepicker._getInst(b.target);if(d.input.val()!==d.lastVal)try{c=a.datepicker.parseDate(a.datepicker._get(d,"dateFormat"),d.input?d.input.val():null,a.datepicker._getFormatConfig(d)),c&&(a.datepicker._setDateFromField(d),a.datepicker._updateAlternate(d),a.datepicker._updateDatepicker(d))}catch(a){}return!0},_showDatepicker:function(b){if(b=b.target||b,"input"!==b.nodeName.toLowerCase()&&(b=a("input",b.parentNode)[0]),!a.datepicker._isDisabledDatepicker(b)&&a.datepicker._lastInput!==b){var c,d,e,f,g,h,i;c=a.datepicker._getInst(b),a.datepicker._curInst&&a.datepicker._curInst!==c&&(a.datepicker._curInst.dpDiv.stop(!0,!0),c&&a.datepicker._datepickerShowing&&a.datepicker._hideDatepicker(a.datepicker._curInst.input[0])),d=a.datepicker._get(c,"beforeShow"),e=d?d.apply(b,[b,c]):{},e!==!1&&(Z(c.settings,e),c.lastVal=null,a.datepicker._lastInput=b,a.datepicker._setDateFromField(c),a.datepicker._inDialog&&(b.value=""),a.datepicker._pos||(a.datepicker._pos=a.datepicker._findPos(b),a.datepicker._pos[1]+=b.offsetHeight),f=!1,a(b).parents().each(function(){return f|="fixed"===a(this).css("position"),!f}),g={left:a.datepicker._pos[0],top:a.datepicker._pos[1]},a.datepicker._pos=null,c.dpDiv.empty(),c.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),a.datepicker._updateDatepicker(c),g=a.datepicker._checkOffset(c,g,f),c.dpDiv.css({position:a.datepicker._inDialog&&a.blockUI?"static":f?"fixed":"absolute",display:"none",left:g.left+"px",top:g.top+"px"}),c.inline||(h=a.datepicker._get(c,"showAnim"),i=a.datepicker._get(c,"duration"),c.dpDiv.css("z-index",V(a(b))+1),a.datepicker._datepickerShowing=!0,a.effects&&a.effects.effect[h]?c.dpDiv.show(h,a.datepicker._get(c,"showOptions"),i):c.dpDiv[h||"show"](h?i:null),a.datepicker._shouldFocusInput(c)&&c.input.trigger("focus"),a.datepicker._curInst=c))}},_updateDatepicker:function(b){this.maxRows=4,U=b,b.dpDiv.empty().append(this._generateHTML(b)),this._attachHandlers(b);var c,d=this._getNumberOfMonths(b),e=d[1],f=17,g=b.dpDiv.find("."+this._dayOverClass+" a");g.length>0&&Y.apply(g.get(0)),b.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),e>1&&b.dpDiv.addClass("ui-datepicker-multi-"+e).css("width",f*e+"em"),b.dpDiv[(1!==d[0]||1!==d[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),b.dpDiv[(this._get(b,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),b===a.datepicker._curInst&&a.datepicker._datepickerShowing&&a.datepicker._shouldFocusInput(b)&&b.input.trigger("focus"),b.yearshtml&&(c=b.yearshtml,setTimeout(function(){c===b.yearshtml&&b.yearshtml&&b.dpDiv.find("select.ui-datepicker-year:first").replaceWith(b.yearshtml),c=b.yearshtml=null},0))},_shouldFocusInput:function(a){return a.input&&a.input.is(":visible")&&!a.input.is(":disabled")&&!a.input.is(":focus")},_checkOffset:function(b,c,d){var e=b.dpDiv.outerWidth(),f=b.dpDiv.outerHeight(),g=b.input?b.input.outerWidth():0,h=b.input?b.input.outerHeight():0,i=document.documentElement.clientWidth+(d?0:a(document).scrollLeft()),j=document.documentElement.clientHeight+(d?0:a(document).scrollTop());return c.left-=this._get(b,"isRTL")?e-g:0,c.left-=d&&c.left===b.input.offset().left?a(document).scrollLeft():0,c.top-=d&&c.top===b.input.offset().top+h?a(document).scrollTop():0,c.left-=Math.min(c.left,c.left+e>i&&i>e?Math.abs(c.left+e-i):0),c.top-=Math.min(c.top,c.top+f>j&&j>f?Math.abs(f+h):0),c},_findPos:function(b){var c,d=this._getInst(b),e=this._get(d,"isRTL");while(b&&("hidden"===b.type||1!==b.nodeType||a.expr.filters.hidden(b)))b=b[e?"previousSibling":"nextSibling"];return c=a(b).offset(),[c.left,c.top]},_hideDatepicker:function(b){var c,d,e,f,g=this._curInst;!g||b&&g!==a.data(b,"datepicker")||this._datepickerShowing&&(c=this._get(g,"showAnim"),d=this._get(g,"duration"),e=function(){a.datepicker._tidyDialog(g)},a.effects&&(a.effects.effect[c]||a.effects[c])?g.dpDiv.hide(c,a.datepicker._get(g,"showOptions"),d,e):g.dpDiv["slideDown"===c?"slideUp":"fadeIn"===c?"fadeOut":"hide"](c?d:null,e),c||e(),this._datepickerShowing=!1,f=this._get(g,"onClose"),f&&f.apply(g.input?g.input[0]:null,[g.input?g.input.val():"",g]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),a.blockUI&&(a.unblockUI(),a("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(a){a.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(b){if(a.datepicker._curInst){var c=a(b.target),d=a.datepicker._getInst(c[0]);(c[0].id===a.datepicker._mainDivId||0!==c.parents("#"+a.datepicker._mainDivId).length||c.hasClass(a.datepicker.markerClassName)||c.closest("."+a.datepicker._triggerClass).length||!a.datepicker._datepickerShowing||a.datepicker._inDialog&&a.blockUI)&&(!c.hasClass(a.datepicker.markerClassName)||a.datepicker._curInst===d)||a.datepicker._hideDatepicker()}},_adjustDate:function(b,c,d){var e=a(b),f=this._getInst(e[0]);this._isDisabledDatepicker(e[0])||(this._adjustInstDate(f,c+("M"===d?this._get(f,"showCurrentAtPos"):0),d),this._updateDatepicker(f))},_gotoToday:function(b){var c,d=a(b),e=this._getInst(d[0]);this._get(e,"gotoCurrent")&&e.currentDay?(e.selectedDay=e.currentDay,e.drawMonth=e.selectedMonth=e.currentMonth,e.drawYear=e.selectedYear=e.currentYear):(c=new Date,e.selectedDay=c.getDate(),e.drawMonth=e.selectedMonth=c.getMonth(),e.drawYear=e.selectedYear=c.getFullYear()),this._notifyChange(e),this._adjustDate(d)},_selectMonthYear:function(b,c,d){var e=a(b),f=this._getInst(e[0]);f["selected"+("M"===d?"Month":"Year")]=f["draw"+("M"===d?"Month":"Year")]=parseInt(c.options[c.selectedIndex].value,10),this._notifyChange(f),this._adjustDate(e)},_selectDay:function(b,c,d,e){var f,g=a(b);a(e).hasClass(this._unselectableClass)||this._isDisabledDatepicker(g[0])||(f=this._getInst(g[0]),f.selectedDay=f.currentDay=a("a",e).html(),f.selectedMonth=f.currentMonth=c,f.selectedYear=f.currentYear=d,this._selectDate(b,this._formatDate(f,f.currentDay,f.currentMonth,f.currentYear)))},_clearDate:function(b){var c=a(b);this._selectDate(c,"")},_selectDate:function(b,c){var d,e=a(b),f=this._getInst(e[0]);c=null!=c?c:this._formatDate(f),f.input&&f.input.val(c),this._updateAlternate(f),d=this._get(f,"onSelect"),d?d.apply(f.input?f.input[0]:null,[c,f]):f.input&&f.input.trigger("change"),f.inline?this._updateDatepicker(f):(this._hideDatepicker(),this._lastInput=f.input[0],"object"!=typeof f.input[0]&&f.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(b){var c,d,e,f=this._get(b,"altField");f&&(c=this._get(b,"altFormat")||this._get(b,"dateFormat"),d=this._getDate(b),e=this.formatDate(c,d,this._getFormatConfig(b)),a(f).val(e))},noWeekends:function(a){var b=a.getDay();return[b>0&&b<6,""]},iso8601Week:function(a){var b,c=new Date(a.getTime());return c.setDate(c.getDate()+4-(c.getDay()||7)),b=c.getTime(),c.setMonth(0),c.setDate(1),Math.floor(Math.round((b-c)/864e5)/7)+1},parseDate:function(b,c,d){if(null==b||null==c)throw"Invalid arguments";if(c="object"==typeof c?c.toString():c+"",""===c)return null;var e,f,g,h=0,i=(d?d.shortYearCutoff:null)||this._defaults.shortYearCutoff,j="string"!=typeof i?i:(new Date).getFullYear()%100+parseInt(i,10),k=(d?d.dayNamesShort:null)||this._defaults.dayNamesShort,l=(d?d.dayNames:null)||this._defaults.dayNames,m=(d?d.monthNamesShort:null)||this._defaults.monthNamesShort,n=(d?d.monthNames:null)||this._defaults.monthNames,o=-1,p=-1,q=-1,r=-1,s=!1,t,u=function(a){var c=e+1<b.length&&b.charAt(e+1)===a;return c&&e++,c},v=function(a){var b=u(a),d="@"===a?14:"!"===a?20:"y"===a&&b?4:"o"===a?3:2,e="y"===a?d:1,f=new RegExp("^\\d{"+e+","+d+"}"),g=c.substring(h).match(f);if(!g)throw"Missing number at position "+h;return h+=g[0].length,parseInt(g[0],10)},w=function(b,d,e){var f=-1,g=a.map(u(b)?e:d,function(a,b){return[[b,a]]}).sort(function(a,b){return-(a[1].length-b[1].length)});if(a.each(g,function(a,b){var d=b[1];if(c.substr(h,d.length).toLowerCase()===d.toLowerCase())return f=b[0],h+=d.length,!1}),f!==-1)return f+1;throw"Unknown name at position "+h},x=function(){if(c.charAt(h)!==b.charAt(e))throw"Unexpected literal at position "+h;h++};for(e=0;e<b.length;e++)if(s)"'"!==b.charAt(e)||u("'")?x():s=!1;else switch(b.charAt(e)){case"d":q=v("d");break;case"D":w("D",k,l);break;case"o":r=v("o");break;case"m":p=v("m");break;case"M":p=w("M",m,n);break;case"y":o=v("y");break;case"@":t=new Date(v("@")),o=t.getFullYear(),p=t.getMonth()+1,q=t.getDate();break;case"!":t=new Date((v("!")-this._ticksTo1970)/1e4),o=t.getFullYear(),p=t.getMonth()+1,q=t.getDate();break;case"'":u("'")?x():s=!0;break;default:x()}if(h<c.length&&(g=c.substr(h),!/^\s+/.test(g)))throw"Extra/unparsed characters found in date: "+g;if(o===-1?o=(new Date).getFullYear():o<100&&(o+=(new Date).getFullYear()-(new Date).getFullYear()%100+(o<=j?0:-100)),r>-1){p=1,q=r;do{if(f=this._getDaysInMonth(o,p-1),q<=f)break;p++,q-=f}while(!0)}if(t=this._daylightSavingAdjust(new Date(o,p-1,q)),t.getFullYear()!==o||t.getMonth()+1!==p||t.getDate()!==q)throw"Invalid date";return t},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(a,b,c){if(!b)return"";var d,e=(c?c.dayNamesShort:null)||this._defaults.dayNamesShort,f=(c?c.dayNames:null)||this._defaults.dayNames,g=(c?c.monthNamesShort:null)||this._defaults.monthNamesShort,h=(c?c.monthNames:null)||this._defaults.monthNames,i=function(b){var c=d+1<a.length&&a.charAt(d+1)===b;return c&&d++,c},j=function(a,b,c){var d=""+b;if(i(a))while(d.length<c)d="0"+d;return d},k=function(a,b,c,d){return i(a)?d[b]:c[b]},l="",m=!1;if(b)for(d=0;d<a.length;d++)if(m)"'"!==a.charAt(d)||i("'")?l+=a.charAt(d):m=!1;else switch(a.charAt(d)){case"d":l+=j("d",b.getDate(),2);break;case"D":l+=k("D",b.getDay(),e,f);break;case"o":l+=j("o",Math.round((new Date(b.getFullYear(),b.getMonth(),b.getDate()).getTime()-new Date(b.getFullYear(),0,0).getTime())/864e5),3);break;case"m":l+=j("m",b.getMonth()+1,2);break;case"M":l+=k("M",b.getMonth(),g,h);break;case"y":l+=i("y")?b.getFullYear():(b.getFullYear()%100<10?"0":"")+b.getFullYear()%100;break;case"@":l+=b.getTime();break;case"!":l+=1e4*b.getTime()+this._ticksTo1970;break;case"'":i("'")?l+="'":m=!0;break;default:l+=a.charAt(d)}return l},_possibleChars:function(a){var b,c="",d=!1,e=function(c){var d=b+1<a.length&&a.charAt(b+1)===c;return d&&b++,d};for(b=0;b<a.length;b++)if(d)"'"!==a.charAt(b)||e("'")?c+=a.charAt(b):d=!1;else switch(a.charAt(b)){case"d":case"m":case"y":case"@":c+="0123456789";break;case"D":case"M":return null;case"'":e("'")?c+="'":d=!0;break;default:c+=a.charAt(b)}return c},_get:function(a,b){return void 0!==a.settings[b]?a.settings[b]:this._defaults[b]},_setDateFromField:function(a,b){if(a.input.val()!==a.lastVal){var c=this._get(a,"dateFormat"),d=a.lastVal=a.input?a.input.val():null,e=this._getDefaultDate(a),f=e,g=this._getFormatConfig(a);try{f=this.parseDate(c,d,g)||e}catch(a){d=b?"":d}a.selectedDay=f.getDate(),a.drawMonth=a.selectedMonth=f.getMonth(),a.drawYear=a.selectedYear=f.getFullYear(),a.currentDay=d?f.getDate():0,a.currentMonth=d?f.getMonth():0,a.currentYear=d?f.getFullYear():0,this._adjustInstDate(a)}},_getDefaultDate:function(a){return this._restrictMinMax(a,this._determineDate(a,this._get(a,"defaultDate"),new Date))},_determineDate:function(b,c,d){var e=function(a){var b=new Date;return b.setDate(b.getDate()+a),b},f=function(c){try{return a.datepicker.parseDate(a.datepicker._get(b,"dateFormat"),c,a.datepicker._getFormatConfig(b))}catch(a){}var d=(c.toLowerCase().match(/^c/)?a.datepicker._getDate(b):null)||new Date,e=d.getFullYear(),f=d.getMonth(),g=d.getDate(),h=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,i=h.exec(c);while(i){switch(i[2]||"d"){case"d":case"D":g+=parseInt(i[1],10);break;case"w":case"W":g+=7*parseInt(i[1],10);break;case"m":case"M":f+=parseInt(i[1],10),g=Math.min(g,a.datepicker._getDaysInMonth(e,f));break;case"y":case"Y":e+=parseInt(i[1],10),g=Math.min(g,a.datepicker._getDaysInMonth(e,f));
}i=h.exec(c)}return new Date(e,f,g)},g=null==c||""===c?d:"string"==typeof c?f(c):"number"==typeof c?isNaN(c)?d:e(c):new Date(c.getTime());return g=g&&"Invalid Date"===g.toString()?d:g,g&&(g.setHours(0),g.setMinutes(0),g.setSeconds(0),g.setMilliseconds(0)),this._daylightSavingAdjust(g)},_daylightSavingAdjust:function(a){return a?(a.setHours(a.getHours()>12?a.getHours()+2:0),a):null},_setDate:function(a,b,c){var d=!b,e=a.selectedMonth,f=a.selectedYear,g=this._restrictMinMax(a,this._determineDate(a,b,new Date));a.selectedDay=a.currentDay=g.getDate(),a.drawMonth=a.selectedMonth=a.currentMonth=g.getMonth(),a.drawYear=a.selectedYear=a.currentYear=g.getFullYear(),e===a.selectedMonth&&f===a.selectedYear||c||this._notifyChange(a),this._adjustInstDate(a),a.input&&a.input.val(d?"":this._formatDate(a))},_getDate:function(a){var b=!a.currentYear||a.input&&""===a.input.val()?null:this._daylightSavingAdjust(new Date(a.currentYear,a.currentMonth,a.currentDay));return b},_attachHandlers:function(b){var c=this._get(b,"stepMonths"),d="#"+b.id.replace(/\\\\/g,"\\");b.dpDiv.find("[data-handler]").map(function(){var b={prev:function(){a.datepicker._adjustDate(d,-c,"M")},next:function(){a.datepicker._adjustDate(d,+c,"M")},hide:function(){a.datepicker._hideDatepicker()},today:function(){a.datepicker._gotoToday(d)},selectDay:function(){return a.datepicker._selectDay(d,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return a.datepicker._selectMonthYear(d,this,"M"),!1},selectYear:function(){return a.datepicker._selectMonthYear(d,this,"Y"),!1}};a(this).on(this.getAttribute("data-event"),b[this.getAttribute("data-handler")])})},_generateHTML:function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O=new Date,P=this._daylightSavingAdjust(new Date(O.getFullYear(),O.getMonth(),O.getDate())),Q=this._get(a,"isRTL"),R=this._get(a,"showButtonPanel"),S=this._get(a,"hideIfNoPrevNext"),T=this._get(a,"navigationAsDateFormat"),U=this._getNumberOfMonths(a),V=this._get(a,"showCurrentAtPos"),W=this._get(a,"stepMonths"),X=1!==U[0]||1!==U[1],Y=this._daylightSavingAdjust(a.currentDay?new Date(a.currentYear,a.currentMonth,a.currentDay):new Date(9999,9,9)),Z=this._getMinMaxDate(a,"min"),$=this._getMinMaxDate(a,"max"),_=a.drawMonth-V,aa=a.drawYear;if(_<0&&(_+=12,aa--),$){b=this._daylightSavingAdjust(new Date($.getFullYear(),$.getMonth()-U[0]*U[1]+1,$.getDate())),b=Z&&b<Z?Z:b;while(this._daylightSavingAdjust(new Date(aa,_,1))>b)_--,_<0&&(_=11,aa--)}for(a.drawMonth=_,a.drawYear=aa,c=this._get(a,"prevText"),c=T?this.formatDate(c,this._daylightSavingAdjust(new Date(aa,_-W,1)),this._getFormatConfig(a)):c,d=this._canAdjustMonth(a,-1,aa,_)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+c+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"e":"w")+"'>"+c+"</span></a>":S?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+c+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"e":"w")+"'>"+c+"</span></a>",e=this._get(a,"nextText"),e=T?this.formatDate(e,this._daylightSavingAdjust(new Date(aa,_+W,1)),this._getFormatConfig(a)):e,f=this._canAdjustMonth(a,1,aa,_)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+e+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"w":"e")+"'>"+e+"</span></a>":S?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+e+"'><span class='ui-icon ui-icon-circle-triangle-"+(Q?"w":"e")+"'>"+e+"</span></a>",g=this._get(a,"currentText"),h=this._get(a,"gotoCurrent")&&a.currentDay?Y:P,g=T?this.formatDate(g,h,this._getFormatConfig(a)):g,i=a.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(a,"closeText")+"</button>",j=R?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(Q?i:"")+(this._isInRange(a,h)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+g+"</button>":"")+(Q?"":i)+"</div>":"",k=parseInt(this._get(a,"firstDay"),10),k=isNaN(k)?0:k,l=this._get(a,"showWeek"),m=this._get(a,"dayNames"),n=this._get(a,"dayNamesMin"),o=this._get(a,"monthNames"),p=this._get(a,"monthNamesShort"),q=this._get(a,"beforeShowDay"),r=this._get(a,"showOtherMonths"),s=this._get(a,"selectOtherMonths"),t=this._getDefaultDate(a),u="",w=0;w<U[0];w++){for(x="",this.maxRows=4,y=0;y<U[1];y++){if(z=this._daylightSavingAdjust(new Date(aa,_,a.selectedDay)),A=" ui-corner-all",B="",X){if(B+="<div class='ui-datepicker-group",U[1]>1)switch(y){case 0:B+=" ui-datepicker-group-first",A=" ui-corner-"+(Q?"right":"left");break;case U[1]-1:B+=" ui-datepicker-group-last",A=" ui-corner-"+(Q?"left":"right");break;default:B+=" ui-datepicker-group-middle",A=""}B+="'>"}for(B+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+A+"'>"+(/all|left/.test(A)&&0===w?Q?f:d:"")+(/all|right/.test(A)&&0===w?Q?d:f:"")+this._generateMonthYearHeader(a,_,aa,Z,$,w>0||y>0,o,p)+"</div><table class='ui-datepicker-calendar'><thead><tr>",C=l?"<th class='ui-datepicker-week-col'>"+this._get(a,"weekHeader")+"</th>":"",v=0;v<7;v++)D=(v+k)%7,C+="<th scope='col'"+((v+k+6)%7>=5?" class='ui-datepicker-week-end'":"")+"><span title='"+m[D]+"'>"+n[D]+"</span></th>";for(B+=C+"</tr></thead><tbody>",E=this._getDaysInMonth(aa,_),aa===a.selectedYear&&_===a.selectedMonth&&(a.selectedDay=Math.min(a.selectedDay,E)),F=(this._getFirstDayOfMonth(aa,_)-k+7)%7,G=Math.ceil((F+E)/7),H=X&&this.maxRows>G?this.maxRows:G,this.maxRows=H,I=this._daylightSavingAdjust(new Date(aa,_,1-F)),J=0;J<H;J++){for(B+="<tr>",K=l?"<td class='ui-datepicker-week-col'>"+this._get(a,"calculateWeek")(I)+"</td>":"",v=0;v<7;v++)L=q?q.apply(a.input?a.input[0]:null,[I]):[!0,""],M=I.getMonth()!==_,N=M&&!s||!L[0]||Z&&I<Z||$&&I>$,K+="<td class='"+((v+k+6)%7>=5?" ui-datepicker-week-end":"")+(M?" ui-datepicker-other-month":"")+(I.getTime()===z.getTime()&&_===a.selectedMonth&&a._keyEvent||t.getTime()===I.getTime()&&t.getTime()===z.getTime()?" "+this._dayOverClass:"")+(N?" "+this._unselectableClass+" ui-state-disabled":"")+(M&&!r?"":" "+L[1]+(I.getTime()===Y.getTime()?" "+this._currentClass:"")+(I.getTime()===P.getTime()?" ui-datepicker-today":""))+"'"+(M&&!r||!L[2]?"":" title='"+L[2].replace(/'/g,"&#39;")+"'")+(N?"":" data-handler='selectDay' data-event='click' data-month='"+I.getMonth()+"' data-year='"+I.getFullYear()+"'")+">"+(M&&!r?"&#xa0;":N?"<span class='ui-state-default'>"+I.getDate()+"</span>":"<a class='ui-state-default"+(I.getTime()===P.getTime()?" ui-state-highlight":"")+(I.getTime()===Y.getTime()?" ui-state-active":"")+(M?" ui-priority-secondary":"")+"' href='#'>"+I.getDate()+"</a>")+"</td>",I.setDate(I.getDate()+1),I=this._daylightSavingAdjust(I);B+=K+"</tr>"}_++,_>11&&(_=0,aa++),B+="</tbody></table>"+(X?"</div>"+(U[0]>0&&y===U[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=B}u+=x}return u+=j,a._keyEvent=!1,u},_generateMonthYearHeader:function(a,b,c,d,e,f,g,h){var i,j,k,l,m,n,o,p,q=this._get(a,"changeMonth"),r=this._get(a,"changeYear"),s=this._get(a,"showMonthAfterYear"),t="<div class='ui-datepicker-title'>",u="";if(f||!q)u+="<span class='ui-datepicker-month'>"+g[b]+"</span>";else{for(i=d&&d.getFullYear()===c,j=e&&e.getFullYear()===c,u+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",k=0;k<12;k++)(!i||k>=d.getMonth())&&(!j||k<=e.getMonth())&&(u+="<option value='"+k+"'"+(k===b?" selected='selected'":"")+">"+h[k]+"</option>");u+="</select>"}if(s||(t+=u+(!f&&q&&r?"":"&#xa0;")),!a.yearshtml)if(a.yearshtml="",f||!r)t+="<span class='ui-datepicker-year'>"+c+"</span>";else{for(l=this._get(a,"yearRange").split(":"),m=(new Date).getFullYear(),n=function(a){var b=a.match(/c[+\-].*/)?c+parseInt(a.substring(1),10):a.match(/[+\-].*/)?m+parseInt(a,10):parseInt(a,10);return isNaN(b)?m:b},o=n(l[0]),p=Math.max(o,n(l[1]||"")),o=d?Math.max(o,d.getFullYear()):o,p=e?Math.min(p,e.getFullYear()):p,a.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";o<=p;o++)a.yearshtml+="<option value='"+o+"'"+(o===c?" selected='selected'":"")+">"+o+"</option>";a.yearshtml+="</select>",t+=a.yearshtml,a.yearshtml=null}return t+=this._get(a,"yearSuffix"),s&&(t+=(!f&&q&&r?"":"&#xa0;")+u),t+="</div>"},_adjustInstDate:function(a,b,c){var d=a.selectedYear+("Y"===c?b:0),e=a.selectedMonth+("M"===c?b:0),f=Math.min(a.selectedDay,this._getDaysInMonth(d,e))+("D"===c?b:0),g=this._restrictMinMax(a,this._daylightSavingAdjust(new Date(d,e,f)));a.selectedDay=g.getDate(),a.drawMonth=a.selectedMonth=g.getMonth(),a.drawYear=a.selectedYear=g.getFullYear(),"M"!==c&&"Y"!==c||this._notifyChange(a)},_restrictMinMax:function(a,b){var c=this._getMinMaxDate(a,"min"),d=this._getMinMaxDate(a,"max"),e=c&&b<c?c:b;return d&&e>d?d:e},_notifyChange:function(a){var b=this._get(a,"onChangeMonthYear");b&&b.apply(a.input?a.input[0]:null,[a.selectedYear,a.selectedMonth+1,a])},_getNumberOfMonths:function(a){var b=this._get(a,"numberOfMonths");return null==b?[1,1]:"number"==typeof b?[1,b]:b},_getMinMaxDate:function(a,b){return this._determineDate(a,this._get(a,b+"Date"),null)},_getDaysInMonth:function(a,b){return 32-this._daylightSavingAdjust(new Date(a,b,32)).getDate()},_getFirstDayOfMonth:function(a,b){return new Date(a,b,1).getDay()},_canAdjustMonth:function(a,b,c,d){var e=this._getNumberOfMonths(a),f=this._daylightSavingAdjust(new Date(c,d+(b<0?b:e[0]*e[1]),1));return b<0&&f.setDate(this._getDaysInMonth(f.getFullYear(),f.getMonth())),this._isInRange(a,f)},_isInRange:function(a,b){var c,d,e=this._getMinMaxDate(a,"min"),f=this._getMinMaxDate(a,"max"),g=null,h=null,i=this._get(a,"yearRange");return i&&(c=i.split(":"),d=(new Date).getFullYear(),g=parseInt(c[0],10),h=parseInt(c[1],10),c[0].match(/[+\-].*/)&&(g+=d),c[1].match(/[+\-].*/)&&(h+=d)),(!e||b.getTime()>=e.getTime())&&(!f||b.getTime()<=f.getTime())&&(!g||b.getFullYear()>=g)&&(!h||b.getFullYear()<=h)},_getFormatConfig:function(a){var b=this._get(a,"shortYearCutoff");return b="string"!=typeof b?b:(new Date).getFullYear()%100+parseInt(b,10),{shortYearCutoff:b,dayNamesShort:this._get(a,"dayNamesShort"),dayNames:this._get(a,"dayNames"),monthNamesShort:this._get(a,"monthNamesShort"),monthNames:this._get(a,"monthNames")}},_formatDate:function(a,b,c,d){b||(a.currentDay=a.selectedDay,a.currentMonth=a.selectedMonth,a.currentYear=a.selectedYear);var e=b?"object"==typeof b?b:this._daylightSavingAdjust(new Date(d,c,b)):this._daylightSavingAdjust(new Date(a.currentYear,a.currentMonth,a.currentDay));return this.formatDate(this._get(a,"dateFormat"),e,this._getFormatConfig(a))}});function X(b){var c="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return b.on("mouseout",c,function(){a(this).removeClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&a(this).removeClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&a(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",c,Y)}function Y(){a.datepicker._isDisabledDatepicker(U.inline?U.dpDiv.parent()[0]:U.input[0])||(a(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),a(this).addClass("ui-state-hover"),this.className.indexOf("ui-datepicker-prev")!==-1&&a(this).addClass("ui-datepicker-prev-hover"),this.className.indexOf("ui-datepicker-next")!==-1&&a(this).addClass("ui-datepicker-next-hover"))}function Z(b,c){a.extend(b,c);for(var d in c)null==c[d]&&(b[d]=c[d]);return b}a.fn.datepicker=function(b){if(!this.length)return this;a.datepicker.initialized||(a(document).on("mousedown",a.datepicker._checkExternalClick),a.datepicker.initialized=!0),0===a("#"+a.datepicker._mainDivId).length&&a("body").append(a.datepicker.dpDiv);var c=Array.prototype.slice.call(arguments,1);return"string"!=typeof b||"isDisabled"!==b&&"getDate"!==b&&"widget"!==b?"option"===b&&2===arguments.length&&"string"==typeof arguments[1]?a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this[0]].concat(c)):this.each(function(){"string"==typeof b?a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this].concat(c)):a.datepicker._attachDatepicker(this,b)}):a.datepicker["_"+b+"Datepicker"].apply(a.datepicker,[this[0]].concat(c))},a.datepicker=new W,a.datepicker.initialized=!1,a.datepicker.uuid=(new Date).getTime(),a.datepicker.version="1.12.0";var $=a.datepicker,_=a.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),aa=!1;a(document).on("mouseup",function(){aa=!1});var ba=a.widget("ui.mouse",{version:"1.12.0",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var b=this;this.element.on("mousedown."+this.widgetName,function(a){return b._mouseDown(a)}).on("click."+this.widgetName,function(c){if(!0===a.data(c.target,b.widgetName+".preventClickEvent"))return a.removeData(c.target,b.widgetName+".preventClickEvent"),c.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(b){if(!aa){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(b),this._mouseDownEvent=b;var c=this,d=1===b.which,e=!("string"!=typeof this.options.cancel||!b.target.nodeName)&&a(b.target).closest(this.options.cancel).length;return!(d&&!e&&this._mouseCapture(b))||(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){c.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(b)&&this._mouseDelayMet(b)&&(this._mouseStarted=this._mouseStart(b)!==!1,!this._mouseStarted)?(b.preventDefault(),!0):(!0===a.data(b.target,this.widgetName+".preventClickEvent")&&a.removeData(b.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(a){return c._mouseMove(a)},this._mouseUpDelegate=function(a){return c._mouseUp(a)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),b.preventDefault(),aa=!0,!0))}},_mouseMove:function(b){if(this._mouseMoved){if(a.ui.ie&&(!document.documentMode||document.documentMode<9)&&!b.button)return this._mouseUp(b);if(!b.which)if(b.originalEvent.altKey||b.originalEvent.ctrlKey||b.originalEvent.metaKey||b.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(b)}return(b.which||b.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(b),b.preventDefault()):(this._mouseDistanceMet(b)&&this._mouseDelayMet(b)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,b)!==!1,this._mouseStarted?this._mouseDrag(b):this._mouseUp(b)),!this._mouseStarted)},_mouseUp:function(b){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,b.target===this._mouseDownEvent.target&&a.data(b.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(b)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,aa=!1,b.preventDefault()},_mouseDistanceMet:function(a){return Math.max(Math.abs(this._mouseDownEvent.pageX-a.pageX),Math.abs(this._mouseDownEvent.pageY-a.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),ca=a.ui.plugin={add:function(b,c,d){var e,f=a.ui[b].prototype;for(e in d)f.plugins[e]=f.plugins[e]||[],f.plugins[e].push([c,d[e]])},call:function(a,b,c,d){var e,f=a.plugins[b];if(f&&(d||a.element[0].parentNode&&11!==a.element[0].parentNode.nodeType))for(e=0;e<f.length;e++)a.options[f[e][0]]&&f[e][1].apply(a.element,c)}},da=a.ui.safeBlur=function(b){b&&"body"!==b.nodeName.toLowerCase()&&a(b).trigger("blur")};a.widget("ui.draggable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(a,b){this._super(a,b),"handle"===a&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?void(this.destroyOnClear=!0):(this._removeHandleClassName(),void this._mouseDestroy())},_mouseCapture:function(b){var c=this.options;return this._blurActiveElement(b),!(this.helper||c.disabled||a(b.target).closest(".ui-resizable-handle").length>0)&&(this.handle=this._getHandle(b),!!this.handle&&(this._blockFrames(c.iframeFix===!0?"iframe":c.iframeFix),!0))},_blockFrames:function(b){this.iframeBlocks=this.document.find(b).map(function(){var b=a(this);return a("<div>").css("position","absolute").appendTo(b.parent()).outerWidth(b.outerWidth()).outerHeight(b.outerHeight()).offset(b.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(b){var c=a.ui.safeActiveElement(this.document[0]),d=a(b.target);this._getHandle(b)&&d.closest(c).length||a.ui.safeBlur(c)},_mouseStart:function(b){var c=this.options;return this.helper=this._createHelper(b),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),a.ui.ddmanager&&(a.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===a(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(b),this.originalPosition=this.position=this._generatePosition(b,!1),this.originalPageX=b.pageX,this.originalPageY=b.pageY,c.cursorAt&&this._adjustOffsetFromHelper(c.cursorAt),this._setContainment(),this._trigger("start",b)===!1?(this._clear(),!1):(this._cacheHelperProportions(),a.ui.ddmanager&&!c.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b),this._mouseDrag(b,!0),a.ui.ddmanager&&a.ui.ddmanager.dragStart(this,b),!0)},_refreshOffsets:function(a){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:a.pageX-this.offset.left,top:a.pageY-this.offset.top}},_mouseDrag:function(b,c){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(b,!0),this.positionAbs=this._convertPositionTo("absolute"),!c){var d=this._uiHash();if(this._trigger("drag",b,d)===!1)return this._mouseUp(new a.Event("mouseup",b)),!1;this.position=d.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",a.ui.ddmanager&&a.ui.ddmanager.drag(this,b),!1},_mouseStop:function(b){var c=this,d=!1;return a.ui.ddmanager&&!this.options.dropBehaviour&&(d=a.ui.ddmanager.drop(this,b)),this.dropped&&(d=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!d||"valid"===this.options.revert&&d||this.options.revert===!0||a.isFunction(this.options.revert)&&this.options.revert.call(this.element,d)?a(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){c._trigger("stop",b)!==!1&&c._clear()}):this._trigger("stop",b)!==!1&&this._clear(),!1},_mouseUp:function(b){return this._unblockFrames(),a.ui.ddmanager&&a.ui.ddmanager.dragStop(this,b),this.handleElement.is(b.target)&&this.element.trigger("focus"),a.ui.mouse.prototype._mouseUp.call(this,b)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new a.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(b){return!this.options.handle||!!a(b.target).closest(this.element.find(this.options.handle)).length},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(b){var c=this.options,d=a.isFunction(c.helper),e=d?a(c.helper.apply(this.element[0],[b])):"clone"===c.helper?this.element.clone().removeAttr("id"):this.element;return e.parents("body").length||e.appendTo("parent"===c.appendTo?this.element[0].parentNode:c.appendTo),d&&e[0]===this.element[0]&&this._setPositionRelative(),e[0]===this.element[0]||/(fixed|absolute)/.test(e.css("position"))||e.css("position","absolute"),e},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(b){"string"==typeof b&&(b=b.split(" ")),a.isArray(b)&&(b={left:+b[0],top:+b[1]||0}),"left"in b&&(this.offset.click.left=b.left+this.margins.left),"right"in b&&(this.offset.click.left=this.helperProportions.width-b.right+this.margins.left),"top"in b&&(this.offset.click.top=b.top+this.margins.top),"bottom"in b&&(this.offset.click.top=this.helperProportions.height-b.bottom+this.margins.top)},_isRootNode:function(a){return/(html|body)/i.test(a.tagName)||a===this.document[0]},_getParentOffset:function(){var b=this.offsetParent.offset(),c=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==c&&a.contains(this.scrollParent[0],this.offsetParent[0])&&(b.left+=this.scrollParent.scrollLeft(),b.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(b={top:0,left:0}),{top:b.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:b.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var a=this.element.position(),b=this._isRootNode(this.scrollParent[0]);return{top:a.top-(parseInt(this.helper.css("top"),10)||0)+(b?0:this.scrollParent.scrollTop()),left:a.left-(parseInt(this.helper.css("left"),10)||0)+(b?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var b,c,d,e=this.options,f=this.document[0];return this.relativeContainer=null,e.containment?"window"===e.containment?void(this.containment=[a(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,a(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,a(window).scrollLeft()+a(window).width()-this.helperProportions.width-this.margins.left,a(window).scrollTop()+(a(window).height()||f.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]):"document"===e.containment?void(this.containment=[0,0,a(f).width()-this.helperProportions.width-this.margins.left,(a(f).height()||f.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]):e.containment.constructor===Array?void(this.containment=e.containment):("parent"===e.containment&&(e.containment=this.helper[0].parentNode),c=a(e.containment),d=c[0],void(d&&(b=/(scroll|auto)/.test(c.css("overflow")),this.containment=[(parseInt(c.css("borderLeftWidth"),10)||0)+(parseInt(c.css("paddingLeft"),10)||0),(parseInt(c.css("borderTopWidth"),10)||0)+(parseInt(c.css("paddingTop"),10)||0),(b?Math.max(d.scrollWidth,d.offsetWidth):d.offsetWidth)-(parseInt(c.css("borderRightWidth"),10)||0)-(parseInt(c.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(b?Math.max(d.scrollHeight,d.offsetHeight):d.offsetHeight)-(parseInt(c.css("borderBottomWidth"),10)||0)-(parseInt(c.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=c))):void(this.containment=null)},_convertPositionTo:function(a,b){b||(b=this.position);var c="absolute"===a?1:-1,d=this._isRootNode(this.scrollParent[0]);return{top:b.top+this.offset.relative.top*c+this.offset.parent.top*c-("fixed"===this.cssPosition?-this.offset.scroll.top:d?0:this.offset.scroll.top)*c,left:b.left+this.offset.relative.left*c+this.offset.parent.left*c-("fixed"===this.cssPosition?-this.offset.scroll.left:d?0:this.offset.scroll.left)*c}},_generatePosition:function(a,b){var c,d,e,f,g=this.options,h=this._isRootNode(this.scrollParent[0]),i=a.pageX,j=a.pageY;return h&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),b&&(this.containment&&(this.relativeContainer?(d=this.relativeContainer.offset(),c=[this.containment[0]+d.left,this.containment[1]+d.top,this.containment[2]+d.left,this.containment[3]+d.top]):c=this.containment,a.pageX-this.offset.click.left<c[0]&&(i=c[0]+this.offset.click.left),a.pageY-this.offset.click.top<c[1]&&(j=c[1]+this.offset.click.top),a.pageX-this.offset.click.left>c[2]&&(i=c[2]+this.offset.click.left),a.pageY-this.offset.click.top>c[3]&&(j=c[3]+this.offset.click.top)),g.grid&&(e=g.grid[1]?this.originalPageY+Math.round((j-this.originalPageY)/g.grid[1])*g.grid[1]:this.originalPageY,j=c?e-this.offset.click.top>=c[1]||e-this.offset.click.top>c[3]?e:e-this.offset.click.top>=c[1]?e-g.grid[1]:e+g.grid[1]:e,f=g.grid[0]?this.originalPageX+Math.round((i-this.originalPageX)/g.grid[0])*g.grid[0]:this.originalPageX,i=c?f-this.offset.click.left>=c[0]||f-this.offset.click.left>c[2]?f:f-this.offset.click.left>=c[0]?f-g.grid[0]:f+g.grid[0]:f),"y"===g.axis&&(i=this.originalPageX),"x"===g.axis&&(j=this.originalPageY)),{top:j-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:h?0:this.offset.scroll.top),left:i-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:h?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(b,c,d){return d=d||this._uiHash(),a.ui.plugin.call(this,b,[c,d,this],!0),/^(drag|start|stop)/.test(b)&&(this.positionAbs=this._convertPositionTo("absolute"),d.offset=this.positionAbs),a.Widget.prototype._trigger.call(this,b,c,d)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),a.ui.plugin.add("draggable","connectToSortable",{start:function(b,c,d){var e=a.extend({},c,{item:d.element});d.sortables=[],a(d.options.connectToSortable).each(function(){var c=a(this).sortable("instance");c&&!c.options.disabled&&(d.sortables.push(c),c.refreshPositions(),c._trigger("activate",b,e))})},stop:function(b,c,d){var e=a.extend({},c,{item:d.element});d.cancelHelperRemoval=!1,a.each(d.sortables,function(){var a=this;a.isOver?(a.isOver=0,d.cancelHelperRemoval=!0,a.cancelHelperRemoval=!1,a._storedCSS={position:a.placeholder.css("position"),top:a.placeholder.css("top"),left:a.placeholder.css("left")},a._mouseStop(b),a.options.helper=a.options._helper):(a.cancelHelperRemoval=!0,a._trigger("deactivate",b,e))})},drag:function(b,c,d){a.each(d.sortables,function(){var e=!1,f=this;f.positionAbs=d.positionAbs,f.helperProportions=d.helperProportions,f.offset.click=d.offset.click,f._intersectsWith(f.containerCache)&&(e=!0,a.each(d.sortables,function(){return this.positionAbs=d.positionAbs,this.helperProportions=d.helperProportions,this.offset.click=d.offset.click,this!==f&&this._intersectsWith(this.containerCache)&&a.contains(f.element[0],this.element[0])&&(e=!1),e})),e?(f.isOver||(f.isOver=1,d._parent=c.helper.parent(),f.currentItem=c.helper.appendTo(f.element).data("ui-sortable-item",!0),f.options._helper=f.options.helper,f.options.helper=function(){return c.helper[0]},b.target=f.currentItem[0],f._mouseCapture(b,!0),f._mouseStart(b,!0,!0),f.offset.click.top=d.offset.click.top,f.offset.click.left=d.offset.click.left,f.offset.parent.left-=d.offset.parent.left-f.offset.parent.left,f.offset.parent.top-=d.offset.parent.top-f.offset.parent.top,d._trigger("toSortable",b),d.dropped=f.element,a.each(d.sortables,function(){this.refreshPositions()}),d.currentItem=d.element,f.fromOutside=d),f.currentItem&&(f._mouseDrag(b),c.position=f.position)):f.isOver&&(f.isOver=0,f.cancelHelperRemoval=!0,f.options._revert=f.options.revert,f.options.revert=!1,f._trigger("out",b,f._uiHash(f)),f._mouseStop(b,!0),f.options.revert=f.options._revert,f.options.helper=f.options._helper,f.placeholder&&f.placeholder.remove(),c.helper.appendTo(d._parent),d._refreshOffsets(b),c.position=d._generatePosition(b,!0),d._trigger("fromSortable",b),d.dropped=!1,a.each(d.sortables,function(){this.refreshPositions()}))})}}),a.ui.plugin.add("draggable","cursor",{start:function(b,c,d){var e=a("body"),f=d.options;e.css("cursor")&&(f._cursor=e.css("cursor")),e.css("cursor",f.cursor)},stop:function(b,c,d){var e=d.options;e._cursor&&a("body").css("cursor",e._cursor)}}),a.ui.plugin.add("draggable","opacity",{start:function(b,c,d){var e=a(c.helper),f=d.options;e.css("opacity")&&(f._opacity=e.css("opacity")),e.css("opacity",f.opacity)},stop:function(b,c,d){var e=d.options;e._opacity&&a(c.helper).css("opacity",e._opacity)}}),a.ui.plugin.add("draggable","scroll",{start:function(a,b,c){c.scrollParentNotHidden||(c.scrollParentNotHidden=c.helper.scrollParent(!1)),c.scrollParentNotHidden[0]!==c.document[0]&&"HTML"!==c.scrollParentNotHidden[0].tagName&&(c.overflowOffset=c.scrollParentNotHidden.offset())},drag:function(b,c,d){var e=d.options,f=!1,g=d.scrollParentNotHidden[0],h=d.document[0];g!==h&&"HTML"!==g.tagName?(e.axis&&"x"===e.axis||(d.overflowOffset.top+g.offsetHeight-b.pageY<e.scrollSensitivity?g.scrollTop=f=g.scrollTop+e.scrollSpeed:b.pageY-d.overflowOffset.top<e.scrollSensitivity&&(g.scrollTop=f=g.scrollTop-e.scrollSpeed)),e.axis&&"y"===e.axis||(d.overflowOffset.left+g.offsetWidth-b.pageX<e.scrollSensitivity?g.scrollLeft=f=g.scrollLeft+e.scrollSpeed:b.pageX-d.overflowOffset.left<e.scrollSensitivity&&(g.scrollLeft=f=g.scrollLeft-e.scrollSpeed))):(e.axis&&"x"===e.axis||(b.pageY-a(h).scrollTop()<e.scrollSensitivity?f=a(h).scrollTop(a(h).scrollTop()-e.scrollSpeed):a(window).height()-(b.pageY-a(h).scrollTop())<e.scrollSensitivity&&(f=a(h).scrollTop(a(h).scrollTop()+e.scrollSpeed))),e.axis&&"y"===e.axis||(b.pageX-a(h).scrollLeft()<e.scrollSensitivity?f=a(h).scrollLeft(a(h).scrollLeft()-e.scrollSpeed):a(window).width()-(b.pageX-a(h).scrollLeft())<e.scrollSensitivity&&(f=a(h).scrollLeft(a(h).scrollLeft()+e.scrollSpeed)))),f!==!1&&a.ui.ddmanager&&!e.dropBehaviour&&a.ui.ddmanager.prepareOffsets(d,b)}}),a.ui.plugin.add("draggable","snap",{start:function(b,c,d){var e=d.options;d.snapElements=[],a(e.snap.constructor!==String?e.snap.items||":data(ui-draggable)":e.snap).each(function(){var b=a(this),c=b.offset();this!==d.element[0]&&d.snapElements.push({item:this,width:b.outerWidth(),height:b.outerHeight(),top:c.top,left:c.left})})},drag:function(b,c,d){var e,f,g,h,i,j,k,l,m,n,o=d.options,p=o.snapTolerance,q=c.offset.left,r=q+d.helperProportions.width,s=c.offset.top,t=s+d.helperProportions.height;for(m=d.snapElements.length-1;m>=0;m--)i=d.snapElements[m].left-d.margins.left,
j=i+d.snapElements[m].width,k=d.snapElements[m].top-d.margins.top,l=k+d.snapElements[m].height,r<i-p||q>j+p||t<k-p||s>l+p||!a.contains(d.snapElements[m].item.ownerDocument,d.snapElements[m].item)?(d.snapElements[m].snapping&&d.options.snap.release&&d.options.snap.release.call(d.element,b,a.extend(d._uiHash(),{snapItem:d.snapElements[m].item})),d.snapElements[m].snapping=!1):("inner"!==o.snapMode&&(e=Math.abs(k-t)<=p,f=Math.abs(l-s)<=p,g=Math.abs(i-r)<=p,h=Math.abs(j-q)<=p,e&&(c.position.top=d._convertPositionTo("relative",{top:k-d.helperProportions.height,left:0}).top),f&&(c.position.top=d._convertPositionTo("relative",{top:l,left:0}).top),g&&(c.position.left=d._convertPositionTo("relative",{top:0,left:i-d.helperProportions.width}).left),h&&(c.position.left=d._convertPositionTo("relative",{top:0,left:j}).left)),n=e||f||g||h,"outer"!==o.snapMode&&(e=Math.abs(k-s)<=p,f=Math.abs(l-t)<=p,g=Math.abs(i-q)<=p,h=Math.abs(j-r)<=p,e&&(c.position.top=d._convertPositionTo("relative",{top:k,left:0}).top),f&&(c.position.top=d._convertPositionTo("relative",{top:l-d.helperProportions.height,left:0}).top),g&&(c.position.left=d._convertPositionTo("relative",{top:0,left:i}).left),h&&(c.position.left=d._convertPositionTo("relative",{top:0,left:j-d.helperProportions.width}).left)),!d.snapElements[m].snapping&&(e||f||g||h||n)&&d.options.snap.snap&&d.options.snap.snap.call(d.element,b,a.extend(d._uiHash(),{snapItem:d.snapElements[m].item})),d.snapElements[m].snapping=e||f||g||h||n)}}),a.ui.plugin.add("draggable","stack",{start:function(b,c,d){var e,f=d.options,g=a.makeArray(a(f.stack)).sort(function(b,c){return(parseInt(a(b).css("zIndex"),10)||0)-(parseInt(a(c).css("zIndex"),10)||0)});g.length&&(e=parseInt(a(g[0]).css("zIndex"),10)||0,a(g).each(function(b){a(this).css("zIndex",e+b)}),this.css("zIndex",e+g.length))}}),a.ui.plugin.add("draggable","zIndex",{start:function(b,c,d){var e=a(c.helper),f=d.options;e.css("zIndex")&&(f._zIndex=e.css("zIndex")),e.css("zIndex",f.zIndex)},stop:function(b,c,d){var e=d.options;e._zIndex&&a(c.helper).css("zIndex",e._zIndex)}});var ea=a.ui.draggable;a.widget("ui.resizable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(a){return parseFloat(a)||0},_isNumber:function(a){return!isNaN(parseFloat(a))},_hasScroll:function(b,c){if("hidden"===a(b).css("overflow"))return!1;var d=c&&"left"===c?"scrollLeft":"scrollTop",e=!1;return b[d]>0||(b[d]=1,e=b[d]>0,b[d]=0,e)},_create:function(){var b,c=this.options,d=this;this._addClass("ui-resizable"),a.extend(this,{_aspectRatio:!!c.aspectRatio,aspectRatio:c.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:c.helper||c.ghost||c.animate?c.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(a("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,b={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(b),this.originalElement.css("margin",0),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css(b),this._proportionallyResize()),this._setupHandles(),c.autoHide&&a(this.element).on("mouseenter",function(){c.disabled||(d._removeClass("ui-resizable-autohide"),d._handles.show())}).on("mouseleave",function(){c.disabled||d.resizing||(d._addClass("ui-resizable-autohide"),d._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy();var b,c=function(b){a(b).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(c(this.element),b=this.element,this.originalElement.css({position:b.css("position"),width:b.outerWidth(),height:b.outerHeight(),top:b.css("top"),left:b.css("left")}).insertAfter(b),b.remove()),this.originalElement.css("resize",this.originalResizeStyle),c(this.originalElement),this},_setOption:function(a,b){switch(this._super(a,b),a){case"handles":this._removeHandles(),this._setupHandles()}},_setupHandles:function(){var b=this.options,c,d,e,f,g,h=this;if(this.handles=b.handles||(a(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=a(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),e=this.handles.split(","),this.handles={},d=0;d<e.length;d++)c=a.trim(e[d]),f="ui-resizable-"+c,g=a("<div>"),this._addClass(g,"ui-resizable-handle "+f),g.css({zIndex:b.zIndex}),this.handles[c]=".ui-resizable-"+c,this.element.append(g);this._renderAxis=function(b){var c,d,e,f;b=b||this.element;for(c in this.handles)this.handles[c].constructor===String?this.handles[c]=this.element.children(this.handles[c]).first().show():(this.handles[c].jquery||this.handles[c].nodeType)&&(this.handles[c]=a(this.handles[c]),this._on(this.handles[c],{mousedown:h._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(d=a(this.handles[c],this.element),f=/sw|ne|nw|se|n|s/.test(c)?d.outerHeight():d.outerWidth(),e=["padding",/ne|nw|n/.test(c)?"Top":/se|sw|s/.test(c)?"Bottom":/^e$/.test(c)?"Right":"Left"].join(""),b.css(e,f),this._proportionallyResize()),this._handles=this._handles.add(this.handles[c])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){h.resizing||(this.className&&(g=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),h.axis=g&&g[1]?g[1]:"se")}),b.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._handles.remove()},_mouseCapture:function(b){var c,d,e=!1;for(c in this.handles)d=a(this.handles[c])[0],(d===b.target||a.contains(d,b.target))&&(e=!0);return!this.options.disabled&&e},_mouseStart:function(b){var c,d,e,f=this.options,g=this.element;return this.resizing=!0,this._renderProxy(),c=this._num(this.helper.css("left")),d=this._num(this.helper.css("top")),f.containment&&(c+=a(f.containment).scrollLeft()||0,d+=a(f.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:c,top:d},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:g.width(),height:g.height()},this.originalSize=this._helper?{width:g.outerWidth(),height:g.outerHeight()}:{width:g.width(),height:g.height()},this.sizeDiff={width:g.outerWidth()-g.width(),height:g.outerHeight()-g.height()},this.originalPosition={left:c,top:d},this.originalMousePosition={left:b.pageX,top:b.pageY},this.aspectRatio="number"==typeof f.aspectRatio?f.aspectRatio:this.originalSize.width/this.originalSize.height||1,e=a(".ui-resizable-"+this.axis).css("cursor"),a("body").css("cursor","auto"===e?this.axis+"-resize":e),this._addClass("ui-resizable-resizing"),this._propagate("start",b),!0},_mouseDrag:function(b){var c,d,e=this.originalMousePosition,f=this.axis,g=b.pageX-e.left||0,h=b.pageY-e.top||0,i=this._change[f];return this._updatePrevProperties(),!!i&&(c=i.apply(this,[b,g,h]),this._updateVirtualBoundaries(b.shiftKey),(this._aspectRatio||b.shiftKey)&&(c=this._updateRatio(c,b)),c=this._respectSize(c,b),this._updateCache(c),this._propagate("resize",b),d=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),a.isEmptyObject(d)||(this._updatePrevProperties(),this._trigger("resize",b,this.ui()),this._applyChanges()),!1)},_mouseStop:function(b){this.resizing=!1;var c,d,e,f,g,h,i,j=this.options,k=this;return this._helper&&(c=this._proportionallyResizeElements,d=c.length&&/textarea/i.test(c[0].nodeName),e=d&&this._hasScroll(c[0],"left")?0:k.sizeDiff.height,f=d?0:k.sizeDiff.width,g={width:k.helper.width()-f,height:k.helper.height()-e},h=parseFloat(k.element.css("left"))+(k.position.left-k.originalPosition.left)||null,i=parseFloat(k.element.css("top"))+(k.position.top-k.originalPosition.top)||null,j.animate||this.element.css(a.extend(g,{top:i,left:h})),k.helper.height(k.size.height),k.helper.width(k.size.width),this._helper&&!j.animate&&this._proportionallyResize()),a("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",b),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var a={};return this.position.top!==this.prevPosition.top&&(a.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(a.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(a.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(a.height=this.size.height+"px"),this.helper.css(a),a},_updateVirtualBoundaries:function(a){var b,c,d,e,f,g=this.options;f={minWidth:this._isNumber(g.minWidth)?g.minWidth:0,maxWidth:this._isNumber(g.maxWidth)?g.maxWidth:1/0,minHeight:this._isNumber(g.minHeight)?g.minHeight:0,maxHeight:this._isNumber(g.maxHeight)?g.maxHeight:1/0},(this._aspectRatio||a)&&(b=f.minHeight*this.aspectRatio,d=f.minWidth/this.aspectRatio,c=f.maxHeight*this.aspectRatio,e=f.maxWidth/this.aspectRatio,b>f.minWidth&&(f.minWidth=b),d>f.minHeight&&(f.minHeight=d),c<f.maxWidth&&(f.maxWidth=c),e<f.maxHeight&&(f.maxHeight=e)),this._vBoundaries=f},_updateCache:function(a){this.offset=this.helper.offset(),this._isNumber(a.left)&&(this.position.left=a.left),this._isNumber(a.top)&&(this.position.top=a.top),this._isNumber(a.height)&&(this.size.height=a.height),this._isNumber(a.width)&&(this.size.width=a.width)},_updateRatio:function(a){var b=this.position,c=this.size,d=this.axis;return this._isNumber(a.height)?a.width=a.height*this.aspectRatio:this._isNumber(a.width)&&(a.height=a.width/this.aspectRatio),"sw"===d&&(a.left=b.left+(c.width-a.width),a.top=null),"nw"===d&&(a.top=b.top+(c.height-a.height),a.left=b.left+(c.width-a.width)),a},_respectSize:function(a){var b=this._vBoundaries,c=this.axis,d=this._isNumber(a.width)&&b.maxWidth&&b.maxWidth<a.width,e=this._isNumber(a.height)&&b.maxHeight&&b.maxHeight<a.height,f=this._isNumber(a.width)&&b.minWidth&&b.minWidth>a.width,g=this._isNumber(a.height)&&b.minHeight&&b.minHeight>a.height,h=this.originalPosition.left+this.originalSize.width,i=this.originalPosition.top+this.originalSize.height,j=/sw|nw|w/.test(c),k=/nw|ne|n/.test(c);return f&&(a.width=b.minWidth),g&&(a.height=b.minHeight),d&&(a.width=b.maxWidth),e&&(a.height=b.maxHeight),f&&j&&(a.left=h-b.minWidth),d&&j&&(a.left=h-b.maxWidth),g&&k&&(a.top=i-b.minHeight),e&&k&&(a.top=i-b.maxHeight),a.width||a.height||a.left||!a.top?a.width||a.height||a.top||!a.left||(a.left=null):a.top=null,a},_getPaddingPlusBorderDimensions:function(a){for(var b=0,c=[],d=[a.css("borderTopWidth"),a.css("borderRightWidth"),a.css("borderBottomWidth"),a.css("borderLeftWidth")],e=[a.css("paddingTop"),a.css("paddingRight"),a.css("paddingBottom"),a.css("paddingLeft")];b<4;b++)c[b]=parseFloat(d[b])||0,c[b]+=parseFloat(e[b])||0;return{height:c[0]+c[2],width:c[1]+c[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var a,b=0,c=this.helper||this.element;b<this._proportionallyResizeElements.length;b++)a=this._proportionallyResizeElements[b],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(a)),a.css({height:c.height()-this.outerDimensions.height||0,width:c.width()-this.outerDimensions.width||0})},_renderProxy:function(){var b=this.element,c=this.options;this.elementOffset=b.offset(),this._helper?(this.helper=this.helper||a("<div style='overflow:hidden;'></div>"),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++c.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(a,b){return{width:this.originalSize.width+b}},w:function(a,b){var c=this.originalSize,d=this.originalPosition;return{left:d.left+b,width:c.width-b}},n:function(a,b,c){var d=this.originalSize,e=this.originalPosition;return{top:e.top+c,height:d.height-c}},s:function(a,b,c){return{height:this.originalSize.height+c}},se:function(b,c,d){return a.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[b,c,d]))},sw:function(b,c,d){return a.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[b,c,d]))},ne:function(b,c,d){return a.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[b,c,d]))},nw:function(b,c,d){return a.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[b,c,d]))}},_propagate:function(b,c){a.ui.plugin.call(this,b,[c,this.ui()]),"resize"!==b&&this._trigger(b,c,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),a.ui.plugin.add("resizable","animate",{stop:function(b){var c=a(this).resizable("instance"),d=c.options,e=c._proportionallyResizeElements,f=e.length&&/textarea/i.test(e[0].nodeName),g=f&&c._hasScroll(e[0],"left")?0:c.sizeDiff.height,h=f?0:c.sizeDiff.width,i={width:c.size.width-h,height:c.size.height-g},j=parseFloat(c.element.css("left"))+(c.position.left-c.originalPosition.left)||null,k=parseFloat(c.element.css("top"))+(c.position.top-c.originalPosition.top)||null;c.element.animate(a.extend(i,k&&j?{top:k,left:j}:{}),{duration:d.animateDuration,easing:d.animateEasing,step:function(){var d={width:parseFloat(c.element.css("width")),height:parseFloat(c.element.css("height")),top:parseFloat(c.element.css("top")),left:parseFloat(c.element.css("left"))};e&&e.length&&a(e[0]).css({width:d.width,height:d.height}),c._updateCache(d),c._propagate("resize",b)}})}}),a.ui.plugin.add("resizable","containment",{start:function(){var b,c,d,e,f,g,h,i=a(this).resizable("instance"),j=i.options,k=i.element,l=j.containment,m=l instanceof a?l.get(0):/parent/.test(l)?k.parent().get(0):l;m&&(i.containerElement=a(m),/document/.test(l)||l===document?(i.containerOffset={left:0,top:0},i.containerPosition={left:0,top:0},i.parentData={element:a(document),left:0,top:0,width:a(document).width(),height:a(document).height()||document.body.parentNode.scrollHeight}):(b=a(m),c=[],a(["Top","Right","Left","Bottom"]).each(function(a,d){c[a]=i._num(b.css("padding"+d))}),i.containerOffset=b.offset(),i.containerPosition=b.position(),i.containerSize={height:b.innerHeight()-c[3],width:b.innerWidth()-c[1]},d=i.containerOffset,e=i.containerSize.height,f=i.containerSize.width,g=i._hasScroll(m,"left")?m.scrollWidth:f,h=i._hasScroll(m)?m.scrollHeight:e,i.parentData={element:m,left:d.left,top:d.top,width:g,height:h}))},resize:function(b){var c,d,e,f,g=a(this).resizable("instance"),h=g.options,i=g.containerOffset,j=g.position,k=g._aspectRatio||b.shiftKey,l={top:0,left:0},m=g.containerElement,n=!0;m[0]!==document&&/static/.test(m.css("position"))&&(l=i),j.left<(g._helper?i.left:0)&&(g.size.width=g.size.width+(g._helper?g.position.left-i.left:g.position.left-l.left),k&&(g.size.height=g.size.width/g.aspectRatio,n=!1),g.position.left=h.helper?i.left:0),j.top<(g._helper?i.top:0)&&(g.size.height=g.size.height+(g._helper?g.position.top-i.top:g.position.top),k&&(g.size.width=g.size.height*g.aspectRatio,n=!1),g.position.top=g._helper?i.top:0),e=g.containerElement.get(0)===g.element.parent().get(0),f=/relative|absolute/.test(g.containerElement.css("position")),e&&f?(g.offset.left=g.parentData.left+g.position.left,g.offset.top=g.parentData.top+g.position.top):(g.offset.left=g.element.offset().left,g.offset.top=g.element.offset().top),c=Math.abs(g.sizeDiff.width+(g._helper?g.offset.left-l.left:g.offset.left-i.left)),d=Math.abs(g.sizeDiff.height+(g._helper?g.offset.top-l.top:g.offset.top-i.top)),c+g.size.width>=g.parentData.width&&(g.size.width=g.parentData.width-c,k&&(g.size.height=g.size.width/g.aspectRatio,n=!1)),d+g.size.height>=g.parentData.height&&(g.size.height=g.parentData.height-d,k&&(g.size.width=g.size.height*g.aspectRatio,n=!1)),n||(g.position.left=g.prevPosition.left,g.position.top=g.prevPosition.top,g.size.width=g.prevSize.width,g.size.height=g.prevSize.height)},stop:function(){var b=a(this).resizable("instance"),c=b.options,d=b.containerOffset,e=b.containerPosition,f=b.containerElement,g=a(b.helper),h=g.offset(),i=g.outerWidth()-b.sizeDiff.width,j=g.outerHeight()-b.sizeDiff.height;b._helper&&!c.animate&&/relative/.test(f.css("position"))&&a(this).css({left:h.left-e.left-d.left,width:i,height:j}),b._helper&&!c.animate&&/static/.test(f.css("position"))&&a(this).css({left:h.left-e.left-d.left,width:i,height:j})}}),a.ui.plugin.add("resizable","alsoResize",{start:function(){var b=a(this).resizable("instance"),c=b.options;a(c.alsoResize).each(function(){var b=a(this);b.data("ui-resizable-alsoresize",{width:parseFloat(b.width()),height:parseFloat(b.height()),left:parseFloat(b.css("left")),top:parseFloat(b.css("top"))})})},resize:function(b,c){var d=a(this).resizable("instance"),e=d.options,f=d.originalSize,g=d.originalPosition,h={height:d.size.height-f.height||0,width:d.size.width-f.width||0,top:d.position.top-g.top||0,left:d.position.left-g.left||0};a(e.alsoResize).each(function(){var b=a(this),d=a(this).data("ui-resizable-alsoresize"),e={},f=b.parents(c.originalElement[0]).length?["width","height"]:["width","height","top","left"];a.each(f,function(a,b){var c=(d[b]||0)+(h[b]||0);c&&c>=0&&(e[b]=c||null)}),b.css(e)})},stop:function(){a(this).removeData("ui-resizable-alsoresize")}}),a.ui.plugin.add("resizable","ghost",{start:function(){var b=a(this).resizable("instance"),c=b.size;b.ghost=b.originalElement.clone(),b.ghost.css({opacity:.25,display:"block",position:"relative",height:c.height,width:c.width,margin:0,left:0,top:0}),b._addClass(b.ghost,"ui-resizable-ghost"),a.uiBackCompat!==!1&&"string"==typeof b.options.ghost&&b.ghost.addClass(this.options.ghost),b.ghost.appendTo(b.helper)},resize:function(){var b=a(this).resizable("instance");b.ghost&&b.ghost.css({position:"relative",height:b.size.height,width:b.size.width})},stop:function(){var b=a(this).resizable("instance");b.ghost&&b.helper&&b.helper.get(0).removeChild(b.ghost.get(0))}}),a.ui.plugin.add("resizable","grid",{resize:function(){var b,c=a(this).resizable("instance"),d=c.options,e=c.size,f=c.originalSize,g=c.originalPosition,h=c.axis,i="number"==typeof d.grid?[d.grid,d.grid]:d.grid,j=i[0]||1,k=i[1]||1,l=Math.round((e.width-f.width)/j)*j,m=Math.round((e.height-f.height)/k)*k,n=f.width+l,o=f.height+m,p=d.maxWidth&&d.maxWidth<n,q=d.maxHeight&&d.maxHeight<o,r=d.minWidth&&d.minWidth>n,s=d.minHeight&&d.minHeight>o;d.grid=i,r&&(n+=j),s&&(o+=k),p&&(n-=j),q&&(o-=k),/^(se|s|e)$/.test(h)?(c.size.width=n,c.size.height=o):/^(ne)$/.test(h)?(c.size.width=n,c.size.height=o,c.position.top=g.top-m):/^(sw)$/.test(h)?(c.size.width=n,c.size.height=o,c.position.left=g.left-l):((o-k<=0||n-j<=0)&&(b=c._getPaddingPlusBorderDimensions(this)),o-k>0?(c.size.height=o,c.position.top=g.top-m):(o=k-b.height,c.size.height=o,c.position.top=g.top+f.height-o),n-j>0?(c.size.width=n,c.position.left=g.left-l):(n=j-b.width,c.size.width=n,c.position.left=g.left+f.width-n))}});var fa=a.ui.resizable;a.widget("ui.dialog",{version:"1.12.0",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(b){var c=a(this).css(b).offset().top;c<0&&a(this).css("top",b.top-c)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&a.fn.draggable&&this._makeDraggable(),this.options.resizable&&a.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var b=this.options.appendTo;return b&&(b.jquery||b.nodeType)?a(b):this.document.find(b||"body").eq(0)},_destroy:function(){var a,b=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),a=b.parent.children().eq(b.index),a.length&&a[0]!==this.element[0]?a.before(this.element):b.parent.append(this.element)},widget:function(){return this.uiDialog},disable:a.noop,enable:a.noop,close:function(b){var c=this;this._isOpen&&this._trigger("beforeClose",b)!==!1&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||a.ui.safeBlur(a.ui.safeActiveElement(this.document[0])),this._hide(this.uiDialog,this.options.hide,function(){c._trigger("close",b)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(b,c){var d=!1,e=this.uiDialog.siblings(".ui-front:visible").map(function(){return+a(this).css("z-index")}).get(),f=Math.max.apply(null,e);return f>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",f+1),d=!0),d&&!c&&this._trigger("focus",b),d},open:function(){var b=this;return this._isOpen?void(this._moveToTop()&&this._focusTabbable()):(this._isOpen=!0,this.opener=a(a.ui.safeActiveElement(this.document[0])),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){b._focusTabbable(),b._trigger("focus")}),this._makeFocusTarget(),void this._trigger("open"))},_focusTabbable:function(){var a=this._focusedElement;a||(a=this.element.find("[autofocus]")),a.length||(a=this.element.find(":tabbable")),a.length||(a=this.uiDialogButtonPane.find(":tabbable")),a.length||(a=this.uiDialogTitlebarClose.filter(":tabbable")),a.length||(a=this.uiDialog),a.eq(0).trigger("focus")},_keepFocus:function(b){function c(){var b=a.ui.safeActiveElement(this.document[0]),c=this.uiDialog[0]===b||a.contains(this.uiDialog[0],b);c||this._focusTabbable()}b.preventDefault(),c.call(this),this._delay(c)},_createWrapper:function(){this.uiDialog=a("<div>").hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(b){if(this.options.closeOnEscape&&!b.isDefaultPrevented()&&b.keyCode&&b.keyCode===a.ui.keyCode.ESCAPE)return b.preventDefault(),void this.close(b);if(b.keyCode===a.ui.keyCode.TAB&&!b.isDefaultPrevented()){var c=this.uiDialog.find(":tabbable"),d=c.filter(":first"),e=c.filter(":last");b.target!==e[0]&&b.target!==this.uiDialog[0]||b.shiftKey?b.target!==d[0]&&b.target!==this.uiDialog[0]||!b.shiftKey||(this._delay(function(){e.trigger("focus")}),b.preventDefault()):(this._delay(function(){d.trigger("focus")}),b.preventDefault())}},mousedown:function(a){this._moveToTop(a)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var b;this.uiDialogTitlebar=a("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(b){a(b.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=a("<button type='button'></button>").button({label:a("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(a){a.preventDefault(),this.close(a)}}),b=a("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(b,"ui-dialog-title"),this._title(b),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":b.attr("id")})},_title:function(a){this.options.title?a.text(this.options.title):a.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=a("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=a("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var b=this,c=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),a.isEmptyObject(c)||a.isArray(c)&&!c.length?void this._removeClass(this.uiDialog,"ui-dialog-buttons"):(a.each(c,function(c,d){var e,f;d=a.isFunction(d)?{click:d,text:c}:d,d=a.extend({type:"button"},d),e=d.click,f={icon:d.icon,iconPosition:d.iconPosition,showLabel:d.showLabel},delete d.click,delete d.icon,delete d.iconPosition,delete d.showLabel,a("<button></button>",d).button(f).appendTo(b.uiButtonSet).on("click",function(){e.apply(b.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),void this.uiDialogButtonPane.appendTo(this.uiDialog))},_makeDraggable:function(){var b=this,c=this.options;function d(a){return{position:a.position,offset:a.offset}}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(c,e){b._addClass(a(this),"ui-dialog-dragging"),b._blockFrames(),b._trigger("dragStart",c,d(e))},drag:function(a,c){b._trigger("drag",a,d(c))},stop:function(e,f){var g=f.offset.left-b.document.scrollLeft(),h=f.offset.top-b.document.scrollTop();c.position={my:"left top",at:"left"+(g>=0?"+":"")+g+" top"+(h>=0?"+":"")+h,of:b.window},b._removeClass(a(this),"ui-dialog-dragging"),b._unblockFrames(),b._trigger("dragStop",e,d(f))}})},_makeResizable:function(){var b=this,c=this.options,d=c.resizable,e=this.uiDialog.css("position"),f="string"==typeof d?d:"n,e,s,w,se,sw,ne,nw";function g(a){return{originalPosition:a.originalPosition,originalSize:a.originalSize,position:a.position,size:a.size}}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:c.maxWidth,maxHeight:c.maxHeight,minWidth:c.minWidth,minHeight:this._minHeight(),handles:f,start:function(c,d){b._addClass(a(this),"ui-dialog-resizing"),b._blockFrames(),b._trigger("resizeStart",c,g(d))},resize:function(a,c){b._trigger("resize",a,g(c))},stop:function(d,e){var f=b.uiDialog.offset(),h=f.left-b.document.scrollLeft(),i=f.top-b.document.scrollTop();c.height=b.uiDialog.height(),c.width=b.uiDialog.width(),c.position={my:"left top",at:"left"+(h>=0?"+":"")+h+" top"+(i>=0?"+":"")+i,of:b.window},b._removeClass(a(this),"ui-dialog-resizing"),b._unblockFrames(),b._trigger("resizeStop",d,g(e))}}).css("position",e)},_trackFocus:function(){this._on(this.widget(),{focusin:function(b){this._makeFocusTarget(),this._focusedElement=a(b.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var b=this._trackingInstances(),c=a.inArray(this,b);c!==-1&&b.splice(c,1)},_trackingInstances:function(){var a=this.document.data("ui-dialog-instances");return a||(a=[],this.document.data("ui-dialog-instances",a)),a},_minHeight:function(){var a=this.options;return"auto"===a.height?a.minHeight:Math.min(a.minHeight,a.height)},_position:function(){var a=this.uiDialog.is(":visible");a||this.uiDialog.show(),this.uiDialog.position(this.options.position),a||this.uiDialog.hide()},_setOptions:function(b){var c=this,d=!1,e={};a.each(b,function(a,b){c._setOption(a,b),a in c.sizeRelatedOptions&&(d=!0),a in c.resizableRelatedOptions&&(e[a]=b)}),d&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",e)},_setOption:function(b,c){var d,e,f=this.uiDialog;"disabled"!==b&&(this._super(b,c),"appendTo"===b&&this.uiDialog.appendTo(this._appendTo()),"buttons"===b&&this._createButtons(),"closeText"===b&&this.uiDialogTitlebarClose.button({label:a("<a>").text(""+this.options.closeText).html()}),"draggable"===b&&(d=f.is(":data(ui-draggable)"),d&&!c&&f.draggable("destroy"),!d&&c&&this._makeDraggable()),"position"===b&&this._position(),"resizable"===b&&(e=f.is(":data(ui-resizable)"),e&&!c&&f.resizable("destroy"),e&&"string"==typeof c&&f.resizable("option","handles",c),e||c===!1||this._makeResizable()),"title"===b&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var a,b,c,d=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),d.minWidth>d.width&&(d.width=d.minWidth),a=this.uiDialog.css({height:"auto",width:d.width}).outerHeight(),b=Math.max(0,d.minHeight-a),c="number"==typeof d.maxHeight?Math.max(0,d.maxHeight-a):"none","auto"===d.height?this.element.css({minHeight:b,maxHeight:c,height:"auto"}):this.element.height(Math.max(0,d.height-a)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var b=a(this);return a("<div>").css({position:"absolute",width:b.outerWidth(),height:b.outerHeight()}).appendTo(b.parent()).offset(b.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(b){return!!a(b.target).closest(".ui-dialog").length||!!a(b.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var b=!0;this._delay(function(){b=!1}),this.document.data("ui-dialog-overlays")||this._on(this.document,{focusin:function(a){b||this._allowInteraction(a)||(a.preventDefault(),this._trackingInstances()[0]._focusTabbable())}}),this.overlay=a("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{
mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1)}},_destroyOverlay:function(){if(this.options.modal&&this.overlay){var a=this.document.data("ui-dialog-overlays")-1;a?this.document.data("ui-dialog-overlays",a):(this._off(this.document,"focusin"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null}}}),a.uiBackCompat!==!1&&a.widget("ui.dialog",a.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(a,b){"dialogClass"===a&&this.uiDialog.removeClass(this.options.dialogClass).addClass(b),this._superApply(arguments)}});var ga=a.ui.dialog;a.widget("ui.droppable",{version:"1.12.0",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var b,c=this.options,d=c.accept;this.isover=!1,this.isout=!0,this.accept=a.isFunction(d)?d:function(a){return a.is(d)},this.proportions=function(){return arguments.length?void(b=arguments[0]):b?b:b={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},this._addToManager(c.scope),c.addClasses&&this._addClass("ui-droppable")},_addToManager:function(b){a.ui.ddmanager.droppables[b]=a.ui.ddmanager.droppables[b]||[],a.ui.ddmanager.droppables[b].push(this)},_splice:function(a){for(var b=0;b<a.length;b++)a[b]===this&&a.splice(b,1)},_destroy:function(){var b=a.ui.ddmanager.droppables[this.options.scope];this._splice(b)},_setOption:function(b,c){if("accept"===b)this.accept=a.isFunction(c)?c:function(a){return a.is(c)};else if("scope"===b){var d=a.ui.ddmanager.droppables[this.options.scope];this._splice(d),this._addToManager(c)}this._super(b,c)},_activate:function(b){var c=a.ui.ddmanager.current;this._addActiveClass(),c&&this._trigger("activate",b,this.ui(c))},_deactivate:function(b){var c=a.ui.ddmanager.current;this._removeActiveClass(),c&&this._trigger("deactivate",b,this.ui(c))},_over:function(b){var c=a.ui.ddmanager.current;c&&(c.currentItem||c.element)[0]!==this.element[0]&&this.accept.call(this.element[0],c.currentItem||c.element)&&(this._addHoverClass(),this._trigger("over",b,this.ui(c)))},_out:function(b){var c=a.ui.ddmanager.current;c&&(c.currentItem||c.element)[0]!==this.element[0]&&this.accept.call(this.element[0],c.currentItem||c.element)&&(this._removeHoverClass(),this._trigger("out",b,this.ui(c)))},_drop:function(b,c){var d=c||a.ui.ddmanager.current,e=!1;return!(!d||(d.currentItem||d.element)[0]===this.element[0])&&(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var c=a(this).droppable("instance");if(c.options.greedy&&!c.options.disabled&&c.options.scope===d.options.scope&&c.accept.call(c.element[0],d.currentItem||d.element)&&ha(d,a.extend(c,{offset:c.element.offset()}),c.options.tolerance,b))return e=!0,!1}),!e&&(!!this.accept.call(this.element[0],d.currentItem||d.element)&&(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",b,this.ui(d)),this.element)))},ui:function(a){return{draggable:a.currentItem||a.element,helper:a.helper,position:a.position,offset:a.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}});var ha=a.ui.intersect=function(){function a(a,b,c){return a>=b&&a<b+c}return function(b,c,d,e){if(!c.offset)return!1;var f=(b.positionAbs||b.position.absolute).left+b.margins.left,g=(b.positionAbs||b.position.absolute).top+b.margins.top,h=f+b.helperProportions.width,i=g+b.helperProportions.height,j=c.offset.left,k=c.offset.top,l=j+c.proportions().width,m=k+c.proportions().height;switch(d){case"fit":return j<=f&&h<=l&&k<=g&&i<=m;case"intersect":return j<f+b.helperProportions.width/2&&h-b.helperProportions.width/2<l&&k<g+b.helperProportions.height/2&&i-b.helperProportions.height/2<m;case"pointer":return a(e.pageY,k,c.proportions().height)&&a(e.pageX,j,c.proportions().width);case"touch":return(g>=k&&g<=m||i>=k&&i<=m||g<k&&i>m)&&(f>=j&&f<=l||h>=j&&h<=l||f<j&&h>l);default:return!1}}}();a.ui.ddmanager={current:null,droppables:{default:[]},prepareOffsets:function(b,c){var d,e,f=a.ui.ddmanager.droppables[b.options.scope]||[],g=c?c.type:null,h=(b.currentItem||b.element).find(":data(ui-droppable)").addBack();a:for(d=0;d<f.length;d++)if(!(f[d].options.disabled||b&&!f[d].accept.call(f[d].element[0],b.currentItem||b.element))){for(e=0;e<h.length;e++)if(h[e]===f[d].element[0]){f[d].proportions().height=0;continue a}f[d].visible="none"!==f[d].element.css("display"),f[d].visible&&("mousedown"===g&&f[d]._activate.call(f[d],c),f[d].offset=f[d].element.offset(),f[d].proportions({width:f[d].element[0].offsetWidth,height:f[d].element[0].offsetHeight}))}},drop:function(b,c){var d=!1;return a.each((a.ui.ddmanager.droppables[b.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&ha(b,this,this.options.tolerance,c)&&(d=this._drop.call(this,c)||d),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],b.currentItem||b.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,c)))}),d},dragStart:function(b,c){b.element.parentsUntil("body").on("scroll.droppable",function(){b.options.refreshPositions||a.ui.ddmanager.prepareOffsets(b,c)})},drag:function(b,c){b.options.refreshPositions&&a.ui.ddmanager.prepareOffsets(b,c),a.each(a.ui.ddmanager.droppables[b.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var d,e,f,g=ha(b,this,this.options.tolerance,c),h=!g&&this.isover?"isout":g&&!this.isover?"isover":null;h&&(this.options.greedy&&(e=this.options.scope,f=this.element.parents(":data(ui-droppable)").filter(function(){return a(this).droppable("instance").options.scope===e}),f.length&&(d=a(f[0]).droppable("instance"),d.greedyChild="isover"===h)),d&&"isover"===h&&(d.isover=!1,d.isout=!0,d._out.call(d,c)),this[h]=!0,this["isout"===h?"isover":"isout"]=!1,this["isover"===h?"_over":"_out"].call(this,c),d&&"isout"===h&&(d.isout=!1,d.isover=!0,d._over.call(d,c)))}})},dragStop:function(b,c){b.element.parentsUntil("body").off("scroll.droppable"),b.options.refreshPositions||a.ui.ddmanager.prepareOffsets(b,c)}},a.uiBackCompat!==!1&&a.widget("ui.droppable",a.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}});var ia=a.ui.droppable,ja=a.widget("ui.progressbar",{version:"1.12.0",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=a("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(a){return void 0===a?this.options.value:(this.options.value=this._constrainedValue(a),void this._refreshValue())},_constrainedValue:function(a){return void 0===a&&(a=this.options.value),this.indeterminate=a===!1,"number"!=typeof a&&(a=0),!this.indeterminate&&Math.min(this.options.max,Math.max(this.min,a))},_setOptions:function(a){var b=a.value;delete a.value,this._super(a),this.options.value=this._constrainedValue(b),this._refreshValue()},_setOption:function(a,b){"max"===a&&(b=Math.max(this.min,b)),this._super(a,b)},_setOptionDisabled:function(a){this._super(a),this.element.attr("aria-disabled",a),this._toggleClass(null,"ui-state-disabled",!!a)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var b=this.options.value,c=this._percentage();this.valueDiv.toggle(this.indeterminate||b>this.min).width(c.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,b===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=a("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":b}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==b&&(this.oldValue=b,this._trigger("change")),b===this.options.max&&this._trigger("complete")}}),ka=a.widget("ui.selectable",a.ui.mouse,{version:"1.12.0",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var b=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){b.elementPos=a(b.element[0]).offset(),b.selectees=a(b.options.filter,b.element[0]),b._addClass(b.selectees,"ui-selectee"),b.selectees.each(function(){var c=a(this),d=c.offset(),e={left:d.left-b.elementPos.left,top:d.top-b.elementPos.top};a.data(this,"selectable-item",{element:this,$element:c,left:e.left,top:e.top,right:e.left+c.outerWidth(),bottom:e.top+c.outerHeight(),startselected:!1,selected:c.hasClass("ui-selected"),selecting:c.hasClass("ui-selecting"),unselecting:c.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=a("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(b){var c=this,d=this.options;this.opos=[b.pageX,b.pageY],this.elementPos=a(this.element[0]).offset(),this.options.disabled||(this.selectees=a(d.filter,this.element[0]),this._trigger("start",b),a(d.appendTo).append(this.helper),this.helper.css({left:b.pageX,top:b.pageY,width:0,height:0}),d.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var d=a.data(this,"selectable-item");d.startselected=!0,b.metaKey||b.ctrlKey||(c._removeClass(d.$element,"ui-selected"),d.selected=!1,c._addClass(d.$element,"ui-unselecting"),d.unselecting=!0,c._trigger("unselecting",b,{unselecting:d.element}))}),a(b.target).parents().addBack().each(function(){var d,e=a.data(this,"selectable-item");if(e)return d=!b.metaKey&&!b.ctrlKey||!e.$element.hasClass("ui-selected"),c._removeClass(e.$element,d?"ui-unselecting":"ui-selected")._addClass(e.$element,d?"ui-selecting":"ui-unselecting"),e.unselecting=!d,e.selecting=d,e.selected=d,d?c._trigger("selecting",b,{selecting:e.element}):c._trigger("unselecting",b,{unselecting:e.element}),!1}))},_mouseDrag:function(b){if(this.dragged=!0,!this.options.disabled){var c,d=this,e=this.options,f=this.opos[0],g=this.opos[1],h=b.pageX,i=b.pageY;return f>h&&(c=h,h=f,f=c),g>i&&(c=i,i=g,g=c),this.helper.css({left:f,top:g,width:h-f,height:i-g}),this.selectees.each(function(){var c=a.data(this,"selectable-item"),j=!1,k={};c&&c.element!==d.element[0]&&(k.left=c.left+d.elementPos.left,k.right=c.right+d.elementPos.left,k.top=c.top+d.elementPos.top,k.bottom=c.bottom+d.elementPos.top,"touch"===e.tolerance?j=!(k.left>h||k.right<f||k.top>i||k.bottom<g):"fit"===e.tolerance&&(j=k.left>f&&k.right<h&&k.top>g&&k.bottom<i),j?(c.selected&&(d._removeClass(c.$element,"ui-selected"),c.selected=!1),c.unselecting&&(d._removeClass(c.$element,"ui-unselecting"),c.unselecting=!1),c.selecting||(d._addClass(c.$element,"ui-selecting"),c.selecting=!0,d._trigger("selecting",b,{selecting:c.element}))):(c.selecting&&((b.metaKey||b.ctrlKey)&&c.startselected?(d._removeClass(c.$element,"ui-selecting"),c.selecting=!1,d._addClass(c.$element,"ui-selected"),c.selected=!0):(d._removeClass(c.$element,"ui-selecting"),c.selecting=!1,c.startselected&&(d._addClass(c.$element,"ui-unselecting"),c.unselecting=!0),d._trigger("unselecting",b,{unselecting:c.element}))),c.selected&&(b.metaKey||b.ctrlKey||c.startselected||(d._removeClass(c.$element,"ui-selected"),c.selected=!1,d._addClass(c.$element,"ui-unselecting"),c.unselecting=!0,d._trigger("unselecting",b,{unselecting:c.element})))))}),!1}},_mouseStop:function(b){var c=this;return this.dragged=!1,a(".ui-unselecting",this.element[0]).each(function(){var d=a.data(this,"selectable-item");c._removeClass(d.$element,"ui-unselecting"),d.unselecting=!1,d.startselected=!1,c._trigger("unselected",b,{unselected:d.element})}),a(".ui-selecting",this.element[0]).each(function(){var d=a.data(this,"selectable-item");c._removeClass(d.$element,"ui-selecting")._addClass(d.$element,"ui-selected"),d.selecting=!1,d.selected=!0,d.startselected=!0,c._trigger("selected",b,{selected:d.element})}),this._trigger("stop",b),this.helper.remove(),!1}}),la=a.widget("ui.selectmenu",[a.ui.formResetMixin,{version:"1.12.0",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var b=this.element.uniqueId().attr("id");this.ids={element:b,button:b+"-button",menu:b+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=a()},_drawButton:function(){var b,c=this,d=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(a){this.button.focus(),a.preventDefault()}}),this.element.hide(),this.button=a("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),b=a("<span>").appendTo(this.button),this._addClass(b,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(d).appendTo(this.button),this.options.width!==!1&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){c._rendered||c._refreshMenu()})},_drawMenu:function(){var b=this;this.menu=a("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=a("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(a,c){a.preventDefault(),b._setSelection(),b._select(c.item.data("ui-selectmenu-item"),a)},focus:function(a,c){var d=c.item.data("ui-selectmenu-item");null!=b.focusIndex&&d.index!==b.focusIndex&&(b._trigger("focus",a,{item:d}),b.isOpen||b._select(d,a)),b.focusIndex=d.index,b.button.attr("aria-activedescendant",b.menuItems.eq(d.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var a,b=this.element.find("option");this.menu.empty(),this._parseOptions(b),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,b.length&&(a=this._getSelectedItem(),this.menuInstance.focus(null,a),this._setAria(a.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(a){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",a)))},_position:function(){this.menuWrap.position(a.extend({of:this.button},this.options.position))},close:function(a){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",a))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(b){var c=a("<span>");return this._setText(c,b.label),this._addClass(c,"ui-selectmenu-text"),c},_renderMenu:function(b,c){var d=this,e="";a.each(c,function(c,f){var g;f.optgroup!==e&&(g=a("<li>",{text:f.optgroup}),d._addClass(g,"ui-selectmenu-optgroup","ui-menu-divider"+(f.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),g.appendTo(b),e=f.optgroup),d._renderItemData(b,f)})},_renderItemData:function(a,b){return this._renderItem(a,b).data("ui-selectmenu-item",b)},_renderItem:function(b,c){var d=a("<li>"),e=a("<div>",{title:c.element.attr("title")});return c.disabled&&this._addClass(d,null,"ui-state-disabled"),this._setText(e,c.label),d.append(e).appendTo(b)},_setText:function(a,b){b?a.text(b):a.html("&#160;")},_move:function(a,b){var c,d,e=".ui-menu-item";this.isOpen?c=this.menuItems.eq(this.focusIndex).parent("li"):(c=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),e+=":not(.ui-state-disabled)"),d="first"===a||"last"===a?c["first"===a?"prevAll":"nextAll"](e).eq(-1):c[a+"All"](e).eq(0),d.length&&this.menuInstance.focus(b,d)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(a){this[this.isOpen?"close":"open"](a)},_setSelection:function(){var a;this.range&&(window.getSelection?(a=window.getSelection(),a.removeAllRanges(),a.addRange(this.range)):this.range.select(),this.button.focus())},_documentClick:{mousedown:function(b){this.isOpen&&(a(b.target).closest(".ui-selectmenu-menu, #"+a.ui.escapeSelector(this.ids.button)).length||this.close(b))}},_buttonEvents:{mousedown:function(){var a;window.getSelection?(a=window.getSelection(),a.rangeCount&&(this.range=a.getRangeAt(0))):this.range=document.selection.createRange()},click:function(a){this._setSelection(),this._toggle(a)},keydown:function(b){var c=!0;switch(b.keyCode){case a.ui.keyCode.TAB:case a.ui.keyCode.ESCAPE:this.close(b),c=!1;break;case a.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(b);break;case a.ui.keyCode.UP:b.altKey?this._toggle(b):this._move("prev",b);break;case a.ui.keyCode.DOWN:b.altKey?this._toggle(b):this._move("next",b);break;case a.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(b):this._toggle(b);break;case a.ui.keyCode.LEFT:this._move("prev",b);break;case a.ui.keyCode.RIGHT:this._move("next",b);break;case a.ui.keyCode.HOME:case a.ui.keyCode.PAGE_UP:this._move("first",b);break;case a.ui.keyCode.END:case a.ui.keyCode.PAGE_DOWN:this._move("last",b);break;default:this.menu.trigger(b),c=!1}c&&b.preventDefault()}},_selectFocusedItem:function(a){var b=this.menuItems.eq(this.focusIndex).parent("li");b.hasClass("ui-state-disabled")||this._select(b.data("ui-selectmenu-item"),a)},_select:function(a,b){var c=this.element[0].selectedIndex;this.element[0].selectedIndex=a.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(a)),this._setAria(a),this._trigger("select",b,{item:a}),a.index!==c&&this._trigger("change",b,{item:a}),this.close(b)},_setAria:function(a){var b=this.menuItems.eq(a.index).attr("id");this.button.attr({"aria-labelledby":b,"aria-activedescendant":b}),this.menu.attr("aria-activedescendant",b)},_setOption:function(a,b){if("icons"===a){var c=this.button.find("span.ui-icon");this._removeClass(c,null,this.options.icons.button)._addClass(c,null,b.button)}this._super(a,b),"appendTo"===a&&this.menuWrap.appendTo(this._appendTo()),"width"===a&&this._resizeButton()},_setOptionDisabled:function(a){this._super(a),this.menuInstance.option("disabled",a),this.button.attr("aria-disabled",a),this._toggleClass(this.button,null,"ui-state-disabled",a),this.element.prop("disabled",a),a?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var b=this.options.appendTo;return b&&(b=b.jquery||b.nodeType?a(b):this.document.find(b).eq(0)),b&&b[0]||(b=this.element.closest(".ui-front, dialog")),b.length||(b=this.document[0].body),b},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var a=this.options.width;return a===!1?void this.button.css("width",""):(null===a&&(a=this.element.show().outerWidth(),this.element.hide()),void this.button.outerWidth(a))},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()+1))},_getCreateOptions:function(){var a=this._super();return a.disabled=this.element.prop("disabled"),a},_parseOptions:function(b){var c=this,d=[];b.each(function(b,e){d.push(c._parseOption(a(e),b))}),this.items=d},_parseOption:function(a,b){var c=a.parent("optgroup");return{element:a,index:b,value:a.val(),label:a.text(),optgroup:c.attr("label")||"",disabled:c.prop("disabled")||a.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),ma=a.widget("ui.slider",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var b,c,d=this.options,e=this.element.find(".ui-slider-handle"),f="<span tabindex='0'></span>",g=[];for(c=d.values&&d.values.length||1,e.length>c&&(e.slice(c).remove(),e=e.slice(0,c)),b=e.length;b<c;b++)g.push(f);this.handles=e.add(a(g.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(b){a(this).data("ui-slider-handle-index",b)})},_createRange:function(){var b=this.options;b.range?(b.range===!0&&(b.values?b.values.length&&2!==b.values.length?b.values=[b.values[0],b.values[0]]:a.isArray(b.values)&&(b.values=b.values.slice(0)):b.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=a("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==b.range&&"max"!==b.range||this._addClass(this.range,"ui-slider-range-"+b.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(b){var c,d,e,f,g,h,i,j,k=this,l=this.options;return!l.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),c={x:b.pageX,y:b.pageY},d=this._normValueFromMouse(c),e=this._valueMax()-this._valueMin()+1,this.handles.each(function(b){var c=Math.abs(d-k.values(b));(e>c||e===c&&(b===k._lastChangedValue||k.values(b)===l.min))&&(e=c,f=a(this),g=b)}),h=this._start(b,g),h!==!1&&(this._mouseSliding=!0,this._handleIndex=g,this._addClass(f,null,"ui-state-active"),f.trigger("focus"),i=f.offset(),j=!a(b.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=j?{left:0,top:0}:{left:b.pageX-i.left-f.width()/2,top:b.pageY-i.top-f.height()/2-(parseInt(f.css("borderTopWidth"),10)||0)-(parseInt(f.css("borderBottomWidth"),10)||0)+(parseInt(f.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(b,g,d),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(a){var b={x:a.pageX,y:a.pageY},c=this._normValueFromMouse(b);return this._slide(a,this._handleIndex,c),!1},_mouseStop:function(a){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(a,this._handleIndex),this._change(a,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(a){var b,c,d,e,f;return"horizontal"===this.orientation?(b=this.elementSize.width,c=a.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(b=this.elementSize.height,c=a.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),d=c/b,d>1&&(d=1),d<0&&(d=0),"vertical"===this.orientation&&(d=1-d),e=this._valueMax()-this._valueMin(),f=this._valueMin()+d*e,this._trimAlignValue(f)},_uiHash:function(a,b,c){var d={handle:this.handles[a],handleIndex:a,value:void 0!==b?b:this.value()};return this._hasMultipleValues()&&(d.value=void 0!==b?b:this.values(a),d.values=c||this.values()),d},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(a,b){return this._trigger("start",a,this._uiHash(b))},_slide:function(a,b,c){var d,e,f=this.value(),g=this.values();this._hasMultipleValues()&&(e=this.values(b?0:1),f=this.values(b),2===this.options.values.length&&this.options.range===!0&&(c=0===b?Math.min(e,c):Math.max(e,c)),g[b]=c),c!==f&&(d=this._trigger("slide",a,this._uiHash(b,c,g)),d!==!1&&(this._hasMultipleValues()?this.values(b,c):this.value(c)))},_stop:function(a,b){this._trigger("stop",a,this._uiHash(b))},_change:function(a,b){this._keySliding||this._mouseSliding||(this._lastChangedValue=b,this._trigger("change",a,this._uiHash(b)))},value:function(a){return arguments.length?(this.options.value=this._trimAlignValue(a),this._refreshValue(),void this._change(null,0)):this._value()},values:function(b,c){var d,e,f;if(arguments.length>1)return this.options.values[b]=this._trimAlignValue(c),this._refreshValue(),void this._change(null,b);if(!arguments.length)return this._values();if(!a.isArray(arguments[0]))return this._hasMultipleValues()?this._values(b):this.value();for(d=this.options.values,e=arguments[0],f=0;f<d.length;f+=1)d[f]=this._trimAlignValue(e[f]),this._change(null,f);this._refreshValue()},_setOption:function(b,c){var d,e=0;switch("range"===b&&this.options.range===!0&&("min"===c?(this.options.value=this._values(0),this.options.values=null):"max"===c&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),a.isArray(this.options.values)&&(e=this.options.values.length),this._super(b,c),b){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(c),this.handles.css("horizontal"===c?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),d=e-1;d>=0;d--)this._change(null,d);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(a){this._super(a),this._toggleClass(null,"ui-state-disabled",!!a)},_value:function(){var a=this.options.value;return a=this._trimAlignValue(a)},_values:function(a){var b,c,d;if(arguments.length)return b=this.options.values[a],b=this._trimAlignValue(b);if(this._hasMultipleValues()){for(c=this.options.values.slice(),d=0;d<c.length;d+=1)c[d]=this._trimAlignValue(c[d]);return c}return[]},_trimAlignValue:function(a){if(a<=this._valueMin())return this._valueMin();if(a>=this._valueMax())return this._valueMax();var b=this.options.step>0?this.options.step:1,c=(a-this._valueMin())%b,d=a-c;return 2*Math.abs(c)>=b&&(d+=c>0?b:-b),parseFloat(d.toFixed(5))},_calculateNewMax:function(){var a=this.options.max,b=this._valueMin(),c=this.options.step,d=Math.round((a-b)/c)*c;a=d+b,a>this.options.max&&(a-=c),this.max=parseFloat(a.toFixed(this._precision()))},_precision:function(){var a=this._precisionOf(this.options.step);return null!==this.options.min&&(a=Math.max(a,this._precisionOf(this.options.min))),a},_precisionOf:function(a){var b=a.toString(),c=b.indexOf(".");return c===-1?0:b.length-c-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(a){"vertical"===a&&this.range.css({width:"",left:""}),"horizontal"===a&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var b,c,d,e,f,g=this.options.range,h=this.options,i=this,j=!this._animateOff&&h.animate,k={};this._hasMultipleValues()?this.handles.each(function(d){c=(i.values(d)-i._valueMin())/(i._valueMax()-i._valueMin())*100,k["horizontal"===i.orientation?"left":"bottom"]=c+"%",a(this).stop(1,1)[j?"animate":"css"](k,h.animate),i.options.range===!0&&("horizontal"===i.orientation?(0===d&&i.range.stop(1,1)[j?"animate":"css"]({left:c+"%"},h.animate),1===d&&i.range[j?"animate":"css"]({width:c-b+"%"},{queue:!1,duration:h.animate})):(0===d&&i.range.stop(1,1)[j?"animate":"css"]({bottom:c+"%"},h.animate),1===d&&i.range[j?"animate":"css"]({height:c-b+"%"},{queue:!1,duration:h.animate}))),b=c}):(d=this.value(),e=this._valueMin(),f=this._valueMax(),c=f!==e?(d-e)/(f-e)*100:0,k["horizontal"===this.orientation?"left":"bottom"]=c+"%",this.handle.stop(1,1)[j?"animate":"css"](k,h.animate),"min"===g&&"horizontal"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({width:c+"%"},h.animate),"max"===g&&"horizontal"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({width:100-c+"%"},h.animate),"min"===g&&"vertical"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({height:c+"%"},h.animate),"max"===g&&"vertical"===this.orientation&&this.range.stop(1,1)[j?"animate":"css"]({height:100-c+"%"},h.animate))},_handleEvents:{keydown:function(b){var c,d,e,f,g=a(b.target).data("ui-slider-handle-index");switch(b.keyCode){case a.ui.keyCode.HOME:case a.ui.keyCode.END:case a.ui.keyCode.PAGE_UP:case a.ui.keyCode.PAGE_DOWN:case a.ui.keyCode.UP:case a.ui.keyCode.RIGHT:case a.ui.keyCode.DOWN:case a.ui.keyCode.LEFT:if(b.preventDefault(),!this._keySliding&&(this._keySliding=!0,this._addClass(a(b.target),null,"ui-state-active"),
c=this._start(b,g),c===!1))return}switch(f=this.options.step,d=e=this._hasMultipleValues()?this.values(g):this.value(),b.keyCode){case a.ui.keyCode.HOME:e=this._valueMin();break;case a.ui.keyCode.END:e=this._valueMax();break;case a.ui.keyCode.PAGE_UP:e=this._trimAlignValue(d+(this._valueMax()-this._valueMin())/this.numPages);break;case a.ui.keyCode.PAGE_DOWN:e=this._trimAlignValue(d-(this._valueMax()-this._valueMin())/this.numPages);break;case a.ui.keyCode.UP:case a.ui.keyCode.RIGHT:if(d===this._valueMax())return;e=this._trimAlignValue(d+f);break;case a.ui.keyCode.DOWN:case a.ui.keyCode.LEFT:if(d===this._valueMin())return;e=this._trimAlignValue(d-f)}this._slide(b,g,e)},keyup:function(b){var c=a(b.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(b,c),this._change(b,c),this._removeClass(a(b.target),null,"ui-state-active"))}}}),na=a.widget("ui.sortable",a.ui.mouse,{version:"1.12.0",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(a,b,c){return a>=b&&a<b+c},_isFloating:function(a){return/left|right/.test(a.css("float"))||/inline|table-cell/.test(a.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(a,b){this._super(a,b),"handle"===a&&this._setHandleClassName()},_setHandleClassName:function(){var b=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),a.each(this.items,function(){b._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var a=this.items.length-1;a>=0;a--)this.items[a].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(b,c){var d=null,e=!1,f=this;return!this.reverting&&(!this.options.disabled&&"static"!==this.options.type&&(this._refreshItems(b),a(b.target).parents().each(function(){if(a.data(this,f.widgetName+"-item")===f)return d=a(this),!1}),a.data(b.target,f.widgetName+"-item")===f&&(d=a(b.target)),!!d&&(!(this.options.handle&&!c&&(a(this.options.handle,d).find("*").addBack().each(function(){this===b.target&&(e=!0)}),!e))&&(this.currentItem=d,this._removeCurrentsFromItems(),!0))))},_mouseStart:function(b,c,d){var e,f,g=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(b),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},a.extend(this.offset,{click:{left:b.pageX-this.offset.left,top:b.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(b),this.originalPageX=b.pageX,this.originalPageY=b.pageY,g.cursorAt&&this._adjustOffsetFromHelper(g.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),g.containment&&this._setContainment(),g.cursor&&"auto"!==g.cursor&&(f=this.document.find("body"),this.storedCursor=f.css("cursor"),f.css("cursor",g.cursor),this.storedStylesheet=a("<style>*{ cursor: "+g.cursor+" !important; }</style>").appendTo(f)),g.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",g.opacity)),g.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",g.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",b,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!d)for(e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("activate",b,this._uiHash(this));return a.ui.ddmanager&&(a.ui.ddmanager.current=this),a.ui.ddmanager&&!g.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this._mouseDrag(b),!0},_mouseDrag:function(b){var c,d,e,f,g=this.options,h=!1;for(this.position=this._generatePosition(b),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-b.pageY<g.scrollSensitivity?this.scrollParent[0].scrollTop=h=this.scrollParent[0].scrollTop+g.scrollSpeed:b.pageY-this.overflowOffset.top<g.scrollSensitivity&&(this.scrollParent[0].scrollTop=h=this.scrollParent[0].scrollTop-g.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-b.pageX<g.scrollSensitivity?this.scrollParent[0].scrollLeft=h=this.scrollParent[0].scrollLeft+g.scrollSpeed:b.pageX-this.overflowOffset.left<g.scrollSensitivity&&(this.scrollParent[0].scrollLeft=h=this.scrollParent[0].scrollLeft-g.scrollSpeed)):(b.pageY-this.document.scrollTop()<g.scrollSensitivity?h=this.document.scrollTop(this.document.scrollTop()-g.scrollSpeed):this.window.height()-(b.pageY-this.document.scrollTop())<g.scrollSensitivity&&(h=this.document.scrollTop(this.document.scrollTop()+g.scrollSpeed)),b.pageX-this.document.scrollLeft()<g.scrollSensitivity?h=this.document.scrollLeft(this.document.scrollLeft()-g.scrollSpeed):this.window.width()-(b.pageX-this.document.scrollLeft())<g.scrollSensitivity&&(h=this.document.scrollLeft(this.document.scrollLeft()+g.scrollSpeed))),h!==!1&&a.ui.ddmanager&&!g.dropBehaviour&&a.ui.ddmanager.prepareOffsets(this,b)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),c=this.items.length-1;c>=0;c--)if(d=this.items[c],e=d.item[0],f=this._intersectsWithPointer(d),f&&d.instance===this.currentContainer&&!(e===this.currentItem[0]||this.placeholder[1===f?"next":"prev"]()[0]===e||a.contains(this.placeholder[0],e)||"semi-dynamic"===this.options.type&&a.contains(this.element[0],e))){if(this.direction=1===f?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(d))break;this._rearrange(b,d),this._trigger("change",b,this._uiHash());break}return this._contactContainers(b),a.ui.ddmanager&&a.ui.ddmanager.drag(this,b),this._trigger("sort",b,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(b,c){if(b){if(a.ui.ddmanager&&!this.options.dropBehaviour&&a.ui.ddmanager.drop(this,b),this.options.revert){var d=this,e=this.placeholder.offset(),f=this.options.axis,g={};f&&"x"!==f||(g.left=e.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),f&&"y"!==f||(g.top=e.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,a(this.helper).animate(g,parseInt(this.options.revert,10)||500,function(){d._clear(b)})}else this._clear(b,c);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var b=this.containers.length-1;b>=0;b--)this.containers[b]._trigger("deactivate",null,this._uiHash(this)),this.containers[b].containerCache.over&&(this.containers[b]._trigger("out",null,this._uiHash(this)),this.containers[b].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),a.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?a(this.domPosition.prev).after(this.currentItem):a(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(b){var c=this._getItemsAsjQuery(b&&b.connected),d=[];return b=b||{},a(c).each(function(){var c=(a(b.item||this).attr(b.attribute||"id")||"").match(b.expression||/(.+)[\-=_](.+)/);c&&d.push((b.key||c[1]+"[]")+"="+(b.key&&b.expression?c[1]:c[2]))}),!d.length&&b.key&&d.push(b.key+"="),d.join("&")},toArray:function(b){var c=this._getItemsAsjQuery(b&&b.connected),d=[];return b=b||{},c.each(function(){d.push(a(b.item||this).attr(b.attribute||"id")||"")}),d},_intersectsWith:function(a){var b=this.positionAbs.left,c=b+this.helperProportions.width,d=this.positionAbs.top,e=d+this.helperProportions.height,f=a.left,g=f+a.width,h=a.top,i=h+a.height,j=this.offset.click.top,k=this.offset.click.left,l="x"===this.options.axis||d+j>h&&d+j<i,m="y"===this.options.axis||b+k>f&&b+k<g,n=l&&m;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>a[this.floating?"width":"height"]?n:f<b+this.helperProportions.width/2&&c-this.helperProportions.width/2<g&&h<d+this.helperProportions.height/2&&e-this.helperProportions.height/2<i},_intersectsWithPointer:function(a){var b,c,d="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,a.top,a.height),e="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,a.left,a.width),f=d&&e;return!!f&&(b=this._getDragVerticalDirection(),c=this._getDragHorizontalDirection(),this.floating?"right"===c||"down"===b?2:1:b&&("down"===b?2:1))},_intersectsWithSides:function(a){var b=this._isOverAxis(this.positionAbs.top+this.offset.click.top,a.top+a.height/2,a.height),c=this._isOverAxis(this.positionAbs.left+this.offset.click.left,a.left+a.width/2,a.width),d=this._getDragVerticalDirection(),e=this._getDragHorizontalDirection();return this.floating&&e?"right"===e&&c||"left"===e&&!c:d&&("down"===d&&b||"up"===d&&!b)},_getDragVerticalDirection:function(){var a=this.positionAbs.top-this.lastPositionAbs.top;return 0!==a&&(a>0?"down":"up")},_getDragHorizontalDirection:function(){var a=this.positionAbs.left-this.lastPositionAbs.left;return 0!==a&&(a>0?"right":"left")},refresh:function(a){return this._refreshItems(a),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var a=this.options;return a.connectWith.constructor===String?[a.connectWith]:a.connectWith},_getItemsAsjQuery:function(b){var c,d,e,f,g=[],h=[],i=this._connectWith();if(i&&b)for(c=i.length-1;c>=0;c--)for(e=a(i[c],this.document[0]),d=e.length-1;d>=0;d--)f=a.data(e[d],this.widgetFullName),f&&f!==this&&!f.options.disabled&&h.push([a.isFunction(f.options.items)?f.options.items.call(f.element):a(f.options.items,f.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),f]);h.push([a.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):a(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]);function j(){g.push(this)}for(c=h.length-1;c>=0;c--)h[c][0].each(j);return a(g)},_removeCurrentsFromItems:function(){var b=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=a.grep(this.items,function(a){for(var c=0;c<b.length;c++)if(b[c]===a.item[0])return!1;return!0})},_refreshItems:function(b){this.items=[],this.containers=[this];var c,d,e,f,g,h,i,j,k=this.items,l=[[a.isFunction(this.options.items)?this.options.items.call(this.element[0],b,{item:this.currentItem}):a(this.options.items,this.element),this]],m=this._connectWith();if(m&&this.ready)for(c=m.length-1;c>=0;c--)for(e=a(m[c],this.document[0]),d=e.length-1;d>=0;d--)f=a.data(e[d],this.widgetFullName),f&&f!==this&&!f.options.disabled&&(l.push([a.isFunction(f.options.items)?f.options.items.call(f.element[0],b,{item:this.currentItem}):a(f.options.items,f.element),f]),this.containers.push(f));for(c=l.length-1;c>=0;c--)for(g=l[c][1],h=l[c][0],d=0,j=h.length;d<j;d++)i=a(h[d]),i.data(this.widgetName+"-item",g),k.push({item:i,instance:g,width:0,height:0,left:0,top:0})},refreshPositions:function(b){this.floating=!!this.items.length&&("x"===this.options.axis||this._isFloating(this.items[0].item)),this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var c,d,e,f;for(c=this.items.length-1;c>=0;c--)d=this.items[c],d.instance!==this.currentContainer&&this.currentContainer&&d.item[0]!==this.currentItem[0]||(e=this.options.toleranceElement?a(this.options.toleranceElement,d.item):d.item,b||(d.width=e.outerWidth(),d.height=e.outerHeight()),f=e.offset(),d.left=f.left,d.top=f.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(c=this.containers.length-1;c>=0;c--)f=this.containers[c].element.offset(),this.containers[c].containerCache.left=f.left,this.containers[c].containerCache.top=f.top,this.containers[c].containerCache.width=this.containers[c].element.outerWidth(),this.containers[c].containerCache.height=this.containers[c].element.outerHeight();return this},_createPlaceholder:function(b){b=b||this;var c,d=b.options;d.placeholder&&d.placeholder.constructor!==String||(c=d.placeholder,d.placeholder={element:function(){var d=b.currentItem[0].nodeName.toLowerCase(),e=a("<"+d+">",b.document[0]);return b._addClass(e,"ui-sortable-placeholder",c||b.currentItem[0].className)._removeClass(e,"ui-sortable-helper"),"tbody"===d?b._createTrPlaceholder(b.currentItem.find("tr").eq(0),a("<tr>",b.document[0]).appendTo(e)):"tr"===d?b._createTrPlaceholder(b.currentItem,e):"img"===d&&e.attr("src",b.currentItem.attr("src")),c||e.css("visibility","hidden"),e},update:function(a,e){c&&!d.forcePlaceholderSize||(e.height()||e.height(b.currentItem.innerHeight()-parseInt(b.currentItem.css("paddingTop")||0,10)-parseInt(b.currentItem.css("paddingBottom")||0,10)),e.width()||e.width(b.currentItem.innerWidth()-parseInt(b.currentItem.css("paddingLeft")||0,10)-parseInt(b.currentItem.css("paddingRight")||0,10)))}}),b.placeholder=a(d.placeholder.element.call(b.element,b.currentItem)),b.currentItem.after(b.placeholder),d.placeholder.update(b,b.placeholder)},_createTrPlaceholder:function(b,c){var d=this;b.children().each(function(){a("<td>&#160;</td>",d.document[0]).attr("colspan",a(this).attr("colspan")||1).appendTo(c)})},_contactContainers:function(b){var c,d,e,f,g,h,i,j,k,l,m=null,n=null;for(c=this.containers.length-1;c>=0;c--)if(!a.contains(this.currentItem[0],this.containers[c].element[0]))if(this._intersectsWith(this.containers[c].containerCache)){if(m&&a.contains(this.containers[c].element[0],m.element[0]))continue;m=this.containers[c],n=c}else this.containers[c].containerCache.over&&(this.containers[c]._trigger("out",b,this._uiHash(this)),this.containers[c].containerCache.over=0);if(m)if(1===this.containers.length)this.containers[n].containerCache.over||(this.containers[n]._trigger("over",b,this._uiHash(this)),this.containers[n].containerCache.over=1);else{for(e=1e4,f=null,k=m.floating||this._isFloating(this.currentItem),g=k?"left":"top",h=k?"width":"height",l=k?"pageX":"pageY",d=this.items.length-1;d>=0;d--)a.contains(this.containers[n].element[0],this.items[d].item[0])&&this.items[d].item[0]!==this.currentItem[0]&&(i=this.items[d].item.offset()[g],j=!1,b[l]-i>this.items[d][h]/2&&(j=!0),Math.abs(b[l]-i)<e&&(e=Math.abs(b[l]-i),f=this.items[d],this.direction=j?"up":"down"));if(!f&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[n])return void(this.currentContainer.containerCache.over||(this.containers[n]._trigger("over",b,this._uiHash()),this.currentContainer.containerCache.over=1));f?this._rearrange(b,f,null,!0):this._rearrange(b,null,this.containers[n].element,!0),this._trigger("change",b,this._uiHash()),this.containers[n]._trigger("change",b,this._uiHash(this)),this.currentContainer=this.containers[n],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[n]._trigger("over",b,this._uiHash(this)),this.containers[n].containerCache.over=1}},_createHelper:function(b){var c=this.options,d=a.isFunction(c.helper)?a(c.helper.apply(this.element[0],[b,this.currentItem])):"clone"===c.helper?this.currentItem.clone():this.currentItem;return d.parents("body").length||a("parent"!==c.appendTo?c.appendTo:this.currentItem[0].parentNode)[0].appendChild(d[0]),d[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),d[0].style.width&&!c.forceHelperSize||d.width(this.currentItem.width()),d[0].style.height&&!c.forceHelperSize||d.height(this.currentItem.height()),d},_adjustOffsetFromHelper:function(b){"string"==typeof b&&(b=b.split(" ")),a.isArray(b)&&(b={left:+b[0],top:+b[1]||0}),"left"in b&&(this.offset.click.left=b.left+this.margins.left),"right"in b&&(this.offset.click.left=this.helperProportions.width-b.right+this.margins.left),"top"in b&&(this.offset.click.top=b.top+this.margins.top),"bottom"in b&&(this.offset.click.top=this.helperProportions.height-b.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var b=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])&&(b.left+=this.scrollParent.scrollLeft(),b.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&a.ui.ie)&&(b={top:0,left:0}),{top:b.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:b.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var a=this.currentItem.position();return{top:a.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:a.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var b,c,d,e=this.options;"parent"===e.containment&&(e.containment=this.helper[0].parentNode),"document"!==e.containment&&"window"!==e.containment||(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===e.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===e.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(e.containment)||(b=a(e.containment)[0],c=a(e.containment).offset(),d="hidden"!==a(b).css("overflow"),this.containment=[c.left+(parseInt(a(b).css("borderLeftWidth"),10)||0)+(parseInt(a(b).css("paddingLeft"),10)||0)-this.margins.left,c.top+(parseInt(a(b).css("borderTopWidth"),10)||0)+(parseInt(a(b).css("paddingTop"),10)||0)-this.margins.top,c.left+(d?Math.max(b.scrollWidth,b.offsetWidth):b.offsetWidth)-(parseInt(a(b).css("borderLeftWidth"),10)||0)-(parseInt(a(b).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,c.top+(d?Math.max(b.scrollHeight,b.offsetHeight):b.offsetHeight)-(parseInt(a(b).css("borderTopWidth"),10)||0)-(parseInt(a(b).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(b,c){c||(c=this.position);var d="absolute"===b?1:-1,e="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,f=/(html|body)/i.test(e[0].tagName);return{top:c.top+this.offset.relative.top*d+this.offset.parent.top*d-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():f?0:e.scrollTop())*d,left:c.left+this.offset.relative.left*d+this.offset.parent.left*d-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():f?0:e.scrollLeft())*d}},_generatePosition:function(b){var c,d,e=this.options,f=b.pageX,g=b.pageY,h="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&a.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,i=/(html|body)/i.test(h[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(b.pageX-this.offset.click.left<this.containment[0]&&(f=this.containment[0]+this.offset.click.left),b.pageY-this.offset.click.top<this.containment[1]&&(g=this.containment[1]+this.offset.click.top),b.pageX-this.offset.click.left>this.containment[2]&&(f=this.containment[2]+this.offset.click.left),b.pageY-this.offset.click.top>this.containment[3]&&(g=this.containment[3]+this.offset.click.top)),e.grid&&(c=this.originalPageY+Math.round((g-this.originalPageY)/e.grid[1])*e.grid[1],g=this.containment?c-this.offset.click.top>=this.containment[1]&&c-this.offset.click.top<=this.containment[3]?c:c-this.offset.click.top>=this.containment[1]?c-e.grid[1]:c+e.grid[1]:c,d=this.originalPageX+Math.round((f-this.originalPageX)/e.grid[0])*e.grid[0],f=this.containment?d-this.offset.click.left>=this.containment[0]&&d-this.offset.click.left<=this.containment[2]?d:d-this.offset.click.left>=this.containment[0]?d-e.grid[0]:d+e.grid[0]:d)),{top:g-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():i?0:h.scrollTop()),left:f-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():i?0:h.scrollLeft())}},_rearrange:function(a,b,c,d){c?c[0].appendChild(this.placeholder[0]):b.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?b.item[0]:b.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var e=this.counter;this._delay(function(){e===this.counter&&this.refreshPositions(!d)})},_clear:function(a,b){this.reverting=!1;var c,d=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(c in this._storedCSS)"auto"!==this._storedCSS[c]&&"static"!==this._storedCSS[c]||(this._storedCSS[c]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();this.fromOutside&&!b&&d.push(function(a){this._trigger("receive",a,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||b||d.push(function(a){this._trigger("update",a,this._uiHash())}),this!==this.currentContainer&&(b||(d.push(function(a){this._trigger("remove",a,this._uiHash())}),d.push(function(a){return function(b){a._trigger("receive",b,this._uiHash(this))}}.call(this,this.currentContainer)),d.push(function(a){return function(b){a._trigger("update",b,this._uiHash(this))}}.call(this,this.currentContainer))));function e(a,b,c){return function(d){c._trigger(a,d,b._uiHash(b))}}for(c=this.containers.length-1;c>=0;c--)b||d.push(e("deactivate",this,this.containers[c])),this.containers[c].containerCache.over&&(d.push(e("out",this,this.containers[c])),this.containers[c].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,b||this._trigger("beforeStop",a,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!b){for(c=0;c<d.length;c++)d[c].call(this,a);this._trigger("stop",a,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){a.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(b){var c=b||this;return{helper:c.helper,placeholder:c.placeholder||a([]),position:c.position,originalPosition:c.originalPosition,offset:c.positionAbs,item:c.currentItem,sender:b?b.element:null}}});function oa(a){return function(){var b=this.element.val();a.apply(this,arguments),this._refresh(),b!==this.element.val()&&this._trigger("change")}}a.widget("ui.spinner",{version:"1.12.0",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var b=this._super(),c=this.element;return a.each(["min","max","step"],function(a,d){var e=c.attr(d);null!=e&&e.length&&(b[d]=e)}),b},_events:{keydown:function(a){this._start(a)&&this._keydown(a)&&a.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(a){return this.cancelBlur?void delete this.cancelBlur:(this._stop(),this._refresh(),void(this.previous!==this.element.val()&&this._trigger("change",a)))},mousewheel:function(a,b){if(b){if(!this.spinning&&!this._start(a))return!1;this._spin((b>0?1:-1)*this.options.step,a),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(a)},100),a.preventDefault()}},"mousedown .ui-spinner-button":function(b){var c;c=this.element[0]===a.ui.safeActiveElement(this.document[0])?this.previous:this.element.val();function d(){var b=this.element[0]===a.ui.safeActiveElement(this.document[0]);b||(this.element.trigger("focus"),this.previous=c,this._delay(function(){this.previous=c}))}b.preventDefault(),d.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,d.call(this)}),this._start(b)!==!1&&this._repeat(null,a(b.currentTarget).hasClass("ui-spinner-up")?1:-1,b)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(b){if(a(b.currentTarget).hasClass("ui-state-active"))return this._start(b)!==!1&&void this._repeat(null,a(b.currentTarget).hasClass("ui-spinner-up")?1:-1,b)},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&this.uiSpinner.height()>0&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(b){var c=this.options,d=a.ui.keyCode;switch(b.keyCode){case d.UP:return this._repeat(null,1,b),!0;case d.DOWN:return this._repeat(null,-1,b),!0;case d.PAGE_UP:return this._repeat(null,c.page,b),!0;case d.PAGE_DOWN:return this._repeat(null,-c.page,b),!0}return!1},_start:function(a){return!(!this.spinning&&this._trigger("start",a)===!1)&&(this.counter||(this.counter=1),this.spinning=!0,!0)},_repeat:function(a,b,c){a=a||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,b,c)},a),this._spin(b*this.options.step,c)},_spin:function(a,b){var c=this.value()||0;this.counter||(this.counter=1),c=this._adjustValue(c+a*this._increment(this.counter)),this.spinning&&this._trigger("spin",b,{value:c})===!1||(this._value(c),this.counter++)},_increment:function(b){var c=this.options.incremental;return c?a.isFunction(c)?c(b):Math.floor(b*b*b/5e4-b*b/500+17*b/200+1):1},_precision:function(){var a=this._precisionOf(this.options.step);return null!==this.options.min&&(a=Math.max(a,this._precisionOf(this.options.min))),a},_precisionOf:function(a){var b=a.toString(),c=b.indexOf(".");return c===-1?0:b.length-c-1},_adjustValue:function(a){var b,c,d=this.options;return b=null!==d.min?d.min:0,c=a-b,c=Math.round(c/d.step)*d.step,a=b+c,a=parseFloat(a.toFixed(this._precision())),null!==d.max&&a>d.max?d.max:null!==d.min&&a<d.min?d.min:a},_stop:function(a){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",a))},_setOption:function(a,b){var c,d,e;return"culture"===a||"numberFormat"===a?(c=this._parse(this.element.val()),this.options[a]=b,void this.element.val(this._format(c))):("max"!==a&&"min"!==a&&"step"!==a||"string"==typeof b&&(b=this._parse(b)),"icons"===a&&(d=this.buttons.first().find(".ui-icon"),this._removeClass(d,null,this.options.icons.up),this._addClass(d,null,b.up),e=this.buttons.last().find(".ui-icon"),this._removeClass(e,null,this.options.icons.down),this._addClass(e,null,b.down)),void this._super(a,b))},_setOptionDisabled:function(a){this._super(a),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!a),this.element.prop("disabled",!!a),this.buttons.button(a?"disable":"enable")},_setOptions:oa(function(a){this._super(a)}),_parse:function(a){return"string"==typeof a&&""!==a&&(a=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(a,10,this.options.culture):+a),""===a||isNaN(a)?null:a},_format:function(a){return""===a?"":window.Globalize&&this.options.numberFormat?Globalize.format(a,this.options.numberFormat,this.options.culture):a},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var a=this.value();return null!==a&&a===this._adjustValue(a)},_value:function(a,b){var c;""!==a&&(c=this._parse(a),null!==c&&(b||(c=this._adjustValue(c)),a=this._format(c))),this.element.val(a),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:oa(function(a){this._stepUp(a)}),_stepUp:function(a){this._start()&&(this._spin((a||1)*this.options.step),this._stop())},stepDown:oa(function(a){
this._stepDown(a)}),_stepDown:function(a){this._start()&&(this._spin((a||1)*-this.options.step),this._stop())},pageUp:oa(function(a){this._stepUp((a||1)*this.options.page)}),pageDown:oa(function(a){this._stepDown((a||1)*this.options.page)}),value:function(a){return arguments.length?void oa(this._value).call(this,a):this._parse(this.element.val())},widget:function(){return this.uiSpinner}}),a.uiBackCompat!==!1&&a.widget("ui.spinner",a.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}});var pa=a.ui.spinner;a.widget("ui.tabs",{version:"1.12.0",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var a=/#.*$/;return function(b){var c,d;c=b.href.replace(a,""),d=location.href.replace(a,"");try{c=decodeURIComponent(c)}catch(a){}try{d=decodeURIComponent(d)}catch(a){}return b.hash.length>1&&c===d}}(),_create:function(){var b=this,c=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,c.collapsible),this._processTabs(),c.active=this._initialActive(),a.isArray(c.disabled)&&(c.disabled=a.unique(c.disabled.concat(a.map(this.tabs.filter(".ui-state-disabled"),function(a){return b.tabs.index(a)}))).sort()),this.options.active!==!1&&this.anchors.length?this.active=this._findActive(c.active):this.active=a(),this._refresh(),this.active.length&&this.load(c.active)},_initialActive:function(){var b=this.options.active,c=this.options.collapsible,d=location.hash.substring(1);return null===b&&(d&&this.tabs.each(function(c,e){if(a(e).attr("aria-controls")===d)return b=c,!1}),null===b&&(b=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),null!==b&&b!==-1||(b=!!this.tabs.length&&0)),b!==!1&&(b=this.tabs.index(this.tabs.eq(b)),b===-1&&(b=!c&&0)),!c&&b===!1&&this.anchors.length&&(b=0),b},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):a()}},_tabKeydown:function(b){var c=a(a.ui.safeActiveElement(this.document[0])).closest("li"),d=this.tabs.index(c),e=!0;if(!this._handlePageNav(b)){switch(b.keyCode){case a.ui.keyCode.RIGHT:case a.ui.keyCode.DOWN:d++;break;case a.ui.keyCode.UP:case a.ui.keyCode.LEFT:e=!1,d--;break;case a.ui.keyCode.END:d=this.anchors.length-1;break;case a.ui.keyCode.HOME:d=0;break;case a.ui.keyCode.SPACE:return b.preventDefault(),clearTimeout(this.activating),void this._activate(d);case a.ui.keyCode.ENTER:return b.preventDefault(),clearTimeout(this.activating),void this._activate(d!==this.options.active&&d);default:return}b.preventDefault(),clearTimeout(this.activating),d=this._focusNextTab(d,e),b.ctrlKey||b.metaKey||(c.attr("aria-selected","false"),this.tabs.eq(d).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",d)},this.delay))}},_panelKeydown:function(b){this._handlePageNav(b)||b.ctrlKey&&b.keyCode===a.ui.keyCode.UP&&(b.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(b){return b.altKey&&b.keyCode===a.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):b.altKey&&b.keyCode===a.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(b,c){var d=this.tabs.length-1;function e(){return b>d&&(b=0),b<0&&(b=d),b}while(a.inArray(e(),this.options.disabled)!==-1)b=c?b+1:b-1;return b},_focusNextTab:function(a,b){return a=this._findNextTab(a,b),this.tabs.eq(a).trigger("focus"),a},_setOption:function(a,b){return"active"===a?void this._activate(b):(this._super(a,b),"collapsible"===a&&(this._toggleClass("ui-tabs-collapsible",null,b),b||this.options.active!==!1||this._activate(0)),"event"===a&&this._setupEvents(b),void("heightStyle"===a&&this._setupHeightStyle(b)))},_sanitizeSelector:function(a){return a?a.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var b=this.options,c=this.tablist.children(":has(a[href])");b.disabled=a.map(c.filter(".ui-state-disabled"),function(a){return c.index(a)}),this._processTabs(),b.active!==!1&&this.anchors.length?this.active.length&&!a.contains(this.tablist[0],this.active[0])?this.tabs.length===b.disabled.length?(b.active=!1,this.active=a()):this._activate(this._findNextTab(Math.max(0,b.active-1),!1)):b.active=this.tabs.index(this.active):(b.active=!1,this.active=a()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var b=this,c=this.tabs,d=this.anchors,e=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(b){a(this).is(".ui-state-disabled")&&b.preventDefault()}).on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){a(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return a("a",this)[0]}).attr({role:"presentation",tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=a(),this.anchors.each(function(c,d){var e,f,g,h=a(d).uniqueId().attr("id"),i=a(d).closest("li"),j=i.attr("aria-controls");b._isLocal(d)?(e=d.hash,g=e.substring(1),f=b.element.find(b._sanitizeSelector(e))):(g=i.attr("aria-controls")||a({}).uniqueId()[0].id,e="#"+g,f=b.element.find(e),f.length||(f=b._createPanel(g),f.insertAfter(b.panels[c-1]||b.tablist)),f.attr("aria-live","polite")),f.length&&(b.panels=b.panels.add(f)),j&&i.data("ui-tabs-aria-controls",j),i.attr({"aria-controls":g,"aria-labelledby":h}),f.attr("aria-labelledby",h)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),c&&(this._off(c.not(this.tabs)),this._off(d.not(this.anchors)),this._off(e.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(b){return a("<div>").attr("id",b).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(b){var c,d,e;for(a.isArray(b)&&(b.length?b.length===this.anchors.length&&(b=!0):b=!1),e=0;d=this.tabs[e];e++)c=a(d),b===!0||a.inArray(e,b)!==-1?(c.attr("aria-disabled","true"),this._addClass(c,null,"ui-state-disabled")):(c.removeAttr("aria-disabled"),this._removeClass(c,null,"ui-state-disabled"));this.options.disabled=b,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,b===!0)},_setupEvents:function(b){var c={};b&&a.each(b.split(" "),function(a,b){c[b]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(a){a.preventDefault()}}),this._on(this.anchors,c),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(b){var c,d=this.element.parent();"fill"===b?(c=d.height(),c-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var b=a(this),d=b.css("position");"absolute"!==d&&"fixed"!==d&&(c-=b.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){c-=a(this).outerHeight(!0)}),this.panels.each(function(){a(this).height(Math.max(0,c-a(this).innerHeight()+a(this).height()))}).css("overflow","auto")):"auto"===b&&(c=0,this.panels.each(function(){c=Math.max(c,a(this).height("").height())}).height(c))},_eventHandler:function(b){var c=this.options,d=this.active,e=a(b.currentTarget),f=e.closest("li"),g=f[0]===d[0],h=g&&c.collapsible,i=h?a():this._getPanelForTab(f),j=d.length?this._getPanelForTab(d):a(),k={oldTab:d,oldPanel:j,newTab:h?a():f,newPanel:i};b.preventDefault(),f.hasClass("ui-state-disabled")||f.hasClass("ui-tabs-loading")||this.running||g&&!c.collapsible||this._trigger("beforeActivate",b,k)===!1||(c.active=!h&&this.tabs.index(f),this.active=g?a():f,this.xhr&&this.xhr.abort(),j.length||i.length||a.error("jQuery UI Tabs: Mismatching fragment identifier."),i.length&&this.load(this.tabs.index(f),b),this._toggle(b,k))},_toggle:function(b,c){var d=this,e=c.newPanel,f=c.oldPanel;this.running=!0;function g(){d.running=!1,d._trigger("activate",b,c)}function h(){d._addClass(c.newTab.closest("li"),"ui-tabs-active","ui-state-active"),e.length&&d.options.show?d._show(e,d.options.show,g):(e.show(),g())}f.length&&this.options.hide?this._hide(f,this.options.hide,function(){d._removeClass(c.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),h()}):(this._removeClass(c.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),f.hide(),h()),f.attr("aria-hidden","true"),c.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),e.length&&f.length?c.oldTab.attr("tabIndex",-1):e.length&&this.tabs.filter(function(){return 0===a(this).attr("tabIndex")}).attr("tabIndex",-1),e.attr("aria-hidden","false"),c.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(b){var c,d=this._findActive(b);d[0]!==this.active[0]&&(d.length||(d=this.active),c=d.find(".ui-tabs-anchor")[0],this._eventHandler({target:c,currentTarget:c,preventDefault:a.noop}))},_findActive:function(b){return b===!1?a():this.tabs.eq(b)},_getIndex:function(b){return"string"==typeof b&&(b=this.anchors.index(this.anchors.filter("[href$='"+a.ui.escapeSelector(b)+"']"))),b},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){a.data(this,"ui-tabs-destroy")?a(this).remove():a(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var b=a(this),c=b.data("ui-tabs-aria-controls");c?b.attr("aria-controls",c).removeData("ui-tabs-aria-controls"):b.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(b){var c=this.options.disabled;c!==!1&&(void 0===b?c=!1:(b=this._getIndex(b),c=a.isArray(c)?a.map(c,function(a){return a!==b?a:null}):a.map(this.tabs,function(a,c){return c!==b?c:null})),this._setOptionDisabled(c))},disable:function(b){var c=this.options.disabled;if(c!==!0){if(void 0===b)c=!0;else{if(b=this._getIndex(b),a.inArray(b,c)!==-1)return;c=a.isArray(c)?a.merge([b],c).sort():[b]}this._setOptionDisabled(c)}},load:function(b,c){b=this._getIndex(b);var d=this,e=this.tabs.eq(b),f=e.find(".ui-tabs-anchor"),g=this._getPanelForTab(e),h={tab:e,panel:g},i=function(a,b){"abort"===b&&d.panels.stop(!1,!0),d._removeClass(e,"ui-tabs-loading"),g.removeAttr("aria-busy"),a===d.xhr&&delete d.xhr};this._isLocal(f[0])||(this.xhr=a.ajax(this._ajaxSettings(f,c,h)),this.xhr&&"canceled"!==this.xhr.statusText&&(this._addClass(e,"ui-tabs-loading"),g.attr("aria-busy","true"),this.xhr.done(function(a,b,e){setTimeout(function(){g.html(a),d._trigger("load",c,h),i(e,b)},1)}).fail(function(a,b){setTimeout(function(){i(a,b)},1)})))},_ajaxSettings:function(b,c,d){var e=this;return{url:b.attr("href"),beforeSend:function(b,f){return e._trigger("beforeLoad",c,a.extend({jqXHR:b,ajaxSettings:f},d))}}},_getPanelForTab:function(b){var c=a(b).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+c))}}),a.uiBackCompat!==!1&&a.widget("ui.tabs",a.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}});var qa=a.ui.tabs;a.widget("ui.tooltip",{version:"1.12.0",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var b=a(this).attr("title")||"";return a("<a>").text(b).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(b,c){var d=(b.attr("aria-describedby")||"").split(/\s+/);d.push(c),b.data("ui-tooltip-id",c).attr("aria-describedby",a.trim(d.join(" ")))},_removeDescribedBy:function(b){var c=b.data("ui-tooltip-id"),d=(b.attr("aria-describedby")||"").split(/\s+/),e=a.inArray(c,d);e!==-1&&d.splice(e,1),b.removeData("ui-tooltip-id"),d=a.trim(d.join(" ")),d?b.attr("aria-describedby",d):b.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=a("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=a([])},_setOption:function(b,c){var d=this;this._super(b,c),"content"===b&&a.each(this.tooltips,function(a,b){d._updateContent(b.element)})},_setOptionDisabled:function(a){this[a?"_disable":"_enable"]()},_disable:function(){var b=this;a.each(this.tooltips,function(c,d){var e=a.Event("blur");e.target=e.currentTarget=d.element[0],b.close(e,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var b=a(this);if(b.is("[title]"))return b.data("ui-tooltip-title",b.attr("title")).removeAttr("title")}))},_enable:function(){this.disabledTitles.each(function(){var b=a(this);b.data("ui-tooltip-title")&&b.attr("title",b.data("ui-tooltip-title"))}),this.disabledTitles=a([])},open:function(b){var c=this,d=a(b?b.target:this.element).closest(this.options.items);d.length&&!d.data("ui-tooltip-id")&&(d.attr("title")&&d.data("ui-tooltip-title",d.attr("title")),d.data("ui-tooltip-open",!0),b&&"mouseover"===b.type&&d.parents().each(function(){var b=a(this),d;b.data("ui-tooltip-open")&&(d=a.Event("blur"),d.target=d.currentTarget=this,c.close(d,!0)),b.attr("title")&&(b.uniqueId(),c.parents[this.id]={element:this,title:b.attr("title")},b.attr("title",""))}),this._registerCloseHandlers(b,d),this._updateContent(d,b))},_updateContent:function(a,b){var c,d=this.options.content,e=this,f=b?b.type:null;return"string"==typeof d||d.nodeType||d.jquery?this._open(b,a,d):(c=d.call(a[0],function(c){e._delay(function(){a.data("ui-tooltip-open")&&(b&&(b.type=f),this._open(b,a,c))})}),void(c&&this._open(b,a,c)))},_open:function(b,c,d){var e,f,g,h,i=a.extend({},this.options.position);function j(a){i.of=a,f.is(":hidden")||f.position(i)}if(d){if(e=this._find(c))return void e.tooltip.find(".ui-tooltip-content").html(d);c.is("[title]")&&(b&&"mouseover"===b.type?c.attr("title",""):c.removeAttr("title")),e=this._tooltip(c),f=e.tooltip,this._addDescribedBy(c,f.attr("id")),f.find(".ui-tooltip-content").html(d),this.liveRegion.children().hide(),h=a("<div>").html(f.find(".ui-tooltip-content").html()),h.removeAttr("name").find("[name]").removeAttr("name"),h.removeAttr("id").find("[id]").removeAttr("id"),h.appendTo(this.liveRegion),this.options.track&&b&&/^mouse/.test(b.type)?(this._on(this.document,{mousemove:j}),j(b)):f.position(a.extend({of:c},this.options.position)),f.hide(),this._show(f,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(g=this.delayedShow=setInterval(function(){f.is(":visible")&&(j(i.of),clearInterval(g))},a.fx.interval)),this._trigger("open",b,{tooltip:f})}},_registerCloseHandlers:function(b,c){var d={keyup:function(b){if(b.keyCode===a.ui.keyCode.ESCAPE){var d=a.Event(b);d.currentTarget=c[0],this.close(d,!0)}}};c[0]!==this.element[0]&&(d.remove=function(){this._removeTooltip(this._find(c).tooltip)}),b&&"mouseover"!==b.type||(d.mouseleave="close"),b&&"focusin"!==b.type||(d.focusout="close"),this._on(!0,c,d)},close:function(b){var c,d=this,e=a(b?b.currentTarget:this.element),f=this._find(e);return f?(c=f.tooltip,void(f.closing||(clearInterval(this.delayedShow),e.data("ui-tooltip-title")&&!e.attr("title")&&e.attr("title",e.data("ui-tooltip-title")),this._removeDescribedBy(e),f.hiding=!0,c.stop(!0),this._hide(c,this.options.hide,function(){d._removeTooltip(a(this))}),e.removeData("ui-tooltip-open"),this._off(e,"mouseleave focusout keyup"),e[0]!==this.element[0]&&this._off(e,"remove"),this._off(this.document,"mousemove"),b&&"mouseleave"===b.type&&a.each(this.parents,function(b,c){a(c.element).attr("title",c.title),delete d.parents[b]}),f.closing=!0,this._trigger("close",b,{tooltip:c}),f.hiding||(f.closing=!1)))):void e.removeData("ui-tooltip-open")},_tooltip:function(b){var c=a("<div>").attr("role","tooltip"),d=a("<div>").appendTo(c),e=c.uniqueId().attr("id");return this._addClass(d,"ui-tooltip-content"),this._addClass(c,"ui-tooltip","ui-widget ui-widget-content"),c.appendTo(this._appendTo(b)),this.tooltips[e]={element:b,tooltip:c}},_find:function(a){var b=a.data("ui-tooltip-id");return b?this.tooltips[b]:null},_removeTooltip:function(a){a.remove(),delete this.tooltips[a.attr("id")]},_appendTo:function(a){var b=a.closest(".ui-front, dialog");return b.length||(b=this.document[0].body),b},_destroy:function(){var b=this;a.each(this.tooltips,function(c,d){var e=a.Event("blur"),f=d.element;e.target=e.currentTarget=f[0],b.close(e,!0),a("#"+c).remove(),f.data("ui-tooltip-title")&&(f.attr("title")||f.attr("title",f.data("ui-tooltip-title")),f.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),a.uiBackCompat!==!1&&a.widget("ui.tooltip",a.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var a=this._superApply(arguments);return this.options.tooltipClass&&a.tooltip.addClass(this.options.tooltipClass),a}});var ra=a.ui.tooltip}),"function"!=typeof Object.create&&(Object.create=function(a){function b(){}return b.prototype=a,new b}),function(a,b,c){var d={init:function(b,c){var d=this;d.$elem=a(c),d.options=a.extend({},a.fn.owlCarousel.options,d.$elem.data(),b),d.userOptions=b,d.loadContent()},loadContent:function(){var b=this,c;function d(a){var c,d="";if("function"==typeof b.options.jsonSuccess)b.options.jsonSuccess.apply(this,[a]);else{for(c in a.owl)a.owl.hasOwnProperty(c)&&(d+=a.owl[c].item);b.$elem.html(d)}b.logIn()}"function"==typeof b.options.beforeInit&&b.options.beforeInit.apply(this,[b.$elem]),"string"==typeof b.options.jsonPath?(c=b.options.jsonPath,a.getJSON(c,d)):b.logIn()},logIn:function(){var a=this;a.$elem.data("owl-originalStyles",a.$elem.attr("style")).data("owl-originalClasses",a.$elem.attr("class")),a.$elem.css({opacity:0}),a.orignalItems=a.options.items,a.checkBrowser(),a.wrapperWidth=0,a.checkVisible=null,a.setVars()},setVars:function(){var a=this;return 0!==a.$elem.children().length&&(a.baseClass(),a.eventTypes(),a.$userItems=a.$elem.children(),a.itemsAmount=a.$userItems.length,a.wrapItems(),a.$owlItems=a.$elem.find(".owl-item"),a.$owlWrapper=a.$elem.find(".owl-wrapper"),a.playDirection="next",a.prevItem=0,a.prevArr=[0],a.currentItem=0,a.customEvents(),void a.onStartup())},onStartup:function(){var a=this;a.updateItems(),a.calculateAll(),a.buildControls(),a.updateControls(),a.response(),a.moveEvents(),a.stopOnHover(),a.owlStatus(),a.options.transitionStyle!==!1&&a.transitionTypes(a.options.transitionStyle),a.options.autoPlay===!0&&(a.options.autoPlay=5e3),a.play(),a.$elem.find(".owl-wrapper").css("display","block"),a.$elem.is(":visible")?a.$elem.css("opacity",1):a.watchVisibility(),a.onstartup=!1,a.eachMoveUpdate(),"function"==typeof a.options.afterInit&&a.options.afterInit.apply(this,[a.$elem])},eachMoveUpdate:function(){var a=this;a.options.lazyLoad===!0&&a.lazyLoad(),a.options.autoHeight===!0&&a.autoHeight(),a.onVisibleItems(),"function"==typeof a.options.afterAction&&a.options.afterAction.apply(this,[a.$elem])},updateVars:function(){var a=this;"function"==typeof a.options.beforeUpdate&&a.options.beforeUpdate.apply(this,[a.$elem]),a.watchVisibility(),a.updateItems(),a.calculateAll(),a.updatePosition(),a.updateControls(),a.eachMoveUpdate(),"function"==typeof a.options.afterUpdate&&a.options.afterUpdate.apply(this,[a.$elem])},reload:function(){var a=this;b.setTimeout(function(){a.updateVars()},0)},watchVisibility:function(){var a=this;return a.$elem.is(":visible")===!1&&(a.$elem.css({opacity:0}),b.clearInterval(a.autoPlayInterval),b.clearInterval(a.checkVisible),void(a.checkVisible=b.setInterval(function(){a.$elem.is(":visible")&&(a.reload(),a.$elem.animate({opacity:1},200),b.clearInterval(a.checkVisible))},500)))},wrapItems:function(){var a=this;a.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),a.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),a.wrapperOuter=a.$elem.find(".owl-wrapper-outer"),a.$elem.css("display","block")},baseClass:function(){var a=this,b=a.$elem.hasClass(a.options.baseClass),c=a.$elem.hasClass(a.options.theme);b||a.$elem.addClass(a.options.baseClass),c||a.$elem.addClass(a.options.theme)},updateItems:function(){var b=this,c,d;if(b.options.responsive===!1)return!1;if(b.options.singleItem===!0)return b.options.items=b.orignalItems=1,b.options.itemsCustom=!1,b.options.itemsDesktop=!1,b.options.itemsDesktopSmall=!1,b.options.itemsTablet=!1,b.options.itemsTabletSmall=!1,b.options.itemsMobile=!1,!1;if(c=a(b.options.responsiveBaseWidth).width(),c>(b.options.itemsDesktop[0]||b.orignalItems)&&(b.options.items=b.orignalItems),b.options.itemsCustom!==!1)for(b.options.itemsCustom.sort(function(a,b){return a[0]-b[0]}),d=0;d<b.options.itemsCustom.length;d+=1)b.options.itemsCustom[d][0]<=c&&(b.options.items=b.options.itemsCustom[d][1]);else c<=b.options.itemsDesktop[0]&&b.options.itemsDesktop!==!1&&(b.options.items=b.options.itemsDesktop[1]),c<=b.options.itemsDesktopSmall[0]&&b.options.itemsDesktopSmall!==!1&&(b.options.items=b.options.itemsDesktopSmall[1]),c<=b.options.itemsTablet[0]&&b.options.itemsTablet!==!1&&(b.options.items=b.options.itemsTablet[1]),c<=b.options.itemsTabletSmall[0]&&b.options.itemsTabletSmall!==!1&&(b.options.items=b.options.itemsTabletSmall[1]),c<=b.options.itemsMobile[0]&&b.options.itemsMobile!==!1&&(b.options.items=b.options.itemsMobile[1]);b.options.items>b.itemsAmount&&b.options.itemsScaleUp===!0&&(b.options.items=b.itemsAmount)},response:function(){var c=this,d,e;return c.options.responsive===!0&&(e=a(b).width(),c.resizer=function(){a(b).width()!==e&&(c.options.autoPlay!==!1&&b.clearInterval(c.autoPlayInterval),b.clearTimeout(d),d=b.setTimeout(function(){e=a(b).width(),c.updateVars()},c.options.responsiveRefreshRate))},void a(b).resize(c.resizer))},updatePosition:function(){var a=this;a.jumpTo(a.currentItem),a.options.autoPlay!==!1&&a.checkAp()},appendItemsSizes:function(){var b=this,c=0,d=b.itemsAmount-b.options.items;b.$owlItems.each(function(e){var f=a(this);f.css({width:b.itemWidth}).data("owl-item",Number(e)),e%b.options.items!==0&&e!==d||e>d||(c+=1),f.data("owl-roundPages",c)})},appendWrapperSizes:function(){var a=this,b=a.$owlItems.length*a.itemWidth;a.$owlWrapper.css({width:2*b,left:0}),a.appendItemsSizes()},calculateAll:function(){var a=this;a.calculateWidth(),a.appendWrapperSizes(),a.loops(),a.max()},calculateWidth:function(){var a=this;a.itemWidth=Math.round(a.$elem.width()/a.options.items)},max:function(){var a=this,b=(a.itemsAmount*a.itemWidth-a.options.items*a.itemWidth)*-1;return a.options.items>a.itemsAmount?(a.maximumItem=0,b=0,a.maximumPixels=0):(a.maximumItem=a.itemsAmount-a.options.items,a.maximumPixels=b),b},min:function(){return 0},loops:function(){var b=this,c=0,d=0,e,f,g;for(b.positionsInArray=[0],b.pagesInArray=[],e=0;e<b.itemsAmount;e+=1)d+=b.itemWidth,b.positionsInArray.push(-d),b.options.scrollPerPage===!0&&(f=a(b.$owlItems[e]),g=f.data("owl-roundPages"),g!==c&&(b.pagesInArray[c]=b.positionsInArray[e],c=g))},buildControls:function(){var b=this;b.options.navigation!==!0&&b.options.pagination!==!0||(b.owlControls=a('<div class="owl-controls"/>').toggleClass("clickable",!b.browser.isTouch).appendTo(b.$elem)),b.options.pagination===!0&&b.buildPagination(),b.options.navigation===!0&&b.buildButtons()},buildButtons:function(){var b=this,c=a('<div class="owl-buttons"/>');b.owlControls.append(c),b.buttonPrev=a("<div/>",{class:"owl-prev",html:b.options.navigationText[0]||""}),b.buttonNext=a("<div/>",{class:"owl-next",html:b.options.navigationText[1]||""}),c.append(b.buttonPrev).append(b.buttonNext),c.on("touchstart.owlControls mousedown.owlControls",'div[class^="owl"]',function(a){a.preventDefault()}),c.on("touchend.owlControls mouseup.owlControls",'div[class^="owl"]',function(c){c.preventDefault(),a(this).hasClass("owl-next")?b.next():b.prev()})},buildPagination:function(){var b=this;b.paginationWrapper=a('<div class="owl-pagination"/>'),b.owlControls.append(b.paginationWrapper),b.paginationWrapper.on("touchend.owlControls mouseup.owlControls",".owl-page",function(c){c.preventDefault(),Number(a(this).data("owl-page"))!==b.currentItem&&b.goTo(Number(a(this).data("owl-page")),!0)})},updatePagination:function(){var b=this,c,d,e,f,g,h;if(b.options.pagination===!1)return!1;for(b.paginationWrapper.html(""),c=0,d=b.itemsAmount-b.itemsAmount%b.options.items,f=0;f<b.itemsAmount;f+=1)f%b.options.items===0&&(c+=1,d===f&&(e=b.itemsAmount-b.options.items),g=a("<div/>",{class:"owl-page"}),h=a("<span></span>",{text:b.options.paginationNumbers===!0?c:"",class:b.options.paginationNumbers===!0?"owl-numbers":""}),g.append(h),g.data("owl-page",d===f?e:f),g.data("owl-roundPages",c),b.paginationWrapper.append(g));b.checkPagination()},checkPagination:function(){var b=this;return b.options.pagination!==!1&&void b.paginationWrapper.find(".owl-page").each(function(){a(this).data("owl-roundPages")===a(b.$owlItems[b.currentItem]).data("owl-roundPages")&&(b.paginationWrapper.find(".owl-page").removeClass("active"),a(this).addClass("active"))})},checkNavigation:function(){var a=this;return a.options.navigation!==!1&&void(a.options.rewindNav===!1&&(0===a.currentItem&&0===a.maximumItem?(a.buttonPrev.addClass("disabled"),a.buttonNext.addClass("disabled")):0===a.currentItem&&0!==a.maximumItem?(a.buttonPrev.addClass("disabled"),a.buttonNext.removeClass("disabled")):a.currentItem===a.maximumItem?(a.buttonPrev.removeClass("disabled"),a.buttonNext.addClass("disabled")):0!==a.currentItem&&a.currentItem!==a.maximumItem&&(a.buttonPrev.removeClass("disabled"),a.buttonNext.removeClass("disabled"))))},updateControls:function(){var a=this;a.updatePagination(),a.checkNavigation(),a.owlControls&&(a.options.items>=a.itemsAmount?a.owlControls.hide():a.owlControls.show())},destroyControls:function(){var a=this;a.owlControls&&a.owlControls.remove()},next:function(a){var b=this;if(b.isTransition)return!1;if(b.currentItem+=b.options.scrollPerPage===!0?b.options.items:1,b.currentItem>b.maximumItem+(b.options.scrollPerPage===!0?b.options.items-1:0)){if(b.options.rewindNav!==!0)return b.currentItem=b.maximumItem,!1;b.currentItem=0,a="rewind"}b.goTo(b.currentItem,a)},prev:function(a){var b=this;if(b.isTransition)return!1;if(b.options.scrollPerPage===!0&&b.currentItem>0&&b.currentItem<b.options.items?b.currentItem=0:b.currentItem-=b.options.scrollPerPage===!0?b.options.items:1,b.currentItem<0){if(b.options.rewindNav!==!0)return b.currentItem=0,!1;b.currentItem=b.maximumItem,a="rewind"}b.goTo(b.currentItem,a)},goTo:function(a,c,d){var e=this,f;return!e.isTransition&&("function"==typeof e.options.beforeMove&&e.options.beforeMove.apply(this,[e.$elem]),a>=e.maximumItem?a=e.maximumItem:a<=0&&(a=0),e.currentItem=e.owl.currentItem=a,e.options.transitionStyle!==!1&&"drag"!==d&&1===e.options.items&&e.browser.support3d===!0?(e.swapSpeed(0),e.browser.support3d===!0?e.transition3d(e.positionsInArray[a]):e.css2slide(e.positionsInArray[a],1),e.afterGo(),e.singleItemTransition(),!1):(f=e.positionsInArray[a],e.browser.support3d===!0?(e.isCss3Finish=!1,c===!0?(e.swapSpeed("paginationSpeed"),b.setTimeout(function(){e.isCss3Finish=!0},e.options.paginationSpeed)):"rewind"===c?(e.swapSpeed(e.options.rewindSpeed),b.setTimeout(function(){e.isCss3Finish=!0},e.options.rewindSpeed)):(e.swapSpeed("slideSpeed"),b.setTimeout(function(){e.isCss3Finish=!0},e.options.slideSpeed)),e.transition3d(f)):c===!0?e.css2slide(f,e.options.paginationSpeed):"rewind"===c?e.css2slide(f,e.options.rewindSpeed):e.css2slide(f,e.options.slideSpeed),void e.afterGo()))},jumpTo:function(a){var b=this;"function"==typeof b.options.beforeMove&&b.options.beforeMove.apply(this,[b.$elem]),a>=b.maximumItem||a===-1?a=b.maximumItem:a<=0&&(a=0),b.swapSpeed(0),b.browser.support3d===!0?b.transition3d(b.positionsInArray[a]):b.css2slide(b.positionsInArray[a],1),b.currentItem=b.owl.currentItem=a,b.afterGo()},afterGo:function(){var a=this;a.prevArr.push(a.currentItem),a.prevItem=a.owl.prevItem=a.prevArr[a.prevArr.length-2],a.prevArr.shift(0),a.prevItem!==a.currentItem&&(a.checkPagination(),a.checkNavigation(),a.eachMoveUpdate(),a.options.autoPlay!==!1&&a.checkAp()),"function"==typeof a.options.afterMove&&a.prevItem!==a.currentItem&&a.options.afterMove.apply(this,[a.$elem])},stop:function(){var a=this;a.apStatus="stop",b.clearInterval(a.autoPlayInterval)},checkAp:function(){var a=this;"stop"!==a.apStatus&&a.play()},play:function(){var a=this;return a.apStatus="play",a.options.autoPlay!==!1&&(b.clearInterval(a.autoPlayInterval),void(a.autoPlayInterval=b.setInterval(function(){a.next(!0)},a.options.autoPlay)))},swapSpeed:function(a){var b=this;"slideSpeed"===a?b.$owlWrapper.css(b.addCssSpeed(b.options.slideSpeed)):"paginationSpeed"===a?b.$owlWrapper.css(b.addCssSpeed(b.options.paginationSpeed)):"string"!=typeof a&&b.$owlWrapper.css(b.addCssSpeed(a))},addCssSpeed:function(a){return{"-webkit-transition":"all "+a+"ms ease","-moz-transition":"all "+a+"ms ease","-o-transition":"all "+a+"ms ease",transition:"all "+a+"ms ease"}},removeTransition:function(){return{"-webkit-transition":"","-moz-transition":"","-o-transition":"",transition:""}},doTranslate:function(a){return{"-webkit-transform":"translate3d("+a+"px, 0px, 0px)","-moz-transform":"translate3d("+a+"px, 0px, 0px)","-o-transform":"translate3d("+a+"px, 0px, 0px)","-ms-transform":"translate3d("+a+"px, 0px, 0px)",transform:"translate3d("+a+"px, 0px,0px)"}},transition3d:function(a){var b=this;b.$owlWrapper.css(b.doTranslate(a))},css2move:function(a){var b=this;b.$owlWrapper.css({left:a})},css2slide:function(a,b){var c=this;c.isCssFinish=!1,c.$owlWrapper.stop(!0,!0).animate({left:a},{duration:b||c.options.slideSpeed,complete:function(){c.isCssFinish=!0}})},checkBrowser:function(){var a=this,d="translate3d(0px, 0px, 0px)",e=c.createElement("div"),f,g,h,i;e.style.cssText="  -moz-transform:"+d+"; -ms-transform:"+d+"; -o-transform:"+d+"; -webkit-transform:"+d+"; transform:"+d,f=/translate3d\(0px, 0px, 0px\)/g,g=e.style.cssText.match(f),h=null!==g&&1===g.length,i="ontouchstart"in b||b.navigator.msMaxTouchPoints,a.browser={support3d:h,isTouch:i}},moveEvents:function(){var a=this;a.options.mouseDrag===!1&&a.options.touchDrag===!1||(a.gestures(),a.disabledEvents())},eventTypes:function(){var a=this,b=["s","e","x"];a.ev_types={},a.options.mouseDrag===!0&&a.options.touchDrag===!0?b=["touchstart.owl mousedown.owl","touchmove.owl mousemove.owl","touchend.owl touchcancel.owl mouseup.owl"]:a.options.mouseDrag===!1&&a.options.touchDrag===!0?b=["touchstart.owl","touchmove.owl","touchend.owl touchcancel.owl"]:a.options.mouseDrag===!0&&a.options.touchDrag===!1&&(b=["mousedown.owl","mousemove.owl","mouseup.owl"]),a.ev_types.start=b[0],a.ev_types.move=b[1],a.ev_types.end=b[2];
},disabledEvents:function(){var b=this;b.$elem.on("dragstart.owl",function(a){a.preventDefault()}),b.$elem.on("mousedown.disableTextSelect",function(b){return a(b.target).is("input, textarea, select, option")})},gestures:function(){var d=this,e={offsetX:0,offsetY:0,baseElWidth:0,relativePos:0,position:null,minSwipe:null,maxSwipe:null,sliding:null,dargging:null,targetElement:null};d.isCssFinish=!0;function f(a){if(void 0!==a.touches)return{x:a.touches[0].pageX,y:a.touches[0].pageY};if(void 0===a.touches){if(void 0!==a.pageX)return{x:a.pageX,y:a.pageY};if(void 0===a.pageX)return{x:a.clientX,y:a.clientY}}}function g(b){"on"===b?(a(c).on(d.ev_types.move,i),a(c).on(d.ev_types.end,j)):"off"===b&&(a(c).off(d.ev_types.move),a(c).off(d.ev_types.end))}function h(c){var h=c.originalEvent||c||b.event,i;if(3===h.which)return!1;if(!(d.itemsAmount<=d.options.items)){if(d.isCssFinish===!1&&!d.options.dragBeforeAnimFinish)return!1;if(d.isCss3Finish===!1&&!d.options.dragBeforeAnimFinish)return!1;d.options.autoPlay!==!1&&b.clearInterval(d.autoPlayInterval),d.browser.isTouch===!0||d.$owlWrapper.hasClass("grabbing")||d.$owlWrapper.addClass("grabbing"),d.newPosX=0,d.newRelativeX=0,a(this).css(d.removeTransition()),i=a(this).position(),e.relativePos=i.left,e.offsetX=f(h).x-i.left,e.offsetY=f(h).y-i.top,g("on"),e.sliding=!1,e.targetElement=h.target||h.srcElement}}function i(g){var h=g.originalEvent||g||b.event,i,j;d.newPosX=f(h).x-e.offsetX,d.newPosY=f(h).y-e.offsetY,d.newRelativeX=d.newPosX-e.relativePos,"function"==typeof d.options.startDragging&&e.dragging!==!0&&0!==d.newRelativeX&&(e.dragging=!0,d.options.startDragging.apply(d,[d.$elem])),(d.newRelativeX>8||d.newRelativeX<-8)&&d.browser.isTouch===!0&&(void 0!==h.preventDefault?h.preventDefault():h.returnValue=!1,e.sliding=!0),(d.newPosY>10||d.newPosY<-10)&&e.sliding===!1&&a(c).off("touchmove.owl"),i=function(){return d.newRelativeX/5},j=function(){return d.maximumPixels+d.newRelativeX/5},d.newPosX=Math.max(Math.min(d.newPosX,i()),j()),d.browser.support3d===!0?d.transition3d(d.newPosX):d.css2move(d.newPosX)}function j(c){var f=c.originalEvent||c||b.event,h,i,j;f.target=f.target||f.srcElement,e.dragging=!1,d.browser.isTouch!==!0&&d.$owlWrapper.removeClass("grabbing"),d.newRelativeX<0?d.dragDirection=d.owl.dragDirection="left":d.dragDirection=d.owl.dragDirection="right",0!==d.newRelativeX&&(h=d.getNewPosition(),d.goTo(h,!1,"drag"),e.targetElement===f.target&&d.browser.isTouch!==!0&&(a(f.target).on("click.disable",function(b){b.stopImmediatePropagation(),b.stopPropagation(),b.preventDefault(),a(b.target).off("click.disable")}),i=a._data(f.target,"events").click,j=i.pop(),i.splice(0,0,j))),g("off")}d.$elem.on(d.ev_types.start,".owl-wrapper",h)},getNewPosition:function(){var a=this,b=a.closestItem();return b>a.maximumItem?(a.currentItem=a.maximumItem,b=a.maximumItem):a.newPosX>=0&&(b=0,a.currentItem=0),b},closestItem:function(){var b=this,c=b.options.scrollPerPage===!0?b.pagesInArray:b.positionsInArray,d=b.newPosX,e=null;return a.each(c,function(f,g){d-b.itemWidth/20>c[f+1]&&d-b.itemWidth/20<g&&"left"===b.moveDirection()?(e=g,b.options.scrollPerPage===!0?b.currentItem=a.inArray(e,b.positionsInArray):b.currentItem=f):d+b.itemWidth/20<g&&d+b.itemWidth/20>(c[f+1]||c[f]-b.itemWidth)&&"right"===b.moveDirection()&&(b.options.scrollPerPage===!0?(e=c[f+1]||c[c.length-1],b.currentItem=a.inArray(e,b.positionsInArray)):(e=c[f+1],b.currentItem=f+1))}),b.currentItem},moveDirection:function(){var a=this,b;return a.newRelativeX<0?(b="right",a.playDirection="next"):(b="left",a.playDirection="prev"),b},customEvents:function(){var a=this;a.$elem.on("owl.next",function(){a.next()}),a.$elem.on("owl.prev",function(){a.prev()}),a.$elem.on("owl.play",function(b,c){a.options.autoPlay=c,a.play(),a.hoverStatus="play"}),a.$elem.on("owl.stop",function(){a.stop(),a.hoverStatus="stop"}),a.$elem.on("owl.goTo",function(b,c){a.goTo(c)}),a.$elem.on("owl.jumpTo",function(b,c){a.jumpTo(c)})},stopOnHover:function(){var a=this;a.options.stopOnHover===!0&&a.browser.isTouch!==!0&&a.options.autoPlay!==!1&&(a.$elem.on("mouseover",function(){a.stop()}),a.$elem.on("mouseout",function(){"stop"!==a.hoverStatus&&a.play()}))},lazyLoad:function(){var b=this,c,d,e,f,g;if(b.options.lazyLoad===!1)return!1;for(c=0;c<b.itemsAmount;c+=1)d=a(b.$owlItems[c]),"loaded"!==d.data("owl-loaded")&&(e=d.data("owl-item"),f=d.find(".lazyOwl"),"string"==typeof f.data("src")?(void 0===d.data("owl-loaded")&&(f.hide(),d.addClass("loading").data("owl-loaded","checked")),g=b.options.lazyFollow!==!0||e>=b.currentItem,g&&e<b.currentItem+b.options.items&&f.length&&b.lazyPreload(d,f)):d.data("owl-loaded","loaded"))},lazyPreload:function(a,c){var d=this,e=0,f;"DIV"===c.prop("tagName")?(c.css("background-image","url("+c.data("src")+")"),f=!0):c[0].src=c.data("src");function g(){a.data("owl-loaded","loaded").removeClass("loading"),c.removeAttr("data-src"),"fade"===d.options.lazyEffect?c.fadeIn(400):c.show(),"function"==typeof d.options.afterLazyLoad&&d.options.afterLazyLoad.apply(this,[d.$elem])}function h(){e+=1,d.completeImg(c.get(0))||f===!0?g():e<=100?b.setTimeout(h,100):g()}h()},autoHeight:function(){var c=this,d=a(c.$owlItems[c.currentItem]).find("img"),e;function f(){var d=a(c.$owlItems[c.currentItem]).height();c.wrapperOuter.css("height",d+"px"),c.wrapperOuter.hasClass("autoHeight")||b.setTimeout(function(){c.wrapperOuter.addClass("autoHeight")},0)}function g(){e+=1,c.completeImg(d.get(0))?f():e<=100?b.setTimeout(g,100):c.wrapperOuter.css("height","")}void 0!==d.get(0)?(e=0,g()):f()},completeImg:function(a){var b;return!!a.complete&&(b=typeof a.naturalWidth,"undefined"===b||0!==a.naturalWidth)},onVisibleItems:function(){var b=this,c;for(b.options.addClassActive===!0&&b.$owlItems.removeClass("active"),b.visibleItems=[],c=b.currentItem;c<b.currentItem+b.options.items;c+=1)b.visibleItems.push(c),b.options.addClassActive===!0&&a(b.$owlItems[c]).addClass("active");b.owl.visibleItems=b.visibleItems},transitionTypes:function(a){var b=this;b.outClass="owl-"+a+"-out",b.inClass="owl-"+a+"-in"},singleItemTransition:function(){var a=this,b=a.outClass,c=a.inClass,d=a.$owlItems.eq(a.currentItem),e=a.$owlItems.eq(a.prevItem),f=Math.abs(a.positionsInArray[a.currentItem])+a.positionsInArray[a.prevItem],g=Math.abs(a.positionsInArray[a.currentItem])+a.itemWidth/2,h="webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";a.isTransition=!0,a.$owlWrapper.addClass("owl-origin").css({"-webkit-transform-origin":g+"px","-moz-perspective-origin":g+"px","perspective-origin":g+"px"});function i(a){return{position:"relative",left:a+"px"}}e.css(i(f,10)).addClass(b).on(h,function(){a.endPrev=!0,e.off(h),a.clearTransStyle(e,b)}),d.addClass(c).on(h,function(){a.endCurrent=!0,d.off(h),a.clearTransStyle(d,c)})},clearTransStyle:function(a,b){var c=this;a.css({position:"",left:""}).removeClass(b),c.endPrev&&c.endCurrent&&(c.$owlWrapper.removeClass("owl-origin"),c.endPrev=!1,c.endCurrent=!1,c.isTransition=!1)},owlStatus:function(){var a=this;a.owl={userOptions:a.userOptions,baseElement:a.$elem,userItems:a.$userItems,owlItems:a.$owlItems,currentItem:a.currentItem,prevItem:a.prevItem,visibleItems:a.visibleItems,isTouch:a.browser.isTouch,browser:a.browser,dragDirection:a.dragDirection}},clearEvents:function(){var d=this;d.$elem.off(".owl owl mousedown.disableTextSelect"),a(c).off(".owl owl"),a(b).off("resize",d.resizer)},unWrap:function(){var a=this;0!==a.$elem.children().length&&(a.$owlWrapper.unwrap(),a.$userItems.unwrap().unwrap(),a.owlControls&&a.owlControls.remove()),a.clearEvents(),a.$elem.attr("style",a.$elem.data("owl-originalStyles")||"").attr("class",a.$elem.data("owl-originalClasses"))},destroy:function(){var a=this;a.stop(),b.clearInterval(a.checkVisible),a.unWrap(),a.$elem.removeData()},reinit:function(b){var c=this,d=a.extend({},c.userOptions,b);c.unWrap(),c.init(d,c.$elem)},addItem:function(a,b){var c=this,d;return!!a&&(0===c.$elem.children().length?(c.$elem.append(a),c.setVars(),!1):(c.unWrap(),d=void 0===b||b===-1?-1:b,d>=c.$userItems.length||d===-1?c.$userItems.eq(-1).after(a):c.$userItems.eq(d).before(a),void c.setVars()))},removeItem:function(a){var b=this,c;return 0!==b.$elem.children().length&&(c=void 0===a||a===-1?-1:a,b.unWrap(),b.$userItems.eq(c).remove(),void b.setVars())}};a.fn.owlCarousel=function(b){return this.each(function(){if(a(this).data("owl-init")===!0)return!1;a(this).data("owl-init",!0);var c=Object.create(d);c.init(b,this),a.data(this,"owlCarousel",c)})},a.fn.owlCarousel.options={items:5,itemsCustom:!1,itemsDesktop:[1199,4],itemsDesktopSmall:[979,3],itemsTablet:[768,2],itemsTabletSmall:!1,itemsMobile:[479,1],singleItem:!1,itemsScaleUp:!1,slideSpeed:200,paginationSpeed:800,rewindSpeed:1e3,autoPlay:!1,stopOnHover:!1,navigation:!1,navigationText:["prev","next"],rewindNav:!0,scrollPerPage:!1,pagination:!0,paginationNumbers:!1,responsive:!0,responsiveRefreshRate:200,responsiveBaseWidth:b,baseClass:"owl-carousel",theme:"owl-theme",lazyLoad:!1,lazyFollow:!0,lazyEffect:"fade",autoHeight:!1,jsonPath:!1,jsonSuccess:!1,dragBeforeAnimFinish:!0,mouseDrag:!0,touchDrag:!0,addClassActive:!1,transitionStyle:!1,beforeUpdate:!1,afterUpdate:!1,beforeInit:!1,afterInit:!1,beforeMove:!1,afterMove:!1,afterAction:!1,startDragging:!1,afterLazyLoad:!1}}(jQuery,window,document),function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof module&&"object"==typeof module.exports?module.exports=b():a.Cldr=b()}(this,function(){var a=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)},b=function(b,c){if(a(b)&&(b=b.join("/")),"string"!=typeof b)throw new Error('invalid path "'+b+'"');return b=b.replace(/^\//,"").replace(/^cldr\//,""),b=b.replace(/{[a-zA-Z]+}/g,function(a){return a=a.replace(/^{([^}]*)}$/,"$1"),c[a]}),b.split("/")},c=function(a,b){var c,d;if(a.some)return a.some(b);for(c=0,d=a.length;c<d;c++)if(b(a[c],c,a))return!0;return!1},d=function(a,b,d,e){var f,g,h=d[0],i=d[1],j=a.localeSep,k=d[2],l=d.slice(3,4);return e=e||{},"und"!==h&&"Zzzz"!==i&&"ZZ"!==k?[h,i,k].concat(l):"undefined"!=typeof b.get("supplemental/likelySubtags")?(g=c([[h,i,k],[h,k],[h,i],[h],["und",i]],function(a){return f=!/\b(Zzzz|ZZ)\b/.test(a.join(j))&&b.get(["supplemental/likelySubtags",a.join(j)])}),g?(f=f.split(j),["und"!==h?h:f[0],"Zzzz"!==i?i:f[1],"ZZ"!==k?k:f[2]].concat(l)):e.force?b.get("supplemental/likelySubtags/und").split(j):void 0):void 0},e=function(a,b,e){var f,g,h=e[0],i=e[1],j=e[2],k=e[3];return g=c([[[h,"Zzzz","ZZ"],[h]],[[h,"Zzzz",j],[h,j]],[[h,i,"ZZ"],[h,i]]],function(c){var g=d(a,b,c[0]);return f=c[1],g&&g[0]===e[0]&&g[1]===e[1]&&g[2]===e[2]}),g?(k&&f.push(k),f):e},f=function(a){var b,c,d=[];return a=a.replace(/_/,"-"),b=a.split("-u-"),b[1]&&(b[1]=b[1].split("-t-"),a=b[0]+(b[1][1]?"-t-"+b[1][1]:""),d[4]=b[1][0]),c=a.split("-t-")[0],b=c.match(/^(([a-z]{2,3})(-([A-Z][a-z]{3}))?(-([A-Z]{2}|[0-9]{3}))?)((-([a-zA-Z0-9]{5,8}|[0-9][a-zA-Z0-9]{3}))*)$|^(root)$/),null===b?["und","Zzzz","ZZ"]:(d[0]=b[10]||b[2]||"und",d[1]=b[4]||"Zzzz",d[2]=b[6]||"ZZ",b[7]&&b[7].length&&(d[3]=b[7].slice(1)),d)},g=function(a,b){var c,d;if(a.forEach)return a.forEach(b);for(c=0,d=a.length;c<d;c++)b(a[c],c,a)},h=function(a,b,c){var h=a._availableBundleMap,i=a._availableBundleMapQueue;return i.length&&(g(i,function(c){var g,j,k,l;l=f(c),j=d(a,b,l),k=e(a,b,j),k=k.join(a.localeSep),g=i[k],g&&g.length<c.length||(h[k]=c)}),a._availableBundleMapQueue=[]),h[c]||null},i=function(a){var b,c=[];if(Object.keys)return Object.keys(a);for(b in a)c.push(b);return c},j=function(a,b){var c,d;return d=a+(b&&JSON?": "+JSON.stringify(b):""),c=new Error(d),c.code=a,g(i(b),function(a){c[a]=b[a]}),c},k=function(a,b,c){if(!b)throw j(a,c)},l=function(a,b){k("E_MISSING_PARAMETER","undefined"!=typeof a,{name:b})},m=function(a,b,c,d){k("E_INVALID_PAR_TYPE",c,{expected:d,name:b,value:a})},n=function(b,c){m(b,c,"string"==typeof b||a(b),"String or Array")},o=function(a){return null!==a&&""+a=="[object Object]"},p=function(a,b){m(a,b,"undefined"==typeof a||o(a),"Plain Object")},q=function(a,b){m(a,b,"string"==typeof a,"a string")},r=function(a,b){var c,d=a,e=b.length;for(c=0;c<e-1;c++)if(d=d[b[c]],!d)return;return d[b[c]]},s=function(a,b){var c,d=a._availableBundleMapQueue,e=r(b,["main"]);if(e)for(c in e)e.hasOwnProperty(c)&&"root"!==c&&d.indexOf(c)===-1&&d.push(c)},t=function(b){return a(b)?b:[b]},u=function(){var b=function(){var c={},d=[].slice.call(arguments,0);return g(d,function(d){var e;for(e in d)e in c&&"object"==typeof c[e]&&!a(c[e])?c[e]=b(c[e],d[e]):c[e]=d[e]}),c};return b}(),v=function(a,b,c){var d,e,f;for(l(c[0],"json"),d=0;d<c.length;d++)for(f=t(c[d]),e=0;e<f.length;e++)p(f[e],"json"),b=u(b,f[e]),s(a,f[e]);return b},w=function(a,c,d){var e=b(c,d);return r(a._resolved,e)},x=function(a){this.init(a)};return x._alwaysArray=t,x._coreLoad=v,x._createError=j,x._itemGetResolved=w,x._jsonMerge=u,x._pathNormalize=b,x._resourceGet=r,x._validatePresence=l,x._validateType=m,x._validateTypePath=n,x._validateTypePlainObject=p,x._availableBundleMap={},x._availableBundleMapQueue=[],x._resolved={},x.localeSep="-",x.load=function(){x._resolved=v(x,x._resolved,arguments)},x.prototype.init=function(a){var b,c,g,i,j,k,m,n,o,p=x.localeSep,r="";l(a,"locale"),q(a,"locale"),k=f(a),5===k.length&&(n=k.pop(),r=p+"u"+p+n,k[3]||k.pop()),o=k[3],g=d(x,this,k,{force:!0})||k,c=g[0],j=g[1],m=g[2],i=e(x,this,g).join(p),this.attributes=b={bundle:h(x,this,i),minLanguageId:i+r,maxLanguageId:g.join(p)+r,language:c,script:j,territory:m,region:m,variant:o},n&&("-"+n).replace(/-[a-z]{3,8}|(-[a-z]{2})-([a-z]{3,8})/g,function(a,c,d){c?b["u"+c]=d:b["u"+a]=!0}),this.locale=a},x.prototype.get=function(a){return l(a,"path"),n(a,"path"),w(x,a,this.attributes)},x.prototype.main=function(a){return l(a,"path"),n(a,"path"),k("E_MISSING_BUNDLE",null!==this.attributes.bundle,{locale:this.locale}),a=t(a),this.get(["main/{bundle}"].concat(a))},x}),function(a){"function"==typeof define&&define.amd?define(["../cldr"],a):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("../cldr")):a(Cldr)}(function(a){var b=a._pathNormalize,c=a._validatePresence,d=a._validateType,e;e=function(){function a(){}var b=a.prototype,c=this,d=c.EventEmitter;function e(a,b){var c=a.length;while(c--)if(a[c].listener===b)return c;return-1}function f(a){return function b(){return this[a].apply(this,arguments)}}return b.getListeners=function a(b){var c=this._getEvents(),d,e;if(b instanceof RegExp){d={};for(e in c)c.hasOwnProperty(e)&&b.test(e)&&(d[e]=c[e])}else d=c[b]||(c[b]=[]);return d},b.flattenListeners=function a(b){var c=[],d;for(d=0;d<b.length;d+=1)c.push(b[d].listener);return c},b.getListenersAsObject=function a(b){var c=this.getListeners(b),d;return c instanceof Array&&(d={},d[b]=c),d||c},b.addListener=function a(b,c){var d=this.getListenersAsObject(b),f="object"==typeof c,g;for(g in d)d.hasOwnProperty(g)&&e(d[g],c)===-1&&d[g].push(f?c:{listener:c,once:!1});return this},b.on=f("addListener"),b.addOnceListener=function a(b,c){return this.addListener(b,{listener:c,once:!0})},b.once=f("addOnceListener"),b.defineEvent=function a(b){return this.getListeners(b),this},b.defineEvents=function a(b){for(var c=0;c<b.length;c+=1)this.defineEvent(b[c]);return this},b.removeListener=function a(b,c){var d=this.getListenersAsObject(b),f,g;for(g in d)d.hasOwnProperty(g)&&(f=e(d[g],c),f!==-1&&d[g].splice(f,1));return this},b.off=f("removeListener"),b.addListeners=function a(b,c){return this.manipulateListeners(!1,b,c)},b.removeListeners=function a(b,c){return this.manipulateListeners(!0,b,c)},b.manipulateListeners=function a(b,c,d){var e,f,g=b?this.removeListener:this.addListener,h=b?this.removeListeners:this.addListeners;if("object"!=typeof c||c instanceof RegExp){e=d.length;while(e--)g.call(this,c,d[e])}else for(e in c)c.hasOwnProperty(e)&&(f=c[e])&&("function"==typeof f?g.call(this,e,f):h.call(this,e,f));return this},b.removeEvent=function a(b){var c=typeof b,d=this._getEvents(),e;if("string"===c)delete d[b];else if(b instanceof RegExp)for(e in d)d.hasOwnProperty(e)&&b.test(e)&&delete d[e];else delete this._events;return this},b.removeAllListeners=f("removeEvent"),b.emitEvent=function a(b,c){var d=this.getListenersAsObject(b),e,f,g,h;for(g in d)if(d.hasOwnProperty(g)){f=d[g].length;while(f--)e=d[g][f],e.once===!0&&this.removeListener(b,e.listener),h=e.listener.apply(this,c||[]),h===this._getOnceReturnValue()&&this.removeListener(b,e.listener)}return this},b.trigger=f("emitEvent"),b.emit=function a(b){var c=Array.prototype.slice.call(arguments,1);return this.emitEvent(b,c)},b.setOnceReturnValue=function a(b){return this._onceReturnValue=b,this},b._getOnceReturnValue=function a(){return!this.hasOwnProperty("_onceReturnValue")||this._onceReturnValue},b._getEvents=function a(){return this._events||(this._events={})},a.noConflict=function b(){return c.EventEmitter=d,a},a}();var f=function(a,b){d(a,b,"undefined"==typeof a||"function"==typeof a,"Function")},g,h,i=new e;function j(a,b){d(a,b,"string"==typeof a||a instanceof RegExp,"String or RegExp")}function k(a,b){return function(d,e){return c(d,"event"),j(d,"event"),c(e,"listener"),f(e,"listener"),b[a].apply(b,arguments)}}function l(a){return k("off",a)}function m(a){return k("on",a)}function n(a){return k("once",a)}a.off=l(i),a.on=m(i),a.once=n(i),h=a.prototype.init,a.prototype.init=function(){var a;this.ee=a=new e,this.off=l(a),this.on=m(a),this.once=n(a),h.apply(this,arguments)};function o(){g=a.prototype.get,a.prototype.get=function(a){var c=g.apply(this,arguments);return a=b(a,this.attributes).join("/"),i.trigger("get",[a,c]),this.ee.trigger("get",[a,c]),c}}return a._eventInit=o,o(),a}),function(a){"function"==typeof define&&define.amd?define(["../cldr"],a):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("../cldr")):a(Cldr)}(function(a){var b=a._alwaysArray,c=function(a){var c,d;return c=function(c){return function(d){return d=b(d),a.get([c].concat(d))}},d=c("supplemental"),d.weekData=c("supplemental/weekData"),d.weekData.firstDay=function(){return a.get("supplemental/weekData/firstDay/{territory}")||a.get("supplemental/weekData/firstDay/001")},d.weekData.minDays=function(){var b=a.get("supplemental/weekData/minDays/{territory}")||a.get("supplemental/weekData/minDays/001");return parseInt(b,10)},d.timeData=c("supplemental/timeData"),d.timeData.allowed=function(){return a.get("supplemental/timeData/{territory}/_allowed")||a.get("supplemental/timeData/001/_allowed")},d.timeData.preferred=function(){return a.get("supplemental/timeData/{territory}/_preferred")||a.get("supplemental/timeData/001/_preferred")},d},d=a.prototype.init;return a.prototype.init=function(){d.apply(this,arguments),this.supplemental=c(this)},a}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","cldr/event"],b):"object"==typeof exports?module.exports=b(require("cldrjs")):a.Globalize=b(a.Cldr)}(this,function(a){var b=function(a){return"string"==typeof a?a:"number"==typeof a?""+a:JSON.stringify(a)},c=function(a,c){return a=a.replace(/{[0-9a-zA-Z-_. ]+}/g,function(a){return a=a.replace(/^{([^}]*)}$/,"$1"),b(c[a])})},d=function(){var a=arguments[0],b=[].slice.call(arguments,1);return b.forEach(function(b){var c;for(c in b)a[c]=b[c]}),a},e=function(a,b,e){var f;return b=a+(b?": "+c(b,e):""),f=new Error(b),f.code=a,d(f,e),f},f=function(a){return[].reduce.call(a,function(a,b){var c=b.charCodeAt(0);return a=(a<<5)-a+c,0|a},0)},g=function(a,b,c,d){var e;return d=d||JSON.stringify(c),e=f(a+b+d),e>0?"a"+e:"b"+Math.abs(e)},h=function(a){if(void 0!==a.name)return a.name;var b=/^function\s+([\w\$]+)\s*\(/.exec(a.toString());return b&&b.length>0?b[1]:void 0},i=function(a,b,c,d){var e=JSON.stringify(a),f=h(c),i=b.locale;return f?(c.runtimeKey=g(f,i,null,e),c.generatorString=function(){return'Globalize("'+i+'").'+f+"("+e.slice(1,-1)+")"},c.runtimeArgs=d,c):c},j=function(a,b,c,d){if(!c)throw e(a,b,d)},k=function(a){return Array.isArray(a)?a:a?[a]:[]},l=function(a,b,c){var d;c=c||{},d=k(c.skip).some(function(b){return b.test(a)}),j("E_MISSING_CLDR","Missing required CLDR content `{path}`.",b||d,{path:a})},m=function(a){j("E_DEFAULT_LOCALE_NOT_DEFINED","Default locale has not been defined.",void 0!==a,{})},n=function(a,b){j("E_MISSING_PARAMETER","Missing required parameter `{name}`.",void 0!==a,{name:b})},o=function(a,b,c,d){j("E_PAR_OUT_OF_RANGE","Parameter `{name}` has value `{value}` out of range [{minimum}, {maximum}].",void 0===a||a>=c&&a<=d,{maximum:d,minimum:c,name:b,value:a})},p=function(a,b,c,d){j("E_INVALID_PAR_TYPE","Invalid `{name}` parameter ({value}). {expected} expected.",c,{expected:d,name:b,value:a})},q=function(b,c){p(b,c,void 0===b||"string"==typeof b||b instanceof a,"String or Cldr instance")},r=function(a){return null!==a&&""+a=="[object Object]"},s=function(a,b){p(a,b,void 0===a||r(a),"Plain Object")},t=function(b){return b instanceof a?b:new a(b)},u=function(a){return a.replace(/([.*+?^=!:${}()|\[\]\/\\])/g,"\\$1")},v=function(a,b,c){var d;for("string"!=typeof a&&(a=String(a)),d=a.length;d<b;d+=1)a=c?a+"0":"0"+a;return a};function w(a){a.once("get",l),a.get("supplemental/likelySubtags")}function x(a){return this instanceof x?(n(a,"locale"),q(a,"locale"),this.cldr=t(a),void w(this.cldr)):new x(a)}return x.load=function(){a.load.apply(a,arguments)},x.locale=function(a){return q(a,"locale"),arguments.length&&(this.cldr=t(a),w(this.cldr)),this.cldr},x._alwaysArray=k,x._createError=e,x._formatMessage=c,x._isPlainObject=r,x._objectExtend=d,x._regexpEscape=u,x._runtimeBind=i,x._stringPad=v,x._validate=j,x._validateCldr=l,x._validateDefaultLocale=m,x._validateParameterPresence=n,x._validateParameterRange=o,x._validateParameterTypePlainObject=s,x._validateParameterType=p,x}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","cldr/event"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._alwaysArray,d=b._createError,e=b._isPlainObject,f=b._runtimeBind,g=b._validateDefaultLocale,h=b._validate,i=b._validateParameterPresence,j=b._validateParameterType,k=b._validateParameterTypePlainObject,l;l=function(){b._parse=function(){function a(a,b){function c(){this.constructor=a}c.prototype=b.prototype,a.prototype=new c}function b(a,b,c,d,e,f){this.message=a,this.expected=b,this.found=c,this.offset=d,this.line=e,this.column=f,this.name="SyntaxError"}a(b,Error);function c(a){var c=arguments.length>1?arguments[1]:{},d={},e={start:Ma},f=Ma,g=[],h=function(a){return{type:"messageFormatPattern",statements:a}},i=d,j="{",k={type:"literal",value:"{",description:'"{"'},l=null,m=",",n={type:"literal",value:",",description:'","'},o="}",p={type:"literal",value:"}",description:'"}"'},q=function(a,b){var c={type:"messageFormatElement",argumentIndex:a};return b&&b.length?c.elementFormat=b[1]:c.output=!0,c},r="plural",s={type:"literal",value:"plural",description:'"plural"'},t=function(a,b){return{type:"elementFormat",key:a,val:b}},u="selectordinal",v={type:"literal",value:"selectordinal",description:'"selectordinal"'},w="select",x={type:"literal",value:"select",description:'"select"'},y=function(a,b){return{type:"elementFormat",key:a,val:b}},z=function(a,b){return{type:"pluralFormatPattern",pluralForms:b,offset:a||0}},A="offset",B={type:"literal",value:"offset",description:'"offset"'},C=":",D={type:"literal",value:":",description:'":"'},E=function(a){return a},F=function(a,b){return{key:a,val:b}},G=function(a){return a},H="=",I={type:"literal",value:"=",description:'"="'},J=function(a){return{type:"selectFormatPattern",pluralForms:a}},K=function(a){return a},L="#",M={type:"literal",value:"#",description:'"#"'},N=function(){return{type:"octothorpe"}},O=function(a){return{type:"string",val:a.join("")}},P={type:"other",description:"identifier"},Q=/^[0-9a-zA-Z$_]/,R={type:"class",value:"[0-9a-zA-Z$_]",description:"[0-9a-zA-Z$_]"},S=/^[^ \t\n\r,.+={}]/,T={type:"class",value:"[^ \\t\\n\\r,.+={}]",description:"[^ \\t\\n\\r,.+={}]"},U=function(a){return a},V=function(a){return a.join("")},W=/^[^{}#\\\0-\x1F\x7f \t\n\r]/,X={type:"class",value:"[^{}#\\\\\\0-\\x1F\x7f \\t\\n\\r]",description:"[^{}#\\\\\\0-\\x1F\x7f \\t\\n\\r]"},Y=function(a){return a},Z="\\\\",$={type:"literal",value:"\\\\",description:'"\\\\\\\\"'},_=function(){return"\\"},aa="\\#",ba={type:"literal",value:"\\#",description:'"\\\\#"'},ca=function(){return"#"},da="\\{",ea={type:"literal",value:"\\{",description:'"\\\\{"'},fa=function(){return"{"},ga="\\}",ha={type:"literal",value:"\\}",description:'"\\\\}"'},ia=function(){return"}"},ja="\\u",ka={type:"literal",value:"\\u",description:'"\\\\u"'},la=function(a,b,c,d){return String.fromCharCode(parseInt("0x"+a+b+c+d))},ma=/^[0-9]/,na={type:"class",value:"[0-9]",description:"[0-9]"},oa=function(a){return parseInt(a.join(""),10)},pa=/^[0-9a-fA-F]/,qa={type:"class",value:"[0-9a-fA-F]",description:"[0-9a-fA-F]"},ra={type:"other",description:"whitespace"},sa=function(a){return a.join("")},ta=/^[ \t\n\r]/,ua={type:"class",value:"[ \\t\\n\\r]",description:"[ \\t\\n\\r]"},va=0,wa=0,xa=0,ya={line:1,column:1,seenCR:!1},za=0,Aa=[],Ba=0,Ca;if("startRule"in c){if(!(c.startRule in e))throw new Error("Can't start parsing from rule \""+c.startRule+'".');f=e[c.startRule]}function Da(){return a.substring(wa,va)}function Ea(){return wa}function Fa(){return Ja(wa).line}function Ga(){return Ja(wa).column}function Ha(a){throw La(null,[{type:"other",description:a}],wa)}function Ia(a){throw La(a,null,wa)}function Ja(b){function c(b,c,d){var e,f;for(e=c;e<d;e++)f=a.charAt(e),"\n"===f?(b.seenCR||b.line++,b.column=1,b.seenCR=!1):"\r"===f||"\u2028"===f||"\u2029"===f?(b.line++,b.column=1,b.seenCR=!0):(b.column++,b.seenCR=!1)}return xa!==b&&(xa>b&&(xa=0,ya={line:1,column:1,seenCR:!1}),c(ya,xa,b),xa=b),ya}function Ka(a){va<za||(va>za&&(za=va,Aa=[]),Aa.push(a))}function La(c,d,e){function f(a){var b=1;a.sort(function(a,b){return a.description<b.description?-1:a.description>b.description?1:0});while(b<a.length)a[b-1]===a[b]?a.splice(b,1):b++}function g(a,b){function c(a){function b(a){return a.charCodeAt(0).toString(16).toUpperCase()}return a.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\x08/g,"\\b").replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\f/g,"\\f").replace(/\r/g,"\\r").replace(/[\x00-\x07\x0B\x0E\x0F]/g,function(a){return"\\x0"+b(a)}).replace(/[\x10-\x1F\x80-\xFF]/g,function(a){return"\\x"+b(a)}).replace(/[\u0180-\u0FFF]/g,function(a){return"\\u0"+b(a)}).replace(/[\u1080-\uFFFF]/g,function(a){return"\\u"+b(a)})}var d=new Array(a.length),e,f,g;for(g=0;g<a.length;g++)d[g]=a[g].description;return e=a.length>1?d.slice(0,-1).join(", ")+" or "+d[a.length-1]:d[0],f=b?'"'+c(b)+'"':"end of input","Expected "+e+" but "+f+" found."}var h=Ja(e),i=e<a.length?a.charAt(e):null;return null!==d&&f(d),new b(null!==c?c:g(d,i),d,i,e,h.line,h.column)}function Ma(){var a;return a=Na()}function Na(){var a,b,c;a=va,b=[],c=Oa(),c===d&&(c=Ya(),c===d&&(c=Xa()));while(c!==d)b.push(c),c=Oa(),c===d&&(c=Ya(),c===d&&(c=Xa()));return b!==d&&(wa=a,b=h(b)),a=b}function Oa(){var b,c,e,f,g,h,r;return b=va,123===a.charCodeAt(va)?(c=j,va++):(c=d,0===Ba&&Ka(k)),c!==d?(e=cb(),e!==d?(f=Za(),f!==d?(g=va,44===a.charCodeAt(va)?(h=m,va++):(h=d,0===Ba&&Ka(n)),h!==d?(r=Pa(),r!==d?(h=[h,r],g=h):(va=g,g=i)):(va=g,g=i),g===d&&(g=l),g!==d?(h=cb(),h!==d?(125===a.charCodeAt(va)?(r=o,va++):(r=d,0===Ba&&Ka(p)),r!==d?(wa=b,c=q(f,g),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Pa(){var b,c,e,f,g,h,j,k;if(b=va,c=cb(),c!==d?(a.substr(va,6)===r?(e=r,va+=6):(e=d,0===Ba&&Ka(s)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Qa(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d&&(b=va,c=cb(),c!==d?(a.substr(va,13)===u?(e=u,va+=13):(e=d,0===Ba&&Ka(v)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Qa(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d&&(b=va,c=cb(),c!==d?(a.substr(va,6)===w?(e=w,va+=6):(e=d,0===Ba&&Ka(x)),e!==d?(f=cb(),f!==d?(44===a.charCodeAt(va)?(g=m,va++):(g=d,0===Ba&&Ka(n)),g!==d?(h=cb(),h!==d?(j=Ua(),j!==d?(k=cb(),k!==d?(wa=b,c=t(e,j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b===d)))if(b=va,c=cb(),c!==d)if(e=Za(),e!==d){f=[],g=Wa();while(g!==d)f.push(g),g=Wa();f!==d?(wa=b,c=y(e,f),b=c):(va=b,b=i)}else va=b,b=i;else va=b,b=i;return b}function Qa(){var a,b,c,e;if(a=va,b=Ra(),b===d&&(b=l),b!==d){if(c=[],e=Sa(),e!==d)while(e!==d)c.push(e),e=Sa();else c=i;c!==d?(wa=a,b=z(b,c),a=b):(va=a,a=i)}else va=a,a=i;return a}function Ra(){var b,c,e,f,g,h,j,k;return b=va,c=cb(),c!==d?(a.substr(va,6)===A?(e=A,va+=6):(e=d,0===Ba&&Ka(B)),e!==d?(f=cb(),f!==d?(58===a.charCodeAt(va)?(g=C,va++):(g=d,0===Ba&&Ka(D)),g!==d?(h=cb(),h!==d?(j=ab(),j!==d?(k=cb(),k!==d?(wa=b,c=E(j),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Sa(){var b,c,e,f,g,h,l,m,n;return b=va,c=cb(),c!==d?(e=Ta(),e!==d?(f=cb(),f!==d?(123===a.charCodeAt(va)?(g=j,va++):(g=d,0===Ba&&Ka(k)),g!==d?(h=cb(),h!==d?(l=Na(),l!==d?(m=cb(),m!==d?(125===a.charCodeAt(va)?(n=o,va++):(n=d,0===Ba&&Ka(p)),n!==d?(wa=b,c=F(e,l),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Ta(){var b,c,e;return b=va,c=Za(),c!==d&&(wa=b,c=G(c)),b=c,b===d&&(b=va,61===a.charCodeAt(va)?(c=H,va++):(c=d,0===Ba&&Ka(I)),c!==d?(e=ab(),e!==d?(wa=b,c=E(e),b=c):(va=b,b=i)):(va=b,b=i)),b}function Ua(){var a,b,c;if(a=va,b=[],c=Va(),c!==d)while(c!==d)b.push(c),c=Va();else b=i;return b!==d&&(wa=a,b=J(b)),a=b}function Va(){var b,c,e,f,g,h,l,m,n;return b=va,c=cb(),c!==d?(e=Za(),e!==d?(f=cb(),f!==d?(123===a.charCodeAt(va)?(g=j,va++):(g=d,0===Ba&&Ka(k)),g!==d?(h=cb(),h!==d?(l=Na(),l!==d?(m=cb(),m!==d?(125===a.charCodeAt(va)?(n=o,va++):(n=d,0===Ba&&Ka(p)),n!==d?(wa=b,c=F(e,l),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Wa(){var b,c,e,f,g,h;return b=va,c=cb(),c!==d?(44===a.charCodeAt(va)?(e=m,va++):(e=d,0===Ba&&Ka(n)),e!==d?(f=cb(),f!==d?(g=Za(),g!==d?(h=cb(),h!==d?(wa=b,c=K(g),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i),b}function Xa(){var b,c;return b=va,35===a.charCodeAt(va)?(c=L,va++):(c=d,0===Ba&&Ka(M)),c!==d&&(wa=b,c=N()),b=c}function Ya(){var a,b,c;if(a=va,b=[],c=$a(),c===d&&(c=db()),c!==d)while(c!==d)b.push(c),c=$a(),c===d&&(c=db());else b=i;return b!==d&&(wa=a,b=O(b)),a=b}function Za(){var b,c,e,f,g,h,j;if(Ba++,b=va,c=cb(),c!==d){if(e=va,f=va,Q.test(a.charAt(va))?(g=a.charAt(va),va++):(g=d,0===Ba&&Ka(R)),g!==d){h=[],S.test(a.charAt(va))?(j=a.charAt(va),va++):(j=d,0===Ba&&Ka(T));while(j!==d)h.push(j),S.test(a.charAt(va))?(j=a.charAt(va),va++):(j=d,0===Ba&&Ka(T));h!==d?(g=[g,h],f=g):(va=f,f=i)}else va=f,f=i;f!==d&&(f=a.substring(e,va)),e=f,e!==d?(f=cb(),f!==d?(wa=b,c=U(e),b=c):(va=b,b=i)):(va=b,b=i)}else va=b,b=i;return Ba--,b===d&&(c=d,0===Ba&&Ka(P)),b}function $a(){var a,b,c;if(a=va,b=[],c=_a(),c!==d)while(c!==d)b.push(c),c=_a();else b=i;return b!==d&&(wa=a,b=V(b)),a=b}function _a(){var b,c,e,f,g,h;return b=va,W.test(a.charAt(va))?(c=a.charAt(va),va++):(c=d,0===Ba&&Ka(X)),c!==d&&(wa=b,c=Y(c)),b=c,b===d&&(b=va,a.substr(va,2)===Z?(c=Z,va+=2):(c=d,0===Ba&&Ka($)),c!==d&&(wa=b,c=_()),b=c,b===d&&(b=va,a.substr(va,2)===aa?(c=aa,va+=2):(c=d,0===Ba&&Ka(ba)),c!==d&&(wa=b,c=ca()),b=c,b===d&&(b=va,a.substr(va,2)===da?(c=da,va+=2):(c=d,0===Ba&&Ka(ea)),c!==d&&(wa=b,c=fa()),b=c,b===d&&(b=va,a.substr(va,2)===ga?(c=ga,va+=2):(c=d,0===Ba&&Ka(ha)),c!==d&&(wa=b,c=ia()),b=c,b===d&&(b=va,a.substr(va,2)===ja?(c=ja,va+=2):(c=d,0===Ba&&Ka(ka)),c!==d?(e=bb(),e!==d?(f=bb(),f!==d?(g=bb(),g!==d?(h=bb(),h!==d?(wa=b,c=la(e,f,g,h),b=c):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)):(va=b,b=i)))))),b}function ab(){var b,c,e;
if(b=va,c=[],ma.test(a.charAt(va))?(e=a.charAt(va),va++):(e=d,0===Ba&&Ka(na)),e!==d)while(e!==d)c.push(e),ma.test(a.charAt(va))?(e=a.charAt(va),va++):(e=d,0===Ba&&Ka(na));else c=i;return c!==d&&(wa=b,c=oa(c)),b=c}function bb(){var b;return pa.test(a.charAt(va))?(b=a.charAt(va),va++):(b=d,0===Ba&&Ka(qa)),b}function cb(){var a,b,c;Ba++,a=va,b=[],c=db();while(c!==d)b.push(c),c=db();return b!==d&&(wa=a,b=sa(b)),a=b,Ba--,a===d&&(b=d,0===Ba&&Ka(ra)),a}function db(){var b;return ta.test(a.charAt(va))?(b=a.charAt(va),va++):(b=d,0===Ba&&Ka(ua)),b}if(Ca=f(),Ca!==d&&va===a.length)return Ca;throw Ca!==d&&va<a.length&&Ka({type:"end",description:"end of input"}),La(null,Aa,za)}return{SyntaxError:b,parse:c}}().parse;function a(a,b){if(/^[A-Z_$][0-9A-Z_$]*$/i.test(a))return b?b+"."+a:a;var c=JSON.stringify(a);return b?b+"["+c+"]":c}function b(a,b,c){if(this.lc=[a],this.runtime.pluralFuncs={},this.runtime.pluralFuncs[this.lc[0]]=b,this.runtime.fmt={},c)for(var d in c)this.runtime.fmt[d]=c[d]}return b.plurals={},b.formatters={},b.prototype.runtime={number:function(a,b){if(isNaN(a))throw new Error("'"+a+"' isn't a number.");return a-(b||0)},plural:function(a,b,c,d,e){if({}.hasOwnProperty.call(d,a))return d[a]();b&&(a-=b);var f=c(a,e);return f in d?d[f]():d.other()},select:function(a,b){return{}.hasOwnProperty.call(b,a)?b[a]():b.other()},pluralFuncs:{},fmt:{},toString:function(){var b=function(c,d){if("object"!=typeof c){var e=c.toString().replace(/^(function )\w*/,"$1"),f=/([ \t]*)\S.*$/.exec(e);return f?e.replace(new RegExp("^"+f[1],"mg"),""):e}var g=[];for(var h in c)"toString"!=h&&(0==d?g.push("var "+h+" = "+b(c[h],d+1)+";\n"):g.push(a(h)+": "+b(c[h],d+1)));if(0==d)return g.join("");if(0==g.length)return"{}";var f="  ";while(--d)f+="  ";return"{\n"+g.join(",\n").replace(/^/gm,f)+"\n}"};return b(this,0)}},b.prototype._precompile=function(c,d){d=d||{keys:{},offset:{}};var e=[],f,g,h=[];switch(c.type){case"messageFormatPattern":for(f=0;f<c.statements.length;++f)e.push(this._precompile(c.statements[f],d));return g=e.join(" + ")||'""',d.pf_count?g:"function(d) { return "+g+"; }";case"messageFormatElement":return d.pf_count=d.pf_count||0,c.output?a(c.argumentIndex,"d"):(d.keys[d.pf_count]=c.argumentIndex,this._precompile(c.elementFormat,d));case"elementFormat":switch(h=[a(d.keys[d.pf_count],"d")],c.key){case"select":return h.push(this._precompile(c.val,d)),"select("+h.join(", ")+")";case"selectordinal":return h=h.concat([0,a(this.lc[0],"pluralFuncs"),this._precompile(c.val,d),1]),"plural("+h.join(", ")+")";case"plural":return d.offset[d.pf_count||0]=c.val.offset||0,h=h.concat([d.offset[d.pf_count]||0,a(this.lc[0],"pluralFuncs"),this._precompile(c.val,d)]),"plural("+h.join(", ")+")";default:return this.withIntlSupport&&!(c.key in this.runtime.fmt)&&c.key in b.formatters&&(g=b.formatters[c.key],this.runtime.fmt[c.key]="function"==typeof g(this)?g(this):g),h.push(JSON.stringify(this.lc)),c.val&&c.val.length&&h.push(JSON.stringify(1==c.val.length?c.val[0]:c.val)),"fmt."+c.key+"("+h.join(", ")+")"}case"pluralFormatPattern":case"selectFormatPattern":d.pf_count=d.pf_count||0,"selectFormatPattern"==c.type&&(d.offset[d.pf_count]=0);var i=!0;for(f=0;f<c.pluralForms.length;++f){var j=c.pluralForms[f].key;"other"===j&&(i=!1);var k=JSON.parse(JSON.stringify(d));k.pf_count++,e.push(a(j)+": function() { return "+this._precompile(c.pluralForms[f].val,k)+";}")}if(i)throw new Error("No 'other' form found in "+c.type+" "+d.pf_count);return"{ "+e.join(", ")+" }";case"string":return JSON.stringify(c.val||"");case"octothorpe":return d.pf_count?(h=[a(d.keys[d.pf_count-1],"d")],d.offset[d.pf_count-1]&&h.push(d.offset[d.pf_count-1]),"number("+h.join(", ")+")"):'"#"';default:throw new Error("Bad AST type: "+c.type)}},b.prototype.compile=function(c,d){var e={},f=this.lc,g=function(a,c){try{var d=b._parse(c);return a._precompile(d)}catch(a){throw new Error((d?"Precompiler":"Parser")+" error: "+a.toString())}},h=function(b,c){if(c||(c=0),"object"!=typeof b)return b;for(var d=[],e="",f=0;f<c;++f)e+="  ";for(var g in b)d.push("\n"+e+"  "+a(g)+": "+h(b[g],c+1));return"{"+d.join(",")+"\n"+e+"}"};if("string"==typeof c){var i=new Function("number, plural, select, pluralFuncs, fmt","return "+g(this,c));return i(this.runtime.number,this.runtime.plural,this.runtime.select,this.runtime.pluralFuncs,this.runtime.fmt)}d=d||{};for(var j in c)if(d.locale&&(this.lc=d.locale[j]&&[].concat(d.locale[j])||f),"string"==typeof c[j])try{e[j]=g(this,c[j])}catch(a){throw a.message=a.message.replace(":"," with `"+j+"`:"),a}else{e[j]={};for(var k in c[j])try{e[j][k]=g(this,c[j][k])}catch(a){throw a.message=a.message.replace(":"," with `"+k+"` in `"+j+"`:"),a}}this.lc=f;var l=this.runtime.toString()+"\n";switch(d.global||""){case"exports":var m=[];for(var n in e)m.push(a(n,"exports")+" = "+h(e[n]));return new Function(l+m.join(";\n"));case"module.exports":return new Function(l+"module.exports = "+h(e));case"":return new Function(l+"return "+h(e));default:return new Function("G",l+a(d.global,"G")+" = "+h(e))}},b}();var m=function(){return d("E_MISSING_PLURAL_MODULE","Plural module not loaded.")},n=function(a){h("E_MISSING_MESSAGE_BUNDLE","Missing message bundle for locale `{locale}`.",a.attributes.bundle&&void 0!==a.get("globalize-messages/{bundle}"),{locale:a.locale})},o=function(a,b){a=a.join("/"),h("E_MISSING_MESSAGE","Missing required message content `{path}`.",void 0!==b,{path:a})},p=function(a,b){a=a.join("/"),h("E_INVALID_MESSAGE","Invalid message content `{path}`. {expected} expected.","string"==typeof b,{expected:"a string",path:a})},q=function(a,b){j(a,b,void 0===a||e(a)||Array.isArray(a),"Array or Plain Object")},r=function(a){return function b(c){return"number"!=typeof c&&"string"!=typeof c||(c=[].slice.call(arguments,0)),q(c,"variables"),a(c)}},s=function(a,b){var c=a.locale,d=b.toString;return b.toString=function(){var a,e,f,g={};return f=d.call(b),/number\(/.test(f)&&(g.number="messageFormat.number"),/plural\(/.test(f)&&(g.plural="messageFormat.plural"),/select\(/.test(f)&&(g.select="messageFormat.select"),f.replace(/pluralFuncs(\[([^\]]+)\]|\.([a-zA-Z]+))/,function(a){return g.pluralFuncs='{"'+c+'": Globalize("'+c+'").pluralGenerator()}',a}),a=Object.keys(g).join(", "),e=Object.keys(g).map(function(a){return g[a]}).join(", "),"(function( "+a+" ) {\n  return "+f+"\n})("+e+")"},b},t=[].slice;return b.loadMessages=function(b){var c,d={"globalize-messages":b,main:{}};i(b,"json"),k(b,"json");for(c in b)b.hasOwnProperty(c)&&(d.main[c]={});a.load(d)},b.messageFormatter=b.prototype.messageFormatter=function(a){var b,d,e,h,k,q=t.call(arguments,0);return i(a,"path"),j(a,"path","string"==typeof a||Array.isArray(a),"a String nor an Array"),a=c(a),b=this.cldr,g(b),n(b),e=b.get(["globalize-messages/{bundle}"].concat(a)),o(a,e),Array.isArray(e)&&(e=e.join(" ")),p(a,e),h=void 0!==this.plural?this.pluralGenerator():m,d=new l(b.locale,h).compile(e),k=r(d),f(q,b,k,[s(b,d),h]),k},b.formatMessage=b.prototype.formatMessage=function(a){return this.messageFormatter(a).apply({},t.call(arguments,1))},b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._createError,d=b._objectExtend,e=b._regexpEscape,f=b._runtimeBind,g=b._stringPad,h=b._validateCldr,i=b._validateDefaultLocale,j=b._validateParameterPresence,k=b._validateParameterRange,l=b._validateParameterType,m=b._validateParameterTypePlainObject,n=function(a){return c("E_UNSUPPORTED","Unsupported {feature}.",{feature:a})},o=function(a,b){l(a,b,void 0===a||"number"==typeof a,"Number")},p=function(a,b){l(a,b,void 0===a||"string"==typeof a,"a string")},q=function(a,b,c){var d,e=b,f="",g=",",h=!!c;a=String(a).split("."),d=a[0].length;while(d>e)f=a[0].slice(d-e,d)+(f.length?g:"")+f,d-=e,h&&(e=c,h=!1);return a[0]=a[0].slice(0,d)+(f.length?g:"")+f,a.join(".")},r=function(a,b,c,d,e,f){return d?(a=f?e(a,f):e(a,{exponent:-d}),c&&(a=String(a).split("."),a[1]=g(a[1]||"",c,!0),a=a.join("."))):a=e(a),a=String(a),b&&(a=a.split("."),a[0]=g(a[0],b),a=a.join(".")),a},s=function(a,b,c){var d;return a=a.toPrecision(b+2),d=Math.ceil(Math.log(Math.abs(a))/Math.log(10)),d-=b,c(a,{exponent:d})},t=function(a,b,c,d){var e,f;if(b>c&&(c=b),e=s(a,b,d),f=s(a,c,d),a=+e===+f?e:f,a=(+a).toString(10),/e/.test(a))throw n({feature:"integers out of (1e21, 1e-7)"});return b-a.replace(/^0+|\./g,"").length>0&&(a=a.split("."),a[1]=g(a[1]||"",b-a[0].replace(/^0+/,"").length,!0),a=a.join(".")),a},u=function(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,s,u,v,w;return k=b[1],g=b[2],f=b[3],d=b[4],h=b[5],e=b[6],s=b[7],m=b[8],u=b[9],p=b[15],c=b[16],i=b[17],w=b[18],j=b[19],isNaN(a)?i:(a<0?(n=b[12],l=b[13],v=b[14]):(n=b[11],l=b[0],v=b[10]),isFinite(a)?(o=l,n.indexOf("%")!==-1?a*=100:n.indexOf("\u2030")!==-1&&(a*=1e3),a=isNaN(h*e)?r(a,g,f,d,p,s):t(a,h,e,p),a=a.replace(/^-/,""),m&&(a=q(a,m,u)),o+=a,o+=v,o.replace(/('([^']|'')+'|'')|./g,function(a,b){return b?(b=b.replace(/''/,"'"),b.length>2&&(b=b.slice(1,-1)),b):(a=a.replace(/[.,\-+E%\u2030]/,function(a){return w[a]}),j&&(a=a.replace(/[0-9]/,function(a){return j[+a]})),a)})):l+c+v)},v=function(a){return function b(c){return j(c,"value"),o(c,"value"),u(c,a)}},w=function(a){var b=a.attributes["u-nu"];return b?("traditio"===b&&(b="traditional"),["native","traditional","finance"].indexOf(b)!==-1?a.main(["numbers/otherNumberingSystems",b]):b):a.main("numbers/defaultNumberingSystem")},x=function(a){var b,c=w(a);if("latn"!==c){if(b=a.supplemental(["numberingSystems",c]),"numeric"!==b._type)throw n("`"+b._type+"` numbering system");return b._digits}},y=/^(('[^']+'|''|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/,z=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t;if(a=a.match(y),!a)throw new Error("Invalid pattern: "+a);if(m=a[1],l=a[3],e=a[4],s=a[8],q=a[9],t=a[10],s?s.replace(/(@+)(#*)/,function(a,b,c){k=b.length,h=k+c.length}):(d=a[7],f=a[6],d&&(d.replace(/[0-9]+/,function(a){i=a}),i?(p=+("0."+i),i=i.length):i=0,g=d.length-1),f.replace(/0+$/,function(a){j=a.length})),q)throw n({feature:"scientific notation (not implemented)"});if(l)throw n({feature:"padding (not implemented)"});return(b=e.lastIndexOf(","))!==-1&&(c=e.split(".")[0],o=c.length-b-1,(c=e.lastIndexOf(",",b-1))!==-1&&(r=b-1-c)),[m,l,j,i,g,k,h,p,o,r,t]},A=function(a,b){return b.main(["numbers/symbols-numberSystem-"+w(b),a])},B={".":"decimal",",":"group","%":"percentSign","+":"plusSign","-":"minusSign",E:"exponential","\u2030":"perMille"},C=function(a){var b,c={};for(b in B)c[b]=A(B[b],a);return c},D=function(a){return isNaN(a)?NaN:Math[a<0?"ceil":"floor"](a)},E=function(a){return a=a||"round",a="truncate"===a?D:Math[a],function(b,c){var d,e;if(b=+b,isNaN(b))return NaN;if("object"==typeof c&&c.exponent){if(d=+c.exponent,e=1,0===d)return a(b);if("number"!=typeof d||d%1!==0)return NaN}else{if(e=+c||1,1===e)return a(b);if(isNaN(e))return NaN;e=e.toExponential().split("e"),d=+e[1],e=+e[0]}return b=b.toString().split("e"),b[0]=+b[0]/e,b[1]=b[1]?+b[1]-d:-d,b=a(+(b[0]+"e"+b[1])),b=b.toString().split("e"),b[0]=+b[0]*e,b[1]=b[1]?+b[1]+d:d,+(b[0]+"e"+b[1])}},F=function(a,b,c){var d,e,f,g,h,i,j;function k(a,b){a in c&&(j[b]=c[a])}return c=c||{},a=a.split(";"),h=a[0],d=a[1]||"-"+h,f=z(d),e=f[0],g=f[10],i=E(c.round),i.generatorString=function(){return"numberRound("+(c.round?'"'+c.round+'"':"")+")"},j=z(h).concat([h,e+h+g,e,g,i,A("infinity",b),A("nan",b),C(b),x(b)]),k("minimumIntegerDigits",2),k("minimumFractionDigits",3),k("maximumFractionDigits",4),k("minimumSignificantDigits",5),k("maximumSignificantDigits",6),c.useGrouping===!1&&(j[8]=null),"minimumFractionDigits"in c&&!("maximumFractionDigits"in c)?j[4]=Math.max(j[3],j[4]):!("minimumFractionDigits"in c)&&"maximumFractionDigits"in c&&(j[3]=Math.min(j[3],j[4])),j},G=/^([^0-9]*)(([0-9,]*[0-9]+)(\.[0-9]+)?)(E[+-]?[0-9]+)?([^0-9]*)$/,H=function(a,b){var c,d,f,g,h,i,j,k,l,m,n;if(d=b[0],g=b[1],j=b[2],k=b[3],f=b[4],c=a.match(d))l=1/0,m=a.slice(0,c.length),n=a.slice(c.length+1);else{if(i=new RegExp(Object.keys(g).map(function(a){return e(a)}).join("|"),"g"),a=a.replace(i,function(a){return g[a]}),f&&(h=new RegExp(Object.keys(f).map(function(a){return e(a)}).join("|"),"g"),a=a.replace(h,function(a){return f[a]})),"."===a.charAt(0)&&(a="0"+a),a=a.match(G),!a)return NaN;if(m=a[1],n=a[6],l=a[2].replace(/,/g,""),a[5]&&(l+=a[5]),l=+l,isNaN(l))return NaN;a[0].indexOf("%")!==-1?(l/=100,n=n.replace("%","")):a[0].indexOf("\u2030")!==-1&&(l/=1e3,n=n.replace("\u2030",""))}return m===j&&n===k&&(l*=-1),l},I=function(a){return function b(c){return j(c,"value"),p(c,"value"),H(c,a)}},J=function(a){var b,c={};for(b in B)c[A(B[b],a)]=b;return c},K=function(a,b){var c,e,f,g,h=x(b);return a=a.split(";"),f=a[1]||"-"+a[0],g=z(f),h&&(c=h.split("").reduce(function(a,b,c){return a[b]=String(c),a},{}),e="0123456789".split("").reduce(function(a,b){return a[b]="invalid",a},{}),c=d(e,c)),[A("infinity",b),d({},B,J(b)),g[0],g[10].replace("%","").replace("\u2030",""),c]},L=function(a,b){if("decimal"!==a&&"percent"!==a)throw new Error("Invalid style");return b.main(["numbers",a+"Formats-numberSystem-"+w(b),"standard"])};function M(a){var b=a[2],c=a[3],d=a[4],e=a[5],f=a[6];if(isNaN(e*f)){if(!isNaN(e)||!isNaN(f))throw new Error("Neither or both the minimum and maximum significant digits must be present");k(b,"minimumIntegerDigits",1,21),k(c,"minimumFractionDigits",0,20),k(d,"maximumFractionDigits",c,20)}else k(e,"minimumSignificantDigits",1,21),k(f,"maximumSignificantDigits",e,21)}return b.numberFormatter=b.prototype.numberFormatter=function(a){var b,c,d,e,g;return m(a,"options"),a=a||{},c=this.cldr,b=[a],i(c),c.on("get",h),d=a.raw?a.raw:L(a.style||"decimal",c),e=F(d,c,a),c.off("get",h),M(e),g=v(e),f(b,c,g,[e]),g},b.numberParser=b.prototype.numberParser=function(a){var b,c,d,e,g;return m(a,"options"),a=a||{},c=this.cldr,b=[a],i(c),c.on("get",h),d=a.raw?a.raw:L(a.style||"decimal",c),e=K(d,c),c.off("get",h),g=I(e),f(b,c,g,[e]),g},b.formatNumber=b.prototype.formatNumber=function(a,b){return j(a,"value"),o(a,"value"),this.numberFormatter(b)(a)},b.parseNumber=b.prototype.parseNumber=function(a,b){return j(a,"value"),p(a,"value"),this.numberParser(b)(a)},b._createErrorUnsupportedFeature=n,b._numberNumberingSystem=w,b._numberPattern=L,b._numberSymbol=A,b._stringPad=g,b._validateParameterTypeNumber=o,b._validateParameterTypeString=p,b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","./number","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._alwaysArray,d=b._formatMessage,e=b._numberNumberingSystem,f=b._numberPattern,g=b._runtimeBind,h=b._stringPad,i=b._validateCldr,j=b._validateDefaultLocale,k=b._validateParameterPresence,l=b._validateParameterType,m=b._validateParameterTypeNumber,n=b._validateParameterTypePlainObject,o=function(a,b){l(a,b,void 0===a||"string"==typeof a&&/^[A-Za-z]{3}$/.test(a),"3-letter currency code string as defined by ISO 4217")},p=function(a,b,c){var d,e="",f=c.supplemental(["currencyData/fractions",a])||c.supplemental("currencyData/fractions/DEFAULT");return d=+f._digits,d&&(e="."+h("0",d).slice(0,-1)+f._rounding),b.replace(/\.(#+|0*[0-9]|0+[0-9]?)/g,e)},q=function(a,b){var c,d={};for(c in a)b.test(c)&&(d[c]=a[c]);return d},r=function(a){return q(a.main(["numbers","currencyFormats-numberSystem-"+e(a)]),/^unitPattern/)},s=function(a,b){var c=f("decimal",b);return c=p(a,c,b),{currency:a,pattern:c,unitPatterns:r(b)}},t=function(a,b,c){var e,f,g=c.displayNames||{},h=c.unitPatterns;return e=g["displayName-count-"+b]||g["displayName-count-other"]||g.displayName||c.currency,f=h["unitPattern-count-"+b]||h["unitPattern-count-other"],d(f,[a,e])},u=function(a,b,c){var d;return d=b&&c?function d(e){return k(e,"value"),m(e,"value"),t(a(e),b(e),c)}:function b(c){return a(c)}},v=function(a,b){var c=s(a,b);return c.displayNames=q(b.main(["numbers/currencies",a]),/^displayName/),c},w=/[\0-#%-\*,-;\?-\]_a-\{\}\x7F-\xA1\xA7\xAA\xAB\xAD\xB2\xB3\xB5-\xB7\xB9-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u0383\u0386-\u03F5\u03F7-\u0481\u0483-\u058C\u0590-\u0605\u0609\u060A\u060C\u060D\u0610-\u06DD\u06DF-\u06E8\u06EA-\u06FC\u06FF-\u07F5\u07F7-\u09F1\u09F4-\u09F9\u09FC-\u0AF0\u0AF2-\u0B6F\u0B71-\u0BF2\u0BFB-\u0C7E\u0C80-\u0D78\u0D7A-\u0E3E\u0E40-\u0F00\u0F04-\u0F12\u0F14\u0F18\u0F19\u0F20-\u0F33\u0F35\u0F37\u0F39-\u0FBD\u0FC6\u0FCD\u0FD0-\u0FD4\u0FD9-\u109D\u10A0-\u138F\u139A-\u17DA\u17DC-\u193F\u1941-\u19DD\u1A00-\u1B60\u1B6B-\u1B73\u1B7D-\u1FBC\u1FBE\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF-\u2043\u2045-\u2051\u2053-\u2079\u207D-\u2089\u208D-\u209F\u20BE-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u218F\u2308-\u230B\u2329\u232A\u23FB-\u23FF\u2427-\u243F\u244B-\u249B\u24EA-\u24FF\u2768-\u2793\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2CE4\u2CEB-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u3003\u3005-\u3011\u3014-\u301F\u3021-\u3035\u3038-\u303D\u3040-\u309A\u309D-\u318F\u3192-\u3195\u31A0-\u31BF\u31E4-\u31FF\u321F-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u32FF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA835\uA83A-\uAA76\uAA7A-\uAB5A\uAB5C-\uD7FF\uDC00-\uFB28\uFB2A-\uFBB1\uFBC2-\uFDFB\uFDFE-\uFE61\uFE63\uFE67\uFE68\uFE6A-\uFF03\uFF05-\uFF0A\uFF0C-\uFF1B\uFF1F-\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5F-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]|\uD800[\uDC00-\uDD36\uDD40-\uDD78\uDD8A\uDD8B\uDD8D-\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFD-\uDFFF]|[\uD801\uD803-\uD819\uD81B-\uD82E\uD830-\uD833\uD836-\uD83A\uD83F-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDC76\uDC79-\uDEC7\uDEC9-\uDFFF]|\uD81A[\uDC00-\uDF3B\uDF40-\uDF44\uDF46-\uDFFF]|\uD82F[\uDC00-\uDC9B\uDC9D-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD65-\uDD69\uDD6D-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDDDE-\uDDFF\uDE42-\uDE44\uDE46-\uDEFF\uDF57-\uDFFF]|\uD835[\uDC00-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFFF]|\uD83B[\uDC00-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDD0F\uDD2F\uDD6C-\uDD6F\uDD9B-\uDDE5\uDE03-\uDE0F\uDE3B-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF\uDF2D-\uDF2F\uDF7E\uDF7F\uDFCF-\uDFD3\uDFF8-\uDFFF]|\uD83D[\uDCFF\uDD4B-\uDD4F\uDD7A\uDDA4\uDE43\uDE44\uDED0-\uDEDF\uDEED-\uDEEF\uDEF4-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDFFF]|[\uD800-\uDBFF]/,x=function(a,b,c){var d,f,g={"[:digit:]":/\d/,"[:^S:]":w},h=b.main(["numbers/currencies",a,"symbol"]);return d=["beforeCurrency","afterCurrency"].map(function(a){return b.main(["numbers","currencyFormats-numberSystem-"+e(b),"currencySpacing",a])}),f=b.main(["numbers","currencyFormats-numberSystem-"+e(b),"accounting"===c.style?"accounting":"standard"]),f=p(a,f,b).split(";").map(function(a){return a.split("\xa4").map(function(a,b){var c=g[d[b].currencyMatch],e=g[d[b].surroundingMatch],f="";return c=c.test(h.charAt(b?h.length-1:0)),e=e.test(a.charAt(b?0:a.length-1).replace(/[#@,.]/g,"0")),c&&a&&e&&(f=d[b].insertBetween),(b?f:"")+a+(b?"":f)}).join("'"+h+"'")}).join(";"),{pattern:f}},y=function(a,b){var d,e={};b=c(b);for(d in a)b.indexOf(d)===-1&&(e[d]=a[d]);return e};function z(a,b){i(a,b,{skip:[/supplemental\/currencyData\/fractions\/[A-Za-z]{3}$/]})}return b.currencyFormatter=b.prototype.currencyFormatter=function(a,b){var c,d,e,f,h,i,l;return k(a,"currency"),o(a,"currency"),n(b,"options"),d=this.cldr,b=b||{},c=[a,b],l=b.style||"symbol",j(d),d.on("get",z),h={accounting:x,code:s,name:v,symbol:x}[l](a,d,b),d.off("get",z),b=y(b,"style"),b.raw=h.pattern,"symbol"===l||"accounting"===l?(e=this.numberFormatter(b),i=u(e),g(c,d,i,[e])):(e=this.numberFormatter(b),f=this.pluralGenerator(),i=u(e,f,h),g(c,d,i,[e,f,h])),i},b.currencyParser=b.prototype.currencyParser=function(){},b.formatCurrency=b.prototype.formatCurrency=function(a,b,c){return k(a,"value"),m(a,"value"),this.currencyFormatter(b,c)(a)},b.parseCurrency=b.prototype.parseCurrency=function(){},b}),function(a,b){"function"==typeof define&&define.amd?define(["cldr","../globalize","./number","cldr/event","cldr/supplemental"],b):"object"==typeof exports?module.exports=b(require("cldrjs"),require("globalize")):b(a.Cldr,a.Globalize)}(this,function(a,b){var c=b._createError,d=b._createErrorUnsupportedFeature,e=b._formatMessage,f=b._numberSymbol,g=b._regexpEscape,h=b._runtimeBind,i=b._stringPad,j=b._validateCldr,k=b._validateDefaultLocale,l=b._validateParameterPresence,m=b._validateParameterType,n=b._validateParameterTypePlainObject,o=b._validateParameterTypeString,p=function(a,b){m(a,b,void 0===a||a instanceof Date,"Date")},q=function(a,b){return c("E_INVALID_PAR_VALUE","Invalid `{name}` value ({value}).",{name:a,value:b})},r=function(a,b){var c,d,f,g,h;function i(a,c,d){return e(b.main(["dates/calendars/gregorian/dateTimeFormats",a]),[d,c])}switch(!0){case"skeleton"in a:f=a.skeleton,d=b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",f]),d||(g=f.split(/[^hHKkmsSAzZOvVXx]/).slice(-1)[0],c=f.split(/[^GyYuUrQqMLlwWdDFgEec]/)[0],h=/(MMMM|LLLL).*[Ec]/.test(c)?"full":/MMMM/g.test(c)?"long":/MMM/g.test(c)||/LLL/g.test(c)?"medium":"short",d=i(h,b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",c]),b.main(["dates/calendars/gregorian/dateTimeFormats/availableFormats",g])));break;case"date"in a:case"time"in a:d=b.main(["dates/calendars/gregorian","date"in a?"dateFormats":"timeFormats",a.date||a.time]);break;case"datetime"in a:d=i(a.datetime,b.main(["dates/calendars/gregorian/dateFormats",a.datetime]),b.main(["dates/calendars/gregorian/timeFormats",a.datetime]));break;case"raw"in a:d=a.raw;break;default:throw q({name:"options",value:a})}return d},s=function(a,b){return(a.getDay()-b+7)%7},t=function(a,b){var c=864e5;return(b.getTime()-a.getTime())/c},u=function(a,b){switch(a=new Date(a.getTime()),b){case"year":a.setMonth(0);case"month":a.setDate(1);case"day":a.setHours(0);case"hour":a.setMinutes(0);case"minute":a.setSeconds(0);case"second":a.setMilliseconds(0)}return a},v=function(a){return Math.floor(t(u(a,"year"),a))},w=function(a){return a-u(a,"day")},x=/([a-z])\1*|'([^']|'')+'|''|./gi,y=function(a,b,c,d){var e,f=a.getTimezoneOffset();return e=Math.abs(f),d=d||{1:function(a){return i(a,1)},2:function(a){return i(a,2)}},b.split(";")[f>0?1:0].replace(":",c).replace(/HH?/,function(a){return d[a.length](Math.floor(e/60))}).replace(/mm/,function(){return d[2](e%60)})},z=["sun","mon","tue","wed","thu","fri","sat"],A=function(a,b,c){var d=c.timeSeparator;return c.pattern.replace(x,function(e){var f,g=e.charAt(0),h=e.length;switch("j"===g&&(g=c.preferredTime),"Z"===g&&(h<4?(g="x",h=4):h<5?(g="O",h=4):(g="X",h=5)),g){case"G":f=c.eras[a.getFullYear()<0?0:1];break;case"y":f=a.getFullYear(),2===h&&(f=String(f),f=+f.substr(f.length-2));break;case"Y":f=new Date(a.getTime()),f.setDate(f.getDate()+7-s(a,c.firstDay)-c.firstDay-c.minDays),f=f.getFullYear(),2===h&&(f=String(f),f=+f.substr(f.length-2));break;case"Q":case"q":f=Math.ceil((a.getMonth()+1)/3),h>2&&(f=c.quarters[g][h][f]);break;case"M":case"L":f=a.getMonth()+1,h>2&&(f=c.months[g][h][f]);break;case"w":f=s(u(a,"year"),c.firstDay),f=Math.ceil((v(a)+f)/7)-(7-f>=c.minDays?0:1);break;case"W":f=s(u(a,"month"),c.firstDay),f=Math.ceil((a.getDate()+f)/7)-(7-f>=c.minDays?0:1);break;case"d":f=a.getDate();break;case"D":f=v(a)+1;break;case"F":f=Math.floor(a.getDate()/7)+1;break;case"e":case"c":if(h<=2){f=s(a,c.firstDay)+1;break}case"E":f=z[a.getDay()],f=c.days[g][h][f];break;case"a":f=c.dayPeriods[a.getHours()<12?"am":"pm"];break;case"h":f=a.getHours()%12||12;break;case"H":f=a.getHours();break;case"K":f=a.getHours()%12;break;case"k":f=a.getHours()||24;break;case"m":f=a.getMinutes();break;case"s":f=a.getSeconds();break;case"S":f=Math.round(a.getMilliseconds()*Math.pow(10,h-3));break;case"A":f=Math.round(w(a)*Math.pow(10,h-3));break;case"z":case"O":0===a.getTimezoneOffset()?f=c.gmtZeroFormat:(f=y(a,h<4?"+H;-H":c.tzLongHourFormat,d,b),f=c.gmtFormat.replace(/\{0\}/,f));break;case"X":if(0===a.getTimezoneOffset()){f="Z";break}case"x":f=1===h?"+HH;-HH":h%2?"+HH:mm;-HH:mm":"+HHmm;-HHmm",f=y(a,f,":");break;case":":f=d;break;case"'":e=e.replace(/''/,"'"),h>2&&(e=e.slice(1,-1)),f=e;break;default:f=e}return"number"==typeof f&&(f=b[h](f)),f})},B=function(a,b){return function c(d){return l(d,"value"),p(d,"value"),A(d,a,b)}},C=function(a){return z.indexOf(a.supplemental.weekData.firstDay())},D=function(a,b){var c={numberFormatters:{},pattern:a,timeSeparator:f("timeSeparator",b)},e=["abbreviated","wide","narrow"];function g(a){c.numberFormatters[a]=i("",a)}return a.replace(x,function(a){var f,h=a.charAt(0),i=a.length;switch("j"===h&&(c.preferredTime=h=b.supplemental.timeData.preferred()),"Z"===h&&4===i&&(h="O",i=4),h){case"G":c.eras=b.main(["dates/calendars/gregorian/eras",i<=3?"eraAbbr":4===i?"eraNames":"eraNarrow"]);break;case"y":f=!0;break;case"Y":c.firstDay=C(b),c.minDays=b.supplemental.weekData.minDays(),f=!0;break;case"u":case"U":throw d({feature:"year pattern `"+h+"`"});case"Q":case"q":i>2?(c.quarters||(c.quarters={}),c.quarters[h]||(c.quarters[h]={}),c.quarters[h][i]=b.main(["dates/calendars/gregorian/quarters","Q"===h?"format":"stand-alone",e[i-3]])):f=!0;break;case"M":case"L":i>2?(c.months||(c.months={}),c.months[h]||(c.months[h]={}),c.months[h][i]=b.main(["dates/calendars/gregorian/months","M"===h?"format":"stand-alone",e[i-3]])):f=!0;break;case"w":case"W":c.firstDay=C(b),c.minDays=b.supplemental.weekData.minDays(),f=!0;break;case"d":case"D":case"F":f=!0;break;case"g":throw d({feature:"Julian day pattern `g`"});case"e":case"c":if(i<=2){c.firstDay=C(b),f=!0;break}case"E":c.days||(c.days={}),c.days[h]||(c.days[h]={}),6===i?c.days[h][i]=b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format","short"])||b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format","abbreviated"]):c.days[h][i]=b.main(["dates/calendars/gregorian/days","c"===h?"stand-alone":"format",e[i<3?0:i-3]]);break;case"a":c.dayPeriods=b.main("dates/calendars/gregorian/dayPeriods/format/wide");break;case"h":case"H":case"K":case"k":case"m":case"s":case"S":case"A":f=!0;break;case"z":case"O":c.gmtFormat=b.main("dates/timeZoneNames/gmtFormat"),c.gmtZeroFormat=b.main("dates/timeZoneNames/gmtZeroFormat"),c.tzLongHourFormat=b.main("dates/timeZoneNames/hourFormat");case"Z":case"X":case"x":g(1),g(2);break;case"v":case"V":throw d({feature:"timezone pattern `"+h+"`"})}f&&g(i)}),c},E=function(a){return 1===new Date(a,1,29).getMonth()},F=function(a){return new Date(a.getFullYear(),a.getMonth()+1,0).getDate()},G=function(a,b){var c=new Date(a.getFullYear(),a.getMonth()+1,0).getDate();a.setDate(b<1?1:b<c?b:c)},H=function(a,b){var c=a.getDate();a.setDate(1),a.setMonth(b),G(a,c)},I=function(a,b,c){return a<b||a>c},J=function(a,b,c){var e,f,g,h,i,j,k,l,m,n=0,o=1,p=2,q=3,r=4,s=5,t=6,v=new Date,w=[],x=["year","month","day","hour","minute","second","milliseconds"];if(!b.length)return null;if(m=b.every(function(a){var b,m,u,x;if("literal"===a.type)return!0;switch(m=a.type.charAt(0),x=a.type.length,"j"===m&&(m=c.preferredTimeData),m){case"G":w.push(n),i=+a.value;break;case"y":if(u=a.value,2===x){if(I(u,0,99))return!1;b=100*Math.floor(v.getFullYear()/100),u+=b,u>v.getFullYear()+20&&(u-=100)}v.setFullYear(u),w.push(n);break;case"Y":throw d({feature:"year pattern `"+m+"`"});case"Q":case"q":break;case"M":case"L":if(u=x<=2?a.value:+a.value,I(u,1,12))return!1;h=u,w.push(o);break;case"w":case"W":break;case"d":f=a.value,w.push(p);break;case"D":g=a.value,w.push(p);break;case"F":break;case"e":case"c":case"E":break;case"a":e=a.value;break;case"h":if(u=a.value,I(u,1,12))return!1;j=k=!0,v.setHours(12===u?0:u),w.push(q);break;case"K":if(u=a.value,I(u,0,11))return!1;j=k=!0,v.setHours(u),w.push(q);break;case"k":if(u=a.value,I(u,1,24))return!1;j=!0,v.setHours(24===u?0:u),w.push(q);break;case"H":if(u=a.value,I(u,0,23))return!1;j=!0,v.setHours(u),w.push(q);break;case"m":if(u=a.value,I(u,0,59))return!1;v.setMinutes(u),w.push(r);break;case"s":if(u=a.value,I(u,0,59))return!1;v.setSeconds(u),w.push(s);break;case"A":v.setHours(0),v.setMinutes(0),v.setSeconds(0);case"S":u=Math.round(a.value*Math.pow(10,3-x)),v.setMilliseconds(u),w.push(t);break;case"Z":case"z":case"O":case"X":case"x":l=a.value-v.getTimezoneOffset()}return!0}),!m)return null;if(j&&!(!e^k))return null;if(0===i&&v.setFullYear(v.getFullYear()*-1+1),void 0!==h&&H(v,h-1),void 0!==f){if(I(f,1,F(v)))return null;v.setDate(f)}else if(void 0!==g){if(I(g,1,E(v.getFullYear())?366:365))return null;v.setMonth(0),v.setDate(g)}return k&&"pm"===e&&v.setHours(v.getHours()+12),l&&v.setMinutes(v.getMinutes()+l),w=Math.max.apply(null,w),v=u(v,x[w])},K=/[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDD16-\uDD1B\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9]|\uD806[\uDCE0-\uDCF2]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]/,L=function(a,b,c){var d,e=c.timeSeparator,f=[],h=["abbreviated","wide","narrow"];return d=c.pattern.match(x).every(function(d){var i,j,k,l,m={};function n(b,c){var d=a.match(b);return c=c||function(a){return+a},!!d&&(d.length<8?m.value=60*(d[1]?-c(d[1]):c(d[4])):m.value=60*(d[1]?-c(d[1]):c(d[7]))+(d[1]?-c(d[4]):c(d[10])),!0)}function o(a,b,c){var d;return b||(b="{0}"),d=a.replace("+","\\+").replace(/HH|mm/g,"(("+K.source+")("+K.source+"))").replace(/H|m/g,"(("+K.source+")("+K.source+")?)"),c&&(d=d.replace(/:/g,c)),d=d.split(";").map(function(a){return b.replace("{0}",a)}).join("|"),new RegExp(d)}function p(){if(1===j)return k=!0,l=K}function q(){if(1===j)return k=!0,l=new RegExp("("+K.source+")("+K.source+")?")}function r(){if(2===j)return k=!0,l=new RegExp("("+K.source+")("+K.source+")")}function s(b){var d,e,f=c[b.join("/")];for(d in f)if(e=new RegExp("^"+f[d]),e.test(a))return m.value=d,l=new RegExp(f[d]);return null}switch(m.type=d,i=d.charAt(0),j=d.length,"Z"===i&&(j<4?(i="x",j=4):j<5?(i="O",j=4):(i="X",j=5)),i){case"G":s(["gregorian/eras",j<=3?"eraAbbr":4===j?"eraNames":"eraNarrow"]);break;case"y":case"Y":k=!0,l=1===j?new RegExp("("+K.source+")+"):2===j?new RegExp("("+K.source+")("+K.source+")"):new RegExp("("+K.source+"){"+j+",}");break;case"Q":case"q":p()||r()||s(["gregorian/quarters","Q"===i?"format":"stand-alone",h[j-3]]);break;case"M":case"L":q()||r()||s(["gregorian/months","M"===i?"format":"stand-alone",h[j-3]]);break;case"D":j<=3&&(k=!0,l=new RegExp("("+K.source+"){"+j+",3}"));break;case"W":case"F":
p();break;case"e":case"c":if(j<=2){p()||r();break}case"E":6===j?s(["gregorian/days",["c"===i?"stand-alone":"format"],"short"])||s(["gregorian/days",["c"===i?"stand-alone":"format"],"abbreviated"]):s(["gregorian/days",["c"===i?"stand-alone":"format"],h[j<3?0:j-3]]);break;case"a":s(["gregorian/dayPeriods/format/wide"]);break;case"w":case"d":case"h":case"H":case"K":case"k":case"j":case"m":case"s":q()||r();break;case"S":k=!0,l=new RegExp("("+K.source+"){"+j+"}");break;case"A":k=!0,l=new RegExp("("+K.source+"){"+(j+5)+"}");break;case"z":case"O":if(a===c["timeZoneNames/gmtZeroFormat"])m.value=0,l=new RegExp(c["timeZoneNames/gmtZeroFormat"]);else if(l=o(j<4?"+H;-H":c["timeZoneNames/hourFormat"],c["timeZoneNames/gmtFormat"],e),!n(l,b))return null;break;case"X":if("Z"===a){m.value=0,l=/Z/;break}case"x":if(l=o(1===j?"+HH;-HH":j%2?"+HH:mm;-HH:mm":"+HHmm;-HHmm"),!n(l))return null;break;case"'":m.type="literal",d=d.replace(/''/,"'"),j>2&&(d=d.slice(1,-1)),l=new RegExp(g(d));break;default:m.type="literal",l=/./}return!!l&&(a=a.replace(new RegExp("^"+l.source),function(a){return m.lexeme=a,k&&(m.value=b(a)),""}),!!m.lexeme&&(f.push(m),!0))}),""!==a&&(d=!1),d?f:[]},M=function(a,b,c){return function d(e){var f;return l(e,"value"),o(e,"value"),f=L(e,a,c),J(e,f,b)||null}},N=function(a){return{preferredTimeData:a.supplemental.timeData.preferred()}},O=function(a,b){var c={pattern:a,timeSeparator:f("timeSeparator",b)},e=["abbreviated","wide","narrow"];function g(a,b){c[a.replace(/^.*\/dates\//,"").replace(/calendars\//,"")]=b}return b.on("get",g),a.match(x).forEach(function(a){var c,f;switch(c=a.charAt(0),f=a.length,"Z"===c&&f<5&&(c="O",f=4),c){case"G":b.main(["dates/calendars/gregorian/eras",f<=3?"eraAbbr":4===f?"eraNames":"eraNarrow"]);break;case"u":case"U":throw d({feature:"year pattern `"+c+"`"});case"Q":case"q":f>2&&b.main(["dates/calendars/gregorian/quarters","Q"===c?"format":"stand-alone",e[f-3]]);break;case"M":case"L":f>2&&b.main(["dates/calendars/gregorian/months","M"===c?"format":"stand-alone",e[f-3]]);break;case"g":throw d({feature:"Julian day pattern `g`"});case"e":case"c":if(f<=2)break;case"E":6===f?b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],"short"])||b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],"abbreviated"]):b.main(["dates/calendars/gregorian/days",["c"===c?"stand-alone":"format"],e[f<3?0:f-3]]);break;case"a":b.main(["dates/calendars/gregorian/dayPeriods/format/wide"]);break;case"z":case"O":b.main("dates/timeZoneNames/gmtFormat"),b.main("dates/timeZoneNames/gmtZeroFormat"),b.main("dates/timeZoneNames/hourFormat");break;case"v":case"V":throw d({feature:"timezone pattern `"+c+"`"})}}),b.off("get",g),c};function P(a,b){j(a,b,{skip:[/dates\/calendars\/gregorian\/dateTimeFormats\/availableFormats/,/dates\/calendars\/gregorian\/days\/.*\/short/,/supplemental\/timeData\/(?!001)/,/supplemental\/weekData\/(?!001)/]})}return b.dateFormatter=b.prototype.dateFormatter=function(a){var b,c,d,e,f,g,i;n(a,"options"),c=this.cldr,a=a||{skeleton:"yMd"},b=[a],k(c),c.on("get",P),f=r(a,c),g=D(f,c),c.off("get",P),d=g.numberFormatters,delete g.numberFormatters;for(e in d)d[e]=this.numberFormatter({raw:d[e]});return i=B(d,g),h(b,c,i,[d,g]),i},b.dateParser=b.prototype.dateParser=function(a){var b,c,d,e,f,g,i;return n(a,"options"),c=this.cldr,a=a||{skeleton:"yMd"},b=[a],k(c),c.on("get",P),f=r(a,c),g=O(f,c),e=N(c),c.off("get",P),d=this.numberParser({raw:"0"}),i=M(d,e,g),h(b,c,i,[d,e,g]),i},b.formatDate=b.prototype.formatDate=function(a,b){return l(a,"value"),p(a,"value"),this.dateFormatter(b)(a)},b.parseDate=b.prototype.parseDate=function(a,b){return l(a,"value"),o(a,"value"),this.dateParser(b)(a)},b}),"undefined"!=typeof GenericEventListener&&GenericEventListener&&GenericEventListener.topicNamespace||(GenericEventListener={_loaded:!1,_useHostedCMLib:!1,initializer:function(){},load:function(){load(!1)},load:function(a){this._loaded===!1&&(wcTopic.subscribe("/wc/analytics/pageview",$.proxy(this.handlePageView,this)),wcTopic.subscribe("/wc/analytics/productview",$.proxy(this.handleProductView,this)),wcTopic.subscribe("/wc/analytics/cartview",$.proxy(this.handleCartView,this)),wcTopic.subscribe("/wc/analytics/addcart",$.proxy(this.handleAddCart,this)),wcTopic.subscribe("/wc/analytics/element",$.proxy(this.handleElement,this)),wcTopic.subscribe("/wc/analytics/registration",$.proxy(this.handleRegistration,this)),wcTopic.subscribe("/wc/analytics/conversionevent",$.proxy(this.handleConversionEvent,this)),this._loaded=!0,a===!0&&(this._useHostedCMLib=!0))},handlePageView:function(a){},handleProductView:function(a){},handleCartView:function(a){},handleAddCart:function(a){},handleElement:function(a){},handleRegistration:function(a){},handleConversionEvent:function(a){}}),"undefined"!=typeof CoremetricsEventListener&&CoremetricsEventListener&&CoremetricsEventListener.topicNamespace||(CoremetricsEventListener=$.extend(GenericEventListener,{PARAM_STORE_ID:"storeId",handlePageView:function(a){var b=!1;b&&window.alert("handlePageView");var c="pagename",d="pageType",e="category",f="searchTerms",g="searchCount",h="options",i="debug",j="extraParams",k="attributes",l="useDDX",m="true",n=document.title,o=null,p=null,q=null,r=null,s=null,t=null,u=this._getStoreId(),v=new Array,w=!1,y=!1;for(x in a)if(x===h){var z=a[x];z===l&&(w=!0)}else if(x===i){var A=a[x];A===m&&(y=!0)}else x===c?n=a[x]:x===d?o=a[x]:x===e?p="null"===a[x]||""===a[x]?null:a[x]:x===f?q="null"===a[x]||""===a[x]?null:a[x]:x===g?r="null"===a[x]||""===a[x]?null:a[x]:x===this.PARAM_STORE_ID?u=a[x]:w?x===j?t=a[x]:x===k&&(s=a[x]):(v.push(a[x]),null!==t?t+=", ":t="",t+=null==a[x]||"null"===a[x]?"null":'"'===a[x].charAt(0)&&'"'===a[x].charAt(a[x].length-1)?a[x]:'"'+a[x]+'"');w?(null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=s&&"null"!==s&&"'null'"!==s||(s=""),null!=t&&"null"!==t&&"'null'"!==t||(t=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),"undefined"==typeof digitalData&&(digitalData={}),digitalData.page={pageInfo:{pageID:n,onsiteSearchTerm:q,onsiteSearchResults:r},category:{primaryCategory:p},attributes:{exploreAttributes:s,extraFields:t}},digitalData.pageInstanceID=o,b&&window.alert(JSON.stringify(digitalData))):(this._useHostedCMLib?v.unshift(n,p,q,r):v.unshift(n,p,q,r,u),cmCreatePageviewTag.apply({},v));var B=JSON.stringify(a),a=document.getElementById("cm-pageview");if(y&&null!==a){if(w){var C="digitalData = { ";C+="page:{pageInfo:{pageID: '"+n+"', onsiteSearchTerm: '"+q+"', onsiteSearchResults: '"+r+"'}, category:{primaryCategory: '"+p+"'},",C+="attributes:{exploreAttributes: '"+s+"' ,extraFields: '"+t+"'}},",C+="pageInstanceID: '"+o+"' };",b&&window.alert(C)}else{var C="cmCreatePageviewTag(";C+=null!==n&&""!==n&&"null"!==n?'"'+n+'", ':"null, ",C+=null!==p&&""!==p&&"null"!==p?'"'+p+'", ':"null, ",C+=null!==q&&""!==q&&"null"!==q?'"'+q+'", ':"null, ",C+=null!==r&&""!==r&&"null"!==r?'"'+r+'"':"null",this._useHostedCMLib||(C+=null!==u&&""!==u&&"null"!==u?', "'+u+'"':", null"),null!==t&&(C+=", "+t),C+=");"}var D=document.createTextNode(B);a.appendChild(D),a.appendChild(document.createElement("br"));var E=document.createTextNode(C);a.appendChild(E),a.appendChild(document.createElement("br"))}},handleConversionEvent:function(a){var b=!1;b&&window.alert("handleConversionEvent");var c="eventId",d="category",e="actionType",f="points",g="options",h="debug",i="extraParams",j="attributes",k="useDDX",l="true",m=null,n=null,o=null,p=null,q=null,r=null,s=this._getStoreId(),t=new Array,u=!1,v=!1;for(x in a)if(x===g)var w=a[x];else if(x===h){var y=a[x];y===l&&(v=!0)}else x===c?m=a[x]:x===d?n=a[x]:x===e?o=a[x]:x===f?p=a[x]:u?x===i?r=a[x]:x===j&&(q=a[x]):t.push(a[x]);u?(null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-conversionevent"),digitalData.event=[{eventInfo:{eventName:m,eventAction:o,eventPoints:p},category:{primaryCategory:n},attributes:{exploreAttributes:q,extraFields:r}}],b&&window.alert(JSON.stringify(digitalData))):(t.unshift(m,o,n,p),cmCreateConversionEventTag.apply({},t));var z=JSON.stringify(a),a=document.getElementById("cm-conversionevent");if(v&&null!==a){if(u){var A="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(A+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),A+="event:[{eventInfo:{eventName: '"+m+"', eventAction: '"+o+"', eventPoints: '"+p+"'}, category:{primaryCategory: '"+n+"'}, attributes:{exploreAttributes: '"+q+"', extraFields: '"+r+"'}}]}",b&&window.alert(A)}else{var A="cmCreateConversionEventTag(";A+=null!==m&&""!==m?'"'+m+'", ':"null, ",A+=null!==o&&""!==o?'"'+o+'", ':"null, ",A+=null!==n&&""!==n?'"'+n+'", ':"null, ",A+=null!==p&&""!==p?'"'+p+'"':"null",A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}},handleProductView:function(a){var b=!1;b&&window.alert("handleProductView");var c="productId",d="name",e="category",f="masterCategory",g="virtualCategory",h="attributes",i="useDDX",j="true",k=null,l=null,m=null,n=null,o=null,p=null,q=this._getStoreId(),r=null,s=!1,t=!1;if(a.options===i&&(s=!0),a.debug===j&&(t=!0),a.product&&$.isArray(a.product)){s&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-productdetail"),digitalData.product=new Array);for(var u=a.product,v=0;v<u.length;v++){var w=u[v],y=new Array;for(x in w)x===c?k=w[x]:x===d?l=w[x]:x===e?m=w[x]:x===f?n=w[x]:x===this.PARAM_STORE_ID?q=w[x]:s?x===h?o=w[x]:x===g&&(p=w[x]):(y.push(w[x]),null!==r?r+=", ":r="",r+=null==w[x]||"null"===w[x]?"null":'"'===w[x].charAt(0)&&'"'===w[x].charAt(w[x].length-1)?w[x]:'"'+w[x]+'"');if(null==k||null==l||null==m||null==n);else{s?(null!=k&&"null"!==k&&"'null'"!==k||(k=""),null!=l&&"null"!==l&&"'null'"!==l||(l=""),null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),digitalData.product[v]={productInfo:{productID:k,productName:l},category:{primaryCategory:m,virtualCategory:p},attributes:{exploreAttributes:o}},b&&window.alert(JSON.stringify(digitalData))):(this._useHostedCMLib?y.unshift(k,l,m):y.unshift(null,k,l,m,q,"N",n),cmCreateProductviewTag.apply({},y));var z=JSON.stringify(a),a=document.getElementById("cm-productview");if(t&&null!==a){if(s){var A="digitalData.product["+v+"] = { ";A+="productInfo:{productID: '"+k+"', productName: '"+l+"'},category:{primaryCategory: '"+m+"', virtualCategory: '"+p+"'},attributes:{exploreAttributes: '"+o+"'}};",b&&window.alert(A)}else{var A="";A=this._useHostedCMLib?"cmCreateProductviewTag(":"cmCreateProductviewTag(null, ",A+=null!==k&&""!==k?'"'+k+'", ':"null, ",null!==l&&""!==l?(l=l.replace(/\"/g,'\\"'),A+='"'+l+'", '):A+="null, ",A+=null!==m&&""!==m?'"'+m+'"':"null",this._useHostedCMLib||(A+=null!==q&&""!==q?', "'+q+'", "N", ':', null, "N", ',A+=null!==n&&""!==n?'"'+n+'"':"null"),null!==r&&(A+=", "+r),A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}}}}},handleCartView:function(a){var b=!1;b&&window.alert("handleCartView");var c="productId",d="name",e="category",f="masterCategory",g="quantity",h="price",i="currency",j="extraParams",k="attributes",l="useDDX",m="true",n="false",o=null,p=null,q=null,r=!1,s=!0,t=!1;a.options===l&&(r=!0),a.useCMSetupOther===m?s=!0:a.useCMSetupOther===n&&(s=!1),a.debug===m&&(t=!0);var u=!1;if(a.cart&&$.isArray(a.cart)){r&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-cart"),digitalData.cart={},digitalData.cart.item=new Array);for(var v=a.cart,w=0;w<v.length;w++){var y=null,z=null,A=null,B=null,C=null,D=null,E=null,F=this._getStoreId(),G=new Array,p=null,H=v[w];for(x in H)x===c?y=H[x]:x===d?z=H[x]:x===e?A=H[x]:x===f?B=H[x]:x===g?C=H[x]:x===h?D=H[x]:x===i?E=H[x]:x===this.PARAM_STORE_ID?F=H[x]:r?x===k?o=H[x]:x===j&&(p=H[x]):(G.push(H[x]),null!==p?p+=", ":p="",p+=null==H[x]||"null"===H[x]?"null":'"'===H[x].charAt(0)&&'"'===H[x].charAt(H[x].length-1)?H[x]:'"'+H[x]+'"');if(null==y||null==z||null==A||null==B||null==C||null==D||null==E);else{if(r)null!=y&&"null"!==y&&"'null'"!==y||(y=""),null!=z&&"null"!==z&&"'null'"!==z||(z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),digitalData.cart.item[w]={},digitalData.cart.item[w]={productInfo:{productID:y,productName:z},quantity:C,price:D,currency:E,category:{primaryCategory:A,virtualCategory:q},attributes:{exploreAttributes:o,extraFields:p}},s&&cmSetupOther({cm_currencyCode:'"'+E+'"'}),b&&window.alert(JSON.stringify(digitalData));else if(u=!0,this._useHostedCMLib){cmSetCurrencyCode(E);var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J='cmSetCurrencyCode("'+E+'");',K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}G.unshift(y,z,C,D,A),cmCreateShopAction5Tag.apply({},G)}else G.unshift(y,z,C,D,A,F,E,B),cmCreateShopAction5Tag.apply({},G);var L=JSON.stringify(a),a=document.getElementById("cm-shopAction");if(t&&null!==a){if(r){var M="digitalData.cart.item["+w+"] = { ";M+="productInfo:{productID: '"+y+"', productName: '"+z+"'}, quantity: '"+C+"', price: '"+D+"', currency: '"+E+"', category:{primaryCategory: '"+A+"', virtualCategory: '"+q+"'}, attributes:{exploreAttributes: '"+o+"', extraFields: '"+p+"'}};",s&&(M+='cmSetupOther({"cm_currencyCode":"'+E+'"});'),b&&window.alert(M)}else{var M="cmCreateShopAction5Tag(";M+=null!==y&&""!==y?'"'+y+'", ':"null, ",null!==z&&""!==z?(z=z.replace(/\"/g,'\\"'),M+='"'+z+'", '):M+="null, ",M+=null!==C&&""!==C?'"'+C+'", ':"null, ",M+=null!==D&&""!==D?'"'+D+'", ':"null, ",M+=null!==A&&""!==A?'"'+A+'"':"null",this._useHostedCMLib||(M+=null!==F&&""!==F?', "'+F+'", ':", null, ",M+=null!==E&&""!==E?'"'+E+'", ':"null, ",M+=null!==B&&""!==B?'"'+B+'"':"null"),null!==p&&(M+=", "+p),M+=");"}var N=document.createTextNode(L);a.appendChild(N),a.appendChild(document.createElement("br"));var O=document.createTextNode(M);a.appendChild(O),a.appendChild(document.createElement("br"))}}}}if(u){cmDisplayShop5s();var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J="cmDisplayShop5s();",K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}}},handleAddCart:function(a){var b=!1;b&&window.alert("handleAddCart");var c="productId",d="name",e="category",f="masterCategory",g="quantity",h="price",i="currency",j="extraParams",k="attributes",l="useDDX",m="true",n="false",o=null,p=null,q=null,r=!1,s=!0,t=!1;a.useCMSetupOther===m?s=!0:a.useCMSetupOther===n&&(s=!1),a.debug===m&&(t=!0);var u=!1;if(a.cart&&$.isArray(a.cart)){r&&("undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-cart"),digitalData.cart={},digitalData.cart.item=new Array);for(var v=a.cart,w=0;w<v.length;w++){var y=null,z=null,A=null,B=null,C=null,D=null,E=null,F=this._getStoreId(),G=new Array,p=null,H=v[w];for(x in H)x===c?y=H[x]:x===d?z=H[x]:x===e?A=H[x]:x===f?B=H[x]:x===g?C=H[x]:x===h?D=H[x]:x===i?E=H[x]:x===this.PARAM_STORE_ID?F=H[x]:r?x===k?o=H[x]:x===j&&(p=H[x]):(G.push(H[x]),null!==p?p+=", ":p="",p+=null==H[x]||"null"===H[x]?"null":'"'===H[x].charAt(0)&&'"'===H[x].charAt(H[x].length-1)?H[x]:'"'+H[x]+'"');if(null==y||null==z||null==A||null==B||null==C||null==D||null==E);else{if(r)null!=y&&"null"!==y&&"'null'"!==y||(y=""),null!=z&&"null"!==z&&"'null'"!==z||(z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=q&&"null"!==q&&"'null'"!==q||(q=""),null!=o&&"null"!==o&&"'null'"!==o||(o=""),null!=p&&"null"!==p&&"'null'"!==p||(p=""),digitalData.cart.item[w]={},digitalData.cart.item[w]={productInfo:{productID:y,productName:z},quantity:C,price:D,currency:E,category:{primaryCategory:A,virtualCategory:q},attributes:{exploreAttributes:o,extraFields:p}},s&&cmSetupOther({cm_currencyCode:'"'+E+'"'}),b&&window.alert(JSON.stringify(digitalData));else if(u=!0,this._useHostedCMLib){cmSetCurrencyCode(E);var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J='cmSetCurrencyCode("'+E+'");',K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}G.unshift(y,z,C,D,A),cmCreateShopAction5Tag.apply({},G)}else G.unshift(y,z,C,D,A,F,E,B),cmCreateShopAction5Tag.apply({},G);var L=JSON.stringify(a),a=document.getElementById("cm-shopAction");if(t&&null!==a){if(r){var M="digitalData.cart.item["+w+"] = { ";M+="productInfo:{productID: '"+y+"', productName: '"+z+"'}, quantity: '"+C+"', price: '"+D+"', currency: '"+E+"', category:{primaryCategory: '"+A+"', virtualCategory: '"+q+"'}, attributes:{exploreAttributes: '"+o+"', extraFields: '"+p+"'}};",s&&(M+='cmSetupOther({"cm_currencyCode":"'+E+'"});'),b&&window.alert(M)}else{var M="cmCreateShopAction5Tag(";M+=null!==y&&""!==y?'"'+y+'", ':"null, ",null!==z&&""!==z?(z=z.replace(/\"/g,'\\"'),M+='"'+z+'", '):M+="null, ",M+=null!==C&&""!==C?'"'+C+'", ':"null, ",M+=null!==D&&""!==D?'"'+D+'", ':"null, ",M+=null!==A&&""!==A?'"'+A+'"':"null",this._useHostedCMLib||(M+=null!==F&&""!==F?', "'+F+'", ':", null, ",M+=null!==E&&""!==E?'"'+E+'", ':"null, ",M+=null!==B&&""!==B?'"'+B+'"':"null"),null!==p&&(M+=", "+p),M+=");"}var N=document.createTextNode(L);a.appendChild(N),a.appendChild(document.createElement("br"));var O=document.createTextNode(M);a.appendChild(O),a.appendChild(document.createElement("br"))}}}}if(u){cmDisplayShop5s();var I=document.getElementById("cm-shopAction");if(t&&null!==I){var J="cmDisplayShop5s();",K=document.createTextNode(J);I.appendChild(K),I.appendChild(document.createElement("br"))}}},handleElement:function(a){var b=!1;b&&window.alert("handleElement");var c="elementId",d="category",e="pageId",f="pageCategory",g="location",h="options",i="debug",j="extraParams",k="useDDX",l="true",m=null,n=null,o=null,p=null,q=null,r=null,s=this._getStoreId(),t=new Array,u=!1,v=!1;for(x in a)if(x===h){var w=a[x];w===k&&(u=!0)}else if(x===i){var y=a[x];y===l&&(v=!0)}else x===c?m=a[x]:x===d?n=a[x]:x===e?o=a[x]:x===f?p=a[x]:x===g?q=a[x]:x===this.PARAM_STORE_ID?s=a[x]:u?x===j&&(r=a[x]):t.push(a[x]);if(null==m);else{u?(null!=m&&"null"!==m&&"'null'"!==m||(m=""),null!=n&&"null"!==n&&"'null'"!==n||(n=""),null!=r&&"null"!==r&&"'null'"!==r||(r=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-element"),digitalData.component=[{componentInfo:{componentID:m},category:{primaryCategory:n},attributes:{exploreAttributes:r}}],b&&window.alert(JSON.stringify(digitalData))):this._useHostedCMLib?(t.unshift(m,n),cmCreateElementTag.apply({},t)):(t.unshift(m,n,o,p,q,s),cmCreatePageElementTag.apply({},t));var z=JSON.stringify(a),a=document.getElementById("cm-element");if(v&&null!==a){if(u){var A="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(A+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),A+="component:[{componentInfo:{componentID: '"+m+"'},category:{primaryCategory: '"+n+"'},attributes:{exploreAttributes: '"+r+"'}}]}",b&&window.alert(A)}else{var A="";A=this._useHostedCMLib?"cmCreateElementTag(":"cmCreatePageElementTag(",A+=null!==m&&""!==m?'"'+m+'", ':"null, ",A+=null!==n&&""!==n?'"'+n+'"':"null",this._useHostedCMLib||(A+=null!==o&&""!==o?', "'+o+'", ':", null, ",A+=null!==p&&""!==p?'"'+p+'", ':"null, ",A+=null!==q&&""!==q?'"'+q+'", ':"null, ",A+=null!==s&&""!==s?'"'+s+'"':"null"),A+=");"}var B=document.createTextNode(z);a.appendChild(B),a.appendChild(document.createElement("br"));var C=document.createTextNode(A);a.appendChild(C),a.appendChild(document.createElement("br"))}}},handleRegistration:function(a){var b=!1;b&&window.alert("handleRegistration");var c="userId",d="userEmail",e="userCity",f="userState",g="userZip",h="newsletterName",i="subscribedFlag",j="storeId",k="userCountry",l="age",m="gender",n="maritalStatus",o="numChildren",p="numInHousehold",q="companyName",r="hobbies",s="income",t="extraParams0",u="options",v="debug",w="extraParams",y="useDDX",z="true",A=null,B=null,C=null,D=null,E=null,F=null,G=null,H=null,I=null,J=null,K=null,L=null,M=null,N=null,O=null,P=null,Q=null,R=this._getStoreId(),S=new Array,T=null,U=!1,V=!1;for(x in a)if(x===u){var W=a[x];W===y&&(U=!0)}else if(x===v){var X=a[x];X===z&&(V=!0)}else if(x===c)A=a[x];else if(x===d)B=a[x];else if(x===e)C=a[x];else if(x===f)D=a[x];else if(x===g)E=a[x];else if(x===h)F=a[x];else if(x===i)G=a[x];else if(x===j)R=a[x];else if(x===k)H=a[x];else if(x===l){var Y=a[x];I="0"===Y||""===Y?"null":Y}else if(x===m){var Y=a[x];J=""===Y?"null":Y}else if(x===n){var Y=a[x];K=""===Y?"null":Y}else if(x===o){var Y=a[x];L="0"===Y||""===Y?"null":Y}else if(x===p){var Y=a[x];M="0"===Y||""===Y?"null":Y}else if(x===q){var Y=a[x];N=""===Y?"null":Y}else if(x===r){var Y=a[x];O=""===Y?"null":Y}else if(x===s){var Y=a[x];P="0"===Y||""===Y?"null":Y}else if(x===t){var Y=a[x];Q="0"===Y||""===Y?"null":Y}else U?x===w&&(T=a[x]):(S.push(a[x]),T=null==T?'"'+a[x]+'"':', "'+a[x]+'"');var Z="";this._useHostedCMLib||U?(null!=I&&"null"!==I||(I=""),null!=J&&"null"!==J||(J=""),null!=K&&"null"!==K||(K=""),null!=L&&"null"!==L||(L=""),null!=M&&"null"!==M||(M=""),null!=N&&"null"!==N||(N=""),null!=O&&"null"!==O||(O=""),null!=P&&"null"!==P||(P=""),Z=I+"-_-"+J+"-_-"+K+"-_-"+L+"-_-"+M+"-_-"+N+"-_-"+O+"-_-"+P,null!==Q&&"null"!==Q&&(Z+="-_-"+Q),S.unshift(A,B,C,D,E,H,Z)):S.unshift(A,B,C,D,E,F,G,R,H,I,J,K,L,M,N,O,P),U?(null!=A&&"null"!==A&&"'null'"!==A||(A=""),null!=B&&"null"!==B&&"'null'"!==B||(B=""),null!=Z&&"null"!==Z&&"'null'"!==Z||(Z=""),null!=C&&"null"!==C&&"'null'"!==C||(C=""),null!=D&&"null"!==D&&"'null'"!==D||(D=""),null!=E&&"null"!==E&&"'null'"!==E||(E=""),null!=H&&"null"!==H&&"'null'"!==H||(H=""),"undefined"==typeof digitalData&&(digitalData={},digitalData.pageInstanceID="wcs-standardpage_wcs-registration"),digitalData.user=[{profile:[{profileInfo:{profileID:A,profileEmail:B,exploreAttributes:Z},address:{city:C,state_province:D,postalcode:E,country:H}}]}],b&&window.alert(JSON.stringify(digitalData))):cmCreateRegistrationTag.apply({},S);var $=JSON.stringify(a),a=document.getElementById("cm-registration");if(V&&null!==a){if(U){var _="digitalData = { ";null!==digitalData.pageInstanceID&&""!==digitalData.pageInstanceID&&(_+="pageInstanceID:'"+digitalData.pageInstanceID+"', "),_+="user:[{profile:[{profileInfo:{profileID: '"+A+"', profileEmail: '"+B+"', exploreAttributes: '"+Z+"'}, address:{city: '"+C+"', state_province: '"+D+"',postalcode: '"+E+"', country: '"+H+"'}}]}]}",b&&window.alert(_)}else{var _="cmCreateRegistrationTag(";_+=null!==A&&""!==A&&"null"!==A?'"'+A+'", ':"null, ",_+=null!==B&&""!==B&&"null"!==B?'"'+B+'", ':"null, ",_+=null!==C&&""!==C&&"null"!==C?'"'+C+'", ':"null, ",_+=null!==D&&""!==D&&"null"!==D?'"'+D+'", ':"null, ",_+=null!==E&&""!==E&&"null"!==E?'"'+E+'", ':"null, ",this._useHostedCMLib||(_+=null!==F&&""!==F&&"null"!==F?'"'+F+'", ':"null, ",_+=null!==G&&""!==G&&"null"!==G?'"'+G+'", ':"null, ",_+=null!==R&&""!==R&&"null"!==R?'"'+R+'", ':"null, "),_+=null!==H&&""!==H&&"null"!==H?'"'+H+'", ':"null, ",this._useHostedCMLib?_+='"'+Z+'"':(_+=null!==I&&""!==I&&"null"!==I?'"'+I+'", ':"null, ",_+=null!==J&&""!==J&&"null"!==J?'"'+J+'", ':"null, ",_+=null!==K&&""!==K&&"null"!==K?'"'+K+'", ':"null, ",_+=null!==L&&""!==L&&"null"!==L?'"'+L+'", ':"null, ",_+=null!==M&&""!==M&&"null"!==M?'"'+M+'", ':"null, ",_+=null!==N&&""!==N&&"null"!==N?'"'+N+'", ':"null, ",_+=null!==O&&""!==O&&"null"!==O?'"'+O+'", ':"null, ",_+=null!==P&&""!==P&&"null"!==P?'"'+P+'"':"null"),null!==T&&(_+=", "+T),_+=");"}var aa=document.createTextNode($);a.appendChild(aa),a.appendChild(document.createElement("br"));var ba=document.createTextNode(_);a.appendChild(ba),a.appendChild(document.createElement("br"))}},_getStoreId:function(){for(var a=window.location.search.substr(1).split("&"),b=0;b<a.length;b++){var c=a[b].split("=");if(2===c.length&&c[0]===this.PARAM_STORE_ID)return c[1]}return null}}));var arrayUtils=arrayUtils||{stableSort:function(a,b){var c=a.map(function(a,b){return{element:a,index:b}});return c.sort(function(a,c){var d=b(a.element,c.element);return 0===d?a.index-c.index:d}).map(function(a){return a.element})},verifyTransitiveProperty:function(a,b){var c;for(c=0;c<a.length-1;c++)if(!b(a[c],a[c+1]))return!1;return!0},isEmpty:function(a){return 0===a.length},last:function(a){if(!this.isEmpty(a))return a[a.length-1]},arrTo2D:function(a,b){if("undefined"==typeof b)throw"The number of columns to divide the array into is undefined";var c=[];while(a.length)c.push(a.splice(0,b));return c}},KeyCodes=KeyCodes||{TAB:9,RETURN:13,SHIFT:16,SPACE:32,ESCAPE:27,LEFT_ARROW:37,UP_ARROW:38,RIGHT_ARROW:39,DOWN_ARROW:40};wcTopic={_topics:{},_getIdArray:function(a){var b=new Array;if("array"===$.type(a)||"object"===$.type(a))for(var c in a)b.push(a[c]);else"string"===$.type(a)?b.push(a):console.error("jQuery.Topic - ids has an unsupported type: "+$.type(a));return b},_processIds:function(a){var b=this._getIdArray(a);for(var c in b){var d=b[c];this._topics[d]||(this._topics[d]=$.Topic(d))}return b},subscribe:function(a,b){var c=this._processIds(a);for(var d in c)this._topics[c[d]].subscribe(b)},publish:function(a,b){var c=this._processIds(a),d;for(var e in c)d=Array.prototype.slice.call(arguments,1),this._topics[c[e]].publish.apply(null,d)},subscribeOnce:function(a,b,c){var d=this._processIds(a);for(var e in d)this._topics[d[e]].subscribeOnce(b,c)}},jQuery.Topic=function(a){var b=jQuery.Callbacks("unique"),c={id:a,publish:b.fire,subscribe:b.add,subscribeOnce:function(a,c){if($.isFunction(a)){var d=function(){a.apply(c||this,arguments),b.remove(d)};b.add(d)}else a.forEach(function(a){if($.isFunction(a)){var d=function(){a.apply(c||this,arguments),b.remove(d)};b.add(d)}else console.err(a+" is not a function")})},unsubscribe:b.remove};return c};var Utils=Utils||{once:function(a,b){var c;return function(){return a&&(c=a.apply(b||this,arguments),a=null),c}},stopEvent:function(a){a.preventDefault(),a.stopPropagation()},getTextDirection:function(a){var b=null;return window.getComputedStyle?b=window.getComputedStyle(a,null).direction:a.currentStyle&&(b=a.currentStyle.direction),b},isOpera:function(){return!!navigator.userAgent.match(/Opera|OPR\//)},has_ios:function(){return navigator.userAgent.match(/(iPod|iPhone|iPad)/)},isChrome:function(){return/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())},hasTouch:function(){return"ontouchstart"in window||navigator.MaxTouchPoints>0||navigator.msMaxTouchPoints>0},get_IE_version:function(){var a=window.navigator.userAgent,b=a.indexOf("MSIE ");if(b>0)return parseInt(a.substring(b+5,a.indexOf(".",b)),10);var c=a.indexOf("Trident/");if(c>0){var d=a.indexOf("rv:");return parseInt(a.substring(d+3,a.indexOf(".",d)),10)}var e=a.indexOf("Edge/");return e>0?parseInt(a.substring(e+5,a.indexOf(".",e)),10):void 0},keys:function(a){var b=[],c;for(c in a)a.hasOwnProperty(c)&&b.push(c);return b},iterate_obj_in_order:function(a,b,c){var d=this.keys(a),e=d.length,f,g;for(d.sort(b),f=0;f<e;f++)if(g=d[f],c(g,a[g]))break},varExists:function(a){return null!==a&&"undefined"!=typeof a},existsAndNotEmpty:function(a){return this.varExists(a)&&a.length},is_null_or_undefined:function(a){return null===a||"undefined"==typeof a},isNullOrUndefined:function(a){return null===a||"undefined"==typeof a},isUndefined:function(a){return"undefined"==typeof a},isUndefinedOrEmpty:function(a){return"undefined"==typeof a||0===a.length},isObject:function(a){return null!==a&&"object"==typeof a},isString:function(a){return"string"==typeof a},queryToObject:function(a){var b='{"'+a.split("&").map(function(a){return a.replace("=",'":"')}).join('","')+'"}';return a?JSON.parse(b,function(a,b){return""===a?b:decodeURIComponent(b)}):{}},updateQueryStringParameter:function(a,b,c){var d={};if(this.isString(b))d[b]=c;else{if(!this.isObject(b))throw"Invalid key parameter, expected a String or an Object, got: "+b;if(this.isUndefined(c)){if($.isEmptyObject(b))return console.warn("The given parameters are empty"),a}else console.warn("Value parameter passed, but will not be used: "+c);d=b}return $.each(d,function(b,c){var d=new RegExp("([?|&])"+b+"=.*?(&|#|$)","i");if(a.match(d))a=a.replace(d,"$1"+b+"="+c+"$2");else{var e="";a.indexOf("#")!==-1&&(e=a.replace(/.*#/,"#"),a=a.replace(/#.*/,""));var f=a.indexOf("?")!==-1?"&":"?";a=a+f+b+"="+c+e}}),a},addDays:function(a,b){var c=new Date(a);return c.setDate(c.getDate()+b),c},addMilliseconds:function(a,b){return new Date(a.getTime()+b)},set_option:function(a,b,c,d){if(this.is_null_or_undefined(a.options[b])){var e=$(a.element).data(c);this.is_null_or_undefined(e)?a.option(b,d):a.option(b,e)}},toggleHyperlink:function(a,b){if(a.is("a"))if(b){a.off("click.utils");var c=a.data("utils.toggleHyperlink");a.attr("onclick",c.onclick)}else a.on("click.utils",function(a){a.preventDefault()}),a.data("utils.toggleHyperlink",{onclick:a.attr("onclick")}),a.removeAttr("onclick");else console.err("not a hyperlink: "+a)},position:function(a){var b=$(a),c=b.offset();return{x:c.left,y:c.top,w:b.width(),h:b.height()}},isEmptyOrWhiteSpace:function(a){return""===$.trim(a)},isBoolean:function(a){return"boolean"===$.type(a)},selectAll:function(a){if(a.length>0){var b=$(a[0]),c;for(c=1;c<a.length;c++)b=b.add(a[c]);return b}return $()},elementExists:function(a){return $(a).length>0},ifSelectorExists:function(a,b,c){var d=$(a);if(d.length)return c?$.proxy(b,c)(d):b(d)},selectExistingElement:function(a){return a.map(function(a){return $(a)}).find(function(a){return a.length})},replaceAttr:function(a,b,c){a.attr(b,c(a.attr(b)))},scrollIntoView:function(a){var b=$(a).offset().top,c=$(window).scrollTop();b<c?$(a)[0].scrollIntoView(!0):b+$(a).height()>c+$(window).height()&&$(a)[0].scrollIntoView(!1)},onOnce:function(a,b,c,d,e){var f=b+"."+c;this.isString(d)?a.off(f).on(f,d,e):(e=d,a.off(f).on(f,e))},substituteStringWithObj:function(a,b){return a.replace(/{(\w+(\.*\w*)*)}/g,function(a,c){if("undefined"!=typeof b){var d=b,e=c.substr(0,c.indexOf("."));c=c.substr(c.indexOf(".")+1,c.length);while(""!==e)d=d[e],e=c.substr(0,c.indexOf(".")),c=c.substr(c.indexOf(".")+1,c.length);return""!==c&&(d=d[c]),"undefined"!=typeof d?d:a}return a})},substituteStringWithMap:function(a,b){return a=a.replace(/\{([0-9])\}/g,function(a,c){return b[c]})},getLocalizationMessage:function(a,b){if(GlobalizeLoaded)return Globalize.formatMessage(a,b)},formatCurrency:function(a,b){if(a=a.replace(/[^0-9\.\,]/g,""),b)var c=b.currency,d=b.locale;if(c||(c=WCParamJS.commandContextCurrency),GlobalizeLoaded)return d?(a=Globalize(d).parseNumber(a),Globalize(d).formatCurrency(a,c,b)):(a=Globalize.parseNumber(a),Globalize.formatCurrency(a,c,b))},parseNumber:function(a){if(a=a.replace(/[^0-9\.\,]/g,""),GlobalizeLoaded)return Globalize.parseNumber(a)},formatNumber:function(a,b){if(a=a.replace(/[^0-9\.\,]/g,""),GlobalizeLoaded)return a=Globalize.parseNumber(a),Globalize.formatNumber(a,b)},getLocale:function(){return navigator.languages?navigator.languages[0]:navigator.language||navigator.userLanguage},round:function(a,b){return Number(Math.round(a+"e"+b)+"e-"+b)},toBoolean:function(a){return!!a},arrContains:function(a,b){return $.inArray(b,a)!==-1},notNullOrWhiteSpace:function(a){return null!==a&&0!==$.trim(a).length},findInObj:function(a,b){var c;return $(a).each(function(a,d){
if(b(a,d))return c=a,!1}),c},areSiblings:function(a,b){var c=function(a,b){return $(a).siblings().is($(b))};return!(!arrayUtils.verifyTransitiveProperty(a,c)||!arrayUtils.verifyTransitiveProperty(b,c))&&(!(!arrayUtils.isEmpty(a)&&!arrayUtils.isEmpty(b))||c(arrayUtils.last(a),b[0]))},sameParent:function(a){},getObject:function(a){if(""!==a){var b=a.split("."),c=window[b[0]];for(i=1;i<b.length;i++){if(!c)break;c=c[b[i]]}return c}},idExists:function(){if(0===arguments.length)return console.warn("No arguments passed to idExists"),!0;for(var a=0;a<arguments.length;a++)if(!$(arguments[a].length))return!1;return!0},aop_after:function(a,b,c){var d=$.proxy(a[b],a);a[b]=function(){return d.apply(this,arguments),c(arguments)}},substituteString:function(a,b){return a=a.replace(/\$\{([0-9])\}/g,function(a,b){return subsMap[b]})}};jQuery(document).ready(function($){$.widget("wc.refreshWidget",{url:void 0,ariaMessage:void 0,ariaLiveId:void 0,options:{formId:void 0,renderContextChangedHandler:null,postRefreshHandler:null},_create:function(){this.element.attr("refreshurl")&&(this.url=this.element.attr("refreshurl")),this.url||console.warn("Warning: refreshurl is not defined for refresh area: "+this.element.attr("id")),"RefreshArea"!==this.element.attr("wcType")&&console.error("Error: wcType is not set to 'RefreshArea' for refresh area: "+this.element.attr("id")),this.element.attr("declareFunction")||console.error("Error: declareFunction is not set for refresh area: "+this.element.attr("id")),this.element.attr("ariaMessage")&&(this.ariaMessage=this.element.attr("ariaMessage")),this.element.attr("ariaLiveId")&&(this.ariaMessage=this.element.attr("ariaLiveId"))},updateUrl:function(a){this.url=a},updateFormId:function(a){this.options.formId=a},refresh:function(parameters){var domNode=this.element,widget=this;!this.url&&this.element.attr("refreshurl")&&(this.url=this.element.attr("refreshurl"));var formNode=null;if(this.options.formId&&(formNode=$("#"+this.options.formId)),parameters?parameters.requesttype||(parameters.requesttype="ajax"):parameters={requesttype:"ajax"},!this.url)return void console.error("refreshurl is not specified for refresh area: "+domNode.attr("id"));this.url=this.url.replace(/amp;/g,"");var mergedParameters=parameters;if("object"==typeof wcCommonRequestParameters){mergedParameters={},$.extend(mergedParameters,parameters);for(var parameterName in wcCommonRequestParameters)this._isParameterExcluded(this.url,parameterName)?console.debug("parameter "+parameterName+" is excluded"):mergedParameters.parameterName=wcCommonRequestParameters.parameterName}if($.isArray(mergedParameters)){var keyValuePairs={};for(var paramKey in mergedParameters)$.isArray(mergedParameters[paramKey])?mergedParameters[paramKey].length>0&&(keyValuePairs[paramKey]=mergedParameters[paramKey]):keyValuePairs[paramKey]=mergedParameters[paramKey];mergedParameters=keyValuePairs,console.debug("mergedParameters after modifying = "+JSON.stringify(mergedParameters))}var failureHandler=function(a,b){console.error("failed to refresh widget "+domNode.attr("id")),wcTopic.publish("ajaxRequestCompleted")},successHandler=function(data,status){function getIds(a,b){var c="";if(mergedParameters&&mergedParameters[a]&&(c=mergedParameters[a]),""===c&&null!=formNode&&formNode[a]&&(c=formNode[a],null!=formNode[a].value&&(c=formNode[a].value)),""===c&&b){var d=b;if(d.indexOf(a)!==-1){d=d.substring(d.indexOf(a));var e=d.split("&"),f=e[0].split("=");c=f[1]}}return c}function parseJsonCommentFiltered(str){str=str.replace("/*",""),str=str.replace("*/","");var json=eval("("+str+")");return json}var storeId=getIds("storeId",widget.url),catalogId=getIds("catalogId",widget.url),langId=getIds("langId",widget.url),errorCodeBegin=data.indexOf("errorCode");function serverErrorHandler(a){if(console.debug("error condition encountered - error code: "+a),a.indexOf("2550")!==-1)console.debug("error type: ERR_DIDNT_LOGON - the customer did not log on to the system."),console.debug("redirecting to URL: AjaxLogonForm?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId+"&myAcctMain=1"),document.location.href="AjaxLogonForm?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId+"&myAcctMain=1";else if(a.indexOf("2510")!==-1){console.debug("error type: ERR_SESSION_TIMEOUT - use session has timed out");var b=parseJsonCommentFiltered(data),c="Logoff?";if("true"==b.exceptionData.isBecomeUser&&(c="RestoreOriginalUserSetInSession?URL=Logoff&"),"true"==b.exceptionData.rememberMe){var d=c+"rememberMe=true&storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId;console.debug("try to logoff, get URL="+d),$.ajax({type:"GET",url:d,data:mergedParameters,success:function(a,b){console.debug("User logged off. Reload current page to avoid data inconsistence..."),document.location.reload()},error:function(a){document.location.href="ReLogonFormView?rememberMe=true&storeId="+storeId}})}else console.debug("redirecting to URL: "+c+"URL=ReLogonFormView&storeId="+storeId),document.location.href=c+"URL=ReLogonFormView&storeId="+storeId}else a.indexOf("2520")!==-1?(console.debug("error type: ERR_PROHIBITED_CHAR - detected prohibited characters in request"),console.debug("redirecting to URL: ProhibitedCharacterErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="ProhibitedCharacterErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId):errorCodeString.indexOf("2540")!==-1?(console.debug("error type: ERR_CSRF - cross site request forgery attempt was detected"),console.debug("redirecting to URL: CrossSiteRequestForgeryErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="CrossSiteRequestForgeryErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId):errorCodeString.indexOf("CMN1039E")!==-1&&(console.debug("error type: _ERR_INVALID_COOKIE - cookie error was detected"),console.debug("redirecting to URL: CookieErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId),document.location.href="CookieErrorView?storeId="+storeId+"&catalogId="+catalogId+"&langId="+langId)}if(errorCodeBegin!=-1){var errorCodeEnd=data.indexOf(",",errorCodeBegin),errorCodeString=data.substring(errorCodeBegin,errorCodeEnd);serverErrorHandler(errorCodeString)}else domNode.html(data),WCWidgetParser.parse(domNode),null!=widget.options.postRefreshHandler&&widget.options.postRefreshHandler(widget.element);wcTopic.publish("ajaxRequestCompleted"),widget._updateLiveRegion()},ajaxParams={data:formNode?formNode.serialize()+"&"+$.param(mergedParameters):mergedParameters,url:this.url,type:"POST",traditional:!0,success:successHandler,error:failureHandler};$.ajax(ajaxParams)},renderContextChanged:function(a){null!=this.options.renderContextChangedHandler&&this.options.renderContextChangedHandler(a)},_updateLiveRegion:function(){if($("#"+this.ariaLiveId+"_ACCE_Label").css("display","block"),""!==this.ariaMessage&&""!==this.ariaLiveId){var a=document.createTextNode(this.ariaMessage),b=document.getElementById(this.ariaLiveId);if(b){while(b.firstChild)b.removeChild(b.firstChild);b.appendChild(a)}}}})}(jQuery)),wcRenderContext={contextArray:{},getRefreshAreaIds:function(a){return this.checkIdDefined(a)?this.contextArray[a].refreshAreaIds:void console.error("wcRenderContext.getRefreshAreaIds: Common render context "+a+" is not defined")},getRenderContextProperties:function(a){return this.checkIdDefined(a)?this.contextArray[a].contextProperties:void console.error("wcRenderContext.getRenderContextProperties: Common render context "+a+" is not defined")},addRefreshAreaId:function(a,b){return this.checkIdDefined(a)?void(Utils.arrContains(this.contextArray[a].refreshAreaIds,b)||this.contextArray[a].refreshAreaIds.push(b)):void console.error("wcRenderContext.addRefreshAreaId: Common render context "+a+" is not defined")},declare:function(a,b,c){if(this.checkIdDefined(a))return void console.error("Common render context with id =  "+a+" already exits.Please use a different id");if(!$.isArray(b))return void console.error("refresh area ids should be an array, got: "+b);""===c&&(c={});var d={id:a,refreshAreaIds:b,contextProperties:c,currentRCProperties:{}};this.contextArray[a]=d,this._syncRCProperties(a)},updateRenderContext:function(a,b){if(!this.checkIdDefined(a))return void console.error("wcRenderContext.updateRenderContext: Common render context "+a+" is not defined");var c=this.getRenderContextProperties(a);for(var d in b){var e=b[d];e!=c[d]&&(Utils.isUndefined(e)?delete c[d]:c[d]=e)}var f=this.getRefreshAreaIds(a);$.each(f,function(a,b){var c=$("#"+b);c.refreshWidget("renderContextChanged",c)}),wcTopic.publish(a+"/RenderContextChanged",{actionId:a+"/RenderContextChanged"}),this._syncRCProperties(a)},testForChangedRC:function(a,b){for(var c=!1,d=0;d<b.length;d++){var e=b[d];if(this.contextArray[a].currentRCProperties[e]!=this.contextArray[a].contextProperties[e]){c=!0;break}}return c},checkIdDefined:function(a){return Utils.toBoolean(this.contextArray[a])},_syncRCProperties:function(a){var b=this.getRenderContextProperties(a),c=$.extend({},b);this.contextArray[a].currentRCProperties=c}},function($){$.wcServicePlugin=function(options){var settings=$.extend({id:void 0,actionId:void 0,url:void 0,formId:void 0,successHandler:void 0,failureHandler:void 0},options),validateParameters=function(a){return!0},validateForm=function(a){return!0},successTest=function(a){return!a.errorMessage&&!a.errorMessageKey},_isParameterExcluded=function(a,b){try{if("object"==typeof URLConfig)if("object"==typeof URLConfig.excludedURLPatterns)for(var c in URLConfig.excludedURLPatterns){var d=URLConfig.excludedURLPatterns[c],e=c;if("object"==typeof d&&(d.urlPattern&&(e=d.urlPattern),console.debug("URL pattern to match : "+e),e=new RegExp(e),a.match(e))){var f=d.excludedParameters;for(var g in f)if(parametername==g)return!0}}else console.debug("The parameter "+b+" is not excluded");else console.debug("No URLConfig defined.")}catch(a){console.debug("An error occured while trying to exclude "+a)}return!1},output={setFormId:function(a){settings.formId=a},setActionId:function(a){settings.actionId=a},setUrl:function(a){settings.url=a},setParam:function(a,b){settings[a]=b},getParam:function(a){return settings[a]},invoke:function(parameters){var valid=!0,formNode=null;settings.formId&&(formNode=$("#"+settings.formId)),formNode&&(valid=validateForm(formNode)),valid&&(valid=validateParameters(parameters));function addAuthToken(a){try{return $("#csrf_authToken").length?a.authToken=$("#csrf_authToken").val():console.debug("auth token is missing from the HTML DOM"),!0}catch(a){console.debug("An error occured while trying to add authToken to request "+a)}return!1}parameters?parameters.requesttype||(parameters.requesttype="ajax"):(parameters={},parameters.requesttype="ajax"),addAuthToken(parameters);var mergedParameters=parameters;if("object"==typeof wcCommonRequestParameters){mergedParameters={},$.extend(mergedParameters,parameters);for(var parameterName in wcCommonRequestParameters)_isParameterExcluded(this.url,parameterName)?console.debug("parameter "+parameterName+" is excluded"):mergedParameters.parameterName=wcCommonRequestParameters.parameterName}if($.isArray(mergedParameters)){var keyValuePairs={};for(var paramKey in mergedParameters)$.isArray(mergedParameters[paramKey])?mergedParameters[paramKey].length>0&&(keyValuePairs[paramKey]=mergedParameters[paramKey]):keyValuePairs[paramKey]=mergedParameters[paramKey];mergedParameters=keyValuePairs,console.debug("mergedParameters after modifying = "+JSON.stringify(mergedParameters))}var successHandler=function(a,b){function c(a,b){var c="";if(mergedParameters&&mergedParameters[a]&&(c=mergedParameters[a]),""==c&&null!=formNode&&formNode[a]&&(c=formNode[a],null!=formNode[a].value&&(c=formNode[a].value)),""==c&&b){var d=b;if(d.indexOf(a)!=-1){d=d.substring(d.indexOf(a));var e=d.split("&"),f=e[0].split("=");c=f[1]}}return c}var d=c("storeId",settings.url),e=c("catalogId",settings.url),f=c("langId",settings.url);function g(c){if("2500"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="LogonForm?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f+"&myAcctMain=1",console.debug("error type: ERR_USER_NOT_LOGGED_ON - only registered user can invoke the command"),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2550"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="AjaxLogonForm?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f+"&myAcctMain=1",console.debug("error type: ERR_DIDNT_LOGON - the customer did not log on to the system."),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2530"==c){var g=a.originatingCommand;g=g.replace("?","%3F"),g=g.replace(/&amp;/g,"%26"),g=g.replace(/&/g,"%26"),g=g.replace(/=/g,"%3D"),g="PasswordReEnterErrorView?nextUrl="+g+"&storeId="+d+"&catalogId="+e+"&langId="+f,console.debug("error type: ERR_PASSWORD_REREQUEST - password is required"),console.debug("redirecting to URL: "+g),document.location.href=g}else if("2510"==c){console.debug("error type: ERR_SESSION_TIMEOUT - use session has timed out");var h="Logoff?";if("true"==a.exceptionData.isBecomeUser&&(h="RestoreOriginalUserSetInSession?URL=Logoff&"),"true"==a.exceptionData.rememberMe){var g=h+"rememberMe=true&storeId="+d+"&catalogId="+e+"&langId="+f;console.debug("try to logoff, get URL="+g),$.ajax({type:"GET",url:g,data:mergedParameters,success:function(a,b){console.debug("User logged off. Reload current page to avoid data inconsistence..."),document.location.reload()},error:function(a){document.location.href="ReLogonFormView?rememberMe=true&storeId="+d}})}else console.debug("redirecting to URL: "+h+"URL=ReLogonFormView&storeId="+d),document.location.href=h+"URL=ReLogonFormView&storeId="+d}else"2520"==c?(console.debug("error type: ERR_PROHIBITED_CHAR - detected prohibited characters in request"),console.debug("redirecting to URL: ProhibitedCharacterErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="ProhibitedCharacterErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):"2540"==c?(console.debug("error type: ERR_CSRF - cross site request forgery attempt was detected"),console.debug("redirecting to URL: CrossSiteRequestForgeryErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="CrossSiteRequestForgeryErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):"CMN1039E"==c?(console.debug("error type: _ERR_INVALID_COOKIE - cookie error was detected"),console.debug("redirecting to URL: CookieErrorView?storeId="+d+"&catalogId="+e+"&langId="+f),document.location.href="CookieErrorView?storeId="+d+"&catalogId="+e+"&langId="+f):settings.failureHandler&&(console.debug("calling service.failureHandler"),settings.failureHandler(a,b));wcTopic.publish("ajaxRequestCompleted")}console.debug("response from ajax call:");for(var h in a)console.debug("  "+h+"="+a[h]);if(successTest(a)){if(settings.successHandler){var i=$(this).attr("data");i=i?JSON.parse('{"'+i.replace(/&/g,'","').replace(/=/g,'":"')+'"}',function(a,b){return""===a?b:decodeURIComponent(b)}):{},settings.successHandler(a,i),console.debug("success: publishing modelChanged event")}settings.actionId&&(console.debug("triggering action: "+settings.actionId),wcTopic.publish(settings.actionId,{actionId:settings.actionId,data:a}))}else console.debug("error condition encountered - error code: "+a.errorCode),g(a.errorCode)},failureHandler=function(a,b){console.debug("Warning: communication error while making the service call");var c=a.errorMessage;c?alert(c):(c=a.errorMessageKey,c?alert(c):alert("Service request error."))};if(console.debug("service formId = "+settings.formId),valid){wcTopic.publish("ajaxRequestInitiated");var stripComment=function(a,b,c){var d=a.indexOf(b),e=-1,f="",g="";return d!=-1&&(e=a.indexOf(c)),e!=-1&&(f=a.substr(0,d),g=a.substr(e+c.length),a=f+g),a.indexOf(b)!=-1&&(a=stripComment(a,b,c)),a},ajaxParams={url:settings.url,type:"POST",data:formNode?formNode.serialize()+"&"+$.param(mergedParameters,!0):mergedParameters,traditional:!0,dataFilter:function(str){str=str.replace("/*",""),str=str.replace("*/",""),str.indexOf("<!--")!=-1&&(str=stripComment(str,"<!--","-->")),str.indexOf("<%--")!=-1&&(str=stripComment(str,"<%--","--%>"));var json=eval("("+str+")");return json},success:successHandler,error:failureHandler};$.ajax(ajaxParams)}}};return output}}(jQuery),wcService={wcServices:{},getServiceById:function(a){return this.wcServices[a]},declare:function(a){a.id&&(this.wcServices[a.id]=$.wcServicePlugin(a))},invoke:function(a,b){var c=this.getServiceById(a);c?c.invoke(b):console.error("Attempt to invoke an unregistered service: "+a)}};var WCWidgetParser;!function(a){WCWidgetParser=WCWidgetParser||{widgetDefinitions:{dialog:{fcnName:"Dialog"},autocomplete:{fcnName:"autocomplete"},tabs:{fcnName:"tabs"},datepicker:{fcnName:"datepicker",defaultOptions:{showOtherMonths:!0,changeYear:!0,dayNamesMin:["S","M","T","W","T","F","S"],altFormat:"yy-mm-dd",dateFormat:"mm/dd/yy"}},"wc.WCDialog":{fcnName:"WCDialog"},"wc.Carousel":{fcnName:"Carousel"},"wc.Grid":{fcnName:"Grid"},"wc.tooltip":{fcnName:"wcToolTip"},"wc.Select":{fcnName:"Select"},"wc.ValidationTextbox":{fcnName:"ValidationTextbox"}},_parse_widget:function(b,c,d){var e=this.widgetDefinitions[c];if(!e)return void console.error("Widget type: "+c+" not registered");var f=e.fcnName,g=e.default_options||{};if(d=d||{},Utils.isObject(d)||a.isArray(d)){var h=a.extend({},g,d);b[f]?b[f](h):console.error("Function: "+f+" does not exist")}else b[f](g),console.error("The given html option is neither an Object nor an array (the default options will be used instead): "+d)},parse:function(b){var c=[];a("[data-widget-type]",b).each(a.proxy(function(b,d){var e=a(d),f=e.data("widget-type"),g=e.data("widget-options");a.isArray(f)?Utils.varExists(g)&&!a.isArray(g)?console.error("widgetName is an array but widgetOptions is not: "+g):f.length!==g.length?console.error("widgetName and widgetOptions have different lengths"):f.forEach(function(a,b){c.push({element:e,widgetName:a,widgetOptions:g[b]})}):c.push({element:e,widgetName:f,widgetOptions:g})},this));var d=function(a,b){return a.widgetOptions&&a.widgetOptions.parseOrder?b.widgetOptions&&b.widgetOptions.parseOrder?a.widgetOptions.parseOrder-b.widgetOptions.parseOrder:-1:b.widgetOptions&&b.widgetOptions.parseOrder?1:0},e=function(a,b){return a.element.is(":visible")?b.element.is(":visible")?0:-1:b.element.is(":visible")?1:0};c=arrayUtils.stableSort(c,function(a,b){var c=d(a,b);return 0===c&&(c=e(a,b)),c}),a.each(c,a.proxy(function(a,b){this._parse_widget(b.element,b.widgetName,b.widgetOptions)},this))},parseRefreshArea:function(b){a("[wcType='RefreshArea']",b).each(function(b,c){var d=a(c).attr("declareFunction"),e,f,g=null;if(d){var h=d.indexOf(".");h>0&&(e=d.substr(0,h));var i=d.indexOf("(");if(i>0){f=d.substr(h+1,i-h-1);var j=d.slice(i+1,d.length-1);j=j.replace(/"/g,"").replace(/'/g,"").replace(/ /g,""),g=j.split(",")}else f=d.substr(h+1)}f&&(e?Utils.isUndefined(window[e])?console.error("Namespace "+e+" is not defined"):Utils.isUndefined(window[e][f])?console.error("Function "+f+" is not defined under namespace "+e):window[e][f](g):Utils.isUndefined(window[f])?console.error(f+" is not defined!"):a.isFunction(window[f])?window[f](g):console.error(window[f]+" is not a function!"))})}},a(document).ready(function(){WCWidgetParser.parse(),WCWidgetParser.parseRefreshArea()})}(jQuery),function(){$.widget("wc.Carousel",$.Widget,{options:{prevButton:null,nextButton:null,paginationButtons:null,contentContainer:"div.content",overflowVisible:!1,owlCarouselOptions:{autoHeight:!1,autoWidth:!0,pagination:!1,slideSpeed:2e3,afterMove:function(a){this.options.paginationButtons&&this.paginationButtons.removeClass("selected").eq(this.owlCarousel.currentItem).attr("class","selected")},afterUpdate:function(){this._togglePrevNextButtons()}}},_proxyFunction:function(a){$.isFunction(this.options.owlCarouselOptions[a])&&(this.options.owlCarouselOptions[a]=$.proxy(this.options.owlCarouselOptions[a],this))},_create:function(){if(this._super(this),this.content=$(this.options.contentContainer,this.element),this._proxyFunction("afterMove"),this._proxyFunction("afterUpdate"),this.options.columnCountByWidth){var a=this.options.columnCountByWidth;if(Utils.isObject(a)){var b=$(window).width(),c=Object.keys(a).map(function(a){return parseInt(a,10)});c.sort(function(a,b){return a-b}),c=c.map(function(b){return[b,a[b.toString()]]}),this.options.owlCarouselOptions.itemsCustom=c}else console.error("columnCountByWidth is not an object: "+this.options.columnCountByWidth)}this.owlCarousel=this.content.owlCarousel(this.options.owlCarouselOptions).data("owlCarousel"),this.options.overflowVisible&&$(".owl-wrapper-outer",this.element).addClass("overflow-visible"),$(window).resize($.proxy(function(){this.owlCarousel.reload(),this._togglePrevNextButtons()},this)),this._add_event_handlers(),this._togglePrevNextButtons()},_togglePrevNextButtons:function(){var a=this.owlCarousel.itemsAmount>this.owlCarousel.options.items;a?(this.options.nextButton&&this.$nextButton.show(),this.options.prevButton&&this.$prevButton.show()):(this.options.nextButton&&this.$nextButton.hide(),this.options.prevButton&&this.$prevButton.hide())},_add_event_handlers:function(){var a=this.owlCarousel;this.element.on("resized.owl.carousel",function(){console.log("resized")}),this.options.prevButton&&(this.$prevButton=$(this.options.prevButton,this.element),this.$prevButton.click(function(b){a.prev(),b.preventDefault()})),this.options.nextButton&&(this.$nextButton=$(this.options.nextButton,this.element),this.$nextButton.click(function(b){a.next(),b.preventDefault()})),this.options.paginationButtons&&(this.paginationButtons=$(this.options.paginationButtons,this.element),this.paginationButtons.first().attr("class","selected"),this.paginationButtons.each(function(b,c){$(c).click(function(c){a.goTo(b),c.preventDefault()})}))},_destroy:function(){this.owlCarousel.destroy()}})}(),function(a){a.widget("wc.Grid",a.Widget,{options:{columnCount:1,rowCount:null,elementSelector:"div.grid-element",useColumnWrapper:!1,columnWrapperClass:"grid-column-wrapper"},optionChangedHandlers:{columnCount:function(){this._columnCountUpdated()},columnCountByWidth:function(){this.resize()},elementSelector:function(){this.$elements=void 0}},columnContainerClass:{1:"ui-grid-solo",2:"ui-grid-a",3:"ui-grid-b",4:"ui-grid-c",5:"ui-grid-d",6:"ui-grid-e",7:"ui-grid-f",8:"ui-grid-g",9:"ui-grid-h"},currentColumnContainerClass:null,columnClass:{1:"ui-block-a",2:"ui-block-b",3:"ui-block-c",4:"ui-block-d",5:"ui-block-e",6:"ui-block-f",7:"ui-block-g",8:"ui-block-h",9:"ui-block-i"},_setOption:function(a,b){this._super(a,b),this.optionChangedHandlers[a]&&this.optionChangedHandlers[a].call(this)},_getColumnContainerClass:function(a){var b=this.columnContainerClass[String(a)];if(b)return b;throw"Unsupported, too many columns: "+a},_columnCountUpdated:function(){this.$elements=this.$elements||a(this.options.elementSelector,this.element);var b=this.$elements,c=b.parent(),d=this.options.columnCount,e=this.options.rowCount;if(d){if(0===d)throw"Column count must be greater than 0!";if(e){if(0===e)throw"rowCount must be greater than 0!";if(b.length>d*e)throw"The number of elements ("+b.length+") cannot fit into a "+d+" by "+e+" grid"}else e=Math.ceil(b.length/d)}else{if(!e)throw"Row count and column count not defined!";if(0===e)throw"rowCount must be greater than 0!";d=Math.ceil(b.length/e)}this.options.useColumnWrapper&&c.hasClass(this.options.columnWrapperClass)&&(b.unwrap(),c=b.parent()),this.currentColumnContainerClass&&c.removeClass(this.currentColumnContainerClass),this.currentColumnContainerClass=this._getColumnContainerClass(d),c.addClass(this.currentColumnContainerClass);var f=arrayUtils.arrTo2D(a.makeArray(b),d),g;for(g=0;g<d;g++){var h=a(f.filter(function(a){return a.length>g}).map(function(a){return a[g]}));this.options.useColumnWrapper?(h=h.detach(),$wrapper=a('<div class="'+this.options.columnWrapperClass+" "+this.columnClass[g+1]+'"></div>'),c.append($wrapper),$wrapper.append(h)):h.removeClass(this.allColumnClass).addClass(this.columnClass[g+1])}},_validateElements:function(){if(!Utils.areSiblings(a(this.options.elementSelector,this.element),a([])))throw"Grid elements must all be under the same parent"},_create:function(){this._super(this),this.allColumnClass=a.map(this.columnClass,function(a,b){return a}).join(" "),this._validateElements(),this.option("columnCount",this._calculateColumnBasedOnClientWidth()),a(window).resize(a.proxy(function(){this.resize()},this))},_calculateColumnBasedOnClientWidth:function(){var a=1,b=this.element.get(0).clientWidth;return this.options.columnCountByWidth&&Utils.iterate_obj_in_order(this.options.columnCountByWidth,function(a,b){return parseInt(b)-parseInt(a)},function(c,d){if(b>=parseInt(c))return a=d,!0}),a},resize:function(){var a=this._calculateColumnBasedOnClientWidth();a!==this.options.columnCount&&this.option("columnCount",a)}})}(jQuery),function($){$.widget("wc.Select",$.ui.selectmenu,{options:{wcMenuClass:"",useValueAsLink:!1},_create:function(){if(this._super(this),this.options.useValueAsLink)Utils.isUndefined(this.element.attr("onChange"))||console.warn("onChange defined for select menu, but it will be ignored since useValueAsLink is set to true"),this.options.change=function(){var a=$(this).val();Utils.existsAndNotEmpty(a)?window.location=a:console.error("the url is not defined")};else if(void 0!==this.element.attr("onChange")){var onChange=this.element.attr("onChange").replace(/javascript:/i,"");this.options.change=function(event,data){eval(onChange)}}var selectedOption=$(this.element).find("[selected='selected']");selectedOption.length&&$(this.element[0]).prop("selectedIndex",selectedOption.index())},open:function(a){this._super(this),this.menuItems&&(this._removeClass(this.menu.find(".ui-state-select"),null,"ui-state-select"),this._addClass(this._getSelectedItem().children(),null,"ui-state-select"),this.menuInstance.focus(null,this._getSelectedItem()))},close:function(a){this._super(this),this._removeClass(this.menu.find(".ui-state-select"),null,"ui-state-select"),this._addClass(this._getSelectedItem().children(),null,"ui-state-select")},_drawButton:function(){this._super(this),this.button.addClass(this.element.attr("class")),this.button.addClass(this.element.attr("baseclass")),this.button.attr("style","")},_drawMenu:function(){var a=this;this._super(this),this.menu.menu({focus:function(b,c){var d=c.item.data("ui-selectmenu-item");d&&a.menuItems.eq(d.index).focus()}}).css("font-size",this.buttonItem.css("font-size"));var b=this.options.wcMenuClass;void 0!==b&&null!==b&&""!==b&&this.menu.addClass(b)},_position:function(){this._super(this),this.reposition(this.menuWrap,this.button)},reposition:function(a,b){this.menuWrap.css("z-index",1e3),this.menu.css("height","auto");var c=a.height(),d=a.position().top-$(window).scrollTop(),e=$(window).height()-d;d>$(window).height()/2&&c>e?d>c?this.menuWrap.css("top",a.position().top-c-b.outerHeight()):(this.menuWrap.css("top",a.position().top-d),this.menu.css("height",d-b.outerHeight())):c>e&&this.menu.css("height",e)},_renderItem:function(a,b){return this._super(a,b),a.children().last().attr("value",b.value),a.children().children().last().attr("style",b.element[0].style.cssText),a.children().last()},refresh_noResizeButton:function(){this._refreshMenu(),$(this.element[0]).prop("selectedIndex")>-1&&this._setText(this.buttonItem,this._getSelectedItem().text())}})}(jQuery),function(){$.widget("wc.ValidationTextbox",$.Widget,{options:{canBeEmpty:!0,trimBeforeValidation:!0,errorClass:"error",submitButtonDisabledClass:"disabled",invalidMessage:null},_create:function(){this._super(this),this.options.regExp&&(this.regExp=new RegExp(this.options.regExp)),this.element.addClass("wcValidationTextbox"),this.options.submitButton&&(this.submitButton=$(this.options.submitButton)),this.element.bind("input propertychange",$.proxy(function(a){this.validationAndErrorHandler()&&this.options.onValidInput&&this.options.onValidInput($(this.element).prop("value"))},this))},toggleSubmitButton:function(a){this.options.submitButton&&this.submitButton.length&&(a?this.submitButton.removeClass(this.options.submitButtonDisabledClass):this.submitButton.addClass(this.options.submitButtonDisabledClass),this.submitButton.is("a")?Utils.toggleHyperlink(this.submitButton,a):this.submitButton.is("input")?this.submitButton.prop("disabled",!a):console.err("don't know how to disable: "+this.submitButton))},validateFormat:function(a){return Utils.isBoolean(this.options.canBeEmpty)&&""===a?this.options.canBeEmpty:!(this.options.regExp&&!this.regExp.test(a))},validationAndErrorHandler:function(){var a=$(this.element),b=this.element.val();this.options.trimBeforeValidation&&(b=$.trim(b));var c=null;return this.validateFormat(b)||(c=this.options.invalidMessage),null==c&&null!=this.options.customValidateFunction&&void 0!=this.options.customValidateFunction&&(c=this.options.customValidateFunction()),null==c?(a.hasClass(this.options.errorClass)&&(a.removeClass(this.options.errorClass),this.tooltip&&(this.tooltip.destroy(),this.tooltip=null),this.toggleSubmitButton(!0)),!0):(this.tooltip&&this.element.data("tooltip-content")&&this.element.data("tooltip-content")!=c?(this.element.data("tooltip-content",c),this.tooltip.tooltip.find(".content").text(c),this.tooltip.show_popup()):this.tooltip?this.tooltip.show_popup():a.hasClass(this.options.errorClass)||(a.addClass(this.options.errorClass),this.element.data("tooltip-content",c),this.tooltip=this.element.wcToolTip().data("custom-wcToolTip"),this.tooltip.show_popup(),this.toggleSubmitButton(!1)),!1)}})}(),function(){$.widget("wc.WCDialog",$.ui.dialog,{options:{show_title:!1,autoOpen:!1,timeout:null,autoClose:!1,close_button_selector:"a.closeButton",close_on_primary_click:!0,relatedSource:null,modal:!0,width:"auto"},_create:function(){this._super(this),this.options.show_title||this.element.siblings("div.ui-dialog-titlebar").hide(),this.element.attr("data-widget-type","wc.WCDialog"),$(window).resize($.proxy(function(){this.reposition()},this)),this._add_event_handlers()},_add_event_handlers:function(){if(this.options.close_button_selector&&(this.close_button=$(this.options.close_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.close()},this))),this.options.primary_button_selector&&(this.primary_button=$(this.options.primary_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.options.close_on_primary_click&&this.close()},this))),this.options.secondary_button_selector&&(this.secondary_button=$(this.options.secondary_button_selector,this.element).on("click.WCDialog",$.proxy(function(){this.close()},this))),this.options.timeout||this.options.autoClose){var a=this,b,c=function(){b&&(clearTimeout(b),b=null)},d=function(){b&&c(),b=setTimeout(function(){a.close()},a.options.timeout)};this.option.timeout&&(this.element.on("wcdialogopen",d),this.element.on("wcdialogclose",c),this.element.on("mouseover",function(b){c(),a.element.on("mouseleave",d)})),this.options.autoClose&&a.element.add($(a.options.relatedSource)).on("mouseleave",function(b){$.contains(a.element.get(0),b.toElement)||$.contains($(a.options.relatedSource).get(0),b.toElement)||a.close()})}},reposition:function(){var a=this.element.parent("div.ui-widget-content:first[role='dialog']");0===a.height()&&a.height(this.element.height()),0===a.width()&&a.width(this.element.width());var b=this.option("position");this.option("position",b)},bringToFront:function(a){var b=0;a=$(a||".ui-dialog"),a.each(function(a,c){var d=$(c).css("z-index");$.isNumeric(d)&&(d=parseInt(d),d>b&&(b=d))}),this.element.parent(".ui-dialog").css("z-index",parseInt(b)+1)},update_content:function(a){var b=$(a).detach();
this.element.html(b.html()),this.reposition(),this._add_event_handlers()}})}(),function(a){a.widget("custom.wcToolTip",{options:{accessibilityKey:null},_create:function(){var a=this;this.element.on("mouseenter.wcToolTip",function(){a.show_popup()}),this.element.on("mouseleave.wcToolTip",function(){a.hide_popup()}),null!==this.options.accessibilityKey&&this.element.on("keydown.wcToolTip",function(b){b.keyCode===a.options.accessibilityKey&&a.show_popup()})},show_popup:function(){if(this.tooltip)this.tooltip.show();else{var b=a(this.element).data("tooltip-header"),c=a(this.element).data("tooltip-content");c&&b?this.tooltip=a("<div class='WCTooltip'><div class='container'><div class='connector'></div><div class='header'>"+b+"</div><div class='content' >"+c+"</div></div></div>"):b?this.tooltip=a("<div class='WCTooltip'><div class='container' style='padding:8px;' ><div class='connector'></div>"+b+"</div></div>"):c?this.tooltip=a("<div class='WCTooltip'><div class='container'><div class='connector'></div><div class='content' >"+c+"</div></div></div>"):this.tooltip=a(""),this.element.after(this.tooltip)}this.tooltip.position({my:"center top",at:"center bottom",of:this.element,collision:"none"})},hide_popup:function(){this.tooltip&&this.tooltip.hide()},_destroy:function(){this.tooltip&&(this.tooltip.hide(),this.tooltip.remove()),this.element.off("mouseenter.wcToolTip"),this.element.off("mouseleave.wcToolTip")}})}(jQuery);

/*
 * Common utilities for all brands in the NERD project
 */

/**
 * isMobile https://github.com/kaimallea/isMobile
 * This function detects mobile devices and then it then creates a JavaScript object with the results.
 * version 0.5.1
 */
!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,b=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,u=/\bWindows(?:.+)ARM\b/i,c=/BlackBerry/i,s=/BB10/i,v=/Opera Mini/i,h=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/\Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(l,i),tablet:!m(l,i)&&m(b,i),device:m(l,i)||m(b,i)},android:{phone:!m(f,i)&&m(l,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(l,i)&&!m(a,i)&&(m(b,i)||m(p,i)),device:!m(f,i)&&(m(l,i)||m(b,i)||m(a,i)||m(p,i))},windows:{phone:m(f,i),tablet:m(u,i),device:m(f,i)||m(u,i)},other:{blackberry:m(c,i),blackberry10:m(s,i),opera:m(v,i),firefox:m(w,i),chrome:m(h,i),device:m(c,i)||m(s,i)||m(v,i)||m(w,i)||m(h,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=i():"function"==typeof define&&define.amd?define([],e.isMobile=i()):e.isMobile=i()}(this);

/**
 * replaceAll function. Replaces all occurrences of a string (since the js replace function only replaces the first one)
 * @param {String} search String to search for
 * @param {String} replacement Replacement string
 * @returns String with all replacements done
 */
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function plog(str){
    console.log(new Date().toISOString()+"::PSL::"+str);
}
/** custom function  **/
window.setQueryParams = function (url, params) { // case 2
    let pasreUrl = url.split('?')[0];
    let result =  pasreUrl + params;
    return result;
}

window.setAttr = function (id, attributeName, url, params) { // per jsp
    let tag = document.getElementById(id)
    if (tag)  tag.setAttribute(attributeName, window.setQueryParams(url, params))
}

/**
 * HB-1995 Checkout | Payment | AMEX card: add field validation CVV should have 4 digits (3 if cc is not amex)
 */

/**
 * This function check if the credit card passed as parameter is an American Express
 * Following this guide: https://www.cybersource.com/developers/getting_started/test_and_manage/best_practices/card_type_id/
 * Amex rules are: Valid length: 15 digits. First digit must be a 3 and second digit must be a 4 or 7.
 *
 * @param {String} ccNumber Credit card number with or without spaces
 * @param {boolean} strictTest If false this function will only test the first digits condition
 */
function isAmexCreditCard(ccNumber, strictTest){
    var ccNumberParsed;
    if (ccNumber.includes(" ")){
        ccNumberParsed = ccNumber.split(" ");
        ccNumberParsed = ccNumberParsed.join("");
    } else {
        ccNumberParsed = ccNumber;
    }
    if (ccNumberParsed.length<2){
        return false;
    }else{
        var ccHead = ccNumberParsed.substring(0,2);
        //Check if the credit card is American Express
        if (ccHead != "34" && ccHead != "37"){
            return false;
        } else {
            if (strictTest){
                if (ccNumberParsed.length == 15){
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }
}




function addDirectToCart(moco) {
	  //Declare a service for retrieving catalog entry detailed information for an item...
	isAdd2CartClicked=true;
	
	 var parameters = {
           moco : moco 
       };

	 
  wcService.declare({
      id: "GetCatalogEntryByMocoCmd",
      actionId: "GetCatalogEntryByMocoCmd",
      url: "GetCatalogEntryByMocoCmd",
      
      successHandler: function (serviceResponse) {
    	  //productDisplayJS.productAdd2Cart('entitledItem_'+serviceResponse.catentry);
    	  productDisplayJS.Add2ShopCartAjax('entitledItem_'+serviceResponse.catentry,1, false);
          productPageAdd2Cart();
          
          showDropdown=true;
          
          if (showDropdown && isVogue) {
        	  $('#shoppingCart').addClass('open');
              $('#MiniShopCartProductAdded').show();
              update_content = true;
              //We have added item to cart..So display the drop down with item added message..
              positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
              showDropdown = false;
              populateProductAddedDropdown();
          }
      },
      failureHandler: function (serviceResponse) {
          console.debug("We can't add to cart Item "+moco);
      }
  });
	 
  wcService.invoke("GetCatalogEntryByMocoCmd", parameters);
  
}





function GetCardType(number) {

	var retval="";
	
	var re = new RegExp("^4");
	if (number.match(re) != null)
		retval = "Visa";

	// Mastercard
	// Updated for Mastercard 2017 BINs expansion
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
    	retval = "MasterCard";

	// AMEX
	re = new RegExp("^3[47]");
	if (number.match(re) != null)
		retval = "Amex";

	// Discover
	re = new RegExp(
			"^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
	if (number.match(re) != null)
		retval = "Discover";

	// Diners
	re = new RegExp("^36");
	if (number.match(re) != null)
		retval = "Diners";

	// Diners - Carte Blanche
	re = new RegExp("^30[0-5]");
	if (number.match(re) != null)
		retval = "Diners";

	// JCB
	re = new RegExp("^35(2[89]|[3-8][0-9])");
	if (number.match(re) != null)
		retval =  "JCB";

	
	if(retval != '')
		return retval;
	else
		return "CC";

}

/**
 * This function changes the maxlength of the CVV input field, according to the
 * card number input value
 * 
 * @param {String}
 *            ccInputId Id of the credit card input field
 * @param {String}
 *            cvvInputId Id of the cvv input field
 */
function updateCVVInputLength(ccInputId, cvvInputId){
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    document.getElementById(cvvInputId).setAttribute("maxlength", maxVal);
}

/**
 * This function tests if the cvv length is valid for the credit card number passed as paramenter
 * Currently the logic is:
 *  If the card is Amex and ccv lenght = 4, then return true,
 *  if the card is not Amex and ccv lenght = 3, then return true,
 *  otherwise return false
 *
 * @param {String} ccNumber Credit card number
 * @param {String} cvv CVV number
 */
function matchCreditCardCVV(ccNumber, cvv){
    if (isAmexCreditCard(ccNumber, false)){
        //is American Express
        if (cvv.length==4){
            return true;
        }else{
            return false;
        }
    } else {
        //not American Express
        if (cvv.length==3){
            return true;
        }else{
            return false;
        }
    }
}

/* HB-1995 END ******************************************************************************/

/**
 * This function validates the maxlength of the CVV input field, according to the type of card card gotten from the input value of the card field
 *
 * @param {String} ccInputId Id of the credit card input field
 * @param {String} cvvInputId Id of the cvv input field
 */
function validateCVVInputLength(ccInputId, cvvInputId) {
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    var ccvInputValue = document.getElementById(cvvInputId).value;
    if (undefined != ccvInputValue && "" !== ccvInputValue) {
    	if (ccvInputValue.length != maxVal) {
    		$("#wrongCVVLength").css("display", "block");
    	} else {
    		$("#wrongCVVLength").css("display", "none");
    	}
    }
}

/**
 * getGoogleAddress(countryCode, zipCode, language, callbackFunction)
 *
 * This function provides a common interface to access the Google Address API.
 * First it makes an async call to Google API sending required parameters and,
 * when the response is received, it parses the data to fit our requirements.
 * Finally launches callbackFunction sending the parsed data object as parameter.
 *
 * Usage: e.g. (Named function)     getGoogleAddress("ES","15001", "es", myFunction);
 *             (Anonymous function) getGoogleAddress("ES","15001", "es", function(data){
 *                                      //Your code here
 *                                      //At this point data is an object with all the address info
 *                                  });
 *
 * Parsed address object:
 *      {
 *          status : <success | error>,
 *          error_description : <error description (only when status = error)>,
 *          address :
 *              {
 *                  city : <city name>,
 *                  country : <country name>,
 *                  country_short : <short country name>,
 *                  locality : <locality name>,
 *                  neighborhood : <neighborhoodId name>,
 *                  prov_state : <province name (state in the US), e.g."Citta Metropolitana di Milano">,
 *                  prov_state_short : <short province name (state in the US) e.g."MI">
 *                  zipcode : <zip code>
 *              },
 *          raw :
 *              {
 *                  <data object received from Google API>
 *              }
 *      }
 *
 * Usage samples:
 *    getGoogleAddress("US","10462", "en", showAddressData);
 *    getGoogleAddress("ES","15001", "es", showAddressData);
 *    getGoogleAddress("IT","20099", "it", showAddressData);
 *    getGoogleAddress("FR","20099", "it", showAddressData);
 *    getGoogleAddress("US","10462", "en", function(result){
 *        if (result.status == "error"){
 *            console.log(result.error_description);
 *        } else {
 *            console.log(result);
 *        }
 *    });
 *
 *
 * @param {String} countryCode e.g."ES"
 * @param {String} zipCode e.g."15001"
 * @param {String} language e.g. "es"
 * @param {function} callbackFunction
 */
function getGoogleAddress(countryCode, zipCode, language, callbackFunction){
    try{
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            componentRestrictions: {
              country: countryCode,
              postalCode: zipCode
            }
          }, function(results, status) {
            
                if(status != "OK"){
                    if(AddressHelper.zipCodeNotFound ||status == "ZERO_RESULTS") {
                        zipCodeError = false;
                    }
                    else {
                        zipCodeError = true
                    }
                }
                else{
                    zipCodeError=false;
                }
                
                findAddressInformation(results);
            
          });
    }catch(e){
        console.log("getGoogleAddress : the promise constructor cannot be invoked directly");
    }
    

      function findAddressInformation (results){
            var city = null;
            var locality = null;
            var neighborhood = null;
            var maxNeighborhoodlenght = 31;
            var province = null;
            var province_short = null;
            var postalCode = null;
            var administrativeArea2 = null;
            var administrativeArea1 = null;
            var administrativeArea3 = null;
            var administrativeArea2_short = null;
            var administrativeArea1_short = null;
            var administrativeArea3_short = null;
            var country = null;
            var country_short = null;
            var responseObj={};
            var addressData={};

            if (results == null || results[0] == null ||  results[0].address_components == null || results[0].address_components.length == 0
                    || (results[0].address_components.length == 1 && results[0].address_components[0].types[0] == "country")) {

                responseObj.status = "error";
                responseObj.error_description = "zipcode_not_found";
                responseObj.raw = results;

            } else {

                if (results != null && results[0] != null) {
                    var addressComponents = results[0].address_components;
                    for (var i = 0; i < addressComponents.length; i++) {

                        if (addressComponents[i].types[0] == "postal_code") {
                            postalCode = addressComponents[i].long_name;
                        }
                        //getting city
                        if (addressComponents[i].types[0] == "postal_town") {
                            city = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "country") {
                            country = addressComponents[i].long_name;
                            country_short = addressComponents[i].short_name;
                        }
                        //getting locality
                        if (addressComponents[i].types[0] == "locality") {
                            locality = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "neighborhood") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        if (addressComponents[i].types[2] == "sublocality_level_1") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        //getting administrative Area1 (state)
                        if (addressComponents[i].types[0] == "administrative_area_level_1") {
                            administrativeArea1 = addressComponents[i].long_name;
                            administrativeArea1_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area2
                        if (addressComponents[i].types[0] == "administrative_area_level_2") {
                            administrativeArea2 = addressComponents[i].long_name;
                            administrativeArea2_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area3
                        if (addressComponents[i].types[0] == "administrative_area_level_3") {
                            administrativeArea3 = addressComponents[i].long_name;
                            administrativeArea3_short = addressComponents[i].short_name;
                        }
                    }
                }

                if (city == null) {

                    if (locality == null){
                        if (neighborhood == null){
                            if (administrativeArea3 == null){
                                city = administrativeArea2;
                            } else {
                                city = administrativeArea3;
                            }
                        } else {
                            city = neighborhood;
                        }
                    } else {
                        city = locality;
                    }
                }

                // For america and canada administrativeArea1 represents the province
                // For italy and spain this value is stored on administrativeArea2
                if (country_short === 'ES') {
                    province = administrativeArea2;
                    province_short = zipCode.substring(0,2);
                    //HB-5761: revert HB-5556
                    //province_short = administrativeArea2_short; 
                } else if (country_short === 'IT') {
                    province = administrativeArea2;
                    province_short = administrativeArea2_short;
                } else {
                    province = administrativeArea1;
                    province_short = administrativeArea1_short;
                }

                addressData.city = city;
                addressData.locality = locality;
                addressData.neighborhood = neighborhood;
                addressData.prov_state = province;
                addressData.prov_state_short = province_short;
                addressData.country = country;
                addressData.country_short = country_short;
                addressData.zipcode = postalCode;

                /*
                addressData.administrativeArea1 = administrativeArea1;
                addressData.administrativeArea2 = administrativeArea2;
                addressData.administrativeArea3 = administrativeArea3;
                addressData.administrativeArea1_short = administrativeArea1_short;
                addressData.administrativeArea2_short = administrativeArea2_short;
                addressData.administrativeArea3_short = administrativeArea3_short;
                */
                
                responseObj.status = "success";
                responseObj.address = addressData;
                responseObj.raw = results;

                
            }
            callbackFunction(responseObj);
        
      }


}

function getGoogleAddressPromise(countryCode, zipCode, language){
   return new Promise(function(resolve, reject) {
                var geocoder = new google.maps.Geocoder();
        
                geocoder.geocode({
                    componentRestrictions: {
                    country: countryCode,
                    postalCode: zipCode
                }
                }, function(results, status) {
                        var data= {
                        results:"",
                         status:""
                        }
                    if (status == 'OK') {
                        zipCodeError=false;
                        data.results=results;
                        data.status= status;
                        resolve(data);
                    } else {     	
                        reject(function(data){
                            console.log("UnregisteredCheckout.jsp::","Zip code unknown");
                        });
       
                    }
       
                  });
    });
      
}

function convertGoogleAddressResponse(data){
    var responseObj = {};

    if (data.status != "OK"){
        responseObj.status = "error";
        responseObj.error_description = "google_api_error";
        responseObj.raw = data;
    } else {
        var addressData = {};

        var city = null;
        var locality = null;
        var neighborhood = null;
        var province = null;
        var province_short = null;
        var postalCode = null;
        var administrativeArea2 = null;
        var administrativeArea1 = null;
        var administrativeArea3 = null;
        var administrativeArea2_short = null;
        var administrativeArea1_short = null;
        var administrativeArea3_short = null;
        var country = null;
        var country_short = null;

        if (data == null || data.results[0] == null ||  data.results[0].address_components == null || data.results[0].address_components.length == 0
                || (data.results[0].address_components.length == 1 && data.results[0].address_components[0].types[0] == "country")) {

            responseObj.status = "error";
            responseObj.error_description = "zipcode_not_found";
            responseObj.raw = data;

        } else {

            if (data != null && data.results[0] != null) {
                var addressComponents = data.results[0].address_components;
                for (var i = 0; i < addressComponents.length; i++) {

                    if (addressComponents[i].types[0] == "postal_code") {
                        postalCode = addressComponents[i].long_name;
                    }
                    //getting city
                    if (addressComponents[i].types[0] == "postal_town") {
                        city = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "country") {
                        country = addressComponents[i].long_name;
                        country_short = addressComponents[i].short_name;
                    }
                    //getting locality
                    if (addressComponents[i].types[0] == "locality") {
                        locality = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "neighborhood") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[2] == "sublocality_level_1") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    //getting administrative Area1 (state)
                    if (addressComponents[i].types[0] == "administrative_area_level_1") {
                        administrativeArea1 = addressComponents[i].long_name;
                        administrativeArea1_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area2
                    if (addressComponents[i].types[0] == "administrative_area_level_2") {
                        administrativeArea2 = addressComponents[i].long_name;
                        administrativeArea2_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area3
                    if (addressComponents[i].types[0] == "administrative_area_level_3") {
                        administrativeArea3 = addressComponents[i].long_name;
                        administrativeArea3_short = addressComponents[i].short_name;
                    }
                }
            }

            if (city == null) {
                //city = locality == null ? (neighborhood == null ? (administrativeArea3 == null ? administrativeArea2 : administrativeArea3) : neighborhood) : locality;
                if (locality == null){
                    if (neighborhood == null){
                        if (administrativeArea3 == null){
                            city = administrativeArea2;
                        } else {
                            city = administrativeArea3;
                        }
                    } else {
                        city = neighborhood;
                    }
                } else {
                    city = locality;
                }
            }

            // For america and canada administrativeArea1 represents the province
            // For italy and spain this value is stored on administrativeArea2
            if (country_short === 'ES') {
                province = administrativeArea2;
                //province_short = postalCode.substring(0,2);
                //fix
                province_short = administrativeArea2_short;
            } else if (country_short === 'IT') {
                province = administrativeArea2;
                province_short = administrativeArea2_short;
            } else {
                province = administrativeArea1;
                province_short = administrativeArea1_short;
            }

            addressData.city = city;
            addressData.locality = locality;
            addressData.neighborhood = neighborhood;
            addressData.prov_state = province;
            addressData.prov_state_short = province_short;
            addressData.country = country;
            addressData.country_short = country_short;
            addressData.zipcode = postalCode;

            responseObj.status = "success";
            responseObj.address = addressData;
            responseObj.raw = data;
        }
    }

    return responseObj;
}

function getUserAddressListPromise(){
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
    return $.ajax({
        method: "GET",
        url: url,
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        data: {
            "timestamp": Date.now()
        },
        dataType: "json"
    });
}

function updateCurrentOrderShippingDatePromise(){
    var time = "0700";
    if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
        time = "1200";
    } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
        time = "1800";
    }

    var date = $("#datepicker-holder").datepicker('getDate');
    var formattedDate = $.datepicker.formatDate("yymmdd", date);

    $.ajax({
        type: "POST",
        url: "AjaxShippingDateUpdate?requestType=update&shippingDate=" + formattedDate + time + "&ordersId=.&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate"
        }
    });
}



/**
 * This function transform a jQuery ajax error response to a string error message
 * Usage:
 *   $.ajax({
 *       ...
 *       success: function (data) {
 *           ...
 *       },
 *       error: function(jqXHR, exception){
 *           console.log(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
 *       },
 *       complete: function(){
 *           ...
 *       }
 *   });
 *
 * @param {Object} jqXHR
 * @param {String} exception
 * @returns {String} Error message
 */
function getAjaxErrorMessage(jqXHR, exception){
    var msg = "";
    if (jqXHR.status === 0) {
        msg = "Not connected.\n Verify Network.";
    } else if (jqXHR.status == 404) {
        msg = "Requested page not found. [404]";
    } else if (jqXHR.status == 500) {
        msg = "Internal Server Error [500].";
    } else if (exception === "parsererror") {
        msg = "Requested JSON parse failed.";
    } else if (exception === "timeout") {
        msg = "Time out error.";
    } else if (exception === "abort") {
        msg = "Ajax request aborted.";
    } else {
        msg = "Uncaught Error.\n" + jqXHR.responseText;
    }

    return msg;
}
/**
 * @desc Compare arrays
 * @param {Array} array
 * @see https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript?page=1&tab=votes#tab-top
 * @return True or False
 */

// Warn if overriding existing method
if (Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");

// Attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // If the other array is a falsy value, return
    if (!array) return false;

    // Compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // Recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

/**
 * Add NodeList.forEach and Element.remove support to IE9+
 */
(function() {
    if (typeof NodeList.prototype.forEach !== "function"){
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if (typeof Element.prototype.remove !== "function"){
        Element.prototype.remove = function(){
            this.parentElement.removeChild(this);
        }
    }
})();

/**
 * This function creates a cookie named 'WC_X_LoggedUser=No' when the user is G (guest).
 * If the storeUserType changes to registered, the cookie is deleted by the function.
 * This function helps Akamai to determinate if the jsp should be cached or not.
 * NERD-761
 * 23-11-23
 * hb-14987 --> in this function is been added sessionStorage["logged"] = 'false'; 
 * 				to indicated the user is not logged
 * 			    
 */

loggedUserCookieManager();

function loggedUserCookieManager(){
    //If the user is G=Guest, creates the cookie
    if (storeUserType === "G"){
        document.cookie="WC_X_LoggedUser=No;;path=/";

    }
    //Otherwise, the cookie is deleted
    else{
        var today = new Date();
        today.setTime(today.getTime() - 1000);
        var expires = "expires="+today.toUTCString();
        document.cookie="WC_X_LoggedUser=;" + expires + ";path=/";
    }
}




function getTaxesFromZipCodePromise(srcForm){
    if (!AddressHelper.hasTaxes){
        return "";
    }else{
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var city = srcForm.city.value;
        var state = srcForm.state.value;
        var zipcode = srcForm.zipCode.value;

        // submit AjaxOrderCalculate request
        var params = [];

        params.storeId      = WCParamJS.storeId;
        params.catalogId    = WCParamJS.catalogId;
        params.langId       = WCParamJS.langId;

        params.updatePrices = "0";
        if(isCheckOut){
            params.orderId = ".";
        } else {
            params.orderId = $('#wcs_calTax_notification #orderId').val();
        }

        params.addressFlag = true;
        params.isDeliveryAddressAdded = false;
        params.zipCode = zipcode != null ? zipcode : "";
        params.city = city != null ? city : "";
        params.state = state != null ? state : "";
        params.country = "us";
        params.isZipChange = true;//isZipChange;

        var url = getAbsoluteURL() + "AjaxOrderCalculate?";
        for (var param  in params) {
            url += param + "=" + params[param] + "&";
        }
        url += "calculationUsageId=-1&";
        url += "calculationUsageId=-2&";
        url += "calculationUsageId=-3&";
        url += "calculationUsageId=-4";

        //Make the call to AjaxOrderCalculate
        return $.ajax({
            url: url,
            type: 'POST',
        });
    }
}

function goToOrderShippingBillingViewOnClickHandler(event){
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    let isFormNoError = true; //true if form is without error in checkout 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }
    
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    form2.email1.value=form1.email1.value;
    if(isFormNoError){
        isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    }else {
        AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>')
    }
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
                  if (typeof data.contact === 'undefined'){
                      plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                      AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                  } else {
                      for (var i = 0; i<data.contact.length; i++){
                          if (data.contact[i].nickName == 'MyAddress_Shipping'){
                              plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                              AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                              break;
                          }
                      }
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        	if(AddressHelper.validateAddressForm(form3)) {
        		/*
        		 * //REPLACE BOSS: 
        		 * 70128 with zipcode of pickupstore
        		 * we will take this zipcode by the tab services
        		 
        		getGoogleAddressPromise(countryCode, '70128', storeLanguage) 
		        .then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + '70128' + " not valid for country "+countryCode;
		            } else {
		            	/*
		            	 * REPLACE BOSS: 
		            	 * var city will be the city of store
		            	 * we will take this city by the tab services
		            	
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_billingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form3, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form3);
		        }).then(function(data){
		        	//Billing Address
		            return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		        }).then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		            	formValidationError = true;
		                throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		            } else {
		            	AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		            }
		            return getUserAddressListPromise();
		        }).then(function(data){
			    	if (typeof data.contact !== 'undefined'){
			        	for (var i = 0; i<data.contact.length; i++){
			            	if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
			                	AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
			                    plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
			                }
			            }
			        }
			    }, function(err){
			    	 console.log(err);
			    }).then(function(){
		            if (!AddressHelper.validateAddressForm(form3)){
		                formValidationError = true;
		            }
		            if (!AddressHelper.validateAddressForm(form2)){
		            	formValidationError = true;
		           	}
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            AddressHelper.joinNewsletter('recipient_detail', WCParamJS.langId, WCParamJS.storeId);
		            
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv2');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, false, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        }); 
        	}
        }else{*/
	    	if(AddressHelper.validateAddressForm(form1)) {
                if(isFormNoError)
                    isFormNoError  = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		
		            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
		
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        })
	    	}else{
                isFormNoError = false;
            }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError){ 
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc'); 
    }  
}


// NERD-760 Functions that help Akamai to determinate if it is necesary to activate the cache depending if the user is logged and / or if there are items on cart

/**
 * This function calls updateItemsInCartBadge() passing it the number of items that have been added to the cart by the user.
 * NERD-762
 */
function getNumberOfItemsInCart(){
    if(personInfo.userId !== '-1002' || (isVogue && document.querySelectorAll('.pdp').length > 0)){
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
        getAjaxCallInfo(url, null, numberOfItemsInCartCallback);

        function numberOfItemsInCartCallback(response) {
            if(response.recordSetTotal !== '0') {
                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
                getAjaxCallInfo(url, null, orderitemsInfoInCartCallback);
            } else {
                updateItemsInCartBadge(response.recordSetTotal);
            }
        }
        function orderitemsInfoInCartCallback(response) {
        	var total= 0;
        	if(response != undefined && response.recordSetTotal != 0) {
        		total = response.recordSetTotal;
        		response.orderItem.forEach(function(item) {
        			if(item.partNumber.includes('Service') || item.partNumber.endsWith("SV") || item.partNumber.endsWith("PG") ) { //non contare engraving, lenti e servizi 
        				total-=1;
                    }
        		});
        		
        	}
        	updateItemsInCartBadge(total);
            /**if(response.orderItem) {
                for(var i = 0; i < response.orderItem.length; i++) {
                    if((response.orderItem[i].xitem_field2 && (response.orderItem[i].xitem_field2).indexOf("|") !== -1)
                     || (response.orderItem[i].partNumber && (response.orderItem[i].partNumber).indexOf("K-") !== -1)) {
                        total--;
                    }
                }
                updateItemsInCartBadge(total);
            }*/
        }
    }
}

/**
 * This function updates the number rendered into the shoping bag badge according to the number of items included in the cart.
 * As well, if the amount is equal to 0, adds the class 'empty' to the element.
 * @param {*} itemsInCartBadge Amount of items added to the cart by the user.
 * NERD-762
 */

var itemsInCartBadge = "0";
function updateItemsInCartBadge(paramItemsInCart){

    var itemsInCartBadgeElement;
    if (document.getElementById("minishopcart_total") !== null) {
        itemsInCartBadgeElement = document.getElementById("minishopcart_total");
    } else {
        itemsInCartBadgeElement = "0";
    }
    itemsInCartBadge = paramItemsInCart;
    itemsInCartBadgeElement.innerHTML  = itemsInCartBadge;

    if (itemsInCartBadgeElement.innerHTML === "0"){
        itemsInCartBadgeElement.classList.add("empty");
    }

    if(isPersol && paramItemsInCart > 0){
    	var minicartHtml = $('#minishopcart_total');
    	if(minicartHtml.length == 0){
    	minicartHtml = $('<div/>',{id: 'minishopcart_total', class: 'minishopcart-quantity-number'});
    	}
    	minicartHtml.text(paramItemsInCart);
    	$('#widget_minishopcart').prepend(minicartHtml);
    }
    
    if(isVogue) {
        var shopElem =  document.getElementById('shoppingCart');
        var isPDP = document.querySelectorAll('.pdp').length > 0;
        if(isPDP) {
            if(!isAdd2CartClicked && personInfo.userId === '-1002') {
                shopElem.classList.remove('fill');
            } else if(isAdd2CartClicked) {
                shopElem.classList.remove('fill','added');
                shopElem.classList.add('added');
                isAdd2CartClicked = false;
            } else if(!isAdd2CartClicked && personInfo.userId !== '-1002' && paramItemsInCart !== '0' && paramItemsInCart !== '') {
                shopElem.classList.add('fill');
            }
        } else {
            if(itemsInCartBadgeElement.innerHTML !== "0") {
                shopElem.classList.add('fill');
            } else {
                shopElem.classList.remove('fill');
            }
        }
    }
}

/**
 * Function that make a GET ajax call and execute a callback if success
 * @param {string} url - the url to make the ajax call
 * @param {object} params - ajax call params if its needed
 * @param {function} callback - function that it will be executed if ajax call is success
 */
function getAjaxCallInfo(url, params, callback) {
    var parameters = {};
    if(params) {
        parameters = params;
    }
    parameters["timestamp"] = Date.now();
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters,
        success: function (response, textStatus, request) {
            callback(response);
        },
        error: function(response){
            console.log(response);
            if(typeof pageType != "undefined")
				callback(response);
        }
    });
}

// BEGIN NERD-795 PSD2 | Front-end | Adaptation
// Those functions are called from servicesDeclaration.js AjaxSubmitOrder service
    /**
     * This function creates a dark overlay with a loader spinner that fits the whole page and adds a 'noScroll' class to the body.
     * The scope is to improve the UX while the PSD2 payment is in process.
     */
    function createPaymentLoaderOverlay(){
        $("body").append("<div class='paymentLoaderOverlay'></div>");
        $('body').addClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner that fits the whole page and removes a 'noScroll' class from the body.
 */
    function deletePaymentLoaderOverlay(){
        $(".paymentLoaderOverlay").remove();
        $('body').removeClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner when any error message is closed by clicking on its closing buton
 */
    $(function(){
        $('#clickableErrorMessageImg').click(deletePaymentLoaderOverlay);

    });

// END NERD-795 PSD2 | Front-end | Adaptation
// BEGIN HB-3160: recover parameter from URL generic function.
/**
 * Recover a parameter from URL, returning the default value if does not exist.
 *
 * @param parameter Parameter name
 * @param defaultValue Parameter default value when it does not exist in URL
 * @return Parameter value
 */
function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        urlparameter = vars[parameter];
        if (urlparameter === undefined || urlparameter === null) {
            urlparameter = defaultvalue;
        }
    }
    return urlparameter;
}
// END HB-3160

/**
 * HB-3032 | All | Analytics | Do not push to Tealium certain payment response codes
 * This variable is used in Stores/WebContent/<Brand>SAS/javascript/ServicesDeclaration.js, in failureHandler of AjaxRESTOrderSubmit service
 *
 * Those response values are not application errors so they should not be shown in Analytics
 * 202 - Expired card
 * 203 - Card refused
 * 204 - Insufficient funds
 * 205 - Stolen card
 * 208 - Inactive card
 * 209 - CVN doesn't match
 * 210 - Reached the credit limit
 * 211 - Invalid CVN
 * 230 - Soft decline
 * 231 - Invalid account number
 * 233 - General decline
 * 481 - Decision manager decline (now managed by Forter)
 */

var paymentResponseCodesNotWCSError = [
    "PLUGIN_RC_202",
    "PLUGIN_RC_203",
    "PLUGIN_RC_204",
    "PLUGIN_RC_205",
    "PLUGIN_RC_208",
    "PLUGIN_RC_209",
    "PLUGIN_RC_210",
    "PLUGIN_RC_211",
    "PLUGIN_RC_230",
    "PLUGIN_RC_231",
    "PLUGIN_RC_233",
    "PLUGIN_RC_481"
];

var paymentErrorMessageMeaning = {};

paymentErrorMessageMeaning["PLUGIN_RC_202"] = "Expired card";
paymentErrorMessageMeaning["PLUGIN_RC_203"] = "Card refused";
paymentErrorMessageMeaning["PLUGIN_RC_204"] = "Insufficient funds";
paymentErrorMessageMeaning["PLUGIN_RC_205"] = "Stolen card";
paymentErrorMessageMeaning["PLUGIN_RC_208"] = "Inactive card";
paymentErrorMessageMeaning["PLUGIN_RC_209"] = "CVN doesn't match";
paymentErrorMessageMeaning["PLUGIN_RC_210"] = "Reached the credit limit";
paymentErrorMessageMeaning["PLUGIN_RC_211"] = "Invalid CVN";
paymentErrorMessageMeaning["PLUGIN_RC_230"] = "Soft decline";
paymentErrorMessageMeaning["PLUGIN_RC_231"] = "Invalid account number";
paymentErrorMessageMeaning["PLUGIN_RC_233"] = "General decline";
paymentErrorMessageMeaning["PLUGIN_RC_481"] = "Decision manager decline";

function sendPaymentErrorMessageToTealium(errorMessageKey, errorMessage){
    if (paymentResponseCodesNotWCSError.includes(errorMessageKey)){
        pushErrorToTealium('Client', "Cybersource Error " + errorMessageKey + " (" + paymentErrorMessageMeaning[errorMessageKey] + ")", 'Error in CyberSource occurred on payment of order',CheckoutHelperJS.getOrderId());
    } else {
        //pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order <' + CheckoutHelperJS.getOrderId() + '>');
    	//HB-3186
    	pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order',CheckoutHelperJS.getOrderId());
    }
}

// HB-3032 END

function getAjaxPromise(url) {
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters
    });
}

function removeErrorMessagesFromElement(element){
    $(element).find(".error-messages-section").remove();
    $('#WC_PromotionCodeDisplay_div_2').removeClass('error');
}

function addErrorMessageToElement(element, message){
    var el = $(element);
    var noErrorSection = false;

    if ($(el).find(".error-messages-section").length==0){
        if(el.attr('id')== 'PromotionCodeForm' && (isOliver ||isPersol) ){ //only checkout 3.0
            $('#WC_PromotionCodeDisplay_div_2').addClass('error');
            $('#PromotionCodeForm #PromotionCodeForm_upper .input-style').after("<div class='error-messages-section'></div>");
        }else{
        $(el).append("<div class='error-messages-section'></div>");
        }
        noErrorSection = true;
    }

    el = $(element).find(".error-messages-section");

    if (noErrorSection || $(el).find(".error-message.error-message-md5-"+md5(message).toString()).length==0){
    	if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
    		$('#PromotionCodeForm .error-message').remove();
    		$('#PromotionCodeForm input#promoCode.error , #PromotionCodeForm input#coupon-value.error').removeClass('ea_input');
    	}
    	var finalMessage = "<div class='error-message error-message-md5-"+ md5(message).toString() +"'>" + message + "</div>";
        $(el).append(finalMessage);
    }
}

/* detect mobile*/ 
window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

window.tabletPortraitCheck = function(){
    var tabletPortrait = false;
    var mq =  window.matchMedia( "screen and (min-width:1024");
    var portrait =  window.matchMedia("(orientation: portrait)");
    if(!mq.matches  && portrait.matches){
        tabletPortrait = true; 
    }
    return tabletPortrait;
}

/* function to manage header z-index in pdp mobile  */
function checkMobilePdpPage(){
    if((window.mobilecheck() || window.tabletPortraitCheck()) && $('#page').hasClass('pdp')){
        return true
    }
}

//its also used in WCAG.js too
function productPageAdd2Cart(wishlistProductId) {

    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
			showCTAloaderClip();
		}else{
			showCTAloader("productPageAdd2Cart");
		}
	} else if (isPersol || isOliver){
        if (!isWishlistPage){
            showCTAloader("productPageAdd2Cart");
        } else {
            showWishlistCTAloader(wishlistProductId);
        }
    }

    var waitForEl = function(selector, callback) {
        if ($(selector).length) {
            callback();
        } else {
            setTimeout(function() {
                waitForEl(selector, callback);
            }, 1000);
        }
    };

    var selector = '[aria-describedby="MiniShopCartProductAdded"]';

    waitForEl(selector, function() {

    	if(isPersol && !productDisplayJS.priceSwitched){
    		if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	    			var clip_on_selected = $('.product-clip-on.selected').attr('catentryClip');
	    			var clip_on_sku_selected = $('#current-clipon-catentry').val();
	    			var offer_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].price;
	                var list_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].listprice;
	                productDisplayJS.lastPriceSaved = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
    		} else {
	            var offer_price = !isWishlistPage ? document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('offerPrice_'+wishlistProductId).innerText;
	            //document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
	            productDisplayJS.lastPriceSaved = offer_price;
	            var list_price = !isWishlistPage ? document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
	            if (!isWishlistPage) {
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	            } else {
	                document.getElementById('listPrice_'+wishlistProductId).innerText = productDisplayJS.lastOfferPriceSaved;
	            }
	            productDisplayJS.lastOfferPriceSaved = list_price;
    		}
            
            
           
            /*
             // Show complete pair offer price if frame has a promotion
             // Now handled by LensConfigurator

                if (completePairTotalPrice != undefined && completePairTotalPrice[frameId] != undefined && completePairTotalPrice[frameId][selectedLendCatentryId] != undefined) {
                    var frameId = $("#roxLenses").val();
                    var selectedLensID = $("#presc--lens--id").val();
                    var hasPromotion = completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] != undefined ? completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] : false;
                    if (hasPromotion) {
                        var completePairOfferPrice = completePairTotalPrice[frameId][selectedLensID]['offerPrice'];
                        var completePairListPrice = completePairTotalPrice[frameId][selectedLensID]['listPrice']; 
                        $('.priceCart')[0].innerText = WCCurrencyJS.format(completePairOfferPrice);
                        $('#minicartPST.price__list')[0].innerText = WCCurrencyJS.format(completePairListPrice);
                        document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    }
                }
            */
	    	if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
	    	productDisplayJS.priceSwitched = true;
            
    	}
    	else if(isOliver && !productDisplayJS.priceSwitched) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+wishlistProductId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			var temp = div.getElementsByClassName('price__unity')[0].innerText;
    			productDisplayJS.lastPriceSaved = temp;
        		div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        	}
    		
    		var temp = !isWishlistPage ? document.getElementById('listPrice_'+productParent).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
    		if (!isWishlistPage){
                document.getElementById('listPrice_'+productParent).innerText=productDisplayJS.lastOfferPriceSaved;
            } else {
                document.getElementById('listPrice_'+wishlistProductId).innerText=productDisplayJS.lastOfferPriceSaved;
            }
            
    		productDisplayJS.lastOfferPriceSaved = temp;
    		if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
    		productDisplayJS.priceSwitched = true;
    	}
        //reset size
        $('.options_dropdown_column input').each(function( index,input ) {
            if(isOliver){
                var stringCmp = "normal"
            }else{
                var stringCmp = "standard"
            }         
            if(input.value.toLowerCase().includes(stringCmp)){
                $('.options_dropdown_column .size-option-selected span').html(input.value);
            }
        //reset z-index bottom-scrollable-section
        $('.bottom-scrollable-section').css('z-index', "3"); 
            
        });
    	// work the magic
        var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
        showDefaultPaymentPlacement(defaultPaymentPlacement);
        $('[aria-describedby="MiniShopCartProductAdded"]').addClass("opend");
        // $('#page-overflow-wrapper').addClass('overflow-hidden');
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            $('body').addClass('no-scroll');
        }

        if($('#page').hasClass('pdp') && brandCode=="PO"){
            $('#header').css('z-index', '1000') 
        }

        $(".minishopcartadded--fade").show(); 
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            if(!$('#header').is(":visible")) $('#header').slideDown()
            hideHeaderTimeout.cancel();
        }
        if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			setTimeout(function() {
    				hideCTAloaderClip();
                }, 1000)
    		}else{
    			setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
    		}
    	} else if (isPersol || isOliver){
            if (!isWishlistPage){
                setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
            } else {
                setTimeout(function() {
                    hideWishlistCTALoader(wishlistProductId);
                }, 1000)
            }
        }

        if (minicartYMALCallback != undefined) {
            minicartYMALCallback.onWidgetLoaded();
        }

        //HB-7718 
        //check if the add to cart is related to upsell
        var isUpsell = false;
        if($('#upsell-added-inicart').length > 0){
            isUpsell = true;
        }

        //START Early Access
        if (isPersol){
        	var offer_price;
        	var list_price;
        	
            //Wishlist
            if (isWishlistPage) window.lastOfferPrice = returnLastOfferPrice();
            //Wishlist

            //if a upsell products is been added in cart we must use the offerprice and listprice of the upsell product
        	//this listprice and offerprice are in a div created in updateLastOfferUpsell() in store-presol.js
        	//after this we must delete the div with upsell product's listprice and offerprice.
        	if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	        		var str_offer_price = offer_price.trim();
	            	var str_list_price = list_price.trim();
        	} else {
        		var str_offer_price = returnLastOfferPrice().trim();
            	var str_list_price = productDisplayJS.lastOfferPriceSaved.trim();
        	}
        	
        	//SETTING PRICE IN MINICART
        	if(!isUpsell){
        		if(productDisplayJS.engraving){
        			 str_offer_price = document.getElementById('offerPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 if(productDisplayJS.lastOfferPriceSaved!==""){
        				 str_list_price = document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 }
        		}
        		$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html(str_offer_price);
        		
        		
        		if(str_offer_price != str_list_price && !str_list_price.includes("NaN")){
        			document.getElementById("minicartPST").innerHTML=str_list_price;
        		}
                if (!isWishlistPage){
	        		if(!($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true')){
		        		offer_price = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
		        		list_price = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
	        		}
                } else {
                    offer_price = document.getElementById('offerPrice_'+wishlistProductId).innerText;
                    list_price = document.getElementById('listPrice_'+wishlistProductId).innerText;
                } 
        	}else{
        		if($('#upsell-added-inicart #upsell-offer-price').text().length > 0){
        			$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html($('#upsell-added-inicart #upsell-offer-price').text());
        		}
        		offer_price = $('#upsell-added-inicart #upsell-offer-price').text();
        		list_price = $('#upsell-added-inicart #upsell-list-price').text();
                //hide carousel for new upsell
                hideCarouselRecommend('#minicartYMAL');
        	}
        	
        	//upload PST in minicart
            if((document.cookie.includes('X_WC_PR_SEGMENTS') || isUpsell) && list_price.length > 0){
            	if(parseFloat(list_price.replace( /^\D+/g, '')) != parseFloat(offer_price.replace( /^\D+/g, ''))){
            		$('#minicartPST.price__list')[0].innerText = list_price;
            	}
            	
            	if(isUpsell){
            		$('#upsell-added-inicart').remove();
            	}
            }
        }else{
            if(isUpsell){
                //hide carousel for new upsell
                $('#upsell-added-inicart').remove();
                hideCarouselRecommend('#minicartYMAL');
            }
        }
        //END Early Access

        //Show badge in minicart
        if (isOliver || isPersol){
            if ( $('.minicart-badge .prescription_added').length > 0 || $('.minicart-badge .product_polarized').length > 0) {
                if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                    $(".minicart-badge").show();
                } else $(".minicart-badge.mobile").show();
            }
        }

        //added manifest map in localStorage
        if(localStorage != undefined){
            if(localStorage['manifestMap']!= undefined){ 
                try {
                    var manifestMapMerged = $.extend($.parseJSON(localStorage['manifestMap']),$.parseJSON($("#manifestMap").val()));
                    localStorage.setItem('manifestMap', JSON.stringify(manifestMapMerged));
                }
                catch(e) {
                    localStorage.setItem('manifestMap',$("#manifestMap").val());
                }
            }else{

                localStorage.setItem('manifestMap',$("#manifestMap").val());
            }

            if (isOliver || isPersol) {
                // var upSellPartNumber = $("#upSellPartnumber").val();
                // const upSellPartnumberArray = upSellPartNumber.split(" ").slice(1);
                if (isWishlistPage){
                    replaceImageMinicart($("#cartDropdown .product_image img"));
                } else {
                    replaceImageMinicart($("#cartDropdown .product_image img"), partNumber);
                }
                replaceImageMinicart($("#cartSuggestion .owl-item.active .product_image  img:nth-child(2)"));
                $("#skeleton-minicart").hide();
                $("#cartDropdown .product_image img").eq(0).show();
            }
        
        }

    });
}

function changeHeaderIndex(isOpening){
    isOpening ? $('#header').css('z-index', '1001') :  $('#header').css('z-index', '600')
}
function changeFooterIndex(isOpening){
    isOpening ? $('#footerWrapper').css('z-index', '1002') :  $('#footerWrapper').css('z-index', '600')
}

function hideCarouselRecommend(container){
    switch(container){
      case "#minicartYMAL":
        if(isPersol) $('#widget_minishopcart_popup_1').addClass('disable-carousel');
      default:
        $(container).hide();
      break;
    }
}
function getPreOrderBadge(attributes) {
    var preOrder = null;
    preOrder = attributes.find(x=>(x.identifier == 'PREORDER' && x.usage == 'Descriptive'));
    if(isPreOrderActive && preOrder) {
        var preOrderVal = preOrder.values[0].value ? preOrder.values[0].value.toString().toLowerCase() : null;
        if(preOrderVal && preOrderVal == 'true') {
            return preOrder.identifier;
        }
    }
}


function printBadges(attributes){
    /**
     * OP Badge Hierarchy
     * PremiumMaterials > Exclusive > Pre-release > New > Clip Available
    */
    if(isOliver) {
        var newRelease = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;
        var preRelease = null;
        
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        preRelease = attributes.find(x=>(x.identifier == 'PRE_RELEASE' && x.usage == 'Descriptive')); 
        if(preRelease) {
            var preReleaseVal = preRelease.values[0].value ? preRelease.values[0].value.toString().toLowerCase():null;
            if(preReleaseVal && preReleaseVal =='true')
                return preRelease.name;
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
        clipsAvailable = attributes.find(x=>(x.identifier == 'MATCH_WITH_CLIPS' && x.usage == 'Descriptive'));
        if(clipsAvailable) {
            var clipsAvailableVal = clipsAvailable.values[0].value ? clipsAvailable.values[0].value.toString().toLowerCase() : null;
            if(clipsAvailableVal && clipsAvailableVal =='true')
                return  $('#clipAvailable').val();
        }  
    }
     /**
     * PO Badge Hierarchy
     * Limited Edition > Exclusive > PremiumMaterials > New
    */
    if(isPersol){
        
        var premiumMaterial = null;
        var exclusive = null;
        var newRelease = null;
        var limited = null;
        
       
        limited = attributes.find(x=>(x.identifier == 'LIMITED_EDITION' && x.usage == 'Descriptive'));
        if(limited) {
            var limitedEditionVal = limited.values[0].value ? limited.values[0].value.toString().toLowerCase() : null;
            if( limitedEditionVal && limitedEditionVal == 'true')
                return limited.name;
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
    }

    return "";
}

//Begin of EMAIL_ME
function printStatus(product){
    
    if(isEcommerceStoreJS == 'TRUE' && !(typeof product['inventory'] === 'undefined')){
        
        var comingSoon = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'true';
        var soldOut = product['inventory']['ranking'] == '0';
        var comingSoonBack = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'false';
        if(soldOut == false && comingSoonBack == false && comingSoon == false){
            return false; //se non ci sono badge da mostrare ritorna falso ==>serve per il controllo in CatalogENtryList_Oliver/persol_ui.jspf 
        }else{
            return {'SoldOut': SOLD_OUT_STATUS ,
                        'isSoldOut': soldOut , 
                        'Coming': COMING_SOON_STATUS, 
                        'isComing': comingSoon,
                        'ComingSoonBack': COMING_SOON_BACK_STATUS,
                        'isComingSoonBack': comingSoonBack,
                        }
        }
                    
    }   else{
        return false;
    }    
    
}
//End of EMAIL_ME




function getPolarized (attributes,isClass) {
    var polarized = null;
    var isPolar = false;
    if (attributes != undefined) {
        polarized = attributes.find(x=>(x.identifier == 'POLARIZED' && x.usage == 'Descriptive'));
        var polarizedValue = polarized && polarized.values[0].value ? polarized.values[0].value.toString().toLowerCase(): 'false';
        if(polarizedValue == 'true' || polarizedValue == 'yes') {
            polarized = polarized.name;
            if(polarized == null){
                polarized = POLARIZED_TEXT;
            }
            isPolar= true;
        }
        else polarized=null;
    }
    return isClass ? isPolar : polarized;    
}

function getTransitionBadge (attributes,isClass) {
    var transition = null;
    var isTransition = false;

    if (attributes != undefined) {
        transition = attributes.find(x=>(x.identifier == 'TRANSITIONS' && x.usage == 'Descriptive'));
        var transitionValue = transition && transition.values[0].value ? transition.values[0].value.toString().toLowerCase(): 'false';
        if(transitionValue == 'true' || transitionValue == 'yes') {
            transition = transition.name;
            if(transition == null){
                transition = TRANSITION_TEXT;
            }
            isTransition= true;
        }
        else transition=null;
    }
    return isClass ? isTransition : transition;
}


function isPrescription(attributes){
    var isRoxable=false;
    for (var index = 0; index < attributes.length; index++) {
    
           
            if ( attributes[index].identifier == 'IS_ROXABLE') {
                isRoxable = (attributes[index].values[0].value.toLowerCase() == 'yes' || attributes[index].values[0].value.toLowerCase() == 'true');
                break;
            }else{
                isRoxable = false;
            }
        
    }
    return isRoxable;
}



function getElementPosition(idClass) {
    var element = $(idClass);
    var offset = element.offset();

    return {
        'top': offset.top,
        'right': offset.left + element.outerWidth(),
        'bottom': offset.top + element.outerHeight(),
        'left': offset.left,
    };
};
          
function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
   };

function replaceImage(picture,typeImg){
        var urlBase_Persol = "https://assets2.persol.com/is/image/";
        var urlBase_Oliver = "https://assets2.oliverpeoples.com/is/image/";
        var urlBaseAccessories_Oliver = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var urlBaseAccessories_Persol = "https://assets.persol.com/extra/image/TargetOptical/accessories/";
        var FOLDER_NAME_Persol = "Persol";
        var FOLDER_NAME_Oliver = "OliverPeoples";
        var SUFFIX_AKAMAI_WS = "_manifest_2.json";
        var FOLDER_ACCESSORIES_IMAGES_PERSOL = "https://assets.persol.com/extra/image/Persol/accessories/";
        var FOLDER_ACCESSORIES_IMAGES_OLIVER = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var productPartNumber;
        if(isOliver){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }else if(isPersol){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }
        if (screenWidthPx <= 400) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=400');
        } else if (400 < screenWidthPx && screenWidthPx <= 750) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=800');
        } else if (1200 < screenWidthPx) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=2000');
        }

        //get partnumber and create url for call to manifest
        for(var i = 0; i < picture.length; i++) {
        	if(picture[i].className == 'lazy catalog__image--front'){
        		productPartNumber= picture[i].dataset.partnumber;
        		if(isPersol){
                    var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }else{
                    var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }
        	}else{
        		for(var j = 0; j < picture[i].childNodes.length; j++){
                    if(picture[i].childNodes[j].nodeName == 'IMG'){
                        productPartNumber= picture[0].childNodes[5].dataset['partnumber'];
                        if(isPersol){
                            var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }else{
                            var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }                        
                    }
                }
        	}            
        }
        var thumbnail="";
        var hasImage=false;
         //call service (manifest)
        $.ajax({
            url: akamaiAPI,
            dataType: "json",
            success: function(data) {
                //check if there is the required image
                for (var i = 0; i < data.items.length; i++) {
                    var imageFileKey = data.items[i].file_key;
                    if (imageFileKey.includes(typeImg)) {
                        hasImage= true;
                    }
                }

            }, error: function(requestObject, error, errorThrown){
                console.error("error in rest call to manifest",error);
            }, complete: function(){
                if(hasImage){//if it exists  create URL images
                    if(isPersol){
                        thumbnail= baseUrlAkamaiIMPO + classicPathAkamaiIMPO + productPartNumber +"__"+ typeImg+'.png' + ymalAkamaiPolicy;
                    }else{
                        thumbnail = baseUrlAkamaiIMOP + classicPathAkamaiIMOP + productPartNumber +"__"+ typeImg+'.png'+ymalAkamaiPolicy;
                    } 
                }else{ //else put 001 image or 002 image
                        if(isPersol && typeImg == 'STD__shad__fr'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isPersol && typeImg == 'STD__shad__qt'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy); 
                        }else if(isOliver && typeImg == 'STD__shad__fr'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isOliver && typeImg == 'STD__shad__qt'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy);
                        }      
                }
                //replace picture srcset
                for(var g = 0; g < picture.length; g++) {
                	if(picture[g].className == 'lazy catalog__image--front'){
                		thumbnail = thumbnail.split('=')[0] + '=HB_parameters_transp&wid=720&cropnorth=-9&cropsouth=-9';
                		picture[g].dataset["srcset"]= thumbnail;
                	}else{
                		for(var j = 0; j < picture[g].childNodes.length; j++){
                            if(picture[g].childNodes[j].nodeName == "SOURCE"){
                               picture[g].childNodes[j].dataset["srcset"]= thumbnail;
                            }
                        }
                	}
                }
            }
        });
}

function replaceTileImgByDevice(url,pattern,tileType) {
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if (typeof url == 'string') {
        var screenWidthPx = Math.round(window.innerWidth*window.devicePixelRatio);
        if (screenWidthPx < 400/* mobile */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=400');
            }
        } else if (400 < screenWidthPx && screenWidthPx <= 750/* tablet */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=500');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=100');
            }
        } else if (750 < screenWidthPx && screenWidthPx <= 1200/* desktop 1x */) {
            if (tileType == 'small') {
                if(isWishlistPage){
                    return url.replace(pattern,'wid=800');
                }else{
                    return url.replace(pattern,'wid=400');
                } 
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=150');
            }
        } else if (1200 < screenWidthPx)/* desktop 2x */ {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=1600');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=300');
            }
        }
    }
    return url;
}

function removeIOSRubberEffect( element ) {
	element.addEventListener( "touchstart", function () {
		var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
		if ( top === 0 ) {
			element.scrollTop = 1;
		} else if ( currentScroll === totalScroll ) {
			element.scrollTop = top - 1;
		}
	} );
}

function handleSwipeBounce(){
    var startX = 0, startY = 0;

    $('.owl-wrapper').on( "touchstart", function(e){
            e=(e.touches)?e.touches[0]:e;//e.touches[0] is for ios
            startX = e.clientX;
            startY = e.clientY; 
    } );

    $('.owl-wrapper').on( "touchmove", function(event){
        var e=(event.touches)?event.touches[0]:event;//e.touches[0] is for ios
        var deltaX = Math.abs(e.clientX - startX);
        var deltaY = Math.abs(e.clientY - startY);

        if(deltaX > deltaY) {
          event.preventDefault();
        }
    });

    $('.owl-item').on( "touchend", function(e){ 
        if (isOliver) {
            $('body').css('overflow', 'auto'); 
        }
    });
}

function disableScrollingByClass() {
    document.ontouchmove = function ( event ) {

        var isTouchMoveAllowed = true, target = event.target;
    
        while ( target !== null ) {
            if ( target.classList && target.classList.contains( 'disable-scrolling' ) ) {
                isTouchMoveAllowed = false;
                break;
            }
            target = target.parentNode;
        }
    
        if ( !isTouchMoveAllowed ) {
            event.preventDefault();
        }
    
    };
}

function manageScrollOverlay(isOpen){
    /*
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if (isOpen) {
            if (myPane !== undefined){
                myPane.disableDrag();
                bodyScrollLock.enableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").hide();
        } else {
            if (myPane !== undefined) {
                myPane.enableDrag();
                bodyScrollLock.disableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").show();
        }
    }
    */
}
/** jQuery Get Browser Plugin
 * @version: 1.01
 * @author: Pablo E. Fernández (islavisual@gmail.com).
 * Copyright 2016-2018 Islavisual. 
 * Licensed under MIT (https://github.com/islavisual/getBrowser/blob/master/LICENSE). 
 * Last update: 07/02/2018
 **/
 !function(e){e.extend({browser:function(){var e,r=navigator.userAgent,t=r.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];/trident/i.test(t[1])&&(e=/\brv[ :]+(\d+)/g.exec(r)||[],t[1]="Internet Explorer",t[2]=e[1]),"Chrome"===t[1]&&(e=r.match(/\b(OPR|Edge)\/(\d+)/),t[1]=null!=e?e.slice(1).join(" ").replace("OPR","Opera"):"Chrome"),t=t[2]?[t[1],t[2]]:[navigator.appName,navigator.appVersion,"-?"],null!=(e=r.match(/version\/(\d+)/i))&&t.splice(1,1,e[1]);var o=/firefox/.test(navigator.userAgent.toLowerCase())&&!/webkit    /.test(navigator.userAgent.toLowerCase()),a=/webkit/.test(navigator.userAgent.toLowerCase()),s=/opera/.test(navigator.userAgent.toLowerCase()),n=/edge/.test(navigator.userAgent.toLowerCase())||/msie/.test(navigator.userAgent.toLowerCase())||/msie (\d+\.\d+);/.test(navigator.userAgent.toLowerCase())||/trident.*rv[ :]*(\d+\.\d+)/.test(navigator.userAgent.toLowerCase()),i=n?"":a?"-webkit-":o?"-moz-":"";return{name:t[0],version:t[1],firefox:o,opera:s,msie:n,chrome:a,prefix:i}}}),jQuery.browser=e.browser()}(jQuery);

 /** Handle multiple promises */
 function all(array,promises) {
     var deferred = $.Deferred();
     var fulfilled = 0, length = array.length;
     var results = [];
     if (length === 0) {
         deferred.resolve(results);
     } else {
             for (var index=0; index<array.length; index++) {
            	 
            	 (function (index) {
            		 var upc = array[index];
                     promises[upc].then(function(response){
                       results[index] = response;
                       fulfilled++;
                       if (fulfilled === length) {
                           deferred.resolve(results);
                       }
                     });
            	 }(index));
                 
           }
     }
     return deferred.promise();
 };
 
 /** getScript with cache */
 jQuery.cachedScript = function(url,options) {
   // Allow user to set any option except for dataType, cache, and url
   options = $.extend(options || {},{
     dataType: "script",
     cache: true,
     url: url
   });
   // Use $.ajax() since it is more flexible than $.getScript
   // Return the jqXHR object so we can chain callbacks
   return jQuery.ajax(options);
 };
 
//left: 37, up: 38, right: 39, down: 40,
//spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
	e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
	  preventDefault(e);
	  return false;
	}
}

//modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
	get: function () { supportsPassive = true; } 
}));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

//call this to Disable
function disableScroll() {
	window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
	window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
	window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
	window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

//call this to Enable
function enableScroll() {
	window.removeEventListener('DOMMouseScroll', preventDefault, false);
	window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
	window.removeEventListener('touchmove', preventDefault, wheelOpt);
	window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

function capitalizeEachWord(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }



function iOSversion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	    return parseInt(v[1], 10);
	}
}
/**
 * Check if we are in Chrome on an iOS device
 * becase function isSafari returns true even when we are in chrome
 * @returns true if is chrome on iOS, false otherwise
 */
function isChromeOnIOS() { 
    return navigator.userAgent.indexOf('CriOS') >= 0;
}

 
/* START Early Access */

function getPriceByCustomerSegment(priceObj) {
    if (isPersol || isVogue){
        //  Check User Customer Segment using cookie
        if (document.cookie.includes("X_WC_PR_SEGMENTS") && window.customerSegment != undefined){
            //  Get price for my customer segment
            if (priceObj["price_"+window.customerSegment] != undefined && priceObj["price_"+window.customerSegment] != ""){
                price = priceObj["price_"+window.customerSegment];
            } else price = priceObj.price;
        } else price = priceObj.price;
    } else if (isOliver){
        price = priceObj.price;
    }
    return price; //  Return price
}

function returnLastOfferPrice() {
    var lastOfferPrice;
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
  
    if (!isWishlistPage) {
      if(productParent[0]){
        if ((window.mobilecheck() || window.tabletPortraitCheck()) && !isPersol){
            lastOfferPrice = document.querySelectorAll('#offerPrice_'+productParent[0])[1].innerText;
        } else if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerHTML;
        }else if(isVogue){
        	lastOfferPrice = document.getElementsByClassName('offerPrice_'+productParent[0]).innerHTML;
        }else{
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerText;
        }
      }
    } else {
      lastOfferPrice = document.getElementById('offerPrice_'+ minicartAddedId).innerText;
    }

    return lastOfferPrice;
}

/* END Early Access */

//checkout 3.0

function goToOrderPaymentViewOnClickHandler(event){
    
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }

    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    	//form2.email1.value=form1.email1.value;
    let isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
            	  var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		          }
                  if(addressValidate){
                	  if (typeof data.contact === 'undefined'){
                          plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                          AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                      } else {
                          for (var i = 0; i<data.contact.length; i++){
                              if (data.contact[i].nickName == 'MyAddress_Shipping'){
                                  plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                                  AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                                  break;
                              }
                          }
                      }
                      /* START - OP BOSS */
                      if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
                    }
                    /* END - OP BOSS */  
                  }else{
                	  restoreAjaxButtons();
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        
        if(AddressHelper.validateAddressForm(form1)) {
            //if(isFormNoError)//isFormNoError check if one of th input field in checkoutform is with error in this case if email is with error with need to send error to analytics 
                isFormNoError = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderPaymentsViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		        	}
		        	
		        	if(addressValidate){
			            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
	
			            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
			            //calling the rest service. If success then address exist else address does not exist.
			            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
			            $.ajax({
			                method: "GET",
			                url: url,
			                headers: {
			                    "Content-Type": "application/json",
			                    "Cache-Control": "no-cache, no-store, must-revalidate"
			                },
			                dataType: "json",
			                success:function(data, textStatus, jqXHR){
			                    if (typeof data.contact === 'undefined'){
			                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
			                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
			                    } else {
			                        for (var i = 0; i<data.contact.length; i++){
			                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
			                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
			                                AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
			                                break;
			                            }
			                        }
			                    }
			                },
			                error:function(jqXHR, exception){
			                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
			                }
			            });
			
			            moveToError();
		        	}else{
		        		restoreAjaxButtons();
		        	}
		        }).then(function(){
                    if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
		            }
		        })
        }else{
            isFormNoError = false;
        }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError)
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc');   
}

function parseStoreHours(storeHours){
	var weekDays = getWeekDays(locale.replace('_','-'));
	var hourString = titleCase(weekDays[0]);
	var existAnotherWithTheSameHours = '';
	//we start from second day
	for(var i = 1; i < storeHours.length; i++){
		if(storeHours[i].opening === storeHours[i-1].opening && storeHours[i].closing === storeHours[i-1].closing){
			if (existAnotherWithTheSameHours == ''){
				existAnotherWithTheSameHours = ' - ';
			}
		}else{
			if(storeHours[i-1].isClosed){
				if(i == 1){
					hourString = hourString + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}
			}else{
				if(i == 1){
					hourString = hourString + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);	
				}
			}
			existAnotherWithTheSameHours =  '';
		}
	}
	
	if( existAnotherWithTheSameHours == '' ){
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}else{
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) +  ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}
	return hourString.replaceAll('"','');
}

function titleCase(string){
	return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function getWeekDays(locale){
    var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
    var weekDays = [];
    for(i = 0; i < 7; i++){       
        weekDays.push(baseDate.toLocaleDateString(locale, { weekday: 'long' }));
        baseDate.setDate(baseDate.getDate() + 1);       
    }

    //HB-9317. This fix is related to common weeksdays order in America. In USA , Sunday is considered the first day of week. This 
    // caused a strange parsing in storeHours. We have aligne the weekdays orders to the classic one.
    if(locale=='en-US' && weekDays[0]=='Sunday'){
        weekDays = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    }
    return weekDays;
}


function iPhoneVersion() {
	  var iHeight = window.screen.height;
	  var iWidth = window.screen.width;

	  
	  if (iWidth === 390 && iHeight === 844) {
		    return "12-13";
	  }
	  
	  if (iWidth === 414 && iHeight === 896) {
		    return "11";
	  }

	  if (iWidth === 414 && iHeight === 896) {
	    return "Xmax-Xr";
	  }
	  else if (iWidth === 375 && iHeight === 812) {
	    return "X-Xs";
	  }
	  else if (iWidth === 320 && iHeight === 480) {
	    return "4";
	  }
	  else if (iWidth === 375 && iHeight === 667) {
	    return "6-7";
	  }
	  else if (iWidth === 414 && iHeight === 736) {
	    return "6+";
	  }
	  else if (iWidth === 320 && iHeight === 568) {
	    return "5";
	  }
	  else if (iHeight <= 480) {
	    return "2-3";
	  }
	  return 'none';
	}



//checkout 3.0

/* START - Online Return Form */

function cleanCartForShipOrder(isReturnForm = false,callback) {
    if(personInfo.userId !== '-1002') {
        
        var url = '/wcs/resources/store/' + WCParamJS.storeId + '/cart/@self';
        function deleteCart(url,callback) {
            $.ajax({
                url: url,
                type: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: "json",
                data: [],
                success: function (response, textStatus, request) {
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                },
                error: function(response){
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                }
            });
        }

        if (isReturnForm) {
            //  When Return Form, simply delete the cart
            deleteCart(url,callback);
        } else {
            //  When in classic cart, delete the cart after checking it is a Ship Order
            getAjaxCallInfo(url, null, function(response) {
                let isShipOrder = false;
                if (response.orderItem !== undefined) {
                    response.orderItem.forEach(function(item) {
                        if (item.partNumber == 'RETURN_SHIPPING_CHARGE_SKU') {
                            isShipOrder = true;
                        }
                    });
                }
                if (isShipOrder) {
                    deleteCart(url,callback);
                }
            });
        }

    }
}

/* END - Online Return Form */

function checkPasswordStrenght(passwordField) {
    var password = passwordField.value;
    const conditionThreshold = 5;
    var sumConditions = 0;
    if(RegExp('(?=.{8,})').test(password)) { //at least 8 characters long
        $('#password_length').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_length').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[A-Z])').test(password)) {//at least one uppercase letter
        $('#password_uppercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_uppercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[a-z])').test(password)) { //at least one lowercase letter
        $('#password_lowercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_lowercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[0-9])').test(password)) { //at least one digit 
        $('#password_number').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_number').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('([^A-Za-z0-9])').test(password)) { //at least one special character
        $('#password_special').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_special').attr("checked",false);
        sumConditions--;
    }
    console.log(sumConditions==conditionThreshold);
    return sumConditions==conditionThreshold;
}

function checkPasswordFieldAndSubmit(form) {
	
	if(form.validationCode.value == ''){
		$('.password-policies-title').addClass('hidden');
		$('#validationCodeError').removeClass('hidden');
	}else{
	 if(checkPasswordStrenght(form.logonPassword)){
	        $('.password-policies-title').removeClass('hidden');
	        $('.password-policies-title-error').addClass('hidden');
	        $('[name="logonPassword"').removeClass('error');
	        submitSpecifiedForm(form);
	    }
		else {
			$('.password-policies-title').addClass('hidden');
	        $('.password-policies-title-error').removeClass('hidden');
	        $('[name="logonPassword"').addClass('error')
		}
	}
   
}

function openPasswordPolicyDiv() {
    $('.password-policies-container').show();
    $('.input-style--password').addClass('passPolicyOpen'); //Persol
}


/*Check specific browser version*/
navigator.sayswho= (function(){
    var N= navigator.appName, ua= navigator.userAgent, tem;
    var M= ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
    if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
    M= M? [M[1], M[2]]: [N, navigator.appVersion,'-?'];
    return M;
})();

function getAttributeValue(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].value : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}

function getAttributeIdentifier(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].identifier : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}
function getConvertedDistance(distance) {
    //var inchMeasure = 25.4;
	var cleanNumber = "";
	
	if(typeof distance != 'undefined'){
		cleanNumber = distance.replace(/\D/g,'');
	}
    return '('+ cleanNumber + ' mm)';
}

function showKlarnaPlacements(){
    $('.pdp .klarna-mess-pdp').show();
    $('.pdp .klarna-minicart, .wishListDisplay .klarna-minicart').show();
    $('.minicart-klarna').show();
    $(".checkout__klarna").show();
    $('#vat_klarna:not(#cartSuggestion .content .espot-complete-order-upsell #vat_klarna)').show();
}

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

//Resolve promise for sha256
function getSha256Promise(message) {
    const result = sha256(message);
    return result instanceof Promise ? result : Promise.resolve(result);
}

//Return FALSE if VARIABLE DOESN'T CONTAINS VALUE; Return TRUE if VARIABLE CONTAINS VALUE;
function checkIsNull(variable){
    if(typeof(variable)!='undefined' &&  variable != '' && variable != null)
        return false;
    else
        return true;
}

window.addEventListener('load', (event) => {
    if (typeof fn_FrameAdvisor === 'function') {
        fn_FrameAdvisor();
    }
});


//CRM Banner - this function opens up promo popups with a promocode in cart on PO and VO
function fn_CartPromoCode(promoCode,copyPromoCode) {
    if (isPersol || isVogue){    
        if (typeof promoCode !== 'undefined' && typeof copyPromoCode !== 'undefined' ||
        promoCode != "" && copyPromoCode != "") {
        	window.isCRMPromo = true;
        	if(isVogue){
        		if($('#promoCodeCRM').length < 1){
        			$('#headerWidget').append('<input type="hidden" id="promoCodeCRM" name="promoCodeCRM" value="' + promoCode +'" autocomplete="off">');
        		}
        		if($('#copyPromoCodeCRM').length < 1){
        			$('#headerWidget').append("<input type='hidden' id='copyPromoCodeCRM' name='copyPromoCodeCRM' value='"+ copyPromoCode.replaceAll("'", '"') +"' autocomplete='off'>");
        		}
        		promoCode = $('#promoCodeCRM').val();
        		copyPromoCode = $('#copyPromoCodeCRM').val();
        	}
            $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
            $(".cart-crm-banner .promo-description").html(copyPromoCode);

            if (isVogue) {
                $("#cart-crm-promocode-box-banner .use-promocode-container").off("click").on("click", function(){
                    if ($("#promo-form-title.dropdown").hasClass("opend")){
                        $("#promo-form-title.dropdown").removeClass("opend");
                    }else{
                        $('#promo-form-title.dropdown').removeClass("opend");
                        $("#promo-form-title.dropdown").addClass("opend");
                    }
                });

                if ((window.mobilecheck() || window.tabletPortraitCheck())) {
                    $("#promo-form-title.dropdown").addClass("available-promocode");
                }

                CRMRemovePromoCode();
            }

            if (isPersol) {
                $("#cart-crm-promo-banner").addClass("showed").removeClass("hidden");
                $("#promotions .wrapperPromotions .promotion-code__label").addClass("available-promocode");

                $(".promotion-code__label.available-promocode, .use-promocode-container").on("click", function(){
                    $(".promocode-box-reminder .apply-promocode-cta").on("click", function(event){
                        event.stopPropagation();
                    });
                    if(isVogue){
                    	if ($("#promotion-code__input").is(":checked")){
                            $(".promotion-code__label.available-promocode").addClass("expanded");
                        } else {
                            $(".promotion-code__label.available-promocode").removeClass("expanded");
                        }
                    }else{
                    	if ($("#promotion-code__input").is(":checked")){
                    		$(".promotion-code__label.available-promocode").removeClass("expanded");
                        } else {
                        	$(".promotion-code__label.available-promocode").addClass("expanded");
                        }
                    }
                    
                });
            }

            $('.cart-crm-banner .apply-promocode-cta').off('click').on('click', function(){
                if (isPersol) {
                    if ($("input#promoCode").val() == "") {
                        $("input#promoCode").val(promoCode.toString());
                        $(".promocode-button-wrapper button").click();
                    }
                } else if (isVogue) {
                    if ($("input#coupon-value").val() == "") {
                        $("input#coupon-value").val(promoCode.toString());
                        $(".promotion_button button").click();
                    }
                }

            });
        } else {
            window.isCRMPromo = false;
        }
    }
}

function CRMRemovePromoCode (){
    if ($("#isPromocodeApplied").val() == 'true') {
        $("#cart-crm-promocode-box-banner").addClass("hidden").removeClass("showed");
        $(".visibleOrderDiscount td").css("color", "#000");
        $("#appliedPromotionCodes").hide();
        $("#CRMappliedPromotionCodes").show();
        $(".removePromotionLink").hide();
        $(".CRMremovePromotionLink").css("display","flex");
        if (!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("#PromotionCodeForm").css("padding-bottom", "16px");
        } else {
            $("#promo-form-title").css("border-bottom", "none");
        }
    } else {
        $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
        $("#CRMappliedPromotionCodes").hide();
    }
}

//retrive all parameters from url
function getAllUrlParams() {
	var queryString = window.location.href.split('?')[1];
	var obj = {};

    if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            var a = arr[i].split('=');

            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            if (paramName.match(/\[(\d+)?\]$/)) {
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}


/*! jQuery UI - v1.12.1 - 2020-07-28
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/draggable.js, widgets/droppable.js, widgets/resizable.js, widgets/selectable.js, widgets/sortable.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/selectmenu.js, widgets/slider.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.ui = $.ui || {};

var version = $.ui.version = "1.12.1";


/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/



var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/


var data = $.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo( function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		} ) :

		// Support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		}
} );

/*!
 * jQuery UI Disable Selection 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: http://api.jqueryui.com/disableSelection/

// This file is deprecated


var disableSelection = $.fn.extend( {
	disableSelection: ( function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.on( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			} );
		};
	} )(),

	enableSelection: function() {
		return this.off( ".ui-disableSelection" );
	}
} );


/*!
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: http://api.jqueryui.com/focusable-selector/



// Selectors
$.ui.focusable = function( element, hasTabindex ) {
	var map, mapName, img, focusableIfVisible, fieldset,
		nodeName = element.nodeName.toLowerCase();

	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" );
		return img.length > 0 && img.is( ":visible" );
	}

	if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
		focusableIfVisible = !element.disabled;

		if ( focusableIfVisible ) {

			// Form controls within a disabled fieldset are disabled.
			// However, controls within the fieldset's legend do not get disabled.
			// Since controls generally aren't placed inside legends, we skip
			// this portion of the check.
			fieldset = $( element ).closest( "fieldset" )[ 0 ];
			if ( fieldset ) {
				focusableIfVisible = !fieldset.disabled;
			}
		}
	} else if ( "a" === nodeName ) {
		focusableIfVisible = element.href || hasTabindex;
	} else {
		focusableIfVisible = hasTabindex;
	}

	return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
};

// Support: IE 8 only
// IE 8 doesn't resolve inherit to visible/hidden for computed values
function visible( element ) {
	var visibility = element.css( "visibility" );
	while ( visibility === "inherit" ) {
		element = element.parent();
		visibility = element.css( "visibility" );
	}
	return visibility !== "hidden";
}

$.extend( $.expr[ ":" ], {
	focusable: function( element ) {
		return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
	}
} );

var focusable = $.ui.focusable;




// Support: IE8 Only
// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
// with a string, so we need to find the proper form.
var form = $.fn.form = function() {
	return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
};


/*!
 * jQuery UI Form Reset Mixin 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: http://api.jqueryui.com/form-reset-mixin/



var formResetMixin = $.ui.formResetMixin = {
	_formResetHandler: function() {
		var form = $( this );

		// Wait for the form reset to actually happen before refreshing
		setTimeout( function() {
			var instances = form.data( "ui-form-reset-instances" );
			$.each( instances, function() {
				this.refresh();
			} );
		} );
	},

	_bindFormResetHandler: function() {
		this.form = this.element.form();
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" ) || [];
		if ( !instances.length ) {

			// We don't use _on() here because we use a single event handler per form
			this.form.on( "reset.ui-form-reset", this._formResetHandler );
		}
		instances.push( this );
		this.form.data( "ui-form-reset-instances", instances );
	},

	_unbindFormResetHandler: function() {
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" );
		instances.splice( $.inArray( this, instances ), 1 );
		if ( instances.length ) {
			this.form.data( "ui-form-reset-instances", instances );
		} else {
			this.form
				.removeData( "ui-form-reset-instances" )
				.off( "reset.ui-form-reset" );
		}
	}
};


/*!
 * jQuery UI Support for jQuery core 1.7.x 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

//>>label: jQuery 1.7 Support
//>>group: Core
//>>description: Support version 1.7.x of jQuery core



// Support: jQuery 1.7 only
// Not a great way to check versions, but since we only support 1.7+ and only
// need to detect <1.8, this is a simple check that should suffice. Checking
// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
// 1.7 anymore). See #11197 for why we're not using feature detection.
if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {

	// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
	// Unlike jQuery Core 1.8+, these only support numeric values to set the
	// dimensions in pixels
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			} );
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			} );
		};

		$.fn[ "outer" + name ] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size, true, margin ) + "px" );
			} );
		};
	} );

	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

;
/*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};




// Internal use only
var escapeSelector = $.ui.escapeSelector = ( function() {
	var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
	return function( selector ) {
		return selector.replace( selectorEscape, "\\$1" );
	};
} )();


/*!
 * jQuery UI Labels 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: http://api.jqueryui.com/labels/



var labels = $.fn.labels = function() {
	var ancestor, selector, id, labels, ancestors;

	// Check control.labels first
	if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
		return this.pushStack( this[ 0 ].labels );
	}

	// Support: IE <= 11, FF <= 37, Android <= 2.3 only
	// Above browsers do not support control.labels. Everything below is to support them
	// as well as document fragments. control.labels does not work on document fragments
	labels = this.eq( 0 ).parents( "label" );

	// Look for the label based on the id
	id = this.attr( "id" );
	if ( id ) {

		// We don't search against the document in case the element
		// is disconnected from the DOM
		ancestor = this.eq( 0 ).parents().last();

		// Get a full set of top level ancestors
		ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

		// Create a selector for the label based on the id
		selector = "label[for='" + $.ui.escapeSelector( id ) + "']";

		labels = labels.add( ancestors.find( selector ).addBack( selector ) );

	}

	// Return whatever we have found for labels
	return this.pushStack( labels );
};


/*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/



var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Tabbable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: http://api.jqueryui.com/tabbable-selector/



var tabbable = $.extend( $.expr[ ":" ], {
	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			hasTabindex = tabIndex != null;
		return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
	}
} );


/*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/



var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );




// This file is deprecated
var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

/*!
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: http://api.jqueryui.com/mouse/



var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.12.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		( this._mouseStarted && this._mouseUp( event ) );

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) { return true; }
} );




// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};



var safeActiveElement = $.ui.safeActiveElement = function( document ) {
	var activeElement;

	// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try {
		activeElement = document.activeElement;
	} catch ( error ) {
		activeElement = document.body;
	}

	// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if ( !activeElement ) {
		activeElement = document.body;
	}

	// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if ( !activeElement.nodeName ) {
		activeElement = document.body;
	}

	return activeElement;
};



var safeBlur = $.ui.safeBlur = function( element ) {

	// Support: IE9 - 10 only
	// If the <body> is blurred, IE will switch windows, see #9420
	if ( element && element.nodeName.toLowerCase() !== "body" ) {
		$( element ).trigger( "blur" );
	}
};


/*!
 * jQuery UI Draggable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: http://api.jqueryui.com/draggable/
//>>demos: http://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css



$.widget( "ui.draggable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// Callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if ( this.options.addClasses ) {
			this._addClass( "ui-draggable" );
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var o = this.options;

		// Among others, prevent a drag on a resizable-handle
		if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle( event );
		if ( !this.handle ) {
			return false;
		}

		this._blurActiveElement( event );

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
			target = $( event.target );

		// Don't blur if the event occurred on an element that is within
		// the currently focused element
		// See #10527, #12472
		if ( target.closest( activeElement ).length ) {
			return;
		}

		// Blur any element that currently has focus, see #4261
		$.ui.safeBlur( activeElement );
	},

	_mouseStart: function( event ) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		this._addClass( this.helper, "ui-draggable-dragging" );

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter( function() {
				return $( this ).css( "position" ) === "fixed";
			} ).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if ( this._trigger( "start", event ) === false ) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		// Execute the drag once - this causes the helper not to be visible before getting its
		// correct position
		this._mouseDrag( event, true );

		// If the ddmanager is used for droppables, inform the manager that dragging has started
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart( this, event );
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function( event, noPropagation ) {

		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Call plugins and callbacks and use the resulting position if something is returned
		if ( !noPropagation ) {
			var ui = this._uiHash();
			if ( this._trigger( "drag", event, ui ) === false ) {
				this._mouseUp( new $.Event( "mouseup", event ) );
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		return false;
	},

	_mouseStop: function( event ) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			dropped = $.ui.ddmanager.drop( this, event );
		}

		//if a drop comes from outside (a sortable)
		if ( this.dropped ) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( $.isFunction( this.options.revert ) &&
				this.options.revert.call( this.element, dropped ) )
		) {
			$( this.helper ).animate(
				this.originalPosition,
				parseInt( this.options.revertDuration, 10 ),
				function() {
					if ( that._trigger( "stop", event ) !== false ) {
						that._clear();
					}
				}
			);
		} else {
			if ( this._trigger( "stop", event ) !== false ) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		// If the ddmanager is used for droppables, inform the manager that dragging has stopped
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop( this, event );
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {

			// The interaction is over; whether or not the click resulted in a drag,
			// focus the element
			this.element.trigger( "focus" );
		}

		return $.ui.mouse.prototype._mouseUp.call( this, event );
	},

	cancel: function() {

		if ( this.helper.is( ".ui-draggable-dragging" ) ) {
			this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function( event ) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this._addClass( this.handleElement, "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this._removeClass( this.handleElement, "ui-draggable-handle" );
	},

	_createHelper: function( event ) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if ( !helper.parents( "body" ).length ) {
			helper.appendTo( ( o.appendTo === "parent" ?
				this.element[ 0 ].parentNode :
				o.appendTo ) );
		}

		// Http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
			helper.css( "position", "absolute" );
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
			right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
			bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document" ) {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ) {
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
					pageX = containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
					pageY = containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
					pageX = containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
					pageY = containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {

				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
				// argument errors in IE (see ticket #6950)
				top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
				pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
						top :
						( ( top - this.offset.click.top >= containment[ 1 ] ) ?
							top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

				left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
					this.originalPageX;
				pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
						left :
						( ( left - this.offset.click.left >= containment[ 0 ] ) ?
							left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this._removeClass( this.helper, "ui-draggable-dragging" );
		if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

} );

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each( function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// RefreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger( "activate", event, uiSortable );
			}
		} );
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop( event );

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {

				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		} );
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {

					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				} );
			}

			if ( innermostIntersecting ) {

				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );

					// Hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );

					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {

				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// Restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );
				}
			}
		} );
	}
} );

$.ui.plugin.add( "draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if ( t.css( "cursor" ) ) {
			o._cursor = t.css( "cursor" );
		}
		t.css( "cursor", o.cursor );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._cursor ) {
			$( "body" ).css( "cursor", o._cursor );
		}
	}
} );

$.ui.plugin.add( "draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if ( t.css( "opacity" ) ) {
			o._opacity = t.css( "opacity" );
		}
		t.css( "opacity", o.opacity );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._opacity ) {
			$( ui.helper ).css( "opacity", o._opacity );
		}
	}
} );

$.ui.plugin.add( "draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if ( !o.axis || o.axis !== "x" ) {
				if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
				} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() - o.scrollSpeed
					);
				} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() + o.scrollSpeed
					);
				}
			}

		}

		if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( i, event );
		}

	}
} );

$.ui.plugin.add( "draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
			.each( function() {
				var $t = $( this ),
					$o = $t.offset();
				if ( this !== i.element[ 0 ] ) {
					i.snapElements.push( {
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					} );
				}
			} );

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

			l = inst.snapElements[ i ].left - inst.margins.left;
			r = l + inst.snapElements[ i ].width;
			t = inst.snapElements[ i ].top - inst.margins.top;
			b = t + inst.snapElements[ i ].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					inst.snapElements[ i ].item ) ) {
				if ( inst.snapElements[ i ].snapping ) {
					( inst.options.snap.release &&
						inst.options.snap.release.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						) );
				}
				inst.snapElements[ i ].snapping = false;
				continue;
			}

			if ( o.snapMode !== "inner" ) {
				ts = Math.abs( t - y2 ) <= d;
				bs = Math.abs( b - y1 ) <= d;
				ls = Math.abs( l - x2 ) <= d;
				rs = Math.abs( r - x1 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l - inst.helperProportions.width
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r
					} ).left;
				}
			}

			first = ( ts || bs || ls || rs );

			if ( o.snapMode !== "outer" ) {
				ts = Math.abs( t - y1 ) <= d;
				bs = Math.abs( b - y2 ) <= d;
				ls = Math.abs( l - x1 ) <= d;
				rs = Math.abs( r - x2 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r - inst.helperProportions.width
					} ).left;
				}
			}

			if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
				( inst.options.snap.snap &&
					inst.options.snap.snap.call(
						inst.element,
						event,
						$.extend( inst._uiHash(), {
							snapItem: inst.snapElements[ i ].item
						} ) ) );
			}
			inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

		}

	}
} );

$.ui.plugin.add( "draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
				return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
			} );

		if ( !group.length ) { return; }

		min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
		$( group ).each( function( i ) {
			$( this ).css( "zIndex", min + i );
		} );
		this.css( "zIndex", ( min + group.length ) );
	}
} );

$.ui.plugin.add( "draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if ( t.css( "zIndex" ) ) {
			o._zIndex = t.css( "zIndex" );
		}
		t.css( "zIndex", o.zIndex );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if ( o._zIndex ) {
			$( ui.helper ).css( "zIndex", o._zIndex );
		}
	}
} );

var widgetsDraggable = $.ui.draggable;


/*!
 * jQuery UI Droppable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: http://api.jqueryui.com/droppable/
//>>demos: http://jqueryui.com/droppable/



$.widget( "ui.droppable", {
	version: "1.12.1",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		addClasses: true,
		greedy: false,
		scope: "default",
		tolerance: "intersect",

		// Callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = $.isFunction( accept ) ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {

				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {

				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		o.addClasses && this._addClass( "ui-droppable" );

	},

	_addToManager: function( scope ) {

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = $.isFunction( value ) ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._addActiveClass();
		if ( draggable ) {
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._removeActiveClass();
		if ( draggable ) {
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._addHoverClass();
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._removeHoverClass();
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element
			.find( ":data(ui-droppable)" )
			.not( ".ui-draggable-dragging" )
			.each( function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
						inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					intersect(
						draggable,
						$.extend( inst, { offset: inst.element.offset() } ),
						inst.options.tolerance, event
					)
				) {
					childrenIntersection = true;
					return false; }
			} );
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ],
				( draggable.currentItem || draggable.element ) ) ) {
			this._removeActiveClass();
			this._removeHoverClass();

			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	},

	// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.13 along with call to it below
	_addHoverClass: function() {
		this._addClass( "ui-droppable-hover" );
	},

	_removeHoverClass: function() {
		this._removeClass( "ui-droppable-hover" );
	},

	_addActiveClass: function() {
		this._addClass( "ui-droppable-active" );
	},

	_removeActiveClass: function() {
		this._removeClass( "ui-droppable-active" );
	}
} );

var intersect = $.ui.intersect = ( function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
} )();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
					( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions( {
				width: m[ i ].element[ 0 ].offsetWidth,
				height: m[ i ].element[ 0 ].offsetHeight
			} );

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;

		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible &&
					intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		} );
		return dropped;

	},
	dragStart: function( draggable, event ) {

		// Listen for scrolling so that if the dragging causes scrolling the position of the
		// droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		} );
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions
		// every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ?
					"isout" :
					( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {

				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				} );

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// We just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[ c === "isout" ? "isover" : "isout" ] = false;
			this[ c === "isover" ? "_over" : "_out" ].call( this, event );

			// We just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		} );

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

		// Call prepareOffsets one final time since IE does not fire return scroll events when
		// overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for activeClass and hoverClass options
	$.widget( "ui.droppable", $.ui.droppable, {
		options: {
			hoverClass: false,
			activeClass: false
		},
		_addActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
		},
		_removeActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
		},
		_addHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
		},
		_removeHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
		}
	} );
}

var widgetsDroppable = $.ui.droppable;


/*!
 * jQuery UI Resizable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Resizable
//>>group: Interactions
//>>description: Enables resize functionality for any element.
//>>docs: http://api.jqueryui.com/resizable/
//>>demos: http://jqueryui.com/resizable/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/resizable.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.resizable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		classes: {
			"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
		},
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,

		// See #7960
		zIndex: 90,

		// Callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseFloat( value ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseFloat( value ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden" ) {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var margins,
			o = this.options,
			that = this;
		this._addClass( "ui-resizable" );

		$.extend( this, {
			_aspectRatio: !!( o.aspectRatio ),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		} );

		// Wrap the element if it cannot hold child nodes
		if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

			this.element.wrap(
				$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
					position: this.element.css( "position" ),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css( "top" ),
					left: this.element.css( "left" )
				} )
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			margins = {
				marginTop: this.originalElement.css( "marginTop" ),
				marginRight: this.originalElement.css( "marginRight" ),
				marginBottom: this.originalElement.css( "marginBottom" ),
				marginLeft: this.originalElement.css( "marginLeft" )
			};

			this.element.css( margins );
			this.originalElement.css( "margin", 0 );

			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css( "resize" );
			this.originalElement.css( "resize", "none" );

			this._proportionallyResizeElements.push( this.originalElement.css( {
				position: "static",
				zoom: 1,
				display: "block"
			} ) );

			// Support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css( margins );

			this._proportionallyResize();
		}

		this._setupHandles();

		if ( o.autoHide ) {
			$( this.element )
				.on( "mouseenter", function() {
					if ( o.disabled ) {
						return;
					}
					that._removeClass( "ui-resizable-autohide" );
					that._handles.show();
				} )
				.on( "mouseleave", function() {
					if ( o.disabled ) {
						return;
					}
					if ( !that.resizing ) {
						that._addClass( "ui-resizable-autohide" );
						that._handles.hide();
					}
				} );
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function( exp ) {
				$( exp )
					.removeData( "resizable" )
					.removeData( "ui-resizable" )
					.off( ".resizable" )
					.find( ".ui-resizable-handle" )
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if ( this.elementIsWrapper ) {
			_destroy( this.element );
			wrapper = this.element;
			this.originalElement.css( {
				position: wrapper.css( "position" ),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css( "top" ),
				left: wrapper.css( "left" )
			} ).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css( "resize", this.originalResizeStyle );
		_destroy( this.originalElement );

		return this;
	},

	_setOption: function( key, value ) {
		this._super( key, value );

		switch ( key ) {
		case "handles":
			this._removeHandles();
			this._setupHandles();
			break;
		default:
			break;
		}
	},

	_setupHandles: function() {
		var o = this.options, handle, i, n, hname, axis, that = this;
		this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all" ) {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split( "," );
			this.handles = {};

			for ( i = 0; i < n.length; i++ ) {

				handle = $.trim( n[ i ] );
				hname = "ui-resizable-" + handle;
				axis = $( "<div>" );
				this._addClass( axis, "ui-resizable-handle " + hname );

				axis.css( { zIndex: o.zIndex } );

				this.handles[ handle ] = ".ui-resizable-" + handle;
				this.element.append( axis );
			}

		}

		this._renderAxis = function( target ) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for ( i in this.handles ) {

				if ( this.handles[ i ].constructor === String ) {
					this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
				}

				if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
							.nodeName
							.match( /^(textarea|input|select|button)$/i ) ) {
					axis = $( this.handles[ i ], this.element );

					padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
						axis.outerHeight() :
						axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test( i ) ? "Top" :
						/se|sw|s/.test( i ) ? "Bottom" :
						/^e$/.test( i ) ? "Right" : "Left" ].join( "" );

					target.css( padPos, padWrapper );

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis( this.element );

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.on( "mouseover", function() {
			if ( !that.resizing ) {
				if ( this.className ) {
					axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
				}
				that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
			}
		} );

		if ( o.autoHide ) {
			this._handles.hide();
			this._addClass( "ui-resizable-autohide" );
		}
	},

	_removeHandles: function() {
		this._handles.remove();
	},

	_mouseCapture: function( event ) {
		var i, handle,
			capture = false;

		for ( i in this.handles ) {
			handle = $( this.handles[ i ] )[ 0 ];
			if ( handle === event.target || $.contains( handle, event.target ) ) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function( event ) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num( this.helper.css( "left" ) );
		curtop = this._num( this.helper.css( "top" ) );

		if ( o.containment ) {
			curleft += $( o.containment ).scrollLeft() || 0;
			curtop += $( o.containment ).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
			o.aspectRatio :
			( ( this.originalSize.width / this.originalSize.height ) || 1 );

		cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
		$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

		this._addClass( "ui-resizable-resizing" );
		this._propagate( "start", event );
		return true;
	},

	_mouseDrag: function( event ) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = ( event.pageX - smp.left ) || 0,
			dy = ( event.pageY - smp.top ) || 0,
			trigger = this._change[ a ];

		this._updatePrevProperties();

		if ( !trigger ) {
			return false;
		}

		data = trigger.apply( this, [ event, dx, dy ] );

		this._updateVirtualBoundaries( event.shiftKey );
		if ( this._aspectRatio || event.shiftKey ) {
			data = this._updateRatio( data, event );
		}

		data = this._respectSize( data, event );

		this._updateCache( data );

		this._propagate( "resize", event );

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function( event ) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if ( this._helper ) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
			soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: ( that.helper.width()  - soffsetw ),
				height: ( that.helper.height() - soffseth )
			};
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

			if ( !o.animate ) {
				this.element.css( $.extend( s, { top: top, left: left } ) );
			}

			that.helper.height( that.size.height );
			that.helper.width( that.size.width );

			if ( this._helper && !o.animate ) {
				this._proportionallyResize();
			}
		}

		$( "body" ).css( "cursor", "auto" );

		this._removeClass( "ui-resizable-resizing" );

		this._propagate( "stop", event );

		if ( this._helper ) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function( forceAspectRatio ) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
			maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
			minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
			maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
		};

		if ( this._aspectRatio || forceAspectRatio ) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if ( pMinWidth > b.minWidth ) {
				b.minWidth = pMinWidth;
			}
			if ( pMinHeight > b.minHeight ) {
				b.minHeight = pMinHeight;
			}
			if ( pMaxWidth < b.maxWidth ) {
				b.maxWidth = pMaxWidth;
			}
			if ( pMaxHeight < b.maxHeight ) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function( data ) {
		this.offset = this.helper.offset();
		if ( this._isNumber( data.left ) ) {
			this.position.left = data.left;
		}
		if ( this._isNumber( data.top ) ) {
			this.position.top = data.top;
		}
		if ( this._isNumber( data.height ) ) {
			this.size.height = data.height;
		}
		if ( this._isNumber( data.width ) ) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if ( this._isNumber( data.height ) ) {
			data.width = ( data.height * this.aspectRatio );
		} else if ( this._isNumber( data.width ) ) {
			data.height = ( data.width / this.aspectRatio );
		}

		if ( a === "sw" ) {
			data.left = cpos.left + ( csize.width - data.width );
			data.top = null;
		}
		if ( a === "nw" ) {
			data.top = cpos.top + ( csize.height - data.height );
			data.left = cpos.left + ( csize.width - data.width );
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
			ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
			isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
			isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.originalPosition.top + this.originalSize.height,
			cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
		if ( isminw ) {
			data.width = o.minWidth;
		}
		if ( isminh ) {
			data.height = o.minHeight;
		}
		if ( ismaxw ) {
			data.width = o.maxWidth;
		}
		if ( ismaxh ) {
			data.height = o.maxHeight;
		}

		if ( isminw && cw ) {
			data.left = dw - o.minWidth;
		}
		if ( ismaxw && cw ) {
			data.left = dw - o.maxWidth;
		}
		if ( isminh && ch ) {
			data.top = dh - o.minHeight;
		}
		if ( ismaxh && ch ) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if ( !data.width && !data.height && !data.left && data.top ) {
			data.top = null;
		} else if ( !data.width && !data.height && !data.top && data.left ) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
			widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if ( !this._proportionallyResizeElements.length ) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++ ) {

			prel = this._proportionallyResizeElements[ i ];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if ( !this.outerDimensions ) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css( {
				height: ( element.height() - this.outerDimensions.height ) || 0,
				width: ( element.width() - this.outerDimensions.width ) || 0
			} );

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if ( this._helper ) {

			this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );

			this._addClass( this.helper, this._helper );
			this.helper.css( {
				width: this.element.outerWidth(),
				height: this.element.outerHeight(),
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			} );

			this.helper
				.appendTo( "body" )
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function( event, dx ) {
			return { width: this.originalSize.width + dx };
		},
		w: function( event, dx ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function( event, dx, dy ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function( event, dx, dy ) {
			return { height: this.originalSize.height + dy };
		},
		se: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		sw: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		},
		ne: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		nw: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		}
	},

	_propagate: function( n, event ) {
		$.ui.plugin.call( this, n, [ event, this.ui() ] );
		( n !== "resize" && this._trigger( n, event, this.ui() ) );
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

} );

/*
 * Resizable Extensions
 */

$.ui.plugin.add( "resizable", "animate", {

	stop: function( event ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
			soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = {
				width: ( that.size.width - soffsetw ),
				height: ( that.size.height - soffseth )
			},
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

		that.element.animate(
			$.extend( style, top && left ? { top: top, left: left } : {} ), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseFloat( that.element.css( "width" ) ),
						height: parseFloat( that.element.css( "height" ) ),
						top: parseFloat( that.element.css( "top" ) ),
						left: parseFloat( that.element.css( "left" ) )
					};

					if ( pr && pr.length ) {
						$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
					}

					// Propagating resize, and updating values for each animation step
					that._updateCache( data );
					that._propagate( "resize", event );

				}
			}
		);
	}

} );

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ?
				oc.get( 0 ) :
				( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			} );

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
				that.offset.left - cop.left :
				( that.offset.left - co.left ) ) );

		hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
				that.offset.top - cop.top :
				( that.offset.top - co.top ) ) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}
	}
} );

$.ui.plugin.add( "resizable", "alsoResize", {

	start: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options;

		$( o.alsoResize ).each( function() {
			var el = $( this );
			el.data( "ui-resizable-alsoresize", {
				width: parseFloat( el.width() ), height: parseFloat( el.height() ),
				left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
			} );
		} );
	},

	resize: function( event, ui ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: ( that.size.height - os.height ) || 0,
				width: ( that.size.width - os.width ) || 0,
				top: ( that.position.top - op.top ) || 0,
				left: ( that.position.left - op.left ) || 0
			};

			$( o.alsoResize ).each( function() {
				var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
					css = el.parents( ui.originalElement[ 0 ] ).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each( css, function( i, prop ) {
					var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
					if ( sum && sum >= 0 ) {
						style[ prop ] = sum || null;
					}
				} );

				el.css( style );
			} );
	},

	stop: function() {
		$( this ).removeData( "ui-resizable-alsoresize" );
	}
} );

$.ui.plugin.add( "resizable", "ghost", {

	start: function() {

		var that = $( this ).resizable( "instance" ), cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost.css( {
			opacity: 0.25,
			display: "block",
			position: "relative",
			height: cs.height,
			width: cs.width,
			margin: 0,
			left: 0,
			top: 0
		} );

		that._addClass( that.ghost, "ui-resizable-ghost" );

		// DEPRECATED
		// TODO: remove after 1.12
		if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {

			// Ghost option
			that.ghost.addClass( this.options.ghost );
		}

		that.ghost.appendTo( that.helper );

	},

	resize: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost ) {
			that.ghost.css( {
				position: "relative",
				height: that.size.height,
				width: that.size.width
			} );
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost && that.helper ) {
			that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
		}
	}

} );

$.ui.plugin.add( "resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = ( grid[ 0 ] || 1 ),
			gridY = ( grid[ 1 ] || 1 ),
			ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
			oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
			isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
			isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
			isMinHeight = o.minHeight && ( o.minHeight > newHeight );

		o.grid = grid;

		if ( isMinWidth ) {
			newWidth += gridX;
		}
		if ( isMinHeight ) {
			newHeight += gridY;
		}
		if ( isMaxWidth ) {
			newWidth -= gridX;
		}
		if ( isMaxHeight ) {
			newHeight -= gridY;
		}

		if ( /^(se|s|e)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if ( /^(ne)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if ( /^(sw)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

} );

var widgetsResizable = $.ui.resizable;


/*!
 * jQuery UI Selectable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: http://api.jqueryui.com/selectable/
//>>demos: http://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css



var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// Callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var that = this;

		this._addClass( "ui-selectable" );

		this.dragged = false;

		// Cache selectee children based on filter
		this.refresh = function() {
			that.elementPos = $( that.element[ 0 ] ).offset();
			that.selectees = $( that.options.filter, that.element[ 0 ] );
			that._addClass( that.selectees, "ui-selectee" );
			that.selectees.each( function() {
				var $this = $( this ),
					selecteeOffset = $this.offset(),
					pos = {
						left: selecteeOffset.left - that.elementPos.left,
						top: selecteeOffset.top - that.elementPos.top
					};
				$.data( this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass( "ui-selected" ),
					selecting: $this.hasClass( "ui-selecting" ),
					unselecting: $this.hasClass( "ui-unselecting" )
				} );
			} );
		};
		this.refresh();

		this._mouseInit();

		this.helper = $( "<div>" );
		this._addClass( this.helper, "ui-selectable-helper" );
	},

	_destroy: function() {
		this.selectees.removeData( "selectable-item" );
		this._mouseDestroy();
	},

	_mouseStart: function( event ) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];
		this.elementPos = $( this.element[ 0 ] ).offset();

		if ( this.options.disabled ) {
			return;
		}

		this.selectees = $( options.filter, this.element[ 0 ] );

		this._trigger( "start", event );

		$( options.appendTo ).append( this.helper );

		// position helper (lasso)
		this.helper.css( {
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		} );

		if ( options.autoRefresh ) {
			this.refresh();
		}

		this.selectees.filter( ".ui-selected" ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			selectee.startselected = true;
			if ( !event.metaKey && !event.ctrlKey ) {
				that._removeClass( selectee.$element, "ui-selected" );
				selectee.selected = false;
				that._addClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = true;

				// selectable UNSELECTING callback
				that._trigger( "unselecting", event, {
					unselecting: selectee.element
				} );
			}
		} );

		$( event.target ).parents().addBack().each( function() {
			var doSelect,
				selectee = $.data( this, "selectable-item" );
			if ( selectee ) {
				doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
				that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
					._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;

				// selectable (UN)SELECTING callback
				if ( doSelect ) {
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				} else {
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
				return false;
			}
		} );

	},

	_mouseDrag: function( event ) {

		this.dragged = true;

		if ( this.options.disabled ) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[ 0 ],
			y1 = this.opos[ 1 ],
			x2 = event.pageX,
			y2 = event.pageY;

		if ( x1 > x2 ) { tmp = x2; x2 = x1; x1 = tmp; }
		if ( y1 > y2 ) { tmp = y2; y2 = y1; y1 = tmp; }
		this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

		this.selectees.each( function() {
			var selectee = $.data( this, "selectable-item" ),
				hit = false,
				offset = {};

			//prevent helper from being selected if appendTo: selectable
			if ( !selectee || selectee.element === that.element[ 0 ] ) {
				return;
			}

			offset.left   = selectee.left   + that.elementPos.left;
			offset.right  = selectee.right  + that.elementPos.left;
			offset.top    = selectee.top    + that.elementPos.top;
			offset.bottom = selectee.bottom + that.elementPos.top;

			if ( options.tolerance === "touch" ) {
				hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
			} else if ( options.tolerance === "fit" ) {
				hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
			}

			if ( hit ) {

				// SELECT
				if ( selectee.selected ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
				}
				if ( selectee.unselecting ) {
					that._removeClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = false;
				}
				if ( !selectee.selecting ) {
					that._addClass( selectee.$element, "ui-selecting" );
					selectee.selecting = true;

					// selectable SELECTING callback
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				}
			} else {

				// UNSELECT
				if ( selectee.selecting ) {
					if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						that._addClass( selectee.$element, "ui-selected" );
						selectee.selected = true;
					} else {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						if ( selectee.startselected ) {
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
						}

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
				if ( selectee.selected ) {
					if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;

						that._addClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = true;

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
			}
		} );

		return false;
	},

	_mouseStop: function( event ) {
		var that = this;

		this.dragged = false;

		$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-unselecting" );
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger( "unselected", event, {
				unselected: selectee.element
			} );
		} );
		$( ".ui-selecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-selecting" )
				._addClass( selectee.$element, "ui-selected" );
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger( "selected", event, {
				selected: selectee.element
			} );
		} );
		this._trigger( "stop", event );

		this.helper.remove();

		return false;
	}

} );


/*!
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: http://api.jqueryui.com/sortable/
//>>demos: http://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css



var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Generate the original position
		this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// Support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		// Execute the drag once - this causes the helper not to be visiblebefore getting its
		// correct position
		this._mouseDrag( event );
		return true;

	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		if ( !this.lastPositionAbs ) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if ( this.options.scroll ) {
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

				if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
				} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
				}

				if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
				}

			} else {

				if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
				} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
				}

				if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() - o.scrollSpeed
					);
				} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() + o.scrollSpeed
					);
				}

			}

			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this._getDragVerticalDirection();
		horizontalDirection = this._getDragHorizontalDirection();

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
			: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ $.isFunction( this.options.items ) ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ $.isFunction( this.options.items ) ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[ 0 ] );

						that._addClass( element, "ui-sortable-placeholder",
								className || that.currentItem[ 0 ].className )
							._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming
					// from a stylesheet), it receives the inline height from the dragged item
					if ( !p.height() ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ?
				this._rearrange( event, itemWithLeastDistance, null, true ) :
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = $.isFunction( o.helper ) ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			$( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this
		// information with an ugly IE fix
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );


/*!
 * jQuery UI Accordion 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/accordion/
//>>demos: http://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css



var widgetsAccordion = $.widget( "ui.accordion", {
	version: "1.12.1",
	options: {
		active: 1,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: true,
		event: "click",
		header: "> li > :first-child, > :not(li):even",
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-accordion-n",
			header: "ui-accordion-s"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );

		// Support: IE8 Only
		// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		this._toggleClass( null, "ui-state-disabled", !!value );
		this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
			!!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		this.headers = this.element.find( this.options.header );
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
//				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
} );


/*!
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: http://api.jqueryui.com/menu/
//>>demos: http://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css



var widgetsMenu = $.widget( "ui.menu", {
	version: "1.12.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {

				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}

				var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
					target = $( event.currentTarget );

				// Ignore bubbled events on parent items, see #11641
				if ( actualTarget[ 0 ] !== target[ 0 ] ) {
					return;
				}

				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				this._removeClass( target.siblings().children( ".ui-state-active" ),
					null, "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						$.ui.safeActiveElement( this.document[ 0 ] )
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
					.find( this.options.items )
						.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: http://api.jqueryui.com/autocomplete/
//>>demos: http://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.autocomplete", {
	version: "1.12.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		// All other element types are determined by whether or not they're contentEditable
		this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;

					// Support: IE 8 only
					// Right clicking a menu item or selecting text from the menu items will
					// result in focus moving out of the input. However, we've already received
					// and ignored the blur event because of the cancelBlur flag set above. So
					// we restore focus to ensure that the menu closes properly based on the user's
					// next actions.
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
					}
				} );
			},
			menufocus: function( event, ui ) {
				var label, item;

				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay( function() {
						this.previous = previous;
						this.selectedItem = item;
					} );
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy( function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	},

	// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable: function( element ) {
		if ( !element.length ) {
			return false;
		}

		var editable = element.prop( "contentEditable" );

		if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
		}

		return editable === "true";
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Controlgroup 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Controlgroup
//>>group: Widgets
//>>description: Visually groups form control widgets
//>>docs: http://api.jqueryui.com/controlgroup/
//>>demos: http://jqueryui.com/controlgroup/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/controlgroup.css
//>>css.theme: ../../themes/base/theme.css


var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

var widgetsControlgroup = $.widget( "ui.controlgroup", {
	version: "1.12.1",
	defaultElement: "<div>",
	options: {
		direction: "horizontal",
		disabled: null,
		onlyVisible: true,
		items: {
			"button": "input[type=button], input[type=submit], input[type=reset], button, a",
			"controlgroupLabel": ".ui-controlgroup-label",
			"checkboxradio": "input[type='checkbox'], input[type='radio']",
			"selectmenu": "select",
			"spinner": ".ui-spinner-input"
		}
	},

	_create: function() {
		this._enhance();
	},

	// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance: function() {
		this.element.attr( "role", "toolbar" );
		this.refresh();
	},

	_destroy: function() {
		this._callChildMethod( "destroy" );
		this.childWidgets.removeData( "ui-controlgroup-data" );
		this.element.removeAttr( "role" );
		if ( this.options.items.controlgroupLabel ) {
			this.element
				.find( this.options.items.controlgroupLabel )
				.find( ".ui-controlgroup-label-contents" )
				.contents().unwrap();
		}
	},

	_initWidgets: function() {
		var that = this,
			childWidgets = [];

		// First we iterate over each of the items options
		$.each( this.options.items, function( widget, selector ) {
			var labels;
			var options = {};

			// Make sure the widget has a selector set
			if ( !selector ) {
				return;
			}

			if ( widget === "controlgroupLabel" ) {
				labels = that.element.find( selector );
				labels.each( function() {
					var element = $( this );

					if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
						return;
					}
					element.contents()
						.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
				} );
				that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
				childWidgets = childWidgets.concat( labels.get() );
				return;
			}

			// Make sure the widget actually exists
			if ( !$.fn[ widget ] ) {
				return;
			}

			// We assume everything is in the middle to start because we can't determine
			// first / last elements until all enhancments are done.
			if ( that[ "_" + widget + "Options" ] ) {
				options = that[ "_" + widget + "Options" ]( "middle" );
			} else {
				options = { classes: {} };
			}

			// Find instances of this widget inside controlgroup and init them
			that.element
				.find( selector )
				.each( function() {
					var element = $( this );
					var instance = element[ widget ]( "instance" );

					// We need to clone the default options for this type of widget to avoid
					// polluting the variable options which has a wider scope than a single widget.
					var instanceOptions = $.widget.extend( {}, options );

					// If the button is the child of a spinner ignore it
					// TODO: Find a more generic solution
					if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
						return;
					}

					// Create the widget if it doesn't exist
					if ( !instance ) {
						instance = element[ widget ]()[ widget ]( "instance" );
					}
					if ( instance ) {
						instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
					}
					element[ widget ]( instanceOptions );

					// Store an instance of the controlgroup to be able to reference
					// from the outermost element for changing options and refresh
					var widgetElement = element[ widget ]( "widget" );
					$.data( widgetElement[ 0 ], "ui-controlgroup-data",
						instance ? instance : element[ widget ]( "instance" ) );

					childWidgets.push( widgetElement[ 0 ] );
				} );
		} );

		this.childWidgets = $( $.unique( childWidgets ) );
		this._addClass( this.childWidgets, "ui-controlgroup-item" );
	},

	_callChildMethod: function( method ) {
		this.childWidgets.each( function() {
			var element = $( this ),
				data = element.data( "ui-controlgroup-data" );
			if ( data && data[ method ] ) {
				data[ method ]();
			}
		} );
	},

	_updateCornerClass: function( element, position ) {
		var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
		var add = this._buildSimpleOptions( position, "label" ).classes.label;

		this._removeClass( element, null, remove );
		this._addClass( element, null, add );
	},

	_buildSimpleOptions: function( position, key ) {
		var direction = this.options.direction === "vertical";
		var result = {
			classes: {}
		};
		result.classes[ key ] = {
			"middle": "",
			"first": "ui-corner-" + ( direction ? "top" : "left" ),
			"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
			"only": "ui-corner-all"
		}[ position ];

		return result;
	},

	_spinnerOptions: function( position ) {
		var options = this._buildSimpleOptions( position, "ui-spinner" );

		options.classes[ "ui-spinner-up" ] = "";
		options.classes[ "ui-spinner-down" ] = "";

		return options;
	},

	_buttonOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-button" );
	},

	_checkboxradioOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
	},

	_selectmenuOptions: function( position ) {
		var direction = this.options.direction === "vertical";
		return {
			width: direction ? "auto" : false,
			classes: {
				middle: {
					"ui-selectmenu-button-open": "",
					"ui-selectmenu-button-closed": ""
				},
				first: {
					"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
				},
				last: {
					"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
				},
				only: {
					"ui-selectmenu-button-open": "ui-corner-top",
					"ui-selectmenu-button-closed": "ui-corner-all"
				}

			}[ position ]
		};
	},

	_resolveClassesValues: function( classes, instance ) {
		var result = {};
		$.each( classes, function( key ) {
			var current = instance.options.classes[ key ] || "";
			current = $.trim( current.replace( controlgroupCornerRegex, "" ) );
			result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
		} );
		return result;
	},

	_setOption: function( key, value ) {
		if ( key === "direction" ) {
			this._removeClass( "ui-controlgroup-" + this.options.direction );
		}

		this._super( key, value );
		if ( key === "disabled" ) {
			this._callChildMethod( value ? "disable" : "enable" );
			return;
		}

		this.refresh();
	},

	refresh: function() {
		var children,
			that = this;

		this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

		if ( this.options.direction === "horizontal" ) {
			this._addClass( null, "ui-helper-clearfix" );
		}
		this._initWidgets();

		children = this.childWidgets;

		// We filter here because we need to track all childWidgets not just the visible ones
		if ( this.options.onlyVisible ) {
			children = children.filter( ":visible" );
		}

		if ( children.length ) {

			// We do this last because we need to make sure all enhancment is done
			// before determining first and last
			$.each( [ "first", "last" ], function( index, value ) {
				var instance = children[ value ]().data( "ui-controlgroup-data" );

				if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
					var options = that[ "_" + instance.widgetName + "Options" ](
						children.length === 1 ? "only" : value
					);
					options.classes = that._resolveClassesValues( options.classes, instance );
					instance.element[ instance.widgetName ]( options );
				} else {
					that._updateCornerClass( children[ value ](), value );
				}
			} );

			// Finally call the refresh method on each of the child widgets.
			this._callChildMethod( "refresh" );
		}
	}
} );

/*!
 * jQuery UI Checkboxradio 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Checkboxradio
//>>group: Widgets
//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
//>>docs: http://api.jqueryui.com/checkboxradio/
//>>demos: http://jqueryui.com/checkboxradio/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.structure: ../../themes/base/checkboxradio.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
	version: "1.12.1",
	options: {
		disabled: null,
		label: null,
		icon: true,
		classes: {
			"ui-checkboxradio-label": "ui-corner-all",
			"ui-checkboxradio-icon": "ui-corner-all"
		}
	},

	_getCreateOptions: function() {
		var disabled, labels;
		var that = this;
		var options = this._super() || {};

		// We read the type here, because it makes more sense to throw a element type error first,
		// rather then the error for lack of a label. Often if its the wrong type, it
		// won't have a label (e.g. calling on a div, btn, etc)
		this._readType();

		labels = this.element.labels();

		// If there are multiple labels, use the last one
		this.label = $( labels[ labels.length - 1 ] );
		if ( !this.label.length ) {
			$.error( "No label found for checkboxradio widget" );
		}

		this.originalLabel = "";

		// We need to get the label text but this may also need to make sure it does not contain the
		// input itself.
		this.label.contents().not( this.element[ 0 ] ).each( function() {

			// The label contents could be text, html, or a mix. We concat each element to get a
			// string representation of the label, without the input as part of it.
			that.originalLabel += this.nodeType === 3 ? $( this ).text() : this.outerHTML;
		} );

		// Set the label option if we found label text
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}
		return options;
	},

	_create: function() {
		var checked = this.element[ 0 ].checked;

		this._bindFormResetHandler();

		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled;
		}

		this._setOption( "disabled", this.options.disabled );
		this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
		this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

		if ( this.type === "radio" ) {
			this._addClass( this.label, "ui-checkboxradio-radio-label" );
		}

		if ( this.options.label && this.options.label !== this.originalLabel ) {
			this._updateLabel();
		} else if ( this.originalLabel ) {
			this.options.label = this.originalLabel;
		}

		this._enhance();

		if ( checked ) {
			this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
			if ( this.icon ) {
				this._addClass( this.icon, null, "ui-state-hover" );
			}
		}

		this._on( {
			change: "_toggleClasses",
			focus: function() {
				this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
			},
			blur: function() {
				this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
			}
		} );
	},

	_readType: function() {
		var nodeName = this.element[ 0 ].nodeName.toLowerCase();
		this.type = this.element[ 0 ].type;
		if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
			$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
		}
	},

	// Support jQuery Mobile enhanced option
	_enhance: function() {
		this._updateIcon( this.element[ 0 ].checked );
	},

	widget: function() {
		return this.label;
	},

	_getRadioGroup: function() {
		var group;
		var name = this.element[ 0 ].name;
		var nameSelector = "input[name='" + $.ui.escapeSelector( name ) + "']";

		if ( !name ) {
			return $( [] );
		}

		if ( this.form.length ) {
			group = $( this.form[ 0 ].elements ).filter( nameSelector );
		} else {

			// Not inside a form, check all inputs that also are not inside a form
			group = $( nameSelector ).filter( function() {
				return $( this ).form().length === 0;
			} );
		}

		return group.not( this.element );
	},

	_toggleClasses: function() {
		var checked = this.element[ 0 ].checked;
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

		if ( this.options.icon && this.type === "checkbox" ) {
			this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
				._toggleClass( this.icon, null, "ui-icon-blank", !checked );
		}

		if ( this.type === "radio" ) {
			this._getRadioGroup()
				.each( function() {
					var instance = $( this ).checkboxradio( "instance" );

					if ( instance ) {
						instance._removeClass( instance.label,
							"ui-checkboxradio-checked", "ui-state-active" );
					}
				} );
		}
	},

	_destroy: function() {
		this._unbindFormResetHandler();

		if ( this.icon ) {
			this.icon.remove();
			this.iconSpace.remove();
		}
	},

	_setOption: function( key, value ) {

		// We don't allow the value to be set to nothing
		if ( key === "label" && !value ) {
			return;
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( this.label, null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;

			// Don't refresh when setting disabled
			return;
		}
		this.refresh();
	},

	_updateIcon: function( checked ) {
		var toAdd = "ui-icon ui-icon-background ";

		if ( this.options.icon ) {
			if ( !this.icon ) {
				this.icon = $( "<span>" );
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
			}

			if ( this.type === "checkbox" ) {
				toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
				this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
			} else {
				toAdd += "ui-icon-blank";
			}
			this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
			if ( !checked ) {
				this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
			}
			this.icon.prependTo( this.label ).after( this.iconSpace );
		} else if ( this.icon !== undefined ) {
			this.icon.remove();
			this.iconSpace.remove();
			delete this.icon;
		}
	},

	_updateLabel: function() {

		// Remove the contents of the label ( minus the icon, icon space, and input )
		var contents = this.label.contents().not( this.element[ 0 ] );
		if ( this.icon ) {
			contents = contents.not( this.icon[ 0 ] );
		}
		if ( this.iconSpace ) {
			contents = contents.not( this.iconSpace[ 0 ] );
		}
		contents.remove();

		this.label.append( this.options.label );
	},

	refresh: function() {
		var checked = this.element[ 0 ].checked,
			isDisabled = this.element[ 0 ].disabled;

		this._updateIcon( checked );
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
		if ( this.options.label !== null ) {
			this._updateLabel();
		}

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { "disabled": isDisabled } );
		}
	}

} ] );

var widgetsCheckboxradio = $.ui.checkboxradio;


/*!
 * jQuery UI Button 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Button
//>>group: Widgets
//>>description: Enhances a form with themeable buttons.
//>>docs: http://api.jqueryui.com/button/
//>>demos: http://jqueryui.com/button/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.button", {
	version: "1.12.1",
	defaultElement: "<button>",
	options: {
		classes: {
			"ui-button": "ui-corner-all"
		},
		disabled: null,
		icon: null,
		iconPosition: "beginning",
		label: null,
		showLabel: true
	},

	_getCreateOptions: function() {
		var disabled,

			// This is to support cases like in jQuery Mobile where the base widget does have
			// an implementation of _getCreateOptions
			options = this._super() || {};

		this.isInput = this.element.is( "input" );

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}

		this.originalLabel = this.isInput ? this.element.val() : this.element.html();
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		return options;
	},

	_create: function() {
		if ( !this.option.showLabel & !this.options.icon ) {
			this.options.showLabel = true;
		}

		// We have to check the option again here even though we did in _getCreateOptions,
		// because null may have been passed on init which would override what was set in
		// _getCreateOptions
		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled || false;
		}

		this.hasTitle = !!this.element.attr( "title" );

		// Check to see if the label needs to be set or if its already correct
		if ( this.options.label && this.options.label !== this.originalLabel ) {
			if ( this.isInput ) {
				this.element.val( this.options.label );
			} else {
				this.element.html( this.options.label );
			}
		}
		this._addClass( "ui-button", "ui-widget" );
		this._setOption( "disabled", this.options.disabled );
		this._enhance();

		if ( this.element.is( "a" ) ) {
			this._on( {
				"keyup": function( event ) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						event.preventDefault();

						// Support: PhantomJS <= 1.9, IE 8 Only
						// If a native click is available use it so we actually cause navigation
						// otherwise just trigger a click event
						if ( this.element[ 0 ].click ) {
							this.element[ 0 ].click();
						} else {
							this.element.trigger( "click" );
						}
					}
				}
			} );
		}
	},

	_enhance: function() {
		if ( !this.element.is( "button" ) ) {
			this.element.attr( "role", "button" );
		}

		if ( this.options.icon ) {
			this._updateIcon( "icon", this.options.icon );
			this._updateTooltip();
		}
	},

	_updateTooltip: function() {
		this.title = this.element.attr( "title" );

		if ( !this.options.showLabel && !this.title ) {
			this.element.attr( "title", this.options.label );
		}
	},

	_updateIcon: function( option, value ) {
		var icon = option !== "iconPosition",
			position = icon ? this.options.iconPosition : value,
			displayBlock = position === "top" || position === "bottom";

		// Create icon
		if ( !this.icon ) {
			this.icon = $( "<span>" );

			this._addClass( this.icon, "ui-button-icon", "ui-icon" );

			if ( !this.options.showLabel ) {
				this._addClass( "ui-button-icon-only" );
			}
		} else if ( icon ) {

			// If we are updating the icon remove the old icon class
			this._removeClass( this.icon, null, this.options.icon );
		}

		// If we are updating the icon add the new icon class
		if ( icon ) {
			this._addClass( this.icon, null, value );
		}

		this._attachIcon( position );

		// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
		// the iconSpace if there is one.
		if ( displayBlock ) {
			this._addClass( this.icon, null, "ui-widget-icon-block" );
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
		} else {

			// Position is beginning or end so remove the ui-widget-icon-block class and add the
			// space if it does not exist
			if ( !this.iconSpace ) {
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-button-icon-space" );
			}
			this._removeClass( this.icon, null, "ui-wiget-icon-block" );
			this._attachIconSpace( position );
		}
	},

	_destroy: function() {
		this.element.removeAttr( "role" );

		if ( this.icon ) {
			this.icon.remove();
		}
		if ( this.iconSpace ) {
			this.iconSpace.remove();
		}
		if ( !this.hasTitle ) {
			this.element.removeAttr( "title" );
		}
	},

	_attachIconSpace: function( iconPosition ) {
		this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
	},

	_attachIcon: function( iconPosition ) {
		this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
	},

	_setOptions: function( options ) {
		var newShowLabel = options.showLabel === undefined ?
				this.options.showLabel :
				options.showLabel,
			newIcon = options.icon === undefined ? this.options.icon : options.icon;

		if ( !newShowLabel && !newIcon ) {
			options.showLabel = true;
		}
		this._super( options );
	},

	_setOption: function( key, value ) {
		if ( key === "icon" ) {
			if ( value ) {
				this._updateIcon( key, value );
			} else if ( this.icon ) {
				this.icon.remove();
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			}
		}

		if ( key === "iconPosition" ) {
			this._updateIcon( key, value );
		}

		// Make sure we can't end up with a button that has neither text nor icon
		if ( key === "showLabel" ) {
				this._toggleClass( "ui-button-icon-only", null, !value );
				this._updateTooltip();
		}

		if ( key === "label" ) {
			if ( this.isInput ) {
				this.element.val( value );
			} else {

				// If there is an icon, append it, else nothing then append the value
				// this avoids removal of the icon when setting label text
				this.element.html( value );
				if ( this.icon ) {
					this._attachIcon( this.options.iconPosition );
					this._attachIconSpace( this.options.iconPosition );
				}
			}
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;
			if ( value ) {
				this.element.blur();
			}
		}
	},

	refresh: function() {

		// Make sure to only check disabled if its an element that supports this otherwise
		// check for the disabled class to determine state
		var isDisabled = this.element.is( "input, button" ) ?
			this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { disabled: isDisabled } );
		}

		this._updateTooltip();
	}
} );

// DEPRECATED
if ( $.uiBackCompat !== false ) {

	// Text and Icons options
	$.widget( "ui.button", $.ui.button, {
		options: {
			text: true,
			icons: {
				primary: null,
				secondary: null
			}
		},

		_create: function() {
			if ( this.options.showLabel && !this.options.text ) {
				this.options.showLabel = this.options.text;
			}
			if ( !this.options.showLabel && this.options.text ) {
				this.options.text = this.options.showLabel;
			}
			if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
				if ( this.options.icons.primary ) {
					this.options.icon = this.options.icons.primary;
				} else {
					this.options.icon = this.options.icons.secondary;
					this.options.iconPosition = "end";
				}
			} else if ( this.options.icon ) {
				this.options.icons.primary = this.options.icon;
			}
			this._super();
		},

		_setOption: function( key, value ) {
			if ( key === "text" ) {
				this._super( "showLabel", value );
				return;
			}
			if ( key === "showLabel" ) {
				this.options.text = value;
			}
			if ( key === "icon" ) {
				this.options.icons.primary = value;
			}
			if ( key === "icons" ) {
				if ( value.primary ) {
					this._super( "icon", value.primary );
					this._super( "iconPosition", "beginning" );
				} else if ( value.secondary ) {
					this._super( "icon", value.secondary );
					this._super( "iconPosition", "end" );
				}
			}
			this._superApply( arguments );
		}
	} );

	$.fn.button = ( function( orig ) {
		return function() {
			if ( !this.length || ( this.length && this[ 0 ].tagName !== "INPUT" ) ||
					( this.length && this[ 0 ].tagName === "INPUT" && (
						this.attr( "type" ) !== "checkbox" && this.attr( "type" ) !== "radio"
					) ) ) {
				return orig.apply( this, arguments );
			}
			if ( !$.ui.checkboxradio ) {
				$.error( "Checkboxradio widget missing" );
			}
			if ( arguments.length === 0 ) {
				return this.checkboxradio( {
					"icon": false
				} );
			}
			return this.checkboxradio.apply( this, arguments );
		};
	} )( $.fn.button );

	$.fn.buttonset = function() {
		if ( !$.ui.controlgroup ) {
			$.error( "Controlgroup widget missing" );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
			return this.controlgroup.apply( this,
				[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
			return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
		}
		if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
			arguments[ 0 ].items = {
				button: arguments[ 0 ].items
			};
		}
		return this.controlgroup.apply( this, arguments );
	};
}

var widgetsButton = $.ui.button;


// jscs:disable maximumLineLength
/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
/*!
 * jQuery UI Datepicker 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: http://api.jqueryui.com/datepicker/
//>>demos: http://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css



$.extend( $.ui, { datepicker: { version: "1.12.1" } } );

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {

		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {

			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[ "" ] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: [ "January","February","March","April","May","June",
			"July","August","September","October","November","December" ], // Names of months for drop-down and formatting
		monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
		dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
		dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
		dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend( this._defaults, this.regional[ "" ] );
	this.regional.en = $.extend( true, {}, this.regional[ "" ] );
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
}

$.extend( Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function( settings ) {
		datepicker_extendRemove( this._defaults, settings || {} );
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function( target, settings ) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = ( nodeName === "div" || nodeName === "span" );
		if ( !target.id ) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst( $( target ), inline );
		inst.settings = $.extend( {}, settings || {} );
		if ( nodeName === "input" ) {
			this._connectDatepicker( target, inst );
		} else if ( inline ) {
			this._inlineDatepicker( target, inst );
		}
	},

	/* Create a new instance object. */
	_newInst: function( target, inline ) {
		var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
		return { id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: ( !inline ? this.dpDiv : // presentation div
			datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function( target, inst ) {
		var input = $( target );
		inst.append = $( [] );
		inst.trigger = $( [] );
		if ( input.hasClass( this.markerClassName ) ) {
			return;
		}
		this._attachments( input, inst );
		input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
			on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
		this._autoSize( inst );
		$.data( target, "datepicker", inst );

		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function( input, inst ) {
		var showOn, buttonText, buttonImage,
			appendText = this._get( inst, "appendText" ),
			isRTL = this._get( inst, "isRTL" );

		if ( inst.append ) {
			inst.append.remove();
		}
		if ( appendText ) {
			inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
			input[ isRTL ? "before" : "after" ]( inst.append );
		}

		input.off( "focus", this._showDatepicker );

		if ( inst.trigger ) {
			inst.trigger.remove();
		}

		showOn = this._get( inst, "showOn" );
		if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
			input.on( "focus", this._showDatepicker );
		}
		if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
			buttonText = this._get( inst, "buttonText" );
			buttonImage = this._get( inst, "buttonImage" );
			inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
				$( "<img/>" ).addClass( this._triggerClass ).
					attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
				$( "<button type='button'></button>" ).addClass( this._triggerClass ).
					html( !buttonImage ? buttonText : $( "<img/>" ).attr(
					{ src:buttonImage, alt:buttonText, title:buttonText } ) ) );
			input[ isRTL ? "before" : "after" ]( inst.trigger );
			inst.trigger.on( "click", function() {
				if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
					$.datepicker._hideDatepicker();
				} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker( input[ 0 ] );
				} else {
					$.datepicker._showDatepicker( input[ 0 ] );
				}
				return false;
			} );
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function( inst ) {
		if ( this._get( inst, "autoSize" ) && !inst.inline ) {
			var findMax, max, maxI, i,
				date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
				dateFormat = this._get( inst, "dateFormat" );

			if ( dateFormat.match( /[DM]/ ) ) {
				findMax = function( names ) {
					max = 0;
					maxI = 0;
					for ( i = 0; i < names.length; i++ ) {
						if ( names[ i ].length > max ) {
							max = names[ i ].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
					"monthNames" : "monthNamesShort" ) ) ) );
				date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
					"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
			}
			inst.input.attr( "size", this._formatDate( inst, date ).length );
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function( target, inst ) {
		var divSpan = $( target );
		if ( divSpan.hasClass( this.markerClassName ) ) {
			return;
		}
		divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
		$.data( target, "datepicker", inst );
		this._setDate( inst, this._getDefaultDate( inst ), true );
		this._updateDatepicker( inst );
		this._updateAlternate( inst );

		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}

		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if ( !inst ) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
			this._dialogInput.on( "keydown", this._doKeyDown );
			$( "body" ).append( this._dialogInput );
			inst = this._dialogInst = this._newInst( this._dialogInput, false );
			inst.settings = {};
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
		}
		datepicker_extendRemove( inst.settings, settings || {} );
		date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
		this._dialogInput.val( date );

		this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
		if ( !this._pos ) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
		}

		// Move input on screen for focus, but hidden behind dialog
		this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass( this._dialogClass );
		this._showDatepicker( this._dialogInput[ 0 ] );
		if ( $.blockUI ) {
			$.blockUI( this.dpDiv );
		}
		$.data( this._dialogInput[ 0 ], "datepicker", inst );
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function( target ) {
		var nodeName,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData( target, "datepicker" );
		if ( nodeName === "input" ) {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass( this.markerClassName ).
				off( "focus", this._showDatepicker ).
				off( "keydown", this._doKeyDown ).
				off( "keypress", this._doKeyPress ).
				off( "keyup", this._doKeyUp );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			$target.removeClass( this.markerClassName ).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = false;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = false; } ).end().
				filter( "img" ).css( { opacity: "1.0", cursor: "" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().removeClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", false );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = true;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = true; } ).end().
				filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().addClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", true );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
		this._disabledInputs[ this._disabledInputs.length ] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function( target ) {
		if ( !target ) {
			return false;
		}
		for ( var i = 0; i < this._disabledInputs.length; i++ ) {
			if ( this._disabledInputs[ i ] === target ) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function( target ) {
		try {
			return $.data( target, "datepicker" );
		}
		catch ( err ) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function( target, name, value ) {
		var settings, date, minDate, maxDate,
			inst = this._getInst( target );

		if ( arguments.length === 2 && typeof name === "string" ) {
			return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
				( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
				this._get( inst, name ) ) : null ) );
		}

		settings = name || {};
		if ( typeof name === "string" ) {
			settings = {};
			settings[ name ] = value;
		}

		if ( inst ) {
			if ( this._curInst === inst ) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker( target, true );
			minDate = this._getMinMaxDate( inst, "min" );
			maxDate = this._getMinMaxDate( inst, "max" );
			datepicker_extendRemove( inst.settings, settings );

			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
				inst.settings.minDate = this._formatDate( inst, minDate );
			}
			if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
				inst.settings.maxDate = this._formatDate( inst, maxDate );
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker( target );
				} else {
					this._enableDatepicker( target );
				}
			}
			this._attachments( $( target ), inst );
			this._autoSize( inst );
			this._setDate( inst, date );
			this._updateAlternate( inst );
			this._updateDatepicker( inst );
		}
	},

	// Change method deprecated
	_changeDatepicker: function( target, name, value ) {
		this._optionDatepicker( target, name, value );
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function( target ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._updateDatepicker( inst );
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function( target, date ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._setDate( inst, date );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function( target, noDefault ) {
		var inst = this._getInst( target );
		if ( inst && !inst.inline ) {
			this._setDateFromField( inst, noDefault );
		}
		return ( inst ? this._getDate( inst ) : null );
	},

	/* Handle keystrokes. */
	_doKeyDown: function( event ) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst( event.target ),
			handled = true,
			isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

		inst._keyEvent = true;
		if ( $.datepicker._datepickerShowing ) {
			switch ( event.keyCode ) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
						if ( sel[ 0 ] ) {
							$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
						}

						onSelect = $.datepicker._get( inst, "onSelect" );
						if ( onSelect ) {
							dateStr = $.datepicker._formatDate( inst );

							// Trigger custom callback
							onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							-$.datepicker._get( inst, "stepBigMonths" ) :
							-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							+$.datepicker._get( inst, "stepBigMonths" ) :
							+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // next month/year on page down/+ ctrl
				case 35: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._clearDate( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._gotoToday( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// -1 day on ctrl or command +left
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +left on Mac
						break;
				case 38: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, -7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// +1 day on ctrl or command +right
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +right
						break;
				case 40: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, +7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker( this );
		} else {
			handled = false;
		}

		if ( handled ) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function( event ) {
		var chars, chr,
			inst = $.datepicker._getInst( event.target );

		if ( $.datepicker._get( inst, "constrainInput" ) ) {
			chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
			chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
			return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function( event ) {
		var date,
			inst = $.datepicker._getInst( event.target );

		if ( inst.input.val() !== inst.lastVal ) {
			try {
				date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
					( inst.input ? inst.input.val() : null ),
					$.datepicker._getFormatConfig( inst ) );

				if ( date ) { // only if valid
					$.datepicker._setDateFromField( inst );
					$.datepicker._updateAlternate( inst );
					$.datepicker._updateDatepicker( inst );
				}
			}
			catch ( err ) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function( input ) {
		input = input.target || input;
		if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
			input = $( "input", input.parentNode )[ 0 ];
		}

		if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst( input );
		if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
			$.datepicker._curInst.dpDiv.stop( true, true );
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
			}
		}

		beforeShow = $.datepicker._get( inst, "beforeShow" );
		beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
		if ( beforeShowSettings === false ) {
			return;
		}
		datepicker_extendRemove( inst.settings, beforeShowSettings );

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField( inst );

		if ( $.datepicker._inDialog ) { // hide cursor
			input.value = "";
		}
		if ( !$.datepicker._pos ) { // position below input
			$.datepicker._pos = $.datepicker._findPos( input );
			$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$( input ).parents().each( function() {
			isFixed |= $( this ).css( "position" ) === "fixed";
			return !isFixed;
		} );

		offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
		$.datepicker._pos = null;

		//to avoid flashes on Firefox
		inst.dpDiv.empty();

		// determine sizing offscreen
		inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
		$.datepicker._updateDatepicker( inst );

		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset( inst, offset, isFixed );
		inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
			"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
			left: offset.left + "px", top: offset.top + "px" } );

		if ( !inst.inline ) {
			showAnim = $.datepicker._get( inst, "showAnim" );
			duration = $.datepicker._get( inst, "duration" );
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
			} else {
				inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function( inst ) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append( this._generateHTML( inst ) );
		this._attachHandlers( inst );

		var origyearshtml,
			numMonths = this._getNumberOfMonths( inst ),
			cols = numMonths[ 1 ],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
		if ( cols > 1 ) {
			inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
		}
		inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
		inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

		if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.trigger( "focus" );
		}

		// Deffered render of the years select (to avoid flashes on Firefox)
		if ( inst.yearshtml ) {
			origyearshtml = inst.yearshtml;
			setTimeout( function() {

				//assure that inst.yearshtml didn't change.
				if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
					inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
				}
				origyearshtml = inst.yearshtml = null;
			}, 0 );
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function( inst, offset, isFixed ) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
			viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

		offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
		offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
		offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

		// Now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
			Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
		offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
			Math.abs( dpHeight + inputHeight ) : 0 );

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function( obj ) {
		var position,
			inst = this._getInst( obj ),
			isRTL = this._get( inst, "isRTL" );

		while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden( obj ) ) ) {
			obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
		}

		position = $( obj ).offset();
		return [ position.left, position.top ];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function( input ) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
			return;
		}

		if ( this._datepickerShowing ) {
			showAnim = this._get( inst, "showAnim" );
			duration = this._get( inst, "duration" );
			postProcess = function() {
				$.datepicker._tidyDialog( inst );
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
			} else {
				inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
					( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
			}

			if ( !showAnim ) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get( inst, "onClose" );
			if ( onClose ) {
				onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
			}

			this._lastInput = null;
			if ( this._inDialog ) {
				this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
				if ( $.blockUI ) {
					$.unblockUI();
					$( "body" ).append( this.dpDiv );
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function( inst ) {
		inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function( event ) {
		if ( !$.datepicker._curInst ) {
			return;
		}

		var $target = $( event.target ),
			inst = $.datepicker._getInst( $target[ 0 ] );

		if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function( id, offset, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}
		this._adjustInstDate( inst, offset +
			( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
			period );
		this._updateDatepicker( inst );
	},

	/* Action for current link. */
	_gotoToday: function( id ) {
		var date,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function( id, select, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a day. */
	_selectDay: function( id, month, year, td ) {
		var inst,
			target = $( id );

		if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}

		inst = this._getInst( target[ 0 ] );
		inst.selectedDay = inst.currentDay = $( "a", td ).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate( id, this._formatDate( inst,
			inst.currentDay, inst.currentMonth, inst.currentYear ) );
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function( id ) {
		var target = $( id );
		this._selectDate( target, "" );
	},

	/* Update the input field with the selected date. */
	_selectDate: function( id, dateStr ) {
		var onSelect,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
		if ( inst.input ) {
			inst.input.val( dateStr );
		}
		this._updateAlternate( inst );

		onSelect = this._get( inst, "onSelect" );
		if ( onSelect ) {
			onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
		} else if ( inst.input ) {
			inst.input.trigger( "change" ); // fire the change event
		}

		if ( inst.inline ) {
			this._updateDatepicker( inst );
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[ 0 ];
			if ( typeof( inst.input[ 0 ] ) !== "object" ) {
				inst.input.trigger( "focus" ); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function( inst ) {
		var altFormat, date, dateStr,
			altField = this._get( inst, "altField" );

		if ( altField ) { // update alternate field too
			altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
			date = this._getDate( inst );
			dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
			$( altField ).val( dateStr );
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function( date ) {
		var day = date.getDay();
		return [ ( day > 0 && day < 6 ), "" ];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function( date ) {
		var time,
			checkDate = new Date( date.getTime() );

		// Find Thursday of this week starting on Monday
		checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

		time = checkDate.getTime();
		checkDate.setMonth( 0 ); // Compare with Jan 1
		checkDate.setDate( 1 );
		return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}

		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},

			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );

				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},

			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}

		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function( format, date, settings ) {
		if ( !date ) {
			return "";
		}

		var iFormat,
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Format a number, with leading zero if necessary
			formatNumber = function( match, value, len ) {
				var num = "" + value;
				if ( lookAhead( match ) ) {
					while ( num.length < len ) {
						num = "0" + num;
					}
				}
				return num;
			},

			// Format a name, short or long as requested
			formatName = function( match, value, shortNames, longNames ) {
				return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
			},
			output = "",
			literal = false;

		if ( date ) {
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						output += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							output += formatNumber( "d", date.getDate(), 2 );
							break;
						case "D":
							output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
							break;
						case "o":
							output += formatNumber( "o",
								Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
							break;
						case "m":
							output += formatNumber( "m", date.getMonth() + 1, 2 );
							break;
						case "M":
							output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
							break;
						case "y":
							output += ( lookAhead( "y" ) ? date.getFullYear() :
								( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt( iFormat );
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function( format ) {
		var iFormat,
			chars = "",
			literal = false,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					chars += format.charAt( iFormat );
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if ( lookAhead( "'" ) ) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt( iFormat );
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function( inst, name ) {
		return inst.settings[ name ] !== undefined ?
			inst.settings[ name ] : this._defaults[ name ];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function( inst, noDefault ) {
		if ( inst.input.val() === inst.lastVal ) {
			return;
		}

		var dateFormat = this._get( inst, "dateFormat" ),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate( inst ),
			date = defaultDate,
			settings = this._getFormatConfig( inst );

		try {
			date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
		} catch ( event ) {
			dates = ( noDefault ? "" : dates );
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = ( dates ? date.getDate() : 0 );
		inst.currentMonth = ( dates ? date.getMonth() : 0 );
		inst.currentYear = ( dates ? date.getFullYear() : 0 );
		this._adjustInstDate( inst );
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function( inst ) {
		return this._restrictMinMax( inst,
			this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function( inst, date, defaultDate ) {
		var offsetNumeric = function( offset ) {
				var date = new Date();
				date.setDate( date.getDate() + offset );
				return date;
			},
			offsetString = function( offset ) {
				try {
					return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						offset, $.datepicker._getFormatConfig( inst ) );
				}
				catch ( e ) {

					// Ignore
				}

				var date = ( offset.toLowerCase().match( /^c/ ) ?
					$.datepicker._getDate( inst ) : null ) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec( offset );

				while ( matches ) {
					switch ( matches[ 2 ] || "d" ) {
						case "d" : case "D" :
							day += parseInt( matches[ 1 ], 10 ); break;
						case "w" : case "W" :
							day += parseInt( matches[ 1 ], 10 ) * 7; break;
						case "m" : case "M" :
							month += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
						case "y": case "Y" :
							year += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
					}
					matches = pattern.exec( offset );
				}
				return new Date( year, month, day );
			},
			newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
				( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

		newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
		if ( newDate ) {
			newDate.setHours( 0 );
			newDate.setMinutes( 0 );
			newDate.setSeconds( 0 );
			newDate.setMilliseconds( 0 );
		}
		return this._daylightSavingAdjust( newDate );
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function( date ) {
		if ( !date ) {
			return null;
		}
		date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function( inst, date, noChange ) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
			this._notifyChange( inst );
		}
		this._adjustInstDate( inst );
		if ( inst.input ) {
			inst.input.val( clear ? "" : this._formatDate( inst ) );
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function( inst ) {
		var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
			this._daylightSavingAdjust( new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function( inst ) {
		var stepMonths = this._get( inst, "stepMonths" ),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find( "[data-handler]" ).map( function() {
			var handler = {
				prev: function() {
					$.datepicker._adjustDate( id, -stepMonths, "M" );
				},
				next: function() {
					$.datepicker._adjustDate( id, +stepMonths, "M" );
				},
				hide: function() {
					$.datepicker._hideDatepicker();
				},
				today: function() {
					$.datepicker._gotoToday( id );
				},
				selectDay: function() {
					$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
					return false;
				},
				selectMonth: function() {
					$.datepicker._selectMonthYear( id, this, "M" );
					return false;
				},
				selectYear: function() {
					$.datepicker._selectMonthYear( id, this, "Y" );
					return false;
				}
			};
			$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
		} );
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function( inst ) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
			isRTL = this._get( inst, "isRTL" ),
			showButtonPanel = this._get( inst, "showButtonPanel" ),
			hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
			navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
			numMonths = this._getNumberOfMonths( inst ),
			showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
			stepMonths = this._get( inst, "stepMonths" ),
			isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
			currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
				new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if ( drawMonth < 0 ) {
			drawMonth += 12;
			drawYear--;
		}
		if ( maxDate ) {
			maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
				maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
			maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
			while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
				drawMonth--;
				if ( drawMonth < 0 ) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get( inst, "prevText" );
		prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );

		nextText = this._get( inst, "nextText" );
		nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );

		currentText = this._get( inst, "currentText" );
		gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
		currentText = ( !navigationAsDateFormat ? currentText :
			this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

		controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get( inst, "closeText" ) + "</button>" : "" );

		buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
			( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";

		firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
		firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

		showWeek = this._get( inst, "showWeek" );
		dayNames = this._get( inst, "dayNames" );
		dayNamesMin = this._get( inst, "dayNamesMin" );
		monthNames = this._get( inst, "monthNames" );
		monthNamesShort = this._get( inst, "monthNamesShort" );
		beforeShowDay = this._get( inst, "beforeShowDay" );
		showOtherMonths = this._get( inst, "showOtherMonths" );
		selectOtherMonths = this._get( inst, "selectOtherMonths" );
		defaultDate = this._getDefaultDate( inst );
		html = "";

		for ( row = 0; row < numMonths[ 0 ]; row++ ) {
			group = "";
			this.maxRows = 4;
			for ( col = 0; col < numMonths[ 1 ]; col++ ) {
				selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
				cornerClass = " ui-corner-all";
				calender = "";
				if ( isMultiMonth ) {
					calender += "<div class='ui-datepicker-group";
					if ( numMonths[ 1 ] > 1 ) {
						switch ( col ) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
							case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
				for ( dow = 0; dow < 7; dow++ ) { // days of the week
					day = ( dow + firstDay ) % 7;
					thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
				if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
					inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
				}
				leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
				curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
				numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
				for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
					calender += "<tr>";
					tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
					for ( dow = 0; dow < 7; dow++ ) { // create date picker days
						daySettings = ( beforeShowDay ?
							beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
						otherMonth = ( printDate.getMonth() !== drawMonth );
						unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
						tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
						printDate.setDate( printDate.getDate() + 1 );
						printDate = this._daylightSavingAdjust( printDate );
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if ( drawMonth > 11 ) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}

		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {

				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function( inst, offset, period ) {
		var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
			month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
			day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
			date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if ( period === "M" || period === "Y" ) {
			this._notifyChange( inst );
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function( inst, date ) {
		var minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			newDate = ( minDate && date < minDate ? minDate : date );
		return ( maxDate && newDate > maxDate ? maxDate : newDate );
	},

	/* Notify change of month/year. */
	_notifyChange: function( inst ) {
		var onChange = this._get( inst, "onChangeMonthYear" );
		if ( onChange ) {
			onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
				[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function( inst ) {
		var numMonths = this._get( inst, "numberOfMonths" );
		return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function( inst, minMax ) {
		return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function( year, month ) {
		return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function( year, month ) {
		return new Date( year, month, 1 ).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
		var numMonths = this._getNumberOfMonths( inst ),
			date = this._daylightSavingAdjust( new Date( curYear,
			curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

		if ( offset < 0 ) {
			date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
		}
		return this._isInRange( inst, date );
	},

	/* Is the given date in the accepted range? */
	_isInRange: function( inst, date ) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			minYear = null,
			maxYear = null,
			years = this._get( inst, "yearRange" );
			if ( years ) {
				yearSplit = years.split( ":" );
				currentYear = new Date().getFullYear();
				minYear = parseInt( yearSplit[ 0 ], 10 );
				maxYear = parseInt( yearSplit[ 1 ], 10 );
				if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
					minYear += currentYear;
				}
				if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
					maxYear += currentYear;
				}
			}

		return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function( inst ) {
		var shortYearCutoff = this._get( inst, "shortYearCutoff" );
		shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
		return { shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
			monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
	},

	/* Format the given date for display. */
	_formatDate: function( inst, day, month, year ) {
		if ( !day ) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = ( day ? ( typeof day === "object" ? day :
			this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
			this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
		return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
	}
} );

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover( dpDiv ) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.on( "mouseout", selector, function() {
			$( this ).removeClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-next-hover" );
			}
		} )
		.on( "mouseover", selector, datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
		$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
		$( this ).addClass( "ui-state-hover" );
		if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-prev-hover" );
		}
		if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-next-hover" );
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove( target, props ) {
	$.extend( target, props );
	for ( var name in props ) {
		if ( props[ name ] == null ) {
			target[ name ] = props[ name ];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function( options ) {

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if ( !$.datepicker.initialized ) {
		$( document ).on( "mousedown", $.datepicker._checkExternalClick );
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
		$( "body" ).append( $.datepicker.dpDiv );
	}

	var otherArgs = Array.prototype.slice.call( arguments, 1 );
	if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	return this.each( function() {
		typeof options === "string" ?
			$.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this ].concat( otherArgs ) ) :
			$.datepicker._attachDatepicker( this, options );
	} );
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.12.1";

var widgetsDatepicker = $.datepicker;


/*!
 * jQuery UI Dialog 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Dialog
//>>group: Widgets
//>>description: Displays customizable dialog windows.
//>>docs: http://api.jqueryui.com/dialog/
//>>demos: http://jqueryui.com/dialog/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/dialog.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.dialog", {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		classes: {
			"ui-dialog": "ui-corner-all",
			"ui-dialog-titlebar": "ui-corner-all"
		},
		closeOnEscape: true,
		closeText: "Close",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",

			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// Callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		if ( this.options.title == null && this.originalTitle != null ) {
			this.options.title = this.originalTitle;
		}

		// Dialogs can't be disabled
		if ( this.options.disabled ) {
			this.options.disabled = false;
		}

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.appendTo( this.uiDialog );

		this._addClass( "ui-dialog-content", "ui-widget-content" );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && ( element.jquery || element.nodeType ) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.css( this.originalCss )

			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );

		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

			// Hiding a focused element doesn't trigger blur in WebKit
			// so in case we have nothing to focus on, explicitly blur the active element
			// https://bugs.webkit.org/show_bug.cgi?id=47182
			$.ui.safeBlur( $.ui.safeActiveElement( this.document[ 0 ] ) );
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		} );
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
				return +$( this ).css( "z-index" );
			} ).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( $.ui.safeActiveElement( this.document[ 0 ] ) );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		} );

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {

		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).trigger( "focus" );
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				isActive = this.uiDialog[ 0 ] === activeElement ||
					$.contains( this.uiDialog[ 0 ], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );

		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $( "<div>" )
			.hide()
			.attr( {

				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			} )
			.appendTo( this._appendTo() );

		this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// Prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
					this._delay( function() {
						first.trigger( "focus" );
					} );
					event.preventDefault();
				} else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
					this._delay( function() {
						last.trigger( "focus" );
					} );
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		} );

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr( {
				"aria-describedby": this.element.uniqueId().attr( "id" )
			} );
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" );
		this._addClass( this.uiDialogTitlebar,
			"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {

				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.trigger( "focus" );
				}
			}
		} );

		// Support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button( {
				label: $( "<a>" ).text( this.options.closeText ).html(),
				icon: "ui-icon-closethick",
				showLabel: false
			} )
			.appendTo( this.uiDialogTitlebar );

		this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		} );

		uiDialogTitle = $( "<span>" ).uniqueId().prependTo( this.uiDialogTitlebar );
		this._addClass( uiDialogTitle, "ui-dialog-title" );
		this._title( uiDialogTitle );

		this.uiDialogTitlebar.prependTo( this.uiDialog );

		this.uiDialog.attr( {
			"aria-labelledby": uiDialogTitle.attr( "id" )
		} );
	},

	_title: function( title ) {
		if ( this.options.title ) {
			title.text( this.options.title );
		} else {
			title.html( "&#160;" );
		}
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" );
		this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
			"ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.appendTo( this.uiDialogButtonPane );
		this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// If we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ( $.isArray( buttons ) && !buttons.length ) ) {
			this._removeClass( this.uiDialog, "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;

			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );

			// Change the context for the click callback to be the main element
			click = props.click;
			buttonOptions = {
				icon: props.icon,
				iconPosition: props.iconPosition,
				showLabel: props.showLabel,

				// Deprecated options
				icons: props.icons,
				text: props.text
			};

			delete props.click;
			delete props.icon;
			delete props.iconPosition;
			delete props.showLabel;

			// Deprecated options
			delete props.icons;
			if ( typeof props.text === "boolean" ) {
				delete props.text;
			}

			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet )
				.on( "click", function() {
					click.apply( that.element[ 0 ], arguments );
				} );
		} );
		this._addClass( this.uiDialog, "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable( {
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		} );
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,

			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css( "position" ),
			resizeHandles = typeof handles === "string" ?
				handles :
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable( {
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		} )
			.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		} );
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {

		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		} );

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button( {

				// Ensure that we always pass a string
				label: $( "<a>" ).text( "" + this.options.closeText ).html()
			} );
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {

			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// Currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// Currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {

		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css( {
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		} );

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// Reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css( {
			height: "auto",
			width: options.width
		} )
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css( {
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			} );
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( {
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				} )
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay( function() {
			isOpening = false;
		} );

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			} );
		}

		this.overlay = $( "<div>" )
			.appendTo( this._appendTo() );

		this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		} );
		this.document.data( "ui-dialog-overlays",
			( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this._off( this.document, "focusin" );
				this.document.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for dialogClass option
	$.widget( "ui.dialog", $.ui.dialog, {
		options: {
			dialogClass: ""
		},
		_createWrapper: function() {
			this._super();
			this.uiDialog.addClass( this.options.dialogClass );
		},
		_setOption: function( key, value ) {
			if ( key === "dialogClass" ) {
				this.uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
			this._superApply( arguments );
		}
	} );
}

var widgetsDialog = $.ui.dialog;


/*!
 * jQuery UI Progressbar 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Progressbar
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/progressbar/
//>>demos: http://jqueryui.com/progressbar/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/progressbar.css
//>>css.theme: ../../themes/base/theme.css



var widgetsProgressbar = $.widget( "ui.progressbar", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-progressbar": "ui-corner-all",
			"ui-progressbar-value": "ui-corner-left",
			"ui-progressbar-complete": "ui-corner-right"
		},
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {

		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element.attr( {

			// Only set static values; aria-valuenow and aria-valuemax are
			// set inside _refreshValue()
			role: "progressbar",
			"aria-valuemin": this.min
		} );
		this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

		this.valueDiv = $( "<div>" ).appendTo( this.element );
		this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
		this._refreshValue();
	},

	_destroy: function() {
		this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// Sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {

		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {

			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_percentage: function() {
		return this.indeterminate ?
			100 :
			100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.width( percentage.toFixed( 0 ) + "%" );

		this
			._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
				value === this.options.max )
			._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
				this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
			}
		} else {
			this.element.attr( {
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			} );
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
} );


/*!
 * jQuery UI Selectmenu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectmenu
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/selectmenu/
//>>demos: http://jqueryui.com/selectmenu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
	version: "1.12.1",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		classes: {
			"ui-selectmenu-button-open": "ui-corner-top",
			"ui-selectmenu-button-closed": "ui-corner-all"
		},
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: false,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();
		this._bindFormResetHandler();

		this._rendered = false;
		this.menuItems = $();
	},

	_drawButton: function() {
		var icon,
			that = this,
			item = this._parseOption(
				this.element.find( "option:selected" ),
				this.element[ 0 ].selectedIndex
			);

		// Associate existing label with the new button
		this.labels = this.element.labels().attr( "for", this.ids.button );
		this._on( this.labels, {
			click: function( event ) {
				this.button.focus();
				event.preventDefault();
			}
		} );

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true",
			title: this.element.attr( "title" )
		} )
			.insertAfter( this.element );

		this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
			"ui-button ui-widget" );

		icon = $( "<span>" ).appendTo( this.button );
		this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
		this.buttonItem = this._renderButtonItem( item )
			.appendTo( this.button );

		if ( this.options.width !== false ) {
			this._resizeButton();
		}

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that._rendered ) {
				that._refreshMenu();
			}
		} );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		} );

		// Wrap menu
		this.menuWrap = $( "<div>" ).append( this.menu );
		this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
		this.menuWrap.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu( {
				classes: {
					"ui-menu": "ui-corner-bottom"
				},
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();

					// Support: IE8
					// If the item was selected via a click, the text selection
					// will be destroyed in IE
					that._setSelection();

					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			} )
			.menu( "instance" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this.buttonItem.replaceWith(
			this.buttonItem = this._renderButtonItem(

				// Fall back to an empty object in case there are no options
				this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
			)
		);
		if ( this.options.width === null ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		var item,
			options = this.element.find( "option" );

		this.menu.empty();

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" )
			.not( ".ui-selectmenu-optgroup" )
				.find( ".ui-menu-item-wrapper" );

		this._rendered = true;

		if ( !options.length ) {
			return;
		}

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this._rendered ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		// If there are no options, don't open the menu
		if ( !this.menuItems.length ) {
			return;
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderButtonItem: function( item ) {
		var buttonItem = $( "<span>" );

		this._setText( buttonItem, item.label );
		this._addClass( buttonItem, "ui-selectmenu-text" );

		return buttonItem;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			var li;

			if ( item.optgroup !== currentOptgroup ) {
				li = $( "<li>", {
					text: item.optgroup
				} );
				that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
						" ui-state-disabled" :
						"" ) );

				li.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" ),
			wrapper = $( "<div>", {
				title: item.element.attr( "title" )
			} );

		if ( item.disabled ) {
			this._addClass( li, null, "ui-state-disabled" );
		}
		this._setText( wrapper, item.label );

		return li.append( wrapper ).appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		if ( window.getSelection ) {
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange( this.range );

		// Support: IE8
		} else {
			this.range.select();
		}

		// Support: IE
		// Setting the text selection kills the button focus in IE, but
		// restoring the focus doesn't kill the selection.
		this.button.focus();
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
					$.ui.escapeSelector( this.ids.button ) ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection;

			if ( window.getSelection ) {
				selection = window.getSelection();
				if ( selection.rangeCount ) {
					this.range = selection.getRangeAt( 0 );
				}

			// Support: IE8
			} else {
				this.range = document.selection.createRange();
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
			case $.ui.keyCode.TAB:
			case $.ui.keyCode.ESCAPE:
				this.close( event );
				preventDefault = false;
				break;
			case $.ui.keyCode.ENTER:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				}
				break;
			case $.ui.keyCode.UP:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "prev", event );
				}
				break;
			case $.ui.keyCode.DOWN:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "next", event );
				}
				break;
			case $.ui.keyCode.SPACE:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				} else {
					this._toggle( event );
				}
				break;
			case $.ui.keyCode.LEFT:
				this._move( "prev", event );
				break;
			case $.ui.keyCode.RIGHT:
				this._move( "next", event );
				break;
			case $.ui.keyCode.HOME:
			case $.ui.keyCode.PAGE_UP:
				this._move( "first", event );
				break;
			case $.ui.keyCode.END:
			case $.ui.keyCode.PAGE_DOWN:
				this._move( "last", event );
				break;
			default:
				this.menu.trigger( event );
				preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr( {
			"aria-labelledby": id,
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icon = this.button.find( "span.ui-icon" );
			this._removeClass( icon, null, this.options.icons.button )
				._addClass( icon, null, value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.menuInstance.option( "disabled", value );
		this.button.attr( "aria-disabled", value );
		this._toggleClass( this.button, null, "ui-state-disabled", value );

		this.element.prop( "disabled", value );
		if ( value ) {
			this.button.attr( "tabindex", -1 );
			this.close();
		} else {
			this.button.attr( "tabindex", 0 );
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button.attr( "aria-expanded", this.isOpen );

		// We can't use two _toggleClass() calls here, because we need to make sure
		// we always remove classes first and add them second, otherwise if both classes have the
		// same theme class, it will be removed after we add it.
		this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
			._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
			._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		// For `width: false`, just remove inline style and stop
		if ( width === false ) {
			this.button.css( "width", "" );
			return;
		}

		// For `width: null`, match the width of the original element
		if ( width === null ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),

			// Support: IE10
			// IE10 wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping
			this.menu.width( "" ).outerWidth() + 1
		) );
	},

	_getCreateOptions: function() {
		var options = this._super();

		options.disabled = this.element.prop( "disabled" );

		return options;
	},

	_parseOptions: function( options ) {
		var that = this,
			data = [];
		options.each( function( index, item ) {
			data.push( that._parseOption( $( item ), index ) );
		} );
		this.items = data;
	},

	_parseOption: function( option, index ) {
		var optgroup = option.parent( "optgroup" );

		return {
			element: option,
			index: index,
			value: option.val(),
			label: option.text(),
			optgroup: optgroup.attr( "label" ) || "",
			disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
		};
	},

	_destroy: function() {
		this._unbindFormResetHandler();
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.labels.attr( "for", this.ids.element );
	}
} ] );


/*!
 * jQuery UI Slider 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: http://api.jqueryui.com/slider/
//>>demos: http://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( $.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( $.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( $.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );


/*!
 * jQuery UI Spinner 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Spinner
//>>group: Widgets
//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
//>>docs: http://api.jqueryui.com/spinner/
//>>demos: http://jqueryui.com/spinner/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/spinner.css
//>>css.theme: ../../themes/base/theme.css



function spinnerModifer( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

$.widget( "ui.spinner", {
	version: "1.12.1",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		classes: {
			"ui-spinner": "ui-corner-all",
			"ui-spinner-down": "ui-corner-br",
			"ui-spinner-up": "ui-corner-tr"
		},
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {

		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {

			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_getCreateOptions: function() {
		var options = this._super();
		var element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value != null && value.length ) {
				options[ option ] = value;
			}
		} );

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			if ( this.cancelBlur ) {
				delete this.cancelBlur;
				return;
			}

			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		mousewheel: function( event, delta ) {
			if ( !delta ) {
				return;
			}
			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay( function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},
		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] ) ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] );
				if ( !isActive ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// support: IE
					// IE sets focus asynchronously, so we need to check if focus
					// moved off of the input because the user clicked on the button.
					this._delay( function() {
						this.previous = previous;
					} );
				}
			}

			// Ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			// Support: IE
			// IE doesn't prevent moving focus even with event.preventDefault()
			// so we set a flag to know when we should ignore the blur event
			// and check (again) if focus moved off of the input.
			this.cancelBlur = true;
			this._delay( function() {
				delete this.cancelBlur;
				checkFocus.call( this );
			} );

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {

			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},

		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	// Support mobile enhanced option and make backcompat more sane
	_enhance: function() {
		this.uiSpinner = this.element
			.attr( "autocomplete", "off" )
			.wrap( "<span>" )
			.parent()

				// Add buttons
				.append(
					"<a></a><a></a>"
				);
	},

	_draw: function() {
		this._enhance();

		this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
		this._addClass( "ui-spinner-input" );

		this.element.attr( "role", "spinbutton" );

		// Button bindings
		this.buttons = this.uiSpinner.children( "a" )
			.attr( "tabIndex", -1 )
			.attr( "aria-hidden", true )
			.button( {
				classes: {
					"ui-button": ""
				}
			} );

		// TODO: Right now button does not support classes this is already updated in button PR
		this._removeClass( this.buttons, "ui-corner-all" );

		this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
		this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
		this.buttons.first().button( {
			"icon": this.options.icons.up,
			"showLabel": false
		} );
		this.buttons.last().button( {
			"icon": this.options.icons.down,
			"showLabel": false
		} );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
			this.uiSpinner.height( this.uiSpinner.height() );
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay( function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return $.isFunction( incremental ) ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// Make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;

		// - round to the nearest step
		aboveMin = Math.round( aboveMin / options.step ) * options.step;

		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// Fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// Clamp the value
		if ( options.max !== null && value > options.max ) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		var prevValue, first, last;

		if ( key === "culture" || key === "numberFormat" ) {
			prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			first = this.buttons.first().find( ".ui-icon" );
			this._removeClass( first, null, this.options.icons.up );
			this._addClass( first, null, value.up );
			last = this.buttons.last().find( ".ui-icon" );
			this._removeClass( last, null, this.options.icons.down );
			this._addClass( last, null, value.down );
		}

		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
		this.element.prop( "disabled", !!value );
		this.buttons.button( value ? "disable" : "enable" );
	},

	_setOptions: spinnerModifer( function( options ) {
		this._super( options );
	} ),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr( {
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,

			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		} );
	},

	isValid: function() {
		var value = this.value();

		// Null is invalid
		if ( value === null ) {
			return false;
		}

		// If value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// Update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.prop( "disabled", false )
			.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinnerModifer( function( steps ) {
		this._stepUp( steps );
	} ),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinnerModifer( function( steps ) {
		this._stepDown( steps );
	} ),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinnerModifer( function( pages ) {
		this._stepUp( ( pages || 1 ) * this.options.page );
	} ),

	pageDown: spinnerModifer( function( pages ) {
		this._stepDown( ( pages || 1 ) * this.options.page );
	} ),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinnerModifer( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for spinner html extension points
	$.widget( "ui.spinner", $.ui.spinner, {
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()

					// Add buttons
					.append( this._buttonHtml() );
		},
		_uiSpinnerHtml: function() {
			return "<span>";
		},

		_buttonHtml: function() {
			return "<a></a><a></a>";
		}
	} );
}

var widgetsSpinner = $.ui.spinner;


/*!
 * jQuery UI Tabs 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: http://api.jqueryui.com/tabs/
//>>demos: http://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tabs", {
	version: "1.12.1",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: ( function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// Decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	} )(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( $.isArray( options.disabled ) ) {
			options.disabled = $.unique( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				} );
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	_sanitizeSelector: function( hash ) {
		return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} )

			// Support: IE <9
			// Preventing the default action in mousedown doesn't prevent IE
			// from focusing the element, so if the anchor gets focused, blur.
			// We don't have to worry about focusing the previously focused
			// element since clicking on a non-focusable element should focus
			// the body anyway.
			.on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function() {
				if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
					this.blur();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				role: "presentation",
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( that._sanitizeSelector( selector ) );

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( $.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// Trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				$.ui.escapeSelector( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( $.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( $.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		// Support: jQuery <1.8
		// jQuery <1.8 returns false if the request is canceled in beforeSend,
		// but as of 1.8, $.ajax() always returns a jqXHR object.
		if ( this.xhr && this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						panel.html( response );
						that._trigger( "load", event, eventData );

						complete( jqXHR, status );
					}, 1 );
				} )
				.fail( function( jqXHR, status ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						complete( jqXHR, status );
					}, 1 );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {

			// Support: IE <11 only
			// Strip any hash that exists to prevent errors with the Ajax request
			url: anchor.attr( "href" ).replace( /#.*$/, "" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( this._sanitizeSelector( "#" + id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

var widgetsTabs = $.ui.tabs;


/*!
 * jQuery UI Tooltip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tooltip
//>>group: Widgets
//>>description: Shows additional information for any element on hover or focus.
//>>docs: http://api.jqueryui.com/tooltip/
//>>demos: http://jqueryui.com/tooltip/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tooltip.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tooltip", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-tooltip": "ui-corner-all ui-widget-shadow"
		},
		content: function() {

			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";

			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,

		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		track: false,

		// Callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = $.trim( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on( {
			mouseover: "open",
			focusin: "open"
		} );

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr( {
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
			.appendTo( this.document[ 0 ].body );
		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		this.disabledTitles = $( [] );
	},

	_setOption: function( key, value ) {
		var that = this;

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			} );
		}
	},

	_setOptionDisabled: function( value ) {
		this[ value ? "_disable" : "_enable" ]();
	},

	_disable: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		} );

		// Remove title attributes to prevent native tooltips
		this.disabledTitles = this.disabledTitles.add(
			this.element.find( this.options.items ).addBack()
				.filter( function() {
					var element = $( this );
					if ( element.is( "[title]" ) ) {
						return element
							.data( "ui-tooltip-title", element.attr( "title" ) )
							.removeAttr( "title" );
					}
				} )
		);
	},

	_enable: function() {

		// restore title attributes
		this.disabledTitles.each( function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		} );
		this.disabledTitles = $( [] );
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )

				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// Kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each( function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			} );
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[ 0 ], function( response ) {

			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay( function() {

				// Ignore async response if tooltip was closed already
				if ( !target.data( "ui-tooltip-open" ) ) {
					return;
				}

				// JQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			} );
		} );
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// If we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
		a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
		a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		a11yContent.appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			} );

			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend( {
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );

		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		// Adds the check to add the timers only when both delay and track options are set (#14682)
		if ( this.options.track && this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval( function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event( event );
					fakeEvent.currentTarget = target[ 0 ];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				this._removeTooltip( this._find( target ).tooltip );
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// Disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// Only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		} );

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			} );
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
			content = $( "<div>" ).appendTo( tooltip ),
			id = tooltip.uniqueId().attr( "id" );

		this._addClass( content, "ui-tooltip-content" );
		this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

		tooltip.appendTo( this._appendTo( element ) );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_appendTo: function( target ) {
		var element = target.closest( ".ui-front, dialog" );

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_destroy: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {

			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {

				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		} );
		this.liveRegion.remove();
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for tooltipClass option
	$.widget( "ui.tooltip", $.ui.tooltip, {
		options: {
			tooltipClass: null
		},
		_tooltip: function() {
			var tooltipData = this._superApply( arguments );
			if ( this.options.tooltipClass ) {
				tooltipData.tooltip.addClass( this.options.tooltipClass );
			}
			return tooltipData;
		}
	} );
}

var widgetsTooltip = $.ui.tooltip;


/*!
 * jQuery UI Effects 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/category/effects-core/
//>>demos: http://jqueryui.com/effect/



var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated",

	// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery = $;

$.effects = {
	effect: {}
};

/*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
( function( jQuery, undefined ) {

	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	// Plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// A set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 )
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// JQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// Element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// Colors = jQuery.Color.names
	colors,

	// Local aliases of functions called often
	each = jQuery.each;

// Determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// Define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {

		// We add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// For now all property types without mod have min and max
	return 0 > value ? 0 : type.max < value ? type.max : value;
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// If this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// Exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// If this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// Named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = jQuery.type( red ),
			rgba = this._rgba = [];

		// More than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// If the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// If the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// This is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// Everything defined but alpha?
					if ( inst[ cache ] &&
							jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

						// Use the default of 1
						inst[ cache ][ 3 ] = 1;
						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// If null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// If null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// If we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				return v == null ? ( i > 2 ? 1 : 0 ) : v;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// Catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// Default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		} ).join( "" );
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// Hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};

each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// Makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// Generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = jQuery.type( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// Makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// Alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var vtype = jQuery.type( value ),
				fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
				local = this[ fn ](),
				cur = local[ prop.idx ],
				match;

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = jQuery.type( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// Add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							( backgroundColor === "" || backgroundColor === "transparent" ) &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {

					// Wrapped to prevent IE from throwing errors on "invalid" values like
					// 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};

} )( jQuery );

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ $.camelCase( key ) ] = style[ key ];
			}
		}

	// Support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// Support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
	$.expr.filters.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.filters.animated );
}

if ( $.uiBackCompat !== false ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				active.id;
			} catch ( e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.12.1",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( $.isFunction( options ) ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( $.isFunction( speed ) ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( $.isFunction( option ) ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated psuedo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( $.isFunction( complete ) ) {
					complete.call( elem[ 0 ] );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat !== false && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" )
				.appendTo( "body" )
				.addClass( options.className )
				.css( {
					top: startPosition.top - fixTop,
					left: startPosition.left - fixLeft,
					height: element.innerHeight(),
					width: element.innerWidth(),
					position: targetFixed ? "fixed" : "absolute"
				} )
				.animate( animation, options.duration, options.easing, function() {
					transfer.remove();
					if ( $.isFunction( done ) ) {
						done();
					}
				} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: http://api.jqueryui.com/blind-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/bounce-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: http://api.jqueryui.com/clip-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: http://api.jqueryui.com/drop-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/explode-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: http://api.jqueryui.com/fade-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: http://api.jqueryui.com/fold-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: http://api.jqueryui.com/highlight-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: http://api.jqueryui.com/size-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: http://api.jqueryui.com/scale-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: http://api.jqueryui.com/puff-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: http://api.jqueryui.com/pulsate-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/shake-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: http://api.jqueryui.com/slide-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: http://api.jqueryui.com/transfer-effect/
//>>demos: http://jqueryui.com/effect/



var effect;
if ( $.uiBackCompat !== false ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;




}));
!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[14+(r+64>>>9<<4)]=r;var e,i,a,d,h,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,d=v,h=m,g=f(g=f(g=f(g=f(g=c(g=c(g=c(g=c(g=u(g=u(g=u(g=u(g=o(g=o(g=o(g=o(g,v=o(v,m=o(m,l=o(l,g,v,m,n[e],7,-680876936),g,v,n[e+1],12,-389564586),l,g,n[e+2],17,606105819),m,l,n[e+3],22,-1044525330),v=o(v,m=o(m,l=o(l,g,v,m,n[e+4],7,-176418897),g,v,n[e+5],12,1200080426),l,g,n[e+6],17,-1473231341),m,l,n[e+7],22,-45705983),v=o(v,m=o(m,l=o(l,g,v,m,n[e+8],7,1770035416),g,v,n[e+9],12,-1958414417),l,g,n[e+10],17,-42063),m,l,n[e+11],22,-1990404162),v=o(v,m=o(m,l=o(l,g,v,m,n[e+12],7,1804603682),g,v,n[e+13],12,-40341101),l,g,n[e+14],17,-1502002290),m,l,n[e+15],22,1236535329),v=u(v,m=u(m,l=u(l,g,v,m,n[e+1],5,-165796510),g,v,n[e+6],9,-1069501632),l,g,n[e+11],14,643717713),m,l,n[e],20,-373897302),v=u(v,m=u(m,l=u(l,g,v,m,n[e+5],5,-701558691),g,v,n[e+10],9,38016083),l,g,n[e+15],14,-660478335),m,l,n[e+4],20,-405537848),v=u(v,m=u(m,l=u(l,g,v,m,n[e+9],5,568446438),g,v,n[e+14],9,-1019803690),l,g,n[e+3],14,-187363961),m,l,n[e+8],20,1163531501),v=u(v,m=u(m,l=u(l,g,v,m,n[e+13],5,-1444681467),g,v,n[e+2],9,-51403784),l,g,n[e+7],14,1735328473),m,l,n[e+12],20,-1926607734),v=c(v,m=c(m,l=c(l,g,v,m,n[e+5],4,-378558),g,v,n[e+8],11,-2022574463),l,g,n[e+11],16,1839030562),m,l,n[e+14],23,-35309556),v=c(v,m=c(m,l=c(l,g,v,m,n[e+1],4,-1530992060),g,v,n[e+4],11,1272893353),l,g,n[e+7],16,-155497632),m,l,n[e+10],23,-1094730640),v=c(v,m=c(m,l=c(l,g,v,m,n[e+13],4,681279174),g,v,n[e],11,-358537222),l,g,n[e+3],16,-722521979),m,l,n[e+6],23,76029189),v=c(v,m=c(m,l=c(l,g,v,m,n[e+9],4,-640364487),g,v,n[e+12],11,-421815835),l,g,n[e+15],16,530742520),m,l,n[e+2],23,-995338651),v=f(v,m=f(m,l=f(l,g,v,m,n[e],6,-198630844),g,v,n[e+7],10,1126891415),l,g,n[e+14],15,-1416354905),m,l,n[e+5],21,-57434055),v=f(v,m=f(m,l=f(l,g,v,m,n[e+12],6,1700485571),g,v,n[e+3],10,-1894986606),l,g,n[e+10],15,-1051523),m,l,n[e+1],21,-2054922799),v=f(v,m=f(m,l=f(l,g,v,m,n[e+8],6,1873313359),g,v,n[e+15],10,-30611744),l,g,n[e+6],15,-1560198380),m,l,n[e+13],21,1309151649),v=f(v,m=f(m,l=f(l,g,v,m,n[e+4],6,-145523070),g,v,n[e+11],10,-1120210379),l,g,n[e+2],15,718787259),m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,d),m=t(m,h);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function d(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function h(n){return a(i(d(n),8*n.length))}function l(n,t){var r,e,o=d(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(d(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),e+="0123456789abcdef".charAt(t>>>4&15)+"0123456789abcdef".charAt(15&t);return e}function v(n){return unescape(encodeURIComponent(n))}function m(n){return h(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)}"function"==typeof define&&define.amd?define(function(){return A}):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);

// TEALIUM BEGIN

// Common tealium code for all brands

if(typeof tealium_data2track === 'undefined'){
    tealium_data2track = [];
}

function getSunOpticalCategoryName(categoryName){
    var catTokenArray = categoryName.split("-");

    for (var i=0; i<catTokenArray.length; i++){
        var currentToken = catTokenArray[i].toLowerCase();
        switch (currentToken){
            case "optical":
                return "OPTICS";
            case "sun":
                return "SUN";
            case "contact_lens":
                return "CONTACT LENSES";
            case "accessories":
                return "ACCESSORIES";
        }
    }
    // HB-1585: other than SUN/OPTICS, return empty, for now.
    return "";
}

/*HB-5614*/
function getCategoryName(categoryName,splitCrit){
    var catTokenArray = categoryName.split(splitCrit);

    for (var i=0; i<catTokenArray.length; i++){
        var currentToken = catTokenArray[i].toLowerCase();
        switch (currentToken){
            case "optical":
                return "OPTICS";
            case "sun":
                return "SUN";
            case "contact_lens":
                return "CONTACT LENSES";
            case "accessories":
                return "ACCESSORIES";
        }
    }
    return "";
}
/*End 5614*/

//Equivalent to $(document).ready() in plain javascript
document.addEventListener("DOMContentLoaded", function(event) {
    addTrackingToCarouselLinks();

    if (isOliver){
        hardCodeDataElementIdsOP();
    }
});

/* HB-11391 BEGIN Add data-element-id tracking on Carousel links */
function addTrackingToCarouselLinks(){
    $(document).off('click','.owl-carousel a').on('click','.owl-carousel a',onClickHandler);

    function onClickHandler(){
	    tealium_data2track.push({
	        id:'Click',
	        Click_FocusElement:this,
	        Tracking_Type: 'hiddenaction'
	    });
    }
}
/* HB-11391 END */

/* HB-2405 BEGIN Add Analytics tracking in catalog entry widget */
function hardCodeDataElementIdsOP(){
    var elements = document.querySelectorAll(".home-page [data-slot-id='3'] [data-element-id='X_product']");
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.setAttribute("data-element-id","X_zone2_product");
    }

    elements = document.querySelectorAll(".home-page [data-slot-id='4'] [data-element-id='X_product']");
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        element.setAttribute("data-element-id","X_NewArrivals_product");
    }
}
/* HB-2405 END */

/* HB-2885 BEGIN Add analytics info to MyAccount */
function updateTealiumUserInfo(){
    var userEmailOptin = 0;
    var userEmail;
    var userId;

    getAjaxPromise("/wcs/resources/store/" + WCParamJS.storeId + "/person/@self")
    .then(function(userData){
        if (typeof userData.email1 !== 'undefined' && userData.email1 != ""){
            userEmail = userData.email1;
            userId = userData.userId;
            return getAjaxPromise("/wcs/resources/store/" + WCParamJS.storeId + "/customNewsletterInfo/byEmail/" + userData.email1);
        }
    })
    .then(function(newsletterData){
        if(typeof newsletterData.newsletterInfo.email !== 'undefined'){
            //The user is in the newsletter
            userEmailOptin = 1;
        }

        var obj = {
            'id' : 'Account-Create',
            'User_LoginStatus' : 'Logged',
            'User_VtoStatus' : '',
            'User_EmailOptin' : userEmailOptin,
            'User_Email_MD5' : md5(userEmail).toString(),
            'User_Phone_MD5' : userEmail.toString(),
            'User_Phone_SHA256' : userEmail.toString(),
            'User_Segments' : '',
            'User_Id' : userId
        }
        tealium_data2track.push(obj);
        console.log("TEALIUM::User info updated and sent");
    })
    .catch(function(error){
        console.log(error);
    });
}
/* HB-2885 END */

/*HB-5965 */
function pushDiscountCode(obj) {
	 tealium_data2track.push(obj);
     sessionStorage.Order_DiscountCode = obj.Order_DiscountCode.split(' ')[0];
     sessionStorage.Order_DiscountName = obj.Order_DiscountName;
     console.log("TEALIUM::Discount Code info updated and sent");
	
}
// TEALIUM END

function validatePhoneForE164(phoneNumber) {
    const regEx = /^\+[1-9]\d{10,14}$/;

    return regEx.test(phoneNumber);
}
function declareControllerForMainAndAddressDiv() {
  var e = $("#content_wrapper");
  wcRenderContext.addRefreshAreaId(
    "contextForMainAndAddressDiv",
    "content_wrapper"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "contextForMainAndAddressDiv"
  );
  e.refreshWidget({
    renderContextChangedHandler: function () {
      CheckoutHelperJS.showHideDivs(t.showArea, t.hideArea);
    },
  });
}

function declareTraditionalShipmentDetailsController() {
  var myWidgetObj = $("#WC_ShipmentDisplay_div_17");
  wcRenderContext.addRefreshAreaId(
    "traditionalShipmentDetailsContext",
    "WC_ShipmentDisplay_div_17"
  );
  var myRCProperties = wcRenderContext.getRenderContextProperties(
      "traditionalShipmentDetailsContext"
    ),
    events = $.extend(
      {},
      order_updated,
      {
        OrderShippingInfoUpdate: "OrderShippingInfoUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxAddUnboundPaymentInstructionToThisOrder:
          "AjaxAddUnboundPaymentInstructionToThisOrder",
      },
      {
        AjaxDeleteUnboundPaymentInstructionFromThisOrder:
          "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      }
    );
  wcTopic.subscribe(events, function (e) {
    myWidgetObj.refreshWidget("refresh", myRCProperties),
      "OrderItemAddressShipMethodUpdate" != e.actionId &&
        (submitRequest(), cursor_wait());
  }),
    myWidgetObj.refreshWidget({
      renderContextChangedHandler: function () {
        wcRenderContext.testForChangedRC("traditionalShipmentDetailsContext", [
          "beginIndex",
        ]) && myWidgetObj.refreshWidget("refresh", myRCProperties);
      },
      postRefreshHandler: function () {
        resetRequest(),
          cursor_clear(),
          "true" == myRCProperties.initializeJS &&
            ($('input[id^="orderItem_"]').each(function (i, orderItem) {
              var initJS =
                "addReqListsJS" +
                orderItem.value +
                " = new AddToRequisitionListsJS(" +
                myRCProperties.storeId +
                "," +
                myRCProperties.catalogId +
                "," +
                myRCProperties.langId +
                ',"' +
                orderItem.value +
                'requisitionListContent","' +
                orderItem.value +
                'requisitionListSelect","' +
                orderItem.value +
                'createNewListMenu","' +
                orderItem.value +
                'listTypeMenu","' +
                orderItem.value +
                'newListNameInput","' +
                orderItem.value +
                'listType","' +
                orderItem.value +
                'productAdded","","AddToRequisitionListsJS' +
                orderItem.value +
                '");addReqListsJS' +
                orderItem.value +
                '.setCatEntryId("' +
                $(
                  "#catalogId_" +
                    orderItem.id.substring(orderItem.id.indexOf("_") + 1)
                ).val() +
                '");';
              eval(initJS);
            }),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval(t.innerHTML);
            }));
      },
    });
}

function declareShippingAddressSelectBoxAreaController() {
  var e = $("#shippingAddressSelectBoxArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressDropDownBoxContext",
    "shippingAddressSelectBoxArea"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "shippingAddressDropDownBoxContext"
    ),
    r = $.extend(
      {},
      address_updated,
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      },
      {
        AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
      }
    );
  wcTopic.subscribe(r, function (r) {
    r.actionId in address_updated
      ? (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        (selectedAddressId = r.data.addressId),
        (t.addressId = selectedAddressId),
        0 != CheckoutHelperJS.orderItemIds.length &&
          CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
            selectedAddressId[0]
          ),
        cursor_clear())
      : "AjaxUpdateOrderItemsAddressId" == r.actionId
      ? (e.refreshWidget("refresh", t), cursor_clear())
      : "AddBillingAddressInCheckOut" == r.actionId &&
        "ShippingAndBilling" == r.data.addBillingAddressInCheckOutAddressType &&
        document.getElementById("singleShipmentAddress") &&
        ((t.addressId = document.getElementById("singleShipmentAddress").value),
        e.refreshWidget("refresh", t),
        cursor_clear());
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus(),
          declareShippingAddressDisplayAreaController();
      },
    });
}

function declareCurrentOrderTotalsAreaController() {
  var e = $("#WC_ShipmentDisplay_div_18");
  wcRenderContext.addRefreshAreaId(
    "currentOrder_Context",
    "WC_ShipmentDisplay_div_18"
  );
  var t = wcRenderContext.getRenderContextProperties("currentOrder_Context"),
    r = $.extend(
      {},
      order_updated,
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
          "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      },
      {
        AjaxPrepareOrderForPaymentSubmit: "AjaxPrepareOrderForPaymentSubmit",
      }
    );
  wcTopic.subscribe(r, function (r) {
    e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        $("#discountDetailsSection").length &&
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").length &&
            $("#appliedPromotionCodes").css("display", "block");
      },
    });
}

function declareSingleShipmentShipChargeController() {
  var e = $("#WC_SingleShipmentDisplay_ShipCharge_Area");
  wcRenderContext.addRefreshAreaId(
    "singleShipmentShipChargeContext",
    "WC_SingleShipmentDisplay_ShipCharge_Area"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "singleShipmentShipChargeContext"
  );
  wcTopic.subscribe(["OrderItemAddressShipMethodUpdate"], function () {
    SBControllersDeclarationJS.shipChargeEnabled &&
      e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function declareBillingAddressSelectBoxAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  wcTopic.subscribe(
    [
      "AddBillingAddressInCheckOut",
      "UpdateBillingAddressInCheckout",
      "AjaxUpdateAddressForPerson",
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    ],
    function (e) {
      var s = t.attr("objectId"),
        a = r["billingAddress" + s];
      "" == r["paymentTCId" + s]
        ? t.refreshWidget("updateUrl", r["billingURL" + s])
        : t.refreshWidget(
            "updateUrl",
            r["billingURL" + s] + "&paymentTCId=" + r["paymentTCId" + s]
          ),
        -1 == r["billingAddress" + s]
          ? ((a = e.data.addressId),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            (r["billingAddress" + s] = a),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"))
          : 0 == r["billingAddress" + s]
          ? t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              paymentMethodSelected: r["payment" + s],
            })
          : (document.getElementById("singleShipmentAddress") &&
              ((shippingAddressId = document.getElementById(
                "singleShipmentAddress"
              ).value),
              (billingAddressId = document.getElementById(
                "billing_address_id_" + s
              ).value),
              shippingAddressId == billingAddressId &&
                s <= CheckoutPayments.numberOfPaymentMethods &&
                "AjaxAddAddressForPerson" != e.data.originalServiceId &&
                (a = e.data.addressId)),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"));
    }
  ),
    t.refreshWidget({
      renderContextChangedHandler: function () {
        var e = t.attr("objectId");
        if (
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "payment" + e,
          ]) ||
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "paymentTCId" + e,
          ])
        ) {
          "" == r["paymentTCId" + e]
            ? t.refreshWidget("updateUrl", r["billingURL" + e])
            : t.refreshWidget(
                "updateUrl",
                r["billingURL" + e] + "&paymentTCId=" + r["paymentTCId" + e]
              );
          var s = $("#billing_address_id_" + e).val();
          t.refreshWidget("refresh", {
            paymentAreaNumber: e,
            selectedAddressId: s,
            paymentMethodSelected: r["payment" + e],
          });
        }
      },
      postRefreshHandler: function () {
        var e = t.attr("objectId");
        CheckoutHelperJS.showHideEditBillingAddressLink(
          document.getElementsByName("billing_address_id")[e - 1],
          e
        ),
          cursor_clear();
        var r = CheckoutHelperJS.getLastAddressLinkIdToFocus();
        if (numAjaxRequests >= 0 && null != r && "undefined" != r && "" != r)
          if (null != document.getElementById(r))
            document.getElementById(r).focus();
          else {
            var s = r.split("_"),
              a = parseInt(s[s.length - 1]) + 1 + "";
            if (r.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
              var i = "WC_ShippingAddressSelectMultiple_link_2_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            } else {
              var i = "WC_ShippingAddressSelectMultiple_link_3_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            }
          }
        declareBillingAddressDisplayAreaController(
          "billingAddressDisplayArea_" + e
        );
      },
    });
}

function declareBillingAddressDisplayAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  t.refreshWidget({
    renderContextChangedHandler: function () {
      var s = r.areaNumber,
        a = e;
      if (
        wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
          "billingAddress" + s,
        ]) &&
        a.charAt(a.length - 1) == s
      ) {
        var i = r["billingAddress" + s];
        t.refreshWidget("refresh", {
          addressId: i,
        });
      }
    },
    postRefreshHandler: function () {
      var e = r.areaNumber;
      CheckoutHelperJS.showHideEditBillingAddressLink(
        document.getElementsByName("billing_address_id")[e - 1],
        e
      ),
        cursor_clear();
    },
  });
}

function declareOrderTotalController() {
  var e = $("#orderTotalAmountArea");
  wcRenderContext.addRefreshAreaId("paymentContext", "orderTotalAmountArea");
  var t =
    (wcRenderContext.getRenderContextProperties("paymentContext"),
    $.extend(
      {},
      order_updated,
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      }
    ));
  wcTopic.subscribe(t, function () {
    cursor_wait(), CheckoutPayments.getTotalInJSON();
  }),
    e.refreshWidget({
      postRefreshHandler: function (e) {
        cursor_clear();
      },
    });
}

function declarePaymentAreaController(e) {
  "object" == typeof e && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("paymentContext", e);
  var r = wcRenderContext.getRenderContextProperties("paymentContext"),
    s = e[e.length - 1];
  t.refreshWidget({
    renderContextChangedHandler: function () {
      r.currentPaymentArea == s &&
        (wcRenderContext.testForChangedRC("paymentContext", ["payment" + s]) ||
          wcRenderContext.testForChangedRC("paymentContext", [
            "paymentTCId" + s,
          ]) ||
          (wcRenderContext.testForChangedRC("paymentContext", ["piAmount"]) &&
            supportPaymentTypePromotions)) &&
        ("empty" == r["payment" + s]
          ? (viewName = "EmptySnippetView")
          : (viewName = paymentSnippetsURLMap[r["payment" + s]]),
        t.refreshWidget("updateUrl", viewName + paymentAreaUrlParam),
        supportPaymentTypePromotions
          ? 1 != CheckoutPayments.numberOfPaymentMethods
            ? t.refreshWidget("refresh", r)
            : 1 == CheckoutPayments.numberOfPaymentMethods &&
              2 > s &&
              t.refreshWidget("refresh", r)
          : t.refreshWidget("refresh", r));
    },
    postRefreshHandler: function () {
      if (!supportPaymentTypePromotions) {
        var e = $("#OrderTotalAmount").val();
        CheckoutPayments.updateAmountFields(e);
      }
      var t = "paymentArea" + s;
      TealeafWCJS.rebind(t);
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey:
          document.getElementsByName("billing_address_id")[s - 1].value,
        areaNumber: s,
      }),
        cursor_clear();
    },
  });
}

function declareShippingAddressDisplayAreaController() {
  var e = $("#shippingAddressDisplayArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressContext",
    "shippingAddressDisplayArea"
  );
  var t = wcRenderContext.getRenderContextProperties("shippingAddressContext");
  e.refreshWidget({
    renderContextChangedHandler: function () {
      if (
        wcRenderContext.testForChangedRC("shippingAddressContext", [
          "shippingAddress",
        ])
      ) {
        var r = t.shippingAddress;
        e.refreshWidget("refresh", {
          addressId: r,
        });
      }
      cursor_clear();
    },
  });
}

function declareEditShippingAdddressAreaController() {
  var e = $("#editShippingAddressArea1");
  wcRenderContext.addRefreshAreaId(
    "editShippingAddressContext",
    "editShippingAddressArea1"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "editShippingAddressContext"
    ),
    r = $.extend({}, address_updated, {
      UpdateBillingAddressInCheckout: "UpdateBillingAddressInCheckout",
    });
  wcTopic.subscribe(r, function (e) {
    2 == shipmentTypeId &&
      (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
      (selectedAddressId = e.data.addressId),
      CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
        selectedAddressId[0]
      ),
      cursor_clear());
  }),
    e.refreshWidget({
      renderContextChangedHandler: function () {
        if (
          wcRenderContext.testForChangedRC("editShippingAddressContext", [
            "shippingAddress",
          ])
        ) {
          var r = t.shippingAddress;
          t.shippingAddress = 0;
          var s = t.addressType;
          e.refreshWidget("refresh", {
            addressId: r,
            addressType: s,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear(),
          AddressHelper.loadStatesUI(
            "shopcartAddressForm",
            "",
            "stateDiv",
            "state",
            !0
          ),
          TealeafWCJS.rebind("centered_single_column_form");
      },
    });
}

function declareMultipleShipmentOrderDetailsRefreshArea() {
  var e = "WC_MultipleShipmentDisplay_div_18",
    t = "multipleShipmentDetailsContext";
  wcRenderContext.checkIdDefined(t) ||
    wcRenderContext.declare(t, [], {
      shipmentDetailsArea: "update",
    });
  var r = wcRenderContext.getRenderContextProperties(t),
    s = $("#" + e);
  wcRenderContext.addRefreshAreaId(t, e);
  var a = $.extend({}, order_updated, {
    AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
    AjaxDeleteOrderItemForShippingBillingPage:
      "AjaxDeleteOrderItemForShippingBillingPage",
    OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
    AjaxPrepareOrderForShipChargeUpdate: "AjaxPrepareOrderForShipChargeUpdate",
    OrderItemAddressShipInstructionsUpdate:
      "OrderItemAddressShipInstructionsUpdate",
    OrderItemAddressShipInstructionsUpdate1:
      "OrderItemAddressShipInstructionsUpdate1",
    AjaxAddUnboundPaymentInstructionToThisOrder:
      "AjaxAddUnboundPaymentInstructionToThisOrder",
    AjaxDeleteUnboundPaymentInstructionFromThisOrder:
      "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
  });
  wcTopic.subscribe(a, function (e) {
    CheckoutHelperJS.RequestShippingDateAction ||
    ("AddBillingAddressInCheckOut" == e.actionId &&
      "Billing" == e.addBillingAddressInCheckOutAddressType)
      ? (CheckoutHelperJS.RequestShippingDateAction = !1)
      : (s.refreshWidget("refresh", r), submitRequest(), cursor_wait());
  });
  var i = function () {
      wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
        s.refreshWidget("refresh", r);
    },
    n = function () {
      if (
        (resetRequest(),
        cursor_clear(),
        "true" == r.initializeJS &&
          ($('input[id^="orderItem_"]').each(function (e, t) {
            $.globalEval($("#addToRequisitionListScript_" + t.value).html());
            var r = "addReqListsJS" + t.value;
            $.globalEval(
              "if(typeof " +
                r +
                ' !== "undefined") {' +
                r +
                '.setCatEntryId("' +
                document.getElementById(
                  "catalogId_" + t.id.substring(t.id.indexOf("_") + 1)
                ).value +
                '");}'
            );
          }),
          $('div[id^="shoppingListScript_"]').each(function (e, t) {
            $.globalEval($(t).html());
          })),
        numAjaxRequests >= 0 &&
          null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus())
      )
        if (
          null !=
          document.getElementById(
            CheckoutHelperJS.getLastAddressLinkIdToFocus()
          )
        )
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus();
        else {
          var e = CheckoutHelperJS.getLastAddressLinkIdToFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
      else if ("" != CheckoutHelperJS.getLastFocus() && tabPressed) {
        if (
          ((tabPressed = !1),
          null != document.getElementById(CheckoutHelperJS.getLastFocus()))
        )
          document.getElementById(CheckoutHelperJS.getLastFocus()).focus();
        else {
          var e = CheckoutHelperJS.getLastFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
        CheckoutHelperJS.setLastFocus("");
      }
    };
  s.refreshWidget({
    renderContextChangedHandler: i,
    postRefreshHandler: n,
  });
}

function declareMultipleShipmentShipChargeRefreshArea() {
  var e = "multipleShipmentShipChargeContext",
    t = "WC_MultipleShipmentDisplay_ShipCharge_Area",
    r = $("#" + t);
  wcRenderContext.checkIdDefined(e) || wcRenderContext.declare(e, [], null);
  var s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(
      [
        "OrderItemAddressShipMethodUpdate",
        "AjaxDeleteOrderItemForShippingBillingPage",
      ],
      function (e) {
        SBControllersDeclarationJS.shipChargeEnabled &&
          ("OrderItemAddressShipMethodUpdate" == e.actionId &&
            r.refreshWidget("refresh", s),
          "AjaxDeleteOrderItemForShippingBillingPage" == e.actionId &&
            r.refreshWidget("refresh", s));
      }
    );
  var a = function () {
    cursor_clear();
  };
  r.refreshWidget({
    postRefreshHandler: a,
  });
}

function declareDOMEditShippingAdddressAreaController() {
  var e = "editShippingAddressContext",
    t = "editShippingAddressArea1",
    r = $("#" + t),
    s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(address_updated, function () {
      wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
        cursor_clear();
    }),
    r.refreshWidget({
      renderContextChangedHandler: function () {
        if (wcRenderContext.testForChangedRC(e, ["shippingAddress"])) {
          var t = s.shippingAddress;
          s.shippingAddress = 0;
          var a = s.addressType;
          r.refreshWidget("refresh", {
            addressId: t,
            addressType: a,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function nullCartTotalCookie(e) {
  setCookie("WC_CartTotal_" + e, null, {
    expires: -1,
    path: "/",
    domain: cookieDomain,
  });
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s),
      i = t[r].substr(s + 1);
    if (
      ((a = a.replace(/^\s+|\s+$/g, "")),
      (i = i.replace(/^\s+|\s+$/g, "")),
      i == e)
    ) {
      setCookie(a, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      });
      break;
    }
  }
}

function initializeInactivityWarning() {
  "G" != storeUserType &&
    0 != inactivityTimeout &&
    document.cookie.indexOf("WC_USERACTIVITY_") > 0 &&
    (null != inactivityTimeoutTracker && clearTimeout(inactivityTimeoutTracker),
    (inactivityTimeoutTracker = setTimeout(
      showInactivityWarningDialog,
      inactivityTimeout - inactivityWarningDialogBuffer
    )));
}

function showInactivityWarningDialog() {
  $("#inactivityWarningPopup").data("wc-WCDialog").open(),
    null != dialogTimeoutTracker && clearTimeout(dialogTimeoutTracker),
    (dialogTimeoutTracker = setTimeout(
      hideInactivityWarningDialog,
      inactivityWarningDialogDisplayTimer
    ));
}

function hideInactivityWarningDialog() {
  $("#inactivityWarningPopup").hide();
}

function resetServerInactivity() {
  $.post({
    url: getAbsoluteURL() + "Ping",
    success: function (e, t, r) {
      e.success
        ? initializeInactivityWarning()
        : console.error("Ping service failed");
    },
    error: function (e, t, r) {
      console.error("Ping service failed");
    },
  });
}

function byId(e) {
  return document.getElementById(e);
}

function focusSetter() {
  $("#MiniCartFocusReceiver1").length
    ? $("#MiniCartFocusReceiver1").focus()
    : $("#MiniCartFocusReceiver2").focus();
}

function determineFocus(e) {
  e.shiftKey &&
    e.keyCode === KeyCodes.TAB &&
    (e.srcElement
      ? "MiniCartFocusReceiver1" == e.srcElement.id
        ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
        : "MiniCartFocusReceiver2" == e.srcElement.id &&
          ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver1" == e.target.id
      ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver2" == e.target.id &&
        ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e)));
}

function destroyDialog(e) {
  void 0 == e && (e = "quick_cart_container");
  var t = $("#" + e).data("wc-WCDialog");
  t && t.destroy(),
    void 0 != e && "quick_cart_container" == e
      ? (dropDownDlg = null)
      : (productAddedDropDownDlg = null);
}

function loadLink(e) {
  document.location.href = e;
}

function clearSearchField() {
  (searchText = $("#SimpleSearchForm_SearchTerm").val()),
    searchText == $("#searchTextHolder").html()
      ? $("#SimpleSearchForm_SearchTerm").val("")
      : (document.getElementById("SimpleSearchForm_SearchTerm").select(),
        showAutoSuggestIfResults(),
        (autoSuggestHover = !1));
}

function fillSearchField() {
  "" == $("#SimpleSearchForm_SearchTerm").val() &&
    ((document.getElementById("SimpleSearchForm_SearchTerm").className =
      "search_input gray_color"),
    $("#SimpleSearchForm_SearchTerm").val($("#searchTextHolder").html())),
    autoSuggestHover || showAutoSuggest(!1);
}

function showDropDownMenu() {
  $("#header_menu_dropdown").css("display", "block"),
    $("#outerCartContainer").css("display", "block");
}

function cursor_wait(e) {
  var t = !0;
  1 == e && Utils.isOpera() && (t = !1),
    t && ENV_SHOWLOADER && setTimeout("showProgressBar()", 500);
}

function showProgressBar() {
  requestSubmitted && displayProgressBar();
}

function displayProgressBar() {
  var e = $("#progress_bar_dialog").data("wc-WCDialog");
  if (e) {
    var t = $("#progress_bar");
    t.css("display", "block"),
      "" !== this.currentId
        ? e.option("position", {
            my: "left top",
            at: "right top",
            of: $("#" + this.currentId),
          })
        : (t.css("left", ""), t.css("top", ""), e.element.html(t)),
      e.open(),
      setTimeout("cursor_clear()", 18e5);
  }
}

function setCurrentId(e) {
  requestSubmitted || "" !== this.currentId || (this.currentId = e);
}

function trim(e) {
  word = e.toString();
  for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
  for (; " " == word.charAt(r); ) r -= 1;
  return t > r ? word.substring(t, t) : word.substring(t, r + 1);
}

function cursor_clear() {
  //requestSubmitted = !1, wcTopic.publish("requestSubmittedChanged", requestSubmitted), showLoadingInternal(false, null);
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
  var e = $("#progress_bar_dialog").data("wc-WCDialog"),
    t = document.getElementById("progress_bar");
  null != e &&
    (null != t && $(t).css("display", "none"),
    e.close(),
    (this.currentId = ""));
}

function escapeXml(e, t) {
  return (
    t &&
      (e = e
        .replace(/&(?!(quot;|#34;|#034;|#x27;|#39;|#039;))/gm, "&amp;")
        .replace(/</gm, "&lt;")
        .replace(/>/gm, "&gt;")),
    (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
  );
}

function submitRequest() {
  return requestSubmitted
    ? !1
    : ((requestSubmitted = !0),
      wcTopic.publish("requestSubmittedChanged", requestSubmitted),
      !0);
}

function resetRequest() {
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
}

function setPageLocation(e) {
  submitRequest() && (document.location.href = e);
}

function submitSpecifiedForm(e) {
  submitRequest() &&
    (console.debug("form.action == " + e.action), processAndSubmitForm(e));
}

function getLocation(e) {
  var t = e;
  t.match(/^[a-zA-Z]+:\/\//) || (t = "http://" + t);
  var r = document.createElement("a");
  return (r.href = t), r;
}

function getReturnUrl(e) {
  var t,
    r = this.getLocation(decodeURIComponent(e));
  (t = r.hostname === location.hostname ? e : "about:blank"),
    (location.href = t);
}

function matchUrlProtocol(e) {
  if (!stringStartsWith(e, "http")) return e;
  var t = document.location.href,
    r = t.lastIndexOf("s", 4),
    s = e,
    a = s.lastIndexOf("s", 4);
  return (
    -1 != r && -1 == a
      ? (s = s.substring(0, 4) + "s" + s.substring(4))
      : -1 == r && -1 != a && (s = s.substring(0, 4) + s.substring(5)),
    s
  );
}

function hideElementById(e) {
  $("#" + e).css("display", "none");
}

function showElementById(e) {
  if (
    e == "billingAddressCreateEditFormDiv_1" &&
    (window.mobilecheck() || window.tabletPortraitCheck())
  ) {
    $("#" + e).css("display", "flex");
  } else {
    $("#" + e).css("display", "block");
  }
}

function hideBackgroundImage(e) {
  $(e).css("backgroundImage", "none");
}

function showBackgroundImage(e) {
  $(e).css(
    "backgroundImage",
    "url(" +
      getImageDirectoryPath() +
      getStyleDirectoryPath() +
      "product_hover_background.png)"
  );
}

function checkIE8Browser() {
  Utils.get_IE_version() &&
    Utils.get_IE_version() <= 8 &&
    (correctBrowser = !0);
}

function ApprovalToolLink(e, t) {
  return (
    checkIE8Browser(),
    correctBrowser
      ? void (RFQwindow = window.open(t))
      : void MessageHelper.formErrorHandleClient(
          e,
          MessageHelper.messages.ERROR_INCORRECT_BROWSER
        )
  );
}

function updateViewAndBeginIndexForCurrencyChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      ($("#SetCurrencyPreferenceForm")[0].URL.value =
        $("#SetCurrencyPreferenceForm")[0].URL.value +
        "&coshopChangeCurrency=" +
        $("#currencySelection").find(":selected").text());
  } catch (e) {
    console.log(e);
  }
}

function updateViewAndBeginIndexForLanguageChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      $("#LanguageSelectionForm").attr(
        "action",
        $("#LanguageSelectionForm").attr("action") +
          "&langId=" +
          $("#languageSelection").find(":selected").text()
      );
  } catch (e) {
    console.log(e);
  }
}

function showHeaderLinksInTwoLines() {
  $("#header_links").length &&
    ($("#header_links").width() > 750 &&
      ($("#header_links1").css("display", "block"),
      $("#headerHomeLink").css("display", "none"),
      $("#headerShopCartLink").css("display", "none")),
    $("#header_links").css("visibility", "visible"));
}

function showLinksInOneLine() {
  $("#header_links").css("visibility", "visible");
}

function isNonNegativeInteger(e) {
  var t = new RegExp(/^\d*$/);
  return null != e && "" !== e && t.test(e);
}

function isPositiveInteger(e) {
  return isNonNegativeInteger(e) && 0 != e;
}

function closeAllDialogs() {
  $("[data-widget-type='wc.WCDialog']").each(function (e, t) {
    $(t).hide();
  });
}

function setWarningMessageCookie(e) {
  setCookie("signon_warning_cookie", e, {
    path: "/",
    domain: cookieDomain,
  });
}

function removeCookie(e) {
  setCookie(e, null, {
    expires: -1,
  });
}

function getCookie(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), a == e))
      return decodeURIComponent(t[r].substr(s + 1));
  }
}

function deleteOnBehalfRoleCookie() {
  var e = getCookie("WC_OnBehalf_Role_" + WCParamJS.storeId);
  null != e &&
    setCookie("WC_OnBehalf_Role_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    });
}

function getCookieName_BeginningWith(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), stringStartsWith(a, e))) return a;
  }
}

function stringStartsWith(e, t) {
  return t.length > 0 && e.substring(0, t.length) === t;
}

function isStorePreview(e, t) {
  return e.indexOf(t) > -1;
}

function hideESpotInfoPopup(e, t) {
  if (null == t || "keypress" != t.type || t.keyCode === KeyCodes.ESCAPE) {
    var r = $("#" + e);
    r.length && r.data("wc-WCDialog").close();
  }
}

function showESpotInfoPopup(e, t) {
  if (
    (null == t || "keypress" != t.type || t.keyCode === KeyCodes.RETURN) &&
    parent.checkPopupAllowed()
  ) {
    var r = $("#" + e).data("wc-WCDialog");
    r &&
      (r.bringToFront(),
      r.bringToFront($(".ESpotInfo")),
      r.open(),
      r.reposition());
  }
}

function incrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && numAjaxRequests++;
}

function decrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && 0 != numAjaxRequests && numAjaxRequests--;
}

function updateParamObject(e, t, r, s, a) {
  if ((null == e && (e = []), null != e[t] && s))
    if ($.isArray(e[t])) null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
    else {
      var i = e[t];
      (e[t] = []), e[t].push(i), e[t].push(r);
    }
  else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
  else if (-1 == a) {
    for (var n = 1; null != e[t + "_" + n]; ) n++;
    e[t + "_" + n] = r;
  } else e[t] = r;
  return e;
}

function showSection(e) {
  $("#" + e).css("visibility", "visible");
}

function hideSection(e) {
  $("#" + e).css("visibility", "");
}

function shiftTabHideSection(e, t) {
  t.shiftKey && t.keyCode === KeyCodes.TAB && hideSection(e);
}

function tabHideSection(e, t, r) {
  t.shiftKey ||
    t.keyCode !== KeyCodes.TAB ||
    (null != r && $("#" + r).focus(), hideSection(e), Utils.stopEvent(t));
}

function saveShiftTabPress(e) {
  1 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function saveTabPress(e) {
  0 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function setFocus(e) {
  tabPressed && ((tabPressed = !1), document.getElementById(e).focus());
}

function increaseHeight(e, t) {
  var r = document.getElementById(e).offsetHeight;
  $("#" + e).css("height", r + t + "px");
}

function redirectToSignOn(e) {
  var t = "Header_GlobalLogin";
  setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
    path: "/",
    domain: cookieDomain,
  }),
    GlobalLoginJS.InitHTTPSecure(t);
}

function handlePopup(e, t) {
  currentPopup == t ? (document.location.href = e) : (currentPopup = t);
}

function isAndroid() {
  if (null == android && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    android = e.indexOf("android") > -1;
  }
  return android;
}

function isIOS() {
  if (null == ios && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    ios =
      e.indexOf("ipad") > -1 ||
      e.indexOf("mac") > -1 ||
      e.indexOf("iphone") > -1 ||
      e.indexOf("ipod") > -1;
  }
  return ios;
}

function outlineSpots() {
  $(document.body).addClass("editMode"),
    $(".carousel > .content").css("zIndex", "auto"),
    $(".ESpotInfo").css("display", "block"),
    $(".searchScore").css("display", "block"),
    $(".editManagedContent").css("display", "block"),
    $(
      ".genericESpot,.product,.searchResultSpot,.productDetail,.categorySpot"
    ).each(function (e, t) {
      if ($(t).hasClass("emptyESpot")) {
        var r = $(".ESpotInfo", t)[0].offsetWidth + 4,
          s = $(".ESpotInfo", t)[0].offsetHeight + 4;
        $(t).attr("_width", $(t).css("width")),
          $(t).attr("_height", $(t).css("height")),
          $(t).css({
            width: +r + "px",
            height: s + "px",
          });
      }
      $(".borderCaption").length
        ? $(t).prepend("<div class='borderCaption'></div>")
        : $(".borderCaption", t).css({
            display: "block",
          }),
        t.addEventListener
          ? (t.addEventListener(
              "mouseover",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", this).first().css({
                    display: "block",
                  }),
                  e.stopPropagation());
              },
              !1
            ),
            t.addEventListener(
              "mouseout",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", this).css({
                    display: "none",
                  }),
                  e.stopPropagation());
              },
              !1
            ))
          : t.attachEvent &&
            ((t.onmouseover = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", e).first().css({
                    display: "block",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)),
            (t.onmouseleave = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", e).css({
                    display: "none",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)));
    });
}

function hideSpots() {
  $(document.body).removeClass("editMode"),
    $(".carousel > .content").css("zIndex", ""),
    $(".ESpotInfo").css("display", "none"),
    $(".caption").css("display", "none"),
    $(".searchScore").css("display", "none"),
    $(".editManagedContent").css("display", "none"),
    $(".borderCaption").css("display", "none"),
    $(".emptyESpot").each(function (e, t) {
      $(t).css({
        width: $(t).attr("_width") + "px",
      }),
        $(t).css({
          height: $(t).attr("_height") + "px",
        });
    });
}

function logout(e) {
  setDeleteCartCookie(),
    setCookie("WC_FIRST_SESSION_POPUP_" + storeDirectory, "false", {
      path: "/",
      domain: cookieDomain,
    }),
    (document.location.href = e);
}

function switchLanguageCurrency(e) {
  var t = document.location.href,
    r = "/" + $("#currentLanguageSEO").val() + "/";
  if (
    (-1 !== t.indexOf("SearchDisplay") ||
      -1 !== t.indexOf("CategoryDisplay")) &&
    -1 !== t.indexOf("#")
  ) {
    var s = t.split("#");
    t = s[0];
  }
  var a = t;
  if (
    -1 !== t.indexOf(r) &&
    document.getElementById(
      "langSEO" +
        document.getElementById("languageSelection").options[
          document.getElementById("languageSelection").selectedIndex
        ].value
    )
  ) {
    var i =
      "/" +
      document.getElementById(
        "langSEO" +
          document.getElementById("languageSelection").options[
            document.getElementById("languageSelection").selectedIndex
          ].value
      ).value +
      "/";
    a = t.replace(r, i);
  }
  if (-1 !== a.indexOf("&")) {
    var n = a.split("&");
    a = "";
    for (var o = 0; o < n.length; o++)
      -1 === n[o].indexOf("langId=")
        ? (a = "" === a ? n[o] : a + "&" + n[o])
        : n[o].indexOf("langId=") > 0 &&
          (0 == o
            ? (a = n[0].substring(0, n[0].indexOf("langId=")))
            : (a += "&"),
          (a =
            a +
            "langId=" +
            document.getElementById("languageSelection").options[
              document.getElementById("languageSelection").selectedIndex
            ].value));
  }
  (a = switchLanguageCurrencyFilter(a)),
    (document.forms[e].URL.value = a),
    (document.forms[e].languageSelectionHidden.value =
      document.getElementById("languageSelection").options[
        document.getElementById("languageSelection").selectedIndex
      ].value),
    $("#widget_language_and_currency_popup").data("wc-WCDialog").close(),
    "function" == typeof changeStoreViewLanguage &&
      changeStoreViewLanguage(document.forms[e].languageSelectionHidden.value),
    document.getElementById(e).submit();
}

function switchLanguageCurrencyFilter(e) {
  var t = [],
    r = [
      {
        key: "registerNew",
        value: "Y",
      },
    ];
  t.push({
    exclude: "UserRegistrationAdd",
    replace: "UserRegistrationForm",
    param: r,
  });
  for (var s = 0; s < t.length; s++)
    if (e.indexOf(t[s].exclude) > 0) {
      if (((e = e.replace(t[s].exclude, t[s].replace)), void 0 != t[s].param))
        for (var a = t[s].param, i = 0; i < a.length; i++)
          e = appendToURL(e, a[i].key, a[i].value, !1);
      break;
    }
  return e;
}

function isParameterExcluded(e, t) {
  try {
    if ("object" == typeof URLConfig)
      if ("object" == typeof URLConfig.excludedURLPatterns)
        for (var r in URLConfig.excludedURLPatterns) {
          var s = URLConfig.excludedURLPatterns[r],
            a = r;
          if (
            "object" == typeof s &&
            (s.urlPattern && (a = s.urlPattern),
            console.debug("URL pattern to match : " + a),
            (a = new RegExp(a)),
            e.match(a))
          ) {
            var i = s.excludedParameters;
            for (var n in i) if (parametername == n) return !0;
          }
        }
      else console.debug("The parameter " + t + " is not excluded");
    else console.debug("No URLConfig defined.");
  } catch (o) {
    console.debug("An error occured while trying to exclude " + o);
  }
  return !1;
}

function appendToURL(e, t, r, s) {
  s = null == s ? !1 : s;
  var a = new RegExp(t + "=[^&]+"),
    i = t + "=" + r;
  return (
    -1 !== e.indexOf(i) ||
      (!a.test(e) || s
        ? ((e += -1 === e.indexOf("?") ? "?" : "&"), (e += i))
        : (e = e.replace(a, i))),
    e
  );
}

function appendWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      isParameterExcluded(e, r) ||
        (e = appendToURL(e, r, wcCommonRequestParameters[r], t));
  return e;
}

function updateFormWithWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      if (
        void 0 !== e.action &&
        null !== e.action &&
        !isParameterExcluded(e.action, r)
      ) {
        var s = !1;
        $("input[name='" + r + "']", e).each(function (a, i) {
          i.value == wcCommonRequestParameters[r]
            ? (s = !0)
            : t || e.removeChild(i);
        }),
          s ||
            ("get" == e.method
              ? $("<input></input>", {
                  name: r,
                  type: "hidden",
                  value: wcCommonRequestParameters[r],
                }).appendTo(e)
              : (e.action = appendToURL(
                  e.action,
                  r,
                  wcCommonRequestParameters[r],
                  t
                )));
      }
}

function addAuthToken(e) {
  try {
    return (
      $("#csrf_authToken").length
        ? $("<input></input>", {
            name: "authToken",
            type: "hidden",
            value: $("#csrf_authToken").val(),
          }).appendTo(e)
        : console.debug("auth token is missing from the HTML DOM"),
      !0
    );
  } catch (t) {
    console.debug(
      "An error occured while trying to add authToken to the form..." + t
    );
  }
  return !1;
}

function processAndSubmitForm(e) {
  updateFormWithWcCommonRequestParameters(e), addAuthToken(e), e.submit();
}

function getCommonParametersQueryString() {
  return (
    "storeId=" +
    WCParamJS.storeId +
    "&langId=" +
    WCParamJS.langId +
    "&catalogId=" +
    WCParamJS.catalogId
  );
}

function getFinalViewURL(e) {
  var t = e.indexOf("finalView");
  if (-1 != t) {
    var r = e.indexOf("&", t);
    if (-1 == r) var s = e.substring(t + 10);
    else var s = e.substring(t + 10, r);
    var a = e.indexOf("?"),
      i = e.substring(a + 1, t);
    if (-1 == r) var n = "";
    else var n = e.substring(r);
    "&" == i.charAt(i.length - 1) && (i = i.substring(0, i.length - 1)),
      "&" == i.charAt(0) && (i = i.substring(1)),
      "&" == n.charAt(n.length - 1) && (n = n.substring(0, n.length - 1)),
      "&" == n.charAt(0) && (n = n.substring(1));
    var o = "";
    return (
      "" !== i
        ? ((o = s + "?" + i), "" !== n && (o = o + "&" + n))
        : (o = s + "?" + n),
      o
    );
  }
  return "";
}

function invokeItemAdd(e) {
  wcService.getServiceById("MyAcctAjaxAddOrderItem").url = e;
  var t = [];
  (t.PasswordRequestAuthenticated = "TRUE"),
    submitRequest() &&
      (cursor_wait(),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      wcService.invoke("MyAcctAjaxAddOrderItem", t));
}

function invokeOtherService(e) {
  wcService.getServiceById("MyAcctGenericService").url = e;
  var t = {
    PasswordRequestAuthenticated: "TRUE",
  };
  submitRequest() &&
    (cursor_wait(),
    setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    }),
    wcService.invoke("MyAcctGenericService", t));
}

function setCookie(e, t, r) {
  var s = function (e, t, r) {
    r || (r = {});
    var s = r.expires;
    if (s) {
      if ("number" == typeof s) {
        var a = new Date();
        a.setTime(a.getTime() + 24 * s * 60 * 60 * 1e3), (s = a);
      }
      s.toUTCString ? (r.expires = s.toUTCString()) : (r.expires = s);
    }
    t = encodeURIComponent(t);
    var i = e + "=" + t;
    for (var e in r) {
      i += "; " + e;
      var n = r[e];
      n !== !0 && (i += "=" + n);
    }
    document.cookie = i;
  };
  if (r) {
    var a = r;
    for (var i in a) a[i] || delete a[i];
    s(e, t, a);
  } else s(e, t);
}

function getBaseTextDir() {
  var e = getCookie(_BTD_PREFS);
  return e ? e : "";
}

function setBaseTextDir(e) {
  var t = getCookie(_BTD_PREFS);
  t != e && setCookie(_BTD_PREFS, e.toLowerCase());
}

function isRTLValue(e) {
  for (var t in e) {
    if (isBidiChar(e.charCodeAt(t))) return !0;
    if (isLatinChar(e.charCodeAt(t))) return !1;
  }
  return !1;
}

function isBidiChar(e) {
  return e >= 1488 && 1535 >= e
    ? !0
    : e >= 1536 && 1631 >= e
    ? !0
    : e >= 1642 && 1775 >= e
    ? !0
    : e >= 1786 && 2047 >= e
    ? !0
    : e >= 64285 && 65023 >= e
    ? !0
    : e >= 65136 && 65276 >= e
    ? !0
    : !1;
}

function isLatinChar(e) {
  return (e > 64 && 91 > e) || (e > 96 && 123 > e) ? !0 : !1;
}

function resolveBaseTextDir(e, t) {
  return "auto" == t ? (isRTLValue(e) ? "rtl" : "ltr") : t;
}

function handleTextDirection(e) {
  var t = getBaseTextDir();
  null != e &&
    "" !== t &&
    ["INPUT", "TEXTAREA"].indexOf(e.tagName) > -1 &&
    $(e).css("direction", resolveBaseTextDir(e.value, t));
}

function enforceTextDirectionOnPage() {
  var e = getBaseTextDir();
  "" !== e &&
    $(".bidiAware").each(function (t, r) {
      r.dir = $(r).css(
        "direction",
        resolveBaseTextDir(r.value || r.text || r.outerText || r.innerHTML, e)
      );
    });
}

function commonServiceFailureHandler(e) {
  e.errorMessage
    ? MessageHelper.displayErrorMessage(e.errorMessage)
    : e.errorMessageKey && MessageHelper.displayErrorMessage(e.errorMessageKey),
    cursor_clear();
}

function isChrome() {
  return (
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  );
}

function successHandlerForURLChainingService(e) {
  if (
    (console.debug("Success Handler of AjaxCustomServiceForURLChaining", e),
    null != this.postRefreshHandlerParameters &&
      "" !== this.postRefreshHandlerParameters)
  ) {
    var t = "";
    (nextServiceURLObject = this.postRefreshHandlerParameters.splice(0, 1)[0]),
      console.debug("nextServiceURLObject ", nextServiceURLObject);
    if (
      null != nextServiceURLObject &&
      "undefined" != typeof nextServiceURLObject
    ) {
      var t = nextServiceURLObject.URL,
        r = nextServiceURLObject.requestType,
        s = nextServiceURLObject.requestParams;
      console.debug("nextServiceURL ", t),
        console.debug("requestType ", r),
        console.debug("requestParams ", s);
    }
    if ("" !== t)
      if ("GET" == r) {
        -1 === t.indexOf("?") &&
          (t = t + "?" + getCommonParametersQueryString());
        for (var a in s) t = t + "&" + a + "=" + s[a];
        document.location.href = t;
      } else {
        var i = getCustomServiceForURLChaining(
          t,
          this.postRefreshHandlerParameters
        );
        wcService.invoke(i.getParam("id"), s);
      }
    else
      console.debug(
        "End of URL chaining with AjaxCustomServiceForURLChaining service"
      );
  }
}

function getCustomServiceForURLChaining(e, t, r) {
  var s = wcService.getServiceById("AjaxCustomServiceForURLChaining");
  return (
    (null == s || void 0 == s) &&
      (console.debug("Start creating AjaxCustomServiceForURLChaining"),
      wcService.declare({
        id: "AjaxCustomServiceForURLChaining",
        actionId: "AjaxCustomServiceForURLChaining",
        url: "",
        formId: "",
        successHandler: successHandlerForURLChainingService,
        failureHandler: commonServiceFailureHandler,
      }),
      (s = wcService.getServiceById("AjaxCustomServiceForURLChaining"))),
    null != e &&
      "undefined" != e &&
      (stringStartsWith("url", "http")
        ? s.setUrl(e)
        : s.setUrl(getAbsoluteURL() + e)),
    null != t && "undefined" != t
      ? s.setParam("postRefreshHandlerParameters", t)
      : s.setParam("postRefreshHandlerParameters", null),
    null != r && "undefined" != r ? s.setFormId(r) : s.setFormId(null),
    console.debug("Return AjaxCustomServiceForURLChaining", s),
    s
  );
}

function declareDeptDropdownRefreshArea(e) {
  wcRenderContext.declare("departmentSubMenuContext", [e], {
    targetId: "",
  });
  var t = function () {
      $("#" + e).refreshWidget(
        "refresh",
        wcRenderContext.getRenderContextProperties("departmentSubMenuContext")
      );
    },
    r = function () {
      updateDepartmentsMenu(),
        activate(
          document.getElementById(
            wcRenderContext.getRenderContextProperties(
              "departmentSubMenuContext"
            ).targetId
          )
        ),
        cursor_clear();
    };
  $("#" + e).refreshWidget({
    renderContextChangedHandler: t,
    postRefreshHandler: r,
  });
}

function ShoppingListJS(
  storeParams,
  catEntryParams,
  shoppingListNames,
  jsObjectName
) {
  (this.storeParams = storeParams),
    (this.catEntryParams = catEntryParams),
    (this.catEntryParams.quantity = 1),
    (this.shoppingListNames = shoppingListNames),
    (this.addItemAfterCreate = !1),
    (this.jsObjectName = jsObjectName),
    (this.dropDownVisible = !1),
    (this.dropDownInFocus = !1),
    (this.dropDownOpen = !1),
    (this.exceptionFlag = !1),
    (this.mouseOnArrow = !1),
    (this.pageName = ""),
    (this.itemId = -1);
  var eventName = "";
  (this.nameToDelete = ""),
    (this.orderItemId = ""),
    (this.actionBeingPerformed = ""),
    "shoppingListJS" != jsObjectName &&
      ((this.pageName = jsObjectName.replace("shoppingListJS", "")),
      (eventName = this.pageName + "_")),
    (this.setCatEntryQuantity = function (e) {
      var e = $.parseJSON(e);
      if ($.isPlainObject(e)) {
        var t = this.catEntryParams.components[e.baseItemId];
        t.id != e.baseItemId && 0 != e.id && (t.id = e.id),
          (t.quantity = e.quantity);
      } else this.catEntryParams.quantity = e;
    }),
    (this.setCatEntryAttributes = function (e) {
      this.catEntryParams.attributes = $.parseJSON(e);
    }),
    (this.setItemId = function (e) {
      this.itemId = e;
    }),
    (this.hideDropDown = function () {
      var e = $("#" + this.pageName + "shoppingListDropDown");
      if (e) {
        $(e).css("display", "none"),
          $("#" + this.pageName + "addToShoppingListBtn .drop")
            .first()
            .focus(),
          (this.dropDownVisible = !1),
          (this.dropDownInFocus = !1),
          (this.dropDownOpen = !1);
        var t = $(".widget_quick_info_popup .content_right_border").first();
        void 0 != t && $(t).css("height", "auto");
      }
    }),
    (this.showDropDown = function () {
      if (0 == this.dropDownOpen) {
        var e = $(".widget_quick_info_popup .content_right_border").first(),
          t = ($(e).height(), "#" + this.pageName + "shoppingListDropDown");
        if (
          ($(t).css("display", ""),
          (this.dropDownVisible = !0),
          $(
            "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
          ).removeClass("focused"),
          $("#quickInfoRefreshArea") && $("#QuickInfoshoppingListDropDown"))
        ) {
          $("#quickInfoRefreshArea").height(),
            $("QuickInfoshoppingListDropDown").height(),
            $(e).height();
        }
        this.dropDownOpen = !0;
      } else this.hideDropDown();
    }),
    (this.showPopup = function (e) {
      this.hideDropDown(), this.clearPopupText();
      var t = $("#" + this.pageName + e + "ShoppingListPopup").data(
          "wc-WCDialog"
        ),
        r = $("#" + this.pageName + "newListName");
      t.option("close_on_primary_click", !1),
        this.hideErrorMessage(),
        this.hideEditErrorMessage(),
        t
          ? (closeAllDialogs(),
            t.close(),
            setTimeout(function () {
              t.open(),
                "create" === e
                  ? $(r).focus()
                  : "edit" === e && $("#editListName").focus();
            }, 250))
          : console.debug(e + "ShoppingListPopup does not exist");
    }),
    (this.showSuccessDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e &&
        "" !== this.actionBeingPerformed &&
        ($("#" + this.pageName + "successMessageAreaText").html(
          Utils.getLocalizationMessage("LIST_CREATED")
        ),
        e.open(),
        (this.actionBeingPerformed = ""));
    }),
    (this.showMessageDialog = function (e) {
      var t = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      t &&
        ($("#" + this.pageName + "successMessageAreaText").html(e), t.open());
    }),
    (this.hideMessageDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e && e.close();
    }),
    (this.showErrorMessage = function (e) {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideErrorMessage = function () {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.showEditErrorMessage = function (e) {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideEditErrorMessage = function () {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.create = function () {
      var e = trim($("#" + this.pageName + "newListName").val()),
        t = $("#" + this.pageName + "newListName").maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_EMPTY"));
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          if (((s.name = e), !submitRequest())) return;
          cursor_wait(),
            wcService.invoke("ShoppingListServiceCreate", s),
            (this.actionBeingPerformed = "create");
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_TOOLONG"));
    }),
    (this.createDefaultListAndAddItem = function (e, t, r) {
      if ((t && "" != t && (this.orderItemId = t), "-1" == e)) {
        var s = this.setCommonParams();
        if (
          ((s.name = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")),
          !submitRequest())
        )
          return;
        cursor_wait(),
          (this.addItemAfterCreate = !0),
          wcService.invoke("ShoppingListServiceCreate", s);
      } else
        t && "" != t ? this.addToListAndDelete(e, t, r) : this.addToList(e, r);
    }),
    (this.addToList = function (e, t) {
      this.hideDropDown();
      var r = this.setCommonParams();
      r.giftListId = e;
      var s = this.catEntryParams.id;
      if (
        "itembean" == this.catEntryParams.type.toLowerCase() ||
        "packagebean" == this.catEntryParams.type.toLowerCase() ||
        "preddynakitbean" == this.catEntryParams.type.toLowerCase() ||
        "dynamickitbean" == this.catEntryParams.type.toLowerCase()
      )
        updateParamObject(r, "catEntryId", this.catEntryParams.id, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      else if ("bundlebean" == this.catEntryParams.type.toLowerCase()) {
        var a = !0;
        for (baseItemId in this.catEntryParams.components)
          if (
            this.catEntryParams.components[baseItemId].skus &&
            this.catEntryParams.components[baseItemId].skus.length > 1
          ) {
            var i = this.catEntryParams.components[baseItemId].resolved;
            if (null == i || "undefined" == i || 0 == i) {
              a = !1;
              break;
            }
          }
        if (!a)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        for (baseItemId in this.catEntryParams.components)
          updateParamObject(
            r,
            "catEntryId",
            this.catEntryParams.components[baseItemId].id,
            !1,
            -1
          ),
            updateParamObject(
              r,
              "quantity",
              this.catEntryParams.components[baseItemId].quantity,
              !1,
              -1
            );
      } else {
        var n = this.itemId;
        if ((-1 == n && (n = this.resolveSKU()), -1 == n))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        (s = n),
          updateParamObject(r, "catEntryId", n, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      }
      "shoppingListJS" != this.jsObjectName && QuickInfoJS.close(),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: s,
            thumbnail: "imgPath",
            focusElement: t,
          }),
          wcService.invoke("ShoppingListServiceAddItem", r));
    }),
    (this.isDuplicate = function (e) {
      var e = this.escapeXml(e, !0);
      return 1 == this.shoppingListNames[e.toUpperCase()];
    }),
    (this.updateDefaultListId = function (e) {
      (this.shoppingListNames[
        Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
      ] = 1),
        $("#" + this.pageName + "addToShoppingList") &&
          $("#" + this.pageName + "addToShoppingList").attr(
            "href",
            '"javascript:" + this.jsObjectName + ".createDefaultListAndAddItem(" + listId + ");"'
          );
    }),
    (this.updateShoppingList = function (e, t, r) {
      var s = this.escapeXml(t, !1);
      (this.shoppingListNames[s.toUpperCase()] = 1),
        !r ||
          ("edit" != r && "delete" != r) ||
          (this.shoppingListNames[this.nameToDelete.toUpperCase()] = -1);
      var a = $("#" + this.pageName + "ShoppingListDivider");
      if (a) {
        var i = "javascript: this.className = 'created_list';";
        if (-1 == this.pageName.indexOf("OI"))
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        else {
          var n = this.pageName.replace("OI", "");
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        }
      }
    }),
    (this.clearPopupText = function () {
      $("#" + this.pageName + "newListName").val("");
    }),
    (this.escapeXml = function (e, t) {
      return (
        t &&
          (e = e
            .replace(/&/gm, "&amp;")
            .replace(/</gm, "&lt;")
            .replace(/>/gm, "&gt;")),
        (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
      );
    }),
    (this.resolveSKU = function () {
      if (1 == this.catEntryParams.skus.length)
        return this.catEntryParams.skus[0].id;
      for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
        var e = 0,
          t = 0;
        for (attribute in this.catEntryParams.skus[idx].attributes) {
          if (
            (t++,
            !this.catEntryParams.attributes ||
              this.catEntryParams.skus[idx].attributes[attribute] !=
                this.catEntryParams.attributes[attribute])
          )
            break;
          e++;
        }
        if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
      }
      return -1;
    }),
    (this.setCommonParams = function () {
      var e = {};
      return (
        (e.storeId = this.storeParams.storeId),
        (e.catalogId = this.storeParams.catalogId),
        (e.langId = this.storeParams.langId),
        e
      );
    }),
    (this.empty = function (e) {
      return null == e || void 0 == e || "" == e;
    }),
    (this.redirectToSignOn = function () {
      var e = document.location.href,
        t = "Header_GlobalLogin";
      setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
        path: "/",
        domain: cookieDomain,
      }),
        GlobalLoginJS.InitHTTPSecure(t);
    }),
    (this.focusList = function (e) {
      this.focusListByElementId(this.pageName + "ShoppingList_" + e);
    }),
    (this.focusListByElementId = function (e) {
      $("#" + e).hasClass("focused") ||
        $("#" + e.replace("ShoppingList", "ShoppingListLink")).focus();
    }),
    (this.focusListLink = function (e) {
      $(
        "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
      ).removeClass("focused"),
        $("#" + this.pageName + "ShoppingList_" + e).addClass("focused");
    }),
    (this.updateShoppingListAndAddItem = function (e) {
      e.listName == Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
        ? this.updateDefaultListId(e.listId)
        : this.updateShoppingList(e.listId, e.listName, e.action),
        this.addItemAfterCreate
          ? ((this.addItemAfterCreate = !1),
            "" != this.orderItemId
              ? this.addToListAndDelete(e.listId, this.orderItemId)
              : this.addToList(e.listId))
          : "add" == e.action && this.showSuccessDialog();
    }),
    (this.navigateDropDown = function (e) {
      var t = this;
      if (e.keyCode === KeyCodes.UP_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (0 == e
              ? t.focusListByElementId($(s).get(s.length - 1).id)
              : t.focusListByElementId($(s).get(e - 1).id),
            (r = !0));
        });
      } else if (e.keyCode === KeyCodes.DOWN_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (s.length - 1 == e
              ? t.focusListByElementId($(s).get(0).id)
              : t.focusListByElementId($(s).get(e + 1).id),
            (r = !0));
        });
      } else
        (e.keyCode === KeyCodes.ESCAPE || e.keyCode === KeyCodes.TAB) &&
          (Utils.stopEvent(e), this.hideDropDown());
    }),
    (this.hideIfNoFocus = function () {
      !this.dropDownVisible ||
        this.dropDownInFocus ||
        this.mouseOnArrow ||
        this.hideDropDown();
    }),
    (this.hasFocus = function (e) {
      $(document).on("contextmenu", function (e) {
        1 == e.which
          ? (this.dropDownInFocus = !0)
          : (this.dropDownInFocus = !1);
      });
    }),
    (this.edit = function () {
      var e = trim($("#editListName").val()),
        t = e.maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_EMPTY")
        );
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          s.name = e;
          var a = $("#multipleWishlistController_select");
          if (
            (null != a &&
              "undefined" != a &&
              0 != a.value &&
              ((s.giftListId = $("#multipleWishlistController_select").val()),
              (this.nameToDelete = $(
                "#multipleWishlistController_select options:dropdown.selectedIndex"
              ).text())),
            $("#editShoppingListPopup").data("wc-WCDialog").close(),
            !submitRequest())
          )
            return;
          cursor_wait(), wcService.invoke("ShoppingListServiceUpdate", s);
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_TOOLONG")
        );
    }),
    (this.deleteList = function () {
      var e = this.setCommonParams(),
        t = $("#multipleWishlistController_select");
      null != t &&
        "undefined" != t &&
        0 != t.value &&
        ((e.giftListId = $("#multipleWishlistController_select").val()),
        (this.nameToDelete = $(
          "#multipleWishlistController_select options:dropdown.selectedIndex"
        ).text())),
        $("#deleteShoppingListPopup").data("wc-WCDialog").close(),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("ShoppingListServiceDelete", e));
    }),
    (this.refreshLinkState = function () {
      var e = $("#multipleWishlistController_select")[0];
      if (null != e) {
        var t = $("#multipleWishlistController_select")[0].options[
            e.selectedIndex
          ].text,
          r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
        t == r
          ? ($("#editDivider").css("display", "none"),
            $("#edit_popup_link").css("display", "none"),
            $("#deleteDivider").css("display", "none"),
            $("#delete_popup_link").css("display", "none"))
          : ($("#editDivider").css("display", "block"),
            $("#edit_popup_link").css("display", "block"),
            $("#deleteDivider").css("display", "block"),
            $("#delete_popup_link").css("display", "block"));
      }
    }),
    (this.addToListAndDelete = function (e, t, r) {
      (this.orderItemId = t),
        wcTopic.publish("modelChanged/AnalyticsConversionEvent"),
        this.hideDropDown();
      var s = this.setCommonParams();
      (s.giftListId = e),
        (s.catEntryId_1 = this.catEntryParams.id),
        (s.quantity_1 = 1),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: this.catEntryParams.id,
            name: this.catEntryParams.name,
            image: this.catEntryParams.image,
            thumbnail: "imgPath",
            focusElement: r,
          }),
          wcService.invoke("ShoppingListServiceAddItemAndRemoveFromCart", s));
    }),
    (this.deleteItemFromCart = function () {
      if ("" != this.orderItemId) {
        var e = this.orderItemId;
        (this.orderItemId = ""),
          "" != e && CheckoutHelperJS.deleteFromCart(e, !0);
      }
    }),
    (this.validateWishName = function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += " '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    }),
    (this.setResolved = function (e, t) {
      this.catEntryParams.components[e].resolved = t;
    }),
    $(document.documentElement).on("mousedown", $.proxy("hideIfNoFocus", this));
  for (baseItemId in this.catEntryParams.components)
    wcTopic.subscribe(
      "DefiningAttributes_Resolved_" + baseItemId,
      function (catEntryId, productId) {
        eval(jsObjectName + ".setResolved('" + productId + "', true)");
      }
    ),
      wcTopic.subscribe(
        "DefiningAttributes_Changed_" + baseItemId,
        function (catEntryId, productId) {
          0 == catEntryId &&
            eval(jsObjectName + ".setResolved('" + productId + "', false)");
        }
      );
}
if (
  (("undefined" != typeof analyticsJS &&
    analyticsJS &&
    analyticsJS.topicNamespace) ||
    (analyticsJS = {
      storeId: 0,
      catalogId: 0,
      urlPath: null,
      miniShopCartTitle: "MiniShoppingCart",
      jsonPageView: "AnalyticsPageView",
      jsonProductView: "AnalyticsProductView",
      jsonElementView: "AnalyticsElementView",
      jsonShopcartView: "AnalyticsShopcartView",
      jsonAddCart: "AnalyticsShopcartView",
      jsonRegistrationView: "AnalyticsRegistrationView",
      jsonConversionEventView: "AnalyticsConversionEventView",
      topicNamespace: "/wc/analytics/",
      pageView: "pageview",
      productView: "productview",
      cartView: "cartview",
      addCart: "addcart",
      element: "element",
      registration: "registration",
      conversionEvent: "conversionevent",
      pageViewControl: !1,
      incTaxInUnitPriceForCart: "F",
      cartViewActionIdList: ["AjaxDeleteOrderItem", "AjaxUpdateOrderItem"],
      addCartActionIdList: ["AddOrderItem", "AjaxAddOrderItemWithShipingInfo"],
      wishlistPageIdList: [
        "AjaxInterestItemAdd",
        "InterestItemDelete",
        "AjaxRestWishListAddItem",
        "AjaxRestWishListRemoveItem",
        "ShoppingListServiceAddItem",
      ],
      conversionEventList: [
        "AjaxInterestItemAdd",
        "AjaxRestWishListAddItem",
        "AjaxInterestItemAddAndDeleteFromCart",
        "ShoppingListServiceAddItem",
        "AnalyticsConversionEvent",
      ],
      publishAnalyticsView: function (e, t, r) {
        var s = this,
          a = {
            url: getAbsoluteURL() + e,
            method: "GET",
            dataType: "json",
            data: $.extend(
              {
                storeId: s.storeId,
                catalogId: s.catalogId,
              },
              t
            ),
            error: function (e, t) {
              wcTopic.publish("ajaxRequestCompleted");
            },
            success: function (e, t) {
              r.call(s, e), wcTopic.publish("ajaxRequestCompleted");
            },
          };
        wcTopic.publish("ajaxRequestInitiated"), $.ajax(a);
      },
      publishTopic: function (e, t) {
        var r = this.makeTopic(e);
        wcTopic.publish(r, t);
      },
      publishPageView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonPageView, e, function (e) {
          t.publishTopic(t.pageView, e);
        });
      },
      publishConversionEventView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonConversionEventView, e, function (e) {
          t.publishTopic(t.conversionEvent, e);
        });
      },
      publishCartView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonShopcartView,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.cartView, t);
          }
        );
      },
      publishAddCart: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonAddCart,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.addCart, t);
          }
        );
      },
      publishRegistrationView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonRegistrationView,
          {
            storeId: e.storeId,
          },
          function (t) {
            e.publishTopic(e.registration, t);
          }
        );
      },
      makeTopic: function (e) {
        return [this.topicNamespace, e].join("");
      },
      getMiniShopCartPageCategory: function () {
        return "MiniShoppingCart";
      },
      getMiniShopCartPageName: function () {
        return ["MiniShoppingCart: ", document.title].join("");
      },
      getMiniShopCartPageViewData: function (e) {
        var t = this.getMiniShopCartPageName(),
          r = this.getMiniShopCartPageCategory();
        return {
          pagename: t,
          category: r,
        };
      },
      publishMiniShopCartPageView: function (e) {
        var t = this;
        if (!t.pageViewControl) {
          t.lockPageView();
          var r = this.getMiniShopCartPageViewData(e);
          this.publishPageView(r);
        }
      },
      lockPageView: function () {
        (this.pageViewControl = !0),
          setTimeout("analyticsJS.pageViewControl = false;", 3e3);
      },
      registerMiniShopCartCartView: function () {
        var e = this;
        $(this.cartViewActionIdList).each(function (t, r) {
          wcTopic.subscribe("modelChanged/" + r, function () {
            e.publishCartView();
          });
        }),
          $(this.addCartActionIdList).each(function (t, r) {
            wcTopic.subscribe("modelChanged/" + r, function () {
              e.publishAddCart();
            });
          });
      },
      loadShopCartHandler: function (e) {
        var t = this;
        e === !0 && (t.incTaxInUnitPriceForCart = "T"),
          t.registerMiniShopCartCartView(),
          t.registerShopCartPaginationPageView(),
          t.registerShippingBillingAddressEditPageView();
      },
      loadShopCartPaginationHandler: function () {
        var e = this;
        e.registerShopCartPaginationPageView();
      },
      registerShopCartPaginationPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "ShopCartPaginationDisplay_Context/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "OrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "traditionalShipmentDetailsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "MSOrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          );
      },
      registerShippingBillingAddressEditPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "editShippingAddressContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Shipping and biling address",
            };
            e.publishPageView(t);
          }
        );
      },
      registerStoreLocatorPageViews: function () {
        var e = this;
        wcTopic.subscribe(
          "selectedStoreListContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Store locator",
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "storeLocatorResultsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
                category: "Store locator",
              };
              e.publishPageView(t);
            }
          );
      },
      loadStoreLocatorPageViews: function () {
        var e = this;
        $(document).ready(function () {
          e.registerStoreLocatorPageViews();
        });
      },
      registerWishlistHandler: function () {
        var e = this,
          t =
            ("Personal Wishlist:" + document.title,
            {
              eventId: "AddToWishlist",
            });
        $(this.conversionEventList).each(function (r, s) {
          wcTopic.subscribe("modelChanged/" + s, function () {
            e.publishConversionEventView(t);
          });
        });
      },
      loadWishlistHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerWishlistHandler();
        });
      },
      publishShopCartLoginTags: function () {
        var e = this;
        $(document).ready(function () {
          e.publishRegistrationView(), e.publishCartView();
        });
      },
      registerProductQuickInfoView: function () {
        var e = this;
        "undefined" != typeof QuickInfoJS &&
          Utils.aop_after(QuickInfoJS, "showDetails", function (t) {
            var r = t[0];
            e.publishAnalyticsView(
              e.jsonProductView,
              {
                productId: r,
                storeId: e.storeId,
              },
              function (t) {
                e.publishTopic(e.productView, t);
              }
            );
          });
      },
      loadProductQuickInfoHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerProductQuickInfoView();
        });
      },
      loadPagingHandler: function () {
        var e = this;
        $(document).ready(function () {
          var t = {
              forward: "page forward",
              backward: "page backward",
            },
            r = [
              ["Common", "goBack", t.backward],
              ["Common", "goForard", t.forward],
              ["Common.HistoryTracker.prototype", "back", t.backward],
              ["Common.HistoryTracker.prototype", "forward", t.forward],
            ];
          $(r).each(function (t, r) {
            var s = Utils.getObject(r[0]),
              a = r[1],
              i = r[2];
            $(s).on(a, function () {
              e.publishPageView({
                pagename: document.title,
                category: i,
              });
            });
          });
        });
      },
      registerSearchResultPageView: function (
        resultInfoDivId,
        registerPageViewNow,
        advSearchFormDivId
      ) {
        var realSearch = !0,
          scope = this;
        if (registerPageViewNow && $("#" + resultInfoDivId).length) {
          var resultInfo = eval(
              "(" + $("#" + resultInfoDivId).html() + ")"
            ).searchResult,
            pageViewData = {
              pagename: document.title,
            };
          "" !== resultInfo.searchTerms &&
            ((pageViewData =
              "0" !== resultInfo.totalResultCount
                ? {
                    pagename:
                      "Search Successful:" + resultInfo.currentPageNumber,
                  }
                : {
                    pagename: "Search Unsuccessful",
                  }),
            resultInfo.searchTerms.length > 0 &&
              ((pageViewData.searchTerms = resultInfo.searchTerms),
              (pageViewData.searchCount = resultInfo.totalResultCount)),
            (pageViewData.category = "Search Results")),
            (pageViewData.attributes = resultInfo.attributes),
            scope.publishPageView(pageViewData);
        }
      },
      loadSearchResultHandler: function (e, t, r) {
        var s = this;
        wcTopic.subscribe("CMPageRefreshEvent", function () {
          s.registerSearchResultPageView(e, t, r);
        });
      },
      registerPaymentPageView: function (e) {
        var t = this;
        Utils.aop_after(e, "setNumberOfPaymentMethods", function (e) {
          var r = e[1];
          t.publishPageView({
            pagename: r.value,
            category: "payment method",
          }),
            (r = null);
        });
      },
      loadPaymentPageView: function (e) {
        var t = this;
        $(document).ready(function () {
          t.registerPaymentPageView(e);
        });
      },
    }),
  (categoryDisplayJS = {
    entitledItems: [],
    selectedProducts: {},
    selectedAttributes: {},
    errorMessages: {},
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    contextChanged: !1,
    isHistory: !1,
    merchandisingAssociationItems: [],
    baseCatalogEntryDetails: [],
    associationThumbnailIndex: 1,
    totalAssociationCount: 0,
    baseItemAddedToCart: !1,
    merchandisingProductAssociationAddToCart: !1,
    merchandisingProductAssociationForm: "",
    isParentBundleBean: !1,
    userType: "",
    moreInfoUrl: "",
    displayPrevAssociation: "",
    displayNextAssociation: "",
    defaultItemArray: [],
    currentPageType: "",
    currentCatalogEntryId: "",
    entitledItemJsonObject: null,
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArray: [],
    setCommonParameters: function (e, t, r, s) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    setSelectedAttribute: function (e, t) {
      console.debug(e + " : " + t),
        (this.selectedAttributes[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t);
    },
    setSelectedAttributeJS: function (e, t) {
      console.debug(
        e.replace(/'/g, "&#039;") + " : " + t.replace(/'/g, "&#039;")
      ),
        (this.selectedAttributes[e.replace(/'/g, "&#039;")] = t.replace(
          /'/g,
          "&#039;"
        )),
        (this.moreInfoUrl =
          this.moreInfoUrl +
          "&" +
          e.replace(/'/g, "&#039;") +
          "=" +
          t.replace(/'/g, "&#039;"));
    },
    displayPriceServiceResponse: function (e, t) {
      (categoryDisplayJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        categoryDisplayJS.displayPrice(e.catalogEntry);
    },
    displayPrice: function (e) {
      var t,
        r = categoryDisplayJS.isPopup;
      if (
        (1 == r &&
          ($("#productPrice").html(e.offerPrice),
          $("#productName").html(e.description[0].name),
          $("#productSKUValue").html(
            e.catalogEntryIdentifier.externalIdentifier.partNumber
          )),
        0 == r)
      ) {
        var s = "";
        if (
          ((s =
            !e.listPriced || e.listPrice <= e.offerPrice
              ? "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price bold'>" +
                e.offerPrice +
                "</span>"
              : "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price listPrice bold'>" +
                e.listPrice +
                "</span><div class='price offerprice bold'>" +
                e.offerPrice +
                "</div>"),
          (s += "<br />"),
          1 == categoryDisplayJS.displayPriceRange)
        )
          for (var a in e.priceRange)
            "null" != e.priceRange[a].endingNumberOfUnits
              ? ((t = MessageHelper.messages.TieredPricingDisp),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].endingNumberOfUnits)),
                (t = t.replace("{2}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>"))
              : ((t = MessageHelper.messages.TieredPricingDispLast),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>")),
              (s += "<br />");
        $("#WC_CachedProductOnlyDisplay_div_4").html(s),
          $("#catalog_link").html(e.description[0].name);
      }
    },
    setSelectedAttributeOfProduct: function (e, t, r) {
      (selectedAttributesForProduct = {}),
        this.selectedProducts[e] &&
          (selectedAttributesForProduct = this.selectedProducts[e]),
        (selectedAttributesForProduct[t] = r),
        (this.selectedProducts[e] = selectedAttributesForProduct);
    },
    getCatalogEntryId: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveSKU(e);
    },
    getImageForSKU: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveImageForSKU(e);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("CatEntryId:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    resolveImageForSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].ItemImage,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("ItemImage:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    addToAllSwatchsArray: function (e, t, r) {
      if (!this.existInAllSwatchsArray(e, t)) {
        var s = [];
        (s[0] = e),
          (s[1] = t),
          (s[2] = r),
          (s[4] = document.getElementById("swatch_" + t).onclick),
          this.allSwatchesArray.push(s);
      }
    },
    existInAllSwatchsArray: function (e, t) {
      for (var r = 0; r < this.allSwatchesArray.length; r++) {
        var s = this.allSwatchesArray[r][0],
          a = this.allSwatchesArray[r][1];
        if (s == e && a == t) return !0;
      }
      return !1;
    },
    updateParamObject: function (e, t, r, s, a) {
      if ((null == e && (e = []), null != e[t] && s))
        if ($.isArray(e[t]))
          null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
        else {
          var i = e[t];
          (e[t] = []), e[t].push(i), e[t].push(r);
        }
      else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
      else if (-1 == a) {
        for (var n = 1; null != e[t + "_" + n]; ) n++;
        e[t + "_" + n] = r;
      } else e[t] = r;
      return e;
    },
    setDefaultItem: function (e, t) {
      this.defaultItemArray[e] = t;
    },
    getDefaultItem: function (e) {
      return this.defaultItemArray[e];
    },
    AddBundle2ShopCartAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.orderId = "."),
        (t.calculateOrder = "0"),
        (t.inventoryValidation = "true");
      for (var r = e.numberOfProduct.value, s = 1; r >= s; s++) {
        var a = e["catEntryId_" + s].value;
        this.selectedProducts[a] &&
          (a = this.getCatalogEntryIdforProduct(this.selectedProducts[a]));
        var i = e["quantity_" + s].value;
        if (null == i || "" === i || 0 >= i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i || "" === i || null == a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", a, !1, -1),
          this.updateParamObject(t, "quantity", i, !1, -1),
          (this.baseItemAddedToCart = !0);
        var n = document.getElementsByName(
          "contractSelectForm_contractId_" + a
        );
        if (null != n && "undefined" != n)
          for (j = 0; j < n.length; j++)
            if (n[j].checked) {
              e["contractId_" + s].value = n[j].value;
              break;
            }
        var o = e["contractId_" + s].value;
        null != o &&
          "" !== o &&
          this.updateParamObject(t, "contractId", o, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxAddOrderItem", t));
    },
    AddBundle2ShopCart: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      e.URL.value = "AjaxOrderItemDisplayView";
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
        var a = e["quantity_" + r].value;
        if (null == a || "" === a || 0 >= a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        var i = document.getElementsByName(
          "contractSelectForm_contractId_" + s
        );
        if (null != i && "undefined" != i)
          for (j = 0; j < i.length; j++)
            if (i[j].checked) {
              e["contractId_" + r].value = i[j].value;
              break;
            }
      }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCart: function (entitledItemId, form, quantity, isPopup) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      if (null != catalogEntryId) {
        if (this.merchandisingProductAssociationAddToCart)
          return void this.AddAssociation2ShopCart(catalogEntryId, quantity);
        (form.catEntryId.value = catalogEntryId),
          (form.productId.value = catalogEntryId),
          this.AddItem2ShopCart(form, quantity),
          hidePopup("second_level_category_popup");
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLink",
              MessageHelper.messages.ERR_RESOLVING_SKU
            ))
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    AddItem2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      e.quantity.value = t;
      var r = document.getElementsByName("contractSelectForm_contractId");
      if (null != r && "undefined" != r)
        for (i = 0; i < r.length; i++)
          if (r[i].checked) {
            e.contractId.value = r[i].value;
            break;
          }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      null != catalogEntryId
        ? (this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams),
          (this.baseItemAddedToCart = !0),
          hidePopup("second_level_category_popup"))
        : 1 == isPopup
        ? ($("#second_level_category_popup").css("zIndex", "1"),
          MessageHelper.formErrorHandleClient(
            "addToCartLinkAjax",
            MessageHelper.messages.ERR_RESOLVING_SKU
          ))
        : (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          ),
          (this.baseItemAddedToCart = !1));
    },
    setEntitledItemJsonObject: function (e) {
      this.entitledItemJsonObject = e;
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    ReplaceItemAjax: function (entitledItemId, quantity) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId,
        typeId = document.getElementById("shipmentTypeId"),
        addressId = "",
        shipModeId = "";
      null != typeId &&
        "" !== typeId &&
        ("2" == typeId.value
          ? ((addressId = document.getElementById(
              "MS_ShipmentAddress_" + removeOrderItemId
            ).value),
            (shipModeId = document.getElementById(
              "MS_ShippingMode_" + removeOrderItemId
            ).value))
          : ((addressId = $("#addressId_all").val()),
            (shipModeId = $("#shipModeId_all").val()))),
        null != catalogEntryId
          ? "" !== removeOrderItemId &&
            this.ReplaceItemAjaxHelper(
              catalogEntryId,
              quantity,
              removeOrderItemId,
              addressId,
              shipModeId
            )
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    ReplaceItemNonAjax: function (entitledItemId, quantity, form) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId;
      if (null != catalogEntryId)
        if ("" === removeOrderItemId);
        else {
          form.orderItemId.value = removeOrderItemId;
          var addressId, shipModeId;
          if (
            (0 == quantity && console.debug("An invalid quantity was selected"),
            null != form.shipmentTypeId && "" !== form.shipmenTypeId
              ? ("2" == form.shipmentTypeId.value
                  ? ((addressId = document.getElementById(
                      "MS_ShipmentAddress_" + removeOrderItemId
                    ).value),
                    (shipModeId = document.getElementById(
                      "MS_ShippingMode_" + removeOrderItemId
                    ).value))
                  : ((addressId = $("#addressId_all").val()),
                    (shipModeId = $("#shipModeId_all").val())),
                (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&addressId=" +
                  addressId +
                  "&shipModeId=" +
                  shipModeId +
                  "&URL=RESTOrderShipInfoUpdate?URL=" +
                  form.URL.value))
              : (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&URL=" +
                  form.URL.value),
            !submitRequest())
          )
            return;
          processAndSubmitForm(form);
        }
      else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2ShopCartAjax: function (e, t, r) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (s.calculateOrder = "0"), (s.inventoryValidation = "true");
      var a = "AjaxAddOrderItem",
        i = "AjaxAddOrderItem_shopCart";
      if ($.isArray(e) && $.isArray(t))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            );
          (s["catEntryId_" + (n + 1)] = e[n]),
            (s["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        (s.catEntryId = e), (s.quantity = t);
      }
      if (null != r && "undefined" != r) {
        for (n in r) s[n] = r[n];
        "dynamicKit" == r.catalogEntryType &&
          ((a = "AjaxAddPreConfigurationToCart"),
          (i = "AjaxAddPreConfigurationToCart_shopCart"));
      }
      var o = document.getElementsByName("contractSelectForm_contractId");
      if (null != o && "undefined" != o)
        for (n = 0; n < o.length; n++)
          if (o[n].checked) {
            s.contractId = o[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(a, s),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    ConfigureDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
    ReplaceItemAjaxHelper: function (e, t, r, s, a) {
      var i = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderItemId: r,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (i.calculationUsage = "-1,-2,-5,-6,-7")
        : (i.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var n = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (o.allocate = "***"),
        (o.backorder = "***"),
        (o.remerge = "***"),
        (o.check = "*n");
      var d = !1;
      null != s &&
        "" !== s &&
        null != a &&
        "" !== a &&
        ((o.addressId = s), (o.shipModeId = a), (d = !0)),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            d
              ? wcService.invoke("AjaxAddOrderItemTemp", n)
              : wcService.invoke("AjaxAddOrderItem", n);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            wcService.invoke("OrderItemAddressShipMethodUpdate", o);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", i));
    },
    AddBundle2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
      }
      (e.action = "InterestItemAdd"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    AddBundle2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.updateable = 0),
        (t.orderId = ".");
      var r = [];
      r = e.catEntryIDS.value.toString().split(",");
      for (var s = 0; s < r.length; s++) {
        var a = document.getElementById("quantity_" + r[s]).value,
          i = r[s];
        if (
          (this.selectedProducts[r[s]] &&
            (i = this.getCatalogEntryIdforProduct(this.selectedProducts[r[s]])),
          (0 == a || null == a) && (a = 1),
          null == a || "" === a || null == i)
        )
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", i, !1, -1),
          this.updateParamObject(t, "quantity", a, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishListAjaxByID: function (e) {
      if (null != e) {
        isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
        var t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          catEntryId: e,
          updateable: 0,
          URL: "SuccessfulAJAXRequest",
        };
        if (
          ($("#controllerURLWishlist").length &&
            $("#WishlistDisplay_Widget").refreshWidget(
              "updateUrl",
              $("#controllerURLWishlist").val()
            ),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    Add2WishListAjax: function (entitledItemId) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListAjaxByID(catalogEntryId);
    },
    AddItem2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        updateable: 0,
        URL: "SuccessfulAJAXRequest",
      };
      $("#controllerURLWishlist").length &&
        $("#WishlistDisplay_Widget").refreshWidget(
          "updateUrl",
          $("#controllerURLWishlist").val()
        ),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishList: function (entitledItemId, form) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListByID(catalogEntryId, form);
    },
    Add2WishListByID: function (e, t) {
      if (
        (isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        null != e)
      ) {
        if (
          ((t.productId.value = e),
          (t.catEntryId.value = e),
          (t.action = "InterestItemAdd"),
          (t.page.value = "customerlinkwishlist"),
          "G" == this.userType
            ? (t.URL.value = "InterestItemDisplay")
            : (t.URL.value = "AjaxLogonForm"),
          (t.quantity.value = "1"),
          !submitRequest())
        )
          return;
        processAndSubmitForm(t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        (e.action = "InterestItemAdd"),
        (e.quantity.value = "1"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    initializeMerchandisingAssociation: function (thumbnailIndex) {
      var associationDisplay = document.getElementById(
          "marchandisingAssociationDisplay"
        ),
        totalPriceMsg = $("#totalPriceMsg").val(),
        baseCatEntryJSON = eval("(" + $("#baseCatEntryDetails").html() + ")");
      this.baseCatalogEntryDetails = baseCatEntryJSON;
      var basePrice = this.baseCatalogEntryDetails[0].baseCatEntry_Price;
      this.totalAssociationCount =
        this.baseCatalogEntryDetails[0].totalAssociations;
      var identifierJSON = "associatedCatEntries_" + thumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      this.merchandisingAssociationItems = associationEntryJSON;
      var totalPrice =
          parseFloat(basePrice) +
          parseFloat(this.merchandisingAssociationItems[0].catEntry_Price),
        dragType = "";
      "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "product")
        : "ItemBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "item")
        : "PackageBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "package")
        : "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type &&
          (dragType = "bundle");
      var widgetHTML = "";
      if ($("#addToCartLink").length) {
        var url =
          "AjaxOrderItemDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId;
        widgetHTML =
          widgetHTML +
          "<form name='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' action='RESTOrderItemAdd' method='post' id='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'>\n<input type='hidden' name='storeId' value='" +
          this.storeId +
          "' id='OrderItemAddForm_storeId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='orderId' value='.' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catalogId' value='" +
          this.catalogId +
          "' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='URL' value='" +
          url +
          "' id='OrderItemAddForm_url_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='errorViewName' value='InvalidInputErrorView' id='OrderItemAddForm_errorViewName_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catEntryId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_catEntryId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='productId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_productId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='1' name='quantity' id='OrderItemAddForm_quantity_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='page' id='OrderItemAddForm_page_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='-1,-2,-3,-4,-5,-6,-7' name='calculationUsage' id='OrderItemAddForm_calcUsage_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='0' name='updateable' id='OrderItemAddForm_updateable_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='giftListId' id='OrderItemAddForm_giftListId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n</form>\n";
      }
      (widgetHTML += "<div class='scroller' id='WC_CategoryDisplayJS_div_1'>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex < this.totalAssociationCount &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showNextAssociation()'  id='WC_ProductAssociation_UpArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "      <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_up_arrow.png' alt='" +
            this.displayNextAssociation +
            "'/></a>")),
        (widgetHTML =
          widgetHTML +
          " <br /><div id='baseContent_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView
          ? (widgetHTML =
              widgetHTML +
              " onmouseover='showPopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");' onmouseout='hidePopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");'>")
          : (widgetHTML += " >"),
        (widgetHTML =
          widgetHTML +
          "  <a href='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'  id='img" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' onfocus='showPopupButton(" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          ");'>"),
        (widgetHTML =
          widgetHTML +
          "     <img src='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail +
          "' alt='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "' class='img' width='70' height='70'/>  </a><br />"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView &&
          (widgetHTML =
            widgetHTML +
            " <div id='popupButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' class='main_quickinfo_button'><span class='secondary_button' >\n<span class='button_container' >\n<span class='button_bg' >\n<span class='button_top'>\n<span class='button_bottom'>\n<a id='QuickInfoButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' href='#' onclick='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onkeypress='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onblur='hidePopupButton(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ");' role='wairole:button' waistate:haspopup='true'>" +
            this.merchandisingAssociationItems[0].showProductQuickViewLable +
            "</a></span>\n</span>\n</span>\n</span>\n</span>\n</div>\n"),
        (widgetHTML += "</div>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex > 1 &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showPreviousAssociation()'  id='WC_ProductAssociation_DownArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "        <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_down_arrow.png' alt='" +
            this.displayPrevAssociation +
            "'/></a>"));
      var comboText =
        this.baseCatalogEntryDetails[0].associatedProductsName.replace(
          /%0/,
          this.baseCatalogEntryDetails[0].baseCatEntry_Name
        );
      (comboText = comboText.replace(
        /%1/,
        this.merchandisingAssociationItems[0].catEntry_Name
      )),
        (widgetHTML =
          widgetHTML +
          "</div><div class='combo_text' id='WC_CategoryDisplayJS_div_2'>\n <h1 id='maHeader' class='status_msg'>" +
          comboText +
          "</h1>\n   <span id='maPrice' class='grey'>" +
          totalPriceMsg +
          Utils.formatCurrency(totalPrice.toFixed(2), {
            currency: this.baseCatalogEntryDetails[0].currency,
          }) +
          "</span>\n</div>\n"),
        (widgetHTML =
          widgetHTML +
          "<input type='hidden' id='compareImgPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail_compare +
          "'/><input type='hidden' id='compareProductDetailsPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'/><input type='hidden' id='compareImgDescription_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "'/>"),
        (associationDisplay.innerHTML = null),
        (associationDisplay.innerHTML = widgetHTML),
        WCWidgetParser.parse(associationDisplay),
        WCWidgetParser.parseRefreshArea(associationDisplay);
    },
    showNextAssociation: function () {
      this.associationThumbnailIndex < this.totalAssociationCount &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex + 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    showPreviousAssociation: function () {
      this.associationThumbnailIndex > 1 &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex - 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    AddAssociation2ShopCartAjax: function (baseProductId, baseProductQuantity) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var identifierJSON =
          "associatedCatEntries_" + this.associationThumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      if (
        ((this.merchandisingAssociationItems = associationEntryJSON),
        (this.baseItemAddedToCart = !1),
        "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type)
      )
        this.Add2ShopCartAjax(baseProductId, baseProductQuantity),
          this.baseItemAddedToCart &&
            showPopup(
              this.merchandisingAssociationItems[0].catEntry_Identifier,
              function (e) {
                return e;
              },
              "marchandisingAssociationDisplay"
            );
      else if (
        ["ItemBean", "PackageBean", "BundleBean"].indexOf(
          this.merchandisingAssociationItems[0].catEntry_Type
        ) > -1
      ) {
        var entitledItemJSON = eval("(" + $("#" + baseProductId).html() + ")");
        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(),
          params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
          };
        if (((params.calculateOrder = "0"), null == catalogEntryId))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        if (
          (this.updateParamObject(params, "catEntryId", catalogEntryId, !1, -1),
          this.updateParamObject(
            params,
            "quantity",
            baseProductQuantity,
            !1,
            -1
          ),
          "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type)
        ) {
          var form = document.getElementById(
              this.merchandisingAssociationItems[0].catEntry_BundleFormId
            ),
            catEntryArray = [];
          catEntryArray = form.catEntryIDS.value.toString().split(",");
          for (var i = 0; i < catEntryArray.length; i++) {
            var qty = document.getElementById(
                "quantity_" + catEntryArray[i]
              ).value,
              catEntryId = catEntryArray[i];
            if (
              (this.getDefaultItem(catEntryArray[i]) &&
                (catEntryId = this.getDefaultItem(catEntryArray[i])),
              (0 == qty || null == qty) && (qty = 1),
              null == qty || "" === qty || null == catEntryId)
            )
              return void MessageHelper.displayErrorMessage(
                MessageHelper.messages.ERR_RESOLVING_SKU
              );
            this.updateParamObject(params, "catEntryId", catEntryId, !1, -1),
              this.updateParamObject(params, "quantity", qty, !1, -1);
          }
        } else
          this.updateParamObject(
            params,
            "catEntryId",
            this.merchandisingAssociationItems[0].catEntry_Identifier,
            !1,
            -1
          ),
            this.updateParamObject(params, "quantity", 1, !1, -1);
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("AjaxAddOrderItem", params);
      }
    },
    AddAssociation2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var r = this.merchandisingProductAssociationForm;
      if (
        ((this.merchandisingProductAssociationAddToCart = !1),
        this.isParentBundleBean)
      ) {
        var s = [];
        s = r.catEntryIDS.value.toString().split(",");
        for (var a = 1, i = 0; i < s.length; i++) {
          var n = document.getElementById("quantity_" + s[i]).value,
            o = s[i];
          if (
            (this.selectedProducts[s[i]] &&
              (o = this.getCatalogEntryIdforProduct(
                this.selectedProducts[s[i]]
              )),
            (0 == n || null == n) && (n = 1),
            null == n || "" === n || null == o)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          var d = document.createElement("input");
          $(d).attr("id", "OrderItemAddForm_catEntryId_" + o),
            $(d).attr("type", "hidden"),
            $(d).attr("name", "catEntryId_" + a),
            $(d).attr("value", o),
            (a += 1),
            r.appendChild(d);
        }
        var l = document.createElement("input");
        $(l).attr("id", "OrderItemAddForm_catEntryId_" + e),
          $(l).attr("type", "hidden"),
          $(l).attr("name", "catEntryId_" + a),
          $(l).attr("value", e),
          r.appendChild(l);
        var c = document.createElement("input");
        $(c).attr("id", "OrderItemAddForm_quantity_" + e),
          $(c).attr("type", "hidden"),
          $(c).attr("name", "quantity_" + a),
          $(c).attr("value", t),
          r.appendChild(c),
          (r.URL.value = "AjaxOrderItemDisplayView"),
          (this.isParentBundleBean = !1);
      } else
        (r.catEntryId_2.value = e),
          (r.productId_2.value = e),
          (r.quantity_2.value = t);
      submitRequest() &&
        (processAndSubmitForm(r),
        (this.merchandisingProductAssociationForm = ""));
    },
    setOrderId: function (e) {
      this.orderId = e;
    },
    addToNewListFromProductDetail: function (
      entitledItemId,
      quantityElemId,
      currentPage
    ) {
      MessageHelper.hideAndClearMessage();
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      return null == catalogEntryId
        ? (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          ),
          void (
            $("#second_level_category_popup").length &&
            hidePopup("second_level_category_popup")
          ))
        : void this.addItemToNewListFromProductDetail(
            catalogEntryId,
            quantityElemId,
            currentPage
          );
    },
    addItemToNewListFromProductDetail: function (e, t, r) {
      if ((MessageHelper.hideAndClearMessage(), null != e)) {
        var s = $("#" + t).val();
        if (null == s || "" === s || 0 >= s || !RequisitionList.isNumber(s))
          return (
            MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            ),
            void (
              $("#second_level_category_popup").length &&
              hidePopup("second_level_category_popup")
            )
          );
        var a = "AjaxLogonForm?page=createrequisitionlist",
          i = document.createElement("form");
        $(i).attr("method", "POST");
        var n = document.createElement("input");
        $(n).attr("type", "hidden"),
          $(n).attr("value", r),
          $(n).attr("name", "previousPage"),
          i.appendChild(n),
          (i.action =
            a +
            "&catEntryId=" +
            e +
            "&quantity=" +
            s +
            "&storeId=" +
            this.storeId +
            "&catalogId=" +
            this.catalogId +
            "&langId=" +
            this.langId),
          document.body.appendChild(i),
          processAndSubmitForm(i);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
        );
    },
    addBundleToNewListFromProductDetail: function (e, t) {
      for (
        var r = e.numberOfProduct.value,
          s = "AjaxLogonForm?page=createrequisitionlist",
          a = 1;
        r >= a;
        a++
      ) {
        var i = e["catEntryId_" + a].value;
        this.selectedProducts[i] &&
          (i = this.getCatalogEntryIdforProduct(this.selectedProducts[i]));
        var n = e["quantity_" + a].value;
        if (null == n || "" === n || 0 >= n || !RequisitionList.isNumber(n))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          );
        s = s + "&catEntryId=" + i + "&quantity=" + n;
      }
      var o = document.createElement("input");
      $(o).attr("type", "hidden"),
        $(o).attr("value", t),
        $(o).attr("name", "previousPage"),
        e.appendChild(o),
        (s =
          s +
          "&numberOfProduct=" +
          e.numberOfProduct.value +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId),
        (e.action = s),
        processAndSubmitForm(e);
    },
    setCurrentPageType: function (e) {
      this.currentPageType = e;
    },
    setCurrentCatalogEntryId: function (e) {
      this.currentCatalogEntryId = e;
    },
    handleCategorySubscription: function (e) {
      var t = document.forms[e],
        r = {
          DM_ReqCmd: t.DM_ReqCmd.value,
          storeId: t.storeId.value,
          catalogId: t.catalogId.value,
          langId: t.langId.value,
          categoryId: t.categoryId.value,
        };
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxCategorySubscribe", r));
    },
  }),
  (compareProductJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    compareReturnName: "",
    returnUrl: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.compareReturnName = s),
        (this.returnUrl = decodeURIComponent(a));
    },
    clear: function () {
      MessageHelper.hideAndClearMessage();
      var e = this.cookieKeyPrefix + this.storeId;
      if (
        (setCookie(e, "", {
          path: "/",
          domain: cookieDomain,
        }),
        $.remove("#compareDropZoneImgDiv"),
        $("#compareDropZoneImg").length &&
          $("#compareDropZoneImg").css("display", "block"),
        $("#compareProductPage").length && $("#compareProductPage").val())
      ) {
        var t =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName +
          "&returnUrl=" +
          encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl));
        document.location.href = appendWcCommonRequestParameters(t);
      }
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.COMPARE_ITEMS_CLEAR
      );
    },
    remove: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r) {
        if ("" == $.trim(r))
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var s = r.split(this.cookieDelimiter),
            a = "";
          for (index in s)
            s[index] != e &&
              (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          });
        }
        this.compareProducts();
      }
    },
    Add2CompareAjax: function (e, t, r, s) {
      MessageHelper.hideAndClearMessage(),
        $("#compareProductParentId_" + e).length &&
          void 0 != document.getElementById("compareProductParentId_" + e) &&
          (e = document.getElementById("compareProductParentId_" + e).value);
      var a = this.cookieKeyPrefix + this.storeId,
        i = getCookie(a);
      if (null != i && (-1 !== i.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPARE_ITEM_EXISTS
        );
      var n = 0;
      if (
        (null != i && "" !== i && (n = i.split(this.cookieDelimiter).length),
        n < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var o = "";
        if (
          ((o = null == i || "" === i ? e : i + this.cookieDelimiter + e),
          setCookie(a, o, {
            path: "/",
            domain: cookieDomain,
          }),
          0 == n &&
            ($("#compareDropZoneImg").css("display", "none"),
            $("#compareZone").after(
              "<div id='compareDropZoneImgDiv' style='width:100%'><table><tbody id='compareItemsTable'><tr id='compareRow'></tr></tbody></table></div>"
            )),
          $("#compareDropZoneImgDiv").length)
        ) {
          var d = (
            '<td id="compareCatentry' +
            e +
            '"><div id="compareCatentryContainer' +
            e +
            '"><div id="compare_img_' +
            e +
            '" class="compare_img"><a id="imgcatBrowseCompare_Item_' +
            e +
            '" href="' +
            r +
            '"><img height="40" width="40" border="0" alt="' +
            s +
            '" title="' +
            s +
            '" src="' +
            t +
            '"></img>\n</a></div><div id="compare_info_' +
            e +
            '" class="compare_info"><div id="compare_product_desc_' +
            e +
            '" class="compare_product_desc">' +
            s +
            "</div></div></div></td>"
          )
            .replace(/\"/g, "'")
            .replace(/\r|\n|\r\n|\n\r/g, "");
          $("#compareRow").after(d);
        }
        $("#compareProductPage").length &&
          "undefined" != document.getElementById("compareProductPage") &&
          $("#compareProductPage").val() &&
          this.compareProducts(),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.COMPAREZONE_ADDED
          );
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPATE_MAX_ITEMS
        );
    },
    compareProducts: function () {
      var e =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName,
        t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (Utils.notNullOrWhiteSpace(r)) {
        var s = r.split(this.cookieDelimiter);
        for (index in s) e = e + "&catentryId=" + s[index];
      }
      (e =
        appendWcCommonRequestParameters(e) +
        "&returnUrl=" +
        encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl))),
        (document.location.href = getAbsoluteURL() + e);
    },
    init: function () {
      wcTopic.subscribe("/dnd/drop", function (e, t, r, s) {
        e != s && s.deleteSelectedNodes();
        var a = "",
          i = "",
          n = "",
          o = e.parent.id;
        if ("compareZone" == s.parent.id) {
          if (
            void 0 != getCookie("coShoppingDisableDnd") &&
            "true" == getCookie("coShoppingDisableDnd")
          )
            return void wcTopic.publish("/wc/collaboration/dndDisabled", []);
          var d = o.indexOf("_", 0);
          d >= 0 && (o = o.substring(d + 1)),
            $("#compareImgPath_" + o).length &&
              void 0 != document.getElementById("compareImgPath_" + o) &&
              (i = document.getElementById("compareImgPath_" + o).value),
            $("#compareProductDetailsPath_" + o).length &&
              void 0 !=
                document.getElementById("compareProductDetailsPath_" + o) &&
              (a = document.getElementById(
                "compareProductDetailsPath_" + o
              ).value),
            $("#compareImgDescription_" + o).length &&
              void 0 != document.getElementById("compareImgDescription_" + o) &&
              (n = document.getElementById("compareImgDescription_" + o).value),
            $("#compareProductParentId_" + o).length &&
              void 0 !=
                document.getElementById("compareProductParentId_" + o) &&
              (o = document.getElementById(
                "compareProductParentId_" + o
              ).value),
            compareProductJS.Add2CompareAjax(o, i, a, n);
        }
      });
      var e = this.cookieKeyPrefix + this.storeId;
      getCookie(e);
    },
  }),
  null == CheckoutPaymentsBis || "object" != typeof CheckoutPaymentsBis)
)
  var CheckoutPaymentsBis = new Object();
(CheckoutPaymentsBis = {
  errorMessages: {},
  numberOfPaymentMethods: 1,
  langId: "-1",
  storeId: "",
  catalogId: "",
  dirtyFlag: !1,
  jQlocale: "",
  maxNumberOfPaymentMethodsSupported: 3,
  paymentObjects: new Array(),
  paymentsToDelete: new Array(),
  paymentsToAdd: new Array(),
  paymentsToUpdate: new Array(),
  prevNumberOfPaymentMethods: 1,
  purchaseOrderNumber: "",
  paymentSpecificAddress: !1,
  quickCheckoutProfileForPaymentFlag: !1,
  currentPaymentMethodChanged: 1,
  setLocale: function (e) {
    this.jQlocale = e;
  },
  setQuickCheckoutProfileForPaymentFlag: function (e) {
    this.quickCheckoutProfileForPaymentFlag = e;
  },
  setErrorMessage: function (e, t) {
    this.errorMessages[e] = t;
  },
  setCommonParameters: function (e, t, r) {
    (this.langId = e), (this.storeId = t), (this.catalogId = r);
  },
  setNumPaymentIndicator: function (e) {
    var t = document.getElementById("paymentSection2");
    if ("block" == t.style.display)
      for (i = 1; i < e; i++) {
        var r = document.getElementById("paymentHeading" + i);
        r.style.display = "block";
      }
    else document.getElementById("paymentHeading1").style.display = "none";
  },
  setNumberOfPaymentMethods: function (e, t, r) {
    for (this.numberOfPaymentMethods = t.value, i = 1; i <= e; i++) {
      var s = document.getElementById(r + i);
      void 0 != s &&
        (i <= t.value
          ? (s.style.display = "block")
          : (s.style.display = "none"));
    }
    var a = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(a), this.setNumPaymentIndicator(t.value);
  },
  clearPaymentFormData: function (e) {
    " " !== this.getValue(e, "cc_brand") && (e.cc_brand.value = " "),
      " " !== this.getValue(e, "cc_cvc") && (e.cc_cvc.value = " "),
      " " !== this.getValue(e, "account") && (e.account.value = " "),
      " " !== this.getValue(e, "payment_token") &&
        (e.payment_token.value = " "),
      " " !== this.getValue(e, "expire_month") && (e.expire_month.value = " "),
      " " !== this.getValue(e, "expire_year") && (e.expire_year.value = " "),
      " " !== this.getValue(e, "check_routing_number") &&
        (e.check_routing_number.value = " "),
      " " !== this.getValue(e, "checkingAccountNumber") &&
        (e.checkingAccountNumber.value = " "),
      " " !== this.getValue(e, "checkRoutingNumber") &&
        (e.checkRoutingNumber.value = " "),
      " " !== this.getValue(e, "numberOfInstallments") &&
        (e.numberOfInstallments.value = " ");
  },
  loadPaymentSnippet: function (e, t) {
    var r = document.forms["PaymentForm" + t];
    this.clearPaymentFormData(r);
    var s = e.value.split("_"),
      a = s[0],
      i = "";
    null != s[1] && (i = s[1]),
      this.paymentSpecificAddress &&
        ((wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["payment" + t] = a),
        (wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["paymentTCId" + t] = i),
        wcRenderContext.updateRenderContext(
          "billingAddressDropDownBoxContext"
        )),
      MessageHelper.hideAndClearMessage();
    for (var n = 0, o = 1; t > o; o++) {
      var d = document.forms["PaymentForm" + o];
      null == d.piAmount ||
        "" == d.piAmount.value ||
        isNaN(d.piAmount.value) ||
        (n = 1 * n + 1 * d.piAmount.value);
    }
    var l = "payment" + t,
      c = r.buyerOrgDN.value,
      u = r.orderId.value,
      m = r.piAmount.value,
      g = {};
    (g[l] = a),
      (g["paymentTCId" + t] = i),
      (g.currentPaymentArea = t),
      (g.payMethodId = a),
      (g.currentTotal = n),
      (g.paymentTCId = i),
      (g.buyerOrgDN = c),
      (g.orderId = u),
      (g.piAmount = m),
      wcRenderContext.updateRenderContext("paymentContext", g);
    var p = document.forms["PaymentForm" + t];
    if ("PayInStore" == a) {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "none"),
        p.billing_address_id && (p.billing_address_id.value = "");
    } else {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "block"),
        "" == p.billing_address_id && (p.billing_address_id.value = "-1");
    }
  },
  loadPaymentSnippetLocally: function (e, t) {
    var r = e.value.split("_"),
      s = r[0],
      a = "",
      i = "",
      n = "",
      o = document.forms["PaymentForm" + t];
    if (
      (null == o.piAmount ||
        "" == o.piAmount.value ||
        isNaN(o.piAmount.value) ||
        (i = o.piAmount.value),
      null == o.piAmount_display ||
        "" == o.piAmount_display.value ||
        isNaN(o.piAmount_display.value) ||
        (n = o.piAmount_display.value),
      null != r[1])
    ) {
      var d = r[1];
      a = $("#PIInfo_Div_" + s + "_" + t + "_" + d).html();
    } else a = $("#PIInfo_Div_" + s + "_" + t).html();
    var l = document.getElementById("paymentFormDiv" + t);
    l.html(a),
      "" != i && (o.piAmount.value = i),
      "" != n && (o.piAmount_display.value = n);
    var c = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(c);
  },
  processCheckout: function (e, t) {
    if (
      (!CheckoutHelperJS.isSinglePageCheckout() ||
        this.validatePaymentTotals(e)) &&
      ((void 0 == t || null == t) && (t = !1),
      !CheckoutHelperJS.checkForDirtyFlag())
    ) {
      if ("1" == CheckoutHelperJS.getShipmentTypeId()) {
        if (null != document.getElementById("requestShippingDateCheckbox")) {
          var r = $("#requestedShippingDate");
          if (!r.ValidationTextbox("validationAndErrorHandler"))
            return void r.focus();
        }
      } else {
        var s = document.getElementById("totalNumberOfItems");
        if (null != s)
          for (var a = 0; a < s.value; a++) {
            var i = document.getElementById("orderItem_" + (a + 1));
            if (null != i) {
              var n = i.value,
                o = $("#MS_requestShippingDateCheckbox_" + n)[0];
              if (null != o) {
                var r = $("#MS_requestedShippingDate_" + n);
                if (!r.ValidationTextbox("validationAndErrorHandler"))
                  return void r.focus();
              }
            }
          }
      }
      if (null != document.getElementById("scheduleOrderInputSection")) {
        var d = document.getElementById("ScheduleOrderFrequency"),
          l = $("#ScheduleOrderStartDate"),
          c = document.getElementById("makeRecurringOrderMandatory");
        if (
          ("undefined" == d.value && null != l.val()) ||
          (c && "true" == c.value && "undefined" == d.value)
        )
          return void MessageHelper.formErrorHandleClient(
            d.id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_FREQUENCY
          );
        if ("undefined" != d.value && null == l.val())
          return void MessageHelper.formErrorHandleClient(
            l[0].id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_START_DATE
          );
        if (!CheckoutHelperJS.validateDate(l, "ScheduleOrderStartDate")) return;
      }
      var u = document.getElementById("numberOfPaymentMethods");
      if (u)
        for (var m = u.value, a = 1; m >= a; a++) {
          var g = document.forms[e + a];
          if ("select-one" == g.payMethodId.type)
            for (var p = 0; p < g.payMethodId.options.length; p++) {
              var h = g.payMethodId.options[p].value.split("_")[0];
              g.payMethodId.options[p].value = h;
            }
        }
      if (!t && !CheckoutHelperJS.isSinglePageCheckout()) {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          (I.orderId = "."),
          !submitRequest())
        )
          return;
        return (
          cursor_wait(),
          void wcService.invoke("AjaxPrepareOrderBeforePaymentCapture", I)
        );
      }
      if (t) this.processPIAndCheckout(e, t);
      else {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxPrepareOrderBeforeSubmit", I);
      }
    }
  },
  processPIAndCheckout: function (e, t) {
    if (
      (void 0 == t || null == t
        ? (t = !1)
        : ("true" == t || "false" == t) && (t = "true" === t),
      this.checkValidPaymentInstructions(e))
    ) {
      var r = document.forms[e + "1"];
      "Y" == this.getValue(r, "valueFromProfileOrder") &&
        (this.setQuickCheckoutProfileForPaymentFlag("true"),
        this.updatePaymentObject(1, "account"));
      for (
        var s = parseInt(this.maxNumberOfPaymentMethodsSupported), a = 1;
        s >= a;
        a++
      ) {
        var i = this.retrievePaymentObject(a);
        null != i &&
          (("delete" != i.action && "re-add" != i.action) ||
            "" == i.piId ||
            this.setPaymentsToDelete(a),
          ("add" == i.action || "re-add" == i.action) &&
            this.setPaymentsToAdd(a),
          "update" == i.action && "" != i.piId && this.setPaymentsToUpdate(a));
      }
      this.getPaymentsToDelete().length > 0
        ? this.deletePaymentInstructions()
        : this.getPaymentsToAdd().length > 0
        ? this.addPaymentInstructions()
        : this.getPaymentsToUpdate().length > 0
        ? this.updatePaymentInstructions()
        : (CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear()),
        CheckoutHelperJS.setFieldDirtyFlag(!1);
    }
  },
  showSummaryPage: function () {
    null != document.getElementById("scheduleOrderInputSection") &&
      CheckoutHelperJS.prepareOrderSchedule();
    var e = encodeURIComponent(this.purchaseOrderNumber),
      t = "";
    "1" == CheckoutHelperJS.getShipmentTypeId()
      ? ((t =
          "SingleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)))
      : ((t =
          "MultipleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)));
  },
  showBillingPage: function () {
    document.location.href = appendWcCommonRequestParameters(
      "OrderBillingView?langId=" +
        this.langId +
        "&storeId=" +
        this.storeId +
        "&catalogId=" +
        this.catalogId +
        "&forceShipmentType=" +
        CheckoutHelperJS.getShipmentTypeId()
    );
  },
  populateProtocolData: function (e, t) {
    return (
      (t = this.updateParamObject(
        t,
        "storeId",
        this.getValue(e, "storeId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payment_token",
        this.getValue(e, "payment_token"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "catalogId",
        this.getValue(e, "catalogId"),
        !0
      )),
      (t = this.updateParamObject(t, "langId", this.getValue(e, "langId"), !0)),
      (t = this.updateParamObject(
        t,
        "valueFromProfileOrder",
        this.getValue(e, "valueFromProfileOrder"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "valueFromPaymentTC",
        this.getValue(e, "valueFromPaymentTC"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "paymentTCId",
        this.getValue(e, "paymentTCId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payMethodId",
        this.getValue(e, "payMethodId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "piAmount",
        this.getValue(e, "piAmount"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "billing_address_id",
        this.getValue(e, "billing_address_id"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "cc_brand",
        this.getValue(e, "cc_brand"),
        !0
      )),
      (t = this.updateParamObject(t, "cc_cvc", this.getValue(e, "cc_cvc"), !0)),
      (t = this.updateParamObject(
        t,
        "account",
        this.getValue(e, "account"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_month",
        this.getValue(e, "expire_month"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_year",
        this.getValue(e, "expire_year"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "check_routing_number",
        this.getValue(e, "check_routing_number"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkingAccountNumber",
        this.getValue(e, "checkingAccountNumber"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkRoutingNumber",
        this.getValue(e, "checkRoutingNumber"),
        !0
      )),
      (t = this.updateParamObject(t, "requesttype", "ajax", !0)),
      e.authToken &&
        (t = this.updateParamObject(
          t,
          "authToken",
          this.getValue(e, "authToken"),
          !0
        )),
      t
    );
  },
  populateProtocolDataForGivenFields: function (e, t, r) {
    for (var s = 0; s < r.length; s++) {
      var a = r[s];
      t = this.updateParamObject(t, a, this.getValue(e, a), !0);
    }
    return (t = this.updateParamObject(t, "requesttype", "ajax", !0));
  },
  getSelected: function (e, t) {
    if (null != e[t]) {
      var r = e[t],
        s = r.selectedIndex;
      return -1 !== s ? r.options[s].text : "";
    }
    return "";
  },
  getValue: function (e, t) {
    return null != e[t] ? e[t].value : " ";
  },
  trim: function (e) {
    word = e.toString();
    for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
    for (; " " == word.charAt(r); ) r -= 1;
    return t > r ? word.substring(t, t) : word.substring(t, r + 1);
  },
  isNumber: function (e) {
    for (var t = "0123456789", e = this.trim(e), r = 0; r < e.length; r++)
      if (-1 == t.indexOf(e.charAt(r))) return !1;
    return !0;
  },
  formatAmountDisplayForLocale: function (e) {
    var t = document.getElementById("piAmount_" + e),
      r = document.getElementById("piAmount_" + e + "_display");
    if ("ar-eg" == this.jQlocale)
      var s = Utils.formatNumber(t.value, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    else if (
      0 === this.jQlocale.indexOf("zh") ||
      0 === this.jQlocale.indexOf("ja") ||
      0 === this.jQlocale.indexOf("ko")
    )
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        maximumFractionDigits: 1,
      });
    else
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    (r.value != s || "ar-eg" == this.jQlocale) && (r.value = s);
  },
  validateAmount: function (e, t) {
    var r = document.forms[e + t];
    (r.piAmount_display.value = r.piAmount_display.value.replace(
      /^\s+|\s+$/g,
      ""
    )),
      (r.piAmount_display.value = r.piAmount_display.value.replace(
        /\xa0/g,
        ""
      ));
    var s = r.piAmount_display.value;
    if ("ar-eg" == this.jQlocale) {
      s = s.replace(",", "");
      var a = Utils.formatNumber(s, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } else var a = Utils.parseNumber(s);
    if (
      (a != r.piAmount.value && (r.piAmount.value = a),
      null != r.piAmount && "" == r.piAmount.value)
    )
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_NO_AMOUNT
        ),
        !1
      );
    if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
        ),
        !1
      );
    if (null != r.piAmount && isNaN(r.piAmount.value))
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
        ),
        !1
      );
    var i = {};
    return (
      (i["paymentAreaAmount" + t] = a),
      wcRenderContext.updateRenderContext("paymentContext", i),
      !0
    );
  },
  validatePaymentTotals: function (e) {
    for (
      var t = parseFloat(0),
        r = document.getElementById("OrderTotalAmount").value,
        s = 1;
      s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms[e + s];
      if (!this.validateAmount(e, s)) return !1;
      t += parseFloat(a.piAmount.value);
      var i = t.toFixed(2);
      t = parseFloat(i);
    }
    if (t == r) return !0;
    var n = document.getElementsByName("piAmount_display")[0];
    return r > t
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT
        ),
        !1)
      : t > r
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages
            .EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT
        ),
        !1)
      : (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM
        ),
        !1);
  },
  isBillingAddressValid: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = r.billing_address_isValid;
      if (s && "false" == s.value) return !1;
    }
    return !0;
  },
  checkValidPaymentInstructions: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = " ";
      null != r["mandatoryFields_" + t] &&
        (s = r["mandatoryFields_" + t].value);
      var a = document.forms.purchaseOrderNumberInfo;
      if (a) {
        if (
          ((this.purchaseOrderNumber = a.purchase_order_number.value),
          "true" == a.purchaseOrderNumberRequired.value &&
            "" == a.purchase_order_number.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberEmpty
            ),
            !1
          );
        if (
          !MessageHelper.isValidUTF8length(a.purchase_order_number.value, 128)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberTooLong
            ),
            !1
          );
      }
      if (
        "select-one" == r.payMethodId.type &&
        "empty" ==
          r.payMethodId.options[r.payMethodId.options.selectedIndex].value
      )
        return (
          MessageHelper.formErrorHandleClient(
            r.payMethodId,
            this.errorMessages.EDPPaymentMethods_NO_PAYMENT_SELECTED
          ),
          !1
        );
      if (
        (CheckoutHelperJS.isPaymentDataDirty(t) &&
          null != document.getElementById("account_" + t) &&
          (document.getElementById("account_" + t).value =
            document.getElementById("account1_" + t).value),
        null != document.getElementById("expire_month_" + t) ||
          null != document.getElementById("expire_year_" + t))
      ) {
        var i = new Date(
            r.curr_year.value,
            r.curr_month.value - 1,
            r.curr_date.value
          ),
          n = 1,
          o = 1;
        null != document.getElementById("expire_month_" + t) &&
          ((o =
            new Number(document.getElementById("expire_month_" + t).value) + 1),
          o > 13 && (o = 1));
        var d = 2e3;
        null != document.getElementById("expire_year_" + t) &&
          (d = new Date(
            document.getElementById("expire_year_" + t).value,
            o - 1,
            n
          ));
      }
      if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
          ),
          !1
        );
      if (
        -1 != s.indexOf("account_" + t) &&
        null != document.getElementById("account_" + t) &&
        "" == document.getElementById("account_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ACCOUNT_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("expire_month_" + t) &&
        -1 != s.indexOf("expire_year_" + t) &&
        null != document.getElementById("expire_month_" + t) &&
        null != document.getElementById("expire_year_" + t) &&
        i >= d
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_INVALID_EXPIRY_DATE
          ),
          !1
        );
      if (null != r.piAmount && "" == r.piAmount.value)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_NO_AMOUNT
          ),
          !1
        );
      if (null != r.piAmount && isNaN(r.piAmount.value))
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
          ),
          !1
        );
      if (
        -1 != s.indexOf("check_routing_number_" + t) &&
        null != document.getElementById("check_routing_number_" + t) &&
        "" == document.getElementById("check_routing_number_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ROUTING_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("CheckAccount_" + t) &&
        null != document.getElementById("CheckAccount_" + t) &&
        "" == document.getElementById("CheckAccount_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BANK_ACCOUNT_NO
          ),
          !1
        );
      if (
        -1 != s.indexOf("billing_address_id") &&
        null != r.billing_address_id &&
        ("" == r.billing_address_id.value || "-1" == r.billing_address_id.value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BILLING_ADDRESS
          ),
          !1
        );
      if (
        CheckoutHelperJS.isPaymentDataDirty(t) &&
        -1 != s.indexOf("cc_cvc_" + t) &&
        null != document.getElementById("cc_cvc_" + t) &&
        null != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        "" != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        !this.isNumber(document.getElementById("cc_cvc_" + t).value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_CVV_NOT_NUMERIC
          ),
          !1
        );
    }
    return this.isBillingAddressValid(e)
      ? CheckoutHelperJS.isSinglePageCheckout() || this.validatePaymentTotals(e)
        ? !0
        : !1
      : (MessageHelper.displayErrorMessage(
          this.errorMessages.EDPPaymentMethods_BILLING_ADDRESS_INVALID
        ),
        !1);
  },
  updateExistingPiId: function (e, t) {
    if (null != e) {
      var r = document.forms[e + 1];
      r.existingPiId.value = t;
    }
  },
  updateParamObject: function (e, t, r, s, a) {
    if ((null == e && (e = []), null != e[t] && s))
      if ($.isArray(e[t])) null != a && "" != a ? (e[t][a] = r) : e[t].push(r);
      else {
        var i = e[t];
        (e[t] = []), e[t].push(i), e[t].push(r);
      }
    else if (null != a && "" != a && -1 != a) e[t + "_" + a] = r;
    else if (-1 == a) {
      for (var n = 1; null != e[t + "_" + n]; ) n++;
      e[t + "_" + n] = r;
    } else e[t] = r;
    return e;
  },
  saveBillingAddressDropDownBoxContextProperties: function (e, t) {
    for (var r = 1; 4 > r; r++) {
      var s = document.forms["PaymentForm" + r];
      if (s) {
        if (null != s.billing_address_id) {
          var a = s.billing_address_id.value;
          "create" == e && t == r && (a = "-1"),
            (wcRenderContext.getRenderContextProperties(
              "billingAddressDropDownBoxContext"
            )["billingAddress" + r] = a);
        }
      } else if (!(null == s && r > 1)) return;
    }
    if ("edit" == e) {
      var s = document.forms["PaymentForm" + t];
      if (s)
        for (var a = s.billing_address_id.value, r = 1; 4 > r; r++) {
          var i = document.forms["PaymentForm" + r];
          if (i) {
            var n = i.billing_address_id.value;
            n == a &&
              (wcRenderContext.getRenderContextProperties(
                "billingAddressDropDownBoxContext"
              )["billingAddress" + r] = "-1");
          }
        }
    }
  },
  createBillingAddress: function (e, t) {
    this.saveBillingAddressDropDownBoxContextProperties("create", e),
      CheckoutHelperJS.createAddress(-1, t);
  },
  displayBillingAddressDetails: function (e, t, r) {
    if (
      (-1 != e.value &&
        (document.getElementById("selectedAddressId_" + t).value = e.value),
      this.saveBillingAddressDropDownBoxContextProperties("create", "-1"),
      -1 != e.value)
    ) {
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey: e.value,
        areaNumber: t,
      });
    }
  },
  getTotalInJSON: function (e, t, r) {
    var s = {};
    (s.operation = e),
      (s.piFormName = t),
      (s.skipOrderPrepare = r),
      (s.storeId = this.storeId),
      (s.catalogId = this.catalogId),
      (s.langId = this.langId);
    var a = appendWcCommonRequestParameters("orderTotalAsJSON");
    wcTopic.publish("ajaxRequestInitiated"),
      $.ajax({
        url: a,
        method: "POST",
        dataType: "json",
        data: s,
        context: this,
        success: CheckoutPayments.updateAmountFieldsWithTotalInJSON,
        error: function (e, t, r) {
          console.debug("error - inside CheckoutPayments.getTotalInJSON()"),
            console.debug(r),
            wcTopic.publish("ajaxRequestCompleted");
        },
      });
  },
  updateAmountFieldsWithTotalInJSON: function (e, t, r) {
    null != e &&
      void 0 != e &&
      CheckoutPayments.updateAmountFields(
        e.orderTotal,
        e.operation,
        e.piFormName,
        e.skipOrderPrepare
      ),
      wcTopic.publish("ajaxRequestCompleted");
  },
  updateAmountFields: function (e, t, r, s) {
    var a,
      i = 0;
    if (
      ((this.numberOfPaymentMethods = document.getElementById(
        "numberOfPaymentMethods"
      ).value),
      null != document.getElementById("OrderTotalAmount") &&
        (document.getElementById("OrderTotalAmount").value = e),
      1 == this.numberOfPaymentMethods)
    )
      return (
        (a = document.forms.PaymentForm1),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = e),
          (a.piAmount_display.value = e),
          this.formatAmountDisplayForLocale("1"),
          null != this.retrievePaymentObject(1) &&
            this.updatePaymentObject(1, "piAmount")),
        void (void 0 != t && "OrderPrepare" == t
          ? this.processPIAndCheckout(r, s)
          : ((void 0 != t && "loadPaymentSnippet" == t) ||
              supportPaymentTypePromotions) &&
            this.currentPaymentMethodChanged &&
            (this.loadPaymentSnippet(
              document.getElementById(
                "payMethodId_" + this.currentPaymentMethodChanged
              ),
              this.currentPaymentMethodChanged
            ),
            this.updatePaymentObject(
              this.currentPaymentMethodChanged,
              "payMethodId"
            )))
      );
    for (var n = 1; n <= this.numberOfPaymentMethods; n++)
      (a = document.forms["PaymentForm" + n]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          (i = 1 * i + 1 * a.piAmount.value);
    var o = e - i;
    if (((o = Math.round(100 * o) / 100), o > 0)) {
      var d = this.numberOfPaymentMethods;
      (a = document.forms["PaymentForm" + d]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = parseFloat(a.piAmount.value) + parseFloat(o)),
          (a.piAmount_display.value = a.piAmount.value),
          this.formatAmountDisplayForLocale(d),
          null != this.retrievePaymentObject(d) &&
            this.updatePaymentObject(d, "piAmount"));
    } else {
      o = -1 * o;
      for (var l = this.numberOfPaymentMethods; l > 0; l--)
        if (
          ((a = document.forms["PaymentForm" + l]),
          null != a.piAmount &&
            "" != a.piAmount.value &&
            !isNaN(a.piAmount.value))
        ) {
          if (a.piAmount.value > o) {
            var c = a.piAmount.value - o;
            (a.piAmount.value = Math.round(100 * c) / 100),
              (a.piAmount_display.value = a.piAmount.value),
              this.formatAmountDisplayForLocale(l),
              null != this.retrievePaymentObject(l) &&
                this.updatePaymentObject(l, "piAmount"),
              (o = 0);
            break;
          }
          (o -= a.piAmount.value),
            (a.piAmount.value = 0),
            null != this.retrievePaymentObject(l) &&
              this.updatePaymentObject(l, "piAmount"),
            this.formatAmountDisplayForLocale(l);
        }
    }
    void 0 != t && "OrderPrepare" == t
      ? this.processPIAndCheckout(r, s)
      : void 0 != t &&
        "loadPaymentSnippet" == t &&
        this.currentPaymentMethodChanged &&
        (this.loadPaymentSnippet(
          document.getElementById(
            "payMethodId_" + this.currentPaymentMethodChanged
          ),
          this.currentPaymentMethodChanged
        ),
        this.updatePaymentObject(
          this.currentPaymentMethodChanged,
          "payMethodId"
        ));
  },
  removeCreditCardNumberAndCVV: function (e, t, r) {
    CheckoutHelperJS.isPaymentDataDirty(e) ||
      (t &&
        (null == document.forms["PaymentForm" + e].valueFromProfileOrder ||
          "Y" !=
            document.forms["PaymentForm" + e].valueFromProfileOrder.value) &&
        $("#account1_" + e).length &&
        $("#account1_" + e).val(""),
      r && $("#cc_cvc_" + e).length && $("#cc_cvc_" + e).val(""));
  },
  initializePaymentAreaDataDirtyFlags: function () {
    (CheckoutHelperJS.dataDirty[1] = !1),
      (CheckoutHelperJS.dataDirty[2] = !1),
      (CheckoutHelperJS.dataDirty[3] = !1);
  },
  initializeOverallPaymentObjects: function () {
    (this.prevNumberOfPaymentMethods = document.getElementById(
      "numberOfPaymentMethods"
    ).value),
      (this.numberOfPaymentMethods = parseInt(
        $("#numberOfPaymentMethods").val()
      ));
    for (
      var e = parseInt(this.maxNumberOfPaymentMethodsSupported), t = 1;
      e >= t;
      t++
    )
      this.initializePaymentObject(t);
    var r = document.forms.PaymentForm1.existingPiId.value,
      s = null;
    if (
      document.forms.PaymentForm1.unboundPiId &&
      ((s = document.forms.PaymentForm1.unboundPiId.value),
      null != s && "" != s)
    )
      var a = s.split(",");
    if (null != r && "" != r)
      for (var i = r.split(","), t = 0; t < i.length; t++) {
        var n = t + 1;
        if (
          ((this.retrievePaymentObject(n).piId = i[t]),
          (document.forms["PaymentForm" + n].piId.value = i[t]),
          n > this.numberOfPaymentMethods &&
            (this.retrievePaymentObject(n).action = "delete"),
          supportPaymentTypePromotions && null != s && "" != s)
        )
          for (var o = 0; o < a.length; o++)
            if (this.retrievePaymentObject(n).piId == a[o]) {
              this.retrievePaymentObject(n).action = "re-add";
              break;
            }
      }
    else this.retrievePaymentObject(1).action = "add";
    !supportPaymentTypePromotions ||
      ("Y" !=
        this.getValue(document.forms.PaymentForm1, "valueFromProfileOrder") &&
        "PayInStore" !=
          this.getValue(document.forms.PaymentForm1, "payMethodId")) ||
      (requestSubmitted
        ? (this.updatePaymentTypePromotionForProfileCheckoutHandler =
            wcTopic.subscribe("requestSubmittedChanged", function (e) {
              e ||
                (CheckoutPayments.updatePaymentTypePromotionForProfileCheckoutHandler.remove(),
                CheckoutPayments.updateUnboundPaymentToOrder());
            }))
        : this.updateUnboundPaymentToOrder());
  },
  initializePaymentObject: function (e) {
    var t = new Array();
    (t.piId = ""),
      (t.action = ""),
      (t.fields = new Array()),
      (t.options = ""),
      this.storePaymentObject(e, t);
  },
  storePaymentObject: function (e, t) {
    this.paymentObjects[e] = t;
  },
  retrievePaymentObject: function (e) {
    return this.paymentObjects[e];
  },
  updatePaymentObject: function (e, t) {
    var r = this.retrievePaymentObject(e);
    if (null != r) {
      if (
        (console.debug(t + " was changed."),
        "" == r.piId
          ? ((r.action = "add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'add'."
            ))
          : "piAmount" == t &&
            "add" != r.action &&
            "delete" != r.action &&
            "re-add" != r.action
          ? ((r.action = "update"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'update'."
            ))
          : ((r.action = "re-add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 're-add'."
            )),
        "piAmount" == t)
      ) {
        for (var s = !1, a = 0; a < r.fields.length; a++)
          if (r.fields[a] == t) {
            s = !0;
            break;
          }
        s || r.fields.push(t);
      }
    } else
      console.debug(
        "CheckoutPayemnts.updatePaymentObject -- payment object not found."
      );
  },
  setPaymentsToDelete: function (e) {
    this.paymentsToDelete.push(e);
  },
  getPaymentsToDelete: function () {
    return this.paymentsToDelete;
  },
  setPaymentsToAdd: function (e) {
    this.paymentsToAdd.push(e);
  },
  getPaymentsToAdd: function () {
    return this.paymentsToAdd;
  },
  setPaymentsToUpdate: function (e) {
    this.paymentsToUpdate.push(e);
  },
  getPaymentsToUpdate: function () {
    return this.paymentsToUpdate;
  },
  deletePaymentInstructions: function () {
    var e = [];
    if (((e.piId = new Array()), this.getPaymentsToDelete().length > 0)) {
      var t = this.getPaymentsToDelete().pop();
      e.piId.push(document.forms["PaymentForm" + t].piId.value),
        (e.storeId = this.storeId),
        (e.catalogId = this.catalogId),
        (e.paymentAreaNumber = t),
        (e.langId = this.langId),
        null != document.forms.PaymentForm1.authToken &&
          (e.authToken = document.forms.PaymentForm1.authToken.value),
        (e.orderId = ".");
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxDeletePaymentInstructionFromThisOrder", e));
  },
  addPaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToAdd().length > 0) {
      var t = this.getPaymentsToAdd().pop(),
        r = document.forms["PaymentForm" + t];
      e = this.populateProtocolData(r, e);
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxAddPaymentInstructionToThisOrder", e));
  },
  updatePaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToUpdate().length > 0) {
      var t = this.getPaymentsToUpdate().pop(),
        r = document.forms["PaymentForm" + t],
        s = this.retrievePaymentObject(t);
      s.fields.push("storeId"),
        s.fields.push("catalogId"),
        s.fields.push("langId"),
        s.fields.push("piId"),
        s.fields.push("payMethodId"),
        s.fields.push("authToken"),
        s.fields.push("orderId"),
        (document.forms["PaymentForm" + t].paymentDataEditable.value = !1),
        s.fields.push("paymentDataEditable"),
        (e = this.populateProtocolDataForGivenFields(r, e, s.fields));
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxUpdatePaymentInstructionInThisOrder", e));
  },
  reinitializePaymentObjects: function (e) {
    supportPaymentTypePromotions && this.updateUnboundPaymentToOrder();
    var t = parseInt(e.value),
      r = parseInt(this.prevNumberOfPaymentMethods),
      s = parseInt(this.maxNumberOfPaymentMethodsSupported);
    if (r > t)
      for (var a = t + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" == i.piId
          ? (i.action = "")
          : ((i.action = "delete"),
            console.debug(
              "The action in the payment object associated with payment area " +
                a +
                " was updated to 'delete'."
            ));
      }
    else if (t > r)
      for (var a = r + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" != i.piId
          ? a > t && s >= a
            ? ("delete" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 'delete'."
              ))
            : ("re-add" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 're-add'."
              ))
          : (this.initializePaymentObject(a),
            console.debug(
              "A new payment object was initialized to be associated with payment area " +
                a +
                "."
            ));
      }
    this.prevNumberOfPaymentMethods = t;
  },
  setPaymentFormPiId: function (e, t) {
    var r = document.forms["PaymentForm" + e];
    r && (r.piId.value = t);
  },
  updateUnboundPaymentToOrder: function (e) {
    this.currentPaymentMethodChanged = e;
    var t = document.forms.PaymentForm1,
      r = this.getValue(t, "piId");
    if (null != r && "" != r) {
      var s = [];
      if (
        ((s.storeId = this.storeId),
        (s.catalogId = this.catalogId),
        (s.langId = this.langId),
        (s.orderId = "."),
        (s.piId = ""),
        !submitRequest())
      )
        return;
      cursor_wait(),
        wcService.invoke("AjaxDeleteUnboundPaymentInstructionFromThisOrder", s);
    } else
      this.isSinglePaymentType()
        ? this.addNewUnboundPaymentInstruction()
        : e &&
          (this.loadPaymentSnippet(
            document.getElementById("payMethodId_" + e),
            e
          ),
          this.updatePaymentObject(e, "payMethodId"));
  },
  addNewUnboundPaymentInstruction: function () {
    var e = document.forms.PaymentForm1,
      t = [];
    if (
      ((t.storeId = this.storeId),
      (t.catalogId = this.catalogId),
      (t.langId = this.langId),
      null != document.forms.PaymentForm1.authToken &&
        (t.authToken = document.forms.PaymentForm1.authToken.value),
      (t.payMethodId = this.getValue(e, "payMethodId", !0)),
      (t.unbound = !0),
      "empty" != t.payMethodId && "" != t.payMethodId)
    ) {
      if (!submitRequest()) return;
      cursor_wait(),
        wcService.invoke("AjaxAddUnboundPaymentInstructionToThisOrder", t);
    }
  },
  isSinglePaymentType: function () {
    for (
      var e = document.forms.PaymentForm1,
        t = this.getValue(e, "payMethodId"),
        r = "empty" != t && "" != t,
        s = 2;
      r && s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms["PaymentForm" + s],
        i = this.getValue(a, "payMethodId");
      r = i == t;
    }
    return r;
  },
}),
  (PromotionChoiceOfFreeGiftsJS = {
    disableApplyButton: !1,
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    updateRewardChoices: function (e, t, r, s) {
      if (this.disableApplyButton) return !1;
      var a = [],
        i = [],
        n = [],
        o = 0;
      (a.storeId = this.storeId),
        (a.orderId = s),
        (a.rewardOptionId = r),
        CheckoutHelperJS.shoppingCartPage
          ? (a.calculationUsage = "-1,-2,-5,-6,-7")
          : (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      for (var d = 0; t > d; d++)
        document.getElementById("no_gifts").checked ||
          (document.getElementById("SelectFreeGift_" + (d + 1)).checked &&
            ((i[o] = document.getElementById(
              "CatalogEntryID_" + (d + 1)
            ).value),
            (n[o] = document.getElementById(
              "GiftItemQuantity_" + (d + 1)
            ).value),
            o++));
      (a.catEntryId = i),
        (a.quantity = n),
        submitRequest() &&
          (cursor_wait(),
          wcService.invoke("AjaxUpdateRewardOption", a),
          setTimeout($.proxy(this, "hidePopup", "free_gifts_popup"), 200),
          $("#free_gifts_popup").data("wc-WCDialog").close());
    },
    checkNumberOfAllowedItems: function (e) {
      var t = 1,
        r = 0;
      for (
        this.disableApplyButton = !1;
        document.getElementById("SelectFreeGift_" + t);

      )
        document.getElementById("SelectFreeGift_" + t).checked && r++, t++;
      if (r > e)
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "error"),
          (document.getElementById("message").innerHTML =
            MessageHelper.messages.PROMOTION_FREE_GIFTS_POPUP_ERROR_EXCEED_GIFT_QUANTITY)),
          (this.disableApplyButton = !0);
      else if (r > 0) {
        if (1 == r)
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS_ONE;
        else {
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS;
          s = s.replace(/%0/, r);
        }
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "status_message"),
          (document.getElementById("message").innerHTML = s));
      } else
        0 == r &&
          (null != document.getElementById("message") &&
            (document.getElementById("message").innerHTML = "&nbsp;"),
          (this.disableApplyButton = !0));
    },
    rewardChoicesEnabledStatus: function () {
      var e = 1;
      if (document.getElementById("no_gifts").checked)
        for (
          this.disableApplyButton = !1,
            null != document.getElementById("message") &&
              (document.getElementById("message").innerHTML = "&nbsp;");
          document.getElementById("SelectFreeGift_" + e);

        )
          (document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0),
            e++;
      else {
        for (; document.getElementById("SelectFreeGift_" + e); )
          (document.getElementById("SelectFreeGift_" + e).disabled = !1), e++;
        this.checkNumberOfAllowedItems(), this.checkFreeGiftsAvailability();
      }
    },
    showFreeGiftsDialog: function () {
      this.checkNumberOfAllowedItems(),
        $("#free_gifts_popup").data("wc-WCDialog").open(),
        this.checkFreeGiftsAvailability();
    },
    checkFreeGiftsAvailability: function () {
      for (
        var e = 1, t = 0;
        document.getElementById("OnlineAvailability_" + e);

      )
        "Available" !=
          document.getElementById("OnlineAvailability_" + e).value &&
        "Backorderable" !=
          document.getElementById("OnlineAvailability_" + e).value
          ? ((document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0))
          : t++,
          e++;
      0 == t && (this.disableApplyButton = !0);
    },
    hideFreeGiftsPopup: function (e, t) {
      if (null == t || "keypress" != t.type || t.keyCode == KeyCodes.ESCAPE) {
        var r = $("#" + e).data("wc-WCDialog");
        r && r.close();
      }
    },
  }),
  ("undefined" != typeof PunchoutJS &&
    PunchoutJS &&
    PunchoutJS.topicNamespace) ||
    (PunchoutJS = {
      divId: "",
      sameWindow: !0,
      displayPopup: function () {
        if (!$("#punchout_popup_container").length)
          return void console.debug(
            "PunchoutJS.displayPopup: element with Id punchout_popup_container was not found on the page."
          );
        $("#punchout_popup_container").show();
        var e = $("<div id='pageMask'/>").appendTo($("body"));
        $(e).css({
          position: "absolute",
          "z-index": 949,
          top: "0px",
          left: "0px",
          width: $("body").innerWidth() + "px",
          height: $("body").innerHeight() + "px",
          background: "#000",
          opacity: "0.40",
        }),
          setTimeout("$('#punchout_popup_close_icon').focus()", 1e3);
      },
      handleResponse: function (e) {
        var t = this.divId,
          r = this.sameWindow,
          s = document.getElementById(t),
          a = s.innerHTML.replace(/(^\s*)|(\s*$)/g, ""),
          i = a.toLowerCase();
        if (0 !== i.indexOf("<form") && 0 !== i.indexOf("&lt;form")) {
          0 !== i.indexOf("<a") && 0 !== i.indexOf("&lt;a")
            ? (s.innerHTML = '<a name="punchout_anchor" href="' + a + '" />')
            : (s.innerHTML = a);
          var n = s.childNodes[0];
          r
            ? (window.location = n.href)
            : ((n.target = "_blank"), window.open(n.href));
        } else {
          s.innerHTML = a;
          var o = s.childNodes[0];
          (o.name = "punchout_form"),
            r ? o.submit() : ((o.target = "_blank"), o.submit());
        }
      },
      pay: function (e, t, r, s, a) {
        (this.divId = s),
          (this.sameWindow = a),
          (params = []),
          (params.storeId = e),
          (params.orderId = t),
          (params.piId = r);
        var i = document.forms.punchoutPaymentRedirectForm_AuthTokenInfo,
          n = i.punchoutPaymentRedirect_authToken.value;
        (params.authToken = n),
          submitRequest() &&
            (cursor_wait(), wcService.invoke("AjaxPunchoutPay", params));
      },
      handleKeyPress: function (e) {
        e.keyCode !== KeyCodes.TAB &&
          e.keyCode !== KeyCodes.SHIFT &&
          location.reload();
      },
      focusElement: function (e) {
        $("#" + e).length ||
          console.debug(
            "PunchoutJS.focusElement: element with Id " +
              e +
              " was not found on the page."
          ),
          $("#" + e).focus();
      },
    }),
  (ShipmodeSelectionExtJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    BOPISEnabled: !1,
    orderItemId: "",
    isPickUpInStore: function () {
      var e = this.getShipTypeValue();
      return "pickUp" == e ? !0 : !1;
    },
    getShipTypeValue: function () {
      if (void 0 != document.BOPIS_FORM)
        for (var e = 0; e < document.BOPIS_FORM.shipType.length; e++)
          if (document.BOPIS_FORM.shipType[e].checked)
            return document.BOPIS_FORM.shipType[e].value;
    },
    getShipTypeValueFromCookieForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t == e) {
        var r = getCookie("WC_shipTypeValue");
        return r;
      }
      return "";
    },
    setShipTypeValueToCookieForOrder: function (e, t) {
      var r = e;
      if (null != r && "undefined" != r && "" != r) {
        var s = getCookie("WC_shipTypeValueOrderId");
        s != t &&
          (setCookie("WC_shipTypeValueOrderId", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValueOrderId", t, {
            path: "/",
            domain: cookieDomain,
          }));
        var a = this.getShipTypeValueFromCookieForOrder(t);
        r != a &&
          (setCookie("WC_shipTypeValue", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValue", r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
      "pickUp" == r
        ? document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "none"),
          setCookie("WC_recurringOrder_" + t, "false", {
            path: "/",
            domain: cookieDomain,
          }),
          document.getElementById("recurringOrder") &&
            (document.getElementById("recurringOrder").checked = !1),
          this.hideShowNonRecurringOrderMsg(t))
        : "shopOnline" == r &&
          document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "block"),
          this.hideShowNonRecurringOrderMsg(t));
    },
    displaySavedShipmentTypeForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t != e)
        setCookie("WC_shipTypeValueOrderId", null, {
          expires: -1,
        }),
          setCookie("WC_shipTypeValue", null, {
            expires: -1,
          });
      else {
        var r = this.getShipTypeValueFromCookieForOrder(e);
        "pickUp" == r
          ? 0 == document.getElementById("shipTypePickUp").disabled
            ? ((document.getElementById("shipTypePickUp").checked = !0),
              document.getElementById("scheduling_options") &&
                ((document.getElementById("scheduling_options").style.display =
                  "none"),
                setCookie("WC_recurringOrder_" + e, "false", {
                  path: "/",
                  domain: cookieDomain,
                }),
                document.getElementById("recurringOrder") &&
                  (document.getElementById("recurringOrder").checked = !1)))
            : ((document.getElementById("shipTypeOnline").checked = !0),
              document.getElementById("scheduling_options") &&
                (document.getElementById("scheduling_options").style.display =
                  "block"),
              this.setShipTypeValueToCookieForOrder("shopOnline", e))
          : "shopOnline" == r &&
            ((document.getElementById("shipTypeOnline").checked = !0),
            document.getElementById("scheduling_options") &&
              (document.getElementById("scheduling_options").style.display =
                "block"));
      }
      this.hideShowNonRecurringOrderMsg(e, !0);
    },
    hideShowNonRecurringOrderMsg: function (e, t) {
      if (
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked) ||
        (document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          null == document.getElementById("shipTypeOnline"))
          ? setCookie("WC_recurringOrder_" + e, "true", {
              path: "/",
              domain: cookieDomain,
            })
          : setCookie("WC_recurringOrder_" + e, "false", {
              path: "/",
              domain: cookieDomain,
            }),
        document.getElementById("nonRecurringOrderItems") &&
          "" != document.getElementById("nonRecurringOrderItems").value)
      ) {
        if (
          document.getElementById("nonRecurringOrderItemsCount") &&
          document.getElementById("numOrderItemsInOrder")
        ) {
          var r = document.getElementById("numOrderItemsInOrder").value,
            s = document.getElementById("nonRecurringOrderItemsCount").value;
          if (r == s && document.getElementById("scheduling_options"))
            return (
              (document.getElementById("scheduling_options").style.display =
                "none"),
              setCookie("WC_recurringOrder_" + e, "false", {
                path: "/",
                domain: cookieDomain,
              }),
              void (
                document.getElementById("recurringOrder") &&
                (document.getElementById("recurringOrder").checked = !1)
              )
            );
        }
        for (
          var a = document.getElementById("nonRecurringOrderItems").value,
            i = a.split(","),
            n = 0;
          n < i.length;
          n++
        )
          document.getElementById("nonRecurringItem_" + i[n]) &&
            ((document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              document.getElementById("shipTypeOnline") &&
              document.getElementById("shipTypeOnline").checked) ||
            (document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              null == document.getElementById("shipTypeOnline"))
              ? (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "block")
              : (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "none"));
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked &&
          !t) ||
          (document.getElementById("recurringOrder") &&
            document.getElementById("recurringOrder").checked &&
            null == document.getElementById("shipTypeOnline") &&
            !t)) &&
          MessageHelper.displayErrorMessage(
            MessageHelper.messages.RECURRINGORDER_ERROR
          );
      }
    },
    registeredUserContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest())
        if (this.isBOPISEnabled() && this.isPickUpInStore())
          document.location.href = appendWcCommonRequestParameters(t);
        else {
          var r =
              ("RESTOrderItemUpdate?remerge=***&check=*n&allocate=***&backorder=***&calculationUsage=-1,-2,-3,-4,-5,-6,-7&calculateOrder=1&orderItemId=" +
                this.orderItemId +
                "&errorViewName=AjaxOrderItemDisplayView&orderId=.&URL=",
              []),
            s = "AjaxRESTOrderItemUpdate",
            a = [];
          (a.remerge = "***"),
            (a.check = "*n"),
            (a.allocate = "***"),
            (a.backorder = "***"),
            (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (a.calculateOrder = "1"),
            (a.orderItemId = this.orderItemId),
            (a.orderId = "."),
            (a.storeId = this.storeId),
            r.push({
              URL: e,
              requestType: "GET",
              requestParams: {},
            });
          var i = getCustomServiceForURLChaining(s, r, null);
          i.invoke(a);
        }
    },
    guestShopperContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest()) {
        var r = [];
        if (this.isBOPISEnabled() && this.isPickUpInStore()) {
          var s = $("#existingPaymentInstructionId").val();
          if ("" != s) {
            for (var a = s.split(","), i = 1; i < a.length; i++)
              r.push({
                URL: "AjaxRESTOrderPIDelete",
                requestParams: {
                  piId: a[i],
                },
              });
            r.push({
              URL: t,
              requestType: "GET",
            });
            var n = [];
            n.piId = a[0];
            var o = getCustomServiceForURLChaining(
              "AjaxRESTOrderPIDelete",
              r,
              null
            );
            o.invoke(n);
          } else document.location.href = t;
        } else {
          var n = [];
          (n.remerge = "***"),
            (n.check = "*n"),
            (n.allocate = "***"),
            (n.backorder = "***"),
            (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (n.calculateOrder = "1"),
            (n.orderItemId = this.orderItemId),
            (n.orderId = "."),
            (n.storeId = this.storeId);
          var r = [];
          r.push({
            URL: e,
            requestType: "GET",
            requestParams: {
              guestChkout: "1",
            },
          });
          var o = getCustomServiceForURLChaining(
            "AjaxRESTOrderItemUpdate",
            r,
            null
          );
          o.invoke(n);
        }
      }
    },
    guestShopperLogon: function (e, t, r) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      var s = "";
      (s = this.isBOPISEnabled() && this.isPickUpInStore() ? r : t),
        (document.AjaxLogon.URL.value = s),
        (document.location.href = e);
    },
    updateCartWithQuickCheckoutProfile: function (e) {
      if (this.isBOPISEnabled() && this.isPickUpInStore())
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.message_QUICK_CHKOUT_ERR
        );
      else {
        if (CheckoutHelperJS.getFieldDirtyFlag())
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
          );
        CheckoutHelperJS.setCommonParameters(
          this.langId,
          this.storeId,
          this.catalogId
        ),
          CheckoutHelperJS.updateCartWithQuickCheckoutProfile(e);
      }
    },
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setOrderItemId: function (e) {
      this.orderItemId = e;
    },
    setBOPISEnabled: function (e) {
      this.BOPISEnabled = e;
    },
    isBOPISEnabled: function () {
      return this.BOPISEnabled;
    },
    submitStoreSelectionForm: function (e) {
      var t = PhysicalStoreCookieJSStore.getPickUpStoreIdFromCookie();
      null != t && "" != t
        ? ((e.physicalStoreId.value = t), processAndSubmitForm(e))
        : null != document.getElementById("storeSelection_NextButton")
        ? MessageHelper.formErrorHandleClient(
            document.getElementById("storeSelection_NextButton"),
            MessageHelper.messages.message_NO_STORE
          )
        : MessageHelper.displayErrorMessage(
            MessageHelper.messages.message_NO_STORE
          );
    },
    submitAddressForm: function (e, t, r) {
      var s = document.forms[e];
      "" != t && AddressHelper.setStateDivName(t);
      var a = !1;
      $("#payInStorePaymentOption").is(":checked") && (a = !0);
      var i = [],
        n = [];
      if (r)
        var o = null,
          d = null;
      else if (AddressHelper.validateAddressForm(s))
        var o = $(s).attr("action"),
          d = s.id;
      var l = $("#existingPaymentInstructionId").val();
      if ("" != l) {
        var c = l.split(",");
        if (null == o) {
          var o = "AjaxRESTOrderPIDelete";
          n.piId = c[0];
        } else
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[0],
            },
          });
        for (var u = 1; u < c.length; u++)
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[u],
            },
          });
      }
      var m = [];
      (m.remerge = "***"),
        (m.check = "*n"),
        (m.allocate = "***"),
        (m.backorder = "***"),
        (m.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (m.calculateOrder = "1"),
        (m.orderItemId = this.orderItemId),
        (m.orderId = "."),
        (m.storeId = this.storeId),
        null == o
          ? ((o = "AjaxRESTOrderItemUpdate"), (n = m))
          : i.push({
              URL: "AjaxRESTOrderItemUpdate",
              requestParams: m,
            }),
        i.push({
          URL: "DOMOrderShippingBillingView",
          requestType: "GET",
          requestParams: {
            payInStore: a,
          },
        });
      var g = getCustomServiceForURLChaining(o, i, d);
      g.invoke(n);
    },
  }),
  (SBControllersDeclarationJS = {
    singlePageCheckout: !0,
    shipChargeEnabled: !1,
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
    setShipChargeEnabled: function (e) {
      this.shipChargeEnabled = e;
    },
  }),
  (SBServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    singlePageCheckout: !0,
    orderPrepare: !1,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), CheckoutHelperJS.deleteFromCart(e.orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate",
    actionId: "OrderItemAddressShipMethodUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderShipChargeUpdate",
    actionId: "AjaxOrderShipChargeUpdate",
    url: "AjaxShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        wcService.invoke("AjaxPrepareOrderForShipChargeUpdate", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForShipChargeUpdate",
    actionId: "AjaxPrepareOrderForShipChargeUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate",
    actionId: "OrderItemAddressShipInstructionsUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      if (
        ((t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        null != document.getElementById("shipInstructions"))
      ) {
        var r = document.getElementById("shipInstructions").value,
          s = document.getElementById("orderItem_1").value;
        (t.shipInstructions = r),
          (t.orderItemId = s),
          wcService.invoke("OrderItemAddressShipInstructionsUpdate1", t);
      } else MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate1",
    actionId: "OrderItemAddressShipInstructionsUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate1",
    actionId: "OrderItemAddressShipMethodUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutHelperJS.storeId,
        r = CheckoutHelperJS.catalogId,
        s = CheckoutHelperJS.langId,
        a = e.orderId,
        i = document.getElementById("orderItem_1").value,
        n = document.getElementById("commonShipModeId").value;
      if (null != n && "undefined" != n) var o = n;
      else var o = document.getElementById("MS_ShippingMode_" + i).value;
      var d = [],
        l = "AjaxRESTOrderShipInfoUpdate",
        c = [];
      (c.remerge = "***"),
        (c.check = "*n"),
        (c.allocate = "***"),
        (c.backorder = "***"),
        (c.storeId = t),
        (c.catalogId = r),
        (c.langId = s),
        (c.orderId = a),
        (c.shipModeId = o),
        (c.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (c.calculateOrder = "1");
      var u = document.getElementById("purchase_order_number");
      if (u) {
        var m = u.value;
        null != m && "undefined" != m && "" != m && (c.purchaseorder_id = m);
      }
      (valueFromProfileOrderElement =
        document.getElementsByName("valueFromProfileOrder")[0] &&
        "Y" == valueFromProfileOrderElement.value) &&
        (c.quickCheckoutProfileForPayment = "true"),
        d.push({
          URL: "OrderShippingBillingView",
          requestType: "GET",
          requestParams: {},
        });
      var g = getCustomServiceForURLChaining(l, d, null);
      g.invoke(c);
    },
    failureHandler: function (e) {
      "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_SWITCH_SINGLE_SHIPMENT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItemsAddressId",
    actionId: "AjaxUpdateOrderItemsAddressId",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        (CheckoutHelperJS.orderItemIds = []),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddressInCheckOut",
    actionId: "AddBillingAddressInCheckOut",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        "" != this.formId &&
          document.getElementById(this.formId) &&
          (e.addBillingAddressInCheckOutAddressType = document.getElementById(
            this.formId
          ).addressType.value);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddressInCheckout",
    actionId: "UpdateBillingAddressInCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderShippingInfoUpdate",
    actionId: "OrderShippingInfoUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforeSubmit",
    actionId: "AjaxPrepareOrderBeforeSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON("OrderPrepare", "PaymentForm", !1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforePaymentCapture",
    actionId: "AjaxPrepareOrderBeforePaymentCapture",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutPayments.setCommonParameters(
        SBServicesDeclarationJS.langId,
        SBServicesDeclarationJS.storeId,
        SBServicesDeclarationJS.catalogId
      ),
        CheckoutPayments.showBillingPage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetAddressIdOfOrderItems",
    actionId: "AjaxSetAddressIdOfOrderItems",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        e.langId +
        "&storeId=" +
        e.storeId +
        "&catalogId=" +
        e.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetShipModeIdForOrder",
    actionId: "AjaxSetShipModeIdForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId;
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetRequestedShipDateForOrder",
    actionId: "AjaxSetRequestedShipDateForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeletePaymentInstructionFromThisOrder",
    actionId: "AjaxDeletePaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutPayments.retrievePaymentObject(e.paymentAreaNumber);
      if (
        ("undefined" != typeof t && (t.piId = ""),
        cursor_clear(),
        CheckoutPayments.getPaymentsToDelete().length < 1)
      )
        if ((cursor_clear(), CheckoutPayments.getPaymentsToAdd().length > 0))
          CheckoutPayments.addPaymentInstructions();
        else if (CheckoutPayments.getPaymentsToUpdate().length > 0)
          CheckoutPayments.updatePaymentInstructions();
        else {
          if (!submitRequest()) return;
          cursor_wait(),
            CheckoutPayments.setCommonParameters(
              SBServicesDeclarationJS.langId,
              SBServicesDeclarationJS.storeId,
              SBServicesDeclarationJS.catalogId
            ),
            CheckoutPayments.showSummaryPage(),
            cursor_clear();
        }
      else CheckoutPayments.deletePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToDelete = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPaymentInstructionToThisOrder",
    actionId: "AjaxAddPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      if (CheckoutPayments.getPaymentsToAdd().length < 1) {
        if (CheckoutPayments.getPaymentsToUpdate().length > 0) {
          CheckoutPayments.updatePaymentInstructions();
        } else {
          if (!submitRequest()) {
            return;
          }

          //setCurrentId('singleOrderSummary');
          resetRequest();
          //showLoadingInternal(true,'shippingBillingPageNext');
          CheckoutHelperJS.checkoutOrder(
            CheckoutHelperJS.getSavedParameter("tempOrderId"),
            CheckoutHelperJS.getSavedParameter("tempUserType"),
            CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
            CheckoutHelperJS.getSavedParameter("tempIsQuote")
          );
        }
      } else {
        CheckoutPayments.addPaymentInstructions();
      }
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToAdd = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear(),
        supportPaymentTypePromotions &&
          1 == CheckoutPayments.numberOfPaymentMethods &&
          CheckoutPayments.addNewUnboundPaymentInstruction();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePaymentInstructionInThisOrder",
    actionId: "AjaxUpdatePaymentInstructionInThisOrder",
    url: "AjaxRESTOrderPIUpdate",
    formId: "",
    successHandler: function (e) {
      if ((cursor_clear(), CheckoutPayments.getPaymentsToUpdate().length < 1)) {
        if (!submitRequest()) return;
        cursor_wait(),
          CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear();
      } else CheckoutPayments.updatePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToUpdate = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddUnboundPaymentInstructionToThisOrder",
    actionId: "AjaxAddUnboundPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.setPaymentFormPiId(1, e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].piId =
          e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].action = "re-add");
      var t = [];
      (t.orderId = e.orderId),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        cursor_wait(),
        wcService.invoke("AjaxPrepareOrderForPaymentSubmit", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    actionId: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      for (var t = 1; t < CheckoutPayments.paymentObjects.length; t++)
        $("#account1_" + t).length &&
          (CheckoutPayments.removeCreditCardNumberAndCVV(t, !0, !0),
          CheckoutHelperJS.paymentDataDirty(t, !0)),
          CheckoutPayments.setPaymentFormPiId(t, ""),
          (CheckoutPayments.paymentObjects[t].piId = ""),
          t > CheckoutPayments.numberOfPaymentMethods
            ? (CheckoutPayments.paymentObjects[t].action = "")
            : (CheckoutPayments.paymentObjects[t].action = "add");
      if (CheckoutPayments.isSinglePaymentType())
        CheckoutPayments.addNewUnboundPaymentInstruction();
      else {
        var r = [];
        (r.orderId = e.orderId),
          (r.storeId = CheckoutHelperJS.storeId),
          (r.catalogId = CheckoutHelperJS.catalogId),
          (r.langId = CheckoutHelperJS.langId),
          cursor_wait(),
          wcService.invoke("AjaxPrepareOrderForPaymentSubmit", r);
      }
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForPaymentSubmit",
    actionId: "AjaxPrepareOrderForPaymentSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON(
          "loadPaymentSnippet",
          "PaymentForm",
          !0
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  flowEnabled.SideBySideIntegration &&
    ((CallCenterIntegrationJS = function () {
      (this.lookUpMode = "lookup"),
        (this.normalMode = "normal"),
        (this.setUpCookies = function (e) {
          var t = "WCC_Mode_" + WCParamJS.storeId;
          void 0 != e &&
            null != e &&
            (e.length > 0
              ? setCookie("WCC_Mode_" + WCParamJS.storeId, escapeXml(e, !0), {
                  path: "/",
                  domain: cookieDomain,
                })
              : removeCookie(t));
        }),
        (this.updateWCParamJS = function (e, t) {
          WCParamJS[e] = t;
        }),
        (this.consumeAddToCartEvent = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode
            ? ((e.action = "Sending_Product"),
              $.extend(e, t),
              (e = JSON.stringify(e)),
              console.debug(e),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : !1;
        }),
        (this.postActionMessage = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode || r == this.normalMode
            ? ((e.action = t),
              (e = JSON.stringify(e)),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : void 0;
        }),
        window.addEventListener("message", function (e) {
          if (e.origin != WCParamJS.wcc_integration_origin)
            return void console.warn(
              "Unexpected WCC Integration server - " + e.origin
            );
          try {
            console.debug(e.data);
            var t = JSON.parse(e.data);
            if (t.action && "Requesting_Cart_Details" === t.action) {
              var r = getCookie("WC_CartOrderId_" + WCParamJS.storeId),
                s = {};
              (s.storeId = WCParamJS.storeId),
                (s.action = "Sending_Cart"),
                (s.custId = WCParamJS.logonId),
                (s.orderId = r),
                e.source.postMessage(JSON.stringify(s), e.origin);
            } else t.action && "ADD_TO_EXTERNAL_CART_SUCCESS" === t.action ? cursor_clear() : t.action && "TERMINATE_ON_BEHALF_SESSION" === t.action ? "undefined" != typeof GlobalLoginShopOnBehalfJS && void 0 != GlobalLoginShopOnBehalfJS && null != GlobalLoginShopOnBehalfJS && GlobalLoginShopOnBehalfJS.restoreCSRSessionAndRedirect(t.redirectURL) : t.action && "SET_USER_IN_SESSION" === t.action && "undefined" != typeof registeredCustomersJS && void 0 != registeredCustomersJS && null != registeredCustomersJS && registeredCustomersJS.setUserInSession(t.userId, t.userName, t.redirectURL);
          } catch (a) {
            console.warn("Unexpected message: " + e.data);
          }
        });
    }),
    $(document).ready(function () {
      callCenterIntegrationJS = new CallCenterIntegrationJS();
    })),
  (shoppingActionsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    userType: "",
    baseItemAddedToCart: !1,
    entitledItems: [],
    entitledItemJsonObject: null,
    selectedAttributesList: {},
    moreInfoUrl: "",
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArrayList: {},
    skuImageId: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    minNumberProductsAllowedToCompare: 2,
    baseCatalogEntryId: 0,
    selectedProducts: {},
    productList: {},
    currencySymbol: "",
    compareReturnName: "",
    searchTerm: "",
    search01: "'",
    search02: '"',
    replaceStr01: /\\\'/g,
    replaceStr02: /\\\"/g,
    ampersandChar: /&/g,
    ampersandEntityName: "&amp;",
    productAddedList: {},
    setCompareReturnName: function (e) {
      this.compareReturnName = e;
    },
    setSearchTerm: function (e) {
      this.searchTerm = e;
    },
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s),
        (this.currencySymbol = a);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    getCatalogEntryId: function (e) {
      var t = [],
        r = this.selectedAttributesList[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveSKU(t);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      if (1 == this.entitledItems.length)
        return this.entitledItems[0].catentry_id;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName],
              o = n.replace(this.search02, this.search01);
            (n in s || o in s) && i++;
          }
          if (a == i)
            return (
              console.debug("CatEntryId:" + t + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x),
              t
            );
        }
      }
      return null;
    },
    setSelectedAttribute: function (e, t, r, s, a) {
      console.debug(e + " : " + t);
      var i = this.selectedAttributesList[r];
      null == i && (i = {}),
        (t = t.replace(this.replaceStr01, this.search01)),
        (t = t.replace(this.replaceStr02, this.search02)),
        (t = t.replace(this.ampersandChar, this.ampersandEntityName)),
        (i[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t),
        (this.selectedAttributesList[r] = i),
        this.changeProdImage(r, e, t, s, a);
    },
    setSelectedAttributeOfProduct: function (
      productId,
      selectedAttributeName,
      selectedAttributeValue,
      isSingleSKU
    ) {
      var selectedAttributesForProduct = null;
      (selectedAttributesForProduct = this.selectedProducts[productId]
        ? this.selectedProducts[productId]
        : {}),
        null != selectedAttributeName &&
          "" != selectedAttributeName &&
          (selectedAttributesForProduct[selectedAttributeName] =
            selectedAttributeValue),
        (this.selectedProducts[productId] = selectedAttributesForProduct);
      var entitledItemJSON = eval(
        "(" + $("#entitledItem_" + productId).html() + ")"
      );
      this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryIdforProduct(
        selectedAttributesForProduct
      );
      if (null == catalogEntryId) catalogEntryId = 0;
      else if (
        (this.changePrice("entitledItem_" + productId, !1, !0, productId),
        "undefined" != typeof MerchandisingAssociationJS &&
          null != MerchandisingAssociationJS.baseItemParams &&
          "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
      )
        for (
          idx = 0;
          idx < MerchandisingAssociationJS.baseItemParams.components.length;
          idx++
        )
          productId ==
            MerchandisingAssociationJS.baseItemParams.components[idx]
              .productId &&
            (MerchandisingAssociationJS.baseItemParams.components[idx].id =
              catalogEntryId);
      var productDetails = null;
      this.productList[productId]
        ? (productDetails = this.productList[productId])
        : ((productDetails = {}),
          (this.productList[productId] = productDetails),
          (productDetails.baseItemId = productId)),
        (productDetails.id = catalogEntryId),
        productDetails.quantity &&
          wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails)),
        isSingleSKU ||
          (0 != catalogEntryId
            ? wcTopic.publish(
                "DefiningAttributes_Resolved_" + productId,
                catalogEntryId,
                productId
              )
            : wcTopic.publish(
                "DefiningAttributes_Changed_" + productId,
                catalogEntryId,
                productId
              ));
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      var dialog = $("#quick_cart_container").data("wc-WCDialog");
      if ((dialog && dialog.close(), browseOnly))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId) {
        var productId = entitledItemId.substring(
          entitledItemId.indexOf("_") + 1
        );
        this.AddItem2ShopCartAjax(
          catalogEntryId,
          quantity,
          customParams,
          productId
        ),
          (this.baseItemAddedToCart = !0);
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLinkAjax",
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ))
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ),
            (this.baseItemAddedToCart = !1));
    },
    AddItem2ShopCartAjax: function (e, t, r, s) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var a = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (a.inventoryValidation = "true"), (a.calculateOrder = "0");
      var i = "AddOrderItem";
      if (((this.productAddedList = {}), Array.isArray(e) && Array.isArray(t)))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (a["catEntryId_" + (n + 1)] = e[n]),
            (a["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
          );
        (a.catEntryId = e), (a.quantity = t);
        var o = {};
        for (attr in this.selectedAttributesList["entitledItem_" + s])
          o[attr] = this.selectedAttributesList["entitledItem_" + s][attr];
        void 0 == s
          ? this.saveAddedProductInfo(t, e, e, o)
          : this.saveAddedProductInfo(t, s, e, o);
      }
      if (null != r && "undefined" != r) {
        for (n in r) a[n] = r[n];
        "dynamicKit" == r.catalogEntryType && (i = "AddPreConfigurationToCart");
      }
      var d = document.getElementsByName("contractSelectForm_contractId");
      if (null != d && "undefined" != d)
        for (n = 0; n < d.length; n++)
          if (d[n].checked) {
            a.contractId = d[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(i, a),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    AddBundle2ShopCartAjax: function () {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var e = "AddOrderItem",
        t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          orderId: ".",
          inventoryValidation: "true",
          calculateOrder: "0",
        },
        r = 1;
      this.productAddedList = {};
      for (productId in this.productList) {
        var s = this.productList[productId],
          a = Utils.parseNumber(s.quantity);
        if (0 != a) {
          if (0 == s.id)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            );
          if (isNaN(a) || 0 > a)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (t["catEntryId_" + r] = s.id),
            (t["quantity_" + r++] = a),
            (this.baseItemAddedToCart = !0),
            this.saveAddedProductInfo(
              a,
              productId,
              s.id,
              this.selectedProducts[productId]
            );
        }
      }
      submitRequest() && (cursor_wait(), wcService.invoke(e, t));
    },
    resetProductAddedList: function () {
      shoppingActionsJS.productAddedList = {};
    },
    saveAddedProductInfo: function (e, t, r, s) {
      var a = "";
      $("#ProductInfoName_" + t).length
        ? (a = document.getElementById("ProductInfoName_" + t).value)
        : $("#ProductInfoName_" + r).length &&
          (a = document.getElementById("ProductInfoName_" + r).value);
      var i = "";
      $("#ProductInfoImage_" + t).length
        ? (i = document.getElementById("ProductInfoImage_" + t).value)
        : $("#ProductInfoImage_" + r).length &&
          (i = document.getElementById("ProductInfoImage_" + r).value);
      var n = "";
      $("#ProductInfoPrice_" + t).length
        ? (n = document.getElementById("ProductInfoPrice_" + t).value)
        : $("#ProductInfoPrice_" + r).length &&
          (n = document.getElementById("ProductInfoPrice_" + r).value);
      var o = [a, i, n, e, s];
      t != r ? (this.productAddedList[r] = o) : (this.productAddedList[t] = o),
        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },
    setSKUImageId: function (e) {
      this.skuImageId = e;
    },
    getImageForSKU: function (e, t) {
      var r = [],
        s = this.selectedAttributesList[e];
      for (attribute in s) r.push(attribute + "_|_" + s[attribute]);
      return this.resolveImageForSKU(r, t);
    },
    resolveImageForSKU: function (e, t) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var r = "",
        s = e.length;
      for (x in this.entitledItems) {
        if (null != t) var r = this.entitledItems[x][t];
        else var r = this.entitledItems[x].ItemImage467;
        var a = this.entitledItems[x].Attributes,
          i = 0;
        for (index in a) i++;
        if (0 == s && 0 == i) return r;
        if (0 != i && s >= i) {
          var n = 0;
          for (attributeName in e) {
            var o = e[attributeName];
            o in a && n++;
          }
          if (i == n) {
            console.debug("ItemImage:" + r + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x);
            var d = [];
            return (
              d.push(r),
              d.push(this.entitledItems[x].ItemThumbnailImage),
              null != this.entitledItems[x].ItemAngleThumbnail &&
                void 0 != this.entitledItems[x].ItemAngleThumbnail &&
                (d.push(this.entitledItems[x].ItemAngleThumbnail),
                d.push(this.entitledItems[x].ItemAngleFullImage)),
              d
            );
          }
        }
      }
      return null;
    },
    disableBuyButtonforUnbuyable: function (e) {
      var t = this.entitledItems[e].buyable,
        r = document.getElementById(
          "listViewAdd2Cart_" + this.entitledItems[e].productId
        );
      null != t &&
        null != r &&
        ("false" == t
          ? (r.className += " add2CartButtonDisabled")
          : (r.className = r.className.replace(" add2CartButtonDisabled", "")));
    },
    changeViewImages: function (e, t) {
      var r = 0;
      for (x in e) {
        var s = r;
        r++,
          $("#WC_CachedProductOnlyDisplay_images_1_" + r).attr("src", e[x]),
          $("#WC_CachedProductOnlyDisplay_links_1_" + r).length &&
            $("#WC_CachedProductOnlyDisplay_links_1_" + r).attr(
              "href",
              "JavaScript:changeThumbNail('productAngleLi" +
                s +
                "','" +
                t[x] +
                "');"
            ),
          $("#productAngleLi" + s).length &&
            "selected" === $("#productAngleLi" + s).attr("className") &&
            changeThumbNail("productAngleLi" + s, t[x]);
      }
    },
    changeProdImage: function (
      entitledItemId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId,
      imageField
    ) {
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1),
        skuImage = null,
        imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
      if (
        (null != imageArr && (skuImage = imageArr[0]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      ) {
        if ($("#" + this.skuImageId).length) {
          (document.getElementById(this.skuImageId).src = skuImage),
            $("#ProductInfoImage_" + productId).length &&
              (document.getElementById("ProductInfoImage_" + productId).value =
                skuImage);
          var itemAngleThumbnail = imageArr[2],
            itemAngleFullImage = imageArr[3];
          null != itemAngleThumbnail &&
            void 0 != itemAngleThumbnail &&
            shoppingActionsJS.changeViewImages(
              itemAngleThumbnail,
              itemAngleFullImage
            );
        }
      } else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes;
          if (null != imageField)
            var itemImage = this.entitledItems[x][imageField];
          else var itemImage = this.entitledItems[x].ItemImage467;
          var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail,
            itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              $("#" + this.skuImageId).length &&
                ($("#" + this.skuImageId).attr("src", itemImage),
                null !=
                  document.getElementById("ProductInfoImage_" + productId) &&
                  (document.getElementById(
                    "ProductInfoImage_" + productId
                  ).value = itemImage)),
                null != itemAngleThumbnail &&
                  void 0 != itemAngleThumbnail &&
                  shoppingActionsJS.changeViewImages(
                    itemAngleThumbnail,
                    itemAngleFullImage
                  ),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    updateSwatchListView: function () {
      for (
        var swatchArray = $("a[id^='swatch_array_']"), i = 0;
        i < swatchArray.length;
        i++
      ) {
        var swatchArrayElement = swatchArray[i];
        eval($(swatchArrayElement).attr("href"));
      }
      for (
        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']"), i = 0;
        i < swatchSkuImage.length;
        i++
      ) {
        var swatchSkuImageElement = swatchSkuImage[i];
        eval($(swatchSkuImageElement).attr("href"));
      }
      for (
        var swatchDefault = $("a[id^='swatch_selectDefault_']"), i = 0;
        i < swatchDefault.length;
        i++
      ) {
        var swatchDefaultElement = swatchDefault[i];
        eval($(swatchDefaultElement).attr("href"));
      }
    },
    selectSwatch: function (e, t, r, s, a, i, n) {
      if (!$("#swatch_" + r + "_" + t).hasClass("color_swatch_disabled")) {
        var o = this.selectedAttributesList[r];
        for (attribute in o) {
          if (attribute == e && o[attribute] != t) {
            var d = document.getElementById("swatch_" + r + "_" + o[attribute]);
            (d.className = "color_swatch"),
              (d.src = d.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById(
                "swatch_link_" + r + "_" + o[attribute]
              ).title = d.alt);
          }
          null !=
            document.getElementById("swatch_link_" + r + "_" + o[attribute]) &&
            document
              .getElementById("swatch_link_" + r + "_" + o[attribute])
              .setAttribute("aria-checked", "false");
        }
        this.makeSwatchSelection(e, t, r, s, a, i, n);
      }
    },
    makeSwatchSelection: function (e, t, r, s, a, i, n) {
      this.setSelectedAttribute(e, t, r, i, n),
        (document.getElementById("swatch_" + r + "_" + t).className =
          "color_swatch_selected"),
        document
          .getElementById("swatch_link_" + r + "_" + t)
          .setAttribute("aria-checked", "true"),
        (document.getElementById(
          "swatch_selection_label_" + r + "_" + e
        ).className = "header color_swatch_label"),
        "none" ==
          document.getElementById("swatch_selection_" + r + "_" + e).style
            .display &&
          (document.getElementById(
            "swatch_selection_" + r + "_" + e
          ).style.display = "inline"),
        null != a
          ? (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = a)
          : (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = t),
        this.updateSwatchImages(e, r, s, n);
    },
    addToAllSwatchsArray: function (e, t, r, s, a) {
      var i = this.allSwatchesArrayList[s];
      if ((null == i && (i = []), !this.existInAllSwatchsArray(e, t, i))) {
        var n = [];
        (n[0] = e),
          (n[1] = t),
          (n[2] = r),
          (n[4] = document.getElementById(
            "swatch_link_" + s + "_" + t
          ).onclick),
          (n[5] = null),
          (n[6] = a),
          i.push(n),
          (this.allSwatchesArrayList[s] = i);
      }
    },
    existInAllSwatchsArray: function (e, t, r) {
      for (var s = 0; s < r.length; s++) {
        var a = r[s][0],
          i = r[s][1];
        if (a == e && i == t) return !0;
      }
      return !1;
    },
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
      0 == this.entitledItems.length &&
        ($("#" + entitledItemId).length &&
          (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON));
      for (x in this.entitledItems) {
        var Attributes = this.entitledItems[x].Attributes;
        for (y in Attributes) {
          var index = y.indexOf("_|_"),
            swatchName = y.substring(0, index),
            swatchValue = y.substring(index + 3);
          this.makeSwatchSelection(
            swatchName,
            swatchValue,
            entitledItemId,
            doNotDisable,
            null,
            imageField
          );
        }
        break;
      }
    },
    updateSwatchImages: function (e, t, r, s) {
      for (
        var a = [],
          i = this.selectedAttributesList[t],
          n = i[e],
          o = this.allSwatchesArrayList[t],
          d = 0;
        d < o.length;
        d++
      ) {
        var l = o[d][0],
          c = o[d][1],
          u = o[d][2],
          m = (o[d][3], o[d][4]),
          g = o[d][6];
        if (l != r && l != e) {
          var p = [];
          (p[0] = l),
            (p[1] = c),
            (p[2] = u),
            (p[4] = m),
            (p[5] = !1),
            (p[6] = g),
            a.push(p);
        }
      }
      for (x in this.entitledItems) {
        var h = this.entitledItems[x].Attributes;
        for (y in h) {
          var I = y.indexOf("_|_"),
            f = y.substring(0, I),
            S = y.substring(I + 3);
          if (f == e && S == n)
            for (z in h) {
              var v = z.indexOf("_|_"),
                _ = z.substring(0, v),
                C = z.substring(v + 3);
              if (y != z)
                for (d in a) {
                  var A = a[d][0],
                    E = a[d][1];
                  _ == A && C == E && (a[d][5] = !0);
                }
            }
        }
      }
      var b = [];
      for (d in a) {
        var A = a[d][0],
          E = a[d][1],
          M = (a[d][2], a[d][3], a[d][4]),
          O = a[d][5];
        if (O) {
          if (
            "color_swatch_selected" !=
            document.getElementById("swatch_" + t + "_" + E).className
          ) {
            var R = document.getElementById("swatch_" + t + "_" + E);
            (R.className = "color_swatch"),
              (R.src = R.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById("swatch_link_" + t + "_" + E).title =
                R.alt);
          }
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "false"),
            (document.getElementById("swatch_link_" + t + "_" + E).onclick = M);
        } else if (A != r) {
          var R = document.getElementById("swatch_" + t + "_" + E),
            P = document.getElementById("swatch_link_" + t + "_" + E);
          (R.className = "color_swatch_disabled"),
            (P.onclick = null),
            (R.src = R.src.replace("_enabled.png", "_disabled.png"));
          Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [R.alt]);
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "true"),
            i[A] == E && b.push(a[d]);
        }
      }
      for (d in b) {
        var T = b[d][0],
          D = b[d][1];
        for (d in a) {
          var A = a[d][0],
            E = a[d][1],
            w = a[d][6],
            O = a[d][5];
          if (A == T && E != D && O) {
            this.makeSwatchSelection(A, E, t, r, w, s);
            break;
          }
        }
      }
    },
    changePrice: function (
      entitledItemId,
      isPopup,
      displayPriceRange,
      productId
    ) {
      (this.displayPriceRange = displayPriceRange), (this.isPopup = isPopup);
      var entitledItemJSON;
      entitledItemJSON =
        $("#" + entitledItemId).length && !this.isPopup
          ? eval("(" + $("#" + entitledItemId).html() + ")")
          : this.getEntitledItemJsonObject();
      var catalogEntryId = null;
      if (
        (this.setEntitledItems(entitledItemJSON),
        this.selectedProducts[productId])
      )
        var catalogEntryId = this.getCatalogEntryIdforProduct(
          this.selectedProducts[productId]
        );
      else var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId)
        if (
          null != this.itemPriceJsonOject[catalogEntryId] &&
          "undefined" != this.itemPriceJsonOject[catalogEntryId]
        )
          this.displayPrice(
            this.itemPriceJsonOject[catalogEntryId].catalogEntry,
            productId
          ),
            console.debug(
              "ShoppingActions.changePrice: using stored json object."
            );
        else {
          var parameters = {
            storeId: this.storeId,
            langId: this.langId,
            catalogId: this.catalogId,
            catalogEntryId: catalogEntryId,
            productId: productId,
          };
          wcService.declare({
            id: "getCatalogEntryDetailsSA",
            actionId: "getCatalogEntryDetailsSA",
            url:
              getAbsoluteURL() +
              appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
            formId: "",
            successHandler: function (e, t) {
              shoppingActionsJS.displayPriceServiceResponse(e, t);
            },
            failureHandler: function (e, t) {
              console.debug(
                "ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request."
              );
            },
          }),
            wcService.invoke("getCatalogEntryDetailsSA", parameters);
        }
      else
        console.debug(
          "ShoppingActions.changePrice: all attributes are not selected."
        );
    },
    displayPriceServiceResponse: function (e, t) {
      var r = t.productId;
      (shoppingActionsJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        shoppingActionsJS.displayPrice(e.catalogEntry, r);
    },
    displayPrice: function (e, t) {
      var r,
        s = shoppingActionsJS.isPopup;
      if (
        (1 == s &&
          ($("#productPrice").html(e.offerPrice),
          (document.getElementById("productName").innerHTML =
            e.description[0].name),
          (document.getElementById("productSKUValue").innerHTML =
            e.catalogEntryIdentifier.externalIdentifier.partNumber)),
        0 == s)
      ) {
        var a = "",
          i = Utils.parseNumber(e.listPrice),
          n = Utils.parseNumber(e.offerPrice);
        if (
          (this.setPriceInProductList(t, n),
          (a =
            !e.listPriced || n >= i
              ? "<span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"
              : "<span id='listPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='old_price'>" +
                e.listPrice +
                "</span><span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"),
          (document.getElementById("price_display_" + t).innerHTML =
            a +
            "<input type='hidden' id='ProductInfoPrice_" +
            e.catalogEntryIdentifier.uniqueID +
            "' value='" +
            e.offerPrice +
            "'/>"),
          (a = ""),
          1 == shoppingActionsJS.displayPriceRange)
        )
          for (var o in e.priceRange)
            e.priceRange[o].endingNumberOfUnits ==
            e.priceRange[o].startingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : "null" != e.priceRange[o].endingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X_TO_Y", {
                  0: e.priceRange[o].startingNumberOfUnits,
                  1: e.priceRange[o].endingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : ((r = Utils.getLocalizationMessage("PQ_PRICE_X_OR_MORE", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r)),
              (a =
                a +
                " <span class='price'>" +
                e.priceRange[o].localizedPrice +
                "</span></p>");
        var d = document.getElementById("productLevelPriceRange_" + t),
          l = document.getElementById("itemLevelPriceRange_" + t);
        null != d && null == l
          ? (d.style.display = "")
          : "" != a && null != l
          ? ((a = Utils.getLocalizationMessage("PQ_PURCHASE") + a),
            (l.innerHTML = a),
            (l.style.display = ""),
            null != d && (d.style.display = "none"))
          : "" == a &&
            (null != l && (l.style.display = "none"),
            null != d && (d.style.display = ""));
        var c = $("#product_name_" + t + " > a");
        1 == c.length
          ? $(c[0]).html(e.description[0].name)
          : $("#product_name_" + t) &&
            $("#product_name_" + t).html(e.description[0].name),
          $("#widget_product_info_viewer > div[id^='PageHeading_']").length &&
            $("#widget_product_info_viewer > div[id^='PageHeading_']").each(
              function (t, r) {
                null != r.childNodes &&
                  3 == r.childNodes.length &&
                  (r.childNodes[1].innerHTML = e.description[0].name);
              }
            ),
          null != document.getElementById("ProductInfoName_" + t) &&
            (document.getElementById("ProductInfoName_" + t).value =
              e.description[0].name),
          document.getElementById("product_shortdescription_" + t) &&
            (document.getElementById(
              "product_shortdescription_" + t
            ).innerHTML = e.description[0].shortDescription),
          document.getElementById("product_SKU_" + t) &&
            (document.getElementById("product_SKU_" + t).innerHTML =
              Utils.getLocalizationMessage("SKU") +
              " " +
              e.catalogEntryIdentifier.externalIdentifier.partNumber);
      }
    },
    showWCDialogPopup: function (e) {
      var t = $("#" + e).data("wc-WCDialog");
      t
        ? (t.open(), $("#" + e).css("display", "block"))
        : console.debug(e + " does not exist");
    },
    notifyAttributeChange: function (e) {
      this.baseCatalogEntryId = e;
      this.selectedAttributesList["entitledItem_" + e];
      wcTopic.publish("DefiningAttributes_Resolved_" + e, e, -1);
    },
    notifyQuantityChange: function (e) {
      wcTopic.publish("Quantity_Changed", e);
    },
    initCompare: function (e) {
      if ("compare" == e || "catalogEntryList" == e) this.checkForCompare();
      else {
        var t = this.cookieKeyPrefix + this.storeId,
          r = "";
        setCookie(t, r, {
          path: "/",
          domain: cookieDomain,
        });
      }
    },
    changeCompareBox: function (e, t) {
      (box = document.getElementById(e)),
        (box.checked = !box.checked),
        this.addOrRemoveFromCompare(t, box.checked);
    },
    addOrRemoveFromCompare: function (e, t) {
      t ? this.addToCompare(e) : this.removeFromCompare(e);
    },
    addToCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r && (-1 != r.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS")
        );
      var s = 0;
      if (
        (null != r && "" !== r && (s = r.split(this.cookieDelimiter).length),
        s < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var a = "";
        (a = null == r || "" === r ? e : r + this.cookieDelimiter + e),
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          }),
          shoppingActionsJS.checkForCompare();
      } else
        this.showWCDialogPopup("widget_product_comparison_popup"),
          (document.getElementById("comparebox_" + e).checked = !1),
          console.debug("You can only compare up to 4 products");
    },
    removeFromCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t),
        s = 0;
      if (null != r) {
        if ("" == r.trim())
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var a = r.split(this.cookieDelimiter),
            i = "";
          for (index in a)
            a[index] != e &&
              (i = "" === i ? a[index] : i + this.cookieDelimiter + a[index]);
          setCookie(t, i, {
            path: "/",
            domain: cookieDomain,
          }),
            (s = i.split(this.cookieDelimiter).length);
        }
        shoppingActionsJS.checkForCompare();
      }
    },
    compareProducts: function (e, t) {
      var r = appendWcCommonRequestParameters(
        "CompareProductsDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          encodeURIComponent(this.compareReturnName) +
          "&searchTerm=" +
          this.searchTerm
      );
      "" != e.top_category && (r = r + "&top_category=" + e.top_category),
        "" != e.parent_category_rn &&
          (r = r + "&parent_category_rn=" + e.parent_category_rn),
        "" != e.categoryId && (r = r + "&categoryId=" + e.categoryId),
        void 0 != t && "" != t && (r = r + "&manufacturer=" + t);
      var s = this.cookieKeyPrefix + this.storeId,
        a = getCookie(s);
      null != a && "" != a.trim() && (r = r + "&catentryId=" + a);
      var i = appendWcCommonRequestParameters(location.href);
      -1 === i.indexOf("?")
        ? (i += "?fromPage=compare")
        : -1 === i.indexOf("fromPage=compare") && (i += "&fromPage=compare"),
        (r = r + "&returnUrl=" + encodeURIComponent(i)),
        (location.href = getAbsoluteURL() + r);
    },
    setProductQuantity: function (e, t, r, s) {
      var a = null;
      this.productList[t]
        ? (a = this.productList[t])
        : ((a = {}),
          (this.productList[t] = a),
          (a.baseItemId = t),
          "item" == e ? (a.id = t) : (a.id = 0)),
        (a.quantity = r),
        wcTopic.publish("Quantity_Changed", JSON.stringify(a)),
        (a.price = Utils.parseNumber(s));
    },
    quantityChanged: function (e, t) {
      if (this.productList[e]) {
        var r = this.productList[e];
        if (
          ((r.quantity = t.trim()),
          wcTopic.publish("Quantity_Changed", JSON.stringify(r)),
          null != MerchandisingAssociationJS &&
            null != MerchandisingAssociationJS.baseItemParams &&
            "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
        )
          for (
            idx = 0;
            idx < MerchandisingAssociationJS.baseItemParams.components.length;
            idx++
          )
            (e ==
              MerchandisingAssociationJS.baseItemParams.components[idx]
                .productId ||
              e ==
                MerchandisingAssociationJS.baseItemParams.components[idx].id) &&
              (MerchandisingAssociationJS.baseItemParams.components[
                idx
              ].quantity = r.quantity);
      }
    },
    setPriceInProductList: function (e, t) {
      var r = this.productList[e];
      r && (r.price = t);
    },
    selectBundleItemSwatch: function (e, t, r, s) {
      if (
        !$("#swatch_" + e + "_" + t + "_" + r).hasClass("color_swatch_disabled")
      ) {
        if ($("#entitledItem_" + e).length) {
          var a,
            i = t + "_" + r;
          a = JSON.stringify($("#entitledItem_" + e).html());
          var n = [];
          for (idx in a) {
            var o = !1,
              d = a[idx];
            for (attribute in d.Attributes)
              if (i == attribute) {
                o = !0;
                break;
              }
            if (o)
              for (attribute in d.Attributes) {
                var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
                l != s && l != t && n.push(attribute);
              }
          }
          var c = [],
            u = [];
          for (idx in a) {
            var d = a[idx];
            for (attribute in d.Attributes) {
              var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
              if (l != s && l != t) {
                var m = "swatch_" + e + "_" + attribute,
                  g = m.replace("swatch_", "swatch_link_");
                if (n.indexOf(attribute) > -1)
                  $("#" + m).hasClass("color_swatch_selected") ||
                    ((document.getElementById(m).className = "color_swatch"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_disabled.png", "_enabled.png")),
                    (document.getElementById(g).title =
                      document.getElementById(m).alt),
                    document
                      .getElementById(g)
                      .setAttribute("aria-disabled", "false"));
                else if (-1 === c.indexOf(attribute)) {
                  c.push(attribute),
                    $("#" + m).hasClass("color_swatch_selected") && u.push(m),
                    (document.getElementById(m).className =
                      "color_swatch_disabled"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_enabled.png", "_disabled.png"));
                  var p = document.getElementById(m).alt;
                  Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [p]);
                  $("#" + g).attr("aria-disabled", "true");
                }
              }
              null !=
                document.getElementById("swatch_link_" + e + "_" + attribute) &&
                document
                  .getElementById("swatch_link_" + e + "_" + attribute)
                  .setAttribute("aria-checked", "false");
            }
          }
          for (idx in u) {
            var h = u[idx],
              I = h.substring(0, h.lastIndexOf("_|_")),
              y = !1;
            $("[id^='" + I + "']").each(function (e, t, r) {
              if (!y && $(t).hasClass("color_swatch")) {
                var a = t.id.split("_");
                shoppingActionsJS.selectBundleItemSwatch(a[1], a[2], a[3], s),
                  shoppingActionsJS.setSelectedAttributeOfProduct(
                    a[1],
                    a[2],
                    a[3],
                    !1
                  ),
                  (y = !0);
              }
            });
          }
        }
        "none" == $("#swatch_selection_" + e + "_" + t).css("display") &&
          $("#swatch_selection_" + e + "_" + t).css("display", "inline"),
          $("#swatch_selection_" + e + "_" + t).html(r);
        var f = "swatch_" + e + "_" + t + "_",
          S = "swatch_link_" + e + "_" + t + "_";
        $("img[id^='" + f + "']").each(function (e, t, r) {
          $(t).hasClass("color_swatch_disabled")
            ? $(t).removeClass("color_swatch")
            : $(t).addClass("color_swatch"),
            $(t).removeClass("color_swatch_selected");
        }),
          $("#" + f + r).attr("className", "color_swatch_selected"),
          document.getElementById(S + r).setAttribute("aria-checked", "true"),
          this.setSelectedAttributeOfProduct(e, t, r, !1),
          this.changeBundleItemImage(e, t, r, "productThumbNailImage_" + e);
      }
    },
    changeBundleItemImage: function (
      catalogEntryId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId
    ) {
      var entitledItemId = "entitledItem_" + catalogEntryId;
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var skuImage = null,
        imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
      if (
        (null != imageArr && (skuImage = imageArr[1]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      )
        null != $("#" + this.skuImageId) &&
          ((document.getElementById(this.skuImageId).src = skuImage),
          null !=
            document.getElementById("ProductInfoImage_" + catalogEntryId) &&
            (document.getElementById(
              "ProductInfoImage_" + catalogEntryId
            ).value = skuImage));
      else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes,
            itemImage = this.entitledItems[x].ItemThumbnailImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              (document.getElementById(this.skuImageId).src = itemImage),
                null !=
                  document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ) &&
                  (document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ).value = itemImage),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    getImageForBundleItem: function (e) {
      var t = [],
        r = this.selectedProducts[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveImageForSKU(t);
    },
    checkForCompare: function () {
      var e = getCookie(
        shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId
      );
      e = e ? e.split(shoppingActionsJS.cookieDelimiter) : [];
      var t = $(".compareCheckboxLabels > label");
      $(".compare_target").each(function (r, s) {
        var a = $('input[type="checkbox"]', s)[0];
        a.checked = -1 !== e.indexOf(a.value);
        var i = a.checked ? (e.length > 1 ? 2 : 1) : 0;
        s.setAttribute("data-state", i.toString());
        var n = $('label[for="' + a.id + '"]', s)[0];
        $(n).html($(t[i]).html());
      });
    },
    replaceItemAjaxHelper: function (e, t, r, s, a, i) {
      var n = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderItemId: r,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        catEntryId: e,
        quantity: t,
        orderId: ".",
        calculateOrder: "1",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var d = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (d.calculationUsage = "-1,-2,-5,-6,-7")
        : (d.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var l = !1,
        c = !0;
      null != s && "" !== s && (d.addressId = s),
        null != a && "" !== a && (d.shipModeId = a),
        null != i && "" !== i && ((d.physicalStoreId = i), (c = !1)),
        null == d.shipModeId ||
          (null == d.addressId && null == d.physicalStoreId) ||
          (l = !0),
        c &&
          ((d.allocate = "***"),
          (d.backorder = "***"),
          (d.remerge = "***"),
          (d.check = "*n")),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            l
              ? wcService.invoke("AjaxAddOrderItemTemp", o)
              : wcService.invoke("AjaxAddOrderItem", o);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            (d.orderItemId =
              null != e.orderItem && null != e.orderItem[0].orderItemId
                ? e.orderItem[0].orderItemId
                : e.orderItemId),
              MessageHelper.displayStatusMessage(
                MessageHelper.messages.SHOPCART_ADDED
              ),
              wcService.invoke("OrderItemAddressShipMethodUpdate", d);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", n));
    },
    customizeDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
  }),
  wcTopic.subscribe(
    "ProductInfo_Reset",
    shoppingActionsJS.resetProductAddedList
  ),
  $(document).ready(function () {
    var e = Utils.get_IE_version();
    9 > e &&
      $(document).on(
        "click",
        '.compare_target > input[type="checkbox"]:click',
        function (e) {
          this.blur(), this.focus();
        }
      );
  }),
  (shoppingActionsServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AddOrderItem",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        var t = $('div[id^="attrValue_"]');
        if (null != $(".definingAttributes")[0])
          var t = $(".definingAttributes");
        else if (null != $(".product_sizes")[0]) var t = $(".product_sizes");
        else if (null != $(".product_info")[0]) var t = $(".product_info");
        for (var r = new Array(), s = 0; s < t.length; s++)
          for (
            var a = t[s].querySelectorAll(".dijitSelect"), i = 0;
            i < a.length;
            i++
          )
            r = r.concat(a[i]);
        for (var n = new Array(), s = 0; s < r.length; s++)
          n[s] = dijit.registry.byNode(r[s]);
        for (var o = !0, s = 0; s < n.length; s++)
          n[s].options.length > 2 && (o = !1);
        if (!o) {
          (shoppingActionsJS.selectedAttributes = new Object()),
            wcTopic.publish(
              "DefiningAttributes_Resolved_" +
                shoppingActionsJS.baseCatalogEntryId,
              shoppingActionsJS.baseCatalogEntryId,
              -1
            );
          for (var s = 0; s < n.length; s++) null != n[s] && (n[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        ),
        wcTopic.publish("ProductAddedToCart");
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      e.errorCode && wcTopic.publish("OrderError", e), cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddPreConfigurationToCart",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          shoppingActionsJS.selectedAttributes = new Object();
          for (var s = 0; s < t.length; s++)
            null != t[s] && ((t[s].value = ""), t[s].onchange());
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      cursor_clear();
    },
  }),
  (CommonContextsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare("multipleShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("singleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("multipleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("traditionalShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("currentOrder_Context", [], null),
  wcRenderContext.declare("editShippingAddressContext", [], {
    shippingAddress: "0",
    addressType: "ShippingAndBilling",
  }),
  wcRenderContext.declare("shippingAddressContext", [], {
    shippingAddress: "0",
  }),
  wcRenderContext.declare("billingAddressDropDownBoxContext", [], {
    billingAddress1: "0",
    billingAddress2: "0",
    billingAddress3: "0",
    billingURL1: "",
    billingURL2: "",
    billingURL3: "",
    areaNumber: "0",
    payment1: "",
    payment2: "",
    payment3: "",
    paymentTCId1: "",
    paymentTCId2: "",
    paymentTCId3: "",
  }),
  wcRenderContext.declare("paymentContext", [], {
    payment1: "empty",
    payment2: "empty",
    payment3: "empty",
    currentAreaNumber: "1",
    billingMode1: "none",
    billingMode2: "none",
    billingMode3: "none",
    currentTotal: "0",
  }),
  wcRenderContext.declare("contextForMainAndAddressDiv", [], {
    showArea: "0",
    hideArea: "0",
  }),
  wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {}),
  wcRenderContext.declare("CategoryDisplay_Context", [], {
    pageView: "",
    beginIndex: "",
  }),
  wcRenderContext.declare("SubCategoryDisplay_Context", [], null),
  wcRenderContext.declare("ShopCartPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderDetailPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("MSOrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("CouponDisplay_Context", [], null),
  wcRenderContext.declare("PromotionFreeGifts_Context", [], {}),
  wcRenderContext.declare("ListOrdersDisplay_Context", [], {
    startNumber: "0",
  }),
  wcRenderContext.declare("ScheduledOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "Scheduled",
  }),
  wcRenderContext.declare("ProcessedOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "PreviouslyProcessed",
  }),
  wcRenderContext.declare("WaitingForApprovalOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "WaitingForApproval",
  }),
  wcRenderContext.declare("BrowsingHistoryContext", [], {
    status: "init",
  }),
  wcRenderContext.declare("BrowsingHistoryDisplay_Context", [], {
    currentPage: "0",
    pageView: "",
  }),
  wcRenderContext.declare("CategorySubscriptionContext", [], null),
  wcRenderContext.declare("RecurringOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("SubscriptionDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("RecentRecurringOrderDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecentSubscriptionDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecurringOrderChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderId: "",
  }),
  wcRenderContext.declare("SubscriptionChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderItemId: "",
    subscriptionName: "",
  }),
  wcRenderContext.declare("QuickInfoContext", ["quickInfoRefreshArea"], {}),
  wcRenderContext.declare("DiscountDetailsContext", [], null),
  wcRenderContext.declare("QuickInfoDiscountDetailsContext", [], {}),
  wcRenderContext.declare("DoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("ScrollableESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoriesESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("CategoryFeaturedProductsESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeLeftESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightTopESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightBottomESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TallDoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryTallDoubleESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("AttachmentPagination_Context", [], {
    beginIndex: "0",
  }),
  (CommonControllersDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    declareAccountCouponRefreshArea: function () {
      var e = $("#CouponDisplay_Widget");
      wcTopic.subscribe(
        ["AjaxCouponsAddRemove", "AjaxWalletItemProcessServiceDelete"],
        function () {
          e.refreshWidget("refresh");
        }
      ),
        e.refreshWidget();
    },
    declareShopCartDisplayRefreshArea: function () {
      var e = $("#ShopCartDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        );
      wcTopic.subscribe(order_updated, function () {
        e.refreshWidget("refresh", t), submitRequest(), cursor_wait();
      });
      var r = function () {
        resetRequest(),
          null != typeof savedOrdersJS &&
            "undefined" != typeof savedOrdersJS &&
            savedOrdersJS.isCurrentOrderPage(!0),
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").css("display", "block");
        var e = t.orderId;
        $("#currentOrderId").length &&
          (e = document.getElementById("currentOrderId").value),
          ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
          $("#OrderFirstItemId").length &&
            (ShipmodeSelectionExtJS.orderItemId =
              document.getElementById("OrderFirstItemId").value),
          cursor_clear(),
          "function" == typeof showApplePayButtons && showApplePayButtons();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareShopCartPagingDisplayRefreshArea: function () {
      var e = $("#ShopCartPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "ShopCartPaginationDisplay_Context",
        "ShopCartPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ShopCartPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
          var e = t.orderId;
          document.getElementById("currentOrderId") &&
            (e = document.getElementById("currentOrderId").value),
            ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval($(t).html());
            }),
            $('input[id^="orderItem_"]').each(function (e, t) {
              null != $("addToRequisitionListScript_" + t.value) &&
                $.globalEval(
                  $("addToRequisitionListScript_" + t.value).innerHTML
                ),
                0 != $("addReqListsJS_" + t.value).length &&
                  $.globalEval(
                    "addReqListsJS" +
                      t.value +
                      '.setCatEntryId("' +
                      $("catalogId_" + t.id.substring(t.id.indexOf("_") + 1))
                        .value +
                      '");'
                  );
            });
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declarePromotionFreeGiftsDisplayRefreshArea: function () {
      var e = $("#PromotionFreeGiftsDisplay");
      wcRenderContext.addRefreshAreaId(
        "PromotionFreeGifts_Context",
        "PromotionFreeGiftsDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "PromotionFreeGifts_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          PromotionChoiceOfFreeGiftsJS.showFreeGiftsDialog();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecentRecurringOrderDisplayRefreshArea: function () {
      var e = $("#RecentRecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentRecurringOrderDisplay_Context",
        "RecentRecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentRecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareRecentSubscriptionDisplayRefreshArea: function () {
      var e = $("#RecentSubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentSubscriptionDisplay_Context",
        "RecentSubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentSubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareOrderItemPaginationDisplayRefreshArea: function (e) {
      ("object" == typeof e || "array" == typeof e) && (e = e[0]);
      var t = $("#" + e);
      wcRenderContext.addRefreshAreaId("OrderItemPaginationDisplay_Context", e);
      var r = wcRenderContext.getRenderContextProperties(
          "OrderItemPaginationDisplay_Context"
        ),
        s = function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && t.refreshWidget("refresh", r);
        },
        a = function () {
          cursor_clear(),
            "true" == r.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").val()
              );
        };
      t.refreshWidget({
        renderContextChangedHandler: s,
        postRefreshHandler: a,
      });
    },
    declareRecurOrderDisplayRefreshArea: function () {
      var e = $("#RecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecurringOrderDisplay_Context",
        "RecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("RecurringOrderDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecurOrderChildOrdersRefreshArea: function () {
      var e = $("#RecurringOrderChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "RecurringOrderChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "RecurringOrderChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionDisplayRefreshArea: function () {
      var e = $("#SubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "SubscriptionDisplay_Context",
        "SubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "SubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("SubscriptionDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionChildOrdersRefreshArea: function () {
      var e = $("#SubscriptionChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "SubscriptionChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "SubscriptionChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareQuickInfoDetails: function () {
      var e = $("#quickInfoRefreshArea"),
        t = wcRenderContext.getRenderContextProperties("QuickInfoContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          if ($("#catEntryParamsForJS").length)
            var e = $.parseJSON($("#catEntryParamsForJS").val());
          if ($("#QuickInfostoreParams").length) {
            var t = $("#QuickInfostoreParams").val(),
              r = $("#QuickInfoshoppingListNames").val();
            (shoppingListJSQuickInfo = new ShoppingListJS(
              $.parseJSON(t),
              e,
              $.parseJSON(r),
              "shoppingListJSQuickInfo"
            )),
              this.quickInfoEvenSubscribed ||
                ((this.quickInfoEvenSubscribed = !0),
                wcTopic.subscribe(
                  "DefiningAttributes_Resolved",
                  function (e, t) {
                    shoppingListJSQuickInfo.setItemId(e, t);
                  }
                ),
                wcTopic.subscribe("QuickInfo_attributesChanged", function (e) {
                  shoppingListJSQuickInfo.setCatEntryAttributes(e);
                }),
                wcTopic.subscribe("Quantity_Changed", function (e) {
                  shoppingListJSQuickInfo.setCatEntryQuantity(e);
                }),
                wcTopic.subscribe("ShoppingList_Changed", function (e) {
                  shoppingListJSQuickInfo.updateShoppingListAndAddItem(e);
                }),
                wcTopic.subscribe("ShoppingListItem_Added", function () {
                  shoppingListJSQuickInfo.deleteItemFromCart();
                }),
                $("#QuickInfoaddToShoppingListDropdown").on(
                  "mouseover",
                  function () {
                    shoppingListJSQuickInfo.mouseOnArrow = !0;
                  }
                ),
                $("#QuickInfoShoppingList_0").on("mouseover", function () {
                  (shoppingListJSQuickInfo.exceptionFlag = !0),
                    $("#QuickInfoShoppingListLink_0").focus();
                }));
            var s = e.id;
            null != s &&
              "" != s &&
              wcRenderContext.updateRenderContext(
                "QuickInfoDiscountDetailsContext",
                {
                  productId: e.id,
                }
              );
          }
          $("#catEntryParamsForJS").length &&
            (QuickInfoJS.catEntryParams = $.parseJSON(
              $("#catEntryParamsForJS").val()
            ));
          var a = $("#quickInfoPopup").data("wc-WCDialog");
          a
            ? (closeAllDialogs(),
              "" == QuickInfoJS.itemId
                ? (QuickInfoJS.setCatEntryQuantity(1),
                  QuickInfoJS.selectDefaultSwatch())
                : QuickInfoJS.selectCurrentAttributes(),
              a.open(),
              "undefined" != typeof TealeafWCJS &&
                TealeafWCJS.rebind("quickInfoPopup"))
            : console.debug("quickInfoPopup does not exist"),
            cursor_clear();
        },
      });
    },
    declareQuickInfoDiscountDetailsController: function () {
      var e = $("#quickInfoDiscountDetailsRefreshArea");
      wcRenderContext.addRefreshAreaId(
        "QuickInfoDiscountDetailsContext",
        "quickInfoDiscountDetailsRefreshArea"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "QuickInfoDiscountDetailsContext"
      );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          cursor_clear();
        },
      });
    },
    declareMSOrderItemPagingDisplayRefreshArea: function (e) {
      var t = "MSOrderItemPaginationDisplay_Context";
      "object" == typeof e && (e = e[0]);
      var r = $("#" + e);
      wcRenderContext.checkIdDefined(t) || wcRenderContext.declare(t, [], null);
      var s = wcRenderContext.getRenderContextProperties(t);
      wcRenderContext.addRefreshAreaId(t, e),
        (renderContextChangedHandler = function () {
          wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
            r.refreshWidget("refresh", s);
        }),
        (postRefreshHandler = function () {
          cursor_clear(),
            "true" == s.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").value
              );
        }),
        r.refreshWidget({
          renderContextChangedHandler: renderContextChangedHandler,
          postRefreshHandler: postRefreshHandler,
        });
    },
    declareSSFSOrderItemPaginationDisplayController: function () {
      var e = $("#OrderConfirmPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "OrderItemPaginationDisplay_Context",
        "OrderConfirmPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "OrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForSingleShipment(e, r, s),
            cursor_clear();
        },
      });
    },
    declareSSFSMSOrderItemPaginationDisplayController: function () {
      var e = $("#MSOrderDetailPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "MSOrderItemPaginationDisplay_Context",
        "MSOrderDetailPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "MSOrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "MSOrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForMultipleShipment(
            e,
            r,
            s
          ),
            cursor_clear();
        },
      });
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      var t = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
      document.location.href = t;
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var GeolocationJS = {
  showPosition: function (e) {
    void 0 !== e &&
      null != e &&
      storeLocatorJSStore.refreshResultsFromNearest(
        e.coords.latitude,
        e.coords.longitude
      );
  },
  locationError: function (e) {
    var t;
    switch (e.code) {
      case e.PERMISSION_DENIED:
        t = "LBS_ERROR_PERMISSION_DENIED";
        break;
      case e.POSITION_UNAVAILABLE:
        t = "LBS_ERROR_NO_USER_CURRENT_LOC";
        break;
      case e.TIMEOUT:
        t = "LBS_ERROR_TIMEOUT";
    }
    storeLocatorJSStore.refreshResultsWithLocationError(t);
  },
  launch: function () {
    navigator.geolocation &&
      navigator.geolocation.getCurrentPosition(
        GeolocationJS.showPosition,
        GeolocationJS.locationError,
        {
          timeout: 1e4,
          enableHighAccuracy: !0,
        }
      );
  },
};
("undefined" != typeof MessageHelper &&
  MessageHelper &&
  MessageHelper.topicNamespace) ||
  (MessageHelper = {
    messages: {},
    identifier: "",
    focusElement: "",
    getCurrentYear: function () {
      return new Date().getFullYear();
    },
    getCurrentMonth: function () {
      return new Date().getMonth() + 1;
    },
    getCurrentDay: function () {
      return new Date().getDate();
    },
    getRenderContextProperty: function (e, t) {
      if (
        (console.debug(
          "enter getRenderContextProperty with propertyName = " + t
        ),
        null == e)
      )
        return console.debug("context is null. Return null..."), null;
      var r = e.properties[t];
      return console.debug("the found property value is: " + r), r;
    },
    setMessage: function (e, t) {
      this.messages[e] = t;
    },
    setFocusElement: function (e) {
      this.focusElement = e;
    },
    showHideMessageArea: function (e) {
      cursor_clear(), (null == e || void 0 == e) && (e = 0);
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "block"),
        $(t).fadeIn(200);
    },
    hideMessageArea: function () {
      cursor_clear();
      var e = "";
      "" !== this.focusElement &&
        null !== $("#" + this.focusElement) &&
        (e = $("#" + this.focusElement));
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "none"),
        null != document.getElementById(e) && e.focus(),
        $(t).fadeOut(500),
        $("#ErrorMessageText").html(""),
        (this.focusElement = "");
    },
    displayErrorMessage: function (e, t, r) {
      if (
        ((null == t || void 0 == t) && (t = 0),
        (void 0 == r || null == r || 1 == r) &&
          null != this.messages.ERROR_MESSAGE_TYPE &&
          "undefined" != this.messages.ERROR_MESSAGE_TYPE)
      ) {
        var s = this.messages.ERROR_MESSAGE_TYPE;
        e = s + e;
      }
      this.setMessageAreaStyle("error_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3),
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: "-1",
            message: e,
          });
    },
    setMessageAreaStyle: function (e) {
      $("#success_icon").css("display", "none"),
        $("#error_icon").css("display", "none"),
        null != $("#" + e) && $("#" + e).css("display", "inline");
    },
    displayStatusMessage: function (e, t) {
      (null == t || void 0 == t) && (t = 0),
        this.setMessageAreaStyle("success_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3);
    },
    hideAndClearMessage: function () {
      $("#ErrorMessageText").html(""), $("#MessageArea").css("display", "none");
    },
    adjustCoordinates: function (e) {
      if ("none" != $("#MessageArea").css("display")) {
        var t = $("#page"),
          r = $("#MessageArea");
        if (null != t && null != r) {
          var s = $(t).position(),
            a = $(t).width();
          (null == e || void 0 == e) && (e = 0),
            $(r).css({
              width: a + 20 + "px",
              left: s.left - 10 + "px",
              top: s.top + e + "px",
            });
        }
      }
    },
    formErrorHandle: function (e, t) {
      this.formErrorHandleClient(e.errorMessageParam, e.errorMessage);
    },
    formErrorHandleClient: function (e, t) {
      e.id && (e = e.id);
      var r = $("#" + e);
      if (null == t)
        return void console.debug(
          "formErrorHandleClient: The error message is null."
        );
      if (r) {
        if (Utils.has_ios())
          this.setMessageAreaStyle("error_icon"),
            $("#MessageArea").css("display", "block"),
            $("#ErrorMessageText").html(t),
            window.setTimeout(function () {
              window.scrollTo(0, 0);
            }, 0);
        else if (this.identifier != e + "_tooltip") {
          r.focus(), (this.identifier = e + "_tooltip");
          var s = document.createElement("span"),
            a = getImageDirectoryPath();
          if (
            (Utils.get_IE_version() < 7
              ? (s.innerHTML =
                  t +
                  "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" +
                  a +
                  "images/empty.gif'></iframe>")
              : (s.innerHTML = t),
            Utils.hasTouch())
          ) {
            var i = this;
            setTimeout(function () {
              var r = this;
              (this.tooltip = $(
                "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                  t +
                  "</div></div>"
              )),
                $("#" + e).after(this.tooltip),
                this.tooltip.position({
                  my: "center top",
                  at: "center bottom",
                  of: $("#" + e),
                }),
                $("#" + e).blur(function () {
                  r.tooltip && (r.tooltip.hide(), r.tooltip.remove()),
                    MessageHelper.clearCurrentIdentifier();
                });
            }, 1e3);
          } else {
            var i = this;
            (this.tooltip = $(
              "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                t +
                "</div></div>"
            )),
              $("#" + e).after(this.tooltip),
              this.tooltip.position({
                my: "center top",
                at: "center bottom",
                of: $("#" + e),
              }),
              $("#" + e).blur(function () {
                i.tooltip && (i.tooltip.hide(), i.tooltip.remove()),
                  MessageHelper.clearCurrentIdentifier();
              });
          }
        }
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: r.id,
            message: t,
          });
      }
    },
    hideFormErrorHandle: function () {
      null != this.tooltip &&
        (this.tooltip.destroyRecursive(),
        (this.tooltip = null),
        this.clearCurrentIdentifier());
    },
    clearCurrentIdentifier: function () {
      this.identifier = "";
    },
    emptyFunc: function (e) {},
    containsDoubleByte: function (e) {
      for (var t = new String(e), r = 127, s = 0; s < t.length; s++)
        if (((chr = t.charCodeAt(s)), chr > r)) return !0;
      return !1;
    },
    isValidEmail: function (e) {
      return this.containsDoubleByte(e)
        ? !1
        : 0 == e.length
        ? !0
        : e.length < 5
        ? !1
        : e.indexOf(" ") > 0
        ? !1
        : e.indexOf("@") < 1
        ? !1
        : e.lastIndexOf(".") < e.indexOf("@") + 2
        ? !1
        : e.lastIndexOf(".") >= e.length - 2
        ? !1
        : !0;
    },
    isValidUTF8length: function (e, t) {
      return this.utf8StringByteLength(e) > t ? !1 : !0;
    },
    utf8StringByteLength: function (e) {
      if (null === e) return 0;
      var t = String(e),
        r = 127,
        s = 2047,
        a = t.length;
      for (i = 0; i < t.length; i++)
        (chr = t.charCodeAt(i)), chr > r && (a += 1), chr > s && (a += 1);
      return a;
    },
    IsNumeric: function (e, t) {
      if (t) var r = "0123456789.";
      else var r = "0123456789";
      var s,
        a = !0;
      for (i = 0; i < e.length && 1 == a; i++)
        (s = e.charAt(i)), -1 == r.indexOf(s) && (a = !1);
      return a;
    },
    IsValidPhone: function (e) {
      var t,
        r = "0123456789()-+ ",
        s = !0;
      for (i = 0; i < e.length && 1 == s; i++)
        (t = e.charAt(i)), -1 == r.indexOf(t) && (s = !1);
      return s;
    },
    showConfirmationDialog: function (e, t) {
      $("#confirmationPopupMessage").html(t);
      var r = $("#confirmationPopup").data("wc-WCDialog"),
        s = "click.MessageHelper";
      r.primary_button.one(s, function (t) {
        t.preventDefault(),
          r.secondary_button.off(s),
          wcTopic.publish(e, {
            action: "YES",
          });
      }),
        r.secondary_button.one(s, function (t) {
          t.preventDefault(),
            r.primary_button.off(s),
            wcTopic.publish(e, {
              action: "NO",
            });
        }),
        r.open();
    },
  }),
  (quickOrderJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    skuErrorMessage: "",
    qtyErrorMessage: "",
    numberOfItemsSupportedPerQuickOrder: "12",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.skuErrorMessage = s),
        (this.qtyErrorMessage = a);
    },
    addToOrderAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          storeNLS.ERROR_ADD2CART_BROWSE_ONLY
        );
      var t = [],
        r = document.forms[e];
      (t.storeId = r.storeId.value),
        (t.catalogId = r.catalogId.value),
        (t.langId = r.langId.value),
        (t.calculateOrder = "0");
      for (
        var s = 0, a = 1;
        a <= this.numberOfItemsSupportedPerQuickOrder;
        a++
      ) {
        var i = r["partNumber_" + a].id,
          n = r["quantity_" + a].id,
          o = trim(r["partNumber_" + a].value),
          d = trim(r["quantity_" + a].value);
        if ((null != o && "" != o) || (null != d && "" != d)) {
          if (null == o || "" == o)
            return void MessageHelper.formErrorHandleClient(
              i,
              this.skuErrorMessage
            );
          if (!isPositiveInteger(d))
            return void MessageHelper.formErrorHandleClient(
              n,
              this.qtyErrorMessage
            );
          (s += 1),
            (r["partNumber_" + a].value = o),
            (r["quantity_" + a].value = d),
            this.updateParamObject(
              t,
              "partNumber_" + s,
              r["partNumber_" + a].value
            ),
            this.updateParamObject(
              t,
              "quantity_" + s,
              r["quantity_" + a].value
            );
        }
      }
      if (s > 0) {
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("QuickOrderAddOrderItem", t);
      }
    },
    updateParamObject: function (e, t, r, s) {
      if ((null == e && (e = []), null != s && "" !== s && -1 !== s))
        e[t + "_" + s] = r;
      else if (-1 === s) {
        for (var a = 1; null != e[t + "_" + a]; ) a++;
        e[t + "_" + a] = r;
      } else e[t] = r;
      return e;
    },
    clearForm: function (e) {
      for (var t = document.forms[e], r = 0; r < t.elements.length; r++)
        "text" == t.elements[r].type && (t.elements[r].value = "");
    },
  }),
  wcService.declare({
    id: "QuickOrderAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        quickOrderJS.clearForm("MQuickOrderForm");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  ("undefined" != typeof ResponsiveJS &&
    null != ResponsiveJS &&
    ResponsiveJS) ||
    (ResponsiveJS = {
      init: function () {
        $("#footerCustomerService").on(
          "click",
          $.proxy(ResponsiveJS._cSToggleAndShow, ResponsiveJS)
        ),
          $("#footerCorporateInfo").on(
            "click",
            $.proxy(ResponsiveJS._cIToggleAndShow, ResponsiveJS)
          ),
          $("#footerExplore").on(
            "click",
            $.proxy(ResponsiveJS._eToggleAndShow, ResponsiveJS)
          ),
          $("#footerFollowUs").on(
            "click",
            $.proxy(ResponsiveJS._FUToggleAndShow, ResponsiveJS)
          );
      },
      _cSToggleAndShow: function (e) {
        this.toggle($("#cSTog")), this.show($("#expandCS"));
      },
      _cIToggleAndShow: function (e) {
        this.toggle($("#cITog")), this.show($("#expandCI"));
      },
      _eToggleAndShow: function (e) {
        this.toggle($("#eTog")), this.show($("#expandE"));
      },
      _FUToggleAndShow: function (e) {
        this.toggle($("#fUTog")), this.show($("#expandFU"));
      },
      toggle: function (e) {
        var t = e;
        null != t &&
          ("-161px -1px" == t.style.backgroundPosition
            ? ((t.style.backgroundPosition = "-181px -1px"),
              (t.style.width = "12px"),
              (t.style.height = "6px"),
              (t.style.left = "6px"),
              (t.style.top = "14px"))
            : ((t.style.backgroundPosition = "-161px -1px"),
              (t.style.width = "6px"),
              (t.style.height = "12px"),
              (t.style.left = "10px"),
              (t.style.top = "10px")));
      },
      show: function (e) {
        (srcElement = e),
          null != srcElement &&
            ("block" == srcElement.style.display
              ? (close("searchDropdown"), (srcElement.style.display = "none"))
              : ($(".subDeptDropdown ").each(function (e, t) {
                  close(t.id);
                }),
                close("departmentsDropdown"),
                close("qLinkDropdown"),
                close("mobileSearchDropdown"),
                close("searchDropdown"),
                close("pageDropdown"),
                close("sortDropdown"),
                (srcElement.style.display = "block")));
      },
    }),
  (ServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        resetRequest(),
        CheckoutHelperJS.deleteFromCart(e.orderItemId, !0),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemForShippingBillingPage",
    actionId: "AjaxDeleteOrderItemForShippingBillingPage",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemFromCart",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem1",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        ),
        CheckoutHelperJS.pendingOrderDetailsPage
          ? cursor_clear()
          : (setDeleteCartCookie(),
            CheckoutHelperJS.shoppingCartPage
              ? (document.location.href = appendWcCommonRequestParameters(
                  "AjaxOrderItemDisplayView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId
                ))
              : (document.location.href = appendWcCommonRequestParameters(
                  "OrderShippingBillingView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId +
                    "&orderId=" +
                    e.orderId
                )));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.hideFormErrorHandle(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem1",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.pendingOrderDetailsPage
        ? cursor_clear()
        : CheckoutHelperJS.shoppingCartPage &&
          (document.location.href = appendWcCommonRequestParameters(
            "AjaxOrderItemDisplayView?storeId=" +
              ServicesDeclarationJS.storeId +
              "&catalogId=" +
              ServicesDeclarationJS.catalogId +
              "&langId=" +
              ServicesDeclarationJS.langId
          ));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderShippingInfo",
    actionId: "AjaxUpdateOrderShippingInfo",
    url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForSubmit",
    actionId: "AjaxPrepareOrderForSubmit",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.setOrderPrepared("true"),
        CheckoutHelperJS.checkoutOrder(
          CheckoutHelperJS.getSavedParameter("tempOrderId"),
          CheckoutHelperJS.getSavedParameter("tempUserType"),
          CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
          CheckoutHelperJS.getSavedParameter("tempIsQuote")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitOrder",
    actionId: "AjaxSubmitOrder",
    url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
    formId: "",
    successHandler: function (e) {
      nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId();
      document.location.href = appendWcCommonRequestParameters(
        "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitQuote",
    actionId: "AjaxSubmitQuote",
    url: getAbsoluteURL() + "AjaxSubmitQuote",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingConfirmationView?storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&orderId=" +
        CheckoutHelperJS.getOrderId() +
        "&shipmentTypeId=" +
        CheckoutHelperJS.getShipmentTypeId() +
        "&isQuote=true&quoteId=" +
        e.outOrderId;
      void 0 != e.outExternalQuoteId &&
        null != e.outExternalQuoteId &&
        (t += t + "&externalQuoteId=" + e.outExternalQuoteId),
        (document.location.href = appendWcCommonRequestParameters(t));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddAddressForPerson",
    actionId: "AjaxAddAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateAddressForPerson",
    actionId: "AjaxUpdateAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderAfterAddressUpdate",
    actionId: "AjaxUpdateOrderAfterAddressUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        ),
        categoryDisplayJS && (categoryDisplayJS.selectedAttributes = []);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd_shopCart",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemDelete",
    actionId: "AjaxInterestItemDelete",
    url: getAbsoluteURL() + "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemListMessage",
    actionId: "AjaxInterestItemListMessage",
    url: getAbsoluteURL() + "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeManage",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeDelete",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAdd",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsRemove",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = document.getElementById("orderIdToSchedule").value,
        r = e.orderId;
      nullCartTotalCookie(e.orderId);
      var s = CheckoutHelperJS.getShipmentTypeId(),
        a = "";
      null !=
        document.forms.purchaseOrderNumberInfo.purchase_order_number.value &&
        (a =
          document.forms.purchaseOrderNumberInfo.purchase_order_number.value);
      var i =
        "RESTOrderCancel?orderId=" +
        t +
        "&storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" +
        r +
        "%26originalOrderId%3D" +
        t +
        "%26shipmentTypeId%3D" +
        s +
        "%26purchaseOrderNumber%3D" +
        a;
      document.location.href = appendWcCommonRequestParameters(i);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId(),
        r =
          "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t;
      (document.location.href = appendWcCommonRequestParameters(r)),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCreate",
    actionId: "AjaxOrderCreate",
    url: getAbsoluteURL() + "AjaxOrderCreate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_CREATED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CREATED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCancel",
    actionId: "AjaxSingleOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDERS_CANCELLED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCancel",
    actionId: "AjaxOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.cancelSavedOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderSave",
    actionId: "AjaxOrderSave",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.saveOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SAVED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetPendingOrder",
    actionId: "AjaxSetPendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        savedOrdersJS.determinePageForward("AjaxSetPendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode || "CMN1024E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePendingOrder",
    actionId: "AjaxUpdatePendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCopy",
    actionId: "AjaxSingleOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxSingleOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCopy",
    actionId: "AjaxOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCalculate",
    actionId: "AjaxSingleOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(MessageHelper.messages.ORDER_COPIED),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCurrentOrderCalculate",
    actionId: "AjaxCurrentOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCalculate",
    actionId: "AjaxOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), savedOrdersJS.copyOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPunchoutPay",
    actionId: "AjaxPunchoutPay",
    url: "AjaxRESTOrderRePay",
    formId: "",
    successHandler: function (e) {
      PunchoutJS.handleResponse(e.orderId),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCategorySubscribe",
    actionId: "AjaxCategorySubscribe",
    url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SUBSCRIPTION_UPDATED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  address_updated = {
    AjaxDeleteAddressForPerson: "AjaxDeleteAddressForPerson",
    AjaxAddAddressForPerson: "AjaxAddAddressForPerson",
    AjaxUpdateAddressForPerson: "AjaxUpdateAddressForPerson",
    AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
  },
  user_changed = {
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  },
  wishlist_changed = {
    AjaxInterestItemAdd: "AjaxInterestItemAdd",
    AjaxInterestItemDelete: "AjaxInterestItemDelete",
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  };
wcTopic.subscribe("ajaxRequestInitiated", incrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", decrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", initializeInactivityWarning),
  wcTopic.subscribe("OrderError", function (e) {
    "CMN4512I" == e.errorCode &&
      (setDeleteCartCookie(), loadMiniCart(null, null));
  });
var showDropdown = !1,
  dropDownDlg = null,
  productAddedDropDownDlg = null,
  originalMiniCartWidth = 0,
  isIE = document.all ? !0 : !1,
  correctBrowser = !1,
  requestSubmitted = !0,
  currentId = "",
  numAjaxRequests = 0,
  widgetsList = [],
  tabPressed = !1,
  currentPopup = "",
  android = null,
  ios = null,
  cookieDomain = "",
  _BTD_PREFS = "WC_Base_Text_Direction",
  detectedLocale = Utils.getLocale();
wcService.declare({
  id: "MyAcctAjaxAddOrderItem",
  actionId: "AjaxAddOrderItem",
  url: "",
  formId: "",
  successHandler: function (e) {
    MessageHelper.hideAndClearMessage(),
      MessageHelper.displayStatusMessage(
        Utils.getLocalizationMessage("SHOPCART_ADDED")
      ),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      cursor_clear();
  },
  failureHandler: function (e) {
    e.errorMessage
      ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          )
        : MessageHelper.displayErrorMessage(e.errorMessage)
      : e.errorMessageKey &&
        MessageHelper.displayErrorMessage(e.errorMessageKey),
      cursor_clear();
  },
}),
  wcService.declare({
    id: "MyAcctGenericService",
    actionId: "",
    url: "",
    formId: "",
    successHandler: function (e) {
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
        MessageHelper.hideAndClearMessage(),
        (finalViewURL = getFinalViewURL(this.url)),
        "" !== finalViewURL
          ? (document.location.href = finalViewURL)
          : (MessageHelper.displayStatusMessage(
              Utils.getLocalizationMessage("MYACCOUNT_ACTION_PERFORMED")
            ),
            cursor_clear());
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (PhysicalStoreCookieJSStore = {
    storeArray: null,
    arrayMaxSize: 5,
    getStoreIdsFromCookie: function () {
      var e = getCookie("WC_physicalStores");
      if (((this.storeArray = new Array()), null != e)) {
        var t = "",
          r = e,
          s = e.length,
          a = r.indexOf(",");
        if (a > 0) {
          for (; a >= 0; )
            (t = r.substring(0, a)),
              this.addToStoreArray(t),
              (r = r.substring(a + 1, s)),
              (s = r.length),
              (a = r.indexOf(","));
          (t = r), this.addToStoreArray(t);
        } else s > 0 && this.addToStoreArray(r);
      }
      return this.storeArray;
    },
    isAddOneStoreIdExceedMax: function () {
      var e = !1;
      return this.getNumStores() + 1 > this.arrayMaxSize && (e = !0), e;
    },
    setStoreIdsToCookie: function () {
      var e = "";
      for (i = 0; i < this.storeArray.length; i++)
        (e += this.storeArray[i]), i < this.storeArray.length - 1 && (e += ",");
      0 == e.length
        ? setCookie("WC_physicalStores", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          })
        : setCookie("WC_physicalStores", e, {
            path: "/",
            domain: cookieDomain,
          });
    },
    addToStoreArray: function (e) {
      for (
        null == this.storeArray && this.getStoreIdsFromCookie(), i = 0;
        i < this.storeArray.length;
        i++
      )
        if (this.storeArray[i] == e) return;
      this.storeArray.length < this.arrayMaxSize && this.storeArray.push(e);
    },
    addToCookie: function (e) {
      this.addToStoreArray(e), this.setStoreIdsToCookie();
    },
    removeFromStoreArray: function (e) {
      null == this.storeArray && this.getStoreIdsFromCookie();
      var t = -1;
      for (i = 0; i < this.storeArray.length; i++)
        this.storeArray[i] == e && ((t = i), (i = this.storeArray.length));
      this.storeArray.splice(t, 1);
    },
    removeFromCookie: function (e) {
      this.removeFromStoreArray(e), this.setStoreIdsToCookie();
    },
    clearStoreArray: function () {
      this.storeArray = new Array();
    },
    clearCookie: function () {
      this.clearStoreArray(), this.setStoreIdsToCookie();
    },
    getNumStores: function () {
      return (
        null == this.storeArray && this.getStoreIdsFromCookie(),
        this.storeArray.length
      );
    },
    getPickUpStoreIdFromCookie: function () {
      var e = getCookie("WC_pickUpStore");
      return e;
    },
    setPickUpStoreIdToCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t != r &&
          (setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie("WC_pickUpStore", t, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearPickUpStoreIdFromCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t == r &&
          setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          });
      }
    },
    getValueFromCookie: function (e) {
      var t = getCookie(e);
      return t;
    },
    setValueToCookie: function (e, t) {
      var r = t;
      if (null != r && "undefined" != r && "" != r) {
        var s = this.getValueFromCookie(e);
        r != s &&
          (setCookie(e, null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie(e, r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearValueFromCookie: function (e) {
      var t = this.getValueFromCookie(e);
      null != t &&
        "undefined" != t &&
        setCookie(e, null, {
          path: "/",
          expires: -1,
          domain: cookieDomain,
        });
    },
  }),
  (storeLocatorJSStore = {
    initProvinceSelections: function () {
      var e = $("#selectCountry").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedCountrySelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectCountry")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("provinceSelectionsContext", {
            countryId: $("#selectCountry")[0].options[t].value,
          });
      }
    },
    refreshCities: function () {
      var e = $("#selectState").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedProvinceSelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectState")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("citySelectionsContext", {
            provinceId: $("#selectState")[0].options[t].value,
          });
      }
    },
    refreshSearchResults: function (e) {
      var t = $("#selectCity").selectedIndex;
      if (t > -1) {
        var r = t,
          s = storeLocatorJSStore.getSavedCitySelectionIndex();
        null != s &&
          s != t &&
          ((r = s),
          ($("#selectCountry")[0].options[r].value("selectCity").options[
            r
          ].selected = !0));
        var a = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stFind");
        null != a &&
          wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
            cityId: document
              .getElementById("selectCountry")
              .options[r].value("selectCity").options[r].value,
            fromPage: e,
          });
      }
    },
    addPhysicalStore: function (e, t) {
      if (1 == PhysicalStoreCookieJSStore.isAddOneStoreIdExceedMax())
        return null !=
          document.getElementById("addPhysicalStoreToCookieButton" + t)
          ? (MessageHelper.formErrorHandleClient(
              "addPhysicalStoreToCookieButton" + t,
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1)
          : (MessageHelper.displayErrorMessage(
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1);
      if (submitRequest())
        return (
          cursor_wait(),
          PhysicalStoreCookieJSStore.addToCookie(e),
          storeLocatorJSStore.showRemoveOption(e),
          !0
        );
    },
    removePhysicalStore: function (e) {
      PhysicalStoreCookieJSStore.removeFromCookie(e),
        PhysicalStoreCookieJSStore.clearPickUpStoreIdFromCookie(e),
        storeLocatorJSStore.showAddOption(e);
    },
    showRemoveOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showAddOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    manageCookieFromCity: function () {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stFind", 1);
    },
    refreshResultsFromCity: function (e, t) {
      return e.selectCity.selectedIndex < 0
        ? void MessageHelper.formErrorHandleClient(
            e.selectCity.id,
            MessageHelper.messages.MISSING_CITY
          )
        : (storeLocatorJSStore.manageCookieFromCity(),
          void wcRenderContext.updateRenderContext(
            "storeLocatorResultsContext",
            {
              cityId: e.selectCity.options[e.selectCity.selectedIndex].value,
              fromPage: t,
              geoCodeLatitude: "",
              geoCodeLongitude: "",
              errorMsgKey: "",
            }
          ));
    },
    refreshResultsFromNearest: function (e, t) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCntry"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          geoCodeLatitude: e,
          geoCodeLongitude: t,
          errorMsgKey: "",
        });
    },
    refreshResultsWithLocationError: function (e) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          errorMsgKey: e,
        });
    },
    refreshStoreList: function (e) {
      wcRenderContext.updateRenderContext("selectedStoreListContext", {
        fromPage: e,
      });
    },
    removeFromStoreList: function (e, t) {
      var r = PhysicalStoreCookieJSStore.getNumStores();
      if (0 == r) this.refreshStoreList(e);
      else {
        var s = document.getElementById(t);
        s.remove();
      }
    },
    hideStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "none"),
        null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "block"),
        null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    changeCountrySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCntry", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("provinceSelectionsContext", {
          countryId: e,
        });
    },
    changeProvinceSelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stProv", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("citySelectionsContext", {
          provinceId: e,
        });
    },
    changeCitySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCity", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");
    },
    getSavedCountrySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCntry");
      if (null != t) {
        var r = $("#selectCountry");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedProvinceSelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stProv");
      if (null != t) {
        var r = $("#selectState");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedCitySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCity");
      if (null != t) {
        var r = $("#selectCity");
        if (null != r && "undefined" != r) {
          var s = r[0].options.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
  }),
  (StoreLocatorContextsJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare(
    "provinceSelectionsContext",
    ["provinceSelections"],
    ""
  ),
  wcRenderContext.declare("citySelectionsContext", ["citySelections"], ""),
  wcRenderContext.declare(
    "storeLocatorResultsContext",
    ["storeLocatorResults"],
    ""
  ),
  wcRenderContext.declare(
    "selectedStoreListContext",
    ["selectedStoreList"],
    ""
  ),
  (StoreLocatorControllersDeclarationJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    provinceSelectionsRefreshArea: function () {
      var e = $("#provinceSelections"),
        t = wcRenderContext.getRenderContextProperties(
          "provinceSelectionsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          storeLocatorJSStore.refreshCities(), cursor_clear();
        },
      });
    },
    citySelectionsRefreshController: function () {
      var e = $("#citySelections"),
        t = wcRenderContext.getRenderContextProperties("citySelectionsContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function (e) {
          storeLocatorJSStore.refreshSearchResults(
            StoreLocatorControllersDeclarationJSStore.fromPage
          ),
            cursor_clear();
        },
      });
    },
    storeLocatorResultsRefreshController: function () {
      var e = $("#storeLocatorResults"),
        t = wcRenderContext.getRenderContextProperties(
          "storeLocatorResultsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus();
          var t = $("#no_store_message");
          null != t && "undefined" != t && t.focus(), cursor_clear();
        },
      });
    },
    selectedStoreListRefreshController: function () {
      var e = $("#selectedStoreList"),
        t = wcRenderContext.getRenderContextProperties(
          "selectedStoreListContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus(), cursor_clear();
        },
      });
    },
  }),
  (AddressBookFormJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    addressDeleted: "false",
    addressNew: "false",
    pageVar: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    getControllerActionHandler: function (e, t) {
      console.debug(
        "entering getControllerActionHandler(controller, handlerKey, actionName): " +
          t
      );
      var r = AddressBookFormJS[t + "s"][e];
      return r
        ? function (e, t, s) {
            r(e, t, s);
          }
        : function (e, t, r) {
            console.debug("empty handler. This is a no-op");
          };
    },
    addressFormAreaActions: {
      create: function (e, t, r) {
        t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "create");
      },
      edit: function (e, t, r) {
        console.debug("starting to getting editing area"),
          t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "edit");
      },
      clean: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
      handleModelChange: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
    },
    addressDisplayAreaActions: {
      reload: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
      handleModelChange: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
    },
    statesDisplayAreaActions: {
      countryUpdated: function (e, t, r) {
        console.debug("IN countryUpdated handler: message = " + e);
        var s = r.renderContext.properties.paramPrefix;
        t.widgetId.match(s)
          ? (console.debug(
              "matchin paramPrefix: " + s + " refreshing " + t.widgetId
            ),
            t.refresh(r.renderContext.properties))
          : console.debug("no maching paramPrefix " + s);
      },
    },
    toggleAddressDisplay: function (e, t, r) {
      console.debug("toggle address display");
      var s = e.options[e.selectedIndex].value;
      $("." + t).each(function (e, t) {
        var a = r + s;
        t.id == a && "MyBillingAddress" != s
          ? $(t).css("display", "block")
          : $(t).css("display", "none");
      });
    },
    populateTextFields: function (e, t, r) {
      if ("block" == document.getElementById("adding").style.display) {
        var s = document.getElementById("adding");
        hideElementById(s);
        var a = document.getElementById("normal");
        a.style.display = "block";
      }
      for (
        var i = e.options[e.selectedIndex].value, n = r.sbAddress, o = 0;
        o < n.length;
        o++
      )
        n[o].value == t[i].addressType && (n[o].checked = "checked");
      (r.nickName.value = t[i].nickName),
        (r.firstName.value = t[i].firstName),
        (r.lastName.value = t[i].lastName),
        (r.address1.value = t[i].address1),
        (r.address2.value = t[i].address2),
        (r.country.value = t[i].country),
        (r.zipCode.value = t[i].zipCode),
        (r.email1.value = t[i].email1),
        (r.phone1.value = t[i].phone1),
        (r.city.value = t[i].city),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state"),
        (r.state.value = t[i].state),
        r.middleName && (r.middleName.value = t[i].middleName),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[i].nickName + "</h2>");
    },
    populateTextFieldsOnLoad: function (e, t, r) {
      for (
        var s = e.options[e.selectedIndex].value, a = r.sbAddress, i = 0;
        i < a.length;
        i++
      )
        a[i].value == t[s].addressType && (a[i].checked = "checked");
      (r.nickName.value = t[s].nickName),
        (r.firstName.value = t[s].firstName),
        (r.lastName.value = t[s].lastName),
        (r.address1.value = t[s].address1),
        (r.address2.value = t[s].address2),
        (r.state.value = t[s].state),
        (r.country.value = t[s].country),
        (r.zipCode.value = t[s].zipCode),
        (r.email1.value = t[s].email1),
        (r.phone1.value = t[s].phone1),
        (r.city.value = t[s].city),
        r.middleName && (r.middleName.value = t[s].middleName),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state", !0),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[s].nickName + "</h2>");
    },
    clearTextFields: function (e) {
      (e.nickName.value = ""),
        (e.firstName.value = ""),
        (e.lastName.value = ""),
        (e.address1.value = ""),
        (e.address2.value = ""),
        (e.city.value = ""),
        (e.state.value = ""),
        (e.country.value = ""),
        (e.zipCode.value = ""),
        (e.email1.value = ""),
        (e.phone1.value = ""),
        e.middleName && (e.middleName.value = "");
    },
    showAdd: function () {
      var e = document.getElementById("normal");
      hideElementById(e);
      var t = document.getElementById("adding");
      t.style.display = "block";
    },
    copyBillingFormNew: function (e, t) {
      var r = document.forms[e],
        s = document.forms[t],
        a = document.getElementById("SameShippingAndBillingAddress");
      a.checked &&
        (hideElementById("shippingAddressCreateEditFormDiv_1"),
        (s.firstName.value = r.firstName.value),
        (s.lastName.value = r.lastName.value),
        (s.address1.value = r.address1.value),
        (s.address2.value = r.address2.value),
        (s.city.value = r.city.value),
        isIE
          ? (document.getElementById("stateDiv2").firstChild.value =
              document.getElementById("stateDiv1").firstChild.value)
          : (s.state.value = r.state.value),
        (s.zipCode.value = r.zipCode.value),
        (s.country.value = r.country.value),
        (s.phone1.value = r.phone1.value),
        (s.email1.value = r.email1.value),
        r.middleName && (s.middleName.value = r.middleName.value)),
        a.checked ||
          (showElementById("shippingAddressCreateEditFormDiv_1"),
          (s.firstName.value = ""),
          (s.lastName.value = ""),
          (s.address1.value = ""),
          (s.address2.value = ""),
          (s.city.value = ""),
          isIE
            ? (document.getElementById("stateDiv2").firstChild.value = "")
            : (s.state.value = ""),
          (s.zipCode.value = ""),
          (s.phone1.value = ""),
          (s.email1.value = ""),
          s.middleName && (s.middleName.value = ""));
    },
  }),
  (LogonForm = {
    SubmitAjaxLogin: function (e) {
      this.validateAjaxLogin(e) &&
        submitRequest() &&
        (setDeleteCartCookie(), e.submit());
    },
    validateAjaxLogin: function (e) {
      return (
        (reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
        "" == e.logonId.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonId.id,
              MessageHelper.messages.LOGON_REQUIRED_FIELD_ENTER
            ),
            !1)
          : (null != e.logonPassword &&
              reWhiteSpace.test(e.logonPassword.value)) ||
            "" == e.logonPassword.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonPassword.id,
              MessageHelper.messages.PASSWORD_REQUIRED_FIELD_ENTER
            ),
            !1)
          : !0
      );
    },
    prepareSubmit: function (e) {
      if (
        "true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished ||
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR
      ) {
        var t = Math.random(),
          r = t.toString(36).slice(-7),
          s = Math.floor(9 * t + 1);
        (r += s),
          (null == $("#logonPassword").val() ||
            "" == $("#logonPassword").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPassword",
                id: "logonPassword",
              })
              .appendTo("form"),
          (null == $("#logonPasswordVerify").val() ||
            "" == $("#logonPasswordVerify").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPasswordVerify",
                id: "logonPasswordVerify",
              })
              .appendTo("form"),
          (null == $("#passwordExpired").val() ||
            "" == $("#passwordExpired").val()) &&
            $("#passwordExpired").val("1");
      }
      this.validatePrepareForm(e) /*&& submitRequest()*/ &&
        (setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {
          path: "/",
          domain: cookieDomain,
        }),
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR ||
        ("true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished &&
          null != e.userId &&
          null != e.userId.value)
          ? null != registeredCustomersJS &&
            registeredCustomersJS.createRegisteredUser(e.landingURL_CSR.value)
          : e.submit());
    },
    validatePrepareForm: function (e) {
      if (
        ((reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
          "" == e.logonId.value)
      )
        return (
          MessageHelper.formErrorHandleClient(
            e.logonId.id,
            MessageHelper.messages.ERROR_LogonIdEmpty
          ),
          !1
        );
      if (
        "function" == typeof this.validateLoginId &&
        !this.validateLoginId(e.logonId)
      )
        return !1;
      if (null != e.ancestorOrgs) {
        if ("" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_OrgNameEmpty
            ),
            !1
          );
        if ("Default Organization" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_DefaultOrgRegistration
            ),
            !1
          );
      }
      return (null != e.logonPassword &&
        reWhiteSpace.test(e.logonPassword.value)) ||
        "" == e.logonPassword.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPassword.id,
            MessageHelper.messages.ERROR_PasswordEmpty
          ),
          !1)
        : (null != e.logonPasswordVerify &&
            reWhiteSpace.test(e.logonPasswordVerify.value)) ||
          "" == e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.ERROR_VerifyPasswordEmpty
          ),
          !1)
        : e.logonPassword.value != e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.PWDREENTER_DO_NOT_MATCH
          ),
          !1)
        : AddressHelper.validateAddressForm(e)
        ? (e.sendMeEmail && e.sendMeEmail.checked
            ? (e.receiveEmail.value = !0)
            : (e.receiveEmail.value = !1),
          e.sendMeSMSNotification && e.sendMeSMSNotification.checked
            ? (e.receiveSMSNotification.value = !0)
            : (e.receiveSMSNotification.value = !1),
          e.sendMeSMSPreference && e.sendMeSMSPreference.checked
            ? (e.receiveSMS.value = !0)
            : (e.receiveSMS.value = !1),
          (null == e.mobileDeviceEnabled ||
            "true" != e.mobileDeviceEnabled.value ||
            MyAccountDisplay.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            MyAccountDisplay.validateBirthday(e))
            ? !0
            : !1)
        : !1;
    },
    validateAge: function (e) {
      var t = parseInt(e.birth_year.value),
        r = parseInt(e.birth_month.value),
        s = parseInt(e.birth_date.value);
      if (0 != t && 0 != r && 0 != s) {
        var a = parseInt(e.curr_year.value),
          i = parseInt(e.curr_month.value),
          n = parseInt(e.curr_date.value);
        13 > a - t
          ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
          : a - t == 13 &&
            (r > i
              ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
              : i == r &&
                s > n &&
                alert(MessageHelper.messages.AGE_WARNING_ALERT));
      }
    },
    checkAge: function (e) {
      1 == e.age.value && alert(MessageHelper.messages.AGE_WARNING_ALERT);
    },
  }),
  (MultipleWishLists = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    defaultListId: null,
    addItemAfterCreate: !1,
    preferredDefaultWishListName: "",
    wishListPrefix: "",
    updateAfterSwitch: !1,
    maxCharsToDisplay: 30,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    switchList: function (e) {
      submitRequest() &&
        (cursor_wait(),
        $("#multipleWishlistController_select").attr("disabled", "true"),
        (this.updateAfterSwitch = !0),
        this.setAsDefault(e));
    },
    updateContextPostSwitch: function (e) {
      this.updateAfterSwitch &&
        (wcRenderContext.updateRenderContext("WishlistDisplay_Context", {
          giftListId: e,
        }),
        wcRenderContext.updateRenderContext("WishlistSelect_Context", {
          giftListId: e,
        })),
        (this.updateAfterSwitch = !1);
    },
    removeItem: function (e) {
      var t = {};
      if (
        ((t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.quantity = 0),
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          0 != $("#multipleWishlistController_select").val() &&
          ((t.giftListId = $("#multipleWishlistController_select").val()),
          !this.empty(e)))
      ) {
        if (((t.giftListItemId = e), !submitRequest())) return;
        cursor_wait(), wcService.invoke("ShoppingListServiceRemoveItem", t);
      }
    },
    getWishListIdForEmail: function (e) {
      var t = document.getElementById(e);
      null != $("#multipleWishlistController_select") &&
        "undefined" != $("#multipleWishlistController_select") &&
        0 != $("#multipleWishlistController_select").val() &&
        (t.giftListId.value = $("#multipleWishlistController_select").val());
    },
    checkSOAEmailForm: function (e) {
      $("#WishListEmailSucMsg_Div").css("display", "none");
      var t = document.getElementById(e);
      return (
        (t.sender_name.value = t.sender_name.value.replace(/^\s+/g, "")),
        (t.recipient.value = t.recipient.value.replace(/^\s+/g, "")),
        "" == t.recipient.value
          ? void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_MISSINGEMAIL")
            )
          : MultipleWishLists.validateWishListEmailString(t.recipient.value)
          ? "" == t.sender_name.value
            ? void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Name").id,
                Utils.getLocalizationMessage("WISHLIST_MISSINGNAME")
              )
            : MultipleWishLists.validateWishListEmailString(
                t.sender_email.value
              )
            ? "" == t.giftListId.value ||
              "false" == t.wishListHasItem.value ||
              "-1" == t.giftListId.value
              ? void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_EMPTY")
                )
              : MultipleWishLists.validateSenderName(t.sender_name.value)
              ? ((t.recipientEmail.value = t.recipient.value),
                (t.recipient.value = ""),
                (t.senderName.value = t.sender_name.value),
                "" != t.sender_email.value &&
                  (t.senderEmail.value = t.sender_email.value),
                "" != t.wishlist_message.value &&
                  (t.message.value = t.wishlist_message.value),
                void (
                  submitRequest() &&
                  (cursor_wait(),
                  wcService
                    .getServiceById("AjaxGiftListAnnouncement")
                    .setFormId(e),
                  wcService.invoke("AjaxGiftListAnnouncement"),
                  (t.senderEmail.value =
                    "SOAWishListEmail@SOAWishListEmail.com"),
                  (t.message.value = "SOAWishListEmail"))
                ))
              : ((t.sender_name.value = ""),
                void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_INVALIDSENDERNAME")
                ))
            : void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Email").id,
                Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
              )
          : void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
            )
      );
    },
    setAsDefault: function (e) {
      if ("-1" != e) {
        var t = {};
        (t.storeId = this.storeId),
          (t.catalogId = this.catalogId),
          (t.langId = this.langId),
          (t.giftListId = e),
          (t.giftListState = "Default"),
          cursor_wait(),
          wcService.invoke("AjaxGiftListServiceChangeGiftListStatus", t);
      } else
        MultipleWishLists.setDefaultListId("-1"),
          MultipleWishLists.updateContextPostSwitch("-1");
    },
    empty: function (e) {
      return null == e || void 0 == e || "" == e;
    },
    setDefaultListId: function (e) {
      this.defaultListId = e;
    },
    getDefaultListId: function () {
      return this.defaultListId;
    },
    setPreferredDefaultWishListName: function (e) {
      this.preferredDefaultWishListName = e;
    },
    setWishListPrefix: function (e) {
      this.wishListPrefix = e;
    },
    validateSenderName: function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += "    '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    },
    validateWishListEmailString: function (e) {
      for (var t = !0, r = e.split(","), s = 0; s < r.length; s++)
        MessageHelper.isValidEmail(r[s]) || (t = !1);
      return t;
    },
  }),
  (MyAccountControllersDeclarationJS = {
    declareProcessedOrdersStatusDisplayRefreshArea: function () {
      var e = $("#ProcessedOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ProcessedOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ProcessedOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWaitingForApprovalOrdersStatusDisplayRefreshArea: function () {
      var e = $("#WaitingForApprovalOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "WaitingForApprovalOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "WaitingForApprovalOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  (MyAccountDisplay = {
    contextChanged: !1,
    isHistory: !1,
    currentSelection: "",
    currentTabId: "PreviouslyProcessed",
    isPreferredLanguageUpdated: !1,
    dropDownDlg: null,
    currentOrderTabId: "recurring_order_details",
    subscriptionDate: "",
    subscriptionOrderId: "",
    subscriptionOrderItemId: "",
    setPreferredLanguageUpdated: function (e) {
      this.isPreferredLanguageUpdated = e;
    },
    getPreferredLanguageUpdated: function () {
      return this.isPreferredLanguageUpdated;
    },
    setSubscriptionDate: function (e) {
      this.subscriptionDate = e;
    },
    getLastRecordInfo: function (e, t, r, s) {
      var a;
      r.split(";");
      return (
        s
          ? 1 == e || "" == e || void 0 == e
            ? (a = "" != t && void 0 != t ? t : " ")
            : "" != r &&
              void 0 != r &&
              (a =
                "" != t && void 0 != t
                  ? r.concat(";").concat(t)
                  : r.concat(";").concat(" "))
          : "" != r &&
            void 0 != r &&
            (a =
              r.lastIndexOf(";") > -1
                ? r.substring(0, r.lastIndexOf(";"))
                : ""),
        a
      );
    },
    updateRenderContextForPagination: function (e, t, r, s, a, i, n, o, d) {
      var l,
        c = this.getLastRecordInfo(a, i, n, o);
      (l = o ? parseInt(t) + parseInt(r) : parseInt(t) - parseInt(r)),
        wcRenderContext.updateRenderContext(e, {
          beginIndex: l,
          pageSize: r,
          isQuote: s,
          lastExternalOrderIds: c,
          recordSetTotal: d,
        });
    },
    escapeXML: function (e) {
      return e
        ? e
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\"/g, "&quot;")
            .replace(/\'/g, "&#039;")
        : ProcessAuthoringConstants.EMPTY;
    },
    getSubscriptionDate: function () {
      var e = parseInt(this.subscriptionDate.substring(0, 4), 10),
        t = parseInt(this.subscriptionDate.substring(5, 7), 10),
        r = parseInt(this.subscriptionDate.substring(8, 10), 10);
      2 == t
        ? e % 4 == 0 && e % 100 != 0 && e % 400 == 0
          ? 29 != r
            ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
            : ((r = "01"), (t = "03"))
          : 28 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
          : ((r = "01"), (t = "03"))
        : 12 == t
        ? 31 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "12"))
          : ((r = "01"), (t = "01"), (e += 1))
        : 4 == t || 6 == t || 9 == t || 11 == t
        ? (30 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t))
        : (31 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t));
      var s = this.subscriptionDate.indexOf("T", 0),
        a = this.subscriptionDate.indexOf("Z", s),
        i = this.subscriptionDate.substring(s + 1, a),
        n = e + "-" + t + "-" + r + "T" + i + "Z";
      return n;
    },
    setOff: function (e) {
      (document.getElementById(e + "_On").style.display = "none"),
        (document.getElementById(e + "_Off").style.display = "inline"),
        (document.getElementById(e).style.display = "none");
    },
    setOn: function (e) {
      (document.getElementById(e + "_On").style.display = "inline"),
        (document.getElementById(e + "_Off").style.display = "none"),
        (document.getElementById(e).style.display = "block");
    },
    selectTab: function (e) {
      (this.currentSelection = "trackOrderStatus"),
        this.setOff(this.currentTabId),
        this.setOn(e),
        (this.currentTabId = e);
    },
    prepareOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("OrderCopy").setUrl(e),
        wcService.invoke("OrderCopy"));
    },
    prepareSSFSOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("SSFSOrderCopy").setUrl(e),
        wcService.invoke("SSFSOrderCopy"));
    },
    prepareSubscriptionRenew: function (e) {
      submitRequest() &&
        (cursor_wait(),
        (wcService.getServiceById("SubscriptionRenew").url = e),
        wcService.invoke("SubscriptionRenew"));
    },
    cancelScheduledOrder: function (e) {
      if (submitRequest()) {
        cursor_wait();
        var t = [];
        (t.orderId = e),
          (t.URL = ""),
          (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          wcService.invoke("AjaxScheduledOrderCancel", t);
      }
    },
    changeSelection: function (e) {
      var t = e.indexOf("currentSelection", 0);
      if ("-1" != t)
        var r = e.indexOf("Slct", t),
          s = e.substring(t + 17, r);
      if (
        (this.currentSelection &&
          (document
            .getElementById(this.currentSelection)
            .setAttribute("class", ""),
          document
            .getElementById(this.currentSelection)
            .setAttribute("className", "")),
        (document.getElementById("MyAccountBreadcrumbLink").style.display =
          "none"),
        document.getElementById("RecurringOrderBreadcrumb") &&
          ((document.getElementById("RecurringOrderBreadcrumb").style.display =
            "none"),
          (document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "none")),
        document.getElementById("SubscriptionBreadcrumb") &&
          ((document.getElementById("SubscriptionBreadcrumb").style.display =
            "none"),
          (document.getElementById("SubscriptionBreadcrumb1").style.display =
            "none")),
        document.getElementById("OrderHistoryBreadcrumb") &&
          ((document.getElementById("OrderHistoryBreadcrumb").style.display =
            "none"),
          (document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "none")),
        s)
      )
        if ("trackOrderStatus" == s)
          document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "inline";
        else if ("OrderDetail" == s) {
          document.getElementById("OrderHistoryBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "OrderHistoryDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackRecurringOrderStatus" == s)
          document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "inline";
        else if ("RecurringOrderDetail" == s) {
          document.getElementById("RecurringOrderBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "RecurringOrderDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackSubscriptionStatus" == s)
          document.getElementById("SubscriptionBreadcrumb1").style.display =
            "inline";
        else if ("SubscriptionDetail" == s) {
          document.getElementById("SubscriptionBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "SubscriptionDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else
          document.getElementById(s) &&
            ((document.getElementById("MyAccountBreadcrumbLink").style.display =
              "inline"),
            document.getElementById(s).setAttribute("class", "strong"),
            document.getElementById(s).setAttribute("className", "strong"),
            (this.currentSelection = s));
      else
        document.getElementById("MyAccountBreadcrumbLink").style.display =
          "inline";
    },
    prepareSubmit: function (e, t, r) {
      if (
        AddressHelper.validateAddressForm(e) &&
        (e.sendMeEmail && e.sendMeEmail.checked
          ? (e.receiveEmail.value = !0)
          : (e.receiveEmail.value = !1),
        e.sendMeSMSNotification && e.sendMeSMSNotification.checked
          ? (e.receiveSMSNotification.value = !0)
          : (e.receiveSMSNotification.value = !1),
        e.sendMeSMSPreference && e.sendMeSMSPreference.checked
          ? (e.receiveSMS.value = !0)
          : (e.receiveSMS.value = !1),
        (null == e.mobileDeviceEnabled ||
          "true" != e.mobileDeviceEnabled.value ||
          this.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            this.validateBirthday(e)) &&
          submitRequest() &&
          (processAndSubmitForm(e),
          "true" != CSRWCParamJS.env_shopOnBehalfSessionEstablished))
      ) {
        var s = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        trim(s) != e.firstName.value + " " + e.lastName.value &&
          setCookie(
            "WC_LogonUserId_" + WCParamJS.storeId,
            e.firstName.value + " " + e.lastName.value,
            {
              path: "/",
              domain: cookieDomain,
            }
          );
      }
    },
    popupWindow: function (e) {
      window.open(e, "mywindow", "status=1,scrollbars=1,resizable=1");
    },
    deleteCoupon: function (e, t) {
      var r = document.forms[e];
      if (((r.couponId.value = t), (r.taskType.value = "D"), submitRequest())) {
        var s = wcService.getServiceById("AjaxRESTWalletCouponsDelete");
        s.setFormId(e),
          cursor_wait(),
          wcService.invoke("AjaxRESTWalletCouponsDelete");
      }
    },
    cancelRecurringOrder: function (e, t) {
      if (submitRequest()) {
        cursor_wait(),
          $("[data-widget-type='wc.WCDialog'][data-popupIndex='" + t + "']")
            .data("wc-WCDialog")
            .destroy();
        var r = {
          subscriptionId: e,
          URL: "",
          storeId: MyAccountServicesDeclarationJS.storeId,
          catalogId: MyAccountServicesDeclarationJS.catalogId,
          langId: MyAccountServicesDeclarationJS.langId,
        };
        wcService.invoke("AjaxCancelSubscription", r);
      }
    },
    updateContract: function (e, t, r) {
      var s = document.forms[e],
        a = !1;
      if (submitRequest()) {
        if (void 0 != s.contractId.length) {
          for (var i = 0; i < s.contractId.length; i++)
            if (s.contractId[i].checked) {
              a = !0;
              break;
            }
          if (!a) {
            for (var n = t.split(";"), o = 0; o < n.length; o++)
              document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + n[o]
              ).checked = !0;
            MessageHelper.displayErrorMessage(r), resetRequest();
          }
        } else
          s.contractId.checked
            ? (a = !0)
            : ((document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + s.contractId.value
              ).checked = !0),
              MessageHelper.displayErrorMessage(r),
              resetRequest());
        a && processAndSubmitForm(s);
      }
    },
    updateOrganization: function (e) {
      var t = document.forms[e];
      submitRequest() && processAndSubmitForm(t);
    },
    HistoryTracker: function (e, t, r) {
      (this.workAreaModeValue = e), (this.elementId = t), (this.changeUrl = r);
    },
    validateBirthday: function (e) {
      if (
        null != e.birth_year &&
        null != e.birth_month &&
        null != e.birth_date
      ) {
        if (
          0 != e.birth_year.value ||
          0 != e.birth_month.value ||
          0 != e.birth_date.value
        ) {
          if (0 == e.birth_month.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_month.id + "-button",
                MessageHelper.messages.ERROR_SpecifyMonth
              ),
              !1
            );
          if (0 == e.birth_date.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_SpecifyDate
              ),
              !1
            );
          var t = 29;
          0 != e.birth_year.value && e.birth_year.value % 4 != 0 && (t = 28);
          for (var r = ["4", "6", "9", "11"], s = !1, a = 0; a < r.length; a++)
            if (r[a] == e.birth_month.value) {
              s = !0;
              break;
            }
          if (s && e.birth_date.value > 30)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (2 == e.birth_month.value && e.birth_date.value > t)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (
            null != e.curr_year &&
            null != e.curr_month &&
            null != e.curr_date
          ) {
            var i = parseInt(e.birth_year.value),
              n = parseInt(e.birth_month.value),
              o = parseInt(e.birth_date.value),
              d = parseInt(e.curr_year.value),
              l = parseInt(e.curr_month.value),
              c = parseInt(e.curr_date.value);
            if (i > d)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_year.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n > l)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_month.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n == l && o > c)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_date.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (null != e.dateOfBirthTemp)
              if (0 != e.birth_month.value && 0 != e.birth_date.value) {
                var u = i,
                  m = n,
                  g = o;
                0 == i && (u = 1896),
                  10 > n && (m = "0" + n),
                  10 > o && (g = "0" + o),
                  (e.dateOfBirthTemp.value = u + "-" + m + "-" + g),
                  (document.getElementById(e.dateOfBirthTemp.id).name =
                    "dateOfBirth");
              } else e.dateOfBirthTemp.value = null;
          }
          return !0;
        }
        if (null != e.dateOfBirthTemp) {
          e.dateOfBirthTemp.value = "";
          if (null != document.getElementById(e.dateOfBirthTemp.id)) {
            document.getElementById(e.dateOfBirthTemp.id).name = "dateOfBirth";
          }
        }

        return (isGDPR && !gdpr_error) || !isGDPR;
      }
      return !0;
    },
    validateMobileDevice: function (e) {
      if (null != e.mobilePhone1 && "" != e.mobilePhone1) {
        if (!MessageHelper.isValidUTF8length(e.mobilePhone1.value, 32))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_PhoneTooLong
            ),
            !1
          );
        if (!MessageHelper.IsValidPhone(e.mobilePhone1.value))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_INVALIDPHONE
            ),
            !1
          );
      }
      return !0;
    },
    showActionsPopup: function (e, t) {
      if (null == e || e.keyCode == KeyCodes.DOWN_ARROW) {
        var r = $("#" + t).data("wc-WCDialog");
        r && ((this.dropDownDlg = r), this.dropDownDlg.open());
      }
    },
    showPopup: function (e, t, r, s) {
      var a = $("#Cancel_" + e + "_popup").data("wc-WCDialog");
      null != a
        ? (closeAllDialogs(),
          a.element.attr("data-popupIndex", r),
          a.open(),
          document
            .getElementById("Cancel_yes_" + e)
            .setAttribute(
              "onclick",
              "MyAccountDisplay.cancelRecurringOrder(" + t + "," + r + ");"
            ),
          document.getElementById("cancel_notice_" + e) &&
            document.getElementById(s) &&
            $("#cancel_notice_" + e).html($("#" + s).val()))
        : console.debug("Cancel_subscription_popup does not exist");
    },
    selectRecurringOrderTab: function (e) {
      this.setOff(this.currentOrderTabId),
        this.setOn(e),
        (this.currentOrderTabId = e);
    },
  }),
  (MyAccountServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "InterestItemDelete",
    actionId: "InterestItemDelete",
    url: "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.WISHLIST_REMOVEITEM
      );
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "InterestItemListMessage",
    actionId: "InterestItemListMessage",
    url: "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddress",
    actionId: "AddBillingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AddShippingAddress",
    actionId: "AddShippingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddress",
    actionId: "UpdateBillingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("PSL::store.js::UpdateBillingAddress::successHandler::");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
      /* HB-407 BEGIN */
      resetRequest();
      javascript: AddressHelper.saveAddress(
        "UpdateShippingAddress",
        "shippingAddressCreateEditFormDiv_1"
      );
      /* HB-407 END */
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateShippingAddress",
    actionId: "UpdateShippingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::successHandler");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::failureHandler");
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAddRemove",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxCouponsAddRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxRESTWalletCouponsDelete",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxRESTWalletCouponsDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxWalletItemProcessServiceDelete",
    actionId: "AjaxWalletItemProcessServiceDelete",
    url: "AjaxWalletItemProcessServiceDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCancelSubscription",
    actionId: "AjaxCancelSubscription",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        closeAllDialogs(),
        "RecurringOrder" == e.subscriptionType
          ? "PendingCancel" == e.state
            ? MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_PENDING_CANCEL_MSG
              )
            : MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_CANCEL_MSG
              )
          : "PendingCancel" == e.state
          ? MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_PENDING_CANCEL_MSG
            )
          : MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_CANCEL_MSG
            );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderCopy",
    actionId: "OrderCopy",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      if (null != e.newOrderItemsCount && e.newOrderItemsCount <= 0)
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.CANNOT_REORDER_ANY_MSG
        );
      else {
        setDeleteCartCookie();
        var r = [],
          s = "AjaxRESTOrderPrepare",
          a = [];
        (a.orderId = e.orderId),
          r.push({
            URL: "AjaxCheckoutDisplayView",
            requestType: "GET",
            requestParams: {},
          });
        var i = getCustomServiceForURLChaining(s, r, null);
        wcService.invoke(i.getParam("id"), a);
      }
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SSFSOrderCopy",
    actionId: "SSFSOrderCopy",
    url: "AjaxSSFSOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      setDeleteCartCookie(),
        (document.location.href = appendWcCommonRequestParameters(
          "AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubscriptionRenew",
    actionId: "SubscriptionRenew",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r = [];
      (r.storeId = MyAccountServicesDeclarationJS.storeId),
        (r.catalogId = MyAccountServicesDeclarationJS.catalogId),
        (r.langId = MyAccountServicesDeclarationJS.langId),
        (r.orderId = e.orderId),
        (r.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (r.requestedShipDate = MyAccountDisplay.getSubscriptionDate()),
        (MyAccountDisplay.subscriptionOrderId = e.orderId),
        (MyAccountDisplay.subscriptionOrderItemId = e.orderItemId[0]),
        wcService.invoke("SetRequestedShippingDate", r);
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SetRequestedShippingDate",
    actionId: "SetRequestedShippingDate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        (document.location.href = appendWcCommonRequestParameters(
          "RESTOrderPrepare?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId +
            "&orderId=" +
            e.orderId +
            "&URL=AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      if (
        "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET" == e.errorMessageKey
      ) {
        var t = [];
        (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          (t.orderId = MyAccountDisplay.subscriptionOrderId),
          (t.orderItemId = MyAccountDisplay.subscriptionOrderItemId),
          (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
          wcService.invoke("RemoveSubscriptionItem", t),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.CANNOT_RENEW_NOW_MSG
          );
      } else
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
          cursor_clear();
    },
  }),
  wcService.declare({
    id: "RemoveSubscriptionItem",
    actionId: "RemoveSubscriptionItem",
    url: "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxScheduledOrderCancel",
    actionId: "AjaxScheduledOrderCancel",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (QuickCheckoutProfile = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    pageVar: "aa",
    changed: "false",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    valueChanged: function (e) {
      QuickCheckoutProfile.changed = e;
    },
    validateForm: function (e) {
      reWhiteSpace = new RegExp(/^\s+$/);
      var t = document.forms[e],
        r = null;
      null != t.pay_expire_year &&
        (r = new Date(
          t.pay_expire_year.value,
          t.pay_expire_month.value - 1,
          1
        ));
      var s = t.curr_month.value;
      if (
        ((s = 1 == s.length ? "0" + s : t.curr_month.value),
        !AddressHelper.validateAddressForm(t, "billing_"))
      )
        return !1;
      if (!AddressHelper.validateAddressForm(t, "shipping_")) return !1;
      var a = $("#payMethodId");
      if (null != a.find(":selected").val()) {
        if (
          (null != t.pay_temp_account &&
            reWhiteSpace.test(t.pay_temp_account.value)) ||
          "" == t.pay_temp_account.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_temp_account.id,
              MessageHelper.messages.REQUIRED_FIELD_ENTER
            ),
            !1
          );
        if (
          ("true" == QuickCheckoutProfile.changed
            ? (t.pay_temp_account.name = "pay_account")
            : (QuickCheckoutProfile.changed = "false"),
          null != t.pay_expire_year &&
            t.pay_expire_year.value < t.curr_year.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_year.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
        if (
          null != t.pay_expire_year &&
          t.pay_expire_year.value == t.curr_year.value &&
          s > t.pay_expire_month.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_month.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
      }
      return !0;
    },
    getCurrentProfile: function (e, t) {
      var r = $("input[name=" + t + "_firstName]")[0],
        s = $("input[name=" + t + "_lastName]")[0],
        a = $("input[name=" + t + "_address1]")[0],
        i = $("input[name=" + t + "_address2]")[0],
        n = $("input[name=" + t + "_zipCode]")[0],
        o = $("input[name=" + t + "_email1]")[0],
        d = $("input[name=" + t + "_phone1]")[0],
        l = $("input[name=" + t + "_city]")[0],
        c = "";
      $("input[name=" + t + "_middleName]")[0] &&
        (c = $("input[name=" + t + "_middleName]")[0]),
        (r.value = e.firstName),
        (s.value = e.lastName),
        (a.value = e.address1),
        (i.value = e.address2),
        (n.value = e.zipCode),
        (o.value = e.email1),
        (d.value = e.phone1),
        (l.value = e.city),
        c && (c.value = e.middleName);
      var u =
          t +
          "_WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
          t +
          "_state_1",
        m = $("#" + u);
      if (
        ("" != e.state &&
          (void 0 !== m && null !== m
            ? (m.val(e.state), m.Select("refresh_noResizeButton"))
            : ((m = $("input[name=" + t + "_state]")[0].val()),
              m.val(e.state))),
        "" != e.country)
      ) {
        var g = $(
          "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
            t +
            "_country_1"
        );
        g.val(e.country),
          g.Select("refresh_noResizeButton"),
          AddressHelper.loadAddressFormStatesUI(
            "QuickCheckout",
            t + "_",
            t + "_stateDiv",
            "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
              t +
              "_state_1",
            !1,
            e.state
          );
      }
    },
    showHide: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      t.checked
        ? (hideElementById("shipAddr"), this.copyBillingAddress(e))
        : (showElementById("shipAddr"),
          ($("input[name=shipping_firstName]")[0].value = ""),
          ($("input[name=shipping_lastName]")[0].value = ""),
          ($("input[name=shipping_address1]")[0].value = ""),
          ($("input[name=shipping_address2]")[0].value = ""),
          ($("input[name=shipping_city]")[0].value = ""),
          ($("input[name=shipping_zipCode]")[0].value = ""),
          ($("input[name=shipping_phone1]")[0].value = ""),
          ($("input[name=shipping_email1]")[0].value = ""),
          ($("select,input[name=shipping_state]")[0].value = ""),
          $("input[name=shipping_middleName]")[0] &&
            ($("input[name=shipping_middleName]")[0].value = ""));
    },
    copyBillingAddress: function (e) {
      ($("input[name=shipping_firstName]")[0].value =
        e.billing_firstName.value),
        ($("input[name=shipping_lastName]")[0].value =
          e.billing_lastName.value),
        ($("input[name=shipping_address1]")[0].value =
          e.billing_address1.value),
        ($("input[name=shipping_address2]")[0].value =
          e.billing_address2.value),
        ($("input[name=shipping_city]")[0].value = e.billing_city.value),
        ($("input[name=shipping_zipCode]")[0].value = e.billing_zipCode.value),
        ($("input[name=shipping_phone1]")[0].value = e.billing_phone1.value),
        ($("input[name=shipping_email1]")[0].value = e.billing_email1.value),
        $("input[name=shipping_middleName]")[0] &&
          ($("input[name=shipping_middleName]")[0].value =
            e.billing_middleName.value);
      var t = $(
        "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_country_1"
      );
      t.val(e.billing_country.value),
        t.Select("refresh_noResizeButton"),
        AddressHelper.loadAddressFormStatesUI(
          "QuickCheckout",
          "shipping_",
          "shipping_stateDiv",
          "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_state_1",
          !1,
          e.billing_state.value
        );
    },
    UpdateProfile: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      if (
        (t.checked && this.copyBillingAddress(e), this.validateForm(e.name))
      ) {
        var r,
          s = $("#payMethodId");
        if (
          (0 !== s.length && (r = s.val()),
          (e.pay_payment_method.value = r),
          (e.pay_cc_brand.value = r),
          (e.pay_payMethodId.value = r),
          !submitRequest())
        )
          return;
        processAndSubmitForm(e);
      }
    },
  }),
  (sterlingIntegrationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    locale: "",
    jspStoreImgDir: "",
    orderBeingCanceled: "",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        alert("-1 " + this.storeId),
        (this.catalogId = r),
        (this.locale = s),
        (this.jspStoreImgDir = a);
    },
    populateOrderLevelInfo: function (orderStr) {
      var jsonOrder = eval("(" + orderStr + ")"),
        locale = document.getElementById("Locale_String").innerHTML,
        shipmentType = 2;
      this.isNullObj(jsonOrder.Root.Order.shipmentTypeId) ||
        (shipmentType = jsonOrder.Root.Order.shipmentTypeId);
      var pmTotalNumber = 0;
      this.isNullObj(jsonOrder.Root.Order.countOfPaymentMethods) ||
        (pmTotalNumber = jsonOrder.Root.Order.countOfPaymentMethods);
      var oiTotalNumber = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (oiTotalNumber = jsonOrder.Root.Order.countOfOrderLines),
        !this.isNullObj(jsonOrder.Root.Order.OrderNo))
      ) {
        var orderNo = jsonOrder.Root.Order.OrderNo;
        if (this.isNullObj(jsonOrder.Root.Order.EntryType))
          document.getElementById("OrderNo").innerHTML = orderNo;
        else {
          var entryType = jsonOrder.Root.Order.EntryType;
          "WCS" == entryType
            ? (document.getElementById("OrderNo").innerHTML =
                orderNo.substring(3))
            : (document.getElementById("OrderNo").innerHTML = orderNo);
        }
      }
      if (!this.isNullObj(jsonOrder.Root.Order.OrderDate)) {
        var orderDate = jsonOrder.Root.Order.OrderDate,
          parsedOrderDate = new Date(orderDate);
        document.getElementById("OrderDate").innerHTML = Globalize.formatDate(
          parsedOrderDate,
          {
            date: "long",
          }
        );
      }
      if (1 == shipmentType) {
        var shippingAddress = null,
          orderLinePersonInfoShipTo = null;
        this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
          (this.isNullObj(
            jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo
          )
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0]) ||
              this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo
              ) ||
              (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo)
            : (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo)),
          this.isNullObj(orderLinePersonInfoShipTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              )
            : this.populateAddress(
                orderLinePersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              );
        var shippingMethod = null;
        if (
          (this.isNullObj(jsonOrder.Root.Order.Shipments) ||
            this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment) ||
            (this.isNullObj(
              jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
            )
              ? this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]) ||
                this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment[0].shipModeDescription
                ) ||
                (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment[0]
                    .shipModeDescription)
              : (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription)),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.shipModeDescription
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription
                  ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription)
                : (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine
                      .shipModeDescription))),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.CarrierServiceCode) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById("Single_Shipping_Method").innerHTML =
              shippingMethod),
          !this.isNullObj(
            document.getElementById("Single_Shipping_Instruction")
          ))
        ) {
          var instructions = null;
          if (
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.Instructions
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions
                  ) ||
                  (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions)
                : (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine.Instructions)),
            !this.isNullObj(instructions) &&
              !this.isNullObj(instructions.Instruction))
          ) {
            var instruction = instructions.Instruction;
            if (this.isNullObj(instruction.InstructionType)) {
              if (!this.isNullObj(instructions.Instruction[0]))
                for (var k in instructions.Instruction)
                  this.isNullObj(instructions.Instruction[k].InstructionType) ||
                    ("SHIP" == instructions.Instruction[k].InstructionType &&
                      (this.isNullObj(
                        instructions.Instruction[k].InstructionText
                      ) ||
                        ((document.getElementById(
                          "Single_Shipping_Instruction_Label"
                        ).style.display = "inline"),
                        (document.getElementById(
                          "Single_Shipping_Instruction"
                        ).innerHTML =
                          document.getElementById("Single_Shipping_Instruction")
                            .innerHTML +
                          instructions.Instruction[k].InstructionText +
                          "<br/>"))));
            } else
              "SHIP" == instruction.InstructionType &&
                (this.isNullObj(instruction.InstructionText) ||
                  ((document.getElementById(
                    "Single_Shipping_Instruction_Label"
                  ).style.display = "inline"),
                  (document.getElementById(
                    "Single_Shipping_Instruction"
                  ).innerHTML = instruction.InstructionText)));
          }
        }
      }
      if (
        !this.isNullObj(document.getElementById("Shipping_As_Complete_Y")) &&
        !this.isNullObj(jsonOrder.Root.Order.IsShipComplete)
      ) {
        var shipAsComplete = jsonOrder.Root.Order.IsShipComplete;
        "Y" == shipAsComplete
          ? ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "inline"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "none"))
          : ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "none"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "inline"));
      }
      var currencyCode = "USD";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
        (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
      var currencyDecimals = 2;
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
        (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
      var currencySymbol = "$";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
        (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.LineSubTotal) ||
          (document.getElementById("Order_SubTotal").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.LineSubTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            ));
      var grandDiscount = jsonOrder.Root.Order.OverallTotals.GrandDiscount;
      this.isNullObj(grandDiscount) ||
        (grandDiscount > 0 && (grandDiscount = 0 - grandDiscount),
        (document.getElementById("Order_Discount").innerHTML =
          this.formatCurrency(
            grandDiscount,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          ))),
        this.isNullObj(
          jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge
        ) ||
          (document.getElementById("Order_Shipping").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.salesTax) ||
          (document.getElementById("Order_Tax").innerHTML = this.formatCurrency(
            jsonOrder.Root.Order.OverallTotals.salesTax,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.shippingTax) ||
          (document.getElementById("Order_ShippingTax").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.shippingTax,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.GrandTotal) ||
          (document.getElementById("Order_Totals").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        0 == pmTotalNumber &&
          (this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoBillTo,
              "Billing_Address_With_No_Payment_Method",
              locale
            ));
      for (var i = 0; pmTotalNumber > i; i++) {
        var paymentMethod = null;
        (paymentMethod =
          1 == pmTotalNumber
            ? jsonOrder.Root.Order.PaymentMethods.PaymentMethod
            : jsonOrder.Root.Order.PaymentMethods.PaymentMethod[i]),
          this.isNullObj(paymentMethod.PersonInfoBillTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              )
            : this.populateAddress(
                paymentMethod.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              ),
          this.isNullObj(paymentMethod.paymentMethodName) ||
            (document.getElementById("Payment_Method_Name_" + i).innerHTML =
              paymentMethod.paymentMethodName),
          this.isNullObj(paymentMethod.PaymentType) ||
            ("CREDIT_CARD" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "inline"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayCreditCardNo) ||
                (document.getElementById("CreditCard_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayCreditCardNo),
              this.isNullObj(paymentMethod.CreditCardExpDate) ||
                ((document.getElementById(
                  "CreditCard_Expiration_Month_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(0, 2)),
                (document.getElementById(
                  "CreditCard_Expiration_Year_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(
                  3,
                  7
                )))),
            "Check" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "inline"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayPaymentReference1) ||
                (document.getElementById("Check_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayPaymentReference1)),
            "LineOfCreidt" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "inline"),
              this.isNullObj(paymentMethod.DisplayCustomerAccountNo) ||
                (document.getElementById(
                  "LineOfCredit_Account_" + i
                ).innerHTML =
                  "************" + paymentMethod.DisplayCustomerAccountNo)),
            this.isNullObj(paymentMethod.MaxChargeLimit) ||
              (document.getElementById("Payment_Method_Amount_" + i).innerHTML =
                this.formatCurrency(
                  paymentMethod.MaxChargeLimit,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                )));
      }
    },
    populateAddress: function (e, t, r) {
      var s = "";
      this.isNullObj(e.AddressID) || (s = e.AddressID);
      var a = "";
      this.isNullObj(e.FirstName) || (a = e.FirstName);
      var i = "";
      this.isNullObj(e.MiddleName) || (i = e.MiddleName);
      var n = "";
      this.isNullObj(e.LastName) || (n = e.LastName);
      var o = "";
      this.isNullObj(e.AddressLine1) || (o = e.AddressLine1);
      var d = "";
      this.isNullObj(e.AddressLine2) || (d = e.AddressLine2);
      var l = "";
      this.isNullObj(e.City) || (l = e.City);
      var c = "";
      this.isNullObj(e.stateDisplayName) || (c = e.stateDisplayName);
      var u = "";
      this.isNullObj(e.countryDisplayName) || (u = e.countryDisplayName);
      var m = "";
      this.isNullObj(e.ZipCode) || (m = e.ZipCode);
      var g = "";
      this.isNullObj(e.DayPhone) || (g = e.DayPhone);
      var p = "";
      this.isNullObj(e.EMailID) || (p = e.EMailID);
      var h = "<p>" + s + "</p>";
      "ar_EG" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          l.length > 0 && (h = h + l + "<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "ja_JP" == r || "ko_KR" == r || "zh_CN" == r || "zh_TW" == r
        ? ((n.length > 0 || a.length > 0) &&
            (h = h + n + "&nbsp;" + a + "<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          (c.length > 0 || l.length > 0) &&
            (h = h + c + "&nbsp;" + l + "&nbsp;<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "de_DE" == r ||
          "es_ES" == r ||
          "fr_FR" == r ||
          "it_IT" == r ||
          "pl_PL" == r ||
          "ro_RO" == r ||
          "ru_RU" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (m.length > 0 || l.length > 0) &&
            (h = h + m + "&nbsp;" + l + "&nbsp;<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : ((a.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (l.length > 0 || c.length > 0) &&
            (h = h + l + "&nbsp;" + c + "&nbsp;<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          g.length > 0 && (h = h + g + "<br />"),
          p.length > 0 && (h = h + p + "<br />")),
        (document.getElementById(t).innerHTML = h);
    },
    isNullObj: function (e) {
      return null != e && void 0 != typeof e ? !1 : !0;
    },
    formatCurrency: function (e, t, r, s, a) {
      return Utils.formatCurrency(e, {
        minimumFractionDigits: parseInt(t),
        maximumFractionDigits: parseInt(t),
        currency: s,
        locale: a,
      });
    },
    revertAllSpecialChars: function (e) {
      return this.isNullObj(e)
        ? e
        : e
            .replace(/&#62;/g, ">")
            .replace(/&#60;/g, "<")
            .replace(/&#39;/g, "'")
            .replace(/&#34;/g, '"')
            .replace(/&#92;/g, "\\")
            .replace(/&#38;/g, "&");
    },
    populateOrderLineInfoForSingleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      if (null != orderStr && "" !== orderStr) {
        orderStr = orderStr.replace("'", "27%");
        var jsonOrder = eval("(" + orderStr + ")"),
          imgDir = document.getElementById("Image_Dir").innerHTML,
          endIndex = document.getElementById("endIndex").innerHTML,
          locale = document.getElementById("Locale_String_S").innerHTML,
          orderLineNum = 1;
        if (
          (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
            (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
          "TBODY" ==
            document.getElementById("order_details").childNodes[0].tagName)
        )
          var parentTable =
            document.getElementById("order_details").childNodes[0];
        else if (
          "TBODY" ==
          document.getElementById("order_details").childNodes[1].tagName
        )
          var parentTable =
            document.getElementById("order_details").childNodes[1];
        for (var i = beginIndex; endIndex > i; i++) {
          var orderLine = null;
          orderLine =
            1 == orderLineNum
              ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
                ? jsonOrder.Root.Order.OrderLines.OrderLine
                : jsonOrder.Root.Order.OrderLines.OrderLine[0]
              : jsonOrder.Root.Order.OrderLines.OrderLine[i];
          var nobottom = null;
          this.isNullObj(orderLine.CalculationCodes) ||
            this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
            (nobottom = "th_align_left_no_bottom"),
            this.isNullObj(nobottom) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("className") + nobottom
                ),
              this.isNullObj(
                document.getElementById(
                  "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                )
              ) ||
                (document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "class",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("class") + nobottom
                  ),
                document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "className",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("className") + nobottom
                  )),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className") + nobottom
                ));
          var catEntryName = null,
            thumbNail = null,
            objectPath = null,
            itemID = null;
          if (
            (this.isNullObj(orderLine.Item.CatalogEntry) ||
              (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
                (objectPath = orderLine.Item.CatalogEntry.objectPath),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
              ) ||
                (this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName
                ) ||
                  (catEntryName =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .catalogEntryName),
                this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
                ) ||
                  (thumbNail =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .thumbNail))),
            this.isNullObj(orderLine.Item.ItemID) ||
              (itemID = orderLine.Item.ItemID),
            this.isNullObj(thumbNail)
              ? document
                  .getElementById("Product_Thumbnail_" + i)
                  .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
              : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
                this.isNullObj(objectPath)
                  ? document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", thumbNail)
                  : ((objectPath = this.revertAllSpecialChars(objectPath)),
                    document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", objectPath + thumbNail))),
            this.isNullObj(catEntryName) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "abbr",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("abbr") + catEntryName
                ),
              document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("alt", catEntryName),
              (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
                catEntryName)),
            this.isNullObj(itemID) ||
              (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
                itemID),
            !this.isNullObj(orderLine.Item.CatalogEntry) &&
              !this.isNullObj(
                orderLine.Item.CatalogEntry.catalogEntryAttributes
              ))
          ) {
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).style.display = "inline";
            for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
              .catalogEntryAttribute)
              document.getElementById(
                "Catalog_Entry_Defining_Attributes_" + i
              ).innerHTML =
                document.getElementById(
                  "Catalog_Entry_Defining_Attributes_" + i
                ).innerHTML +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrName +
                ":" +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
                "<br/>";
          }
          if (!this.isNullObj(orderLine.componentNames)) {
            var dkLabel = document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            );
            this.isNullObj(dkLabel) ||
              (document.getElementById(
                "Dynamic_Kit_Components_Label_" + i
              ).style.display = "inline");
            var ulForDK = document.getElementById(
              "Dynamic_Kit_Components_" + i
            );
            if (!this.isNullObj(ulForDK)) {
              var compNames = orderLine.componentNames.split(",");
              for (var j in compNames) {
                var li = document.createElement("li");
                (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
              }
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
          this.isNullObj(orderLine.MaxLineStatus) ||
            (document.getElementById("Order_Item_Status_" + i).innerHTML =
              Utils.getLocalizationMessage(
                "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
              )),
            this.isNullObj(orderLine.OrderedQty) ||
              (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
                Utils.formatNumber(orderLine.OrderedQty, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }));
          var currencyCode = "USD";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
            (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
          var currencyDecimals = 2;
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
            (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
          var currencySymbol = "$";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
            this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
              (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
                this.formatCurrency(
                  orderLine.LinePriceInfo.UnitPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ));
          var isFree = !1;
          if (
            !this.isNullObj(orderLine.Awards) &&
            !this.isNullObj(orderLine.Awards.Award)
          )
            if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
              if (!this.isNullObj(orderLine.Awards.Award[0]))
                for (var award in orderLine.Awards.Award)
                  if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                    isFree = !0;
                    break;
                  }
            } else
              "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
          if (
            (1 == isFree
              ? ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "inline"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "none"))
              : ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "none"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "inline"),
                this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                  (document.getElementById(
                    "Order_Item_Total_Price_" + i
                  ).innerHTML = this.formatCurrency(
                    orderLine.ComputedPrice.ExtendedPrice,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  ))),
            !this.isNullObj(orderLine.CalculationCodes))
          ) {
            var counter = 0;
            for (var j in orderLine.CalculationCodes.CalculationCode) {
              var calCode = orderLine.CalculationCodes.CalculationCode[j],
                code = calCode.code;
              code = this.revertAllSpecialChars(code);
              var tr = document.createElement("tr");
              parentTable.insertBefore(
                tr,
                document.getElementById("Product_Line_" + (parseInt(i) + 1))
              );
              var th = document.createElement("th");
              th.setAttribute("colSpan", "4"),
                th.setAttribute(
                  "class",
                  "th_align_left_dotted_top_solid_bottom"
                ),
                th.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom"
                );
              var abbrText = document.getElementById(
                "Product_Discount_Text"
              ).innerHTML;
              th.setAttribute("abbr", abbrText + catEntryName),
                th.setAttribute(
                  "id",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                tr.appendChild(th);
              var div = document.createElement("div");
              div.setAttribute(
                "id",
                "WC_OrderItemDetailsSummaryf_div_3_" + i + "_" + counter
              ),
                div.setAttribute("class", "itemspecs"),
                div.setAttribute("className", "itemspecs"),
                th.appendChild(div);
              var a = document.createElement("a");
              a.setAttribute("class", "discount hover_underline"),
                a.setAttribute("className", "discount hover_underline"),
                a.setAttribute(
                  "id",
                  "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
                );
              var url_innerHTML =
                document.getElementById("Promotion_Url").innerHTML;
              this.isNullObj(url_innerHTML) ||
                (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
              var promotionUrl =
                url_innerHTML + "&code=" + encodeURIComponent(code);
              a.setAttribute("href", promotionUrl), div.appendChild(a);
              var img = document.createElement("img");
              if (
                (img.setAttribute("src", imgDir + "images/empty.gif"),
                img.setAttribute("alt", abbrText + catEntryName),
                a.appendChild(img),
                !this.isNullObj(calCode.calculationCodeDescription))
              ) {
                var calCodeDesc = this.revertAllSpecialChars(
                  calCode.calculationCodeDescription
                );
                a.appendChild(document.createTextNode(calCodeDesc));
              }
              var td = document.createElement("td");
              td.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td.appendChild(document.createTextNode(" ")),
                tr.appendChild(td);
              var td1 = document.createElement("td");
              td1.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td1.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td1.setAttribute(
                  "id",
                  "WC_OrderItemDetailsSummaryf_td_5_" + i + "_" + counter
                ),
                td1.setAttribute(
                  "headers",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                td1.appendChild(
                  document.createTextNode(
                    this.formatCurrency(
                      calCode.TotalAmount,
                      currencyDecimals,
                      currencySymbol,
                      currencyCode,
                      locale
                    )
                  )
                ),
                tr.appendChild(td1),
                counter++;
            }
          }
        }
      }
    },
    populateOrderLineInfoForMultipleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      var jsonOrder = eval("(" + orderStr + ")"),
        imgDir = document.getElementById("Image_Dir").innerHTML,
        locale = document.getElementById("Locale_String_M").innerHTML,
        endIndex = document.getElementById("endIndex").innerHTML,
        orderLineNum = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
        "TBODY" ==
          document.getElementById("order_details").childNodes[0].tagName)
      )
        var parentTable =
          document.getElementById("order_details").childNodes[0];
      else if (
        "TBODY" ==
        document.getElementById("order_details").childNodes[1].tagName
      )
        var parentTable =
          document.getElementById("order_details").childNodes[1];
      for (var i = beginIndex; endIndex > i; i++) {
        var orderLine = null;
        orderLine =
          1 == orderLineNum
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
              ? jsonOrder.Root.Order.OrderLines.OrderLine
              : jsonOrder.Root.Order.OrderLines.OrderLine[0]
            : jsonOrder.Root.Order.OrderLines.OrderLine[i];
        var nobottom = null;
        this.isNullObj(orderLine.CalculationCodes) ||
          this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
          (nobottom = "th_align_left_no_bottom"),
          this.isNullObj(nobottom) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("className")
              ));
        var catEntryName = null,
          thumbNail = null,
          objectPath = null,
          itemID = null;
        if (
          (this.isNullObj(orderLine.Item.CatalogEntry) ||
            (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
              (objectPath = orderLine.Item.CatalogEntry.objectPath),
            this.isNullObj(
              orderLine.Item.CatalogEntry.CatalogEntryDescription
            ) ||
              (this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
                  .catalogEntryName
              ) ||
                (catEntryName =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
              ) ||
                (thumbNail =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .thumbNail))),
          this.isNullObj(orderLine.Item.ItemID) ||
            (itemID = orderLine.Item.ItemID),
          this.isNullObj(thumbNail)
            ? document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
            : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
              this.isNullObj(objectPath)
                ? document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", thumbNail)
                : ((objectPath = this.revertAllSpecialChars(objectPath)),
                  document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", objectPath + thumbNail))),
          this.isNullObj(catEntryName) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "abbr",
                document
                  .getElementById("MultipleShipping_rowHeader_product" + i)
                  .getAttribute("abbr") + catEntryName
              ),
            document
              .getElementById("Product_Thumbnail_" + i)
              .setAttribute("alt", catEntryName),
            (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
              catEntryName)),
          this.isNullObj(itemID) ||
            (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
              itemID),
          !this.isNullObj(orderLine.Item.CatalogEntry) &&
            !this.isNullObj(orderLine.Item.CatalogEntry.catalogEntryAttributes))
        ) {
          document.getElementById(
            "Catalog_Entry_Defining_Attributes_" + i
          ).style.display = "inline";
          for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
            .catalogEntryAttribute)
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).innerHTML =
              document.getElementById("Catalog_Entry_Defining_Attributes_" + i)
                .innerHTML +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrName +
              ":" +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
              "<br/>";
        }
        if (!this.isNullObj(orderLine.componentNames)) {
          var dkLabel = document.getElementById(
            "Dynamic_Kit_Components_Label_" + i
          );
          this.isNullObj(dkLabel) ||
            (document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            ).style.display = "inline");
          var ulForDK = document.getElementById("Dynamic_Kit_Components_" + i);
          if (!this.isNullObj(ulForDK)) {
            var compNames = orderLine.componentNames.split(",");
            for (var j in compNames) {
              var li = document.createElement("li");
              (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
            }
          }
        }
        this.isNullObj(orderLine.PersonInfoShipTo)
          ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            )
          : this.populateAddress(
              orderLine.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            );
        var shippingMethod = null;
        if (!this.isNullObj(orderLine.ShipmentLines.ShipmentLine)) {
          var shipmentKey = null;
          if (
            (this.isNullObj(orderLine.ShipmentLines.ShipmentLine.ShipmentKey)
              ? this.isNullObj(
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey
                ) ||
                (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey)
              : (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine.ShipmentKey),
            !this.isNullObj(shipmentKey) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment))
          )
            if (
              this.isNullObj(
                jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey
              )
            ) {
              if (!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]))
                for (var s in jsonOrder.Root.Order.Shipments.Shipment)
                  if (
                    jsonOrder.Root.Order.Shipments.Shipment[s].ShipmentKey ==
                    shipmentKey
                  ) {
                    this.isNullObj(
                      jsonOrder.Root.Order.Shipments.Shipment[s]
                        .shipModeDescription
                    ) ||
                      (shippingMethod =
                        jsonOrder.Root.Order.Shipments.Shipment[s]
                          .shipModeDescription);
                    break;
                  }
            } else
              jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey ==
                shipmentKey &&
                (this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
                ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.Shipments.Shipment
                      .shipModeDescription));
        }
        this.isNullObj(shippingMethod) &&
          (this.isNullObj(orderLine.shipModeDescription)
            ? this.isNullObj(jsonOrder.Root.Order.shipModeDescription) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)
            : (shippingMethod = orderLine.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById(
              "Shipping_Mode_Description_" + i
            ).innerHTML = shippingMethod);
        var isFree = !1;
        if (
          !this.isNullObj(orderLine.Awards) &&
          !this.isNullObj(orderLine.Awards.Award)
        )
          if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
            if (!this.isNullObj(orderLine.Awards.Award[0]))
              for (var award in orderLine.Awards.Award)
                if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                  isFree = !0;
                  break;
                }
          } else
            "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
        if (0 == isFree) {
          if (
            !this.isNullObj(
              document.getElementById("Shipping_Instruction_" + i)
            ) &&
            !this.isNullObj(orderLine.Instructions)
          ) {
            var instructions = orderLine.Instructions;
            if (!this.isNullObj(instructions.Instruction)) {
              var instruction = instructions.Instruction;
              if (this.isNullObj(instruction.InstructionType)) {
                if (!this.isNullObj(instructions.Instruction[0]))
                  for (var k in instructions.Instruction)
                    this.isNullObj(
                      instructions.Instruction[k].InstructionType
                    ) ||
                      ("SHIP" == instructions.Instruction[k].InstructionType &&
                        (this.isNullObj(
                          instructions.Instruction[k].InstructionText
                        ) ||
                          ((document.getElementById(
                            "Shipping_Instruction_Label_" + i
                          ).style.display = "inline"),
                          (document.getElementById(
                            "Shipping_Instruction_" + i
                          ).innerHTML =
                            document.getElementById("Shipping_Instruction_" + i)
                              .innerHTML +
                            instructions.Instruction[k].InstructionText +
                            "<br/>"))));
              } else
                "SHIP" == instruction.InstructionType &&
                  (this.isNullObj(instruction.InstructionText) ||
                    ((document.getElementById(
                      "Shipping_Instruction_Label_" + i
                    ).style.display = "inline"),
                    (document.getElementById(
                      "Shipping_Instruction_" + i
                    ).innerHTML = instruction.InstructionText)));
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            document.getElementById(
              "Requested_Shipping_Date_Label_" + i
            ).style.display = "inline";
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
        }
        this.isNullObj(orderLine.MaxLineStatus) ||
          (document.getElementById("Order_Item_Status_" + i).innerHTML =
            Utils.getLocalizationMessage(
              "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
            )),
          this.isNullObj(orderLine.OrderedQty) ||
            (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
              Utils.formatNumber(orderLine.OrderedQty, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }));
        var currencyCode = "USD";
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
          (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
        var currencyDecimals = 2;
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
          (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
        var currencySymbol = "$";
        if (
          (this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
          this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
            (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
              this.formatCurrency(
                orderLine.LinePriceInfo.UnitPrice,
                currencyDecimals,
                currencySymbol,
                currencyCode,
                locale
              )),
          1 == isFree
            ? ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "inline"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "none"))
            : ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "none"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "inline"),
              this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).innerHTML = this.formatCurrency(
                  orderLine.ComputedPrice.ExtendedPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ))),
          !this.isNullObj(orderLine.CalculationCodes))
        ) {
          var counter = 0;
          for (var j in orderLine.CalculationCodes.CalculationCode) {
            var calCode = orderLine.CalculationCodes.CalculationCode[j],
              code = calCode.code;
            code = this.revertAllSpecialChars(code);
            var tr = document.createElement("tr");
            parentTable.insertBefore(
              tr,
              document.getElementById("Product_Line_" + (parseInt(i) + 1))
            );
            var th = document.createElement("th");
            th.setAttribute("colSpan", "5"),
              th.setAttribute("class", "th_align_left_dotted_top_solid_bottom"),
              th.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom"
              );
            var abbrText = document.getElementById(
              "Product_Discount_Text"
            ).innerHTML;
            th.setAttribute("abbr", abbrText + catEntryName),
              th.setAttribute(
                "id",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              tr.appendChild(th);
            var div = document.createElement("div");
            div.setAttribute(
              "id",
              "WC_MSOrderItemDetailsSummaryf_div_5_" + i + "_" + counter
            ),
              div.setAttribute("class", "itemspecs"),
              div.setAttribute("className", "itemspecs"),
              th.appendChild(div);
            var a = document.createElement("a");
            a.setAttribute("class", "discount"),
              a.setAttribute("className", "discount"),
              a.setAttribute(
                "id",
                "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
              );
            var url_innerHTML =
              document.getElementById("Promotion_Url").innerHTML;
            this.isNullObj(url_innerHTML) ||
              (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
            var promotionUrl =
              url_innerHTML + "&code=" + encodeURIComponent(code);
            a.setAttribute("href", promotionUrl), div.appendChild(a);
            var img = document.createElement("img");
            if (
              (img.setAttribute("src", imgDir + "images/empty.gif"),
              img.setAttribute("alt", abbrText + catEntryName),
              a.appendChild(img),
              !this.isNullObj(calCode.calculationCodeDescription))
            ) {
              var calCodeDesc = this.revertAllSpecialChars(
                calCode.calculationCodeDescription
              );
              a.appendChild(document.createTextNode(calCodeDesc));
            }
            var td = document.createElement("td");
            td.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td.appendChild(document.createTextNode(" ")),
              tr.appendChild(td);
            var td1 = document.createElement("td");
            td1.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td1.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td1.setAttribute(
                "id",
                "WC_MSOrderItemDetailsSummaryf_td_7_" + i + "_" + counter
              ),
              td1.setAttribute(
                "headers",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              td1.appendChild(
                document.createTextNode(
                  this.formatCurrency(
                    calCode.TotalAmount,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  )
                )
              ),
              tr.appendChild(td1),
              counter++;
          }
        }
      }
    },
    cancelOrder: function (e, t) {
      submitRequest() &&
        (cursor_wait(),
        (this.orderBeingCanceled = t),
        wcService.getServiceById("CancelExternalOrder").setUrl(e),
        wcService.invoke("CancelExternalOrder"));
    },
  }),
  wcService.declare({
    id: "CancelExternalOrder",
    actionId: "CancelExternalOrder",
    url: "AJAXProcessExternalOrder",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r =
          "OrderDetails_status_span_" +
          sterlingIntegrationJS.orderBeingCanceled,
        s = $("#" + r);
      s.length && s.html(MessageHelper.messages.MO_OrderStatus_X),
        (r =
          "OrderDetails_cancelButton_" +
          sterlingIntegrationJS.orderBeingCanceled);
      var s = $("#" + r);
      s.length && (s.css("display", "none"), s.css("visibility", "hidden")),
        MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var toggleCollapsible = function (e) {
    var t = e.querySelector(".content"),
      r = $(e).attr("aria-expanded"),
      s = document.getElementById("mainESpotHome");
    t.id.match(/homeESpotDetails/)
      ? "closed" == s.className
        ? (s.className = "expand")
        : (s.className = "closed")
      : 0,
      "true" == r
        ? (window.setTimeout(function () {
            $(e).attr("aria-expanded", "false"),
              $(t).css("transition", "max-height .2s");
          }, 0),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "none");
          }, 300))
        : "false" == r &&
          ($(e).attr("aria-expanded", "true"),
          $(t).css("transition", "max-height .2s"),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "block");
          }, 300));
  },
  updateGrid = function (e, t) {
    var r = t.clientWidth,
      s = $(t).attr("data-min-col-width"),
      a = $(t).attr("data-min-col-count"),
      i = Math.floor(r / s);
    a > i && (i = a);
    var n = Math.floor(100 / i) + "%";
    $(".col", t).css("width", n);
  },
  toggleExpandNav = function (e) {
    var t = byId("icon_" + e),
      r = byId("section_list_" + e);
    "arrow" == t.className
      ? ((t.className = "arrow arrow_collapsed"),
        $(r).attr("aria-expanded", "false"),
        $(r).css("display", "none"))
      : ((t.className = "arrow"),
        $(r).attr("aria-expanded", "true"),
        $(r).css("display", "block"));
  };
$(document).ready(function () {
  var e = function (e) {
    var t = e ? !e.matches : document.documentElement.clientWidth > 583;
    0 == t
      ? $(".collapsible").attr("aria-expanded", t.toString())
      : $(".collapsible:not(.collapsedOnInit)").attr(
          "aria-expanded",
          t.toString()
        );
  };
  if (window.matchMedia) {
    var t = window.matchMedia("(max-width: 600px)");
    e(t), t.addListener(e);
  } else
    e(),
      $(window).on("resize", function (t) {
        e();
      });
  Utils.onOnce(
    $(document),
    "click",
    "collapsible",
    ".collapsible .toggle",
    function (e) {
      toggleCollapsible($(e.target).parents(".collapsible")[0]),
        e.preventDefault();
    }
  ),
    Utils.onOnce(
      $(document),
      "keydown",
      "collapsible",
      ".collapsible .toggle",
      function (e) {
        (e.keyCode === KeyCodes.RETURN || e.keyCode === KeyCodes.SPACE) &&
          (toggleCollapsible($(e.target).parents(".collapsible")[0]),
          e.preventDefault());
      }
    ),
    $(".grid").each(updateGrid),
    $(window).on("resize", function (e) {
      $(".grid").each(updateGrid);
    });
}),
  ("undefined" != typeof CompareProductJS &&
    null != CompareProductJS &&
    CompareProductJS) ||
    (CompareProductJS = {
      params: [],
      compareReturnName: "",
      returnUrl: "",
      cookieKeyPrefix: "CompareItems_",
      cookieDelimiter: ";",
      maxNumberProductsAllowedToCompare: 4,
      setCommonParameters: function (e, t, r, s, a) {
        (this.params.langId = e),
          (this.params.storeId = t),
          (this.params.catalogId = r),
          (this.compareReturnName = s),
          (this.returnUrl = decodeURIComponent(a));
      },
      remove: function (e) {
        var t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        if (null != r) {
          if ("" == r.trim())
            setCookie(t, null, {
              expires: -1,
            });
          else {
            var s = r.split(this.cookieDelimiter),
              a = "";
            for (index in s)
              s[index] != e &&
                (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
            setCookie(t, a, {
              path: "/",
              domain: cookieDomain,
            });
          }
          var t = this.cookieKeyPrefix + this.params.storeId,
            r = getCookie(t),
            i = "",
            n = document.URL.split("catentryId=");
          if (2 == n.length) {
            i = n[0] + "catentryId=" + r;
            for (var o = n[1].split("&"), d = 0; d < o.length; d++)
              d > 0 && (i = i + "&" + n[d]);
          }
          var i = i.replace(/&&/, "&");
          location.href = i;
        }
      },
      compareProducts: function () {
        var e =
            "CompareProductsDisplayView?storeId=" +
            this.params.storeId +
            "&catalogId=" +
            this.params.catalogId +
            "&langId=" +
            this.params.langId +
            "&compareReturnName=" +
            this.compareReturnName,
          t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        null != r && "" != r.trim() && (e = e + "&catentryId=" + r),
          (e = e + "&returnUrl=" + encodeURIComponent(this.returnUrl)),
          (location.href = getAbsoluteURL() + e);
      },
      add2ShopCart: function (e, t, r) {
        var s = {
          storeId: WCParamJS.storeId,
          catalogId: WCParamJS.catalogId,
          langId: WCParamJS.langId,
          orderId: ".",
        };
        (s.calculateOrder = "0"),
          updateParamObject(s, "catEntryId", e, !1, -1),
          updateParamObject(s, "quantity", t, !1, -1);
        var a = "AddOrderItem",
          i = this.getSkuAttributes(e);
        null == i && (i = this.getSkuAttributes(r)),
          submitRequest() &&
            (cursor_wait(),
            shoppingActionsJS.saveAddedProductInfo(t, r, e, i),
            wcService.invoke(a, s));
      },
      getSkuAttributes: function (catEntryId) {
        var jsonDiv = null,
          node = $("#SKUAttributesJSON_" + catEntryId);
        return (
          node &&
            null != node &&
            "undefined" != node &&
            (jsonDiv = eval("(" + node.innerHTML + ")")),
          null != jsonDiv && "undefined" != jsonDiv ? jsonDiv : null
        );
      },
    });
var updateDepartmentsMenu,
  activate,
  ajaxRefresh = "",
  setAjaxRefresh = function (e) {
    ajaxRefresh = e;
  };
$(document).ready(function () {
  var e = !1,
    t = null,
    r = null,
    s = {},
    a = "departmentMenu_",
    i = function () {
      e || ($(document.documentElement).on("mousedown.wc.header", o), (e = !0));
    },
    n = function () {
      e && ($(document.documentElement).off("mousedown.wc.header"), (e = !1));
    },
    o = function (e) {
      var s = e.target;
      if (null !== t && s != document.documentElement) {
        for (
          var a = !0, i = t.getAttribute("data-parent");
          s && s != document.documentElement;

        ) {
          if (
            s == t ||
            s == r ||
            $(s).hasClass("dijitPopup") ||
            i == s.getAttribute("data-parent")
          ) {
            a = !1;
            break;
          }
          s = s.parentNode;
        }
        if (null === s)
          for (var n = $("div", t), o = 0; o < n.length; o++) {
            var l = Utils.position(n[o]);
            if (
              e.clientX >= l.x &&
              e.clientX < l.x + l.w &&
              e.clientY >= l.y &&
              e.clientY < l.y + l.h
            ) {
              a = !1;
              break;
            }
          }
        a && d(t);
      }
    },
    d = function (e) {
      s[e.id] && d(s[e.id]),
        $(e).removeClass("active"),
        $("a[data-activate='" + e.id + "']").removeClass("selected"),
        $("a[data-toggle='" + e.id + "']").removeClass("selected");
      var a = e.getAttribute("data-parent");
      delete s[a], e == t && ((t = null), (r = null), n());
    },
    l = function (e) {
      $(e).hasClass("active") ? d(e) : activate(e);
    },
    c = function () {
      $(document).on("click", "a[data-activate]", function (e) {
        var t = this.getAttribute("data-activate");
        activate(document.getElementById(t)), Utils.stopEvent(e);
      }),
        $(document).on("click", "a[data-deactivate]", function (e) {
          var t = this.getAttribute("data-deactivate");
          d(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("click", "a[data-toggle]", function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("keydown", "a[data-toggle]", function (e) {
          var t;
          if (27 === e.keyCode)
            (t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e);
          else if (40 === e.keyCode) {
            t = this.getAttribute("data-toggle");
            var r = document.getElementById(t);
            activate(r),
              $('[class*="menuLink"]', r)[0].focus(),
              Utils.stopEvent(e);
          }
        });
      var e = Utils.get_IE_version();
      e &&
        10 > e &&
        $("input[placeholder]").each(function (e, t) {
          var r = t.getAttribute("placeholder");
          if (r) {
            var s = document.createElement("label");
            (s.className = "placeholder"),
              (s.innerHTML = r),
              t.parentNode.insertBefore(s, t);
            var a = function () {
              s.style.display = t.value ? "none" : "block";
            };
            window.setTimeout(a, 200),
              $(t).on("blur focus keyup", a),
              $(s).click(function (e) {
                t.focus();
              });
          }
        });
    };
  (activate = function (e) {
    var n = e.id.slice(0, a.length) == a;
    if ("true" == ajaxRefresh && n)
      return (
        setAjaxRefresh(""),
        wcRenderContext.updateRenderContext("departmentSubMenuContext", {
          targetId: e.id,
        }),
        void (
          "function" == typeof cX &&
          setTimeout(function () {
            cX("");
          }, 1e3)
        )
      );
    var o = e.getAttribute("data-parent");
    o && s[o] && d(s[o]),
      o && activate(document.getElementById(o)),
      $(e).addClass("active"),
      $("a[data-activate='" + e.id + "']").addClass("selected");
    var l = $("a[data-toggle='" + e.id + "']");
    l.addClass("selected"),
      o &&
        ((s[o] = e),
        null === t && ((t = e), (r = l.length > 0 ? l[0] : null), i()));
  }),
    c(),
    window.setTimeout(function () {
      var e = document.getElementById("quickLinksBar"),
        t = document.getElementById("quickLinksButton"),
        r = document.getElementById("quickLinksMenu"),
        s = $("> ul > li > a", r);
      document.getElementById("signInOutQuickLink");
      $("#quickLinksMenu > ul > li").each(function (t, r) {
        "facebookQuickLinkItem" != r.id &&
          "globalLoginWidget" != r.id &&
          ((r = r.cloneNode(!0)),
          $("[id]", r).each(function (e, t) {
            t.id += "_alt";
          }),
          e.insertBefore(r, e.firstChild));
      }),
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(t).keydown(function (e) {
          var t;
          40 === e.keyCode
            ? ((t = this.getAttribute("data-toggle")),
              activate(document.getElementById(t)),
              s[0].focus(),
              Utils.stopEvent(e))
            : 9 === e.keyCode || (9 === e.keyCode && e.shiftKey)
            ? d(r)
            : 27 === e.keyCode &&
              ((t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e));
        }),
        $(r).keydown(function (e) {
          if (
            27 === e.keyCode ||
            9 === e.keyCode ||
            (9 === e.keyCode && e.shiftKey)
          )
            d(r);
          else if (27 === e.keyCode) {
            var t = this.getAttribute("data-toggle");
            d(document.getElementById(t)), Utils.stopEvent(e);
          }
        }),
        s.each(function (e, t) {
          t.setAttribute("role", "menuitem"),
            t.setAttribute("tabindex", "-1"),
            $(t).keydown(function (t) {
              switch (t.keyCode) {
                case 38:
                  s[0 === e ? s.length - 1 : e - 1].focus(), Utils.stopEvent(t);
                  break;
                case 40:
                  s[(e + 1) % s.length].focus(), Utils.stopEvent(t);
              }
            });
        });
      var a = document.getElementById("searchFilterButton");
      a &&
        $(a).keydown(function (e) {
          (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
            d(document.getElementById(a.getAttribute("data-toggle")));
        });
      var i = document.getElementById("SimpleSearchForm_SearchTerm");
      i &&
        $(i).click(function (e) {
          $(
            '.selected:not(a[data-toggle="searchBar"])',
            document.getElementById("header")
          ).each(function (e, t) {
            d(document.getElementById(t.getAttribute("data-toggle")));
          });
        });
      var n = document.getElementById("searchFilterMenu");
      n &&
        $('[class*="menuLink"]', n).each(function (e, t) {
          $(t).keydown(function (r) {
            27 === r.keyCode
              ? (d(n), Utils.stopEvent(r))
              : 9 === r.keyCode || (9 === r.keyCode && r.shiftKey)
              ? d(n)
              : 38 === r.keyCode
              ? (t[0 === e ? t.length - 1 : e - 1].focus(), Utils.stopEvent(r))
              : 40 === r.keyCode &&
                (t[(e + 1) % t.length].focus(), Utils.stopEvent(r));
          });
        });
    }, 100);
  if ($(document.getElementById("header")).length > 0) {
    var u = document.getElementById("header"),
      m = Utils.getTextDirection(u),
      g = function () {
        var e = document.getElementById("logo"),
          t = document.getElementById("quickLinksBar"),
          r =
            "rtl" === m
              ? e.offsetLeft - t.offsetLeft
              : t.offsetLeft + t.offsetWidth - (e.offsetLeft + e.offsetWidth),
          s = document.getElementById("facebookQuickLinkItem");
        if (s && s.parentNode != t && r > 1024) t.insertBefore(s, t.firstChild);
        else if (s && s.parentNode == t && 1024 >= r) {
          var a = $("#quickLinksMenu > ul")[0];
          a.append(s);
        }
        var i = $("#quickLinksBar > li");
        if ($(i).length > 0) {
          var n = i[i.length - 2],
            o = i[i.length - 1];
          r -= n.offsetWidth + o.offsetWidth;
          for (var d = i.length - 3; d >= 0; d--)
            (r -= i[d].offsetWidth),
              $(i[d]).toggleClass("border-right", r >= 0);
        }
      };
    window.setTimeout(g, 200), $(window).resize(g);
  }
  (updateDepartmentsMenu = function () {
    var e =
        (document.getElementById("departmentsMenu"), $(".departmentButton")),
      t = $(".departmentMenu"),
      r = $("#departmentsMenu > li");
    r[r.length - 1];
    e.each(function (e, t) {
      $(t).keydown(function (e) {
        (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
          d(document.getElementById(t.getAttribute("data-toggle")));
      });
    }),
      t.each(function (e, t) {
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          null !== t && (l(document.getElementById(t)), Utils.stopEvent(e));
        });
        var r = $('[class*="menuLink"]', t);
        r.each(function (e, s) {
          $(s).keydown(function (s) {
            27 === s.keyCode
              ? (d(document.getElementById(t.getAttribute("id"))),
                Utils.stopEvent(s))
              : 9 === s.keyCode || (9 === s.keyCode && s.shiftKey)
              ? d(document.getElementById(t.getAttribute("id")))
              : 38 === s.keyCode
              ? (r[0 === e ? r.length - 1 : e - 1].focus(), Utils.stopEvent(s))
              : 40 === s.keyCode &&
                (r[(e + 1) % r.length].focus(), Utils.stopEvent(s));
          });
        });
      });
  }),
    window.setTimeout(updateDepartmentsMenu, 200);
  var p = Utils.get_IE_version();
  (!p || p > 8) && $(window).resize(updateDepartmentsMenu),
    $("#searchFilterMenu > ul > li > a").click(function (e) {
      (document.getElementById("searchFilterButton").innerHTML =
        this.innerHTML),
        (document.getElementById("categoryId").value =
          this.getAttribute("data-value")),
        d(document.getElementById("searchFilterMenu"));
    }),
    $("#searchBox > .submitButton").click(function (e) {
      var t = document.getElementById("SimpleSearchForm_SearchTerm");
      t.value = $.trim(t.value);
      var r = $.trim(t.value.replace(/'|"/g, ""));
      t.value &&
        "" !== r &&
        processAndSubmitForm(document.getElementById("searchBox"));
    });
  var h = document.getElementById("searchBox");
  h &&
    $(h).submit(function (e) {
      updateFormWithWcCommonRequestParameters(e.target);
      var t = document.getElementById("SimpleSearchForm_SearchTerm"),
        r = t.value,
        s = $.trim(t.value.replace(/'|"/g, ""));
      return (
        (t.value = s),
        t.value ? void (t.value = $.trim(r)) : (Utils.stopEvent(e), !1)
      );
    });
});
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AddOrderItem: "AddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  dialogWidget,
  update_content = !1,
  dropdownUpdated = !1,
  dropdownInit = !1,
  productAddedList = {};
wcTopic.subscribe("ProductInfo_Added", setProductAddedList),
  ("undefined" != typeof ProductTabJS &&
    null != ProductTabJS &&
    ProductTabJS) ||
    (ProductTabJS = {
      lastTabId: null,
      selectTab: function (e) {
        $("div.tab_container").each(function (e, t) {
          $(t)
            .attr("aria-selected", "false")
            .attr("class", "tab_container inactive_tab")
            .attr("tabindex", "-1");
        }),
          $("div.tab").each(function (e, t) {
            $(t).css("display", "none");
          }),
          $("#" + e)
            .attr("aria-selected", "true")
            .attr("tabindex", "0")
            .attr("class", "tab_container active_tab"),
          $("#" + e + "Widget").css("display", "block"),
          $("#" + e + "Widget").each(function (e, t) {
            t.resize && t.resize();
          }),
          (null == this.lastTabId || this.lastTabId != e) &&
            (this.lastTabId = e);
      },
      selectTabWithKeyboard: function (e, t, r) {
        (r.keyCode == keys.DOWN_ARROW || r.keyCode == keys.RIGHT_ARROW) &&
          (e++,
          $("#tab" + e)
            ? (this.selectTab("tab" + e), this.focusTab("tab" + e))
            : (this.selectTab("tab1"), this.focusTab("tab1")),
          this.cancelEvent(r)),
          (r.keyCode == keys.UP_ARROW || r.keyCode == keys.LEFT_ARROW) &&
            ($("#tab" + (e - 1))
              ? (this.selectTab("tab" + (e - 1)),
                this.focusTab("tab" + (e - 1)))
              : (this.selectTab("tab" + t), this.focusTab("tab" + t)),
            this.cancelEvent(r));
      },
      cancelEvent: function (e) {
        Utils.stopEvent(e);
      },
      focusTab: function (e) {
        return $("#" + e).hasClass("focused_tab")
          ? void $("> div", "#" + e).css("border", "1px dotted #000000")
          : ($("#" + e).addClass("focused_tab"),
            $("> div", $("#" + e)).css("border", "1px dotted #000000"),
            $("#" + e).focus(),
            void 0);
      },
      blurTab: function (e) {
        $(e).removeClass("focused_tab"),
          $("> div", "#" + e).css("border", "1px solid transparent");
      },
    }),
  ("undefined" != typeof QuickInfoJS && null != QuickInfoJS && QuickInfoJS) ||
    (QuickInfoJS = {
      productImgDimensions: "1000x1000",
      quickInfoImgDimensions: "330x330",
      catEntryParams: {},
      selectedAttributes: new Object(),
      catEntryQuantity: 1,
      itemDetailsArr: new Object(),
      params: null,
      replaceOrderItemId: "",
      itemId: "",
      selectedSkuIndex: null,
      selectedThumbnailIndex: null,
      setReplaceOrderItemId: function (e) {
        this.replaceOrderItemId = e;
      },
      setValues: function () {
        $("#catEntryParamsForJS").length &&
          (this.catEntryParams = $.parseJSON($("#catEntryParamsForJS").val())),
          (this.catEntryParams.attributes = this.selectedAttributes);
      },
      setCatEntryQuantity: function (e) {
        this.catEntryQuantity = e;
      },
      showDetails: function (e, t, r, s, a) {
        if (
          (t ? (this.params = t) : (this.params = null),
          (this.selectedAttributes = new Object()),
          (this.selectedSkuIndex = null),
          (this.selectedThumbnailIndex = null),
          submitRequest())
        ) {
          this.close(), cursor_wait();
          var i = this.setCommonParams();
          r
            ? ((this.itemId = r), (i.updateAttributes = "true"))
            : ((this.itemId = ""), (i.updateAttributes = "false")),
            a && (i.parentPage = a),
            s && (this.catEntryQuantity = s),
            (i.productId = e),
            wcRenderContext.updateRenderContext("QuickInfoContext", i);
        }
      },
      changeAttributes: function (e, t, r, s) {
        this.setReplaceOrderItemId(e), this.showDetails(t, null, r, s);
      },
      changeImage: function (e, t) {
        (this.selectedThumbnailIndex = e - 1),
          $("#quickInfoMainImage").attr(
            "src",
            this.getQuickInfoImage(
              this.catEntryParams.skus[this.selectedSkuIndex]
                .thumbnailAttachments[this.selectedThumbnailIndex].path
            )
          ),
          $(".widget_quick_info_popup .other_views li").removeClass("selected"),
          "true" === isProduct
            ? $("#quickInfoProductThumbnail" + e).addClass("selected")
            : $("#quickInfoThumbnail" + e).addClass("selected");
      },
      setSelectedAttribute: function (e, t) {
        this.selectedAttributes[e] = t;
      },
      notifyAttributeChange: function () {
        wcTopic.publish("QuickInfo_attributesChanged", [
          JSON.stringify(this.selectedAttributes),
        ]),
          this.setValues();
        var e = this.resolveSKU();
        if (-1 != e)
          wcTopic.publish(
            "DefiningAttributes_Resolved",
            e,
            this.catEntryParams.id
          ),
            QuickInfoJS.selectItem(!0);
        else {
          wcTopic.publish("DefiningAttributes_Resolved", null, null);
          var t = !1;
          for (var r in this.selectedAttributes)
            null !== this.selectedAttributes[r] &&
              "" !== this.selectedAttributes[r] &&
              (t = !0);
          t ||
            ($("div[id^='quickinfoAngleImagesArea']").css("display", "none"),
            $("div[id^='quickinfoProductAngleImagesArea']").css(
              "display",
              "block"
            ),
            this.showDetails(this.catEntryParams.id, null, null, null, ""));
        }
      },
      selectItem: function (e, t) {
        (this.displayPriceRange = e), this.setValues();
        var r = this.resolveSKU();
        if (-1 == r && t) {
          var s = -1;
          for (idx = 0; idx < this.catEntryParams.skus.length; idx++)
            for (attribute in this.catEntryParams.skus[idx].attributes)
              if (
                this.catEntryParams.attributes &&
                this.catEntryParams.skus[idx].attributes[attribute] ==
                  this.catEntryParams.attributes[attribute]
              ) {
                s = this.catEntryParams.skus[idx].id;
                break;
              }
          -1 != s && ((r = s), (this.updateItemImageOnly = t));
        }
        if (-1 != r)
          if (
            null != this.itemDetailsArr[r] &&
            "undefined" != this.itemDetailsArr[r]
          )
            this.displayItemDetails(this.itemDetailsArr[r]);
          else {
            var a = this.setCommonParams();
            (a.catalogEntryId = r),
              wcService.declare({
                id: "getCatalogEntryDetailsQI",
                actionId: "getCatalogEntryDetailsQI",
                url:
                  getAbsoluteURL() +
                  appendWcCommonRequestParameters(
                    "GetCatalogEntryDetailsByIDView"
                  ),
                formId: "",
                successHandler: function (e, t) {
                  QuickInfoJS.setItemDetails(e, t);
                },
                failureHandler: function (e, t) {
                  console.debug(
                    "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
                  );
                },
              }),
              wcService.invoke("getCatalogEntryDetailsQI", a);
          }
      },
      selectSwatch: function (e, t, r, s) {
        if (
          $("[id='quickInfoSwatch_" + e + "_" + t + "']").hasClass(
            "color_swatch_disabled"
          )
        )
          return alert("return.."), !1;
        this.setValues();
        for (
          var a = $("#WC_QuickInfo_SwatchNames").val().split("_"),
            i = -1,
            n = 0;
          n < a.length;
          n++
        )
          if (a[n] == e) {
            i = n;
            break;
          }
        var o = "quickInfoSwatch_" + e + "_" + t,
          d = "WC_QuickInfo_Swatch_" + e + "_" + t,
          l = new Array();
        for (idx in this.catEntryParams.skus) {
          var c = !1,
            u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes)
            if (e == attribute && t == u.attributes[attribute] && u.buyable) {
              c = !0;
              break;
            }
          if (c)
            for (attribute in u.attributes) {
              for (var m = -1, n = 0; n < a.length; n++)
                if (a[n] == attribute) {
                  m = n;
                  break;
                }
              m > i && l.push(attribute + "_" + u.attributes[attribute]);
            }
        }
        var g = new Array(),
          p = new Array();
        for (idx in this.catEntryParams.skus) {
          var u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes) {
            for (var m = -1, n = 0; n < a.length; n++)
              if (a[n] == attribute) {
                m = n;
                break;
              }
            if (m > i) {
              for (
                var h = attribute + "_" + u.attributes[attribute],
                  r = "quickInfoSwatch_" + h,
                  I = "WC_QuickInfo_Swatch_" + h,
                  y = -1,
                  n = 0;
                n < l.length;
                n++
              )
                if (l[n] == h) {
                  y = n;
                  break;
                }
              for (var f = -1, n = 0; n < g.length; n++)
                if (g[n] == h) {
                  f = n;
                  break;
                }
              y > -1
                ? $("[id='" + r + "']").hasClass("color_swatch_selected") ||
                  ($("[id='" + r + "']").attr("class", "color_swatch"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_disabled.png", "_enabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "false"))
                : -1 == f &&
                  (g.push(h),
                  $("[id='" + r + "']").hasClass("color_swatch_selected") &&
                    p.push(r),
                  $("[id='" + r + "']").attr("class", "color_swatch_disabled"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_enabled.png", "_disabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "true"));
            }
            $(
              "[id='WC_QuickInfo_Swatch_" +
                attribute +
                "_" +
                u.attributes[attribute] +
                "']"
            ).attr("aria-checked", "false");
          }
        }
        for (idx in p) {
          var S = p[idx],
            v = "img[id^='" + S.substring(0, S.lastIndexOf("_")) + "']",
            _ = !1;
          $(v).each(function (e, t, r) {
            if (!_ && $(t).hasClass("color_swatch")) {
              var s = t.id.split("_");
              QuickInfoJS.selectSwatch(
                s[1],
                s[2],
                "quickInfoSwatch_" + s[1] + "_" + s[2],
                "quickInfoSwatch_" + s[1] + "_"
              ),
                QuickInfoJS.selectItem(!0),
                (_ = !0);
            }
          });
        }
        (selector = "img[id^='" + s + "']"),
          $(selector).each(function (e, t, r) {
            $(t).hasClass("color_swatch_disabled") ||
              ($(t).addClass("color_swatch"),
              $(t).hasClass("color_swatch_selected") &&
                $(t).removeClass("color_swatch_selected"));
          }),
          $("[id='" + o + "']").attr("class", "color_swatch_selected"),
          $("[id='quickinfo_swatch_selection_" + e + "']").html(t),
          $("[id='" + d + "']").attr("aria-checked", "true"),
          this.setSelectedAttribute(e, t);
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = WCParamJS.storeId),
          (e.catalogId = WCParamJS.catalogId),
          (e.langId = WCParamJS.langId),
          e
        );
      },
      setItemDetails: function (e, t) {
        (QuickInfoJS.itemDetailsArr[
          e.catalogEntry.catalogEntryIdentifier.uniqueID
        ] = e.catalogEntry),
          QuickInfoJS.displayItemDetails(e.catalogEntry);
      },
      displayItemDetails: function (e) {
        if (null != this.catEntryParams)
          for (idx in this.catEntryParams.skus)
            if (
              null != this.catEntryParams.skus[idx] &&
              this.catEntryParams.skus[idx].id ==
                e.catalogEntryIdentifier.uniqueID
            ) {
              var t = $("div[id^='quickinfoAngleImagesArea']"),
                r = $("div[id^='quickinfoProductAngleImagesArea']");
              if (t.length) var s = t[0];
              if (
                null != this.catEntryParams.skus[idx].thumbnailAttachments &&
                this.catEntryParams.skus[idx].thumbnailAttachments.length > 0
              ) {
                r.css("display", "none");
                var a = $("ul[id^='quickInfoAngleImagesAreaList']");
                if (a.length) {
                  var i = a[0];
                  for (
                    null != s && $(s).css("display", "block"), idx2 = 1;
                    idx2 <=
                    this.catEntryParams.skus[idx].thumbnailAttachments.length;
                    idx2++
                  ) {
                    var n = document.createElement("li"),
                      o = document.createElement("a"),
                      d = document.createElement("img");
                    (n.id = "quickInfoThumbnail" + idx2),
                      (o.href =
                        "javaScript:QuickInfoJS.changeImage(" +
                        idx2 +
                        ",'" +
                        this.catEntryParams.skus[idx].fullImageAttachments[
                          idx2 - 1
                        ].path +
                        "');"),
                      (o.id = "WC_QuickInfo_Link_thumbnail_" + idx2),
                      (o.className = "tlignore"),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (o.title =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      (d.src =
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].path),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (d.alt =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      1 == idx2 && $(i).empty(),
                      o.appendChild(d),
                      n.appendChild(o),
                      i.appendChild(n);
                  }
                }
              } else {
                var l = "block";
                for (attribute in this.selectedAttributes)
                  null != this.selectedAttributes[attribute] &&
                    "" != this.selectedAttributes[attribute] &&
                    (l = "none");
                if (null != r)
                  for (var c = 0; c < r.length; c++)
                    null != r[c] && $(r[c]).css("display", l);
                null != s && $(s).css("display", "none");
              }
              null == this.selectedThumbnailIndex &&
                (this.selectedThumbnailIndex = 0),
                (this.selectedSkuIndex = idx);
              var u = e.description[0].thumbnail;
              null != u &&
                0 != u.length &&
                $("#quickInfoMainImage").attr("src", u),
                $("#ProductInfoImage_" + this.catEntryParams.id).length &&
                  (document.getElementById(
                    "ProductInfoImage_" + this.catEntryParams.id
                  ).value = u);
            }
        if (this.updateItemImageOnly)
          return void (this.updateItemImageOnly = !1);
        if (
          ($(".widget_quick_info_popup .main_header")
            .first()
            .html(e.description[0].name),
          $("#ProductInfoName_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoName_" + this.catEntryParams.id
            ).value = e.description[0].name),
          e.listPriced && e.listPrice > e.offerPrice)
        )
          if (null != $(".widget_quick_info_popup .old_price")[0])
            $(".widget_quick_info_popup .old_price").first().html(e.listPrice);
          else {
            var m = "<span class='old_price'>" + e.listPrice + "</span>",
              g = $(".widget_quick_info_popup .price")[0];
            $(m).before(g);
          }
        else
          null != $(".widget_quick_info_popup .old_price")[0] &&
            $(".widget_quick_info_popup .old_price").remove();
        $(".widget_quick_info_popup .price").first().html(e.offerPrice),
          $(".widget_quick_info_popup .sku")
            .first()
            .html(
              Utils.getLocalizationMessage("SKU") +
                " " +
                e.catalogEntryIdentifier.externalIdentifier.partNumber
            ),
          $("#ProductInfoPrice_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoPrice_" + this.catEntryParams.id
            ).value = e.offerPrice);
      },
      validate: function () {
        return "ProductBean" != this.catEntryParams.type ||
          (null != this.catEntryParams.attributes &&
            "undefined" != this.catEntryParams.attributes)
          ? isPositiveInteger(this.catEntryQuantity)
            ? !0
            : (MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.QUANTITY_INPUT_ERROR
              ),
              !1)
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            ),
            !1);
      },
      add2ShopCart: function (e) {
        if (browseOnly)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage.ERROR_ADD2CART_BROWSE_ONLY
          );
        if ((this.setValues(), this.validate())) {
          null == this.params &&
            ((this.params = this.setCommonParams()),
            (this.params.orderId = "."),
            (this.params.inventoryValidation = "true"),
            (this.params.calculateOrder = "0"));
          var t = "";
          if (
            "itembean" == this.catEntryParams.type.toLowerCase() ||
            "packagebean" == this.catEntryParams.type.toLowerCase() ||
            "dynamickitbean" == this.catEntryParams.type.toLowerCase()
          )
            updateParamObject(
              this.params,
              "catEntryId",
              this.catEntryParams.id,
              !1,
              -1
            ),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = this.catEntryParams.id);
          else {
            var r = this.resolveSKU();
            if (-1 == r)
              return void MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.ERR_RESOLVING_SKU
              );
            updateParamObject(this.params, "catEntryId", r, !1, -1),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = r);
          }
          var s = "AddOrderItem";
          if (null != e && "undefined" != e) {
            for (i in e) this.params[i] = e[i];
            "dynamicKit" == e.catalogEntryType &&
              (s = "AddPreConfigurationToCart");
          }
          "dynamicKit" == this.params.catalogEntryType &&
            (s = "AddPreConfigurationToCart"),
            shoppingActionsJS.saveAddedProductInfo(
              this.catEntryQuantity,
              this.catEntryParams.id,
              t,
              this.selectedAttributes
            ),
            this.close(),
            submitRequest() &&
              (cursor_wait(), wcService.invoke(s, this.params));
        }
      },
      resolveSKU: function () {
        if (1 == this.catEntryParams.skus.length)
          return this.catEntryParams.skus[0].id;
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = 0,
            t = 0;
          for (attribute in this.catEntryParams.skus[idx].attributes) {
            if (
              (t++,
              !this.catEntryParams.attributes ||
                this.catEntryParams.skus[idx].attributes[attribute] !=
                  this.catEntryParams.attributes[attribute])
            )
              break;
            e++;
          }
          if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
        }
        return -1;
      },
      showQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "visible");
      },
      hideQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "");
      },
      shiftTabHideQuickInfoButton: function (e, t) {
        t.shiftKey && t.keyCode === KeyCodes.TAB && this.hideQuickInfoButton(e);
      },
      close: function (e) {
        $("#quickInfoPopup").WCDialog("close"),
          null != e &&
            "undefined" != e &&
            document.getElementById(e) &&
            document.getElementById(e).focus();
      },
      setFocus: function (e) {
        if (e.keyCode === KeyCodes.ESCAPE && $("#catEntryParamsForJS").length) {
          var t = $("#catEntryParamsForJS").val(),
            r = $.parseJSON(t).id;
          document.getElementById("catalogEntry_img" + r) &&
            document.getElementById("catalogEntry_img" + r).focus();
        }
      },
      selectDefaultSwatch: function () {
        var swatchElement = $("a[id^='WC_QuickInfo_Swatch_']")[0];
        swatchElement && eval($(swatchElement).attr("href"));
      },
      replaceCartItem: function () {
        if ((this.setValues(), this.validate())) {
          var e = this.resolveSKU();
          if (-1 == e)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            );
          this.close();
          var t = "",
            r = "",
            s = "",
            a = $("#shipmentTypeId");
          $("#addressId_all").length && $("#shipModeId_all").length
            ? (0 === a.length || "1" != a.val()
                ? (t = $("#addressId_all").val())
                : $("#physicalStoreId").length &&
                  (s = $("#physicalStoreId").val()),
              (r = $("#shipModeId_all").val()))
            : $("#MS_ShipmentAddress_" + this.replaceOrderItemId).length &&
              $("#MS_ShippingMode_" + this.replaceOrderItemId).length &&
              ((t = $("#MS_ShipmentAddress_" + this.replaceOrderItemId).val()),
              (r = $("#MS_ShippingMode_" + this.replaceOrderItemId).val())),
            "" != this.replaceOrderItemId && categoryDisplayJS
              ? shoppingActionsJS.replaceItemAjaxHelper(
                  e,
                  this.catEntryQuantity,
                  this.replaceOrderItemId,
                  t,
                  r,
                  s
                )
              : console.error("categoryDisplayJS not defined");
        }
      },
      selectCurrentAttributes: function () {
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = this.catEntryParams.skus[idx];
          if (e.id == this.itemId) {
            for (attribute in e.attributes) {
              var t = $("select[alt='" + attribute + "']")[0];
              if (t)
                (t.value = e.attributes[attribute]),
                  this.setSelectedAttribute(attribute, t.value);
              else {
                var r = e.attributes[attribute];
                $("[id='quickInfoSwatch_" + attribute + "_" + r + "']")
                  .length &&
                  this.selectSwatch(
                    attribute,
                    r,
                    "quickInfoSwatch_" + attribute + "_" + r,
                    "quickInfoSwatch_" + attribute + "_"
                  );
              }
            }
            return this.notifyAttributeChange(), void this.selectItem(!0);
          }
        }
      },
    }),
  ("undefined" != typeof SearchJS && null != SearchJS && SearchJS) ||
    (SearchJS = {
      autoSuggestTimer: -1,
      autoSuggestKeystrokeDelay: 400,
      autoSuggestHover: !1,
      autoSuggestPreviousTerm: "",
      autoSuggestURL: "",
      autoSelectOption: -1,
      historyIndex: -1,
      retrievedCachedSuggestions: !1,
      TOTAL_SUGGESTED: 4,
      TOTAL_HISTORY: 2,
      AUTOSUGGEST_THRESHOLD: 1,
      DYNAMIC_AUTOSUGGEST_THRESHOLD: 1,
      CACHED_AUTOSUGGEST_OFFSET: 1e3,
      END_OF_LIST: !1,
      STATIC_CONTENT_SECTION_DIV: [
        "autoSuggestStatic_1",
        "autoSuggestStatic_2",
        "autoSuggestStatic_3",
      ],
      staticContentHeaderHistory: "",
      SearchAutoSuggestServletURL: "",
      searchDepartmentHoverTimeout: "",
      searchSuggestionHoverTimeout: "",
      mouseDownConnectHandle: null,
      searchDepartmentSelect: function (e, t) {
        return (
          $("#searchDepartmentLabel").html(t.innerHTML),
          ($("#search_categoryId").value = e),
          this.hideSearchDepartmentList(),
          !1
        );
      },
      cancelEvent: function (e) {
        e.stopPropagation && e.stopPropagation(),
          e.preventDefault && e.preventDefault(),
          (e.cancelBubble = !0),
          (e.cancel = !0),
          (e.returnValue = !1);
      },
      searchDepartmentKeyPressed: function (e, t, r, s, a) {
        if (e.keyCode === KeyCodes.RETURN) {
          this.searchDepartmentSelect(s, a);
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus();
        } else if (e.keyCode === KeyCodes.UP_ARROW)
          0 != t &&
            ($("#searchDepartmentList_" + (t - 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.DOWN_ARROW)
          t != r &&
            ($("#searchDepartmentList_" + (t + 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.ESCAPE) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.hideSearchDepartmentList();
        } else if (e.shiftKey && e.keyCode === KeyCodes.TAB) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList();
        } else
          e.keyCode === KeyCodes.TAB &&
            ($("#search_submit").focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList());
        return !1;
      },
      hideSearchDepartmentList: function () {
        $("#searchDepartmentList").css("display", "none");
      },
      init: function () {
        $(document.CatalogSearchForm.searchTerm).on(
          "focus",
          $.proxy(SearchJS._onFocus, SearchJS)
        ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keydown",
            $.proxy(SearchJS._onKeyDown, SearchJS)
          ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keyup",
            $.proxy(SearchJS._onKeyUp, SearchJS)
          ),
          $("#searchDropdown").on(
            "keyup",
            $.proxy(SearchJS._onKeyTab, SearchJS)
          );
      },
      showSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "block");
      },
      hideSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "none");
      },
      _showMobileSearchComponent: function () {
        var e = document.getElementById("mobileSearchDropdown");
        null != e &&
          ("block" == e.style.display
            ? (DepartmentJS.close("mobileSearchDropdown"),
              (e.style.display = "none"))
            : ($(".subDeptDropdown ").each(function (e, t) {
                DepartmentJS.close(t.id);
              }),
              DepartmentJS.close("departmentsDropdown"),
              (e.style.display = "block")));
      },
      setAutoSuggestURL: function (e) {
        this.SearchAutoSuggestServletURL = getAbsoluteURL() + e;
      },
      _onFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonBlur: function (e) {
        clearTimeout(this.searchSuggestionHoverTimeout),
          (this.searchSuggestionHoverTimeout = setTimeout(
            "SearchJS.showAutoSuggest(false)",
            100
          ));
      },
      _onKeyPress: function (e) {
        return e.keyCode !== KeyCodes.RETURN;
      },
      _onKeyDown: function (e) {
        e.keyCode === KeyCodes.RETURN
          ? (this._handleEnterKey(), this.cancelEvent(e))
          : e.keyCode === KeyCodes.TAB &&
            (clearTimeout(this.searchSuggestionHoverTimeout),
            (this.searchSuggestionHoverTimeout = setTimeout(
              "SearchJS.showAutoSuggest(false)",
              200
            )));
      },
      _onKeyUp: function (e) {
        var t = document.getElementById("searchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            document.CatalogSearchForm.searchTerm.value
          );
      },
      _onKeyTab: function (e) {
        e.keyCode === KeyCodes.TAB && $("#searchFilterButton").focus();
      },
      _MobileonKeyUp: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            $("#MobileSimpleSearchForm_SearchTerm").val()
          );
      },
      _handleEnterKey: function () {
        (document.CatalogSearchForm.searchTerm.value = trim(
          document.CatalogSearchForm.searchTerm.value
        )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            (this.END_OF_LIST
              ? this.gotoAdvancedSearch(byId("advancedSearch").href)
              : "" !== this.autoSuggestURL &&
                this.autoSuggestURL != document.location.href + "#"
              ? (document.location.href = appendWcCommonRequestParameters(
                  this.autoSuggestURL
                ))
              : ((document.CatalogSearchForm.searchTerm.value = trim(
                  document.CatalogSearchForm.searchTerm.value
                )),
                submitSpecifiedForm(document.CatalogSearchForm)));
      },
      _onClick: function (e) {
        return (
          (document.CatalogSearchForm.searchTerm.value = trim(
            document.CatalogSearchForm.searchTerm.value
          )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.CatalogSearchForm)),
          !1
        );
      },
      _MobileonClick: function (e) {
        return (
          (document.MobileCatalogSearchForm.searchTerm.value = trim(
            document.MobileCatalogSearchForm.searchTerm.value
          )),
          document.MobileCatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.MobileCatalogSearchForm)),
          !1
        );
      },
      doDynamicAutoSuggest: function (e, t, r) {
        -1 != this.autoSuggestTimer &&
          (clearTimeout(this.autoSuggestTimer), (this.autoSuggestTimer = -1)),
          (this.autoSuggestTimer = setTimeout(function () {
            var s = e + "&term=" + encodeURIComponent(t) + "&showHeader=" + r;
            $("#autoSuggestDynamic_Result_div").refreshWidget("updateUrl", s),
              console.debug("update autosuggest " + e),
              wcRenderContext.updateRenderContext("AutoSuggest_Context", {}),
              (this.autoSuggestTimer = -1);
          }, this.autoSuggestKeystrokeDelay));
      },
      gotoAdvancedSearch: function (e) {
        var t = $("#SimpleSearchForm_SearchTerm").val();
        document.location.href =
          appendWcCommonRequestParameters(e) + "&searchTerm=" + t;
      },
      showAutoSuggest: function (e) {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        var t = document.getElementById("autoSuggest_Result_div"),
          r = Utils.get_IE_version();
        if (r && 7 > r)
          var s = document.getElementById("autoSuggest_content_div"),
            a = document.getElementById("autoSuggestDropDownIFrame");
        if (isMobile) {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $(".header__first-login").hide(),
                $(".header__search").css({ "max-height": "500px" }),
                $("#firstLogin").css({ "z-index": "19" }),
                $("#searchBox").css({ height: "500px" }),
                $("#searchDropdown").css({
                  left: "0px",
                  right: "0px",
                  width: "100%",
                }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $(".header__first-login").show(),
                $(".header__search").css({ "max-height": "64px" }),
                $("#firstLogin").css({ "z-index": "20" }),
                $("#searchBox").css({ height: "32px" }))
            : this.unregisterMouseDown();
        } else {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $("#searchBox").css({ height: "225px" }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $("#searchBox").css({ height: "68px" }))
            : this.unregisterMouseDown();
        }
      },
      showAutoSuggestIfResults: function () {
        var e = document.getElementById("mobileSearchDropdown");
        "undefined" != typeof staticContent &&
        "" === $("#" + this.STATIC_CONTENT_SECTION_DIV[0]).html() &&
        "" === $("#autoSuggestHistory").html() &&
        null == document.getElementById("dynamicAutoSuggestTotalResults")
          ? this.showAutoSuggest(!1)
          : null != e && "block" == e.style.display
          ? $("#MobileSimpleSearchForm_SearchTerm").val().length <=
            this.AUTOSUGGEST_THRESHOLD
            ? this.showAutoSuggest(!1)
            : this.showAutoSuggest(!0)
          : document.CatalogSearchForm.searchTerm.value.length <=
            this.AUTOSUGGEST_THRESHOLD
          ? this.showAutoSuggest(!1)
          : this.showAutoSuggest(!0);
      },
      selectAutoSuggest: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        if (null != t && "block" == t.style.display)
          var r = document.getElementById("MobileSimpleSearchForm_SearchTerm");
        else var r = document.CatalogSearchForm.searchTerm;
        (r.value = e),
          r.focus(),
          (this.autoSuggestPreviousTerm = e),
          "undefined" != typeof TealeafWCJS &&
            TealeafWCJS.createExplicitChangeEvent(r),
          submitSpecifiedForm(document.CatalogSearchForm);
      },
      highLightSelection: function (e, t) {
        var r = document.getElementById("autoSelectOption_" + t);
        if (null != r && "undefined" != typeof r) {
          if (e) {
            r.className = "autoSuggestSelected";
            var s = document.getElementById("mobileSearchDropdown");
            if (null != s && "block" == s.style.display)
              var a = document.getElementById(
                "MobileSimpleSearchForm_SearchTerm"
              );
            else var a = document.CatalogSearchForm.searchTerm;
            $(a).attr("aria-activedescendant", "suggestionItem_" + t);
            var i = document.getElementById("dynamicAutoSuggestTotalResults");
            ((null != i && "undefined" != typeof i && t < i.value) ||
              t >= this.historyIndex) &&
              ((a.value = r.title), (this.autoSuggestPreviousTerm = r.title)),
              (this.autoSuggestURL = r.href);
          } else r.className = "";
          return !0;
        }
        return !1;
      },
      enableAutoSelect: function (e) {
        this.highLightSelection(!1, this.autoSelectOption);
        var t = document.getElementById("autoSelectOption_" + e);
        (t.className = "autoSuggestSelected"), (this.autoSelectOption = e);
      },
      resetAutoSuggestKeyword: function () {
        var e = document.getElementById("autoSuggestOriginalTerm");
        if (null != e && "undefined" != typeof e) {
          var t = document.getElementById("mobileSearchDropdown");
          if (null != t && "block" == t.style.display)
            var r = document.getElementById(
              "MobileSimpleSearchForm_SearchTerm"
            );
          else var r = document.CatalogSearchForm.searchTerm;
          (r.value = e.value), (this.autoSuggestPreviousTerm = e.value);
        }
      },
      clearAutoSuggestResults: function () {
        for (var e = 0; e < staticContent.length; e++)
          $("#" + this.STATIC_CONTENT_SECTION_DIV[e]).html("");
        (this.autoSuggestPreviousTerm = ""),
          (this.autoSuggestURL = ""),
          $("#autoSuggestDynamic_Result_div").html(""),
          this.showAutoSuggest(!1);
      },
      doAutoSuggest: function (e, t, r) {
        if (
          ((r = r.trim()),
          r.length <= this.AUTOSUGGEST_THRESHOLD && this.showAutoSuggest(!1),
          e.keyCode !== KeyCodes.RETURN)
        ) {
          if (e.keyCode === KeyCodes.TAB)
            return void (this.autoSuggestHover = !0);
          if (e.keyCode === KeyCodes.ESCAPE)
            return void this.showAutoSuggest(!1);
          if (e.keyCode !== KeyCodes.UP_ARROW) {
            if (e.keyCode !== KeyCodes.DOWN_ARROW) {
              if (
                !(
                  (r.length > this.AUTOSUGGEST_THRESHOLD &&
                    r == this.autoSuggestPreviousTerm) ||
                  ((this.autoSuggestPreviousTerm = r),
                  r.length <= this.AUTOSUGGEST_THRESHOLD)
                )
              )
                if (
                  (-1 != this.autoSuggestTimer &&
                    (clearTimeout(this.autoSuggestTimer),
                    (this.autoSuggestTimer = -1)),
                  "" !== r)
                ) {
                  this.autoSelectOption = -1;
                  this.doStaticAutoSuggest(r);
                  if (r.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
                    var s = !0;
                    this.doDynamicAutoSuggest(t, r, s);
                  } else $("#autoSuggestDynamic_Result_div").html("");
                } else this.clearAutoSuggestResults();
            } else if (this.highLightSelection(!0, this.autoSelectOption + 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++;
            else if (
              this.autoSelectOption < this.CACHED_AUTOSUGGEST_OFFSET &&
              this.highLightSelection(!0, this.CACHED_AUTOSUGGEST_OFFSET)
            )
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = this.CACHED_AUTOSUGGEST_OFFSET),
                this.resetAutoSuggestKeyword();
            else if (!this.END_OF_LIST) {
              $("#autoSuggestAdvancedSearch").addClass("autoSuggestSelected"),
                this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++,
                (this.END_OF_LIST = !0);
              var a = document.getElementById("mobileSearchDropdown");
              if (null != a && "block" == a.style.display)
                var i = document.getElementById(
                  "MobileSimpleSearchForm_SearchTerm"
                );
              else var i = document.CatalogSearchForm.searchTerm;
              $(i).attr("aria-activedescendant", "advancedSearch");
            }
          } else {
            var n = document.getElementById("dynamicAutoSuggestTotalResults");
            if (this.END_OF_LIST)
              $("#autoSuggestAdvancedSearch").removeClass(
                "autoSuggestSelected"
              ),
                (this.END_OF_LIST = !1),
                this.autoSelectOption--,
                this.highLightSelection(!0, this.autoSelectOption) ||
                  (this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
                    null != n &&
                    "undefined" != typeof n &&
                    ((this.autoSelectOption = n.value - 1),
                    this.highLightSelection(!0, this.autoSelectOption)));
            else if (this.highLightSelection(!0, this.autoSelectOption - 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption == this.historyIndex &&
                  this.resetAutoSuggestKeyword(),
                this.autoSelectOption--;
            else if (
              this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
              null != n &&
              "undefined" != typeof n
            )
              this.highLightSelection(!1, this.CACHED_AUTOSUGGEST_OFFSET),
                (this.autoSelectOption = n.value - 1),
                this.highLightSelection(!0, this.autoSelectOption);
            else {
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = -1);
              document.getElementById("autoSuggestOriginalTerm");
              this.resetAutoSuggestKeyword();
            }
          }
        }
      },
      tokenizeForBidi: function (e, t, r, s) {
        var a = e.split(" > "),
          n = "",
          o = "";
        if (a.length > 0) {
          for (n += "<div class='category_list'>", i = 0; i < a.length; i++) {
            if (
              (0 != i && (n += "<span class='gt'>&nbsp; > &nbsp;</span>"),
              i == a.length - 1)
            ) {
              var d = t.toLowerCase().indexOf(s),
                l = t.substr(0, d),
                c = t.substr(d + r.length),
                u = "<span class='highlight'>" + r + "</span>";
              o = l + u + c;
            } else o = a[i];
            n += o;
          }
          n += "</div>";
        }
        return n;
      },
      // doStaticAutoSuggest: function (e) {
      //   for (
      //     var t = ["", "", "", "", "", ""],
      //       r = 0,
      //       s = e.toLowerCase(),
      //       a = this.CACHED_AUTOSUGGEST_OFFSET,
      //       i = "<div class='list_section'><div",
      //       n = "</div></div>",
      //       o = 0;
      //     o < staticContent.length;
      //     o++
      //   )
      //     for (var d = 0, l = 0; l < staticContent[o].length; l++) {
      //       var c = staticContent[o][l][0],
      //         u = staticContent[o][l][1],
      //         m = staticContent[o][l][2],
      //         g = c.toLowerCase().indexOf(s);
      //       if (-1 != g) {
      //         var p = this.tokenizeForBidi(m, c, e, s);
      //         if (
      //           ((t[o] =
      //             t[o] +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a id='autoSelectOption_" +
      //             a +
      //             "' title='" +
      //             escapeXml(c, !0) +
      //             "' onmouseout='this.className=\"\"; this.autoSuggestURL=\"\";' onclick='SearchJS.hideSearchComponent();' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             "); this.autoSuggestURL=this.href;' href=\"" +
      //             u +
      //             '">' +
      //             p +
      //             "</a></li></ul>"),
      //           d++,
      //           a++,
      //           d >= this.TOTAL_SUGGESTED)
      //         )
      //           break;
      //       }
      //     }
      //   for (var o = 0; o < staticContent.length; o++)
      //     if (
      //       ($("#" + this.STATIC_CONTENT_SECTION_DIV[o]).html(""), "" !== t[o])
      //     ) {
      //       var h =
      //         "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //         staticContentHeaders[o] +
      //         "</span></li></ul>";
      //       $("#" + this.STATIC_CONTENT_SECTION_DIV[r]).html(
      //         h +
      //           i +
      //           " role='list' title='" +
      //           staticContentHeaders[o] +
      //           "' aria-label='" +
      //           staticContentHeaders[o] +
      //           "'>" +
      //           t[o] +
      //           n
      //       ),
      //         r++;
      //     }
      //   var I = "",
      //     y = document.getElementById("autoSuggestHistory");
      //   y.innerHTML = "";
      //   var f = [];
      //   this.historyIndex = a;
      //   var S = getCookie("searchTermHistory");
      //   if ("undefined" != typeof S)
      //     for (var v = S.split("|"), d = 0, o = v.length - 1; o > 0; o--) {
      //       var _ = v[o],
      //         C = _.toLowerCase();
      //       if (C.match("^" + s) == s) {
      //         for (var A = !1, l = 0; l < f.length; l++)
      //           if (f[l] == C) {
      //             A = !0;
      //             break;
      //           }
      //         if (!A) {
      //           if (d >= this.TOTAL_HISTORY) break;
      //           (I =
      //             I +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a href='#' onmouseout='this.className=\"\"' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             ");' onclick='SearchJS.selectAutoSuggest(this.title); return false;' title='" +
      //             _ +
      //             "' id='autoSelectOption_" +
      //             a +
      //             "'><strong>" +
      //             e +
      //             "</strong>" +
      //             _.substring(e.length, _.length) +
      //             "</a></li></ul>"),
      //             f.push(C),
      //             d++,
      //             a++;
      //         }
      //       }
      //     }
      //   if (
      //     ("" === this.staticContentHeaderHistory &&
      //       (this.staticContentHeaderHistory =
      //         Utils.getLocalizationMessage("HISTORY")),
      //     "" !== I)
      //   ) {
      //     var h =
      //       "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //       this.staticContentHeaderHistory +
      //       "</span></li></ul>";
      //     (y.innerHTML =
      //       h +
      //       i +
      //       " title='" +
      //       this.staticContentHeaderHistory +
      //       "'>" +
      //       I +
      //       n),
      //       r++;
      //   }
      //   return r > 0 ? (this.showAutoSuggest(!0), !0) : !1;
      // },
      retrieveCachedSuggestions: function () {
        this.retrievedCachedSuggestions ||
          wcRenderContext.updateRenderContext("CachedSuggestions_Context", {});
      },
      // updateSearchTermHistoryCookie: function (e) {
      //   var t = "searchTermHistory",
      //     r = "|" + e,
      //     s = getCookie(t);
      //   "undefined" != typeof s && (r = setCookie(t) + r),
      //     setCookie(t, r, {
      //       path: "/",
      //       domain: cookieDomain,
      //     });
      // },
      // updateSearchTermHistoryCookieAndRedirect: function (e, t) {
      //   this.updateSearchTermHistoryCookie(e),
      //     -1 == navigator.userAgent.toLowerCase().indexOf("firefox") &&
      //       (document.location.href = appendWcCommonRequestParameters(t));
      // },
      isValidNumber: function (e) {
        return !isNaN(parseFloat(e)) && isFinite(e) && e >= 0;
      },
      validateForm: function (e) {
        (e.minPrice.value = trim(e.minPrice.value)),
          (e.maxPrice.value = trim(e.maxPrice.value));
        var t = e.minPrice.value,
          r = e.maxPrice.value,
          s = this.isValidNumber(t),
          a = this.isValidNumber(r);
        if (t.length > 0 && !s)
          return (
            MessageHelper.formErrorHandleClient(
              e.minPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (r.length > 0 && !a)
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (t.length > 0 && r.length > 0 && parseFloat(t) > parseFloat(r))
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.ERROR_PRICE_RANGE
            ),
            !1
          );
        (e.searchTerm.value = trim(e.searchTerm.value)),
          (e.filterTerm.value = trim(e.filterTerm.value)),
          (e.manufacturer.value = trim(e.manufacturer.value));
        var i = e.searchTerm.value,
          n = e.filterTerm.value,
          o = e.manufacturer.value;
        return 0 == i.length && 0 == n.length && 0 == o.length
          ? (MessageHelper.formErrorHandleClient(
              e.searchTerm.id,
              MessageHelper.messages.ERROR_EMPTY_SEARCH_FIELDS
            ),
            !1)
          : void processAndSubmitForm(e);
      },
      registerMouseDown: function () {
        null == this.mouseDownConnectHandle &&
          (this.mouseDownConnectHandle = $(document.documentElement).on(
            "mousedown",
            $.proxy("handleMouseDown", this)
          ));
      },
      unregisterMouseDown: function () {
        null != this.mouseDownConnectHandle &&
          ($(document.documentElement).off("mousedown"),
          (this.mouseDownConnectHandle = null));
      },
      handleMouseDown: function (e) {
        var t = e.target;
        if (t != document.documentElement) {
          for (
            var r = document.getElementById("searchDropdown"),
              s = document.CatalogSearchForm.searchTerm,
              a = !0;
            t;

          ) {
            if (t == r || t == s) {
              a = !1;
              break;
            }
            t = t.parentNode;
          }
          a && this.showAutoSuggest(!1);
        }
      },
      declareAutoSuggestRefreshArea: function () {
        wcRenderContext.declare(
          "AutoSuggest_Context",
          ["autoSuggestDynamic_Result_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "AutoSuggest_Context"
            );
            $("#autoSuggestDynamic_Result_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("suggestedKeywordResults"),
              t = document.getElementById("suggestedProductsResults");
            null == e &&
              null == t &&
              $("#autoSuggestDynamic_Result_div").html(""),
              SearchJS.showAutoSuggestIfResults();
          };
        $("#autoSuggestDynamic_Result_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
      declareAutoSuggestCachedSuggestionRefreshArea: function () {
        wcRenderContext.declare(
          "CachedSuggestions_Context",
          ["autoSuggestCachedSuggestions_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "CachedSuggestions_Context"
            );
            $("#autoSuggestCachedSuggestions_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("cachedSuggestions");
            if (null == e) $("#autoSuggestCachedSuggestions_div").html("");
            else {
              for (
                var t = e.getElementsByTagName("script"), r = t.length, s = 0;
                r > s;
                s++
              ) {
                var a = document.createElement("script");
                (a.type = "text/javascript"),
                  (a.text = t[s].text),
                  document
                    .getElementById("autoSuggestCachedSuggestions_div")
                    .appendChild(a);
              }
              SearchJS.retrievedCachedSuggestions = !0;
              var i = document.getElementById("mobileSearchDropdown");
              null != i && "block" == i.style.display
                ? (searchTerm = $("#MobileSimpleSearchForm_SearchTerm").val())
                : (searchTerm = document.CatalogSearchForm.searchTerm.value),
                searchTerm.length > SearchJS.AUTOSUGGEST_THRESHOLD &&
                  SearchJS.doStaticAutoSuggest(searchTerm);
            }
          };
        $("#autoSuggestCachedSuggestions_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
    }),
  ("undefined" != typeof ShoppingListDialogJS &&
    null != ShoppingListDialogJS &&
    ShoppingListDialogJS) ||
    ((ShoppingListDialogJS = {
      storeParams: null,
      dialogParams: null,
      setDialogParams: function (e, t) {
        (this.storeParams = e),
          (this.dialogParams = t),
          null == this.dialogParams.image || "" == this.dialogParams.image
            ? this.fetchAddedItem()
            : this.displayItemAddedWithoutFetching();
      },
      fetchAddedItem: function () {
        var e = this.setCommonParams();
        (e.productId = this.dialogParams.catEntryId),
          (e.catalogEntryId = this.dialogParams.catEntryId),
          $.ajax({
            url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",
            method: "post",
            dataType: "json",
            data: e,
            success: ShoppingListDialogJS.displayItemAddedDialog,
            error: function (e, t, r) {
              console.debug(
                "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
              );
            },
          });
      },
      displayItemAddedDialog: function (e) {
        var t = $("#shoppingListItemAddedPopup");
        if (t.length > 0) {
          var r = e.catalogEntry.description[0];
          $("#shoppingListItemAddedImg")
            .attr("src", r.thumbnail)
            .attr("alt", r.name),
            $("#shoppingListItemAddedName").html(r.name),
            $("#shoppingListItemAddedPopup").data("wc-WCDialog").open();
        } else console.debug("shoppingListItemAddedPopup does not exist");
      },
      displayItemAddedWithoutFetching: function () {
        $("#shoppingListItemAddedPopup").length
          ? ($("#shoppingListItemAddedImg").attr(
              "src",
              this.dialogParams.image
            ),
            $("#shoppingListItemAddedImg").attr("alt", this.dialogParams.name),
            $("#shoppingListItemAddedName").html(this.dialogParams.name))
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      showDialog: function () {
        var e = $("#shoppingListItemAddedPopup");
        e.length > 0
          ? e.data("wc-WCDialog").open()
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = this.storeParams.storeId),
          (e.catalogId = this.storeParams.catalogId),
          (e.langId = this.storeParams.langId),
          e
        );
      },
      close: function () {
        $("#shoppingListItemAddedPopup").hide(),
          this.dialogParams.focusElement &&
            "" != this.dialogParams.focusElement &&
            $("#" + this.dialogParams.focusElement).focus();
      },
    }),
    wcTopic.subscribe(
      "ShoppingListItem_Added",
      ShoppingListDialogJS.showDialog
    )),
  wcRenderContext.declare(
    "WishlistDisplay_Context",
    ["WishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  wcRenderContext.declare(
    "SharedWishlistDisplay_Context",
    ["SharedWishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  (ShoppingListControllersJS = {
    declareWishlistDisplayWidgetRefreshController: function () {
      var e = $("#WishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceRemoveItem",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          ($("#multipleWishlistController_select").disabled = !1),
          cursor_clear();
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSharedWishlistDisplayRefreshController: function () {
      var e = $("#SharedWishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "SharedWishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWishlistSelectWidgetRefreshController: function () {
      wcRenderContext.declare(
        "WishlistSelect_Context",
        ["WishlistSelect_Widget"],
        ""
      );
      var e = $("#WishlistSelect_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistSelect_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        cursor_clear();
        var e = $("#multipleWishlistController_select");
        null == e
          ? ((MultipleWishLists.defaultListId = null),
            (MultipleWishLists.addItemAfterCreate = null))
          : e.length > 0 &&
            ((MultipleWishLists.defaultListId = $(
              "#multipleWishlistController_select"
            ).val()),
            shoppingListJS.refreshLinkState());
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceCreate",
    actionId: "ShoppingListServiceCreate",
    url: getAbsoluteURL() + "AjaxRestWishListCreate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "add",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceUpdate",
    actionId: "ShoppingListServiceUpdate",
    url: getAbsoluteURL() + "AjaxRestWishListUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_EDITED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "edit",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceDelete",
    actionId: "ShoppingListServiceDelete",
    url: getAbsoluteURL() + "AjaxRestWishListDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_DELETED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: "",
          action: "delete",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItem",
    actionId: "ShoppingListServiceAddItem",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceRemoveItem",
    actionId: "ShoppingListServiceRemoveItem",
    url: getAbsoluteURL() + "AjaxRestWishListRemoveItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("ITEM_REMOVED")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItemAndRemoveFromCart",
    actionId: "ShoppingListServiceAddItemAndRemoveFromCart",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListServiceChangeGiftListStatus",
    actionId: "AjaxGiftListServiceChangeGiftListStatus",
    url: getAbsoluteURL() + "AjaxRestWishListChangeState",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        MultipleWishLists.setDefaultListId(e.uniqueID),
        MultipleWishLists.updateContextPostSwitch(e.uniqueID);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListAnnouncement",
    actionId: "AjaxGiftListAnnouncement",
    url: getAbsoluteURL() + "AjaxRESTWishListAnnounce",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("WISHLIST_EMAIL_SENT")
        ),
        $("#WishListEmailSucMsg_Div").css("display", "block"),
        $("#recipientEmail_wishListDisplay").html(
          e.recipient[0].substring(0, 25)
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });


/* jshint esversion: 6 */
/**
 * @fileOverview Generic JS file for Persol brand
 *
 **/
/* detect mobile*/

// .includes polyfill
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement /*, fromIndex*/) {
    'use strict';
    if (this == null) {
      return;
    }

    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {k = 0;}
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement ||
         (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}
// starts with polyfill
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
      value: function(search, rawPos) {
          var pos = rawPos > 0 ? rawPos|0 : 0;
          return this.substring(pos, pos + search.length) === search;
      }
  });
}
/* this remove the page positioning on his previous scroll position*/
if (!isIOS() && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

var didResize;

var phoneWidth = 600;
var tabletWidth = 1024;
var countPrescription = 0;

var catalogEntryDetails = "";
var idSection;

function showSubmenu() {
  $(".nav__section").removeClass( "show") ;
  idSection= "#"+ $(this).attr('id') + "_Section";
  $( idSection ).addClass( "show" );
  $('html').addClass('no-scroll');
  $('.facet__fade').addClass('fade');
  $('.facet__fade').css('z-index','10');
  $('.facet__fade').show();

}

function hideSubmenu() {
  $( idSection ).removeClass( "show");
  $('html').removeClass('no-scroll');
  $('.facet__fade').removeClass('fade');
  $('.facet__fade').css('z-index','');
  var nav = idSection.replace("_Section","");
  $( nav ).css("text-decoration","none");

}

function hideshowallsite() {
    var allsite = $("#allsite-content").html();
    if (allsite !== ''){
        var row4 = document.getElementById("footerRow4");
        $("#allsite-content").empty();
        row4.innerHTML = allsite;
    }else;
    
    if ( $("#otherall label").hasClass("active") ){
        $("#otherall label").toggleClass('active');
        $("#footerRow4").hide();
    }
    else{
        $("#otherall label").addClass('active');
        $("#footerRow4").show();
    }
} 

function refreshNavItemSettings(isDesktop) {
if(isDesktop) {		
  $('.sale_badge').removeClass('submenu__subheader');
  $('.sale_badge').removeClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
  
  if($('#closeIcon').css('display') != 'none' && $('#closeIcon').css('display') != undefined) //chiudi il menu se aperto
    document.getElementById('header__checkbox').click();
  
  $('.header__block-search').removeClass( "hidden" );
  
  $( ".nav__item" ).hover(
            function(){
            	setDDMPosition();
                $(".nav__section").removeClass( "show") ;
                idSection= "#"+ $($(this).find(".nav__link.desktop")).attr('id') + "_Section";
                $( idSection ).addClass( "show" );
               callAlgoliaServiceEspot(idSection);

                $('html').addClass('no-scroll');
                $('.facet__fade').addClass('fade');
                $('.facet__fade').css('z-index','10');
                $('.facet__fade').show();
                $(this).find(".nav__link.desktop").css("text-decoration","underline");
                $(".nav__item a[id!='"+$(this).find("a").attr("id")+"'].nav__link.desktop").css("text-decoration","none");
            },
            function(){
              //if the cursor is not in hover on the sub menu --> hide the submenu
              if($(".nav__section:hover").length < 1) {
                hideSubmenu();
              }
            }
        );
  
} else {
  //sezione mobile
  $( ".nav__item" ).unbind();
  $('.sale_badge').addClass('submenu__subheader');
  $('.sale_badge').addClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
  //loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
  //loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
}
}  



$(document).ready(function () {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
    

  if($('#page').hasClass('pdp')){

    /* handle when sticky bar doesn't become sticky on landing for HB-12208*/
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if(!$(".shopper-action-bar").hasClass("sticky-active")){
            manageStickyElement();
        }
      }


      var timestamp = new Date().getTime() / 1000;
      var diff = timestamp - renderingPageStarterTime;
      console.log('Performance Improvements PDP - #21 - document.ready in store-persol.js (PO only) - ' + diff.toString().slice(0 , 5) + 's');
    }


  var catEntryIdSubscribe;
   // apertura section #departmentLink_sun
  $("#departmentLink_OurWorld_Section,#departmentLink_Gif_Section").addClass("vertical-carousel");
  //apertura menu mobile
  $(".nav__link.phone").click(function() {
    
      var idSection;
      $($(this).siblings()).each(function(){
          if($(this).hasClass("desktop")){
              idSection = "#"+ $(this).attr('id') + "_Section";
          }
          callAlgoliaServiceEspot(idSection); //provare questa
          console.log("idSection",idSection);
          if(idSection == "#departmentLink_collab_Section"){//quando apro collab devo vedere sempre collectio e nascondo i contenuti
              idSection= "#departmentLink_Collection_Section";
              console.log("this",this);
              if($(this).find("subheader__collection")){
                  console.log("ok");
                  $(".subheader__collection").css("display","none");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","block");
                  }

              }
          }else if(idSection=="#departmentLink_Collection_Section"){
              if($(this).find("subheader__collection")){
                  $(".subheader__collection").css("display","block");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","none");
                  }

              }

          }
      })

      
      if($( idSection).hasClass('show')){
          $( idSection).removeClass( "show" );
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.add('iosBody');
          }
      }
      else{
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.remove('iosBody');
          }
          $( idSection).addClass( "show" );
      }
  });
  //funzione back dopo apertuta menu mobile
  $(".nav_back--phone, .back-arrow-mobile-menu").click(backMenu);

  //enable click on span item in mobile menu
  $('.submenu__subheader--mobile').click(function() {
      if($(this).find("a").attr("href")){
          window.location = $(this).find("a").attr("href");
          return false;
       }
});
  var windowSize = window.innerWidth;
  
  refreshNavItemSettings(windowSize >= tabletWidth);

  $(".nav__link.desktop" ).focusin(
      showSubmenu
  );

  $( ".nav__section" ).hover(
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","underline");

      },
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","none");
          hideSubmenu();
      }
  );
  

  //accesibilità nav bar
  var navActive="";
  document.body.classList.add('using-mouse');
document.body.addEventListener('mousedown', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('wheel', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('keydown', function(e) {
      var keycode;
       if (e.key !== undefined) {
         keycode= e.key
       } else if (e.keyIdentifier !== undefined) {
          keycode=e.keyIdentifier;
      } else if (e.keyCode !== undefined) {

          keycode=e.keyCode;
      }
      console.log("key",keycode)
       if(keycode == "Tab" || keycode==9){
            document.body.classList.remove('using-mouse');

            if($(document.activeElement).hasClass("nav__link")) {
              var idSection = "#"+ $(document.activeElement).attr('id') + "_Section";//compongo id sottomenu
              var link = $(idSection).find(".submenu__item a")[0];
              navActive = document.activeElement;
              $($(idSection).find(".start-section")).focus();
            }
       }
  });

  var navActive = null;
  $(".end-section").focusin(function(){
      $($(this).closest(".nav__section")).removeClass("show"); //dopo aver visto ultimo elemento chiudi in sottomenu
      console.log("end-section")
      if(navActive) {
          var navNext = $($(navActive).closest(".nav__item")).next(); //vado al successivo nav item rispetto a quello con il focus all'inizio
          $($(navNext).find("a")).focus();
      }

  })
  // eyeglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"||storeDirectory=="PersolDE"){$("#li-prescription").show();}});
// sunglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"){$("#li-sun-prescription").show();}});


/* var map = {9: false, 16: false};
  $(document).keydown(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = true;
          if (map[16] && map[9]) {
           if($(document.activeElement).hasClass("start-section")) {
               var Section = $($(document.activeElement).closest(".nav__section"));
               idLink= "#"+$(Section).attr('id').replace("_Section","");
               var index=$($(idLink).closest(".nav__item")).index()
               console.log(index)
              var navItem=$(".nav__items")[index+1];
              $($(navItem).find("a")).focus();
               // non funziona come dovrebbe

              }
             /*  if($(document.activeElement).hasClass("nav__link")) {
                  var navPrec = $($(document.activeElement).closest(".nav__item")).prev(); // prendo la voce di menu prec
                  $($(document.activeElement).closest(".nav__section")).removeClass("show"); // tolgo la classe show da quella in cui sto
                  var idPrec= $($(navPrec).find(".nav__link")).att("id"); //prendo l'id della precedente voce di menu
                  var idSectionPrec= "#"+ idPrec+ "_Section";//compongo l'id della section prec
                  $(idSectionPrec).addClass("show"); //mostro il sottomenu
                  $(idSectionPrec).find(".end-section").focus(); // metto il focus sull'end section

              }
          }
      }
  }).keyup(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = false;
      }
  });*/
  windowSize = window.innerWidth;
  var windowSizePrevious = window.innerWidth;
  /* check promoCalloutCookie */
  checkPromoCookie();
  var ts;
  //stop hiding header on hover
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      //sposto i other colors per evitare la cash delle var IOS e ANDROID in jsp
      //$('.catalog-entry-recommendation-widget.other_colors').appendTo($('.bottom-section'));
      
      if ($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        //$('.long-description-widget').css("padding-top", "72px");
        
      } else {
        //$('.catalog-entry-recommendation-widget.other_colors').css("bottom", "28%");
      }
      $('.catalog-entry-recommendation-widget.other_colors').css('display','flex');
      $('.presc--body').css('height', window.innerHeight - $('.presc--content header').outerHeight()-$('.presc--content__button').outerHeight()-$('.presc--content__message').outerHeight()-70+'px'); //40px
      $('.presc--content__fade').width($('.pdp .presc--content--options label').outerWidth());
      $(document).mousemove(function(e){
          var vertical = e.pageY;
          if($('#page').hasClass('pdp') && vertical <= 20
          && !$('#header').is(":visible")
          && $('.slot4').hasClass('fixed-bottom')
          && !$('.presc').hasClass('.showed-presc')
          && !$('.op-pdp-popup-other-colors').hasClass('active')
          && !$('.shopperActions--monogram--pop-up').is(':visible')) {
              if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              } else{
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              }
            /*   $('#header').slideDown("", function(){
                   setHeightFullImage(true)
                 }); */
              $('.freeShipping').show()
          }
          if(vertical > 120 && $('#header').is(":visible") && !$(".header__nav-menu").hasClass("opend") && !$("#headerRow1--wrapper").siblings() && !$('.presc').hasClass('.showed-presc') && !$('.op-pdp-popup-other-colors').hasClass('active') && !('.shopperActions--monogram--pop-up').is(':visible')) {
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $('#bannerTop').slideUp();
              }
            //   $('#header').slideUp();
              setHeightFullImage(false)
          }
      });
      $('.pdp #header').on('mouseenter', function(){
          hideHeaderTimeout.cancel();
      }).on( 'mouseleave', function(){
          if(!$('#Header_GlobalLogin_signInQuickLink').hasClass('active')){
              hideHeaderTimeout.setup();

          }
          if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop controlla
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $("#bannerTop").css("display","flex");
              }}
      });
  } else {
      if($('#page').hasClass('pdp')){
          //event for touch mobile
          $(document).bind('touchstart', function (e){
              ts = e.originalEvent.touches[0].clientY;
          });

          $(document).bind('touchend', function (e){
              var te = e.originalEvent.changedTouches[0].clientY;
              if(ts < te-100 && !$("#vm_box").is(':visible')){
                  hideHeaderTimeout.showHeader();
              }
          });

          $(".othercolors-mobile").prepend($('.catalog-entry-recommendation-widget.other_colors'));
      }
  }
  if($('#page').hasClass('pdp')){
      //retrieveS7multiimage();
      if(!window.mobilecheck() && !window.tabletPortraitCheck()){
        animationInit();
      }

      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $("#monogramText3").on("keydown", function(event){
              if (event.keyCode == 13) {
                      event.preventDefault();
                      event.target.blur()
                  }
          })
      }
  }

  $(document).click(function (e) {

      // Ignore this event if preventDefault has been called.
      if (e.defaultPrevented) return;

      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }


  });

  $(window).resize(function () {
      windowSize = $(document).width();
      if ((windowSize > tabletWidth) && (windowSizePrevious <= tabletWidth)) {
        refreshNavItemSettings(true);
          // We have just passed from a phone resolution to a bigger one
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive > div').length > 0) {
              if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .wrapperClose > div').hasClass("close")) {
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').removeAttr('style');
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
                  //$('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footerCorporateInfoSection h6').length > 0) {
              if ($('#footerCorporateInfoSection h6').hasClass("close")) {
                  $('#footerCorporateInfoSection ul').show();
                  $('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footer-sx h6').length > 0) {
              if ($('#footer-sx h6').hasClass("close")) {
                  $('#footer-sx ul').show();
                  $('#footer-sx h6').removeClass("close");
              }
          }

          if ($('.persolTech h2').length > 0) {
              if ($('.persolTech h2').hasClass("close")) {
                  $('.persolTech ul').show();
                  $('.persolTech h2').removeClass("close");
              }
          }

          if ($('.tSeries > h2').length > 0) {
              if ($('.tSeries > h2').hasClass("close")) {
                  $('.tSeries .wrapperSeries').show();
                  $('.tSeries > h2').removeClass("close");
              }
          }

          if ($('.tEvolution > h2').length > 0) {
              if ($('.tEvolution > h2').hasClass("close")) {
                  $('.tEvolution .wrapperEvolution').show();
                  $('.tEvolution > h2').removeClass("close");
              }
          }

          /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
              if ($('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
                  $('#contentWrapper.pageContent .slot5 ul').show();
                  $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
              }
          }*/

          if ($('#footerQuickLinksSection h6').length > 0) {
              if ($('#footerQuickLinksSection h6').hasClass("close")) {
                  $('#footerQuickLinksSection ul').show();
                  $('#footerQuickLinksSection h6').removeClass("close");
              }
          }
      } else if ((windowSize <= tabletWidth) && (windowSizePrevious > tabletWidth)) {
          // We have just passed from a bigger resolution of phone to a phone resolution
        refreshNavItemSettings(false);
          hideElements();
      }
      if(!(window.mobilecheck() || window.tabletPortraitCheck() && $('#page').hasClass('pdp'))){
          animationInit();
          /*Start EARLY ACCESS */
          if ($("#pdp_bottom-section .list-price").css("display") != "none" && $("#pdp_bottom-section .list-price").text() != ""){
              $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "33%");
          } else $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "30%");
      
          /*End EARLY ACCESS */
      }
      //  else if( window.mobilecheck() || window.tabletPortraitCheck()  && $('#page').hasClass('pdp')){
      //     didResize = true;
      //     var inHeight;
      //     if(window.innerHeight > window.startingHeight ){
      //         inHeight = window.marginScrollable + window.innerHeight - window.startingHeight ;
      //         var newHeight = window.slot2Height +  window.innerHeight - window.startingHeight ;
      //         $('.slot3').height(newHeight);
      //         $('.bottom-scrollable-section').css('margin-top', inHeight )
      //     } else {
      //         inHeight = window.slot2Height + window.startingHeight  - window.innerHeight ;
      //         $('.slot3').height(inHeight)
      //     }
      //     setInterval(function() {
      //         if (didResize) {
      //             didResize = false;
      //         }
      //     }, 300);
      // }
      // I assign the actual width resolution as the PREVIOUS because in the next check I would do I will compare it with the "resized width" (wich it will be the real actual size).
      windowSizePrevious = $(document).width();
  });

  $('.freeShipping').addClass("hidden");;

  if (!isEmpty($('#freeShippingGlobbal').html())) {
      $('.freeShipping').removeClass("hidden");
  }

  // Toggle of the PRODUCT DETAILS (Product Page) section only when the resolution is equals or less than 600px
  // $('#contentWrapper.pageContent .slot5 > h2.product-details').click(function() {
  //     if (window.innerWidth <= tabletWidth) {
  //         $('#contentWrapper.pageContent .slot5 > ul').slideToggle('400');
  //         if( $('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
  //         } else {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
  //         }
  //     }
  // });c

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.persolTech h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.persolTech .tTechnology').slideToggle('400');
          if ($('.persolTech h2').hasClass("close")) {
              $('.persolTech h2').removeClass("close");
          } else {
              $('.persolTech h2').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.tSeries > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tSeries .wrapperSeries').slideToggle('400');
          if ($('.tSeries > h2').hasClass("close")) {
              $('.tSeries > h2').removeClass("close");
          } else {
              $('.tSeries > h2').addClass("close");
          }
      }
  });

  // Toggle of the SERIES EVOLUTION (Product Page) section only when the resolution is equals or less than 600px
  $('.tEvolution > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tEvolution .wrapperEvolution').slideToggle('400');
          if ($('.tEvolution > h2').hasClass("close")) {
              $('.tEvolution > h2').removeClass("close");
          } else {
              $('.tEvolution > h2').addClass("close");
          }
      }
  });

  // Toggle of the SPECIAL EDITIONS section only when the resolution is equals or less than 600px
  $('#footerCorporateInfoSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerCorporateInfoSection ul').slideToggle('400');
          if ($('#footerCorporateInfoSection h6').hasClass("close")) {
              $('#footerCorporateInfoSection h6').removeClass("close");
          } else {
              $('#footerCorporateInfoSection h6').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL section only when the resolution is equals or less than 600px
  $('#footer-sx h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footer-sx ul').slideToggle('400');
          if ($('#footer-sx h6').hasClass("close")) {
              $('#footer-sx h6').removeClass("close");
          } else {
              $('#footer-sx h6').addClass("close");
          }
      }
  });

  // Toggle of the QUICK LINKS section only when the resolution is equals or less than 600px
  $('#footerQuickLinksSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerQuickLinksSection ul').slideToggle('400');
          if ($('#footerQuickLinksSection h6').hasClass("close")) {
              $('#footerQuickLinksSection h6').removeClass("close");
          } else {
              $('#footerQuickLinksSection h6').addClass("close");
          }
      }
  });

  $("#openSeoLinks").click(function(e){
    e.preventDefault();
      $(".footer-allsites").removeClass('footer-allsites-hide');
      $('html, body').animate({scrollTop:$(document).height()}, 'slow');
  });

  $("#allSitesCloseLink").click(function(e){
    e.preventDefault();
      $(".footer-allsites").addClass('footer-allsites-hide');
  });

  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').slideToggle('400');
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').hasClass("close")) {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').removeClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').removeClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').show();
              }
          } else {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').addClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').hide();
              }
          }
      }
  });

  $("#page.personal-information-page .gdpr__input-block .wrapper label").html("");

  if ($("#contentWrapper").hasClass("myAccountSummary")){
    checkEditFormInputs();
  }

  // When the page is ready, we will check if its resolution is lesser than 601 to hide the toggled elements
  if (windowSize < tabletWidth + 1)
      hideElements();

  // Display the header's "dropdown" menu
  if ($(window).width() > tabletWidth) {
      $('#departmentsMenu > li').hover(function () {
          if ($(" > section", this).length > 0) {
              $(" > section", this).stop(true, false, true).slideToggle(200);
              $(this).addClass('hover');
          }
      }, function () {
          $(" > section", this).stop(true, false, true).slideToggle(200);
          $(this).removeClass('hover');
          // $(" > section", this).stop(true, false, true).slideToggle(200);
      });
  }

  // $('#searchIcon').click(function() {
  //     if ($('#searchBar').length > 0) {
  //         $('#searchBar').slideToggle('400');
  //     }
  // });

  /* BEGIN - Responsive Header */
  /* Show/hide lateral menu */
  $('#hamResponsive .menuExpand').click(function () {
    if (window.innerWidth <= tabletWidth) {
          if ($(this).hasClass('open')) {
              /* Responsive menu is opened */
              $(this).removeClass('open');
              $('#page .siteContainer').removeClass('opened');
              $('#page').removeClass('opened');
          } else {
              /* Responsive menu is closed */
              $(this).addClass('open');
              $('#page .siteContainer').addClass('opened');
              $('#page').addClass('opened');
          }
      }
  });

  /* Add 'open' class to the item we click */
  $('#departmentsMenu .dropdownMenu > a, #departmentsMenu li.dropdownMenu > span').click(function (event) {
      if (window.innerWidth <= tabletWidth) {
          var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (iOS) {
              console.log("iOS -> %o", iOS);
              $(this).one(function () {
                  console.log("iOS.one()");
                  $(this).click();
                  console.log("iOS.click()");
              });
          }
          event.preventDefault();
          if ($(this).parent().hasClass('open')) {
              $(this).parent().removeClass('open');
          } else {
              $('#departmentsMenu .dropdownMenu').removeClass('open');
              $(this).parent().addClass('open');
          }
      }
  });
  /* END - Responsive Header */

  /* BEGIN - POP UP PERSOL TECHNOLOGY */
  /* Open the pop up with properties */
  $('.persolTech .tTechnology li .openPopUp').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($(this).parents('li').length > 0) {
          if ($(this).parents('li').find('.popUp').length > 0) {
              // I will create the dialog
              $(this).parents('li').find('.popUp').dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "popUpPersolTechnology popUp-" + $(this).parents('li>div').attr('id')
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true, //new option
                  resizable: false,
                  close: function () {
                      // Stop the video when we close the pop up.
                      $(this).parent().find('video').get(0).pause();
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                  }
              });
          } else {
              // I have already created the dialog, so I have just to open it
              var popUpName = '.popUp-' + $(this).parent().attr('id') + ' .popUp';
              $(popUpName).dialog('open');
          }
          // Launch the function for the new fluid option
          fluidDialog();
      }
  });

  // On window resize run function
  $(window).resize(function () {
      fluidDialog();
  });
  

  function fluidDialog() {
      var $visible = $(".ui-dialog:visible");
      $visible.each(function () {
          var $this = $(this);
          var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
          // If the new fluid option is able
          if (typeof dialog !== 'undefined'
          && typeof dialog.options !== 'undefined'
          && typeof dialog.options.fluid !== 'undefined') {

              var wWidth = $(window).width();
              // Check window width against dialog width
              if (wWidth < (parseInt(dialog.options.maxWidth) + 80)) {
                  // Keep dialog from filling entire screen
                  $this.css("max-width", "90%");
              } else {
                  // Fix maxWidth bug
                  $this.css("max-width", dialog.options.maxWidth + "px");
              }
              // Reposition dialog
              dialog.option("position", dialog.options.position);
          }
      });
  }

  // Play or pause the video on clicking the image above.
  $('.popUp .video .playPause').click(function () {
      if ($(this).parent().find('video').length > 0) {
          var vid = $(this).parent().find('video').get(0);
          if ($(this).hasClass('playing')) {
              $(this).removeClass('playing');
              vid.pause();
          } else {
              $(this).addClass('playing');
              vid.play();
          }
      }
  });

  $(document).click(function (e) {
      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }
  });


  $('.product_page_content .polarizedPersol').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($('#lenses').parent().find('.popUp').length > 0) {
          // I will create the dialog
          $('#lenses').parent().find('.popUp').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUpPersolTechnology popUp-lenses"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  // Stop the video when we close the pop up.
                  $(this).parent().find('video').get(0).pause();
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          var popUpName = '.popUp-lenses .popUp';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP UP PERSOL TECHNOLOGY */

  /* BEGIN - POP-UP ZOOM & 360 */
  $('.viewBy > span').click(function (event) {
      if ($('#pdp-360-popup').length > 0) {
          var tabOpen = event.currentTarget.className == 'viewBy--p360' ? 1 : 0;
          $('#pdp-360-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUp-zoom360"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: 800,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function() {
                  $(this).parent().attr('tabindex','0');

                  var displayedImage = null;

                  if ($('#productMainImage').length) {
                      displayedImage = $('#productMainImage');
                  } else if ($('#sliderProductMainPage0').length) {
                      displayedImage = $('#sliderProductMainPage0');
                  }

                  var pathImg = "";
                  if (displayedImage != null) {
                      console.log("PSL::store-persol.js::Displayed image URL = " + displayedImage.attr('src'));
                      var displayedImageSource = displayedImage.attr('src');
                      if (displayedImageSource.includes("_noshad")) {
                          pathImg = displayedImageSource.split("_noshad")[0];
                      } else if (displayedImageSource.includes("_shad")) {
                          pathImg = displayedImageSource.split("_shad")[0];
                      } else {
                          pathImg = displayedImageSource.split("_")[0];
                      }
                  }
                  console.log("PSL::store-persol.js::Final base image URL = " + pathImg);

                  var imgZoom = pathImg + '_noshad_qt?scl=1';

                  $('.nextCircle').css("display", "none");

                  $('#pdp-360-popup--container').tabs({
                      active: tabOpen
                  });

                  $('#pdp-360-popup--container--zoom--img > img').attr('src', displayedImage.attr('src'));

                  $('#pdp-360-popup--container--zoom--img').zoom({
                      url: imgZoom,
                      on: 'grab'
                  });

                  $("#pdp-360-popup--container--360").spritespin({
                      source: [
                          pathImg + '_noshad_fr?$594$',
                          pathImg + '_noshad_qt?$594$',
                          pathImg + '_060A?$594$',
                          pathImg + '_090A?$594$',
                          pathImg + '_120A?$594$',
                          pathImg + '_150A?$594$',
                          pathImg + '_180A?$594$',
                          pathImg + '_210A?$594$',
                          pathImg + '_240A?$594$',
                          pathImg + '_270A?$594$',
                          pathImg + '_300A?$594$',
                          pathImg + '_330A?$594$'
                      ],
                      width: 595,  // width in pixels of the window/frame
                      height: 385,  // height in pixels of the window/frame
                      animate: false,
                      responsive: true,
                  });

                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position','relative');
                  $(this).parent().find(".ui-button").attr('tabindex','0');
              }
          });
      } else {
          var popUpName = '.popUp-zoom360';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP-UP ZOOM & 360 */

  /* BEGIN - SHOPPING INFO & RETURN POPUP */
  $('#ci_espot__footerCheckout_Left .left_espot #shopping').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').length > 0) {
          // I will create the dialog
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "shopping-popup"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay').removeClass("shopping_overlay");
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay').addClass("shopping_overlay");
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - SHOPPING INFO & RETURN POPUP */
  /* START - catalogEntryDetails for Content Team */
  if ($("#page.pdp").length > 0) {
    catalogEntryDetails = JSON.parse($('#catalogEntryDetails_temp').text());
  }
  /* END - catalogEntryDetails for Content Team */


  /*HB-4558
   * prevent the background page to scroll
   */
        document.ontouchmove = function ( event ) {

            var isTouchMoveAllowed = true, target = event.target;

            while ( target !== null ) {
              if ( target.classList && target.classList.contains('submenu' ) ) {
                isTouchMoveAllowed = false;
                break;
              }
              target = target.parentNode;
            }

            if ( !isTouchMoveAllowed ) {
              event.preventDefault();
            }

       };

  //$('#attrValue_Size-menu .ui-menu-item').click(function(event) {
  $('#attrValue_Size-menu li').click(function (event) {
      // console.log("YEAH CLICK");
      if ($(this).attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE");
      }
  });

  //console.log("YEAH 2");
  $('ul#attrValue_Size-menu').click(function (event) {
      //        console.log("YEAH CLICK 2 -> %o",$(this));
      //        console.log("YEAH CLICK 3 -> %o",$(this).find('li'));
      if ($(this).find('li').attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE 2");
      }
  });


  /* Show default payment placement */
  var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
   showDefaultPaymentPlacement(defaultPaymentPlacement);


});


function backMenu(div){
    var idSection = $(this).closest("section");
    if(idSection.length == 0){
        idSection = $(div).closest("section")
    }
      $( idSection).hasClass('show') ?  $( idSection).removeClass( "show" ) :  $( idSection).addClass( "show" );
      $('.header__block-search').removeClass( "hidden" );
      if(isIOS()){
          document.getElementsByTagName('body')[0].classList.add('iosBody');
      }
}


// This function is for hide the toggle elements when we go through a tablet resolution (> 600 & < 1281) to a phone resolution (< 600)
function hideElements() {
  /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
      $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
      $('#contentWrapper.pageContent .slot5 ul').hide();
  }*/

  if ($('#footerCorporateInfoSection h6').length > 0) {
      $('#footerCorporateInfoSection h6').addClass("close");
      $('#footerCorporateInfoSection ul').hide();
  }

  if ($('#footer-sx h6').length > 0) {
      $('#footer-sx h6').addClass("close");
      $('#footer-sx ul').hide();
  }

  if ($('.persolTech h2').length > 0) {
      $('.persolTech h2').addClass("close");
      $('.persolTech ul').hide();
  }

  if ($('.tSeries > h2').length > 0) {
      $('.tSeries > h2').addClass("close");
      $('.tSeries .wrapperSeries').hide();
  }

  if ($('.tEvolution > h2').length > 0) {
      $('.tEvolution > h2').addClass("close");
      $('.tEvolution .wrapperEvolution').hide();
  }

  if ($('#footerQuickLinksSection h6').length > 0) {
      $('#footerQuickLinksSection h6').addClass("close");
      $('#footerQuickLinksSection ul').hide();
  }
}


// STATIC PAGES SCRIPTS  ///////////////////////////////////////////////////////////////////////////////////////////////

/**
* Convert URL's from received html to absolute
*/
function convertDataToAbsolute(data) {
  //Here we receive specific data of selected page
  //Now we add absolute address value 'http://www.persol.com/'
  var data_absolute = data;

  //replaces all occurrences of searchValue in data
  function replaceValues(data, searchValue, replacementValue) {
      var myString = data;
      while (myString.indexOf(searchValue) > 0) {
          myString = myString.replace(searchValue, replacementValue);
      }
      return myString;
  }

  //remove all occurrences of "this.href + "
  data_absolute = replaceValues(data_absolute, "this.href + ", "");
  data_absolute = replaceValues(data_absolute, "img src=\"/_events", "img src=\"http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "\"/international", "\"http://www.persol.com/international");
  data_absolute = replaceValues(data_absolute, "img src=\"/Content", "img src=\"http://www.persol.com/Content");
  data_absolute = replaceValues(data_absolute, "\"/Scripts", "\"http://www.persol.com/Scripts");
  data_absolute = replaceValues(data_absolute, ";/_events", ";http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "<script type=\"text/javascript\" src=\"http://www.persol.com/Scripts/custom/cufon.js\"></script>", "");
  // <script type="text/javascript" src="http://www.persol.com/Scripts/custom/cufon.js"></script>

  return data_absolute;
}

// // Vintage Celebration Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#vintageCelebrationPage").ready(function () {
//     $("#vintageCelebrationPage .scrollVintage").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage #skipVideo").click(function () {
//         event.preventDefault();
//         $("#vintageCelebrationPage #skipVideo").fadeOut("slow");
//         $("#vintageCelebrationPage #video").fadeOut("slow");
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.unload().then(function () {
//             // the video was unloaded
//         }).catch(function (error) {
//             // an error occurred
//         });
//     });

//     $("#vintageCelebrationPage #but_video").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage #video").fadeIn("slow");
//         $("#vintageCelebrationPage #skipVideo").fadeIn("slow");
//     });

//     /* Cambio de m�todo a carga sin ajax */
//     var flipSpeed = 500;
//     var box1opened = false;
//     var box3opened = false;

//     function box1Flip() {
//         if (box3opened) {
//             box3Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = true;
//     }

//     function box1Back() {
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box1 .backTo').click(function () { box1Back(); });

//     function box3Flip() {
//         if (box1opened) {
//             box1Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = true;
//     }

//     function box3Back() {
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box3 .backTo').click(function () { box3Back(); });


//     $("#vintageCelebrationPage #btn-tabacco-virginia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_tabacco-virginia").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-miele").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_miele").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-madreterra").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_madreterra").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-di-siena").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_terra-di-siena").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-caffe").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_caffe").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-fuoco-e-ardesia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_fuoco-e-ardesia").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-resina-e-sale").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_resina-e-sale").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-ebano-e-oro").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_ebano-e-oro").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-e-oceano").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_terra-e-oceano").html()).promise().done(function () { box3Flip(); });
//     });

//     //Vintage Celebration Mobile Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////

//     var vintageDelay = 500;

//     $("#vintageCelebrationPage .scrollTo").click(function () {
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage .videoCover").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage .mobile .videoCover").fadeOut("slow");
//         $("#vintageCelebrationPage .mobile #player_2").fadeIn("slow");
//     });

//     function closeHavanasSelector() {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });
//     }
//     function closeHavanasSectionModels() {
//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-havanas").click(function () {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .close-btn").click(function () {
//         closeHavanasSelector();
//     });

//     $("#vintageCelebrationPage .section-models.havanas .close-btn").click(function () {
//         closeHavanasSectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .link").click(function () {
//         closeHavanasSelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.havanas").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.havanas .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.havanas .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.havanas').css("height", "100%");
//         });
//     });

//     function closeContemporarySelector() {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });
//     }
//     function closeContemporarySectionModels() {
//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-contemporary").click(function () {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .close-btn").click(function () {
//         closeContemporarySelector();
//     });

//     $("#vintageCelebrationPage .section-models.contemporary .close-btn").click(function () {
//         closeContemporarySectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .link").click(function () {
//         closeContemporarySelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.contemporary").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.contemporary .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.contemporary .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.contemporary').css("height", "100%");
//         });
//     });


//     //control video autoplay
//     var iframe_desktop = document.querySelector('#player_1');
//     var player_desktop = null;

//     if (iframe_desktop != null) {
//         player_desktop = new Vimeo.Player(iframe_desktop);
//     }

//     var iframe_mobile = document.querySelector('#player_2');
//     var player_mobile = null;

//     if (iframe_mobile != null) {
//         player_mobile = new Vimeo.Player(iframe_mobile);
//     }

//     //check window width
//     //    console.log("window width: "+$(window).width());
//     if ($(window).width() > 930 && player_desktop != null && player_mobile != null) {
//         player_desktop.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     } else if (player_desktop != null && player_mobile != null) {
//         player_desktop.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     }
// });

// // Calligrapher page ///////////////////////////////////////////////////////////////////////////////////////////////
// $("calligrapherEditionPage").ready(function () {
//     $(".scrollCalligrapher").click(function (event) {
//         // console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $(".mainVideo").click(function (event) {
//         event.preventDefault();
//         $(".mainVideo .playVideo").hide();
//         $(".mainVideo #play-button-video1").hide();

//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });

//     $(".interviewVideo").click(function (event) {
//         event.preventDefault();
//         $(".interviewVideo .playVideo2").hide();
//         $(".interviewVideo #play-button-video2").hide();

//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });
// });

// // Galleria900 scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $(document).ready(function () {

//     var owl = $('#galleria900Page .owl-carousel');
//     var currentFrame = 0;
//     var movedWithSlide = true;

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         addClassActive: true,
//         afterMove: function () {
//             currentFrame = $(".owl-item.active .item").attr("data-slide-index");
//             updatePager();
//         }
//     });

//     function updatePager() {
//         $(".pager .item a").each(function () {
//             var itemIndex = $(this).attr("data-slide-index");
//             if (itemIndex == currentFrame) {
//                 $(this).children(".photo").removeClass("hidden");
//                 $(this).children(".point").removeClass("hidden");
//             } else {
//                 $(this).children(".photo").addClass("hidden");
//                 $(this).children(".point").addClass("hidden");
//             }
//         });
//     }

//     // Go to the next item
//     $('#galleria900Page #carousel-button-prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#galleria900Page #carousel-button-next').click(function () {
//         owl.trigger('owl.next');
//     });

//     $(".pager .item a").click(function () {
//         currentFrame = $(this).attr("data-slide-index");
//         owl.trigger("owl.goTo", currentFrame);
//         updatePager();
//     });

// });

// //Icons Collection Page Scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPage").ready(function () {
//     $('#iconsPage .but').bind("mouseenter", function () {

//         var i = $(this);

//         $('.but').removeClass('fullopt').addClass('halfopt');
//         $('.boxtitle').css('visibility', 'hidden');
//         $('.boxlink').css('visibility', 'hidden');
//         i.removeClass('halfopt').addClass('fullopt');
//         i.prev().css('visibility', 'visible');
//         i.next().css('visibility', 'visible');

//         var bgmodel = $(this).find('img').attr('alt');
//         var bg = 'bg_' + bgmodel;
//         $('#deficons_header').hide().removeClass().addClass(bg).show();
//     });
// });

// // Typewriter Subpages Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#typewriterEditionPage").ready(function () {
//     var owl = $('#typewriterEditionPage .owl-carousel');

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         addClassActive: true,
//         singleItem: true
//     });

//     // Go to the next item
//     $('#typewriterEditionPage #slide_prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#typewriterEditionPage #slide_next').click(function () {
//         owl.trigger('owl.next');
//     });

//     // Pager
//     $('#typewriterEditionPage .custom-pager .point').click(function () {
//         var currentFrame = $(this).attr("item-pos");
//         owl.trigger("owl.goTo", currentFrame);
//     });

// });

// // Reflex Edition Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#reflexEditionPage").ready(function () {

//     var reflexDelay = 500;
//     var currentOption = 0;

//     $('#reflexEditionPage .up').click(function () {
//         var aTag = $("a[name='gale']");
//         $('html,body').animate({
//             scrollTop: aTag.offset().top
//         }, 'slow');
//     });

//     $("#reflexEditionPage a").mouseover(function () {
//         $("li img").removeAttr("title");
//     });

//     $('#reflexEditionPage .bxslider').bxSlider({
//         captions: true,
//         minSlides: 1,
//         maxSlides: 4,
//         slideWidth: 230,
//         slideMargin: 5,
//         auto: true,
//         infiniteLoop: false,
//         pager: false
//     });

//     function setActiveModel(model) {
//         //mark selected button
//         $("#reflexEditionPage .buttons-container div").removeClass("selected");
//         $("#reflexEditionPage .buttons-container div").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).addClass("selected");
//             }
//         });

//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     }

//     $('#reflexEditionPage .sunBut').click(function () {
//         if (currentOption != 1) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").show();
//                     $("#reflexEditionPage .reflex-glass-details.optical").hide();
//                     setActiveModel("PO3046S");
//                     openProduct("");
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').next().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').next().removeClass('activeMenu');
//             }
//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 1;
//         }
//     });

//     $('#reflexEditionPage .optiBut').click(function () {
//         if (currentOption != 2) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 //select first item
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").hide();
//                     $("#reflexEditionPage .reflex-glass-details.optical").show();
//                     setActiveModel("PO3046V");
//                     openProduct();
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').prev().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').prev().removeClass('activeMenu');
//             }

//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 2;
//         }
//     });

//     $('#reflexEditionPage .modelContainer .buttons-container div').click(function () {
//         //mark selected button
//         $("#reflexEditionPage .modelContainer .buttons-container div").removeClass("selected");
//         $(this).addClass("selected");

//         //show selected model
//         var modelNum = $(this).attr("data-name");

//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     });

//     $(window).resize(function () {
//         if (currentOption > 0) {
//             var altura = $(".reflex-glass-details").height();
//             $("#reflex-glass-details-container").height(altura);
//         }
//     });

//     function openProduct() {
//         var altura = $(".reflex-glass-details").height();
//         //console.log("Altura: "+altura)
//         $('#reflex-glass-details-container').animate({
//             opacity: 1,
//             height: "" + altura + "px"
//         }, reflexDelay, function () { });

//         //        $('#reflex-glass-details').animate({
//         //            opacity: 1,
//         //            height: ""+altura+"px"
//         //        }, reflexDelay, function() {});
//     }

//     function closeProduct() {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");
//     }

//     $('#reflexEditionPage #closebtn').click(function () {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");

//         $('#reflexEditionPage #bullets-mobile').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () {
//             $('#reflexEditionPage #bullets-mobile').addClass("hidden");
//         });

//         currentOption = 0;
//     });

//     $("#reflexEditionPage #bullet_1").hover(function () {
//         $("#reflexEditionPage #tip_01").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_01").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_2").hover(function () {
//         $("#reflexEditionPage #tip_02").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_02").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_3").hover(function () {
//         $("#reflexEditionPage #tip_03").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_03").addClass("hidden");
//     });

//     /* Gallery */
//     $('#reflexEditionPage .showgallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'none') {
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'none');
//             $('#reflex-gallery-container').css('display', 'block');
//             var aTag = $("a[name='gale']");
//             //          $('html,body').animate({
//             //              scrollTop: aTag.offset().top
//             //          }, 'slow');
//         }

//         $.ajax({
//             url: "http://www.persol.com/international/reflex-edition/gallery",
//             type: "POST",
//             success: function (data) {
//                 //Debug code BEGIN
//                 var a = convertDataToAbsolute(data);
//                 // console.log(a);
//                 //Debug code END
//                 $("#galleryContent").html(convertDataToAbsolute(data));
//             }
//         });
//     });

//     $('#reflexEditionPage .hidegallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'block') {
//             $('#reflex-gallery-container').css('display', 'none');
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'block');
//             $("#galleryContent").html('');
//             $('#dvnlcontDetail').remove();
//         }
//     });


// });

// // History Page Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// var slider = null;
// $("#historyPage").ready(function () {

//     /*Slideshow*/
//     slider = $('#historyPage .bxslider').bxSlider({
//         mode: 'fade',
//         captions: true,
//         auto: true,
//         //tickerHover: true,
//         pause: 10000,
//         pagerCustom: '#bx-pager',
//         onSlideNext: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlidePrev: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlideAfter: function (obj, oldindex, newindex) {
//             var degrees = 0;
//             var revdegrees = 0;
//             switch (newindex) {
//                 /*17-30*/
//                 case 0:
//                     degrees = 0;
//                     rotateArrow(8);
//                     break;
//                 case 1:
//                     degrees = 4;
//                     break;
//                 case 2:
//                     degrees = 8;
//                     break;
//                 case 3:
//                     degrees = 12;
//                     break;
//                 case 4:
//                     degrees = 16;
//                     break;
//                 case 5:
//                     degrees = 20;
//                     break;
//                 case 6:
//                     degrees = 24;
//                     break;
//                 /*30-50*/
//                 case 7:
//                     degrees = 36;
//                     rotateArrow(45);
//                     break;
//                 case 8:
//                     degrees = 40;
//                     break;
//                 case 9:
//                     degrees = 44;
//                     break;
//                 case 10:
//                     degrees = 48;
//                     break;
//                 case 11:
//                     degrees = 52;
//                     break;
//                 case 12:
//                     degrees = 56;
//                     break;
//                 /*50-70*/
//                 case 13:
//                     degrees = 67;
//                     rotateArrow(82);
//                     break;
//                 case 14:
//                     degrees = 71;
//                     break;
//                 case 15:
//                     degrees = 75;
//                     break;
//                 case 16:
//                     degrees = 79;
//                     break;
//                 case 17:
//                     degrees = 83;
//                     break;
//                 /*70-90*/
//                 case 18:
//                     degrees = 103;
//                     rotateArrow(110);
//                     break;
//                 case 19:
//                     degrees = 107;
//                     break;
//                 case 20:
//                     degrees = 111;
//                     break;
//                 case 21:
//                     degrees = 115;
//                     break;
//                 case 22:
//                     degrees = 119;
//                     break;
//                 case 23:
//                     degrees = 123;
//                     break;
//                 /*90-oggi*/
//                 case 24:
//                     degrees = 134;
//                     rotateArrow(147);
//                     break;
//                 case 25:
//                     degrees = 138;
//                     break;
//                 case 26:
//                     degrees = 142;
//                     break;
//                 case 27:
//                     degrees = 146;
//                     break;
//                 case 28:
//                     degrees = 150;
//                     break;
//                 case 29:
//                     degrees = 154;
//                     break;
//                 case 30:
//                     degrees = 159;
//                     break;
//             }
//         }
//     });

//     function rotateArrow(deg) {
//         $('#storia-cerchio').stop().animate(
//             { rotation: deg },
//             {
//                 duration: 500,
//                 step: function (now, fx) {
//                     $(this).css({ 'transform': 'rotate(' + now + 'deg)', 'opacity': '1' });
//                 }
//             }
//         );
//     }

//     /*Slideshow*/
//     $('.goto_1730').click(function () {
//         goto1730();
//         rotateArrow(8);
//         slider.goToSlide(0);
//     });

//     $('.goto_3050').click(function () {
//         goto3050();
//         rotateArrow(45);
//         slider.goToSlide(7);
//     });

//     $('.goto_5070').click(function () {
//         goto5070();
//         rotateArrow(82);
//         slider.goToSlide(13);
//     });

//     $('.goto_7090').click(function () {
//         goto7090();
//         rotateArrow(110);
//         slider.goToSlide(18);
//     });

//     $('.goto_90today').click(function () {
//         goto90oggi();
//         rotateArrow(147);
//         slider.goToSlide(24);
//     });
//     /*Cerchio dinamico*/

//     /*Funzioni cambio temporale*/
//     function goto1730() {

//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_1730) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto1-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/1730-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_1730').html());
//         $('#dyn-excerpt').html($('#html_excerpt_1730').html());
//         $('.anno-big-hero').html($('#anno_big_1730').html());
//         $('.anno-small-hero').html($('#anno_small_1730').html());
//     }

//     function goto3050() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_3050) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto2-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/3050-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_3050').html());
//         $('#dyn-excerpt').html($('#html_excerpt_3050').html());
//         $('.anno-big-hero').html($('#anno_big_3050').html());
//         $('.anno-small-hero').html($('#anno_small_3050').html());
//     }

//     function goto5070() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_5070) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto3-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/5070-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_5070').html());
//         $('#dyn-excerpt').html($('#html_excerpt_5070').html());
//         $('.anno-big-hero').html($('#anno_big_5070').html());
//         $('.anno-small-hero').html($('#anno_small_5070').html());
//     }

//     function goto7090() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_7090) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto4-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/7090-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_7090').html());
//         $('#dyn-excerpt').html($('#html_excerpt_7090').html());
//         $('.anno-big-hero').html($('#anno_big_7090').html());
//         $('.anno-small-hero').html($('#anno_small_7090').html());
//     }

//     function goto90oggi() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_90today) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto5-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/90today-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_90today').html());
//         $('#dyn-excerpt').html($('#html_excerpt_90today').html());
//         $('.anno-big-hero').html($('#anno_big_90today').html());
//         $('.anno-small-hero').html($('#anno_small_90today').html());
//     }
//     /*Funzioni cambio temporale*/

//     /*Funzioni navigazione slideshow e cambio temporale*/
//     function gotoPeriodBySlideIndex(nextindex) {
//         //alert("a");
//         if (nextindex >= 0 && nextindex <= 6) {
//             goto1730();
//         } else if (nextindex >= 7 && nextindex <= 12) {
//             goto3050();
//         } else if (nextindex >= 13 && nextindex <= 17) {
//             goto5070();
//         } else if (nextindex >= 18 && nextindex <= 23) {
//             goto7090();
//         } else {
//             goto90oggi();
//         }
//     }
//     /*Funzioni navigazione slideshow e cambio temporale*/

//     //var wrapper = document.getElementById('cn-wrapper');

//     //
//     $("#historyPage li.goto_1730").click(function () {
//         slider.goToSlide(0);
//         goto1730();
//     });
//     $("#historyPage li.goto_3050").click(function () {
//         slider.goToSlide(7);
//         goto3050();
//     });
//     $("#historyPage li.goto_5070").click(function () {
//         slider.goToSlide(13);
//     });
//     $("#historyPage li.goto_7090").click(function () {
//         slider.goToSlide(18);
//     });
//     $("#historyPage li.goto_90today").click(function () {
//         slider.goToSlide(24);
//     });

// });

// // Icons Series Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsSeriesPage").ready(function () {
//     $("#img_cont_1_m1").click(function () {
//         $("#img_cont_1_m2").removeClass("active-marker");
//         $("#img_cont_1_m1").addClass("active-marker");
//         $("#img_cont_1_img1").fadeIn("slow", function () { });
//         $("#img_cont_1_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_1_m2").click(function () {
//         $("#img_cont_1_m1").removeClass("active-marker");
//         $("#img_cont_1_m2").addClass("active-marker");
//         $("#img_cont_1_img2").fadeIn("slow", function () { });
//         $("#img_cont_1_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m1").click(function () {
//         $("#img_cont_2_m2").removeClass("active-marker");
//         $("#img_cont_2_m1").addClass("active-marker");
//         $("#img_cont_2_img1").fadeIn("slow", function () { });
//         $("#img_cont_2_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m2").click(function () {
//         $("#img_cont_2_m1").removeClass("active-marker");
//         $("#img_cont_2_m2").addClass("active-marker");
//         $("#img_cont_2_img2").fadeIn("slow", function () { });
//         $("#img_cont_2_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m1").click(function () {
//         $("#img_cont_3_m2").removeClass("active-marker");
//         $("#img_cont_3_m1").addClass("active-marker");
//         $("#img_cont_3_img1").fadeIn("slow", function () { });
//         $("#img_cont_3_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m2").click(function () {
//         $("#img_cont_3_m1").removeClass("active-marker");
//         $("#img_cont_3_m2").addClass("active-marker");
//         $("#img_cont_3_img2").fadeIn("slow", function () { });
//         $("#img_cont_3_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m1").click(function () {
//         $("#img_cont_4_m2").removeClass("active-marker");
//         $("#img_cont_4_m1").addClass("active-marker");
//         $("#img_cont_4_img1").fadeIn("slow", function () { });
//         $("#img_cont_4_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m2").click(function () {
//         $("#img_cont_4_m1").removeClass("active-marker");
//         $("#img_cont_4_m2").addClass("active-marker");
//         $("#img_cont_4_img2").fadeIn("slow", function () { });
//         $("#img_cont_4_img1").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.one").click(function () {
//         $(".twin-view-container.one .pager.one").addClass("active-marker");
//         $(".twin-view-container.one .pager.two").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.two").click(function () {
//         $(".twin-view-container.one .pager.two").addClass("active-marker");
//         $(".twin-view-container.one .pager.one").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.one").click(function () {
//         $(".twin-view-container.two .pager.one").addClass("active-marker");
//         $(".twin-view-container.two .pager.two").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.two").click(function () {
//         $(".twin-view-container.two .pager.two").addClass("active-marker");
//         $(".twin-view-container.two .pager.one").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.one").click(function () {
//         $(".twin-view-container.three .pager.one").addClass("active-marker");
//         $(".twin-view-container.three .pager.two").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.two").click(function () {
//         $(".twin-view-container.three .pager.two").addClass("active-marker");
//         $(".twin-view-container.three .pager.one").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.one").fadeOut("slow", function () { });
//     });

//     //Hide on document ready;
//     $(".twin-img.two").hide();


// });

// // Icons 100 Anniversary Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPersol100Page").ready(function () {
//     var sliderDesktop = $('#iconsPersol100Page .bxslider.desktop').bxSlider({
//         minSlides: 2,
//         maxSlides: 2,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     var sliderMobile = $('#iconsPersol100Page .bxslider.mobile').bxSlider({
//         minSlides: 1,
//         maxSlides: 1,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     $("#iconsPersol100Page .bx-next").click(function () {
//         sliderDesktop.goToNextSlide();
//         sliderMobile.goToNextSlide();
//         return false;
//     });

//     $("#iconsPersol100Page .bx-prev").click(function () {
//         sliderDesktop.goToPrevSlide();
//         sliderMobile.goToPrevSlide();
//         return false;
//     });

//     // tagboard.js BEGIN
//     // <script type="text/javascript" src="https://static.tagboard.com/public/js/embed.js"></script>
//     (function (window) {
//         var embedIDs = 1,
//             scrollTimer = -1,
//             previousHeight = {},

//             con = {
//                 log: function (s) { console.log(s); },
//                 warn: function (s) { console.warn ? console.warn(s) : console.log(s); },
//                 error: function (s) { console.error ? console.error(s) : console.log(s); }
//             },
//             tgbDivs = (function () {
//                 var divs = [],
//                     elems = document.getElementsByClassName('tagboard-embed');
//                 for (var i = 0; i < elems.length; ++i) {
//                     if (elems[i].nodeName === 'DIV') {
//                         divs.push(elems[i]);
//                     }
//                 }
//                 return divs;
//             })(),
//             tgbDomain = (window.tagboardOptions && window.tagboardOptions.domain) || window.tagboardDomain || "https://embeds.tagboard.com" || "http://localhost",

//             pageScrolled = function _pageScrolled() {
//                 if (scrollTimer != -1) {
//                     clearTimeout(scrollTimer);
//                 }

//                 scrollTimer = window.setTimeout(scrollFinished, 50);
//             },

//             execForFrames = function _execForFrame(func, frame_id) {
//                 // Optional frame_id to run for specific embed frame
//                 var iframes = document.getElementsByClassName('tagboard-iframe');
//                 for (var i = 0; i < iframes.length; ++i) {
//                     var ifrm = iframes[i],
//                         match = ifrm.getAttribute('tgb-frame-id') == frame_id;
//                     if (ifrm.tagName.toLowerCase() === 'iframe' && (!frame_id || match)) {
//                         func(ifrm);
//                         if (frame_id) {
//                             return;
//                         }
//                     }
//                 }
//             },

//             scrollFinished = function _scrollFinished(frame_id) {
//                 execForFrames(function (ifrm) {
//                     var divYOffset = 0;

//                     for (var element = ifrm; element != null; element = element.offsetParent) {
//                         divYOffset += element.offsetTop;
//                     }

//                     ifrm.contentWindow.postMessage('scrollPos:' + Math.max(0, window.pageYOffset - divYOffset), tgbDomain);
//                 }, frame_id);
//             },

//             setFrameHeight = function _setFrameHeight(height, frame_id) {
//                 execForFrames(function (ifrm) {
//                     if (ifrm.getAttribute('fixed-height') != 1) {
//                         var prev = parseInt(ifrm.style.height, 10),
//                             newHeight = height,
//                             event = document.createEvent("CustomEvent");

//                         if (height < prev && previousHeight[frame_id] !== height) { newHeight = prev; }

//                         ifrm.style.height = newHeight + "px";

//                         // Fire off event only if height has changed
//                         if (previousHeight[frame_id] !== height) {
//                             event.initCustomEvent("tgb.embedHeight", true, true, { height: height, iframe: ifrm }); // Because IE
//                             window.dispatchEvent(event);
//                         }

//                         previousHeight[frame_id] = height;
//                     }
//                 }, frame_id);
//             },

//             tagboardAuthWindow,
//             authRequested = function _authRequested(network, doConnect) {
//                 var top = (window.innerHeight / 2) - 300;
//                 left = (window.innerWidth / 2) - 400,
//                     authUrl = tgbDomain + "/u/auth_child?network=" + network + "&connect=" + (doConnect ? "1" : "");
//                 tagboardAuthWindow = window.open(authUrl, "tgbauthwin", "width=800,height=600,resizable=1,location=1,top=" + top + ",left=" + left);
//                 // check for window open fail - i.e. pop-up blocker doing it's thing
//                 if (!tagboardAuthWindow) {
//                     return window.tagboardAuthComplete(false, "The sign-in window was blocked due to a popup blocker. Please allow it to be opened and try again.");
//                 }

//                 function checkChild() {
//                     if (tagboardAuthWindow.closed) {
//                         return window.tagboardAuthComplete(true);
//                     }
//                     setTimeout(checkChild, 500);
//                 }

//                 checkChild();
//             },

//             insertIFrame = function _insertIFrame(div, options) {
//                 var opts = [],
//                     embedID = embedIDs++;

//                 if (options.mobilePostCount) { opts.push('mpc=' + options.mobilePostCount); }
//                 if (options.postCount) { opts.push('pc=' + options.postCount); }
//                 if (options.darkMode) { opts.push('dm=' + !!options.darkMode); }
//                 if (options.autoLoad) { opts.push('al=' + !!options.autoLoad); }
//                 if (options.inlineMedia) { opts.push('im=' + !!options.inlineMedia); }
//                 if (options.moderate) { opts.push('md=' + !!options.moderate); }

//                 opts.push('id=' + embedID);
//                 opts.push('ver=' + options.version);
//                 opts = '#' + opts.join('&');

//                 var ifrm = document.createElement("IFRAME");
//                 ifrm.setAttribute("src", tgbDomain + "/" + options.tagboard + "/embed" + opts);
//                 ifrm.setAttribute("onload", "tagboardQueryHeight(" + embedID + ")");
//                 if (options.version < 3) { ifrm.id = "tagboard-iframe"; iframe = ifrm; }
//                 ifrm.setAttribute("class", "tagboard-iframe");
//                 ifrm.setAttribute("tgb-frame-id", embedID);
//                 ifrm.name = "tagboard";
//                 ifrm.setAttribute("style", "border:0; width:100%;");
//                 ifrm.setAttribute("title", "Tagboard Social Content Web Display");
//                 if (options.fixedHeight) {
//                     ifrm.setAttribute("fixed-height", "1");
//                     ifrm.style.height = "100%";
//                 } else {
//                     ifrm.style.height = "600px"; // Default initial height
//                     ifrm.setAttribute("scrolling", "no");
//                 }
//                 div.appendChild(ifrm);
//             },

//             handleFrameMessage = function _handleFrameMessage(e) {
//                 if (e.origin == tgbDomain) {
//                     var dataObj = {};
//                     e.data.split('&').forEach(function (e) {
//                         var d = e.split(':');
//                         dataObj[d[0]] = d.length > 1 ? d[1] : d[0];
//                     });

//                     if (dataObj.height) {
//                         setFrameHeight(parseInt(dataObj.height), dataObj.frame_id);
//                     }

//                     if (dataObj.auth) {
//                         authRequested(dataObj.auth, dataObj.frame_id);
//                     }
//                     if (e.data.indexOf('tgbRemoveIframe') === 0) {
//                         var id = e.data.substr(e.data.indexOf(':') + 1);
//                         var element = document.querySelector("iframe[tgb-frame-id='" + id + "']");
//                         element.parentNode.removeChild(element);
//                     }
//                 }
//             };

//         if ((window.tagboard && typeof window.tagboard === 'string') || (window.tagboardOptions && window.tagboardOptions.tagboard)) {
//             var tagboardOptions = window.tagboardOptions || {};
//             tagboardOptions.tagboard = tagboardOptions.tagboard || window.tagboard;

//             if (window.tagboard) {
//                 tagboardOptions.version = 1;
//                 con.error("Using deprecated version of Tagboard embed. Update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             } else {
//                 tagboardOptions.version = 2;
//                 con.warn("Using an out-of-date version of Tagboard embed. Please update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             }

//             try {
//                 insertIFrame(document.getElementById("tagboard-embed"), tagboardOptions);
//             } catch (e) {
//                 con.error("Exception generating iFrame for tagboard embed: ", e);
//                 return;
//             }
//         } else if (tgbDivs.length > 0) {
//             tgbDivs.forEach(function (div) {
//                 var options = {
//                     tagboard: div.getAttribute('tgb-slug'),
//                     version: 3,
//                     mobilePostCount: div.getAttribute('tgb-mobile-count'),
//                     postCount: div.getAttribute('tgb-post-count'),
//                     darkMode: div.getAttribute('tgb-dark-mode') === 'true',
//                     autoLoad: div.getAttribute('tgb-auto-load') === 'true',
//                     fixedHeight: div.getAttribute('tgb-fixed-height') === 'true',
//                     inlineMedia: div.getAttribute('tgb-inline-media') === 'true',
//                     moderate: div.getAttribute('tgb-mod') === 'true'
//                 };
//                 if (options.tagboard && !div.getAttribute('tgb-built-iframe')) {
//                     insertIFrame(div, options);
//                     div.setAttribute('tgb-built-iframe', "1");
//                 }
//             });
//         } else {
//             //con.error("Tagboard script expected DIV with class: 'tagboard-embed'");
//             return;
//         }

//         window.tagboardQueryHeight = function queryHeight(frame_id) {
//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage('height?', tgbDomain);
//                 scrollFinished(frame_id);
//             }, frame_id);
//         };

//         window.tagboardAuthComplete = function _tagboardAuthComplete(success, failMessage) {
//             var authMessage = ["authComplete", success ? "1" : "", failMessage].join(":");
//             // close the auth child window
//             tagboardAuthWindow && typeof tagboardAuthWindow.close === "function" && tagboardAuthWindow.close();
//             // notify the embed of the auth status

//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage(authMessage, tgbDomain);
//             });
//         };

//         window.handleFrameMessage = handleFrameMessage;
//         window.pageScrolled = pageScrolled;

//         window.addEventListener('message', window.handleFrameMessage, false);
//         window.addEventListener('scroll', window.pageScrolled, false);

//         if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
//             window.addEventListener('resize', function () {
//                 execForFrames(function (ifrm) {
//                     ifrm.style.width = ifrm.parentNode.clientWidth + "px";
//                     setTimeout(function () { ifrm.style.width = "100%"; }, 2500);
//                 });
//             }, true);
//         }

//     })(window);
//     // tagboard.js END

//     $('#iconsPersol100Page .butOpen').click(function () {
//         $(this).hide();
//         $('.butClose').show();
//         $(".persol100_reg").show();
//     });

//     $('#iconsPersol100Page .butClose').click(function () {
//         $(this).hide();
//         $('.butOpen').show();
//         $(".persol100_reg").hide();
//     });


//     $('#iconsPersol100Page .play-button, .playVideo').click(function () {
//         $(this).siblings("#player_1").attr('src', $(this).siblings("iframe").attr('src') + '?autoplay=1');
//         $('.play-button, .playVideo').css("display", "none");
//     });

// });

// $("#iconsNewGenerationPage").ready(function () {

//     ! function (d, s, id) {
//         var js, fjs = d.getElementsByTagName(s)[0];
//         if (!d.getElementById(id)) {
//             js = d.createElement(s);
//             js.id = id;
//             js.src = "https://platform.twitter.com/widgets.js";
//             fjs.parentNode.insertBefore(js, fjs);
//         }
//     }(document, "script", "twitter-wjs");

//     // Owl carousel 3D
//     var owl3d = $(".owl-carousel-container-3d .owl-carousel").owlCarousel({
//         /* Not working with current owl carousel version (embedded in WCS).
//          * Needs animate.css (https://daneden.github.io/animate.css/)

//         animateOut: 'slideOutDown',
//         animateIn: 'flipInX',*/
//         loop: true,
//         margin: 10,
//         nav: true,
//         responsive: false,
//         items: 1,
//         singleItem: true
//     });

//     // Go to the next item
//     $('.owl-carousel-container-3d #slide_prev').click(function () {
//         owl3d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-3d #slide_next').click(function () {
//         owl3d.trigger('owl.next');
//     });

//     // Owl carousel 2D
//     var owl2d = $(".owl-carousel-container-2d .owl-carousel").owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         /*singleItem: true*/
//         responsive: false,
//         items: 2
//     });

//     // Go to the next item
//     $('.owl-carousel-container-2d #slide_prev').click(function () {
//         owl2d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-2d #slide_next').click(function () {
//         owl2d.trigger('owl.next');
//     });

//     //Slider1 mobile
//     var owlCarousel1m = $('#iconsNewGenerationPage .owl-carousel1m');

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev1m').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next1m').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });

//     //Slider2 mobile
//     var owlCarousel2m = $('#iconsNewGenerationPage .owl-carousel2m');

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev2m').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next2m').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });




//     $('#iconsNewGenerationPage .play-button').click(function (ev) {
//         $("#video")[0].src += "&autoplay=1";
//         $(this).fadeOut('fast');
//         ev.preventDefault();
//     });
//     $('#iconsNewGenerationPage .play-button2').on('click', function (ev) {
//         $("#video2")[0].src += "&autoplay=1";
//         ev.preventDefault();
//         $(this).fadeOut('fast');
//     });

//     $("#iconsNewGenerationPage .scroll").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

// });

// //Technology Scripts //////////////////////////////////////////////////////////////////////////////////////////////
// $("#technology").ready(function () {
//     var techVideo = document.getElementById("techVideo");
//     var owlTech = $('#technology .owl-carousel');

//     owlTech.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         autoPlay: 5000,
//         stopOnHover: true
//     });

//     // Go to the next item
//     $('#technology .carousel-prev').click(function () {
//         owlTech.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#technology .carousel-next').click(function () {
//         owlTech.trigger('owl.next');
//     });


//     $("#techVideo").bind("ended", function () {
//         $(this).addClass("play-button");
//         $(this).removeClass("pause-button");
//     });

//     $(".play-pause-button").click(function () {
//         if (techVideo.paused) {
//             techVideo.play();
//             $(this).removeClass("play-button");
//             $(this).addClass("pause-button");
//         } else {
//             techVideo.pause();
//             $(this).addClass("play-button");
//             $(this).removeClass("pause-button");
//         }
//     });

//     $(".video-container").hover(
//         function () {
//             $(".play-pause-button").fadeIn("slow");
//         }, function () {
//             $(".play-pause-button").fadeOut("slow");
//         });

// });

// // SteveMcQueen Scripts ///////////////////////////////////////////////////////////////////////////////////////////////////////
// $("#McQueenPage").ready(function () {
//     var owlCarousel1 = $('#McQueenPage #owl-carousel1');
//     var owlCarousel2 = $('#McQueenPage #owl-carousel2');
//     var owlCarousel3 = $('#McQueenPage #owl-carousel3');
//     var owlCarousel1m = $('#McQueenPage #owl-carousel1m');
//     var owlCarousel2m = $('#McQueenPage #owl-carousel2m');
//     var owlCarousel3m = $('#McQueenPage #owl-carousel3m');

//     owlCarousel1.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#McQueenPage .carousel-container1 .carousel-prev').click(function () {
//         owlCarousel1.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1 .carousel-next').click(function () {
//         owlCarousel1.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2 .carousel-prev').click(function () {
//         owlCarousel2.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2 .carousel-next').click(function () {
//         owlCarousel2.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3 .carousel-prev').click(function () {
//         owlCarousel3.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3 .carousel-next').click(function () {
//         owlCarousel3.trigger('owl.next');
//     });

//     //MOBILE
//     // Go to the next item
//     $('#McQueenPage .carousel-container1m .carousel-prev').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1m .carousel-next').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2m .carousel-prev').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2m .carousel-next').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3m .carousel-prev').click(function () {
//         owlCarousel3m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3m .carousel-next').click(function () {
//         owlCarousel3m.trigger('owl.next');
//     });

//     // steve2017.js
//     var box_360_clicked = false;
//     var box_360_pos = 0;
//     var giftimer = null;
//     var gifcount = 1;

//     $('.area .bullet').mouseenter(function () {
//         $(this).stop(true, false).animate({ 'opacity': 0 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeIn(200);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         $(this).stop(true, false).animate({ 'opacity': 1 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeOut(200);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     }).click(function () {
//         $('.menu .menu_' + $(this).attr('rel')).click();
//     });
//     var prevFocusedElement;
//     $('.menu a').click(function () {
//         var menuIndex= $(this).attr("rel");
//         prevFocusedElement=this;
//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($("details"));


//         $(this).addClass('sel').siblings().removeClass('sel');
//         $('.area .popup_' + $(this).attr('rel')).fadeIn(500, function () {
//             if ($(this).hasClass('popup_2')) {
//                 giftimer = setInterval(function () {
//                     var left = -gifcount * 449 - 120;
//                     document.getElementById("gif-img").style.backgroundPosition = left + "px 0px";
//                     gifcount = gifcount >= 5 ? 0 : gifcount + 1;
//                 }, 2000);
//             }
//         }).siblings('.popup').fadeOut();


//         // $("popup"+menuIndex).addClass("focus");
//         $("#popup"+menuIndex).focus();


//     }).mouseenter(function () {
//         pos = $(this).attr('rel');
//         $('.area .bullet_' + pos).stop(true, false).animate({ 'opacity': 0 }, 300);
//         $('.area .detail_' + pos).stop(true, false).fadeIn(300);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         lev = $(this).attr('rel');
//         $('.bullet_' + lev).show().animate({ 'opacity': 1 }, 300);
//         $('.area .detail_' + lev).stop(true, false).fadeOut(300);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     });



//     $('.popup .close').click(function () {
//         var menuIndex= $(this).attr("rel");

//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($(".details"));


//         clearInterval(giftimer);
//         $('.menu a').removeClass('sel');
//         $(this).parent().fadeOut();
//         if(this.parentElement.parentElement && $(this.parentElement.parentElement).hasClass('activated-perks')){
            
//         }else{
//             prevFocusedElement.focus();
//         }
        


//     });

//     $('.product_360 .move').mousemove(function (e) {
//         if (box_360_clicked) {
//             frameid = Math.round((e.clientX - box_360_pos.left) * 12 / 520);
//             $('#frame_360_' + frameid).show().siblings('.frame').hide();
//         }
//     });


//     $('.next').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.hasClass('last')) { $('.frame').first().show(); }
//         if ($visible.next().length) $visible.hide().next().show();
//         else {
//             $visible.hide();
//             $('.frame').first().show();
//         }
//     });

//     $('.prev').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.prev().length) $visible.hide().prev().show();
//         else {
//             $visible.hide();
//             $('.frame').last().show();
//         }
//     });
// });

// function switch360Left() {
//     $('.product_360 .frame').hide().eq(2).show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();

//         setTimeout(function () {

//             $('.product_360 .loading').fadeOut();

//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switch360Right() {
//     $('.product_360 .frame').hide().first().show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();
//         setTimeout(function () {
//             $('.product_360 .loading').fadeOut();
//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switchBack() {
//     $('.product_360').fadeOut();
//     $(' .area .details .bullet, .area .detail, .link_360left, .link_360right').fadeIn();
// }


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$("#customerCarePage").ready(function () {
  $("#faqs dd").hide();
  $("#faqs dt").click(function () {
      $(this)
          .next("#faqs dd")
          .slideToggle(500);
      $(this)
          .toggleClass("expanded");
  });
});


// HB-1028 BEGIN Restore all loadingInternal buttons to its initial state
function showLoadingInternal(hide, id) {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}

function disableButton(id) {
  console.log("PSL::LEGACY::disableButton function invoked");
}

function enableButton(id) {
  console.log("PSL::LEGACY::enableButton function invoked");
}

function restoreLoadingInternalButtons() {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}
// HB-1028 END


/**
* This functions validates payment form input fields and legal terms checkbox to continue checkout
* @param payType Currently, possible values are 'cc' for Credit Card and 'paypal' for Paypal
* Related files: PersolSAS\Snippets\EDP\PaymentMethods\StandardVisa.jsp
*/
function makePayment(payType) {
  var error = false;
  var cardType;

  if (payType == 'cc') {
      var validCardNumber = $.payment.validateCardNumber($('#account1_1').val());

      //if not valid card number...
      if ($("#account1_1").val().length == 0 || !validCardNumber) {
          $("#account1_1").addClass("field-error-message");
          $('#account1_1').parent().addClass("isNotValid");
          $('#emptyCreditCard').css('display','inline-block');
          //tealiumPushFormError($('#emptyCreditCard').html());
          var message = $('#emptyCreditCard').html();
          newTealiumPushFormError(message,message);
          error = true;
      } else {
        cardType = GetCardType($("#account1_1").val());
          $("#account1_1").removeClass("field-error-message");
          $('#emptyCreditCard').css('display', 'none');
      }

      //if name on card number...
      if ($('#cc_nameoncard_1').val().trim().length == 0) {
          $('#cc_nameoncard_1').addClass("field-error-message");
          $('#cc_nameoncard_1').parent().addClass("isNotValid");
          $('#emptyNameCard').css('display','inline-block');
          var message = $('#emptyNameCard').html();
          newTealiumPushFormError(message,message);
          error=true;
      } else {
          $('#cc_nameoncard_1').removeClass("field-error-message");
          $('#emptyNameCard').css('display', 'none');
      }

      //if Month select box empty...
      var monthError, yearError;
      if ($('#expire_month_1').val() == undefined || $('#expire_month_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_month_1').addClass("field-error-message");
          $('#expire_month_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          monthError = true;
      } else {
          monthError = false;
          $('#expire_month_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if Year select box empty...
      if ($('#expire_year_1').val() == undefined || $('#expire_year_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_year_1').addClass("field-error-message");
          $('#expire_year_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          yearError = true;
      } else {
          yearError = false;
          $('#expire_year_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if CVV empty...
      var cvvErrors = 0;
      if( $('#cc_cvc_1').val().trim().length == 0 ){
          $('#emptyCVV').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message =$('#emptyCVV').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {
          $('#emptyCVV').css('display', 'none');
      }

      if (cvvErrors == 0 && !matchCreditCardCVV($("#account1_1").val(), $('#cc_cvc_1').val().trim())){
          $('#wrongCVVLength').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message = $('#wrongCVVLength').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {

          $('#wrongCVVLength').css('display', 'none');
      }
      if (cvvErrors > 0) {
          $('#cc_cvc_1').addClass("field-error-message");
      } else {
          $('#cc_cvc_1').removeClass("field-error-message");
      }
  }

  if ($('.card-info--wrapper--terms--input').length > 0) {
      if ($('.card-info--wrapper--terms--input')[0].checked == false) {
          $('.card-info--wrapper--terms--alert').css('display','inline-block');
          $('.card-info--wrapper--terms--input').closest("div").addClass("field-error-message");
          error = true;
      } else {
          $('.card-info--wrapper--terms--input').closest("div").removeClass("field-error-message");
          $('.card-info--wrapper--terms--alert').css('display', 'none');
      }
  }

    if ($('.pres-checkout__input').length > 0) {
    	if(storeDirectory=="PersolUK" || storeDirectory=="PersolUS" || storeDirectory=="PersolDE"){
    		if ($('#pres-checkout__input').prop('checked') === false) {
	            //            $('.card-info--wrapper--terms--alert').css('display','inline-block');
	            $('.pres-checkout__input').closest("div").addClass("pres-checkout__error--show");
	            error = true;
	        } else {
	            $('.pres-checkout__input').closest("div").removeClass("pres-checkout__error--show");
	            //            $('.card-info--wrapper--terms--alert').css('display','none');
	        }
    	}
    }
    if (countPrescription > 1) {
        $(".prescription__wrapper-error-msg").show();
        $("html, body").animate({ scrollTop: 0 }, 500);
        error = true;
    }

  // If telephone1 empty ...
  var telephoneNumber = $('#telephone1').text().trim();
  if (!MessageHelper.isValidUTF8length(telephoneNumber, 32) || !MessageHelper.IsValidPhone(telephoneNumber)) {
      error = true;
      MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_INVALIDTELEPHONE"]);
  }

  if (error) {
	  removeCheckoutLoader();
      restoreAjaxButtons();
      moveToError();
      setTimeout(removeCheckoutLoader, 250);
  } else  {
      try {
          var paymentForm = document.getElementById('PaymentForm1');

          if (payType == 'cc') {
              setCurrentId('shippingBillingPageNext');

              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Cybersource" />');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep(cardType);
              CheckoutPayments.processCheckout('PaymentForm');


          } else if (payType == 'paypal') {
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="PayPal" />');
              $(paymentForm).find('input[name="customerWebId"]').val(window.forterWebId);
              $(paymentForm).find('input[name="customerIPAddress"]').val(window.ipaddress);
              $(paymentForm).find('input[name="forterToken"]').val(window.forterToken);
              setCurrentId('shippingBillingPageNext');
              //The event should not be triggered on the click, it should be triggered when the user is going to be redirected to the payment gateway
              tealiumPushCheckoutStep('PayPal');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'affirm'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Affirm" />');
              $(paymentForm).attr('action', 'AffirmForwardCmd');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep('Affirm');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'klarna'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep("Klarna");

              // Call Klarna Credit authorize and retrieve authorization_token
              Klarna.Credit.authorize({}, function (res) {
                  var auth_token = res["authorization_token"];
                  var isApproved = res["approved"];
                  var show_form = res["show_form"];
                  if (!auth_token || auth_token.length == 0 || !isApproved || isApproved.length == 0) {
                      if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                          MessageHelper.displayErrorMessage("Beim Autorisieren der Klarna-Zahlung ist ein Fehler aufgetreten.");
                      } else{
                          MessageHelper.displayErrorMessage("There was an error with Authorize Klarna Payment.");
                      }
                      setTimeout(removeCheckoutLoader, 250);
                  } else {
                      // Note: we need to pass the token store in auth_token to authorize against it.
                      $(paymentForm).append('<input type="hidden" name="payMethodId" value="Klarna" />');
                      $(paymentForm).append('<input type="hidden" name="checkout_token" value="' + auth_token + '" />');
                      $(paymentForm).attr('action', 'KlarnaReturnCmd');
                      document.getElementById('PaymentForm1').submit();
                  }
              });

          } else {
              console.log("PSL :: Unknown Payment Method = " + payType);
          }
      } catch (e) {
          console.error("Error in makePayment:",e);
          setTimeout(removeCheckoutLoader, 250);
      }
  }
}

$(document).ready(function() {
	//setCidCookie
	if(getUrlParam("cid") != undefined){
        var cidCookieValue = getUrlParam("cid");
        const d = new Date();
        d.setTime(d.getTime() + (28*24*60*60*1000)); //cookie 28 days
        var expires = "expires="+ d.toUTCString();
        document.cookie = "X_WC_CID=" + cidCookieValue + ";" + expires + ";path=/"
        
    }
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }

  //Search Optimization -- Init search Panel
  if (typeof fn_InitSearchPanel == 'function') {
    fn_InitSearchPanel();
}



});
$(window).resize(function() {
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }
});

// Contact Us page START ///////////////////////////////////////////////////////////////////////////////////////////////
$("ContactUsPage").ready(function() {
	
	if($('#contactus-form_EMEA').length > 0){
		manageEMEAForm();
	}else{
		manageOldForm();
	}
	
});

function validateOnlyNumberContactForm(field){
	if($(field).attr('id') == 'ContactUsForm_User_Phone'){
		$('#errorPhone .contact-us-form__error-msg').hide();
	}else{
		$(field).parent().parent().find(".error-message--form .contact-us-form__error-msg").hide();
	}
	
	phone = trim(field.value);
	var isValid = true;
    var digits = "0123456789";
    var digitsCount = 0;
    var validCharsRegexp = /^-?\d+\.?\d*$/;

    for (var i = 0; i < phone.length; i++) {
        if (digits.includes(phone[i])){
            digitsCount++;
        }
    }

    if ((digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp) == null) && phone.length != 0){
        isValid = false;
    }

    if(!isValid){
    	var errorToPlace;
        var errorMessagge = "";
        if(field.id=="ContactUsForm_User_Phone"){
        	errorMessagge = $("#error_phoneNumber").attr('value');
        	errorToPlace = $('#errorPhone');
        }else if(field.id=="ContactUsForm_User_OrderNumber"){
        	errorMessagge = $("#error_order").attr('value');
        	errorToPlace = $(field).parent().parent().find(".error-message--form");
        }
    	errorToPlace ? createErrorContactUsEmea((errorToPlace), errorMessagge) : '';
		error = true;
    }
    return isValid;
}


function validateEmailFormFieldContactForm (formField) {
	var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,3})$/;
	$('#errorEmail .contact-us-form__error-msg').hide();
	var formFieldValue = trim(formField.value);
    var isEmpty = formFieldValue == "";
	var isValid = true;
		
	if (isEmpty || !emailRegexp.test(formFieldValue)) {
		errorToPlace = document.querySelector("#errorEmail");
	    errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
		error = true;
		isValid = false;
	} 
	return isValid;
}

function manageEMEAForm(){
	/**
	*  Mattia A.M. CSE Project
	*/
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");
	//Fill list of phone number;
	var urlFillPhonePrefix  = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_list';
	
	$.ajax({
        url: urlFillPhonePrefix,
        dataType: "json"}
    ).then(function(phoneList){
    	for(var i = 0; i < phoneList.countries.length; i++){
    		$('#containerPhoneNumber .select-items').append('<div class="listReason" id="'+ phoneList.countries[i].callingCode +'"><span>'+  phoneList.countries[i].displayName+'</span><span>'+ phoneList.countries[i].callingCode +'</span></div>')
    		if((WCParamJS.countryCode === phoneList.countries[i].code) || (WCParamJS.countryCode == 'UK' && phoneList.countries[i].code == 'GB')){
    			$('#prefixNumber').html(phoneList.countries[i].callingCode); 
    			$('#prefixNumber').attr('value', phoneList.countries[i].callingCode);
    		}
    	}
    	$('#containerPhoneNumber .listReason').on('click', function(){
    		$('#prefixNumber').html($(this).attr('id')); 
    		$('#prefixNumber').attr('value', $(this).attr('id'));
    	});
    });
	
	function toBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
		    reader.readAsDataURL(file);
		    reader.onload = () => resolve(reader.result);
		    reader.onerror = reject;
		});
	}
	
	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = $('#selection4ReasonDSK').attr('codeReason');
	    var firstNameValue = document.querySelector("#ContactUsForm_User_FirstName");
	    var lastNameValue = document.querySelector("#ContactUsForm_User_LastName");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var orderValue =  document.querySelector("#ContactUsForm_User_OrderNumber");
	    var phoneNumber = $('#prefixNumber').attr('value') + document.getElementById("ContactUsForm_User_Phone").value;
	    var msgValue = document.querySelector("#ContactUs_message");
	    var file = document.querySelector('#attachInput').files[0];
	    var attach64 = null;
	    var attachName = null;
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }
	    if(file != null){
	    	if(file.size > 2097152 || !(file.type.includes('jpeg') || file.type.includes('png') || file.type.includes('pdf'))){
		    	var errorToPlace = document.querySelector("#errorAttach");
		        errorToPlace ? createErrorContactUsEmea($("#errorAttach"), $("#error_attachment").attr('value')) : '';
		        error = true;
		    }else{
		    	attachName = file.name;
		    }
	    }
	    
	    if(document.getElementById("ContactUsForm_User_Phone").value === '' && document.getElementById("ContactUsForm_User_Phone")){
	    	phoneNumber = '';
	    }else if (document.getElementById("ContactUsForm_User_Phone").value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_Phone"))){
		    	error = true;
		    }
	    }
	    
	    if(orderValue.value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_OrderNumber"))){
		    	error = true;
		    }
	    }
	    
	    if (topicValue == null) {
	    	var errorToPlace = document.querySelector("#errorTopic");
	        errorToPlace ? createErrorContactUsEmea($("#errorTopic"), $("#error_topic").attr('value')) : '';
	        error = true;
	    }

	    if (firstNameValue && firstNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorFirstname");
	        errorToPlace ? createErrorContactUsEmea($("#errorFirstname"), $("#error_firstName").attr('value')) : '';
	        error = true;
	    }
	    
	    if (lastNameValue && lastNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorLastname");
	        errorToPlace ? createErrorContactUsEmea($("#errorLastname"), $("#error_lastName").attr('value')) : '';
	        error = true;
	    }

	    if (!validateEmailFormFieldContactForm(document.querySelector("#ContactUsForm_User_Email")) || (emailValue && emailValue.value === '')) {
	    	var errorToPlace = document.querySelector("#errorEmail");
	        errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorNotes");
	        errorToPlace ? createErrorContactUsEmea($("#errorNotes"), $("#error_desription").attr('value')) : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form_EMEA").getAttribute('action');
	    if (action) {
	    	if(attachName != null){
	    		toBase64(file).then(function (data) {
		    		attach64 = data;
		    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
		    	});
	    	}else{
	    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
	    	}
	    	
	    	// HB-16527 Disable button after first click
	    	btnSubmitContactUs.classList.add('disabled');
	    	btnSubmitContactUs.setAttribute('aria-disabled', 'true');
	    	btnSubmitContactUs.style.cursor = 'default';
	    	btnSubmitContactUs.removeEventListener('click', arguments.callee);
	    	
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
	
	a = document.getElementsByClassName("select-selected");

	for (var i = 0; i < a.length; i++) {
		a[i].addEventListener("click", function(e) {
			/*when the select box is clicked, close any other select boxes,
		    and open/close the current select box:*/
		    e.stopPropagation();
		    closeAllSelect(this);
		    this.nextElementSibling.classList.toggle("select-hide");
		    this.classList.toggle("select-arrow-active");
		});
	}
	  
	function closeAllSelect(elmnt) {
	  /*a function that will close all select boxes in the document,
	  except the current select box:*/
	  var x, y, i, xl, yl, arrNo = [];
	  x = document.getElementsByClassName("select-items");
	  y = document.getElementsByClassName("select-selected");
	  xl = x.length;
	  yl = y.length;
	  for (i = 0; i < yl; i++) {
	    if (elmnt == y[i]) {
	      arrNo.push(i)
	    } else {
	      y[i].classList.remove("select-arrow-active");
	    }
	  }
	  for (i = 0; i < xl; i++) {
	    if (arrNo.indexOf(i)) {
	      x[i].classList.add("select-hide");
	    }
	  }
	}
	
	$('#reason-of-contact .listReason').on('click', function(){
		$(this).parent().attr('codeReason',$(this).attr('id'));
		$(this).parent().siblings().text(this.textContent);
	});
	
	/*if the user clicks anywhere outside the select box,
	then close all select boxes:*/
	document.addEventListener("click", closeAllSelect);
	
	$('#textRemove').on('click', function(){
		document.getElementById('attachInput').value = "";
	});
	
	function callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber){

		$.post(action, {
			firstName: firstNameValue.value,
			lastName: lastNameValue.value,
	        email: emailValue.value,
	        intentCode: topicValue,
	        order_id: orderValue.value,
	        note: msgValue.value,
	        attachName: attachName,
	        attach64: attach64,
	        mobile: phoneNumber
	    }, function(data) {
	    	var response = data.replace(/\*/g,"");
	        response = response.replace(/\//g,"");
	        var arr = JSON.parse(response);
	        if (arr['ResponseMessage'] == '1') {
	        	var msgOK = $("#ContactUsForm_msgOK").text();
	            $("#ContactUsForm_Returnmessage").text(msgOK);
	            $("#ContactUsForm_Returnmessage").show();
	        } else {
	        	var msgKO = $("#ContactUsForm_msgKO").text();
	            $("#ContactUsForm_Returnmessage").text(msgKO);
	            $("#ContactUsForm_Returnmessage").show();
	        }
	        // Append returned message to message paragraph.
	        $("#contactus-form_EMEA").hide();
	    });

	}
}


function manageOldForm(){
	/*
	*  Daniel Rilo Ferrero - BEGIN - NERD-656
	*/
	
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");

	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = document.querySelector("#ContactUsForm_Topic");
	    var nameValue = document.querySelector("#ContactUsForm_User_Name");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var msgValue = document.querySelector("#ContactUs_message");
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }

	    if (topicValue && topicValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_7");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Topic error') : '';
	        error = true;
	    }

	    if (nameValue && nameValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_9");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Name error') : '';
	        error = true;
	    }

	    if (emailValue && emailValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_11");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Email error') : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_13");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Message error') : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form").getAttribute('action');
	    if (action) {
	    	$.post(action, {
	    		name: nameValue.value,
	            email: emailValue.value,
	            topic: topicValue.value,
	            message: msgValue.value
	        }, function(data) {
	        	var response = data.replace(/\*/g,"");
	            response = response.replace(/\//g,"");
	            var arr = JSON.parse(response);
	            if (arr['ResponseMessage'] == 'MSG_SENT') {
	            	var msgOK = $("#ContactUsForm_msgOK").text();
	                $("#ContactUsForm_Returnmessage").text(msgOK);
	                $("#ContactUsForm_Returnmessage").show();
	            } else {
	            	var msgKO = $("#ContactUsForm_msgKO").text();
	                $("#ContactUsForm_Returnmessage").text(msgKO);
	                $("#ContactUsForm_Returnmessage").show();
	            }
	            // Append returned message to message paragraph.
	            $("#contactus-form").hide();
	        });
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
}

function createErrorContactUs(whereToPlaceError, errorMsg) {
  whereToPlaceError.insertAdjacentHTML('afterend','<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
}

function createErrorContactUsEmea(whereToPlaceError, errorMsg) {
	  whereToPlaceError.html('<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
	}

function focusOnElement(whereToPlaceFocus) {
  whereToPlaceFocus.focus();
}
/**
*  Daniel Rilo Ferrero - END - NERD-656
*/
//Contact Us page END ///////////////////////////////////////////////////////////////////////////////////////////////

function sleep(miliseconds) {
  console.log("Sleeping... I will wake up in " + miliseconds + " ms");
  var currentTime = new Date().getTime();
  while (currentTime + miliseconds >= new Date().getTime()) {
  }
  console.log("Waking up!");
}




/**
* @param {*} measurements
*/
function getMeasurementsDisplayValue(measurements) {
  var arrM = measurements.split(",");
  return arrM.join("-");
}

/**
* Updates the product name in the NameAndPrice widget.
*
* @param {string} catEntryId The catentryId of the selected product
* @param {string} productId The productId of the product shown
*/
function updateItemName(catEntryId, productId) {
  var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
  //var modelCodeValueElement = document.querySelector(".model_code_display .attr-value");
 // if (modelCodeValueElement != null) {
   //     modelCodeValueElement.innerHTML = catEntry.description[0].name;
       //modelCodeValueElement = modelCodeAttr;
  //}

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $("#detailFeatures .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      
  } else {
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $(".accordion-content .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelLoad= $(".descriptive-attributes-widget .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelLoad != 'undefined'){
    	modelCodeLabelLoad.innerText = modelCodeDisplay.innerText;
      }
  }
 


  var modelMeasurements = document.querySelector(".ItemMeasurements_" + catEntryId);

  var modelMeasurementsValueElement = document.querySelector("#featureMenu .descAttributeValue_modelMeasurements");
  var modelMeasurementsValueElementFirstGridMobile = document.querySelector("#tabAttr .descAttributeValue_modelMeasurements");
  
  if (modelMeasurementsValueElement != null) {
      modelMeasurementsValueElement.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      if (modelMeasurementsValueElementFirstGridMobile != null) {
        modelMeasurementsValueElementFirstGridMobile.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      }
      
  }

  var price = document.querySelector("#listPrice_" + productId);
  if(price != null){
      price.innerHTML = catEntry.listPrice;
  }

  var offer = document.querySelector("#offerPrice_" + productId);
  if(offer != null){
      offer.innerHTML = catEntry.offerPrice;
  }

}

$(".product_page_content").ready(function () {
  wcTopic.subscribe('DefiningAttributes_Resolved', updateItemName);
});




//function assureCityValue(){

// var city = $(".shipping_address_summary > .address > .city > span")[0].innerHTML.trim();
// $("#WC_UserRegistrationAddForm_AddressEntryForm_FormInput_city_1").val( city );
//}
/* HB-587 END *************************************************************************************************/


// /**
//  * HB-550 BEGIN Improve PLP loading time + HB-678 Different behavior for PLP with or without hash
//  * The next code loads dinamically plp sections using Ajax
//  */
// var isAjaxPLP = false;                  //True if we are in a PLP with ajax elements
// var isAjaxPLPHash = false;              //True if we are in a PLP with hash
// var ajaxPLPClass = "plp-ajax-section";  //Class name of PLP elements to load using Ajax
// var ajaxPLPLocked = false;              //Used to lock multiple ajax calls at the same time
// var ajaxPLPHash = "";                   //location.hash of current URL
// var ajaxPLPHashScrollDone = false;      //True if the scroll to hash was done
// var ajaxPLPNoScrollSuffix = "_noScrollToHash"; //Suffix added to collection id to stop default scroll

// $(document).ready(function () {
//     ajaxPLPSetup();

//     if (isAjaxPLP) {
//         // HB-678 BEGIN Different behavior for PLP with or without hash
//         // Without hash: Load collections from top to bottom as they become visible
//         // With hash: Load collections as they become visible
//         if (isAjaxPLPHash) {
//             //ajaxPLPLocked=true;
//             loadCategoryAjax(ajaxPLPHash);
//         } else {
//             ajaxPLPRemoveSuffix();
//             loadVisibleCategoriesAjax();
//         }
//         // HB-678 END
//     }
// });

// $(window).resize(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });
// $(window).scroll(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });

// $(document).ajaxComplete(function () {
//     if (isAjaxPLP) {
//         //Check if ajax load worked correctly
//         var linksError = document.querySelectorAll("a." + ajaxPLPClass + ".loaded");
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() == "") {
//                 $(linksError[i]).removeClass("loaded");
//                 $(linksError[i]).next().removeClass("loaded");
//             } else {
//                 //Hide ajax link image
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //This is to double check that ajax img are hidden when the content is loaded
//         linksError = document.querySelectorAll("a." + ajaxPLPClass);
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() != "") {
//                 $(linksError[i]).addClass("loaded");
//                 $(linksError[i]).next().addClass("loaded");
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //Activate inactive carousels
//         var cs = document.querySelectorAll(".wrapperCategories--owl-carousel:not(.active)");
//         for (var i = 0; i < cs.length; i++) {
//             $(cs[i]).owlCarousel({
//                 items: 1,
//                 lazyLoad: true,
//                 singleItem: true,
//                 navigation: true,
//                 navigationText: false,
//                 addClassActive: true,
//                 //The afterAction is for solve a 'problem' with the Owl Carousel Framework.
//                 //When we resize the size of the browser, the Carousel is refreshd.
//                 //This way, we can control the resize and put the colors in the nav menu.
//                 afterAction: function (event) {
//                     event.onresize = colorCarousel();
//                 }
//             });
//             $(cs[i]).addClass('active');
//         }

//         if (isAjaxPLPHash && !ajaxPLPHashScrollDone && $(ajaxPLPHash + " ." + ajaxPLPClass + ".loaded").length > 0) {
//             //Scroll to loaded category
//             $('html,body').animate(
//                 { scrollTop: $(ajaxPLPHash).offset().top },
//                 1300,
//                 "easeInOutCubic",
//                 function () {
//                     ajaxPLPLocked = false;
//                     //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//                     ajaxPLPHashScrollDone = true;
//                     loadVisibleCategoriesAjax();
//                     activateContent();
//                     ajaxPLPRemoveSuffix();
//                 });
//         } else {
//             ajaxPLPLocked = false;
//             //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//         }
//     }
// });


// //Initialization of Ajax PLP page
// function ajaxPLPSetup() {
//     if ($("a." + ajaxPLPClass).length > 0) {
//         isAjaxPLP = true;

//         //Add content DIV after each AjaxLink
//         var cont = 0;
//         $("a." + ajaxPLPClass).each(function () {
//             cont++;
//             $(this).html("<img class='ajaxloadingImg' src='https://assets.persol.com/extra/image/TargetOptical/icons/ajax_transparent_20x20.png' width='20' height='20'>");
//             $(this).after("<div id='loadedContent_" + cont + "' style='display:none;'></div>");
//         });

//         // HB-678 BEGIN
//         if (location.hash) {
//             //Check if hash collection exists
//             if ($(location.hash + ajaxPLPNoScrollSuffix).length > 0) {
//                 //The collection exists
//                 //console.log("PSL::ajaxPLPSetup::Collection found="+location.hash);
//                 isAjaxPLPHash = true;
//                 ajaxPLPHash = location.hash + ajaxPLPNoScrollSuffix;
//             } else {
//                 //The collection doesn't exist
//                 //console.log("PSL::ajaxPLPSetup::Collection not found="+location.hash);
//             }
//         }
//         // HB-678 END
//     }
// }

// //Remove ajaxPLPNoScrollSuffix from id in all collections to enable default scroll
// function ajaxPLPRemoveSuffix() {
//     $("div.wrapperCategories").each(function () {
//         $(this).attr('id', $(this).attr('id').replace(ajaxPLPNoScrollSuffix, ''));
//     });
// }

// function loadVisibleCategoriesAjax() {
//     if (isAjaxPLP && !ajaxPLPLocked) {
//         if (isAjaxPLPHash) {
//             //Load categories as they become visible
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         ajaxPLPLocked = true;
//                         //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+" "+new Date().toString());
//                         $(linksArray[i]).next().load($(linksArray[i]).attr('href'), null, activateContent($(linksArray[i]).next()));
//                         $(linksArray[i]).addClass('loaded');
//                         $(linksArray[i]).next().addClass('loaded');
//                         $(linksArray[i]).next().fadeIn(2500);

//                         break;
//                     }
//                 }
//             }

//         } else {
//             //Load visible categories FROM TOP TO BOTTOM
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             var loadNeeded = false;
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         loadNeeded = true;
//                         break;
//                     }
//                 }
//             }
//             if (loadNeeded) {
//                 if (!ajaxPLPLocked) {
//                     var firstEmptyLink = document.querySelector("a." + ajaxPLPClass + ":not(.loaded)");
//                     ajaxPLPLocked = true;
//                     $(firstEmptyLink).next().load($(firstEmptyLink).attr('href'), null, activateContent($(firstEmptyLink).next()));
//                     $(firstEmptyLink).addClass('loaded');
//                     $(firstEmptyLink).next().addClass('loaded');
//                     $(firstEmptyLink).next().fadeIn(2500);
//                 }
//             }
//         }
//     }
// }

// /**
//  * HB-678 Loads category using Ajax
//  * @param {string} categoryHash Category id hash, for example #Galleria900
//  */
// function loadCategoryAjax(categoryHash) {
//     var aElement = document.querySelector(categoryHash + " a.plp-ajax-section:not(.loaded)");
//     if (aElement == undefined) {
//         //The category was not found
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category not found or already loaded.");
//     } else {
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category found, array elements = "+aElement);
//         if ($(aElement).next().html() == "") {
//             ajaxPLPLocked = true;
//             $(aElement).next().load($(aElement).attr('href'), null, activateContent($(aElement).next()));
//             $(aElement).addClass('loaded');
//             $(aElement).next().addClass('loaded');
//             $(aElement).next().fadeIn(2500);
//         }
//     }
// }
// /* HB-678 END *************************************************************************************************/

// //Shows section
// function activateContent(contentElement) {
//     if (isAjaxPLP && contentElement !== undefined && $(contentElement).is(":hidden")) {
//         $(contentElement).fadeIn(2000);
//     }
// }

// /*
// We use a key-value variable owlColors and the 'aria-color' found in each class 'product'
// to put the background-color to each button of the carousel.
// */
// function colorCarousel() {
//     $('.wrapperCategories--owl-carousel').each(function (index) {
//         var thisItem = $(this);
//         thisItem.find('.product').each(function (indexItem) {
//             if ($(this).attr('aria-color')) {
//                 $(thisItem).find('.owl-page > span').eq(indexItem).css('background-color', owlColors[$(this).attr('aria-color')]);
//             }
//         });
//     });
// }
// /* HB-550 END *************************************************************************************************/

// /**
//  * HB-638 BEGIN Disable context menu on images
//  */
// function disableContextMenuOnImages() {
//     for (var i = 0; i < document.images.length; i++) {
//         document.images[i].addEventListener("contextmenu", function (e) {
//             e.preventDefault();
//         });
//     }
//     return false;
// }
// $(document).ready(function () {
//     //disableContextMenuOnImages();
// });
// $(document).ajaxComplete(function () {
//     //disableContextMenuOnImages();
// });
/* HB-638 END *************************************************************************************************/

/**
* Function for the checking of the State.
* If the State is California, we have to
* show a new line with a link to a popup
* with a message about some risks.
*/
// function changeState(sel) {
//   sel.value === 'CA' ? $('.prop65').addClass('shown') : $('.prop65').removeClass('shown');
// }

/**
* GDPR BEGIN
*/

/**
* Calculates if age greater than 16 years
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {boolean} true if age >= 16, false otherwise
*/
function olderThan16(year, month, day) {
  var year = parseInt(year);
  var month = parseInt(month);
  var day = parseInt(day);
  var age = calculateAge(year, month, day);
  if (age >= 16)
      return true;
  return false;
}

/**
* Calculates age in years.
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {int} age in years
*/
function calculateAge(year, month, day) {
  var birthdate = new Date(year, month - 1, day);
  var cur = new Date();
  var diff = cur - birthdate; // This is the difference in milliseconds
  var age = Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25
  return age;
}
/* GDPR END *************************************************************************************************/

/**
* Shows a price without the currency, note that the string decimals MUST match the NUMBER_OF_DECIMALS constant
* @param {String} inPrice String with price i.e. something like "$ 100.00"
* @param {boolean} If true, decimals are removed (Default false)
* @returns String without the currency "100.00"
*/
function cleanPrice(inPrice, removeDecimals) {
  if (typeof removeDecimals === 'undefined' || removeDecimals != true) {
      removeDecimals = false;
  }
  var NUMBER_OF_DECIMALS = 2;
  var numbers = "0123456789";
  var validSeparators = ",.";
  var validChars = numbers + ",.";
  var decimalSeparator = "";
  var tempPrice = "";
  var cleanedPrice = "";
  var hasDecimals = true;
  var decimalChar = ".";

  for (var i = 0; i < inPrice.length; i++) {
      if (validChars.includes(inPrice[i])) {
          tempPrice += inPrice[i];
      }
  }

  if (tempPrice.length >= NUMBER_OF_DECIMALS + 2) {
      decimalChar = tempPrice[tempPrice.length - (NUMBER_OF_DECIMALS + 1)];
      if (!validSeparators.includes(decimalChar)) {
          hasDecimals = false;
      }
  }

  if (removeDecimals) {
      if (hasDecimals) {
          tempPrice = tempPrice.substring(0, tempPrice.length - (NUMBER_OF_DECIMALS + 1));
      }
  }

  for (var i = 0; i < tempPrice.length; i++) {
      if (numbers.includes(tempPrice[i]) || tempPrice[i] == decimalChar) {
          cleanedPrice += tempPrice[i];
      }
  }

  return cleanedPrice;
}


/**
* HB-828 BEGIN Expansible address2 line in US
$(document).ready(function () {
  $(".address2_wrapper").click(function () {
      $(this).css("text-decoration", "none");
      $(this).find(".expansible_symbol").html("");
      $(this).find(".address2-input_wrapper").slideDown("fast");
      $(this).find(".optional").fadeIn("fast");
  });

  if ($(".address2_wrapper input").first().val() != "") {
      $(".address2_wrapper").click();
  }
});
*/
/* HB-828 END ******************************************************************************/

/**
* HB-1669 BEGIN Enable or disable addToCart button depending of current catentry stock
*/
function hideOrShowCartBtn (showAdd) {
  if(showAdd) {
      $("#add2CartBtnDisabled").hide();
      if(!$("#add2CartBtnDisabled").hasClass("hidden")) $("#add2CartBtnDisabled").addClass("hidden");
      $("#add2CartBtn").show();
      $("#add2CartBtn").removeClass("hidden");
  } else {
      $("#add2CartBtnDisabled").show();
      $(".namePartPriceContainer").css('visibility', 'hidden');
      $("#add2CartBtnDisabled").removeClass("hidden");
      $("#add2CartBtn").hide();
      // $('.fixed-navbar').addClass('three-columns');
      $('#pdp-presc-and-clip-on').css('visibility', 'hidden');
      if(!$("#add2CartBtn").hasClass("hidden")) $("#add2CartBtn").addClass("hidden");
  }
  createTopRecap();
}


//Show the AddToCart button when only one size available (no size combo)
$(document).ready(function () {
  if ($('.product_page_content').length > 0) {
      if ($('.namePartPriceContainer .old_price').length > 0) {
          $('.namePartPriceContainer').addClass('namePartPriceContainer--offer-price');
//            $('.product_page_content .namePartPriceContainer .vat').css('margin-right', $('.product_page_content .namePartPriceContainer--offer-price .old_price').width() + 5);
      }
  }
  /*if (typeof inventoryMap !== 'undefined') {
      var size = Object.keys(inventoryMap).length;
      if (size == 1) {
          var stock = inventoryMap[Object.keys(inventoryMap)[0]];
          if (stock > 0) {
              //Enable AddToCart button
              hideOrShowCartBtn(true)
              $("#add2CartBtnDisabled").hide();
              $("#add2CartBtn").show();
          } else {
              //Disable AddToCart button
              hideOrShowCartBtn(false)

              $("#add2CartBtnDisabled").show();
              $("#add2CartBtn").hide();
          }
      }
  }*/
  $('.namePartPriceContainer').show();
  
  //$('#add2CartBtn').show();  the addtocart button is shown already by a script in PDP_Prescription
});

/* HB-1669 END ******************************************************************************/

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }
      });
  }
});

/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }

      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
      // Loop thru iFrame attributes to remove these ones are not allowed
      // var notAllowedAttr = [
      //     'scrolling'
      // ]

      // var attrLength = el.attributes.length;
      // var notAllowedAttrLength = notAllowedAttr.length;
      // for (i=0; i < attrLength; i++) {
      //     for (j=0; j < notAllowedAttrLength; j++) {
      //         var test = '';
      //         // console.log("el.getAttribute(notAllowedAttr[j]) -> " + el.getAttribute(notAllowedAttr[j]));
      //         // console.log("el.attributes[i] -> " + el.attributes[i]);
      //         // console.log("el.attributes[i] -> %o", el.attributes[i]);
      //         // console.log("el.hasAttribute("+notAllowedAttr[j]+") -> " + el.hasAttribute(notAllowedAttr[j]));
      //         // test = notAllowedAttr[j].indexOf(el.attributes[i].name);
      //         console.log(el.getAttribute(notAllowedAttr[j]));
      //         console.log("test !== null -> " + (test !== null));
      //         // console.log(test);
      //         // test ? console.log('true') : console.log('falase');
      //         if (test !== null) {
      //             console.log("Removing " + notAllowedAttr[j]);
      //             console.log("1. %o",el);
      //             el.removeAttribute("'"+notAllowedAttr[j]+"'");
      //             console.log("2. %o",el);
      //         }
      //     }
      // }
      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
  });
})
/**
* Daniel Rilo - END - WCAG
*/

function closeMobileMenu(){
    
    $("#headerWrapper.header-fixed").removeClass("header-fixed");
    if($('#page').hasClass('pdp') ){
      $('#header').css('z-index', '5');
      hideHeaderTimeout.setup();
    }
    document.getElementById('header').classList.remove('header--opend');
    document.getElementsByTagName('html')[0].classList.remove('open-menu');
    document.getElementsByTagName('body')[0].classList.remove('open-menu');
    document.getElementById('searchBar').style.display = 'none';
    closeSearchBar();
    document.getElementsByClassName('signInContainer')[0].style.display = 'none';
    $('.signInRegisterRow').removeClass('signInOpened');
    document.getElementById('shoppingCart').style.display = 'block';
    document.getElementById('logo').style.display = 'block';
    $('#closeIcon').hide();
    $('#searchIcon').show();
    if(isPersol){
        document.getElementsByClassName('header_wishlist')[0].style.display = 'block';
    }
    if(isIOS() && sessionStorage.getItem('menu_scrollY')) {
        window.scrollTo(0,sessionStorage.getItem('menu_scrollY'));
        sessionStorage.removeItem('menu_scrollY');
        document.getElementsByTagName('body')[0].classList.remove('iosBody');
    }
    if($(this).hasClass("close-mobile-menu")){
        var headerCheckbox = document.getElementById("header__checkbox");
        headerCheckbox.checked = false;
        backMenu($(this));
    }
}

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }

          newsletterEmail.checkValidity() && newsletterEmail.value !== '' ? document.querySelector('#newsLetter').classList.add('btn-visible') : document.querySelector('#newsLetter').classList.remove('btn-visible');
      });

      // newsletterEmail.addEventListener('blur', function(event) {
      // });
  }

  /**
   *
   */
    var headerChk = document.getElementById('header__checkbox');
    $(".close-mobile-menu").click(closeMobileMenu) ;
    if (headerChk !== null) {
        headerChk.addEventListener('click', function () {
        if (this.checked) {
          $("#headerWrapper").addClass("header-fixed");
              if(isIOS()){
                  sessionStorage.setItem('menu_scrollY',window.scrollY);
                  document.getElementsByTagName('body')[0].classList.add('iosBody');
              }
              /*z-index mobile pdp*/
              if($('#page').hasClass('pdp')) {
                  $('#header').css('z-index', '1001');
              }
              document.getElementById('header').classList.add('header--opend');
              document.getElementsByTagName('html')[0].classList.add('open-menu');
              document.getElementsByTagName('body')[0].classList.add('open-menu');
              document.getElementById('searchBar').style.display = 'block';
              document.getElementsByClassName('signInContainer')[0].style.display = 'flex';
              document.getElementById('shoppingCart').style.display = 'none';
             
            if(!isPersol){
                 document.getElementById('logo').style.display = 'none'; 
             }
            
             if(isPersol){ 
                document.getElementsByClassName('header_wishlist')[0].style.display = 'none'; 
             }
            
              $('#searchIcon').hide();
              $('#closeIcon').show();
              hideHeaderTimeout.cancel();
              
              //HB-17211
              if ((window.mobilecheck() || window.tabletPortraitCheck()) && pageType == 'Search'){
            	  $("#searchBar.header__search-wrapper").css("top","unset");
              }

              if ((window.mobilecheck() || window.tabletPortraitCheck()) && $("#Header_GlobalLogin").hasClass("opend")){
                $("#" + LOGINPANEL_ID + "_signInDropdown .panel .close-btn").click();
              }
          } else {
            closeMobileMenu();
          }
        var headerObj = $("#headerRow1 nav.nav");
        headerObj.attr("data-description",$(".nav__list.nav-menu").text().replace(/'/g,"\\'"));
        tealiumPushClickMenu(headerObj[0]);
      });
  }

  var navLink = document.getElementsByClassName('nav__link--phone');
  if (navLink.length > 0) {
      [].forEach.call(navLink, function (el) {
          el.addEventListener('click', function (event) {
              if (this.classList.contains('nav__link--opend')) {
                  this.classList.remove('nav__link--opend');
                 // document.getElementById("caroselOurWord").style.display = 'none';
              } else {
                  var navLength = navLink.length;
                  for (var i = 0; i < navLength; i++) {
                      navLink[i].classList.remove('nav__link--opend');
                  }
                  this.classList.add('nav__link--opend');
               //   document.getElementById("caroselOurWord").style.display = 'block';
              }
          });
      });
  }

  var menuCarousel = $('.submenu__carousel');
  if (menuCarousel.length > 0) {
      menuCarousel.owlCarousel();
  }

  var backButton = document.getElementsByClassName('submenu__back');
  if (backButton.length > 0) {
      [].forEach.call(backButton, function (el) {
          el.addEventListener('click', function (event) {
              var checkList = document.querySelectorAll('.submenu__list-item input');
              var checkListLength = checkList.length;
              for (var i = 0; i < checkListLength; i++) {
                  document.querySelector('.nav__list').classList.remove('nav_list--opend');
                  checkList[i].checked ? checkList[i].checked = false : '';
              }
             // document.querySelector('.header__first-login').classList.remove('header__first-login--opend');
          });
      });
  }

  var navInput = document.querySelectorAll('.submenu__list-item input');
  if (navInput.length > 0) {
      [].forEach.call(navInput, function (el) {
          el.addEventListener('click', function () {
              document.querySelector('.nav__list').classList.add('nav__list--opend');
            //document.querySelector('.header__first-login').classList.add('header__first-login--opend');
          });
      });
  }

  //   var navSearchIcon = document.querySelector('.header__search-icon');
  // var navSearchIcon = document.getElementById('searchIcon');
  // if (navSearchIcon !== null) {
  //     navSearchIcon.addEventListener('click', function() {
  //         var searchID = document.getElementById('searchBar');
  //         changeTabIndex($("#searchBox"));
  //         searchID.classList.contains('search--opend') ? searchID.classList.remove('search--opend') : searchID.classList.add('search--opend');
  //     });
  // }

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('--open');
      });
  }
  /**
      * Block for the Filters.
      */
  var facetFilter = document.getElementsByClassName('facet-sort');
  if (facetFilter.length > 0) {
      /*
      facetFilter = facetFilter[0];
      var windowScroll = window.scrollY;
      var top = facetFilter.offsetTop;
      var plp = document.getElementsByClassName('plp')[0];
      var sorting =  document.getElementsByClassName('sorting')[0];
      var wcSelectorSorting = document.getElementsByClassName('sorting__wc-selector')[0];

      window.onscroll = function() {
          windowScroll = window.scrollY;
          if (windowScroll >= top) {
              facetFilter.classList.add('facet--sticky');
              sorting.classList.add('sorting--sticky');
              plp.classList.add('plp--sticky');
              wcSelectorSorting.classList.add('sorting__wc-selector--sticky');
          } else {
              facetFilter.classList.remove('facet--sticky');
              sorting.classList.remove('sorting--sticky');
              plp.classList.remove('plp--sticky');
              wcSelectorSorting.classList.remove('sorting__wc-selector--sticky');
          }
      };
      window.onresize = function() {
          top = facetFilter.offsetTop;
      }
      var facetWidgetTitle = document.getElementsByClassName('facet__title-filter')[0];
      var facetWidget = document.getElementsByClassName('facet__widget')[0];
      facetWidgetTitle.addEventListener('click', function() {
          facetWidget.classList.contains('facet__widget--opend') ? facetWidget.classList.remove('facet__widget--opend') : facetWidget.classList.add('facet__widget--opend');
      });
      */

      var facetSubtitle = document.querySelectorAll('.facet__subtitle');
      if (facetSubtitle.length > 0) {
          [].forEach.call(facetSubtitle, function (el) {
              el.addEventListener('click', function () {
                  if (this.classList.contains('facet__subtitle--opend')) {
                      this.classList.remove('facet__subtitle--opend');
                  } else {
                      var facetSubtitleOpend = document.querySelectorAll('.facet__subtitle--opend');
                      var lengthFacet = facetSubtitleOpend.length;
                      if (lengthFacet > 0) {
                          for (var i = 0; i < lengthFacet; i++) {
                              facetSubtitleOpend[i].classList.remove('facet__subtitle--opend');
                          }
                      }
                      this.classList.add('facet__subtitle--opend');
                  }
              });
          });
      }
  }


  var sortBy = document.getElementsByClassName('sorting__dropdown');
  if (sortBy.length > 0) {
      sortBy[0].addEventListener('click', function () {
          console.log('click sortBy');
          var nameList = document.getElementsByClassName('sorting__list')[0];
          var sortWrapper = document.getElementsByClassName('sorting')[0];
          nameList.classList.contains('ui-selectmenu-button-open') ? sortWrapper.classList.add('sorting--open') : sortWrapper.classList.remove('sorting--open');
      });


      document.querySelector('body').addEventListener('click', function (e) {
          var sortingOpen = document.querySelector('.sorting__wc-selector');
          var sortWrapper = document.querySelector('.sorting')

          // If element .sorting__wc-selector exists
          // AND does not contain .ui-selectmenu-open
          // AND element .sorting contains .sorting--open
          // THEN we remove the class .sorting--open BECAUSE the combobox is closed
          if (sortingOpen && !sortingOpen.classList.contains('ui-selectmenu-open') && sortWrapper.classList.contains('sorting--open'))
              sortWrapper.classList.remove('sorting--open');
      });
  }

  var plpCarousel = $('.plp__other-product-carousel');
  var plpCarouselLength = plpCarousel.length;
  if (plpCarouselLength > 0) {
    //   $.each(plpCarousel, function (key, val) {
    //       $(this).owlCarousel({
    //           items: 3,
    //           pagination: false,
    //           navigation: true,
    //           navigationText: [
    //               "<button class='btn--owl-nav btn--owl-prev'></button>",
    //               "<button class='btn--owl-nav btn--owl-next'></button>"
    //           ],
    //           lazyLoad: true,
    //           addClassActive: true,
    //           rewindNav: false
    //       });
    //   })
  }

 
 

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('country-selected__wrapper--open');
          $("#footerWrapper").addClass("footer-pop-open");
      });
  }
});



function onSelectPLP(sel) {
  var str = sel.value;
  var url = window.location.href;
  var newUrl = "";
  var variable = "";
  var variable1 = "";
  var variable2 = "";
  var link = url.indexOf("?") >= 0 ? "&" : "?";

  if (url.indexOf("?orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('?orderBy='));
      variable1 = url.split("?orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "?orderBy=" + str + variable2;
  } else if (url.indexOf("&orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('&orderBy='));
      variable1 = url.split("&orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "&orderBy=" + str + variable2;
  } else {
      newUrl = window.location.href + link + "orderBy=" + str;
  }

  window.location.href = newUrl;
}


// Daniel Rilo - END - CREV NERD-569



/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }
  });
})
/**
* Daniel Rilo -END - WCAG
*/

$(document).ready(function () {
  /**
   * @desc When you click on the "NEWSLETTER" link (in the footer), the "Newsletter" section show/hide.
   * @summary Show/hide Newsletter
   * @author Daniel Rilo
   */
  var btnNewsletterShowHide = document.querySelector('#sxShowNewsletter');
  if (btnNewsletterShowHide) {
      btnNewsletterShowHide.addEventListener('click', function (e) {
          e.preventDefault();

          var newsletterSection = document.querySelector('#newsLetterForm');
          newsletterSection ? newsletterSection.classList.toggle('opend') : '';
      })
  }

  var signInImg = document.querySelector('.signInRegistration__wrapper--left');
  if (signInImg) {
      signInImg.children.length < 1 ? signInImg.classList.add('signInRegistration__wrapper--hide') : '';
  }

  /**
   * @desc When you click on the Cross button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseCross = document.querySelector(".first-session__button-a");
  if (firstSignInPopupCloseCross) {
      addClosePopupSignIn(firstSignInPopupCloseCross);
  }

  /**
   * @desc When you click on the SHOP NOW button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseBtn = document.querySelector(".first-session__shop-button");
  if (firstSignInPopupCloseBtn) {
      addClosePopupSignIn(firstSignInPopupCloseBtn);
  }

  if((pageType == 'Plp' || pageType=='Static') && !(window.mobilecheck() || window.tabletPortraitCheck())) {
      mapMenuAndUnderline();
  } 
  
});


function mapMenuAndUnderline() {
  var allLinksSun = $('[data-espot-name="X_Header_NavSunglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksEye = $('[data-espot-name="X_Header_NavEyeglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksCollection = $('[data-espot-name="X_Header_NavCollections_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksOurWorld = $("#X_Header_NavOurWorld_RightCards a").map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();
  

  var currentPage = window.location.pathname.split('/').pop();

  if(allLinksSun.indexOf(currentPage) != -1) {
     $('[data-element-id="X_X_MainNav_Sun"]').addClass('underline');
  }
  else if (allLinksEye.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Optical"]').addClass('underline');
  }
  else if (allLinksCollection.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Collection"]').addClass('underline');
  }    
  else if (allLinksOurWorld.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_World"]').addClass('underline');
  }    
}

/**
* @function addClosePopupSignIn
* @param {HTML object} item Object where I'll add the 'click' listener.
* @desc Add an Event Listener to a given HTML Object
* @summary Add Close Listener
* @author Daniel Rilo
*/
function addClosePopupSignIn(item) {
  item.addEventListener('click', function() {
      var firstSignInPopupCloseCross = document.querySelector(".first-session");
      if (firstSignInPopupCloseCross) {
          firstSignInPopupCloseCross.remove()
          noScrollFirstLogin(false);
      }
  });
}

/**
* This function keeps accesible the privacy policy link on the newsletter form input once it loses the focus.
*/
$(function(){
  $('#newsletterPolicy').focus(function(){
      $('#newsletterEmail').addClass('focus');
  })
  $('#newsletterPolicy').blur(function(){
      $('#newsletterEmail').removeClass('focus');
  })
});

/**
* Show/hide password in registration form
*/
$(document).ready(function () {
  var buttonShowPassword = document.querySelectorAll('.btn-show-hide-password');
  if (!buttonShowPassword) return false;
  buttonShowPassword.forEach(function(el) {
      el.addEventListener('click', function(e) {
          e.preventDefault();
          showHidePassword(this);
      });

      el.addEventListener('keyup', function(e) {
          if (e.keyCode == 13) showHidePassword(this);
      });
  });
});

/**
* Create sign in pop-up.
*/
$(document).ready(function () {
  $('.have_an_account').on('click', '.shipping_sign_in',function(e){
      e.preventDefault();
      e.stopPropagation();
      var signInPopUp = $(this).parent().find('#sign_in_popUp');
      if (signInPopUp.length > 0) {
          if($(window).width() < 1024) {
              signInPopUp.dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: '100%',
                  position: 'bottom',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                      $('body, html').css('height', 'auto');
                      $('body, html').css('overflow', 'visible');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('body, html').css('height', '100%');
                      $('body, html').css('overflow', 'hidden');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          } else {
              signInPopUp.dialog({
                  modal: false,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          }
      } else {
          var checkoutSignInPopUp = $('.checkout-sign-in-popup').find('#sign_in_popUp');
          if (checkoutSignInPopUp.length > 0) {
              checkoutSignInPopUp.dialog('open');
          }
      }
  });
});

function showHidePassword(elem) {
  var inputType = elem.parentNode.querySelector('input');

  if (!inputType) return false;

  var imgType = elem.parentNode.querySelector('a img');
  var imgName = '';

  if (inputType.getAttribute('type') === 'text') {
      inputType.setAttribute('type', 'password');
      imgName = 'view.svg';
  } else {
      inputType.setAttribute('type', 'text');
      imgName = 'view-strike.svg';
  }

  imgType.src = imgType.src.substring(0, imgType.src.indexOf('view')) + imgName;
}

function noScrollFirstLogin(show) {
  show ? document.querySelector('body').classList.add('no-scroll') : document.querySelector('body').classList.remove('no-scroll');
}

/***
* Error Message
*/
displayLoginErrorMessage = function() {
  var loginError = $('.login-error');
  if (loginError.length > 0) {
      loginError.find('.myaccount_error').text(MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"]);
  }
};


/* START NEW PDP */
function insertCurrentGlassInOtherColors() {
  //TODO: CHECK IF THERE IS IMAGE
var url1 = $.parseJSON($('[id^="entitledItem_"]')[0].innerText)[0].ItemThumbnailImage + "&bgcolor=ffffff";
  var img1 = $('#productMainImage')[0].outerHTML;
  var url = $('#productMainImage')[0].src.replace("f8f8fb", "e3e3f0");
  var img2 = "<img class='image--hover' src=" + url + ">";
  var imgs = img1 + img2;
  $("#current-glass .img-container").html(imgs);

}



function createMiniature () {
  $("#persol_popup-images-carousel img[data-thumbnail]").each(function(index){
          var item = $("#persol_popup-images-carousel .owl-pagination .owl-page span")[index];
          var img = "<img src='" + $(this).data("thumbnail") + "' alt='" + $(this).attr("alt") + "' title='" + $(this).attr("title") + "' />"
          $(item).html(img)
      }
  )
}

handleSize = function(){
  if(window.mobilecheck() || window.tabletPortraitCheck()) {
      $('.size-option-selected').on('click',function(e){
          $('.bottom-scrollable-section').css('z-index', "1000");
         $("html").toggleClass("overflow-hidden"); 
          $("#page").addClass("hidden-scroll-body");
          e.stopPropagation();

          $('.modal-background').slideDown(0);
          manageScrollOverlay(true);
      })

      $('.definingAttributes .modal-background').on('click',function(e) {
          if(e.target.classList.contains('modal-background') && typeof closeSize === 'function') {
              closeSize();
          }
      })
  } else {
      $('.size-option-selected').on('click',function(e){

          $('.modal-background').toggle('hide');
          e.stopPropagation();
          if($('.modal-background').is(':visible')){
              managePopupTabIndex('.size-option-div', true);
          }

          for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
              if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                  $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                  break;
              }
          }

      })
      /*$(window).on('click', function(e){
          if(e.target !== $('.size-option-div') && e.target !== $('.size-option-div li.size-options')){
              $('.modal-background').toggle('hide');
              $(window).off( "click")
          }
      })*/
  }
}

/* Show default payment placement */
/* PDP called function: #11
* prev function: setInventoryMapEntry()
* next function:  ()
*/
function showDefaultPaymentPlacement(payment) {
  var defaultPaymentPlacementCookie = getCookie("defaultPaymentPlacement");
  if (defaultPaymentPlacementCookie != undefined && defaultPaymentPlacementCookie != ""){
      payment = defaultPaymentPlacementCookie;
  }
  if (payment == ""){
      if (klarnaEnabled == 'true'){
          showKlarnaPlacements();
      } else if (affirmEnabled == 'true'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  } else {
      if (payment == 'klarna'){
          showKlarnaPlacements();
      } else if (payment == 'affirm'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  }
}

function initAccessibility(){
  //accessibility screen reader
  $('#owl-pdp .owl-item').attr('aria-selected','false');
  $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}

function manageAccessibility(){
   // apply meta info to next and previous buttons and make them focusable
  //  $('#owl-pdp').attr('role', 'carousel');
   $('#owl-pdp .owl-item.active .popup_link').attr('tabindex','0');
   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
   $('#owl-pdp .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
   $('#owl-pdp .owl-pagination .owl-page.active') .attr('title','Active Slide')
   $('#owl-pdp .owl-pagination .owl-page').on('keydown', function(e){
       if(e.keyCode == 13){
           var slideToGO = parseFloat($(this).children('.owl-numbers').html());
           $("#owl-pdp").data('owlCarousel').goTo(slideToGO - 1);
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).focus().attr('title','Active Slide')
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
       }

   })

   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}


$(document).ready(function(){
  // if page is pdp on orientation change trigger page reload
  if($('#page').hasClass('pdp')){ 
      /*
      //START Early Access
      $('.prices-container #listPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      $('.prices-container #offerPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      //END Early Access
      */
      window.addEventListener("orientationchange", function() {
          location.reload();
          }, false);

          
      var otherColors = $(".catalog-entry-recommendation-widget.other_colors").children(".catalogEntryRecommendationWidget");
      if(otherColors.length === 0){
          $(".catalog-entry-recommendation-widget.other_colors").addClass("other-colors-empty");
      }

      

  }

  // var zIndexSlot3 = $('.slot3').css('z-index');
  $(document).off("click", "#owl-pdp .popup_link").on("click", "#owl-pdp .popup_link", function(){
      //aumento z-index per nascondere le nav in sticky
      // $('.slot3').css('z-index', '6');
      $("html").addClass("overflow-hidden");
      $("#page-overflow-wrapper").addClass("overflow-hidden");
  $('.col12.slot3').css('position','relative');
      if($(this).attr("data-index") !== 0 || $(this).attr("data-index") !== "0")
          $("#persol_popup-images-carousel").trigger('owl.goTo', [$(this).attr("data-index")]);

      var len = $("#persol_popup-images-carousel [id^='lens-magnifier_']").length;
      var windowWidth = window.innerWidth;
      var zoomLevel = 1.5;
      if (windowWidth > 1600){
          zoomLevel = 1.8;
      }
      if(!(window.mobilecheck() || tabletPortraitCheck() )){
          for (var i = 0; i < len; i++) {
              $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").mlens({
                  imgSrc: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big"),      // path of the hi-res version of the image
                  imgSrc2x: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big2x"),  // path of the hi-res @2x version of the image
                  lensShape: "circle",                // shape of the lens (circle/square)
                  lensSize: ["256px","256px"],            // lens dimensions (in px or in % with respect to image dimensions)
                  borderSize: 1,                  // size of the lens border (in px)
                  borderColor: "#bfbfbf",            // color of the lens border (#hex)
                  borderRadius: 0,                // border radius (optional, only if the shape is square)
                  imgOverlay: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-overlay"), // path of the overlay image (optional)
                  overlayAdapt: true,    // true if the overlay image has to adapt to the lens size (boolean)
                  zoomLevel: zoomLevel,          // zoom level multiplicator (number)
                  responsive: true       // true if mlens has to be responsive (boolean)
              });
              $("#mlens_wrapper_" + i).css('position', 'relative');
          }
      }

      togglePopupCarosel(true);
  });

  $("#persol_popup-images .closeButton").click(function(){
      // $('.slot3').css('z-index', '1');
      $("html").removeClass("overflow-hidden");
      $("#page-overflow-wrapper").removeClass("overflow-hidden");
      $('.col12.slot3').css('position','');
      togglePopupCarosel(false);
      manageScrollOverlay(false);
  })

  handleSize();
//   if(window.mobilecheck() || window.tabletPortraitCheck() ){
//       $('.slot4').next().css('visibility', 'hidden')
//   }

  //variables for scroll mobile
  // lazyLoading();

  $(".promo-callout .close-icon").click(function(){
      $(".promo-callout").hide();
      setCookie('promoCalloutCookie', true, {expires: 1} )
  })

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20){
              $('.slot3').slideDown({
                  duration:300,
                  complete:function(){
                          stickyBottomDesktop();
                          $(window).scrollTop(0);
                      }
                  });
          }
      });

      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20 && $('.slot3').is(":visible")){
            if(!$('#page').hasClass('pdp')){
                hideHeaderTimeout.showHeader();
            }
          }
      });
  } else {
      if (!$("#image-soldOut").is(":visible")) {
          //calcolo altezza img centrale
          if( $('.slot3 .full-image-widget').hasClass('other-colors-empty')){
              $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight() );
          } else{
              //$('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight()  - $('.other_colors').outerHeight());
          }
      }
  }

  $('.you_might_also_like .product').on('click', function(){
      var url = $(this).find('a.product__image-link')[0];
      window.location.href = $(url).attr("href")
  })

  var currentImgUrl = null;
  var currentColors = null;
  var currentBadges = null;
  var currentOfferPrice;
  var currentOldPrice;
  var isCaseSlide = false;
  var currentOfferPriceNumber;
  var currentOldPriceNumber;

  //On mouse enter...
  $(document).on('mouseenter','#other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //pdp offer and list price
      currentOfferPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].offerPrice;
      currentOldPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].listPrice;

      currentOfferPriceNumber = parseFloat(currentOfferPrice.replace(/[^0-9\.-]+/g,""));
      currentOldPriceNumber = parseFloat(currentOldPrice.replace(/[^0-9\.-]+/g,""));

      if(isNaN(currentOldPriceNumber)) { 
          //prendilo da FE
          if($(".namePartPriceContainer .list-price").length >0) {
              currentOldPrice =$(".namePartPriceContainer .list-price")[0].innerHTML;
              currentOldPriceNumber = parseFloat(WCCurrencyJS.format(currentOldPrice)).toFixed(2);
          }
      }

      currentColors = $(".current-product-colors").html();
      var infos = $(this).find(".attr--list span");
      var colorsToPrint = ""
      var colorsToPrintDiv = "<div class='product-colors frameProduct'>"
      var subtitleToPrint = ""
      $(infos).each(function(index){

          if($(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span')) {
              subtitleToPrint += $(this).html();
          }
         // if((index == 1 || index == 3)) {
             //  if((!$(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span'))){

                  if($(this).hasClass('front-color-value')){
                      colorsToPrint += $(this).html();
                      colorsToPrintDiv +=  $(this).html();
                  }else if($(this).hasClass('lens-color-value')){
                      colorsToPrint += " /";
                      colorsToPrintDiv += " /";
                      colorsToPrintDiv += $(this).html();
                      colorsToPrintDiv += "</div>";
                  }
                      
            //  }
         // }
      });
      if(!colorsToPrintDiv.includes('</div>')){//for eyeglasses 
          colorsToPrintDiv += '</div>'
      }
      if(subtitleToPrint != "<div class='sizeAndFitContainer'>"){//there are no attributes of geo fit frame fit and polarised
          subtitleToPrint += '</div>';
          $(".current-product-colors").html(colorsToPrintDiv + subtitleToPrint );
      }else{
          $(".current-product-colors").html(colorsToPrint);
      }

      

      //init badge
      if($(".long-description-widget .badge-container").length > 0){
          currentBadges = $(".long-description-widget .badge-container").html();
          if($(this).find(".badge--list").length > 0){
              var badges = $(this).find(".badge--list").html();
              $(".long-description-widget .badge-container").html(badges);
          }
      }
      //finish badge

      //var productID =  $(this).find('.catalog__image--front').attr('data-partNumber');
      //var urlOfferPrice = '/wcs/resources/store/' + WCParamJS.storeId + '/price?q=byPartNumbers&partNumber=' + productID;
      
      var catEntryID =  $(this).find('.catalog__image--front').attr('data-catalogEntryID');
      var urlOldPrice  = '/wcs/resources/store/' + WCParamJS.storeId + '/display_price?q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=' + catEntryID; //prezzo barrato

      // q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=3074457345616683669&currency=USD&checkEntitlement=false&timestamp=1589464328709
      var srcUrl = $(this).find('.catalog__image--front').attr('data-src-hover');
      var imgHover = "<img src='" + srcUrl + "' style='margin-top:"+longDescriptionWidgetMarginTop+"px'/>"
      currentImgUrl = $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html();
      if($('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').hasClass('case')){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').removeClass('case');
          isCaseSlide = true;
      }
      $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html(imgHover);

      //mouseover item offer and list price
      var offerPriceItem = '';
      var oldPriceItem = '';

      //START Early Access    
      offerPriceItem =  $(this).data('price');;
      //END Early Access

      if(this.getElementsByClassName('list-price').length > 0)
          oldPriceItem = WCCurrencyJS.unformat(this.getElementsByClassName('list-price')[0].innerText);

      if(offerPriceItem){
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(offerPriceItem));
          if(oldPriceItem) {
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
              if(oldPriceItem > offerPriceItem){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          }
          else {// provo a interrogare il solr
              $.ajax({
                  url: urlOldPrice,
                  dataType: "json"}
              ).then(function(dataOld){
                  if (isEcommerceStoreJS === 'TRUE'
                      && dataOld !== undefined && dataOld[0].resultList !== undefined
                      && dataOld[0].resultList[0] !== undefined && dataOld[0].resultList[0].unitPrice !== undefined
                      && dataOld[0].resultList[0].unitPrice[0].price !== undefined &&  dataOld[0].resultList[0].unitPrice[0].price.value
                      ) {
                          oldPriceItem = parseFloat(dataOld[0].resultList[0].unitPrice);
                      }
                      if(oldPriceItem) {
                          $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
                          if(oldPriceItem > offerPriceItem){
                              $(".namePartPriceContainer .list-price").show();
                              updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
                          }
                          else{ 
                              $(".namePartPriceContainer .list-price").hide();
                              $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                          }
                      }
                      else {
                          $(".namePartPriceContainer .list-price").html("");
                          $(".namePartPriceContainer .list-price").hide();
                          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                      }
              }, function(){
                  console.log('error');
          })
          }
      } else {
          $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          $(".namePartPriceContainer .list-price").hide();
          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
      }
  });

 $(document).on('mouseleave', '.other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //On mouse leave...
    if(isCaseSlide){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').addClass('case')
      }
      $(".full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper").html(currentImgUrl);
      $(".current-product-colors").html(currentColors);
      if($(".long-description-widget .badge-container").length > 0){
        $(".long-description-widget .badge-container").html(currentBadges);
      }

      //restore base price
      var prescriptionPrice = $('.namePartPriceContainer .offer-price').attr('data-prescription-price')
      if(prescriptionPrice !== undefined && prescriptionPrice != "") {
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(prescriptionPrice))

          var prescriptionPriceOld = $('.namePartPriceContainer .list-price').attr('data-prescription-price')
          if(prescriptionPriceOld !== undefined && prescriptionPriceOld != "" && $(".namePartPriceContainer .list-price").length > 0){
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(prescriptionPriceOld))
              if(prescriptionPriceOld > prescriptionPrice){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(prescriptionPriceOld),WCCurrencyJS.unformat(prescriptionPrice));
              }
              else{
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }

          }
      } else {
          if(currentOfferPrice){
              $('.namePartPriceContainer .offer-price').html(currentOfferPrice);
              if(currentOfferPrice !== currentOldPrice && $('.namePartPriceContainer .list-price').length > 0) {
                  $('.namePartPriceContainer .list-price').html(currentOldPrice);
                  $(".namePartPriceContainer .list-price").show(); 
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(currentOldPrice),WCCurrencyJS.unformat(currentOfferPrice));
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          } else {
              $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          }
      }
      //START Early Access
      if (window.lastOfferPrice != ""
            && $('.namePartPriceContainer .offer-price').length > 0){
          $('.namePartPriceContainer .offer-price')[0].innerText = window.lastOfferPrice;
      } else replacePDPMainPrice(catEntryIdSubscribe);
      //END Early Access
  });

})



var isFirstTime = true;
var endSlider;
var startSlider;
function setStickyProductDetailsNavbar() {
  if(!$('.slot3').is(':visible')){
      if(isFirstTime) {
          startSlider = Math.round($(".product-details-slider").position().top);
          endSlider = Math.round($(".product-details-slider").height() + $(".product-details-slider").position().top);
          isFirstTime = false;
      }

      var tabHeight = 40;
      var heightBlackBar = $(".slot4.fixed-navbar").height();
      if((window.pageYOffset + heightBlackBar) > (startSlider) && (window.pageYOffset + heightBlackBar) < (endSlider - tabHeight)){
          //$("#tab-products-details").addClass("sticky-bar");
          $('.slot5').css('padding-top', $('.tab-bar').height() +'px');
      } else {
          $("#tab-products-details").removeClass("sticky-bar");
          $('.slot5').css('padding-top', 0);
      }
  }
  if($('.slot3').is(':visible')) {
      //$("#tab-products-details").removeClass("sticky-bar");
      $('.slot5').css('padding-top', 0);
  }
}

//editorial JS
  animationInit = function () {
    if ($('#page').hasClass('pdp')){
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            window.onscroll = function() {
               // var header = $('.slot4.fixed-navbar').get(0);
               // var positionSticky = header.offsetTop;
                //var slide = $('.slot3');
                //setStickyHeader(header, positionSticky, slide)
                setCtabarStickyDesktop();
                //event.preventDefault();
                //event.stopPropagation();
                //setStickyProductDetailsNavbar();
            }
        } else {
            //$('.slot4 .defining-attributes-widget').css('height', '0' );
            //window.addEventListener('scroll', animationScroll);
        }
      }
 }


function setStickyHeader (header, positionSticky, slide) {
  var st = window.pageYOffset || document.documentElement.scrollTop;

  if (st >= 20 && st > window.lastScrollTopBarAnimation && window.isFirstScrollStickyBar && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideUp();
      }
    //   $('#header').slideUp();
      $('[aria-describedby="quick_cart_container"]').hide();
      $('.freeShipping').slideUp();
      $('.long-description-widget').fadeOut();
      $('.bottom-section').css("bottom","auto");
      $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","auto");

      $("#tab-products-details").addClass("sticky-bar");

      $('.slot3').slideUp({
          duration:300,
          complete:function(){
              stickyTopDesktop();
              $(window).scrollTop(21);
          }
      });
      // if(!$(header).hasClass("sticky-top") && st >= scrollTopLimit){
      //     stickyTopDesktop();
      // }

  } else if(st < window.lastScrollTopBarAnimation && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if(!$('.slot3').is('visible') && st < 20){
          $('.slot3').slideDown({
              duration:300,
              complete:function(){
                  stickyBottomDesktop();
                  $(window).scrollTop(0);
                  }
              });
          $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","0px");
        $('.bottom-section').css("bottom","0px");
      }
  }

  window.lastScrollTopBarAnimation = st <= 20 ? 1 : st
}

function goBackToTopMobile () {
  $(window).scrollTop(0);
  hideHeaderTimeout.showHeader();
}

function createTopRecap(){
  $("#add2CartBtnNavBar").appendTo( "#fixed-top--mobile .cta-buttons" ).show();
  if($("#add2CartBtnDisabled").is(":visible")) $("#add2CartBtnNavBar").addClass('disabled')
  var url = 'https://assets.persol.com/is/image/Persol/8056597315685_000A.png?bgcolor=%23f7f7f7&impolicy=HB_parameters&wid=290&cropnorth=-7&cropsouth=-8';
  $("#fixed-top--mobile .navbar-product .product-image img").attr("src",url);
  $("#fixed-top--mobile .navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopMobile)
  var prodName = $(".long-description-widget .persol-product-title").html();
  $("#fixed-top--mobile .navbar-product .product-name").html(prodName);
}

var firstTime = true;
function animationScroll(){
  if(parseInt($('#header').css('z-index')) > parseInt($('.bottom-scrollable-section').css('z-index')) && $("#MiniShopCartProductAdded").length === 0) {
      $('#header').css('z-index', '5')
  }
  if($("#fixed-top--mobile .navbar-product .product-price").html().length == 0){
      $("#fixed-top--mobile .navbar-product .product-price").html($(".prices-container .offer-price").html());
  }
  var st = $(window).scrollTop();
  var scroll = st + $("#fixed-top--mobile").height();
  event.preventDefault();
  event.stopPropagation();

  if($("#fixed-top--mobile").hasClass("animation-show") && firstTime) {
      window.productDetailTop = $('.slot5').offset().top;
      window.endSlider = parseInt($("#product-detail-carousel").height() + $('.slot5').offset().top);
      firstTime = false
  }

  if (st > window.lastScrollTopMobile){
      if( st < window.heightHiddenActions ){
          $('.slot4 .defining-attributes-widget').outerHeight(st);
      }
      if(st >= window.heightHiddenActions){
          $('.slot4 .defining-attributes-widget').outerHeight(window.heightHiddenActions);
          $('.slot4').next().css('visibility', 'visible');
      }

      var windowHeight;
      if(isSafari()){
        windowHeight = window.innerHeight-100;
      }else{
        windowHeight = window.innerHeight;
      }

      if (st >= windowHeight){
          $("#fixed-top--mobile .navbar-product .product-name").show()
          $('#fixed-top--mobile').addClass('animation-show');
      }

      //fisso la barra product detail se è presente
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
              //$('#product-detail-carousel').css('padding-top', $('#tab-products-details').height() +'px');
          } else{
              $("#tab-products-details").removeClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          }
      }

  } else if( st < window.lastScrollTopMobile ) {
       // upscroll code
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          } else {
              $('#product-detail-carousel').css('padding-top', '0');
              $("#tab-products-details").removeClass("sticky-bar");
          }
      }

      if(st <= window.innerHeight){
          $("#fixed-top--mobile .navbar-product .product-name").hide()
          $('#fixed-top--mobile').removeClass('animation-show');
      }
      if(st <= window.heightHiddenActions ){
          $('.slot4').next().css('visibility', 'hidden');
          $('.slot4 .defining-attributes-widget').css('height', 0);
          hideHeaderTimeout.showHeader();
      }
  }
      window.lastScrollTopMobile = st <= 0 ? 0 : st;
}
function pinchZoom(){
  // if(window.mobilecheck() || window.tabletPortraitCheck()){
      $("#persol_popup-images-carousel .owl-item img").swipe( {
        pinchStatus:function(event, phase, direction, distance , duration , fingerCount, pinchZoom) {
          if(fingerCount >= 2){
              event.stopPropagation();
          }
          console.log("Pinch zoom scale "+pinchZoom +"Distance pinched "+distance+"Direction " + direction);
          $(this).css('transform', 'scale('+ pinchZoom +')');
          $('#persol_popup-images-carousel .owl-carousel .owl-wrapper-outer').css('overflow', 'visible')
        },
        fingers:2,
        pinchThreshold:0
      });
  // }
}
function stickyTopDesktop(){
  window.isFirstScrollStickyBar = false;
  var header = $('.slot4').get(0);
  //$(header).removeClass("sticky-bottom");
  $(header).addClass("sticky-top");
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Stickybar_AddCart")
  $(".estimated").hide();
  $(".navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopDesktop)
  var prodName = $(".long-description-widget .persol-product-title").html();
  var link = "<a>"+ $(".current-product-colors .product-colors").html().trim() +"</a>";
  $(".navbar-product .product-name").html(prodName);
  $(".navbar-product .product-colors").html(link);
  $(".navbar-placeholder").addClass("fixed-top-navbar");
  $(".bottom-section").addClass("fixed-top-navbar");
  $('.catalog-entry-recommendation-widget.other_colors').hide();/*wcag reason*/
  $('.navbar-product .product-image').focus();
}

function stickyBottomDesktop() {
  window.isFirstScrollStickyBar = true;
  var header = $('.slot4').get(0);
  $(header).removeClass("sticky-top");
  // if(!$("#add2CartBtnDisabled").is(':visible')){
      $(".estimated").show();
  $(header).addClass("sticky-bottom");
  $('.long-description-widget').show();
  $('.catalog-entry-recommendation-widget.other_colors').show();/*wcag reason*/
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Prod_AddCart")
  if(!$('#page').hasClass('pdp')) hideHeaderTimeout.showHeader();
  $(".navbar-placeholder").removeClass("fixed-top-navbar");
  $(".bottom-section").removeClass("fixed-top-navbar");
}

function goBackToTopDesktop(){
  $('.slot3').slideDown({
      duration:300,
      complete:function(){
          $(window).scrollTop(0);
          stickyBottomDesktop();
      }
  });
}

var hideHeaderTimeout = {

  hideHeader: function() {
      /*
      if($('[productAdded=yes]').length < 1){
          if($('#page').find('.ct-promo-bannerTop').length) {
              $('#bannerTop').slideUp();
          }
          $('#header').slideUp({
            complete:function(){
                setHeightFullImage(false)
            }
        })
        $('.freeShipping').slideUp()
        this.timeoutID = undefined;
    }
    */
  },

  showHeader: function() {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideDown();
      }
      $("#header").slideDown({
          complete:function(){
              setHeightFullImage(true)
          }
      });
      $('.freeShipping').slideDown()
      this.setup();
  },

  setup: function() {
    if (window.mobilecheck() || window.tabletPortraitCheck()){
      if (typeof this.timeoutID === 'number') {
          this.cancel();
      }
      this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);
    }
  },/*
  setup: function() {

    if (typeof this.timeoutID === 'number') {

        this.cancel();

    }

    this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);

},*/

  cancel: function() {
      window.clearTimeout(this.timeoutID);
  }
}

//wcag close popup pressing escape
$(document).keyup(function (e) {
  if (e.key === "Escape") {
      if ($('.presc').hasClass('showed-presc')) {
          $('#close-prescriptions').click();
      }
      if ($('.op-pdp-popup-other-colors').hasClass("active")) {
          togglePopupOtherColors(false);
      }
      if ($('.modal-background').is(':visible')) {
          $('.modal-background').toggle('hide');
      }
      if ($('#persol_popup-images').is(':visible')) {
        $("html").removeClass("overflow-hidden");
        $("#page-overflow-wrapper").removeClass("overflow-hidden");
    $('.col12.slot3').css('position','fixed');
        togglePopupCarosel(false);
      }
      if ($('.shopperActions--monogram--pop-up').is(':visible')) {
         $('#close-monogram').click();
      }
  }
});


// ON load risposto al top
window.addEventListener('load',function(){

  if ($('#page').hasClass('pdp')){

      setTimeout(function(){
          // scrollTo(0,-1);
          calculateDistances();
          // if(window.mobilecheck()|| window.tabletPortraitCheck()){
          handleSwipeBounce();
          // }
      },0);

      window.zIndexBS = $('.bottom-scrollable-section').css('z-index');
      hideHeaderTimeout.setup();

      if(!(window.mobilecheck()|| window.tabletPortraitCheck())){
          window.lastScrollTopBarAnimation = 0;
          window.isFirstScrollStickyBar = true;
          //trigger click you may also like
          $('.slot7 .owl-item  .product').on('click', function(){
              $(this).find('a.product__image-link')[0].click()
          })
      } else {
          $('.selector-area-wrapper .size-option').on('click', function(){
              for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
                  if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                      $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                      break;
                  }
              }
          });
      }

      if ($("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").length > 0) $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").show();
  }
});

function checkPromoCookie (){
  var promoCookie = getCookie("promoCalloutCookie");
  if (promoCookie == null) {
      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $(' .promo-callout').css('top', $('#header').outerHeight() + 10)
      }
      $(' .promo-callout-container').show()
  }
}
//wcag
function managePopupTabIndex(container, isOpen){
  if(isOpen){
      $(container).on('keydown', function(e){
          $(container).addClass('focus');
          $(container).focus();
          var focusableEls = $(container + " input:visible, "+ container + " button:visible, " + container + " a:visible, "+ container + " [tabindex]:not([tabindex='-1'])" )
          var firstFocusableEl = focusableEls[0];
          var lastFocusableEl = focusableEls[focusableEls.length - 1];
          var KEYCODE_TAB = 9;
          var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
          if (!isTabPressed) {
              return;
          }
          if ( e.shiftKey ) /* shift + tab */ {
              if (document.activeElement === firstFocusableEl) {
                  lastFocusableEl.focus();
                  e.preventDefault();
              }
          } else /* tab */ {
              if (document.activeElement === lastFocusableEl) {
                  firstFocusableEl.focus();
                  e.preventDefault();
              }
          }
      })
  } else {
      $(container).off('keydown');
  }
}


/**
* NEW LOGIC FOR FORMS NEWSLETTER
*/

/**
* Function that open the newsletter from footer
*/
$(document).on('click','#newsletter-wrapper .newsletter-subscribe span',function() {
 changeTabIndex($('.newsletter'));
 if(checkMobilePdpPage()){
     changeFooterIndex(true)
 }
 $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
 $('.newsletter--fade').show();
 $('body').addClass('no-scroll');
 $('body, html').css('height', '100%');
 $('body, html').css('overflow', 'hidden');
 $("#newsletter-wrapper").hide();
 $(this).attr("data-element-id","X_HP_OverlayNewsletter");
 tealiumPushHPNewsletterSticky($(this)[0]);
});

/**
* Function close sticky and save cookie
*/
$(document).on('click','#newsletter-wrapper .closebutton',function() {
    $("#newsletter-wrapper").fadeOut('fast');
    setCookie("WELCOME_STICKY_SHOWN_"+storeDirectory,true,{expires: 10000,path: "/", domain: cookieDomain});
    $('body').removeClass('no-scroll');
    $('body, html').css('overflow', 'auto');
});

function setHeightFullImage(showHeader) {
    var longDescriptionWidgetMarginTop = $('#header').height();
    if($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        longDescriptionWidgetMarginTop += $('.ct-promo-bannerTop').height();
        $('.bottom-scrollable-section').addClass('visible-bannerTop');
    } else {
        $('.bottom-scrollable-section').removeClass('visible-bannerTop');
    }

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      if (!$("#image-soldOut").is(":visible")) {
          var fullHeight = window.innerHeight - 160;
          var fullHeightNoColor = window.innerHeight - 80;
        //   $('.full-image-widget').not('.no-prescription.other-colors-empty').css('height', fullHeight + 'px');
      }
      $('.full-image-widget.no-prescription.other-colors-empty').css('height', fullHeightNoColor + 'px')

      if($('.full-image-widget').hasClass("no-prescription") && $('.full-image-widget').hasClass("other-colors-empty")){
          $(".bottom-section").addClass("no-colors")
      }

      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          //$(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
         //$(".long-description-widget").css("margin-top", "0");
          //$(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }else {
      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          $(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
          //$(".long-description-widget").css("margin-top", "0");
          $(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }
}

/**
* Function for check email
*/
function validateFormNewsletter() {
  //var inputValue = $('#mce-EMAIL').val();
  var inputValue = $('#newsletterEmail').val();

  if (inputValue == '') {
      $('#mce-error-response').show();
      $('#mce-error-response').children().hide();
      $("#mce-error-response-empty").show();
  } else {
      $('#mce-error-response').css('display') != 'none' ? $('#mce-error-response').hide() : '';
      $('#mce-error-response').css('display') != 'none' ? $('#mce-success-response').hide() : '';

      //if (validateEmail(inputValue)) {
      if (!validateEmail(inputValue)) {
          $('#mce-error-response').show();
          $('#mce-error-response').children().hide();
          $('#mce-error-response-invalid').show();
      }
      else {
          $('#mc-embedded-subscribe-form').submit();
      }
  }
}

/* Function to validate the email */
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}


$(document).ready(function () {
  /**
  * Function that open the newsletter from nav menu in desktop mode
  * and hide the nav menu
  */
  $('.nav-social__item-newsletter').click(function () {
      $('.header__nav-close').click();
      setTimeout(function () {
          $('.newsletter').addClass('opend').find(':focusable').first().focus().addClass('focus');
          $('.newsletter--fade').show();
          $('body').addClass('no-scroll');
          $('body, html').css('height', '100%');
          $('body, html').css('overflow', 'hidden');
          changeTabIndex($('.newsletter'));
      }, 500);
  });

  /**
  * Function that open the newsletter from nav menu in mobile mode
  */
  $('.nav-user__item--newsletter').click(function () {
      changeTabIndex($('.newsletter'));
      if(checkMobilePdpPage()){
          changeFooterIndex(true)
      }
      $('.newsletter').addClass('opend');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
  });

  /**
  * Function that open the newsletter from footer
  */
  $('.newsletter-cta__button, #segment-subscribe-cta').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(true);
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").hide();
      }
  });

  /**
  * Function that close the newsletter
  */
  $('.newsletter__close').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(false)
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter').removeClass('opend');
      $("#footerWrapper").removeClass("footer-pop-open");
      $('.newsletter--fade').hide();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").show();
      }
  });

  /**
  * Function that close the newsletter when click in fade layer
  */
  $('.newsletter--fade').click(function () {
      $('.newsletter__close').click();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
  });

}).mouseup(function (e) {

});


function printEllipsis (text) {
  var checkForSpace = true;
  var index = 250;

  if(text.length < index) return;
  while (checkForSpace) {
      if(text[index] === " " || index > 300) {
          checkForSpace = false;
          // index = 180;
      } else {
          index++;
      }
  }

  return text.slice(0, index) + "...";
}


//open pop up klarna payment page
function openPopup(){
  $('.pop-container iframe').eq(0).attr('scrolling','yes');
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      $(".pop-container.only-mobile").css('display','block');
      bodyScrollLock.disableBodyScroll(document.querySelector('.pop-wrap'));
  } else {
      $(".pop-container.only-desktop").css('display','block');
  }
  $("body").css("overflow","hidden");
$(".pop-bg, .pop-x").bind("click", function() {
  pop_close();
});

}

function pop_close() {
  $(".pop-container").css('display','none');
  $("body").css("overflow","auto");
$("body").unbind("click");
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      bodyScrollLock.enableBodyScroll(document.querySelector('.pop-wrap'));
  }
}

function updateLastOfferUpsell(upsell){
//HB-7718
lastOfferPrice=$('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '');

/*Now we create a div with list price and offer price of upsell product.
this div will be used into:
in productPageAdd2Cart (present in CommonUtilities) to set the pst in minicart.
In the end of this function we will remove this div*/

$('body').append('<div id="upsell-added-inicart"><span id="upsell-list-price">' + $('.espot-complete-order-upsell #listPrice_' + upsell).text().replace(/\s/g, '') + ' </span><span id="upsell-offer-price">' + $('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '') + '</span></div>')
  if(typeof tealiumProducts === 'undefined'){
      tealiumProducts = {};
  }
  var upSellDetails = $('[data-catentry-id='+upsell+'] .product_name a');
  var upsellSku = upSellDetails.length > 0 ? upSellDetails[0].dataset.partnumber : upsell;
  if (typeof tealiumProducts[upsellSku]=== 'undefined'){
      var tealiumProduct = {};

      var listPrice = $('#listPrice_'+upsell).length > 0 ? cleanPrice($('#listPrice_'+upsell)[0].innerText) : '';
      var offerPrice = $('#offerPrice_'+upsell).length > 0 ? cleanPrice($('#offerPrice_'+upsell)[0].innerText) : '';
      if (listPrice != ""){
          listPrice = parseFloat(listPrice).toFixed(2);
      }
      else 
          listPrice = parseFloat(offerPrice).toFixed(2);

      if (offerPrice != ""){
          offerPrice = parseFloat(offerPrice).toFixed(2);
      }
      
      tealiumProduct['Sku']= upsellSku;
      tealiumProduct['ModelName']= upSellDetails.length > 0 ? upSellDetails[0].dataset.description : '';
      tealiumProduct['Category'] = upSellDetails.length > 0 ? upSellDetails[0].dataset.category.toUpperCase() : '';
      tealiumProduct['Price'] = offerPrice;
      tealiumProduct['Status'] = "Available";
      tealiumProduct['PriceFull'] = listPrice;
      tealiumProduct['Engraving'] = "N";
      tealiumProduct['Brand'] = currentBrand;
      tealiumProduct['Units'] = 1;
      
      tealiumProducts[upsellSku] = tealiumProduct;
  } else {
      tealiumProducts[upsellSku].Units++;
  }       
}

function checkEditFormInputs(){
    $(".myAccountSummary .form-group .input_field, .myAccountSummary .form-group .input_field_myacc").each(function(){
        if ($(this).val() == ''){
            $(this).siblings("label").removeClass("labelOnTop");
        } else {
            $(this).siblings("label").addClass("labelOnTop");
        }
    });
}

function setDDMPosition(){
    $("#all_section section").each(function(index,singleSection){
        if ($('#page').hasClass('plp')){
            $( singleSection ).css('top', $('#headerWrapper').height()-$('.ct-global--slider-container.ct-strip').height());
        } else {
            var globalBannerHeight = $('#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner').height();
            if(globalBannerHeight === undefined){
            globalBannerHeight = 0;
            }
            var headerHeight = $('#header').height();
            if ($('#page').hasClass('pdp')){
                headerHeight = $('.header__row1-wrapper').outerHeight(); 
            }
            $( singleSection ).css('top', headerHeight+globalBannerHeight-1); 
        }
    });
}

$(window).scroll(function() {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
});

function callAlgoliaServiceEspot(idSection){
    //I caroselli di algolia nel ddm sono inseriti qui
    if(idSection == '#departmentLink_sun_Section'){
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
        }
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_IconsCards')){
            loadHeaderEspot("X_Header_NavSunglasses_IconsCards"); 
        }
    }
    else if (idSection == '#departmentLink_eyes_Section') {
        if(!isEspotAlreadyLoaded('X_Header_NavEyeglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
        }
    }
    
}

function isEspotAlreadyLoaded(idContainer){
    var container = document.getElementById(idContainer);
    return container.childElementCount != 0;
}

document.addEventListener("DOMContentLoaded", function(event) {
  var lazyImages =[].slice.call(
   document.querySelectorAll(".telecomando-lower-container picture")
  )
  let lazyImageCheck = false; 
  if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
     let lazyImageObserver = 
      new IntersectionObserver(function(entries, observer) {
         entries.forEach(function(entry) {
          if (entry.isIntersecting) {      
             let lazyImage = entry.target;
             lazyImage.lastElementChild.style.display = "block";
             lazyImageObserver.unobserve(lazyImage);
             lazyImageCheck = true;
           }
        });
         if(lazyImageCheck){
        	 setTimeout(function () {      
            	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
             }, 3000); 
         }
       });

     lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
     });
  } else {
    
    // Not supported, load all images immediately
    let active = false;
 
    const lazyLoad = function() {
      if (active === false) {
        active = true;
        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.lastElementChild.style.display = "block";
              lazyImageCheck = true;
              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });
  
              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
            if(lazyImageCheck){
	        	setTimeout(function () {      
	              	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
	            }, 3000);
            }
          });
  
          active = false;
        }, 200);
      }
    };
  
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
   }
 });


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides utility functions for the order check-out pages.
 */

/**
 * The functions defined in this class are used for managing order information update during check-out.
 *
 * @class This CheckoutHelperJS class defines all the variables and functions for the page(s) used in the check-out process to udpate order related information, such as address, shipping method, shipping instruction, etc.
 *
 */
CheckoutHelperJS = {
    /* Global variable declarations */

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */

    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of the order, in case the current shopping cart is not being used. Its default value is empty.
     */
    orderId: "",

    /**
     * This variable stores the shipment type, either 1 for single shipment or 2 for multiple shipment. Its default value is set to empty.
     * @private
     */
    shipmentTypeId: "",


    /**
     * This array stores the item IDs in an order. It is used to save the item IDs before an address is edited or created during the order check-out.
     * @private
     */
    orderItemIds: [],

    /**
     * This constant stores the amount of time in milliseconds that the <code>updateCartWait</code> function needs to wait before updating the shopping cart.
     * @private
     * @constant
     * @see CheckoutHelperJS.updateCartWait
     */
    updateWaitTimeOut: 1500,

    /**
     * This array stores the number of key press events after a shopper has modified the quantity of an item in the shopping cart.
     * @private
     * @see CheckoutHelperJS.updateCartWait
     */
    keyPressCount: {},

    /**
     * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
     * be a two step process where shipping is captured in first step and billing in second step.
     * It is set to true by default.
     *
     * @private
     */
    singlePageCheckout: true,

    /**
     * This array stores the address ID before it is updated by the user during the order check-out.
     * @private
     */
    selectedAddressesArray: {},

    /**
     * This array stores the values that indicate if the payment method input in a payment area has been changed by the user.
     *
     * @private
     */
    dataDirty: {},

    /**
     * This variable stores a value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     * Its default value is set to false.
     *
     * @private
     */
    fieldDirtyFlag: false,

    /**
     * This constant stores the String value representing a date that the service understands to reset a requested shipping date.
     * @private
     * @constant
     */
    resetRequestedShipDateValue: "1970-01-01T00:00:00.000Z",

    /**
     * This variable stores the value that indicates if the current page is the Shopping Cart page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    shoppingCartPage: false,

    /**
     * This variable stores the value that indicates if the current page is the pending order details page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    pendingOrderDetailsPage: false,

    /**
     * This variable stores the value that indicates if the requested shipping date has recently been updated. It is used to determine if certain area of the page needs to be refreshed.
     */
    RequestShippingDateAction: false,

    /**
     * Indicates whether the ShippingChargeType flexflow is enabled.
     */
    shipChargeEnabled: false,

    /**
     * The order ID.
     */
    tempOrderId: "",
    /**
     * The type of the current user.
     */
    tempUserType: "",
    /**
     * The list of emails spearated by space. Order confirmation will be sent to these emails.
     */
    tempEmailAddresses: "",
    /**
     * Indicates whether it is a Quote that is being checked out.
     */
    tempIsQuote: false,

    /**
     * The current order total.
     */
    tempOrderTotal: "0",

    /**
     * used to check if the zip code is changed
     */
    zipCountShoppingCart : 0,

    /**
     * The payment instructions allocated in the order.
     */
    tempPaymentInstructions: {},
    lastAddressLinkIdToFocus: "",
    lastFocusId: "",
    setLastFocus: function (id) {
        this.lastFocusId = id;
    },
    getLastFocus: function () {
        return this.lastFocusId;
    },
    tabPressed: function (event) {
        if (event.keyCode == 9) {
            tabPressed = true;
        }
    },
    setLastAddressLinkIdToFocus: function (lastLinkId) {
        this.lastAddressLinkIdToFocus = lastLinkId;
    },
    getLastAddressLinkIdToFocus: function () {
        return this.lastAddressLinkIdToFocus;
    },

    /**
     * Indicates whether the order is prepared already or not.
     */
    orderPrepared: "false",

    /**
     * Sets the orderPrepared variable to indicate whether the order has been through the OrderPrepare command or not. An order must be prepared before it can be submitted.
     *
     * @param {Boolean} inPrepareIndicator Whether or not the order has been prepared.
     */
    setOrderPrepared: function (inPrepareIndicator) {
        this.orderPrepared = inPrepareIndicator;
    },

    /**
     * Returns whether or not the order is prepared.
     */
    isOrderPrepared: function () {
        return this.orderPrepared;
    },

    /**
     * Save some variables needed for re-calling checkoutOrder method after a service call.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails spearated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    saveCheckoutOrderParameters: function (orderId, userType, addressListForMailNotification, isQuote) {
        this.tempOrderId = orderId;
        this.tempUserType = userType;
        this.tempEmailAddresses = addressListForMailNotification;
        this.tempIsQuote = isQuote;
    },

    /**
     * Sets some internal variables needed for verifying order totals.
     *
     * @param {Object} orderTotal The current order total.
     * @param {Object} paymentInstructions The currently allocated payment instructions for the order.
     */
    setOrderPayments: function (orderTotal, paymentInstructions) {
        this.tempOrderTotal = orderTotal + 0;
        this.tempPaymentInstructions = paymentInstructions;
    },

    /**
     * Returns whether or not the order total amount has been fully allocated with payment instructions.
     */
    isOrderPaymentFullyAllocated: function () {
        var allocatedAmount = 0;
        if (this.tempPaymentInstructions.paymentInstruction != null && this.tempPaymentInstructions.paymentInstruction.length >= 1) {
            for (var i = 0; i < this.tempPaymentInstructions.paymentInstruction.length; i++) {
                allocatedAmount = allocatedAmount + parseFloat(this.tempPaymentInstructions.paymentInstruction[i].piAmount);
            }
        }

        if (allocatedAmount == this.tempOrderTotal) {
            return true;
        } else {
            var roundedAllocatedAmount = allocatedAmount.toFixed(2);
            var roundedTempOrderTotal = this.tempOrderTotal.toFixed(2);
            if (roundedAllocatedAmount == roundedTempOrderTotal) {
                return true;
            } else {
                if (allocatedAmount < this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
                    return false;
                } else if (allocatedAmount > this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
                    return false;
                } else {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
                    return false;
                }
            }
        }
    },

    /**
     * Returns the value of the internal variable with that name.
     *
     * @param {Object} paramName The value of the internal parameter.
     */
    getSavedParameter: function (paramName) {
        return this[paramName];
    },

    /**
     * Sets the ShipChargeEnabled variable to indicate whether the ShippingChargeType feature is enabled.
     *
     * @param {Boolean} enabled This parameter is set to true if the ShippingChargeType feature is enabled.
     */
    setShipChargeEnabled: function (enabled) {
        this.shipChargeEnabled = enabled;
    },

    /**
     * This function updates the input associative array params with the input key-value pair.
     * If the toArray value is true, this function creates an associative array for duplicate entries; otherwise it overwrites the existing array.
     * The function is used for updating input parameters before passing them to a service call.
     *
     * @param {Array} params The associative array to update.
     * @param {String} key The key to search for in the array.
     * @param {String} value The new value to update with when the key has been found in the array.
     * @param {Boolean} toArray If the value is true, then the function creates a new array for duplicate entries. If the value is false, no new array will be created, the existing array will be overwritten.
     * @param {Integer} index The index in the array in which the value should be updated.
     *
     * @returns {Array} params The updated associative array.
     */
    updateParamObject: function (params, key, value, toArray, index) {
        if (params == null) {
            params = [];
        }

        if (params[key] != null && toArray) {
            if ($.isArrayLike(params[key])) {
                //3rd time onwards
                if (index != null && index != "") {
                    //overwrite the old value at specified index
                    params[key][index] = value;
                } else {
                    params[key].push(value);
                }
            } else {
                //2nd time
                var tmpValue = params[key];
                params[key] = [];
                params[key].push(tmpValue);
                params[key].push(value);
            }
        } else {
            //1st time
            if (index != null && index != "" && index != -1) {
                //overwrite the old value at specified index
                params[key + "_" + index] = value;
            } else if (index == -1) {
                var i = 1;
                while (params[key + "_" + i] != null) {
                    i++;
                }
                params[key + "_" + i] = value;
            } else {
                params[key] = value;
            }
        }
        return params;
    },


    /**
     * This function shows or hides the request shipping date input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderItemAddressShipMethodUpdate</code> service will be called to update the shipping information.
     *
     * @param {String} checkBoxName The ID of the request shipping date checkbox.
     * @param {String} divName The name of the div element that contains the request shipping date input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkRequestShippingDateBox: function (checkBoxName, divName, suffix) {
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            checkBoxName = checkBoxName + "_" + suffix;
            divName = divName + "_" + suffix;
        }

        var checkBox = $("#" + checkBoxName)[0];

        if (checkBox.checked) {
            $("#" + divName).css("visibility", "visible");
            $("#" + divName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + divName).css("visibility", "hidden");
            $("#" + divName).css("display", "none");
            if (this.shipmentTypeId == "1") {
                $("#requestedShippingDate").blur();
            } else if (this.shipmentTypeId == "2") {
                $("#MS_requestedShippingDate_" + suffix).blur();
            }
        }

        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete the requestedShippingDate if the checkBox is unchecked
        if (!checkBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            this.updateParamObject(params, "addressId", addressId, false, -1);
            this.updateParamObject(params, "shipModeId", shipModeId, false, -1);

           if($("#requestedShippingDate") != null || $("#MS_requestedShippingDate_" + suffix) != null){
                if(this.shipmentTypeId == "1") {
                    params["requestedShipDate"] = this.resetRequestedShipDateValue;
                } else {
                    this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false, -1);
                }
            }

            var orderItemId = null;
            var qty = -1;
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null) {
                    qty = document.getElementById("qty_" + (i + 1)).value;
                }
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                // we need atleast one orderItemId..this is the limitation of order service..
                if (qty != -1) {
                    if (this.shipmentTypeId == "1") {
                        // Single Shipment
                        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                        break;
                    } else if (this.shipmentTypeId == "2") {
                        // Multiple Shipment
                        if (suffix != null && suffix != "" && orderItemId == suffix) {
                            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                            break;
                        }
                    } else {
                        console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
                    }
                }
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            CheckoutHelperJS.RequestShippingDateAction = true;
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        }
    },


    /**
     * This function shows or hides the shipping instruction input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderShippingInfoUpdate</code> service will be called to update the shipping information.
     * Note that order items that have the same ship-to address and shipping method will share the same shipping instruction.
     *
     * @param {String} checkBoxName The ID of the shipping instruction checkbox.
     * @param {String} divName The name of the div element that contains the shipping instruction input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkShippingInstructionsBox: function (checkBoxName, divName, suffix) {
        //var divName = "shippingInstructionsDiv";
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            thisCheckBoxName = checkBoxName + "_" + suffix;
            thisDivName = divName + "_" + suffix;
        } else {
            thisCheckBoxName = checkBoxName;
            thisDivName = divName;
        }

        var thisCheckBox = $("#" + thisCheckBoxName)[0];

        if (thisCheckBox.checked) {
            $("#" + thisDivName).css("visibility", "visible");
            $("#" + thisDivName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + thisDivName).css("visibility", "hidden");
            $("#" + thisDivName).css("display", "none");
        }

        // Update other shipping instructions div with same addressId and shipModeId..
        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            var orderItemId, tempAddressId, tempShipModeId = "";

            //get current div's shipModeId and addressId..
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;

            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                    orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                    tempAddressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    tempShipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                    if (tempShipModeId == shipModeId && tempAddressId == addressId) {
                        var tempDivName = divName + "_" + orderItemId;
                        var tempCheckBoxName = checkBoxName + "_" + orderItemId;
                        if (thisCheckBox.checked) {
                            $(tempDivName).css("visibility", "visible");
                            $(tempDivName).css("display", "block");
                            $(tempCheckBoxName).attr("checked", "checked");
                }
                        else {
                            //User doesnt want to specify shipping instructions and requested ship date..hide this div..
                            $("#" + tempDivName).css("visibility", "hidden");
                            $("#" + tempDivName).css("display", "none");
                            $("#" + tempCheckBoxName).attr("checked", "");
                        }
                    }
                }
            }
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete shippingInstructions if the checkBox is unchecked
        if (!thisCheckBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            var orderItemId = null;
            if (this.shipmentTypeId == "1") {
                if (document.getElementById("shipInstructions") != null) {
                    this.updateParamObject(params, "shipInstructions", "", false);
                    document.getElementById("shipInstructions").value = "";
                }
                orderItemId = document.getElementById("orderItem_1").value;
                this.updateParamObject(params, "addressId", addressId, false);
                this.updateParamObject(params, "orderItemId", orderItemId, false);

            } else if (this.shipmentTypeId == "2") {
                if (suffix != null && suffix != "") {
                    if (document.getElementById("MS_shipInstructions_" + suffix) != null) {
                        this.updateParamObject(params, "shipInstructions", "", false);
                        document.getElementById("MS_shipInstructions_" + suffix).value = "";
                    }
                    this.updateParamObject(params, "addressId", addressId, false, -1);
                    this.updateParamObject(params, "orderItemId", suffix, false);
                    this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, "");
                }
            } else {
                console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            wcService.invoke("OrderShippingInfoUpdate", params);
        }
    },


    /**
     * This function sets the shipment type for the current page.
     *
     * @param {Integer} shipmentTypeId The shipment type ID, 1 for single shipment or 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.getShipmentTypeId
     */
    initializeShipmentPage: function (shipmentTypeId) {
        this.shipmentTypeId = shipmentTypeId;
    },


    /**
     * This function sets the common parameters for the current page, i.e. language ID, store ID and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    },


    /**
     * This function deletes an order item from the shopping cart.
     * If forWishlist is true, then the item is added to the wish list subsequently by calling the <code>AjaxDeleteOrderItemFromCart</code> service.
     *
     * @param {Integer} orderItemId The ID of the order item to delete.
     * @param {Boolean} forWishlist If the value is true, then the item is added to the wish list.
     */
    deleteFromCart: function (orderItemId, forWishlist) {

        var params = [];
        params.storeId = this.storeId;
        params.catalogId = this.catalogId;
        params.langId = this.langId;
        params.orderId = (this.orderId != null && this.orderId != 'undefined' && this.orderId != "") ? this.orderId : ".";
        params.orderItemId = orderItemId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.check = "*n";
        params.calculateOrder = "1";

        var x = document.getElementById("totalNumberOfItems").value;
        var y = x;
        //Now remove free items from this total number of items count..
        //x = total items and y = totalItems - totalFreeItems
        for (var i = 0; i < x; i++) {
            var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
            if (qtyObj != null || qtyObj != undefined) {
                qty = qtyObj.value;
                if (qty != null && qty != undefined && qty == -1) {
                    y = y - 1;
                }
            }

        }

        if(sessionStorage.barberiniOrderItem == orderItemId)
            sessionStorage.removeItem('barberiniOrderItem');
        
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        if (isOliver || isCarol){

            if (forWishlist) {
                wcService.invoke("AjaxDeleteOrderItemFromCart", params);
            } else {
                if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                    wcService.invoke("AjaxDeleteOrderItem", params);
                } else {
                    // HB-3398 : avoid timeout on iphone when vpn is connected.
                    /*$.ajaxSetup({
                        timeout: 2000 //Time in milliseconds
                    });*/ 
                    wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                }
            }
            // HB-1050 :: workaround
            //setTimeout(function() { window.location.href = window.location.href; }, 500);

        } else {

            if (y == 1) {
                wcService.invoke("AjaxDeleteOrderItem1", params);
            } else {
                if (forWishlist) {
                    wcService.invoke("AjaxDeleteOrderItemFromCart", params);
                } else {
                    if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                        wcService.invoke("AjaxDeleteOrderItem", params);
                    } else {
                        wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                    }
                }
            }
        }
    },

    /**
     * Only for Persol
     */
    updateDeletePresc: function () {
        var countPrescription = parseInt($("#countPresc").val());
        if (countPrescription <= 2){
            $(".prescription__wrapper-error-msg").hide();
            $("#WC_CheckoutLogonf_div_3").show();
            $(".checkout_or_seperator").show();
            $(".paypal_button_container").show();
        }
    },


    /**
     * This function is used to update the ship-to address ID of all items in the current order when the user chooses to add a new address during order check-out.
     * This function calls the <code>AjaxUpdateOrderItemsAddressId</code> service.
     *
     * @param {Integer} addressId The ID of the newly created address.
     */
    updateAddressIdOFItemsOnCreateEditAddress: function (addressId) {
        if (this.shipmentTypeId == "2" && this.orderItemIds.length == 0) {
            // If this is multiple shipment and none of the orderItems addressId is same as modified addressId, then no need make a service call.
            return;
        }
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        if (this.shipmentTypeId == "1") {
            params.addressId = addressId;
        } else {
            var orderItemId = null;
            for (var i = 0; i < this.orderItemIds.length; i++) {
                orderItemId = this.orderItemIds[i];
                this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                this.updateParamObject(params, "addressId", addressId, false, -1);
            }
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxUpdateOrderItemsAddressId", params);
    },


    /**
     * This function is used to save the current order items list when the user edits an existing address or creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressId The ID of the address.
     *
     * @private
     */
    saveOrderItemsList: function (orderItemId, addressId) {
        if (orderItemId == '-1') {
            //Creating or editing shipping address for single shipment, get all the orderItemIds in the order..

            var totalItems = document.getElementById("totalNumberOfItems").value;
            // if order item section is collapsed, we only have data for the first order item. And this is the case for single shipment so it
            // is ok just to update orderItem_1
            this.orderItemIds[0] = document.getElementById("orderItem_1").value;

        } else if (orderItemId == 0 && this.shipmentTypeId == "1") {
            // Editing or creating billing address.. If it's single shipment type, then we need to save all orderItem Id's.
            // If the shipping address is same as this billing address which is edited, then after editing this addressId will change, so we need to update the orderItemIds.

            if (document.getElementById("singleShipmentAddress")) {
                if (addressId == document.getElementById("singleShipmentAddress").value) {
                    var totalItems = document.getElementById("totalNumberOfItems").value;
                    for (var i = 0; i < totalItems; i++) {
                        this.orderItemIds[i] = document.getElementById("orderItem_" + (i + 1)).value;
                    }
                } else {
                    this.orderItemIds = [];
                }
            } else {
                this.orderItemIds = [];
            }
            return;
        } else {
            // OrderItemId is passed..so it's multiple shipment, get all the orderItemIds with the same address...
            // This section is for multiple shipment and create/edit both shipping/billing address...
            var totalItems = document.getElementById("totalNumberOfItems").value;
            var temp = null;
            var orderItemId = null;
            var j = 0;

            //saving orderItemIds (used by this.updateAddressIdOFItemsOnCreateEditAddress) for  the'edit address' link
            for (var i = 0; i < totalItems; i++) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                if (document.getElementById("MS_ShipmentAddress_" + orderItemId)) {
                    temp = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    //addressId is -1 if 'create address' is clicked. The following if will always return false in that case.
                    if (temp == addressId) {
                        //Add this to our list..
                        this.orderItemIds[j++] = orderItemId;
                    }
                }
            }
        }
    },


    /**
     * By convention, all items in an order that have the same shipping address and shipping mode share the same shipping instruction.
     * This function is used to update the shipping instruction of all items that have the same shipping address and shipping mode.
     *
     * @param {Integer} addressId The shipping address ID.
     * @param {Integer} shipModeId The shipping mode ID.
     * @param {String} shipInstructions The shipping instruction.
     */
    setShippingInstuctionsForAllOtherItems: function (addressId, shipModeId, shipInstructions) {

        var orderItemId, addressId1, shipModeId1 = "";
        var totalItems = document.getElementById("totalNumberOfItems").value;
        for (var i = 0; i < totalItems; i++) {
            if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                addressId1 = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                shipModeId1 = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                if (shipModeId1 == shipModeId && addressId1 == addressId) {
                    document.getElementById("MS_shipInstructions_" + orderItemId).value = shipInstructions;
                }
            }
        }
    },


    /**
     * When a user toggles the 'ship as complete' checkbox, the same will be updated at the server side by invoking the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} checkBox The 'ship as complete' checkbox object.
     */
    shipAsComplete: function (checkBox) {
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        if (checkBox.checked) {
            this.updateParamObject(params, "ShipAsComplete", "true", true);
        } else {
            this.updateParamObject(params, "ShipAsComplete", "false", true);
        }
        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * When there is an invalid address ID in an order, this function updates all items to use the valid address ID by invoking the <code>AjaxSetAddressIdOfOrderItems</code> service.
     *
     * @param {Integer} addressId A valid address ID.
     */
    updateAddressIdForOrderItem: function (addressId) {
        if (addressId == null || addressId.length == 0) {
            return true;
        }

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false);
        wcService.invoke("AjaxSetAddressIdOfOrderItems", params);
    },


    /**
     * When there is an invalid shipping mode ID in an order, this function updates all items to use the valid shipping mode ID by invoking the <code>AjaxSetShipModeIdForOrder</code> service.
     *
     * @param {Integer} shipModeId A valid shipping mode ID.
     */
    updateShipModeIdForOrder: function (shipModeId) {
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["shipModeId"] = shipModeId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        wcService.invoke("AjaxSetShipModeIdForOrder", params);
    },

    /**
     * When there is an inconsistent requested ship date in an order when multiple shipment is disabled,
     * this function updates all items to use the the same date by invoking the <code>AjaxSetRequestedShipDateForOrder</code> service.
     *
     * @param {String} date The String representation of the requested ship date
     */
    updateRequestedShipDateForOrder: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        if (date != "") {
            this.updateParamObject(params, "requestedShipDate", date, false);
        } else {
            this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false);
        }

        wcService.invoke("AjaxSetRequestedShipDateForOrder", params);
    },



    /**
     * This function is used to apply a promotion code to the order.
     *
     * @param {String} formName The name of the promotion code entry form.
     * @param {String} returnView   The name of the view that the server should redirect the browser to after a promotion code is applied.
     */
    applyPromotionCode: function (formName, orderId) {

        var form = document.forms[formName];
        form.promoCode.value = trim(form.promoCode.value);
        
        /* START - Early Access */
        if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
        	var eaPromoCodeFlag=true;
           /* if (form.promoCode.value == 'NL-EA21-11' || form.promoCode.value == 'WCL-EA21-11' || form.promoCode.value == 'PFM-EA21-11'){
            	eaPromoCodeFlag = true;
            } else eaPromoCodeFlag = false;
        	*/
        	errorMessage = (eaPromoCodeFlag == true) ? $('#early_access_text').attr('value') : $('#generic_error_text').attr('value');
        	$(form.promoCode).addClass("error");
        	addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
        	if (eaPromoCodeFlag == true){
	        	$('#PromotionCodeForm input#promoCode.error, #PromotionCodeForm input#coupon-value.error').addClass('ea_input');
	        	$('#PromotionCodeForm .error-message').addClass('ea_message');
        	}
            restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            return;
        }else{
        /* END - Early Access */
        //TODO Commonize this 'if'
        
        if (isCarol){
            if (form.promoCode.value == "") {
                MessageHelper.formErrorHandleClient(form.promoCode.id, MessageHelper.messages["PROMOTION_CODE_EMPTY"]);
                return;
            }
        } else {
            var promoCodeValue = form.promoCode.value;
            $(form.promoCode).removeClass("error");
            removeErrorMessagesFromElement(document.forms.PromotionCodeForm);

            var errorMessage = "";

            if (promoCodeValue == ""){
                errorMessage = MessageHelper.messages["PROMOTION_CODE_EMPTY"];
            } else if (promoCodeValue.toUpperCase().includes("IDME_")){
                // Avoid users to manualy insert promocodes that could be valid IDME promocodes
                errorMessage = "Code not allowed";
            }

            if (errorMessage != "") {
                $(form.promoCode).addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
                return;
            }
        }

        service = wcService.getServiceById('AjaxPromotionCodeManage');

        var params = [];
        params["taskType"] = "A";
        params["promoCode"] = trim(form.promoCode.value);
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeManage', params);
    	}
    },


    /**
     * This function is used to remove a promotion code from the order.
     *
     * @param {String} promoCode    The promotion code to remove.
     */
    removePromotionCode: function (promoCode, orderId) {
        sessionStorage.removeItem('Order_DiscountCode');
        sessionStorage.removeItem('Order_DiscountName');
        var params = [];
        params["taskType"] = "R";
        params["promoCode"] = promoCode;
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

       //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeDelete',params);

    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has not been applied to an order then this function can be used to apply that coupon to the current order.
     *
     * @param {String} formName The name of the form that performs the action to apply the coupon, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    applyCoupon: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "A";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsAdd');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsAdd');
    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has been applied to an order then this function can be used to remove that coupon from the current order.
     *
     * @param {String} formName The name of the form that performs the action to remove the coupon from the order, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    removeCouponFromOrder: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "R";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsRemove');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsRemove');
    },


    /**
     * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
     *
     * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
     *
     * @see CheckoutHelperJS.isSinglePageCheckout
     */
    setSinglePageCheckout: function (singlePageCheckout) {
        this.singlePageCheckout = singlePageCheckout;
    },


    /**
     * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     *
     * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
     * enabled/disabled.
     *
     * @see CheckoutHelperJS.setSinglePageCheckout
     */
    isSinglePageCheckout: function () {
        return this.singlePageCheckout;
    },


    /**
     * This function is used to submit the order by invoking the <code>AjaxSubmitOrder</code> service.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails separated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    checkoutOrder: function (orderId, userType, addressListForMailNotification, isQuote) {
        if (isQuote == undefined || isQuote == null) {
            isQuote = false;
        }

        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }

        if (this.isOrderPrepared() == "false") {
            this.saveCheckoutOrderParameters(orderId, userType, addressListForMailNotification, isQuote);
            wcService.invoke("AjaxPrepareOrderForSubmit");
            return;
        }

        params = [];
        params["orderId"] = orderId;
        params["notifyMerchant"] = 1;
        params["notifyShopper"] = 1;
        params["notifyOrderSubmitted"] = 1;
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
        }
            else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
        }
        params["purchaseorder_id"] = purchaseOrderNumber;
        if (userType == 'G') {
            //addressListForMailNotification contains list of emailId's spearated by space.. remove leading or trailing spaces..
            addressListForMailNotification = trim(addressListForMailNotification);

            //Get the space separated email list in an array...
            var emailList = [];
            emailList = addressListForMailNotification.split(" ");

            //Now from this array, remove repeated email Id's.. keep only unique email Id's
            var uniqueList = [];
            for (var j = 0; j < emailList.length; j++) {
                uniqueList[emailList[j]] = emailList[j];
            }

            //Get the total length of unique email id's list..
            var totalLength = 0;
            for (i in uniqueList) {
                totalLength = totalLength + 1;
            }

            //Convert the unique List array into comma separated values...
            var temp = "";
            var k = 0;
            for (i in uniqueList) {
                k = k + 1;
                temp = temp + uniqueList[i];
                if (k < totalLength) {
                    //If not last value, add , before next value..
                    temp = temp + ",";
                }
            }
            //For guest user send the email list..
            params["notify_EMailSender_recipient"] = temp;

            //setup sms phone for service
            var smsOrderNotificationCheckbox = document.getElementById("sendMeSMSNotification");
            if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
                if (smsOrderNotificationCheckbox.checked) {
                    var mobileCountryCode = document.getElementById("mobileCountryCode");
                    var mobilePhone1 = document.getElementById("mobilePhone1");
                    if (mobileCountryCode != null && mobileCountryCode != "undefined" && mobilePhone1 != null && mobilePhone1 != "undefined") {
                        params["SMS"] = mobileCountryCode.value + mobilePhone1.value;
                    }
                }
            }
        }


        //For handling multiple clicks
        /*
        if (!submitRequest()) {
            return;
        }
        */
        cursor_wait();

        if (!isQuote) {
            wcService.invoke("AjaxSubmitOrder", params);
        } else {
            params["URL"] = "";
            this.setOrderId(orderId);
            wcService.invoke("AjaxSubmitQuote", params);
        }
    },


    /**
     * Validates the scheduled start date and sets the cookies that are used to retrieve the start date and interval of a scheduled order.
     */
    prepareOrderSchedule: function () {
        if (document.getElementById("scheduleOrderInputSection") != null) {
            var scheduleOrderStartDateObj = $("#ScheduleOrderStartDate")[0];
            if (!this.validateDate(scheduleOrderStartDateObj, 'ScheduleOrderStartDate')) {
                return;
            }

            var interval = $("#ScheduleOrderFrequency").val();

            var key1 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_strStartDate";
            var key2 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_interval";

            if ((interval == "undefined") && (scheduleOrderStartDateObj.value == null)) {
                // if the order interval is '' and the specified start date is empty, remove the cookies
                   setCookie(key1, null, {expires: -1});
                   setCookie(key2, null, {expires: -1});
            } else {
                var t = $(scheduleOrderStartDateObj).datepicker("getDate");
                var now = new Date();

                t.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

                // set start date in zulu time
                t = t.toISOString();
                setCookie(key1, t, {
                    path: "/",
                    domain: cookieDomain
                });
                setCookie(key2, interval, {
                    path: "/",
                    domain: cookieDomain
                });
            }
        }
    },


    /**
     * Schedules an order.
     *
     * @param {Integer} orderId The order ID of the scheduled order.
     * @param {String} isRecurring The flag to identify a recurring order.
     * @param {String} userType The type of the user.
     */
    scheduleOrder: function (orderId, isRecurring, userType) {
        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }
        if (userType === "G" && isRecurring) {
            MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
            return;
        }
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["orderId"] = orderId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        if (isRecurring != undefined && isRecurring == true) {
            params["startDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '1') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
                params["timePeriod"] = '1';
                params["timePeriodUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '2') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '3') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '4') {
                params["fulfillmentInterval"] = '2';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '5') {
                params["fulfillmentInterval"] = '3';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '6') {
                params["fulfillmentInterval"] = '4';
                params["fulfillmentIntervalUOM"] = 'WEE';
            }
        }
         else {
            params["strStartDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            params["interval"] = getCookie("WC_ScheduleOrder_" + orderId + "_interval");
        }


        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
            } else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
            params["purchaseorder_id"] = purchaseOrderNumber;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if (isRecurring != undefined && isRecurring == true) {
            wcService.invoke("SubmitRecurringOrder", params);
        } else {
            wcService.invoke("ScheduleOrder", params);
        }
    },


    /**
     * Checks if a date occurred in the past.
     *
     * @param {Object} dateObj The date object to be validated.
     * @param {String} elementId The ID of the element that an error message would be attached to.
     */
    validateDate: function (dateObj, elementId) {
        var now = new Date();
        if ($(dateObj).datepicker("getDate") != null && ($(dateObj).datepicker("getDate") - now < 0)) {
            //if the date is the current date, then it is valid
            if (now.toDateString() === $(dateObj).datepicker("getDate").toDateString()) {
                return true;
            }

            if ((elementId != null) && (document.getElementById(elementId) != null)) {
                MessageHelper.formErrorHandleClient(document.getElementById(elementId).id, MessageHelper.messages["PAST_DATE_ERROR"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["PAST_DATE_ERROR"]);
            }
            return false;
        } else {
            return true;
        }
    },

    /**
     * Creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID for a multiple shipment scenario, or 0 to indicate a shipping address needs to be created, or 1 to indicate a billing address needs to be created.
     * @param {String} addressType The type of the address to be created.
     */
    createAddress: function (orderItemId, addressType) {
        this.saveOrderItemsList(orderItemId, "-1");

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        var checkForOpera = true; //require a check of whether the browser is opera or not
        cursor_wait(checkForOpera);
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used to show an area and hide an area on the current page.
     *
     * @param {String} showArea The ID of the area to show.
     * @param {String} hideArea The ID of the area to hide.
     *
     * @private
     */
    showHideDivs: function (showArea, hideArea) {
        document.getElementById(hideArea).style.display = "none";
        document.getElementById(showArea).style.display = "block";
    },


    /**
     * Restores the previous address details when a user cancels editing an existing address or cancels creating a new address.
     *
     * @see CheckoutHelperJS.cancelEditAddress
     */
    restorePreviousAddressDetails: function () {

        //For Ajax flow when the previous shipping address is not available in the array
        //Save the addresses present on server side only.. on change of address the server will be updated in ajax checkout..so can use
        //the address from server side only..
        if (this.shipmentTypeId == "2") {
            for (var i = 0; i < this.orderItemIds.length; i++) {
                //Get the orderItemId
                var orderItemId = this.orderItemIds[i];
                var element = document.getElementById("MS_ShipmentAddress_" + orderItemId);

                if (element != null && element.value == -1) {
                    //IF createAddress is selected in this box, then restore it to previously selected value..
                    element.value = document.getElementById("addressId_" + orderItemId).value;
                }
            }
        } else if (this.shipmentTypeId == "1") {
            var element = document.getElementById("singleShipmentAddress");
            if (element != null && document.getElementById("addressId_all")) {
                element.value = document.getElementById("addressId_all").value;
            }
        }

        //Restore the original billing address(es) that was updated on the server
        for (var i = 1; i < 4; i++) {
            //Find the payment forms that are present on the page
            if (document.getElementById("PaymentForm" + i) != null) {
                var paymentForm = document.getElementById("PaymentForm" + i);
                //Restore the selected billing address if it "create address" was selected
                if (paymentForm.billing_address_id.value == -1) {
                    paymentForm.billing_address_id.value = document.getElementById("selectedAddressId_" + i).value;
                }
                if (wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] == -1) {
                    wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] = paymentForm.billing_address_id.value;
                }
            }
        }
    },


    /**
     * This function is used when a user edits an existing shipping address during check-out.
     *
     * @param {String} addressSelectBoxName The ID of the address drop-down object.
     * @param {Integer} orderItemId The item ID. It is required in the a multiple shipment scenario.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editAddress: function (addressSelectBoxName, orderItemId, profileshipping, profilebilling) {
        var addressBox = document.getElementById(addressSelectBoxName);

        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id.
        this.saveOrderItemsList(orderItemId, addressBox.value);

        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressSelectBoxName != null) {
                MessageHelper.formErrorHandleClient(addressSelectBoxName, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': 'Shipping'
        });

        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used when a user edits an existing billing address during check-out.
     *
     * @param {Integer} orderItemId The item ID.
     * @param {Integer} paymentArea The payment area number that this billing address belongs to.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editBillingAddress: function (orderItemId, paymentArea, profileshipping, profilebilling) {
        var form = document.forms["PaymentForm" + paymentArea];
        var addressBox = form.billing_address_id;
        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id..
        this.saveOrderItemsList(orderItemId, addressBox.value);
        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressBox != null) {
                MessageHelper.formErrorHandleClient(addressBox, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        var billingAddressId = addressBox.value;
        var shippingAddressId = (document.getElementById("singleShipmentAddress")) ? document.getElementById("singleShipmentAddress").value : "noAddress";
        var addressType = (billingAddressId == shippingAddressId) ? "ShippingAndBilling" : "Billing";
        /*
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        */
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },

    /**
     * When a user cancels editing an address, this function is called to hide the address entry form and show the original main content of the page, then calls restorePreviousAddressDetails to restore the previous address.
     *
     * @see CheckoutHelperJS.restorePreviousAddressDetails
     */
    cancelEditAddress: function () {
        this.showHideDivs('mainContents', 'editAddressContents');
        this.restorePreviousAddressDetails();
        if (this.getLastAddressLinkIdToFocus() != null && this.getLastAddressLinkIdToFocus() != 'undefined' && this.getLastAddressLinkIdToFocus() != '') {
            document.getElementById(this.getLastAddressLinkIdToFocus()).focus();
            this.setLastAddressLinkIdToFocus('');
        }
    },

    /**
     * This function gets the shipment type Id for the order. Shipment type Id 1 is for single shipment, 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.initializeShipmentPage
     */
    getShipmentTypeId: function () {
        return this.shipmentTypeId;
    },


    /**
     * Sets the dataDiry flag to indicate if payment information in the specified payment form area has been changed by the user.
     * This method should be used for payment methods involving credit card.
     * @param {Integer} paymentAreaNumber The unique payment area number.
     * @param {Boolean} flag A true/false value to indicate if the payment method input has been changed.
     *
     * @see CheckoutHelperJS.isPaymentDataDirty
     */
    paymentDataDirty: function (paymentAreaNumber, flag) {
        this.dataDirty[paymentAreaNumber] = flag;
        console.debug("Information in payment area " + paymentAreaNumber + " has been modified.");
    },

    /**
     * Returns the dataDiry flag that indicates if payment information in the specified payment form area has been changed by the user.
     *
     * @param {Integer} paymentAreaNumber The unique payment area number.
     *
     * @see CheckoutHelperJS.paymentDataDirty
     */
    isPaymentDataDirty: function (paymentAreaNumber) {
        return this.dataDirty[paymentAreaNumber];
    },


    /**
     * Sets fieldDirtyFlag to indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @param {Boolean} value A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.getFieldDirtyFlag
     */
    setFieldDirtyFlag: function (value) {
        this.fieldDirtyFlag = value;
    },


    /**
     * Returns fieldDirtyFlag that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @returns {Boolean} fieldDirtyFlag A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.setFieldDirtyFlag
     */
    getFieldDirtyFlag: function () {
        return this.fieldDirtyFlag;
    },


    /**
     * Verifies if the dirty flag is set to true, such as when a customer changes shipping information. If the dirty
     * flag is set to true, a message displays prompting the customer to update their current order before they continue
     * to checkout. This function is used in a non-AJAX checkout flow.
     *
     * @return {Boolean} Return true if the dirty flag is set to true.
     */
    checkForDirtyFlag: function () {
        if (this.getFieldDirtyFlag()) {
            if (document.getElementById("ShoppingCart_NonAjaxUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("ShoppingCart_NonAjaxUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
                return true;
            } else if (document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else if (document.getElementById("SingleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("SingleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            }
        }
        return false;
    },


    /**
     * This function is used to show or hide the SMS phone number field section for guest shoppers in the
     * order summary page.
     * @param {DOM Element Id} checkboxElementId The id of the checkbox for getting SMS order notifications.
     * @param {DOM Element Id} smsElementId The id of the element that contains the SMS phone number field.
     */
    showHideCheckoutSMS: function (checkboxElementId, smsElementId) {
        var smsOrderNotificationCheckbox = document.getElementById(checkboxElementId);
        if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
            if (smsOrderNotificationCheckbox.checked) {
                showElementById(smsElementId);
            } else {
                hideElementById(smsElementId);
            }
        }

    },

    /**
     * This function return an array of countries from a global variable called countries.
     * If that variable does not already exist then it will be created and populated from a JSON of country objects which should
     * have been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     **/
    getCountryArray: function () {
        //If the countries array does not already exist then create it.
        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined') return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;
    },

    /**
     *  This function populates the country code to mobile phone based on the selected country.
     *  @param {string} countryDropDownId The id of the mobile country drop down list
     *  @param {string} countryCallingCodeId The id of the mobile country calling code text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = document.getElementById(countryDropDownId).value;
        document.getElementById(countryCallingCodeId).value = countries[countryCode].countryCallingCode;
    },


    /**
     * Invokes the OrderShippingInfoUpdate service to expedite shipping for the selected order item.
     *
     * @param {DOM Element} checkBox The Expedite Shipping check-box object.
     * @param {String} inputOrderItemId The ID of the order item for which you want to expedite shipping.
     */
    expediteShipping: function (checkBox, inputOrderItemId) {

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

        if (checkBox.checked) {
            this.updateParamObject(params, "isExpedited", "true", true);
        } else {
            this.updateParamObject(params, "isExpedited", "false", true);
        }
        if (inputOrderItemId != null) {
            this.updateParamObject(params, "orderItemId", inputOrderItemId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /************************************************************
     * The following methods are used on the Shopping Cart page
     ************************************************************/

    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the total by calling <code>updateCart</code> after <code>updateWaitTimeOut</code> milliseconds have passed.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Object} event A keyboard event object.
     *
     * @see CheckoutHelperJS.updateCart
     */
    updateCartWait: function (quantityBox, orderItemId, event) {
        //Arrows are escaped for keyboard accesibility of table
        if (event.keyCode == KeyCodes.TAB ||
            event.keyCode == KeyCodes.DOWN_ARROW ||
            event.keyCode == KeyCodes.UP_ARROW ||
            event.keyCode == KeyCodes.LEFT_ARROW ||
            event.keyCode == KeyCodes.RIGHT_ARROW
        ) return;

        //Key pressed.. update the flag
        if (this.keyPressCount[orderItemId] == null && isNaN(this.keyPressCount[orderItemId])) {
            this.keyPressCount[orderItemId] = 0;
        }
        this.keyPressCount[orderItemId] = parseInt(this.keyPressCount[orderItemId]) + 1;
        setTimeout($.proxy(this, "updateCart", quantityBox, orderItemId, this.keyPressCount[orderItemId]), this.updateWaitTimeOut);
    },


    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the shopping cart by calling the <code>AjaxUpdateOrderItem</code> service.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Integer} keyPressCountValue The count of keyPress events. If there are more keyPress events after this event was fired, then this function just returns without doing anything.
     */
    updateCart: function (quantityBox, orderItemId, keyPressCountValue) {
        if (keyPressCountValue < this.keyPressCount[orderItemId]) {
            //User has pressed one more key..that key press call will update the server..no work for me..
            return;
        }

        var quantity = (quantityBox.value);
        if (!isNonNegativeInteger(quantity)) {
            TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            MessageHelper.formErrorHandleClient(quantityBox, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
        } else {
            //Its a positive valid number > 0...Update the qty at server side..
            if (!isChrome()) {
                TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            }
            var params = [];
            params.orderId = ".";
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            if (this.shoppingCartPage) {
                params.calculationUsage = "-1,-2,-5,-6,-7";
                params.inventoryValidation = "true";
            } else {
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
            this.updateParamObject(params, "quantity", quantity, false, -1);

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (quantity == 0) {
                var x = document.getElementById("totalNumberOfItems").value;
                var y = x;
                //Now remove free items from this total number of items count..
                //x = total items and y = totalItems - totalFreeItems
                for (var i = 0; i < x; i++) {
                    var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
                    if (qtyObj != null || qtyObj != undefined) {
                        qty = qtyObj.value;
                        if (qty != null && qty != undefined && qty == -1) {
                            y = y - 1;
                        }
                    }

                }

                if (y == 1) {
                    wcService.invoke("AjaxUpdateOrderItem1", params);
                } else {
                    wcService.invoke("AjaxUpdateOrderItem", params);
                }
            } else {
                wcService.invoke("AjaxUpdateOrderItem", params);
            }
        }
    },


    /**
     * Validates the quantity of all items on the 'Shopping Cart' page.
     * @param {DOM Element} form The form object that contains the table of order items.
     */
    updateShoppingCart: function (form) {

        MessageHelper.hideAndClearMessage();
        var totalItems = document.getElementById("totalNumberOfItems").value;
        if (totalItems != null) {
            for (var i = 0; i < totalItems; i++) {
                var quantity = null;
                if (form != undefined) {
                    quantity = form["quantity_" + (i + 1)];
                } else if (document.getElementById("qty_" + (i + 1)) != null) {
                    quantity = document.getElementById("qty_" + (i + 1));
                }
                //Update qty for all items
                if (quantity != null || quantity != undefined) {
                    var v = quantity.value;
                    if (!isNonNegativeInteger(v)) {
                        MessageHelper.formErrorHandleClient(quantity.id, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
                        return;
                    }
                }

            }
            return true;
        } else {
            console.debug("error: element 'totalNumberOfItems' was expected but undefined.");
            return;
        }
    },

    /**
     * If the shopper has selected to perform a recurring order in the shopping cart page, this function is used to
     * validate that all conditions for creating a recurring order are met:
     * - make sure it is a registered shopper
     * - make sure that the order does not have order items that are non-recurring (i.e disallowRecurringOrder flag set to 1)
     *
     * @param {String} userType The user type of the current user, either G (guest shopper) or R (registered shopper).
     */
    canCheckoutContinue: function (userType) {
        if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked) && ((document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) || document.getElementById("shipTypeOnline") == null)) {
            if (document.getElementById("nonRecurringOrderItems") && document.getElementById("nonRecurringOrderItems").value != "") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["RECURRINGORDER_ERROR"]);
                return false;
            } else if (userType != undefined && userType === "G") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
                return false;
            }
        }
        return true;
    },

    /**
     *
     * validate the login fields
     *
     */
    validateLoginFields: function(){
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        var emailField = $("#WC_CheckoutLogon_FormInput_logonId")
            , passwordField = $("#WC_CheckoutLogon_FormInput_logonPassword")
            , hasError = false;

        //TODO Commonize this 'if'
        if (isOliver){

            emailField.parent().removeClass("field-error-message");
            passwordField.parent().removeClass("field-error-message");
            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.parent().addClass("field-error-message");
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val().trim())){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }

        } else {

            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.addClass("field-error-message");
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val())){
                emailField.addClass("field-error-message");
                hasError = true;
            }
        }

        if(hasError){
            return false;
        }
        return true;
    },
    /**
     * Updates the shopping cart in a 'quick check-out' scenario by invoking the <code>QuickCheckOutOrderCopy</code> service.
     *
     * @param {Integer} quickOrderId The ID of the quick check-out order.
     */
    updateCartWithQuickCheckoutProfile: function (quickOrderId) {
        var postRefreshHandlerParameters = [];
        var initialURL = "AjaxRESTOrderCopy";
        var urlRequestParams = [];
        urlRequestParams["storeId"] = this.storeId;
        urlRequestParams["catalogId"] = this.catalogId;
        urlRequestParams["langId"] = this.langId;
        urlRequestParams.toOrderId = ".";
        urlRequestParams["shippingAddressFromOrderProfile"] = "1";
        urlRequestParams["shippingModeFromOrderProfile"] = "1";
        urlRequestParams["URL"] = "dummy";
        urlRequestParams["payInfoFrom"] = quickOrderId;

        postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPrepare", "requestParams":{"orderId":"."}});
        postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{"quickCheckoutProfileForPayment":"true"}});
        var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);

        //For handling multiple clicks
        if(!submitRequest()){
            return;
        }
        cursor_wait();

        wcService.invoke(service.getParam("id"), urlRequestParams);
    },


    /************************************************************
     * End Shopping Cart page specific functions
     ************************************************************/



    /**************************************************************
     * The following methods are used on the Single Shipment page
     **************************************************************/

    /**
     * Helper function used for adding a new shipping address in a single shipment scenario.
     *
     * @param {String} addressType The type of the selected address.
     */
    addNewShippingAddress: function (addressType) {
        this.displayAddressDetails(-1, addressType);
    },

    /**
     * This function is used to update the address of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     */
    updateAddressForAllItems: function (addressSelectBox) {
        //Save it in local array..
        if (addressSelectBox.value != -1) {
            this.selectedAddressesArray[addressSelectBox.name] = addressSelectBox.value;
        }

        var addressId = addressSelectBox.value;
        if (addressId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        var addressId = document.getElementById("singleShipmentAddress").value;
        this.updateParamObject(params, "addressId", addressId, false);
        if (typeof updateGiftRegistrantAddressForItemsExt != "undefined" && typeof updateGiftRegistrantAddressForItemsExt != null) {
            params = updateGiftRegistrantAddressForItemsExt(params, addressId);
        }

        var enabledShipInstructions = false;
        var shipInstructions;

        //Check if Shipping Instructions is enabled
        if (document.getElementById("shipInstructions") != null) {
            shipInstructions = document.getElementById("shipInstructions").value;

            reWhiteSpace = new RegExp(/^\s+$/);
            if (reWhiteSpace.test(shipInstructions)) {
                shipInstructions = "";
            }
            enabledShipInstructions = true;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        //If Shipping Instructions is enabled & there are some shipping instructions entered
        //Update both the shipping address and shipping instructions
        //Else only update shipping address
        if (!enabledShipInstructions || shipInstructions == undefined || shipInstructions == "") {
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        } else {
            wcService.invoke("OrderItemAddressShipInstructionsUpdate", params);
        }
    },


    /**
     * This function is used to update the shipping mode of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available shipping modes.
     */
    updateShipModeForAllItems: function (shipmentSelectBox) {

        var shipModeId = shipmentSelectBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "shipModeId", shipModeId, false);

        if (isCarol && typeof addressId !== 'undefined') {
            this.updateParamObject(params, "addressId", addressId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * This function updates the shipping instruction for items in the order. It is used in a single shipment check-out scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     */
    updateShippingInstructionsForAllItems: function () {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";

        var orderItemId = null;
        var shipInstructions = document.getElementById("shipInstructions").value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(document.getElementById("shipInstructions").id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },

    /**
     * Updates the shipping charge type and account number for items in the order. This method calls the
     * <code>OrderShippingInfoUpdate</code> service and is used in both single and multiple shipment checkout scenarios.
     *
     * @param {Integer} curOrderId The order ID of the current order.
     * @param {Integer} shipModeId The ID of the shipping mode to which shipping charge applies.
     * @param {String} shipChargeType Shipping charge type selected for the shipmode.
     * @param {Integer} shipAcctNum The account number that is used when the selected shipping charge type is Charge by Carrier.
     */
    updateShippingChargeForShipModeAjax: function (curOrderId, shipModeId, shipChargeType, shipAcctNum) {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = curOrderId;
        params.URL = "";
        params["shipModeId"] = shipModeId;
        params["shipChargTypeId"] = shipChargeType;

        // ship account number is optional field for shipping charge, if it is not specified, pass in empty
        if (shipAcctNum != null && typeof shipAcctNum !== 'undefined') {
            params["shipCarrAccntNum"] = shipAcctNum;
        } else {
            params["shipCarrAccntNum"] = "";
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxOrderShipChargeUpdate", params);
    },


    /**
     * Hides the account number field for the selected in shipping charge. If the charge by seller charge
     * type is selected, account field should not be shown.
     * @param {object} selectValue The HTML element of the shipping charge type selection
     * @param {object} acctFieldId The HTML element of the account number field
     */
    hideShipChargeAccountField: function (selectValue, acctFieldId) {

        if (document.getElementById(selectValue).value.indexOf("ByCarrier") > -1) {
            document.getElementById(acctFieldId).style.display = 'block';
        } else {
            document.getElementById(acctFieldId).style.display = 'none';
        }
    },

    /**
     * This function validates the specified requested shipping date then calls {@link CheckoutHelperJS.updateShippingDateForAllItems}
     * to update the date for all items in the current order in a single shipment scenario.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     *
     * @see CheckoutHelperJS.updateRequestedShipDateForThisItem
     */

    updateRequestedShipDate: function (jsDate) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else {
            t = this.resetRequestedShipDateValue;
        }

        this.updateShippingDateForAllItems(t);
    },


    /**
     * This function updates the requested shipping date for all items in the order. It is called by {@link CheckoutHelperJS.updateRequestedShipDate}.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {String} date The String representation of the date object, see {@link CheckoutHelperJS.updateRequestedShipDate}.
     */
    updateShippingDateForAllItems: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "requestedShipDate", date, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Displays the details of an address in a single shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetails: function (addressSelectBoxValue, addressType) {
        //Display selected address details..
        if (addressSelectBoxValue != -1) {
            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            var checkForOpera = true; //require a check of whether the browser is opera or not
            cursor_wait(checkForOpera);
            wcRenderContext.updateRenderContext('shippingAddressContext', {
                'shippingAddress': addressSelectBoxValue
            });
        } else {
            this.createAddress(-1, addressType);
        }
    },


    /************************************************************
     * End Single Shipment page specific functions
     ************************************************************/


    /****************************************************************
     * The following methods are used on the Multiple Shipment page
     ****************************************************************/

    /**
     * This function is used to move all order items into a single shipment when a shopper changes the order from multiple shipment check-out to single shipment.
     * The shipping information of the first item in the order will be used for all items after this update.
     * It calls the <code>OrderItemAddressShipMethodUpdate1</code> service to update the order.
     */
    moveAllItemsToSingleShipment: function () {
        //Get the first orderItem id..
        var orderItemId = document.getElementById("orderItem_1").value;
        //Now get the addressId and shipModeId of this orderItemId...
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        //Update the shipModeId and addressId of all the items present in currentOrder...

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

      // FIX LATER TODO
        var requestedShipDate = $("#MS_requestedShippingDate_" + orderItemId);
        if (requestedShipDate == undefined) {
            requestedShipDate = document.getElementById("MS_requestedShippingDate_" + orderItemId);
            if (requestedShipDate != null && requestedShipDate != 'undefined') {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = requestedShipDate.value;
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            }
        }

        var requestedShipDateCheckbox = document.getElementById("MS_requestShippingDateCheckbox_" + orderItemId);
        if (requestedShipDateCheckbox != null && requestedShipDateCheckbox != 'undefined') {
            if (requestedShipDateCheckbox.checked) {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = this.formatRequestedShipDate(requestedShipDate);
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            } else {
                params.requestedShipDate = this.resetRequestedShipDateValue;
            }
        }

        //addressId -3 is reserved for gift registry "Registrant" address.
        if (addressId == -3) {
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 2; i <= totalItems; i++) {
                if (document.getElementById("orderItem_" + i) != null && document.getElementById("orderItem_" + i) != 'undefined') {
                    var giftOrderItemId = document.getElementById("orderItem_" + i).value;
                    var validAddressId = document.getElementById("MS_ShipmentAddress_" + giftOrderItemId).value;
                    if (validAddressId != -3) {
                        this.updateParamObject(params, "addressId", validAddressId, false);
                        break;
                    }
                } else {
                    break;
                }
            }
        } else {
            this.updateParamObject(params, "addressId", addressId, false);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate1", params);
    },


    /**
     * Helper function for adding an address on the multiple shipment 'Shipping & Billing' page.
     * @param (Integer) orderItemId The ID of the order item.
     */
    addNewShippingAddressForMS: function (orderItemId) {
        this.updateAddressIdForThisItem(-1, orderItemId);

        this.orderItemIds = []; //Reset this.orderItemIds. So that previous edit/create address doesn't have effect on the new create/edit address
        //now save the orderItemId, so we can update that orderItem with the newly created addressId

        //now save the orderItemId, so we can update that orderItem with the newly created addressId
        this.orderItemIds.push(orderItemId);
    },


    /**
     * Updates the address ID for an order item in a multiple shipment check-out scenario.
     * It is used when a different address is selected from the drop down.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service to update.
     *
     * @param {String} addressBoxValue The value, i.e. address ID, of the input select drop-down object that contains all available addresses.
     * @param {Integer} orderItemId The order item ID.
     */
    updateAddressIdForThisItem: function (addressBoxValue, orderItemId) {
        //Save it in local array..
        if (addressBoxValue != -1) {
            var addressBox = document.getElementById("MS_ShipmentAddress_" + orderItemId);
            this.selectedAddressesArray[addressBox.name] = addressBoxValue;
        }
        if (addressBoxValue == -1) return;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        var addressId = addressBoxValue;
        this.updateParamObject(params, "shipToRegistrant", "0", false, -1)
        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        if (typeof updateGiftRegistrantAddressForThisItemExt != "undefined" && typeof updateGiftRegistrantAddressForThisItemExt != null) {
            params = updateGiftRegistrantAddressForThisItemExt(params, addressId);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping mode for an item in the order. It is used in a multiple shipment scenario.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {DOM Element} shipModeBox The select drop-down object that contains all available shipping modes.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShipModeForThisItem: function (shipModeBox, orderItemId) {
        var shipModeId = shipModeBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping instruction for an item. It is used in a multiple shipment scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} textArea The input text area for shipping instruction.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShippingInstructionsForThisItem: function (textArea, orderItemId) {
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
        var shipInstructions = textArea.value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(textArea.id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, shipInstructions);

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * This function updates the requested shipping date for the current item in a multiple shipment check-out scenario.
     * It invokes the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateRequestedShipDateForThisItem: function (jsDate, orderItemId) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else if (jsDate.value == "") {
            t = this.resetRequestedShipDateValue;
        }

        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "requestedShipDate", t, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        CheckoutHelperJS.RequestShippingDateAction = true;
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },

    /**
     * This function formats the requested shipping date from the jQuery datepicker object into a GMT date string.
     *
     * @param {datepicker object} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @return {string} String representation of the requested ship date in GMT.
     */
    formatRequestedShipDate: function (jsDate) {
        var date = $(jsDate).datepicker("getDate");
        //Set the time to 12pm to handle cases where daylight savings cause a date shift
        date.setHours(12);
        return date.toISOString();
    },


    /**
     * This function is used to bring up the address entry form when a user wants to create a new address for an item in a multiple shipment scenario.
     *
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {String} addressType The type of address to create.
     *
     * @private
     */
    createAddressForMS: function (orderItemId, addressType) {
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * Helper function for adding a new address in a multiple shipment scenario.
     *
     * @param (Integer) orderItemId The ID of the item.
     * @param (String) addressType The type of the selected address.
     */
    displayAddressDetailsForMSHelper: function (orderItemId, addressType) {
        this.displayAddressDetailsForMS(-1, orderItemId, addressType);
    },


    /**
     * Displays the details of an address in a multiple shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetailsForMS: function (addressSelectBoxValue, orderItemId, addressType) {
        if (addressSelectBoxValue == -1) {
            this.createAddressForMS(orderItemId, addressType);
        }
    },


    /**
     * This function is used to show or hide the edit address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} orderItemId The id of the orderItem for which the edit address link is displayed/hidden.
     */

    showHideEditAddressLink: function (addressSelectBox, orderItemId) {
        if (addressSelectBox.value == '-3') {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "none");
            }
            return;
        }
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");
            for (var i = 0; i < orgAddressArray.length; i++) {
                if ($("#editAddressLink_" + orderItemId).length) {

                    if (addressSelectBox.value == orgAddressArray[i]) {
                        $("#editAddressLink_" + orderItemId).css("display", "none");
                        break;
                    } else {
                        $("#editAddressLink_" + orderItemId).css("display", "block");
                    }
                }
            }
        } else {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "block");
            }
        }
    },

    /**
     * This function is used to show or hide the dialog for estemated tax in shopping cart.
     */

    showHideEstematedTaxDialog: function (flag) {
        //TODO Commonize this 'if'
        if (!isOliver && !isCarol){
            var position = $('#wcs-calculate-tax').offset();
            var yOffset = position.top  + 20;
            var xOffset = position.left - 180;
            if ($( window ).width() < 650) {
                yOffset = position.top -60;
                xOffset = 0;
            }
            $("#wcs_calTax_notification").css({top: yOffset, left: xOffset});
        }
        $(".enter-zipcode").css("display","table-row");
        

        if (flag){
            $("#wcs_calTax_notification").show();
            if(isOliver || isPersol){
                $("#wcs-calculate-tax-close").show();
                $("#wcs-calculate-tax").hide();
            }
        }
        else{
            $("#wcs_calTax_notification").hide();
            
            if(isOliver || isPersol){
                $("#tax-calculation-form").hide();
                $("#wcs-calculate-tax-close").hide();
                $("#wcs-calculate-tax").show();
            }
        }
    },

    /**
     * calls google service to autofill city provence by zip code
     */
    calculateEstematedTax : function(zipCode, country, lang, isCheckOut, isZipCodeChange, strName) {
        if (isCarol){
            if ($("#WC_UnregisteredCheckout_links_4").length>0){
                showLoadingInternal(true,'WC_UnregisteredCheckout_links_4');
            }
        }

        var zipcode = "";
        var langId = "";
        var countryCode = null;
        var isZipChange = false;
        var storeName = "";

        if(isCheckOut){
            zipcode = zipCode;
            langId = lang;
            countryCode = country;
            isZipChange = isZipCodeChange;
            storeName = strName;
        } else {
            zipcode = $('#wcs_calTax_notification #zip_code').val();
            langId = $('#wcs_calTax_notification #langId').val();
            countryCode = $('#wcs_calTax_notification #country_value').val();

            //TODO Commonize this 'if'
            if (isOliver || isCarol){
                $("#zipCodeDiv").removeClass('error');
                $("#zipCodeDiv .input-style").removeClass('error');
                if (!zipcode.match($('#wcs_calTax_notification #zip_code').attr('data-pattern')) ) {
                    // display error message
                    $("#zipCodeDiv").addClass('error');
                    $("#zipCodeDiv .input-style").addClass('error');
                    restoreAjaxButtons();
                    return false;
                }
            } else {
                $("#wcs_calTax_notification .wcs-error-message").hide();
                if (zipcode.length <5 ) {
                    // display error message.
                    $("#wcs_calTax_notification .wcs-error-message").show();
                    restoreAjaxButtons();
                    return false;
                }
            }

            /* START - Checkout 3.0 */
            //  Force recalculation of taxes when coming back from Shipping Page (it was not possible in previous checkout)
            if ((isOliver || isPersol) && this.zipCountShoppingCart < 1 && $('.tax .total_figures .amount').text().trim() != null && $('.tax .total_figures .amount').text().trim() != '') {
                this.zipCountShoppingCart++;
            }
            /* END - Checkout 3.0 */

            if(this.zipCountShoppingCart >= 1){
                isZipChange = true;
            }else{
                this.zipCountShoppingCart++;
            }

            if (!isOliver && !isCarol){
                setCurrentId('wcs-tax-button_a');
            }
        }

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipcode, langId, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (GoogleAPI)");
                MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                    if (isPersol || isOliver) {
                        ajaxCallCart();
                    } else {
                        CheckoutHelperJS.showHideEstematedTaxDialog(false);
                        CheckoutHelperJS.updateOrderSummary();
                    }  
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;
                var country = result.address.country_short;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = country;
                params.isZipChange = isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },

    /* NEW */
    calculateTaxesFromZipCode : function(zipCodeFormField) {
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var zipCodeFormFieldId = zipCodeFormField.id;
        /*
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");
        */

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateTaxesFromZipCode:: getGoogleAddress error (GoogleAPI): Is the zipCode correct?");
                //MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    CheckoutHelperJS.showHideEstematedTaxDialog(false);
                    CheckoutHelperJS.updateOrderSummary();
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = "us";
                params.isZipChange = true;//isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },


    /**
     * This method updates current cart orderitems address' to the last valid shipping address
     */
    updateCurrentOrderItemsAddressToLastValidOne: function(){
        var METHODNAME = "CheckoutHelperJS.updateCurrentOrderItemsAddressToLastValidOne()";
        var shippingAddressId = getCookie("addressId_formS_" + storeDirectory);
        if (typeof shippingAddressId !== 'undefined'){
            var data = {};
            data.addressId = shippingAddressId;
            data.orderId = ".";
            data.x_calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            data.orderItem = [];
            data.orderItem[0] = {};
            data.orderItem[0].addressId = shippingAddressId;

            var stringifiedData = JSON.stringify(data);

            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
            $.ajax({
                url: url,
                type: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: stringifiedData,

                success: function (data) {
                    plog(METHODNAME + "::Order items shipping address updated OK");
                },
                error: function(jqXHR, exception){
                    plog(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
                },
                complete: function(){
                }
            });
        }
    },

    updateOrderSummary: function(isCheckOut) {
        var countryCode = $("#countryCode").val() || $("#country").val();
        $.ajax({
            url: "CalculateView",
            type: "GET",
            async: false,
            data: "fromPage=CalculateView&storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId,
            success: function (data){

                //TODO Commonize this 'if'
                if (isOliver){

                    if(isCheckOut){
                        /*var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('#order_total .total-amounth.total').html(total);*/
                        ajaxCallCart();//checkout 3.0
                    } else {
                        $('#order_total').html(data);
                    }

                } else if (isCarol){

                    if(isCheckOut){
                        var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        if ($('.order-summary__total-amount--shipping') != undefined) {
                            var str2 = $(data).find(".order-summary__total-amount--shipping").text().trim();
                            str2 = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--shipping').html(str2);
                        }

                        if ($('#order_total .total-amounth.total') != undefined) {
                            var str3 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                            var total = str3.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('#order_total .total-amounth.total').html(total);
                        }

                        if ($('.order-summary__total-amount--total') != undefined) {
                            var str5 = $(data).find(".order-summary__total-amount--total").text().trim();
                            str5 = str5.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--total').html(str5);
                        }

                        if ($('.order-summary__installment-total') != undefined) {
                            var str4 = $(data).find(".order-summary__installment-total").text().trim();
                            str4 = str4.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__installment-total').html(str4);
                        }
                    } else {
                        restoreAjaxButtons();
                        $('#order_total').html(data);
                    }

                } else {

                    if(isCheckOut){
                        // var str1 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_6").html();
                        // var pos = str1.lastIndexOf(">");
                        // str1 = str1.substring(str1.length,pos +1);
                        // str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.tax .total_figures').html(str1);

                        // var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        // var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.orderTotal .total_figures').html(total);
                        
                        // if (affirmEnabled == 'true') {
                        //     $('.affirm-as-low-as').attr('data-amount', WCCurrencyJS.unformat(total) * 100);
                        // }
                        ajaxCallCart();// checkout3.0
                    } else {
                        $('#total_breakdown').html(data);
                    }

                }

                if (affirmEnabled == 'true') {
                    affirm.ui.refresh();
                }
            },
             error: function (xhr, ajaxOptions, thrownError) {
                console.log("PSL::CheckoutHelper.js::updateOrderSummary()::"+thrownError);
             }
        });
    },

    /**
     * This function is used to show or hide the edit billing address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} paymentAreaNumber The area number of the payment section.
     */

    showHideEditBillingAddressLink: function (addressSelectBox, paymentAreaNumber) {

        // If the value is "Please Select Billing Method first", then don't display the edit link on load.
        if ( typeof addressSelectBox !== 'undefined' && addressSelectBox !== null ){
            if (addressSelectBox.value == '-2') {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                return;
            }
        }

        // Gets the address Ids of all the organization addresses
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");

        //if there exists organization addresses
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");

            //loops through all the organization address Ids
            for (var i = 0; i < orgAddressArray.length; i++) {

                //checks to see if the edit link divs exists
                if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {

                    //compares the selected value address Id in the drop down to the organization address id
                    if (addressSelectBox.value == orgAddressArray[i]) {

                        //hides the link if a match is found and then exits the loop (exit is for the case where there might be a different org address id)
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                        break;
                    } else {
                        //displays it in all other cases
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
                    }
                }
            }

        } else {

            // if no organization addresses exists, show the valid edit divs.
            if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
            }
        }
    },

    /**
     * Sets the order ID when it is not called form the current order.
     * The order ID is used to determine which order to act upon such as in the case of deleting an order item from an order.
     * @param {String} orderId The orderID to use.
     */
    setOrderId: function (orderId) {
        this.orderId = orderId;
    },

    /**
     * Returns the orderId.
     */
    getOrderId: function () {
        return this.orderId;
    },

    /************************************************************
     * End Multiple Shipment page specific functions
     ************************************************************/

    _toggleOrderItemDetails: function (div) {
        if (div.css("display") == "none") {
            div.css("display", "block");
            $("#orderExpandAreaBottom").css("display", "none");
            $("#OrderItemDetailsPlus").css("display", "none");
            $("#OrderItemDetailsShowPrompt").css("display", "none");
            $("#OrderItemDetailsMinus").css("display", "inline");
            $("#OrderItemDetailsHidePrompt").css("display", "inline");
            $("#OrderItemDetails_plusImage_link").css("display", "none");
            $("#OrderItemDetails_minusImage_link").css("display", "");
        } else {
            div.css("display", "none");
            $("#orderExpandAreaBottom").css("display", "block");
            $("#OrderItemDetailsPlus").css("display", "inline");
            $("#OrderItemDetailsShowPrompt").css("display", "inline");
            $("#OrderItemDetailsMinus").css("display", "none");
            $("#OrderItemDetailsHidePrompt").css("display", "none");
            $("#OrderItemDetails_plusImage_link").css("display", "");
            $("#OrderItemDetails_minusImage_link").css("display", "none");
        }
    },
    toggleOrderItemDetailsShipping: function (orderItemDetailsDiv, contextId, initializeJS) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': 0,
                    'storeId': this.storeId,
                    'catalogId': this.catalogId,
                    'langId': this.langId,
                    'initializeJS': initializeJS
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    toggleOrderItemDetailsSummary: function (orderItemDetailsDiv, contextId, beginIndex, pageSize, exOrderId, exQuoteId, fromOrderDetails, analytics) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': '',
                    'pageSize': pageSize,
                    'externalOrderId': exOrderId,
                    'externalQuoteId': exQuoteId,
                    'isFromOrderDetailsPage': 'false',
                    'analytics': analytics
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
    redirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
     ajaxRedirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect PayPal checkout
     */
    redirectToPayPalCheckout : function(paypalURL){
        sessionStorage.setItem("isStepPayPalExpress", true);
        paypalURL += "&piAmount=" + $('#totalAmountForPPshortcut').val().trim();
        paypalURL += "&customerWebId=" + window.forterWebId;
        paypalURL += "&customerIPAddress=" + window.ipaddress;
        paypalURL += "&forterToken=" + window.forterToken;
        window.location.href = paypalURL;
        tealiumPushCheckoutStep('PayPalExpressCheckout');
    },

     /**
     * Only for Carol. Update and display shipping methods area passed on zipCode.
     */
    updateShippingMethodsArea : function() {
        var zipcode = $('#zipCodeField').val();
        if (zipcode.length < 9) {
            if (zipcode.length == 0) {
                $('.shipping-method__block').addClass('nodisplay');
                $('#datepicker').addClass('nodisplay');
            }
            return;
        }

        if (addressId === undefined
                || addressId === "" ||
                (oldZipCode != zipcode && storeUserType != undefined && storeUserType === "G")) {
            var addressURL = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipcode;
            $.ajax({
                url: addressURL,
                dataType: 'json',
                type: 'GET',
                success: function (data) {
                    var city = null;
                    var state = null;
                    var zipcode = null;
                    //getting data
                   if (data != null && data.addressInfo[0] != null) {
                       if ( data.addressInfo[0].country == null) {
                           console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                       } else {
                           if (data.addressInfo[0].city != null) {
                               city = data.addressInfo[0].city;
                           }
                           if (data.addressInfo[0].state != null) {
                               state = data.addressInfo[0].state;
                           }
                           if (data.addressInfo[0].zipcode != null) {
                               zipcode = data.addressInfo[0].zipcode;
                           }
                       }

                        // submit AjaxPersonChangeServiceAddressAdd request to create new address to calculate shipping when no address
                        // assigned to the order.
                        var params = [];

                        params.storeId      = ServicesDeclarationJS.storeId;
                        params.catalogId    = ServicesDeclarationJS.catalogId;
                        params.langId       = ServicesDeclarationJS.langId;

                        params.zipCode = zipcode != null ? zipcode : "";
                        params.city = city != null ? city : "";
                        params.state = state != null ? state : "";
                        params.country = countryCode;
                        params.nickName = (nickName != null && nickName != "")? nickName : "MyAddress_Shipping";
                        if (addressId != null && addressId != '') {
                            params.addressId = addressId;
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate?";
                        } else {
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd?";
                        }

                        for (var param  in params) {
                            url += param + "=" + params[param] + "&";
                        }
                        $.ajax({
                            url: url,
                            type: 'POST',
                            success: function (data) {
                                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                                $.ajax({
                                    url: url,
                                    type: 'GET',
                                    headers: {
                                       "Content-Type": "application/json",
                                       "Cache-Control": "no-cache, no-store, must-revalidate"
                                   },
                                   data: {
                                       "timestamp": Date.now()
                                   },
                                    success: function (data) {
                                        if(data != undefined && data.contact != undefined){
                                            for(var i = 0; i < data.contact.length; i++){
                                                if((data.contact[i].addressType === "Shipping" || data.contact[i].addressType === "ShippingAndBilling") && (addressId == null || addressId == "" ||  addressId == data.contact[i].addressId)){
                                                    addressId = data.contact[i].addressId;
                                                    oldZipCode = data.contact[i].zipCode;
                                                    nickName = data.contact[i].nickName;
                                                }
                                            }
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['addressId']=addressId;

                                            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
                                        }
                                    },
                                    error: function(data){
                                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                        console.log(data);
                                    }
                                });
                                CheckoutHelperJS.updateOrderSummary(true);
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
                                CheckoutHelperJS.updateOrderSummary(true);
                            }
                        });

                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {

                }
            });
        } else {
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;

            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
        }

    },

    /**
     * Only for Carol. Show/hide elements inside shipping methods
     */

   showHideGreyShippingMethodsElements : function(hasCEP) {
       var isCheckout = ($('.checkout-page').length > 0);
       if(isCheckout) {
           if(hasCEP == 'true'){
               $('.shipping-method').removeClass('shipping-method--grey');
               $('.physical-stores').removeClass('shipping-method--grey');
               $('#physicalStoresTitle').hide();
               $('.physical-stores > h3').hide();
               $('#shippingMethodTitle').show();
           } else {
               $('.shipping-method').addClass('shipping-method--grey');
               $('.physical-stores').addClass('shipping-method--grey');
               $('#physicalStoresTitle').show();
               $('.physical-stores > h3').show();
               $('#shippingMethodTitle').hide();
           }
       } else {
           $('#physical-stores__title').hide();
       }
     },

     /**
      * Only for Carol. Refresh controller declaration for the Shippong Method display area.
      * @constructor
      */
     declareShippingAddressesDisplayAreaController : function(widgetId) {
          wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {selectedAddressId: ""});
         if(typeof widgetId == "object" || typeof widgetId == "array") {
             widgetId = widgetId[0];
         }
         var myWidgetObj = $("#" + widgetId);

         wcRenderContext.addRefreshAreaId("shippingAddressDropDownBoxContext", widgetId);
         var myRCProperties = wcRenderContext.getRenderContextProperties("shippingAddressDropDownBoxContext");

         myWidgetObj.refreshWidget({
             renderContextChangedHandler: function() {
                 var areaNumber = myRCProperties["areaNumber"];
                 var objectId = widgetId;
                     myWidgetObj.refreshWidget("refresh", {});
             },

             postRefreshHandler: function() {
                 CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(selectedAddressId);
                 AddressHelper.updatePhysicalStoresArea(addressToZipCodeMap[selectedAddressId]);
             }
         });

     },
    /**
     * Only for Carol. Refresh controller declaration for the Shippong Method display area. This function to be deleted after making the grunt build.
     * @constructor
     */
    declareShippingMethodDisplayAreaController : function(widgetId, orderId, addDeclaration) {
        if (typeof addDeclaration == "undefined" || addDeclaration == true) {
            wcRenderContext.declare("ShippingMethodsSelectContext", [], {orderId:orderId,zipCode: ""});
        }
        if(typeof widgetId == "object" || typeof widgetId == "array") {
            widgetId = widgetId[0];
        }
        var myWidgetObj = $("#" + widgetId);

        wcRenderContext.addRefreshAreaId("ShippingMethodsSelectContext", widgetId);
        var myRCProperties = wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext");

        myWidgetObj.refreshWidget({
            renderContextChangedHandler: function() {
                var areaNumber = myRCProperties["areaNumber"];
                var objectId = widgetId;
                    var orderId = myRCProperties["orderId"+areaNumber];
                    myWidgetObj.refreshWidget("refresh", {"orderId": orderId,"ZipCode":""});
            },

            postRefreshHandler: function() {
                if (typeof hasValidAddress == "undefined") {
                    var forceClick = true;
                } else {
                    var forceClick = hasValidAddress;
                }
                if ($("[name=singleShipmentShippingMode]:checked")!= undefined && forceClick) {
                    $("[name=singleShipmentShippingMode]:checked").trigger('click');
                }
                //clears the progress bar set from billingdropdowndisplay.jsp
                cursor_clear();
                var params = [];

                params.storeId      = this.storeId;
                params.catalogId    = this.catalogId;
                params.langId       = this.langId;
                params.requestType = "get";
                cursor_wait();
                wcService.invoke("AjaxShippingDateUpdate", params);
            }
        });

    },

    /**
    * Only for Carol. Update shipping date then redirect.
    */
    updateShippingDateAndRedirect : function(redirectURL) {
        if (document.querySelector('input[name="singleShipmentShippingMode"]:checked') != undefined &&
                document.querySelector('input[name="singleShipmentShippingMode"]:checked').getAttribute("shipmodecode") == 'Scheduled delivery') {
            redirectToURL = redirectURL;
            var params = [];

            params.storeId      = this.storeId;
            params.catalogId    = this.catalogId;
            params.langId       = this.langId;
            params.orderId      = ".";
            params.requestType = "update";
            var time = "0700";
            if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
              time = "1200";
            } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
              time = "1800";
            }
            var date = $("#datepicker-holder").datepicker('getDate');
            var formattedDate = $.datepicker.formatDate("yymmdd", date);
            params.shippingDate = formattedDate + time;
            cursor_wait();
            wcService.invoke("AjaxShippingDateUpdate", params);
        } else {
            CheckoutHelperJS.redirectToLoginRegisterStep(redirectURL);
        }
    }
}
// -----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
// -----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the store jsp's related to address creation and maintenance.
 * @version 1.0
 */

/**
 * The functions defined in this class enable address creation across the store.
 *
 * @class The functions and variables defined in this class validate the form
 *        input field values entered by the customer. Another set of functions
 *        help in loading the UI for the state field when there is a change in
 *        the country field. Another set of functions enable creating an address
 *        in the shopcart page and guest user checkout page.
 */
var zipCodeError= false;
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}





var continents = [
    {
      continent: 'AF',
      countries: ['DZ','AO','BW','BI','CM','CV','CF','TD','KM','YT','CG','CD','BJ','GQ','ET','ER','DJ','GA','GM','GH','GN','CI','KE','LS','LR','LY','MG','MW','ML','MR','MU','MA','MZ','NA','NE','NG','GW','RE','RW','SH','ST','SN','SC','SL','SO','ZA','ZW','SS','EH','SD','SZ','TG','TN','UG','EG','TZ','BF','ZM']
    },
    {
      continent: 'AS',
      countries: ['AF','AZ','BH','BD','AM','BT','IO','BN','MM','KH','LK','CN','TW','CX','CC','CY','GE','PS','HK','IN','ID','IR','IQ','IL','JP','KZ','JO','KP','KR','KW','KG','LA','LB','MO','MY','MV','MN','OM','NP','PK','PH','TL','QA','RU','SA','SG','VN','SY','TJ','TH','AE','TR','TM','UZ','YE','XE','XD','XS']
    },
    {
      continent: 'EU',
      countries: ['AL','UK','AD','AZ','AT','AM','BE','BA','BG','BY','HR','CY','CZ','DK','EE','FO','FI','AX','FR','GE','DE','GI','GR','VA','HU','IS','IE','IT','KZ','LV','LI','LT','LU','MT','MC','MD','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SJ','SE','CH','TR','UA','MK','GB','GG','JE','IM']
    },
    {
      continent: 'NA',
      countries: ['AG','BS','BB','BM','BZ','VG','CA','KY','CR','CU','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','MS','AN','CW','AW','SX','BQ','NI','UM','PA','PR','BL','KN','AI','LC','MF','PM','VC','TT','TC','US','VI']
    },
    {
        continent: 'OC',
        countries: ['AS','AU','SB','CK','FJ','PF','KI','GU','NR','NC','VU','NZ','NU','NF','MP','UM','FM','MH','PW','PG','PN','TK','TO','TV','WF','WS','XX']
    },
    {
        continent: 'SA',
        countries: ['AR','BO','BR','CL','CO','EC','FK','GF','GY','PY','PE','SR','UY','VE']
    }
  ];

function getContinent(country){
	for (var key in continents) {
	    // check if the property/key is defined in the object itself, not in parent
	    if (continents.hasOwnProperty(key)) {
	    	if(continents[key].countries.includes(country)){
	    		return continents[key].continent;
	    	}        
	    }
	}
}

//ChangeDone
AddressHelper = {
    /* The name of the state field div. */
    stateDivName: "stateDiv",
    storeCountry: "",
    storeName: "",
    /* styling class for the state field. */
    stateClass: null,
    selectedCountryCode: null,
    cityId: null,
    stateId: null,
    maxNeighborhoodChar : 31,
    validZipCode: null,
    zipCodeNotFound:false,
    validZipCodeShipping: null,
    validZipCodeBilling: null,
    isSameCountryAsStore: true,
    zipCount: 0,
    validCPF: false,
    hasTaxes: false,

    setStoreName: function (storeName) {
        this.storeName = storeName;
    },

    /**
     * This function set the value of hasTaxes
     *
     * @param {boolean} hasTaxes show if store has taxes or not
     */
    setStoreHasTaxes: function (hasTaxes) {
        this.hasTaxes = (hasTaxes == 'true');
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
            $('.ui-widget-overlay').hasClass('custom-overlay') ? '' : $('.ui-widget-overlay').addClass('custom-overlay');
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showAddEditAddressPopup: function (widgetId, addressIdDiv, storeId) {
        this.showWCDialogPopup(widgetId);
        if (addressIdDiv && addressIdDiv != '') {
            var addressId = $('#' + addressIdDiv)[0].value;
            if (addressId && addressId != '') {
                $.ajax({
                    type: "GET",
                    url: "/wcs/resources/store/" + storeId  + "/person/@self/contact/byAddressId/" + addressId,
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    success: function (data) {
                     // fill address
                        var addEditAddressForm = document.forms['addEditAddressForm'];

                        addEditAddressForm.firstName.value = data.firstName;
                        addEditAddressForm.lastName.value = data.lastName;
                        addEditAddressForm.address1.value = data.addressLine[0];
                        addEditAddressForm.state.value = data.state;
                        addEditAddressForm.city.value = data.city;
                        addEditAddressForm.zipCode.value = data.zipCode;
                        addEditAddressForm.phone1.value = data.phone1;
                        if($('#emailAddress1')[0]) {
                            addEditAddressForm.email1.value = data.email1;
                        }

                        if (typeof addEditAddressForm.addressId == 'undefined' ) {
                            $('<input>').attr({
                                type: 'hidden',
                                id: 'addressId',
                                name: 'addressId',
                                value: addressId
                            }).appendTo(addEditAddressForm);
                        } else {
                            addEditAddressForm.addressId.value = addressId;
                        }

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {

                    }
                });
            }

        } else {
            // clears
            var addEditAddressForm = document.forms['addEditAddressForm'];

            addEditAddressForm.firstName.value = '';
            addEditAddressForm.lastName.value = '';
            addEditAddressForm.address1.value = '';
            addEditAddressForm.state.value = '';
            addEditAddressForm.city.value = '';
            addEditAddressForm.zipCode.value = '';
            addEditAddressForm.phone1.value = '';
            if (addEditAddressForm.addressId) {
                addEditAddressForm.addressId.remove();
            }
        }

    },
    /**
     * This function sets the name for the state field.
     *
     * @param {string}
     *            stateDivName The name to be set for the state field.
     */
    setStateDivName: function (stateDivName) {
        this.stateDivName = stateDivName;
    },

    /**
     * This function sets the styling class for the state field.
    *
    * @param {string}
    *            stateClass The name of the styling class to be set for the
    *            state field.
     */
    setStateClass: function (stateClass) {
        this.stateClass = stateClass;
    },

    /**
     * set selected country code on change country event
     */
    setSelectedCountryCode: function (selectedCountryCode) {
        this.selectedCountryCode = selectedCountryCode;
    },

    setStoreCountry: function (storeCountry) {
        this.storeCountry = storeCountry;
    },

    /**
     * set default selected country onload, in order to perfom zip validation
     */
    setSelectedCountryId: function (selectedCountryId) {
        this.selectedCountryId = selectedCountryId;

        var selectedCountry = document.getElementById(selectedCountryId);

        if (selectedCountry != null) {
            //set default selectedcountry code
            var currentCountryCode = null;

            if (selectedCountryId == "_state1") {
                currentCountryCode = selectedCountry.value;
            } else {
                currentCountryCode = selectedCountry.value;
            }

            this.setSelectedCountryCode(currentCountryCode);
        }


    },

    /**
     * This function return an array of countries from a global variable called
     * countries. If that variable does not already exist then it will be
     * created and populated from a JSON of country objects which should have
     * been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     */
    getCountryArray: function () {

        //If the countries array does not already exist then create it.

        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined')
                return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].statesArray = new Array();
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].statesArray.push({
                            value: state.code,
                            label: state.displayName
                        });
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;

    },

    /**
     * This function will load the state field depending on the country
     * selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     */
    loadStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }
        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
        }

        var stateDivObj = document.getElementById(stateDiv);
        if (Utils.get_IE_version()) { /* For IE */
            var stateClass = ($("#" + newid)).attr("className");
        } else {
            var stateClass = ($("#" + newid)).attr("class");
        }

        if (stateClass != "drop_down_country") {
            this.setStateClass(stateClass);
        }
        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode].states) {
            /* switch to state list. */
            stateDivObj.appendChild(this.createStateWithOptions(paramPrefix,
                currentCountryCode, currentState, id, required));
        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     *	This function creates an input element to represent the state.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createState: function (paramPrefix, currentState, id, required) {
        var stateInput = document.createElement("input");
        stateInput.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateInput.setAttribute("name", paramPrefix + "_state");
        } else {
            stateInput.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateInput.setAttribute("aria-required", "true");
        }
        stateInput.setAttribute("class", this.stateClass);
        stateInput.setAttribute("className", this.stateClass);
        stateInput.setAttribute("size", "35");
        stateInput.setAttribute("maxlength", "49");
        if (currentState != null && currentState != 'undefined') {
            stateInput.setAttribute("value", currentState);
        }
        return stateInput;
    },

    /**
     * This function creates a <select> element to represent the state field and
     * loads it with the states corresponding to the country field.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentCountryCode The country code of the selected country.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createStateWithOptions: function (paramPrefix, currentCountryCode, currentState, id, required) {

        this.getCountryArray();
        var stateSelect = document.createElement("select");
        stateSelect.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateSelect.setAttribute("name", paramPrefix + "_state");
        } else {
            stateSelect.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateSelect.setAttribute("aria-required", "true");
        }
        stateSelect.setAttribute("class", "drop_down_country");
        stateSelect.setAttribute("className", "drop_down_country");
        /*clear old options. */
        stateSelect.options.length = 0;

        /* add all states. */
        for (state_code in countries[currentCountryCode].states) {

            aOption = document.createElement("option");
            stateSelect.options[stateSelect.length] = aOption;
            aOption.text = countries[currentCountryCode].states[state_code];
            aOption.value = state_code;

            if (state_code == currentState
                || countries[currentCountryCode].states[state_code] == currentState) {
                aOption.selected = true;
            }
        }

        return stateSelect;
    },

    /**
     * This function will load the state field for selection dropdown using
     * wc.Select in AdressForm.jsp depending on the country selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     * @param {boolean}
     *            addEmptyOption - If true, it adds 'Please Select' as the first
     *            option with value set to ''.
     */
    loadAddressFormStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue, addEmptyOption) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required = false;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }

        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        }

        var stateDivObj = document.getElementById(stateDiv);
        var stateClass = ($("#" + newid)).attr("class");

        if (stateClass !== "drop_down_country") {
            this.setStateClass(stateClass);
        }

        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode]
            && countries[currentCountryCode].statesArray) {
            /* switch to state list. */
            var statesData = countries[currentCountryCode].statesArray;
            if (addEmptyOption) {
                var option1 = new Object({
                    label: Utils.getLocalizationMessage("PLEASE_SELECT"),
                    value: ''
                });
                statesData.unshift(option1);
            }

            if (this.stateClass == "" || this.stateClass == null
                || this.stateClass == undefined
                || this.stateClass == "null") {
                this.stateClass = "wcSelect";
            }

            $('<select>').attr({
                'name': paramPrefix + 'state',
                'id': paramPrefix + id,
                'class': this.stateClass,
                required: 'required'
            }).appendTo(stateDivObj);
            statesData.forEach(function (item) {
                $('<option>').attr({
                    'value': item.value
                }).html(item.label).appendTo('#' + paramPrefix + id);
            });

            var options = {
                "wcMenuClass": "wcSelectMenu",
            }
            var statesSelect = $("#" + paramPrefix + id).Select(options);
            statesSelect.val(currentState);
            statesSelect.Select("refresh_noResizeButton");

        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     * This function validates the address form independently from the order of the fields displayed on the form, i.e. independent from the locale.
     * A  hidden field named "fields" must be set in the jsp/jspf file that calls this method. The purpose of this hidden field is to set all the mandatory
     * input fields and the order of these fields displayed on each locale-specific address entry page, so that this method knows which input
     * fields to validate and in which order it should validate them.
     *
     * assumptions:
     **1. Mandatory fields use UPPER CASE, non-mandatory fields use lower case.
     **2. The error messages used in this method are declared in the
     * jsp/jspf files that call this method.
     *
     * @param {string} form: The name of the address form obtained from the page containing address input fields.
     * @param {string} prefix: The value is set to shipping or billing.
     * @return {boolean} return: true if no error was found, or the hidden field "fields" were not set in the jsp/jspf file that calls this
     * method, return false if form could not be found, or if there was  an error validating a particular field.
     */
    validateAddressForm: function (form, prefix) {
        reWhiteSpace = new RegExp(/^\s+$/);
        if (prefix == null) {
            prefix = ""
        };
        if (prefix) {
            this.setStateDivName(prefix + "stateDiv")
        };

        if (form != null) {
            var fieldsOrderByLocaleInput = $(form).find("input[id^='AddressForm_FieldsOrderByLocale']");
            if (fieldsOrderByLocaleInput.length>0){
                $(fieldsOrderByLocaleInput).attr("id","AddressForm_FieldsOrderByLocale");
            }

            var fields = "";
            /** The hidden field "AddressForm_FieldsOrderByLocale" is to set all the mandatory fields AND the order of the fields
            *   that are going to be displayed in each locale-dependent address form, so that the JavaScript
            *   used for validation knows which fields to validate and in which order it should validate them. **/
            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
            	fields = document.getElementById("AddressForm_PickUp").value.split(",");
            }else{
            	if (form["UserDetailsForm_FieldsOrderByLocale"] != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["UserAddressForm_FieldsOrderByLocale"] != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form[prefix + "AddressForm_FieldsOrderByLocale"] != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["AddressForm_FieldsOrderByLocale"] != null
                          && form["AddressForm_FieldsOrderByLocale"].value != null
                          && form["AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (document.getElementById("AddressForm_FieldsOrderByLocale").value != null
                          && document.getElementById("AddressForm_FieldsOrderByLocale").value != "") {
                            fields = document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
                    }
            }
            

            var nickName = prefix + "nickName";
            var lastName = prefix + "lastName";
            var firstName = prefix + "firstName";
            var middleName = prefix + "middleName";
            var address1 = prefix + "address1";
            var address2 = prefix + "address2";
            var address3 = prefix + "address3";
            var city = prefix + "city";
            var state = prefix + "state";
            var country = prefix + "country";
            var zipCode = prefix + "zipCode";
            var email1 = prefix + "email1";
            var phone1 = prefix + "phone1";
            var cpf = prefix + "fax1";
            var neighborhood = prefix + "fax2";
            var birth_date = prefix + "birth_date";
            var birth_month = prefix + "birth_month";
            var birth_year = prefix + "birth_year";

            var isValid = true;
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                //console.log("PSL::"+field);
                if (field == "NICK_NAME" || field == "nick_name") {
                    if (form[nickName] != null) {
                        form[nickName].value = trim(form[nickName].value);
                        if (field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))) {
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], false);
                            isValid = false;
                        } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], true);
                        }
                        if (!MessageHelper.isValidUTF8length(form[nickName].value, 254)) {
                            MessageHelper.formErrorHandleClient( form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]);
                            //tealiumPushFormError(MessageHelper.messages["ERROR_RecipientTooLong"]);
                            isValid = false;
                        }
                    }
                } else if (field == "LAST_NAME" || field == "last_name") {
                    if ($(form[lastName]).attr("disabled") == undefined){
                        form[lastName].value = trim(form[lastName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))) {
                            this.manageMultipleEmptyFields(form[lastName], MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        } else if(xss.test(form[lastName].value)){
                            this.manageMultipleEmptyFields(form[lastName],MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        }else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[lastName], "", true);
                            this.validateNotEmpty(form.lastName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[lastName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[lastName].id,MessageHelper.messages["ERROR_LastNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_LastNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "FIRST_NAME" || field == "first_name") {
                    if ($(form[firstName]).attr("disabled") == undefined){
                        form[firstName].value = trim(form[firstName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value)) {
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                            this.removeSuccesIcon(form.firstName);
                            isValid = false;
                        }else if(xss.test(form[firstName].value)){
                        		this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                                this.removeSuccesIcon(form.firstName);
                                isValid = false;
                          } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], true);
                            this.validateNotEmpty(form.firstName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[firstName].value,128)) {
                        MessageHelper.formErrorHandleClient(form[firstName].id,MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "MIDDLE_NAME" || field == "middle_name") {
                    form[middleName].value = trim(form[middleName].value);
                    if (field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))) {
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[middleName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[middleName].id,MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "use_org_address" || field == 'new_line' || field == "PASSWORD" || field == "PASSWORD_VERIFY") {
                } else if (field == "ADDRESS" || field == "address") {
                    form[address1].value = trim(form[address1].value);
                    xss = new RegExp(".*[%<>&;'\0].*"); 
                    if (field == "ADDRESS" && (form[address1].value == "" || reWhiteSpace.test(form[address1].value))) {
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    } /*else if(xss.test(form[address1].value)){
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    }*/else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[address1].value,100)) {
                        MessageHelper.formErrorHandleClient(form[address1].id,MessageHelper.messages["ERROR_AddressTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_AddressTooLong"]);
                        isValid = false;
                    }
                } else if (field == "ZIP" || field == "zip") {
                   var isMandatory = field == "ZIP";
                   if(zipCodeError){
                       isValid= false;
                   }
                   if (!this.validateZipCodeFormField(form[zipCode], isMandatory)){
                       isValid = false;
                   }

                } else if (field == "CITY" || field == "city") {
                    form[city].value = trim(form[city].value);
                    if (field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))) {
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], false);
                        this.removeSuccesIcon(form.city);
                            isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], true);
                        }
                    if (!MessageHelper.isValidUTF8length(form[city].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[city].id,MessageHelper.messages["ERROR_CityTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CityTooLong"]);
                        isValid = false;
                    }
                } else if ((field == "STATE/PROVINCE" || field == "state/province") && form.action.indexOf("PersonChangeServiceAddressAdd") == -1) {
                    state = form[state];
                    if (state == null || state == "") {
                        state = document.getElementById(this.stateDivName).firstElementChild;
                    }

                   
                    if(state.value==""){
                        var stateProvince = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
                        state.value = trim(stateProvince.value);
                    }
                    if (state.value != undefined) {
                        state.value = trim(state.value);
                    }
                    if (field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))) {
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(state.value, 128)) {
                        if (state.tagName == "INPUT" || state.tagName == "input") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR _StateTooLong"]);
                        }
                        //tealiumPushFormError(MessageHelper.messages["ERROR_StateTooLong"]);
                        isValid = false;
                    }
                } else if (field == "COUNTRY/REGION" || field == "country/region") {
                    form[country].value = trim(form[country].value);
                    // if (field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value)) || !this.isSameCountryAsStore) {
                    if (form[country].value == "" || reWhiteSpace.test(form[country].value)) {
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], true)
                    }
                    if (!MessageHelper.isValidUTF8length(form[country].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CountryTooLong"]);
                        isValid = false;
                    }
                } else if (field == "EMAIL1" || field == "email1") {
                    if  (form.name !== "Register" && form.action.indexOf("PersonChangeServiceAddressAdd") == -1){
                        var isMandatory = field == "EMAIL1";
                        if (!this.validateEmailFormField(form.email1, isMandatory)){
                            isValid = false;
                        }
                    }
                } else if ((field == "PHONE1" || field == "phone1") && (form.id.includes("shipping") || form.id.includes("billing") ||form.id.includes("recipient"))) {
                    var isMandatory = field == "PHONE1";
                    if (!this.validatePhoneNumberFormField(form.phone1, isMandatory)){
                        isValid = false;
                    }
                } else if (field == "CODICE_FISCALE" || field == "codice_fiscale") {
                    var isMandatory = field == "CODICE_FISCALE";
                    //codice fiscale is stored in the custom address field 1
                    if (!this.validateCodiceFiscaleFormField(form.addressField1, isMandatory)){
                        isValid = false;
                    }
                } else if ((field == "NUMERO" || field == "numero")){
                    var formField = form[address2];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NUMERO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NUMERO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NUMERO field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "COMPLEMENTO" || field == "complemento")){
                    var formField = form[address3];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "COMPLEMENTO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_COMPLEMENTO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: COMPLEMENTO field empty.NEEDS COMPLETITION");
                    } else  {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "NEIGHBORHOOD" || field == "neighborhood")){
                    var formField = form[neighborhood];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NEIGHBORHOOD") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NEIGHBORHOOD_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NEIGHBORHOOD field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "CPF" || field == "cpf")){
                    var formField = form[cpf];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "CPF") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field empty.NEEDS COMPLETITION");
                    }
                    else if(!(validateCPFCNPJ(formField, false))){
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Invalid"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field not valid");
                    } else {
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "DATEOFBIRTH" || field == "dateofbirth") && $('.checkout-quick-register .dob').length == 0){
                    var formField = document.getElementsByClassName("dob__content")[0];

                    if ($(formField).parent().attr("disabled") == undefined){
                        // var formField = form[birth_date];
                        var birthdate = trim(form[birth_date].value);
                        var birthmonth = trim(form[birth_month].value);
                        var birthyear = trim(form[birth_year].value);


                        var isEmpty =  false;
                        if (  (birthdate == "" || reWhiteSpace.test(birthdate))
                            ||(birthmonth == "" || reWhiteSpace.test(birthmonth))
                            ||(birthyear == "" || reWhiteSpace.test(birthyear)) ){
                                isEmpty = true;
                        };

                        if (isEmpty) {
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Empty"]);
                        }
                        else if (!this.validateAge(birthyear)){
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Invalid"]);
                        }
                    }

                    else {
                        //delete error Messages
                        // this.manageFormErrorFields(formField, "");
                        this.deleteFormErrorMessageFields(formField);
                    }
                }
            } //end for loop

            if (!isValid) {
                $("body").scrollTop(0);

                //this if prevents js error if WCAG.js are not imported
                if(typeof moveToError === 'function'){
                    moveToError();
                }
                restoreAjaxButtons();
                return false;
            }

            return true;
        }
        // /The form is null so..
        return false;
    },
    ////************************************************************************************************* */

/**
 * Function to validate that the register user is older than 18
 * @param {*} form
 */
    validateAge: function(birthYear){
        var isValidAge=true;
        var currentYear = new Date().getFullYear();
        if (isGDPR){
            if (currentYear-birthYear<16){
                isValidAge = false;
            }
        }else if (isCarol){
            if (currentYear-birthYear<18){
                isValidAge = false;
            }
        }
        return isValidAge;
    },

    createFormErrorMessageField: function (fieldID, errorMsg) {
    //If the error message does not exist, sets a generic error message.
        // if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
        //     errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        // }
    //Otherwise, creates a new div to display the error message
        var errorMessageField = document.createElement('div');
        errorMessageField.setAttribute("class", "address-erros-message-cont error-message-wrapper");
        errorMessageField.innerHTML = '<span tabindex="0" id="errorMessageFieldFor_' + fieldID + '" class="error-message form-error-message wcag__error">' + errorMsg + '</span>';

        return errorMessageField;
    },

/**
 * Manage multiple address form error messages for each concerned field.
 */
    manageFormErrorMessageFields: function (field, errorMsg) {


            this.deleteFormErrorMessageFields(field);
            var errorMessageField = this.createFormErrorMessageField(field.id, errorMsg);
            $(field).addClass("field-error-message inputField--invalid");
            field.parentNode.appendChild(errorMessageField);






            //Prevents js error if WCAG.js is not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }

            //Tealium filling form Errors
            //if (typeof tealiumPushFormError !== "undefined" ) {
                //tealiumPushFormError(errorMsg);
                //tealiumPushFormError(errorMsg);
            //}
    }, 

    /**
     * Deletes the error message if the field is not empty anymore.
     * @param {*} field
     */
    deleteFormErrorMessageFields: function (field){
        $("#"+field.id).parent().find(".address-erros-message-cont").remove();
        $("#"+field.id).parent().find(".error-message-wrapper").remove();
    },

    ////************************************************************************************************* */



    /**
     * mandatory field shown when one or multiple empty fields in forms
     */
    getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
    //If the error message does not exist, sets a generic error message.
        if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
            errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        }
    //Otherwise, creates a new div to display the error message
        var mandatoryField = document.createElement('div');
        mandatoryField.setAttribute("class", "address-erros-message-cont");
        mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';

        return mandatoryField;
    },
    /**
      * manage multiple address form empty fields add Error message for each
      * concerned field
     */
    manageMultipleEmptyFields: function (field, errorMsg, isNotEmpty) {

        var mandatoryErrorFieldId = "mandatoryField_" + field.id;

        // delete error message if field is no more empty
        var currentField = document.getElementById(mandatoryErrorFieldId);
        if (currentField != null) {
            $(field).removeClass("field-error-message");
            if (currentField.parentNode != null && currentField.parentNode.className != undefined && currentField.parentNode.className.indexOf("address-erros-message-cont") >= 0) {
                $(currentField.parentNode).remove();
            } else {
                currentField.remove();
            }
        }

        if (!isNotEmpty) {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (!isOliver && field.name != undefined && field.name.toLocaleLowerCase().indexOf('address') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name != 'state' ){//pre modifica ||(isPersol && field.name == 'address1' && $('.myAccountSummary').length == 0) 
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                    //Tealium filling form Errors
                    //tealiumPushFormError(errorMsg);
                }
            }
        }

    },


    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        //Sets the field that the error will be associated to.
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // field.parentNode.appendChild(mandatoryField);
                    field.parentNode.insertAdjacentElement('beforeend', mandatoryField);

                    //this if prevents js error if WCAG.js are not imported
                    if(typeof moveToError === 'function'){
                        moveToError();
                    }

                    //Tealium filling form Errors
                    //if (typeof tealiumPushFormError !== "undefined" ) {
                        //tealiumPushFormError(errorMsg);
                    //}
                }
            }
        }

    },

    /**
     *
     * @param {*} formName Controls if the field is still empty
     */
    isEmpty: function (formField){
        if (formField.value == "" || reWhiteSpace.test(formField.value)){
            return true;
        }
        else{
            this.manageMultipleErrorFields(formField, "", true);
            return false;
        }
    },


    /* NEW */
    validateZipCodeFormField: function(formField, isMandatory){
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value.toUpperCase());
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeEmpty"]);       
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,40)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeTooLong"]); 
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeTooLong"]);
        } else if (!isEmpty) {
            var zipCodeRegexp = this.getZipCodeRegexpForCurrentCountryCode();
            if (!zipCodeRegexp.test(formFieldValue)){
                isValid = false;
                this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //BEGIN HB-10030 - when the call is from goToOrderPaymentViewOnClickHandler
                //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                    //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //END HB-10030
            }
        }
        if (!isValid) {
            isValid = false;
        } else if (!isEmpty) {
            //We check if the country is the same as in the store
            if (this.storeCountry == 'UK') {
                this.storeCountry = 'GB';
            }
            this.isSameCountryAsStore = (this.storeCountry === countryCode);

            this.autofillFormAddressFromZipCode(formField);

            if (this.hasTaxes && formField.form.name.includes("shipping")) {
                CheckoutHelperJS.calculateTaxesFromZipCode(formField);
            }
            isValid = true;
        }
        if(isValid){
            this.addSuccesIcon(formField);
            setTimeout(function() { 
               AddressHelper.showHiddenField(formField);
            }, 500);   
            
        }
        this.removeSuccesIcon(formField);
        return isValid;
    },

    validatePhoneNumberFormField: function(formField, isMandatory){
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var phoneNumber = formFieldValue;
        var isValid = true;

        function isCybersourceValidPhoneNumber(phone){
            var isValid = true;
            var digits = "0123456789";
            var digitsCount = 0;
            var validCharsRegexp = /[a-zA-Z0-9\-\(\)\+\,\*\.\#\/\s]/g;

            for (var i = 0; i < phone.length; i++) {
                if (digits.includes(phone[i])){
                    digitsCount++;
                }
            }

            if (digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp).length != phone.length){
                isValid = false;
            }
            
        
            return isValid;
        }

        function parsePhoneNumberSAP(phone){
            var invalidCharsSAP = "-;/+";
            var parsedPhoneNumber = "";
            for (var i = 0; i < phone.length; i++) {
                var element = phone[i];
                if (invalidCharsSAP.includes(element)){
                    parsedPhoneNumber += " ";
                } else {
                    parsedPhoneNumber += element;
                }
            }
            return parsedPhoneNumber;
        }

        this.removeFieldErrorMessages(formField);
        if (isMandatory && isEmpty) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
        } else if (!isCybersourceValidPhoneNumber(phoneNumber)){
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
        } else {
            formField.value = parsePhoneNumberSAP(phoneNumber);
        }
        if (isValid){
            this.addSuccesIcon(formField);
            return true;
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateEmailFormField: function(formField, isMandatory) {
        //var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        this.removeFieldErrorMessages(formField);
        $(formField).next().removeClass('labelOnTop');
        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailTooLong"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!emailRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            //We have to clear input's email value before setting it again because of
            //the "special" behavior of the <input type="email"> tag containing spaces
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            this.addSuccesIcon(formField);
            return true;
        }else if(!isEmpty){
            $(formField).next().addClass('labelOnTop');//class that block label on top when the email is invalid and not empty
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateCodiceFiscaleFormField: function(formField, isMandatory) {

        var codiceFiscaleRegexp = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale mandatory and empty"/*MessageHelper.messages["ERROR_EmailEmpty"]*/);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale too long"/*MessageHelper.messages["ERROR_EmailTooLong"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!isEmpty && !codiceFiscaleRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale bad format"/*MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            return true;
        }
        return false;
    },
    showHiddenField : function(formField){
            if(formField.matches(":-webkit-autofill") || $(formField).is(".GoogleAutoFilled")){
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").each(function(index){$( this ).prop("readonly",true)})
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").addClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
            }else{
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").removeClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.prov").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").removeClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.cityfield").find("input").prop("readonly",false);               
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").trigger("change");
            }
            
         },
      
      
    validateNotEmpty : function (formField, isMandatory) {

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
        }
        if (isValid) {


            this.addSuccesIcon(formField);
            
            return true;
        }
        this.removeSuccesIcon(formField);
        
       
        return false;


    },
   
    addFieldErrorMessage: function(formField, errorText){
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        var errorMessageClassName = "address-field-error-message--"+formField.name;

        //Add class to the field in order to change its CSS
        $(formField).addClass("field-error-message");
        //Create error messages container if it does not exist already
        if ($("."+errorContainerClassName).length==0){
            $(formField).parent().append("<div class='" + errorContainerClassName + " error-message wcag__error' tabindex='0'></div>");
        }
        $("."+errorContainerClassName).append("<div class='"+errorMessageClassName+"'>"+errorText+"</div>");
    },

    removeFieldErrorMessages: function(formField){
        $(formField).removeClass("field-error-message");
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        if ($("."+errorContainerClassName).length>0){
            $("."+errorContainerClassName).remove();
        }
    },

    /**
     * Returns data into shipping/billing form as JSON
     */
    getJSONContactDataFromAddressForm: function (formName) {
        var form = document.forms[formName];
        var dataArray = {};
        if (form.addressType != undefined) dataArray.addressType = form.addressType.value;
        if (form.nickName != undefined) dataArray.nickName = form.nickName.value;
        if (form.firstName != undefined) dataArray.firstName = form.firstName.value;
        if (form.lastName != undefined) dataArray.lastName = form.lastName.value;
        if (form.phone1 != undefined) dataArray.phone1 = form.phone1.value;
        if (form.email1 != undefined) dataArray.email1 = form.email1.value;
        dataArray.addressLine = ["", "", ""];
        if (form.address1 != undefined) dataArray.addressLine[0] = form.address1.value;
        if (form.address2 != undefined) dataArray.addressLine[1] = form.address2.value;
		if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        if (form.zipCode != undefined) dataArray.zipCode = form.zipCode.value;
        if (form.city != undefined) dataArray.city = form.city.value;
        if (form.country != undefined) dataArray.country = form.country.value;
        if (form.state != undefined) dataArray.state = form.state.value;
        if (form.fax1 != undefined) dataArray.fax1 = form.fax1.value;
        if (form.fax2 != undefined) dataArray.fax2 = form.fax2.value;

        if (countryCode == "US" || countryCode == "CA"){
            //In US and Canada Address3 field will be set as ZIPCODE-STATE. E.g. 10507-NW
            dataArray.addressLine[2] = dataArray.zipCode + "-" + dataArray.state;
        } else {
            if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        }

        return JSON.stringify(dataArray);
    },

    /**
     * This function saves the address entry form when a registered customer
     * wants to edit/add a new address during checkout from his/her shopping
     * cart.
     *
     * @param {string}
     *            The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            The name of the form containing address information.
     * @param {string}
     *            The addressTypeIn being saved.
     */

    saveShopCartAddress: function (serviceId, formName, addressTypeIn) {
        var form = document.forms[formName];
        if (addressTypeIn == 'ShippingAndBilling' || addressTypeIn == 'Shipping') {
            if (serviceId == 'AjaxUpdateAddressForPerson') {
                serviceId = 'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout';
            } else {
                serviceId = 'AjaxAddShippingAndBillingAddressForPersonDuringCheckout';
            }
        }
        if (this.validateAddressForm(form)) {
            this.saveAddress(serviceId, formName);
        }
    },

    /**
     *
     * @param {*} addressId
     * @param {*} addressType Accepted values are "S" for Shipping, "B" for Billing, and "SB" for ShippingBilling
     */
    updateAddressCookies: function(addressId, addressType){
        var error = false;

        if (typeof addressId !== 'undefined' && addressId != null
            && typeof addressType !== 'undefined' && addressType != null){

            if (addressType === "Billing") {
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "Shipping") {
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "ShippingAndBilling"){
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else {
                error = true;
            }
        } else {
            error = true;
        }

        if (error){
            console.log("PSL::AddressHelper.js::updateAddressCookies::Invalid parameters: "
            + "addressType = " + addressType + ", "
            + "addressId = " + addressId);
        } else {
            console.log("PSL::AddressHelper.js::updateAddressCookies::Address cookies updated");
            addressId_formS = getCookie("addressId_formS_"+storeDirectory);
            addressId_formB = getCookie("addressId_formB_"+storeDirectory);
        }
    },

    /**
     *
     */
    initAddressCookies: function(){

        function logAddressErrors(shippingAddressType, billingAddressType){
            if ((shippingAddressType == "" && billingAddressType == "")
            ||(shippingAddressType == "SB" && billingAddressType == "")
            ||(shippingAddressType == "S" && billingAddressType == "B")) {
                plog("AddressHelper.js::initAddressCookies:: Address settings OK");
            } else {
                plog("AddressHelper.js::initAddressCookies:: Address settings KO");
            }
        }

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
        $.ajax({
            method: "GET",
            url: url,
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            dataType: "json",
            data: {
                "timestamp": Date.now()
            },
            success: function(data, textStatus, jqXHR){
                if (typeof data.contact === 'undefined'){
                    plog("AddressHelper.js::initAddressCookies::Address not found");
                } else {
                    for (var i = 0; i<data.contact.length; i++){
                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
                        }
                    }
                }
            },
            error: function(jqXHR, exception){
                plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
            },
            complete: function(){
            }
        });
    },

    /**
     *
     * @param storeId current store id
     * @param onSuccessURL if the update is ok, go to this url
     * @returns
     */
    updateUnregisteredCheckoutAddress: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        location.href = onSuccessURL; 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
                form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    resetUnregisteredCheckoutAddressCookies: function () {
        setCookie("addressId_formS_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
        setCookie("addressId_formB_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
    },

    /**
     * This function saves the address entry form on an unregistered user's
     * checkout page.
     *
     * @param {string} formName1 The name of the billing address form.
     * @param {string} formName2 The name of the shipping address form.
     * @param {string} stateDivName1 The name of the state field in the billing address form.
     * @param {string} stateDivName2 The name of the state field in the shipping address form.
     */
    saveUnregisteredCheckoutAddress: function (formName1, formName2, stateDivName1, stateDivName2/*, buttonId, event*/) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];

        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: Valores iniciales:");
        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form1.nickName.value = " + form1.nickName.value);
        if (form2) {
            console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form2.nickName.value = " + form2.nickName.value);
        }

        this.setStateDivName(stateDivName1);
        /* Validate form input fields */
        if (this.validateAddressForm(form1)) {
            var addressNickNameBase = "MyAddress_";
            var sameaddress = document.getElementById("SameShippingAndBillingAddress");

            if (!sameaddress || sameaddress.checked) {
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }

                form1.addressType.value = 'ShippingAndBilling';
                if (form1.addressId == undefined || form1.addressId.value === '') {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('AddShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }
                else {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, UpdateShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('UpdateShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }

            }
            else {
                //var form2 = document.forms[formName2];
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }
                if (form2.nickName.value == undefined || form2.nickName.value == "") {
                    form2.nickName.value = addressNickNameBase + "Billing";
                }

                console.log("PSL::AddressHelper.js:: form1.nickName.value = " + form1.nickName.value);
                console.log("PSL::AddressHelper.js:: form2.nickName.value = " + form2.nickName.value);

                // Store form1 email as billing address email
                if(!isPersol && !isOliver){
                    form2.email1.value = form1.email1.value;
                }
                

                /* Validate form input fields */
                if (this.validateAddressForm(form2)) {
                    this.setStateDivName(stateDivName2);

                    /*
                     * Note that, when want to save different shipping and billing addresses, we only call AddBillingAddress,
                     * because AddShippingAddress will be called in the successHandler of the service AddBillingAddress
                     * declared in MyAccountServicesDeclaration.js
                     * This is the out-of-the-box behavior in AuroraStorefrontStore
                     */
                    if (form2.addressId == undefined || form2.addressId.value === '') {
                        //console.log("PSL::AddressHelper.js::Add billing address");
                        //$(buttonId).off(event);
                        if (form1.addressId != undefined && form2.addressId != undefined &&
                            form2.addressId.value == form1.addressId.value) {
                            form2.addressId.value = "";
                        }
                        console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                        this.saveAddressCheckoutGuest('AddBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                    else {
                        //$(buttonId).off(event);
                        console.log("PSL::AddressHelper.js::Update billing address");
                        this.saveAddressCheckoutGuest('UpdateBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                }
                else {
                    //FIXME
                    restoreAjaxButton("WC_UnregisteredCheckout_links_4");
                }
            }
        }
        else {
            //FIXME over only a form
            restoreAjaxButton("WC_UnregisteredCheckout_links_4");
        }
    },

    /**
     * This function saves an address entry form to the associated service.
     *
     * @param {string}
     *            serviceId The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            formName The name of the form containing address information.
     */
    saveAddress: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        //		if (form.address1.value == "" && form.address2.value != "") {
        //			form.address1.value = form.address2.value;
        //			form.address2.value = "";
        //		}
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */

        // should migrate this solution to GlobalLoginActions.js to avoid
        // GlobalLoginJS.updateGlobalLoginUserDisplay("...");
        var header = document.getElementById("header");
        if (header == null || !this.hasClass(header, "checkout")) {
            if (!submitRequest()) {
                return;
            }
        }

        cursor_wait();
        wcService.invoke(serviceId);
    },

    ajaxSaveAddress: function (serviceId, formName) {
        // AjaxAddAddressForPerson or AjaxUpdateAddressForPerson
        resetRequest();
        var service = serviceId;
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        if(!this.validateAddressForm(form)) {

            return false;
        } else {
            var dialog = $("#addEditAddressPopup").data("wc-WCDialog");
            if (dialog) {
                dialog.close();
                $("#addEditAddressPopup").css("display", "none");
            }

        }
        if (form.addressId != undefined && form.addressId.value != '') {
            service = 'AjaxUpdateAddressForPerson';
            form.nickName.remove();
        }
        if (form.nickName && form.nickName.value == '') {
            form.nickName.value = new Date().getTime();
        }

        var addressService = wcService.getServiceById(service);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(service);
    },

    /**
     * This function saves an address entry form to the associated service only
     * in the ShippingAndBilling screen in checkout as a Guest.
     *
     * @param {string} serviceId The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string} formName The name of the form containing address information.
     */
    saveAddressCheckoutGuest: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);

        cursor_wait();
        wcService.invoke(serviceId);
    },

    hasClass: function (element, inputClass) {
        return (" " + element.className + " ").indexOf(" " + inputClass + " ") > -1;
    },

    /**
     * This function calls UpdateOrderItem/AjaxUpdateOrderItem service to update
     * order calculation
     */
    updateOrderAfterAddressUpdate: function () {
        var params = {
            storeId: ServicesDeclarationJS.storeId,
            catalogId: ServicesDeclarationJS.catalogId,
            langId: ServicesDeclarationJS.langId
        };
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.orderId = ".";

        cursor_wait();
        //wcService.invoke("AjaxUpdateOrderAfterAddressUpdate", params);
    },

    /**
     * This function populates the country code to mobile phone based on the
     * selected country.
     *
     * @param {string} countryDropDownId The id of the mobile country drop down list
     * @param {string} countryCallingCodeId The id of the mobile country calling code  text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = $("#" + countryDropDownId).val()
        if (countryCode === undefined || countryCode === null)
        // we are using wc.Select
        {
            var countryDropDownWidget = $("#" + countryDropDownId);
            if (countryDropDownWidget !== undefined
                && countryDropDownWidget !== null) {
                countryCode = countryDropDownWidget.val();
            }
        }
        $("#" + countryCallingCodeId).val(
            countries[countryCode].countryCallingCode);
    },

    /**
     * This function checks for an entry in the Mobile Phone Number field. If a
     * Mobile Phone number has been entered, it enables the SMS
     * Notifications/Promotions checkbox, else it disables the SMS
     * Notifications/Promotions checkbox.
     *
     * @param {string} form The name of the form containing the Mobile Phone Number entry field.
     * @param {string} jspStoreImgDir The directory for images
     */
    enableSMSNotifications: function (form, jspStoreImgDir) {
        var form = document.forms[form];
        if (form.mobilePhone1.value !== "") {
            form.sendMeSMSNotification.disabled = false;
            form.sendMeSMSPreference.disabled = false;
            $(".checkedCheckBox.mobileOption").removeClass("disabled").attr(
                "tabindex", "0");
        } else {
            form.sendMeSMSNotification.disabled = true;
            form.sendMeSMSPreference.disabled = true;
            form.sendMeSMSNotification.checked = false;
            form.sendMeSMSPreference.checked = false;
            $(".checkedCheckBox.mobileOption").addClass("disabled").attr(
                "tabindex", "-1").removeClass("checked").attr(
                    "aria-checked", "false").attr("src",
                        jspStoreImgDir + "images/checkbox.png");
        }
    },


    /**
     * Sets the address type when a user wants to add a new address of type
     * shipping and billing during order check out.
     *
     * @param {Object}: checkbox The HTML checkbox input object.
     * @param {Object}: form The form that includes the new address information.
     */
    setAddressTypeInCreatingNewAddressDuringCheckout: function (checkbox, form) {
        if (form.addressType != null && form.originalAddressType != null) {
            if (checkbox.checked) {
                form.addressType.value = 'ShippingAndBilling';
            } else {
                form.addressType.value = form.originalAddressType.value;
            }
        }
    },

    /**
     * Set checkbox state to true when checked and false when unchecked
     *
     * @param String jspStoreImgDir The directory for store images.
     * @param String checkbox The checkbox element.
     * @param String checkboxImg The checkbox image element.
     * @param String checkedValue The value of the input when checked.
     * @param String uncheckedValue The value of the input when unchecked.
     */
    changeCheckboxState: function (jspStoreImgDir, checkbox, checkboxImg, checkedValue, uncheckedValue) {
        var $checkboxImg = $("#" + checkboxImg), $checkbox = $("#" + checkbox);
        if (!$checkboxImg.hasClass("disabled")) {
            if ($checkboxImg.hasClass("checked")) {
                $checkboxImg.removeClass("checked");
                $checkboxImg.attr("aria-checked", "false");
                $checkboxImg
                    .attr("src", jspStoreImgDir + "images/checkbox.png");
                $checkbox.attr("value", uncheckedValue);
                $checkbox.removeAttr("checked");
            } else {
                $checkboxImg.addClass("checked");
                $checkboxImg.attr("src", jspStoreImgDir
                    + "images/checkbox_checked.png");
                $checkboxImg.attr("aria-checked", "true");
                $checkbox.attr("value", checkedValue);
                $checkbox.attr("checked", "checked");
            }
        }
    },
/** FORM VALIDATIONS *************************************************************************************************************************/

    validateEmail: function (email) {
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexp.test(email.value);
        // managing inline style and error message
        this.manageInlineValidationError(isValidEmail, email, 'emailError');
        return isValidEmail;
    },

    validateZipCode: function (zipCodeId, countryId, stateId, cityId, lang, storeName) {
        //getting zip code value
        var countrySelected = document.getElementById(countryId).value;
        var zipCode = document.getElementById(zipCodeId);

        //getting zipcode pattern per selected country
        var selectedCountryPattern = this.returnZipCodePattern();
        var zipRegex = new RegExp(selectedCountryPattern);

        //We match it to uppercase, always have to be like 'ZIP'
        var isValidZip = zipCode != '' && zipRegex.test(zipCode.value.toUpperCase());
        var isZipCodeChange = false;

        //We check if the country is the same as in the store
        if (this.storeCountry == 'UK') {
            this.storeCountry = 'GB';
        }
        this.isSameCountryAsStore = (this.storeCountry === countrySelected);

        //managing inline style and error message
        this.manageInlineValidationError(isValidZip, zipCode, zipCodeId + '_Error');

        // if(!isSameCountryAsStore) this.manageInlineValidationError(isSameCountryAsStore, countrySelected, countryId + '_Error');
        if (isValidZip) {
            //autofill city and state with data
            if (zipCode.value !== "") {
                this.fillFormAddressWithData(zipCode, countryId, stateId, cityId, lang);
            }

            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = true;
            } else {
                this.validZipCodeShipping = true;
            }
            var countryCode = jQuery('#' + countryId).val();
            if (zipCodeId.indexOf("shippingAddress") >= 0) {
                isZipCodeChange= (getCookie("addressId_formB_"+storeDirectory)!=undefined|| getCookie("addressId_formS_"+storeDirectory)!=undefined);
                if (this.hasTaxes) {
                    CheckoutHelperJS.calculateEstematedTax(zipCode.value, countryCode, lang, true, isZipCodeChange, storeName);
                }
            }

        } else {
            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = false;
            } else {
                this.validZipCodeShipping = false;
            }
        }
    },

    /**
     * HB-343 , inline codice fiscale validation
     */
    validateCodiceFiscale: function (codiceId) {
        var selectedCountryCode = this.selectedCountryCode;

        if (selectedCountryCode == 'IT') {
            // getting zip code value
            var codice = document.getElementById(codiceId);

            // getting zipcode pattern per selected country
            var codiceRegex = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

            var isValidCodice = (codice == undefined || codice == null
                || codice.value == undefined || codice.value == ''
                || codiceRegex.test(codice.value));

            // managing inline style and error message
            this.manageInlineValidationError(isValidCodice, codice, codiceId + '_Error');

            return isValidCodice;

        } else {
            return true;
        }
    },

    /**
     * show,hide error message for inline validation
     * @param : isValidInput boolean for valid / invalid input
     * @param : element : input element concerned by validation
     * @param : errorMessageId : span containing error message for input
     */
    manageInlineValidationError: function (isValidInput, element, errorMessageId) {
        if (isValidInput) {
            return true;
        } else {
            return false;
        }
    },


/** END FORM VALIDATIONS *************************************************************************************************************************/

    /* NEW */
    getZipCodeRegexpForCurrentCountryCode: function () {
        var countryregex = "";

        if (countryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        } else if (countryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        } else if (countryCode == 'IT' || countryCode == 'FR' || countryCode == 'ES') {
            countryregex = /^\d{5}$/;
        } else if (countryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        } else if (countryCode == 'GB' || countryCode == 'UK') {
            countryregex = /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/;
        } else {
            countryregex = /./;
            plog("AddressHelper.js::getZipCodeRegexpForCurrentCountryCode()::Error: Regexp not found for countryCode:"+countryCode);
        }

        return countryregex;
    },


    /**
     * return country zipCode pattern per country
     * @param : countryCode : code of concerned country
     */
    returnZipCodePattern: function () {
        var selectedCountryCode = this.selectedCountryCode;
        var countryregex = "";

        if (selectedCountryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        }
        if (selectedCountryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        }
        if (selectedCountryCode == 'IT' || selectedCountryCode == 'FR' || selectedCountryCode == 'ES') {
            countryregex = /^\d{5}$/;
        }
        if (selectedCountryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        }
        if (selectedCountryCode == 'GB') {
            countryregex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;
        }

        return countryregex;

    },


    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     * @param {*} countryId
     * @param {*} stateId
     * @param {*} cityId
     * @param {*} lang
     */
    fillFormAddressWithData: function (zip, countryId, stateId, cityId, lang) {
        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zip.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zip.value;
            var neightborhoodChars = this.maxNeighborhoodChar;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                //Tuncate string -> OCPD-670
                                autofilledNeighborhood.val((data.addressInfo[0].neighborhood).substring(0,neightborhoodChars));
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zip.value, lang, function(result){
                var error = false;
                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                		AddressHelper.zipCodeNotFound = true;
                		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                	}
                	else {
                		error=true;
	                    console.log("PSL::AddressHelper.js::fillFormAddressWithData function ajax error (GoogleAPI):"+result.error_description);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zip, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zip.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zip, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
                        var city = "";

                        if(document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1')!=null){
                            city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
                        }else{
                            city = document.getElementById('WC_UserRegistrationUpdateForm_AddressEntryForm_FormInput_city_1').value;
                        }
	                	
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zip, "", true);
                	}
                	/*else {
                		if(autofilledState != null && autofilledState.value != '') {
                			autofilledStateHidden.value = autofilledState.value;
                		}
                	}*/
                }

            });
        }
    },

    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     */
    autofillFormAddressFromZipCode: function (zipCodeFormField /*, countryId, stateId, cityId, lang*/) {

        var zipCodeFormFieldId = zipCodeFormField.id;
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");

        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zipCodeFormField.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipCodeFormField.value;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                autofilledNeighborhood.val(data.addressInfo[0].neighborhood);
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
                var error = false;
                if (typeof zipCodeFormField.form.city !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.city);
                }
                if (typeof zipCodeFormField.form.state_full !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.state_full);
                }

                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                 		AddressHelper.zipCodeNotFound = true;
                 		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                 	}
                 	else {
                 		error=true;
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error (GoogleAPI): "+result.error_description);
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error: ",result.raw);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zipCodeFormField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
	                    $(zipCodeFormField.form).find("input[name=city]").val("");
	                    $(zipCodeFormField.form).find("input[name=state]").val("");
	                    $(zipCodeFormField.form).find("input[name=state_full]").val("");
                 	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zipCodeFormField.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zipCodeFormField, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
	                	var city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zipCodeFormField, "", true);
                     
	                    if(($('#errorAddressValidation').is(":visible") && $('#addressValidationFirstTime').val() == 'false') || $('#errorAddressValidation').is(":hidden")){
	                    	AddressHelper.addSuccesIcon(zipCodeFormField);
	                    }
	                    
                        AddressHelper.addSuccesIcon('#'+countryId);
                        AddressHelper.addSuccesIcon('#'+stateId);
                        AddressHelper.addSuccesIcon('#'+cityId);
                        
                	}
                }else{
                    AddressHelper.removeSuccesIcon(zipCodeFormField);
                        AddressHelper.removeSuccesIcon('#'+countryId);
                        AddressHelper.removeSuccesIcon('#'+stateId);
                        AddressHelper.removeSuccesIcon('#'+cityId);
                }
                var shippingSelected = $('.shipping_method_content input[name="singleShipmentShippingMode"]:checked').attr("typeshipping").toUpperCase();
                if(shippingSelected == 'COLLECT IN STORE') {
                    autofilledCity.classList.add("blockForBoss");
                    autofilledState.classList.add("blockForBoss");
                }

            });
        }
    },

    fillFormAddressFromAddressDataObject: function(destForm, addressObj){
        if (typeof destForm.city !== 'undefined') {
            destForm.city.value = addressObj.address.city;
        }
        if (typeof destForm.state !== 'undefined') {
            destForm.state.value = addressObj.address.prov_state_short;
        }
        if (typeof destForm.state_full !== 'undefined') {
            destForm.state_full.value = addressObj.address.prov_state;
        }
        if (typeof destForm.zipCode !== 'undefined') {
            destForm.zipCode.value = addressObj.address.zipcode;
        }
    },

    /**
     * Function that launches the command to join the newsletter with the email from the Shipping address
     */
    joinNewsletter: function (form, langId, storeId) {
        reWhiteSpace = new RegExp(/^\s+$/);

        var subscriptionOn = false;
        var updateop = true;
        if ($('#joinNewsletterCheck').is(':checked')) {
        	subscriptionOn = true;
        }else{
        	if(userType == 'R' ){
        		updateop = false;
        	}
        }

        var emailValue = $("#" + form).find("input[name='email1']").val();
        if (localStorage != undefined) {
            localStorage.setItem('encryptedUserEmail',md5(emailValue.toLowerCase()).toString());
            if(isPersol || isOliver || isVogue)
                localStorage.setItem('encryptedUserEmailSHA256',sha256(emailValue.toLowerCase().trim()).toString());
        }
        var fName = $("#" + form).find("input[name='firstName']").val();
        var lName = $("#" + form).find("input[name='lastName']").val();
        
        var cidCookie = null;
        
        if(document.cookie.includes('X_WC_CID')){
        	cidCookie = $.cookie("X_WC_CID");
        }
        
        // Validation of email not in blank and well-formed
        if (emailValue != undefined && emailValue != "" && !reWhiteSpace.test(trim(emailValue))
            && MessageHelper.isValidUTF8length(emailValue, 256)
            && MessageHelper.isValidEmail(emailValue)) {
            var params = {
                storeId: storeId,
                langId: langId,
                email: emailValue,
                viewName: "",
                subscription: subscriptionOn,
                firstName: fName,
                lastName: lName,
                update: updateop,
                isCheckoutForm: true,
                cid: cidCookie
            };

            cursor_wait();

            wcService.invoke("JoinNewsletterService", params);
        }

    }, 
    joinSMS: function (fromPopup) {
        var params = {};
        var phone1Value = $("input[name='phone1']").val();
        if(phone1Value.indexOf("+") == -1 && localStorage.prefixNumberPhone1 != 'undefined'){
            var phone1ValuePrefix = String(localStorage.prefixNumberPhone1) + String(phone1Value);
        }
        
        //start CRM - BANNER
        if(fromPopup){
        	params.isFromPopup = fromPopup;
        }else{
        	params.isFromPopup = false;
        }
        //end CRM - BANNER
        
        
        if (localStorage != undefined ) {
            if(phone1ValuePrefix != undefined){
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1ValuePrefix.trim().toLowerCase()).toString());
                if(typeof sha256(phone1ValuePrefix.toString()) === 'object' && typeof sha256(phone1ValuePrefix.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } ); 
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1ValuePrefix.toString()));
                
            }else{
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1Value.trim().toLowerCase()).toString());
                if(typeof sha256(phone1Value.toString()) === 'object' && typeof sha256(phone1Value.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );  
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Value.toString())); 
            }
        }

        wcService.declare({
            id: "JoinSMSCmdService",
            actionId: "JoinSMSCmd",
            url: "JoinSMSCmd",
        
            successHandler: function(serviceResponse) {
                if(serviceResponse.responseMessage == 'duplicate'){
                    $('#mce-error-sms-duplicate').show();
                    console.log("Duplicate - This Number is already registered");
                    if(serviceResponse.userSMSOptin != 'undefined')
                        tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }else if(serviceResponse.responseMessage == 'success'){
                    tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }
                if(isVogue)
                    localStorage.setItem('tealiumUserSMSOptin',tealiumUserSMSOptin);
            },
            failureHandler: function(serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
        }
        });
        if(userType == 'R'){
            params.userRegistered = 'true';
            params.user_id = userInfo.userId;
        }else{
            params.userRegistered = 'false';
            if(fromPopup){
            	 params.email = $("#homepageSmsPopupFormDiv .emailLbl input").val();
            	if(getUserId() == '-1002'){
            		userId = setUserIdentity();
            	}
            	params.user_id = userId;
            }
        }
        params.store_id = WCParamJS.storeId;
        params.language_id = WCParamJS.langId;
        params.phone1 = phone1Value;
        params.store_identifier = storeDirectory;
        
        var myaccountCheckbox = $("div[id*='WC_UserRegistrationAddForm_myAccount_CheckBoxSMS']").is(":visible");
        var checkoutCheckbox  = $("div[name*='checkbox-sms']").is(":visible");
        var homepagePopupCheckbox = $("div[id*='WC_homepageSmsPopupFormDiv_CheckBoxSMS']").is(":visible");

        if(myaccountCheckbox)
            params.receivesms = $('#WC_UserRegistrationAddForm_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(checkoutCheckbox)
            params.receivesms = $('#WC_shippingAddressCreateEditFormDiv_1_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(homepagePopupCheckbox)
        params.receivesms = $('#WC_homepageSmsPopupFormDiv_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        else if(userType == 'R' && !checkoutCheckbox)
            tealiumUserSMSOptin  = "1";
         
        if((params.phone1 != '' && params.phone1.match(/^\d+$/) != null ) && (checkoutCheckbox))
            wcService.invoke("JoinSMSCmdService", params);    
    },

    updatePhysicalStoresArea: function (zipCodeValue) {
        if (typeof displayPhysicalStoreOptionsInCheckoutShipping != "undefined" && displayPhysicalStoreOptionsInCheckoutShipping == true && zipCodeValue == undefined) {
            var zipcode = $('#WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_zipCode_1').val();
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipcode;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        } else if (zipCodeValue != undefined) {
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipCodeValue;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        }
    },

    saveSelectedPhysicalStoreForOrder: function(ordersId, stloc_id) {

        console.log("saveSelectedPhysicalStoreForOrder");
        $.ajax({
            type: "POST",
            url: "OrderPhysicalStoreAddUpdate?ordersId=" + ordersId + "&stloc_id=" + stloc_id + "&storeId=" + WCParamJS.storeId,
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            success: function (data) {
                console.log(" Selected physical store has been saved successfully");
            }, error: function (data) {
                console.log("An error has been occurred while trying to save the selected physical store");
            }
        });
    },

    /**
     * Funtion that fills the AddressForm from Thank you page with order data
     */
    fillFormAddressThankyouPage: function() {
        $('input[name="firstName"]').attr('value', $('.address #firstName').text());
        $('input[name="lastName"]').attr('value', $('.address #lastName').text());
        $("input[name='logonId']").attr('value', $('.address #emailAddress1').text());
        $("input[name='email1']").attr('value', $('.address #emailAddress1').text());
        $("input[name='usr_email1']").attr('value', $('.address #emailAddress1').text());
        if ($("input[name='middleName']"))
            $("input[name='middleName']").attr('value', $('.address #middleName').text());
        $("input[name='usr_address1']").attr('value', $('.address #addressLine1').text());
        $("input[name='usr_address2']").attr('value', $('.address #addressLine2').text());
        $("input[name='usr_zipCode']").attr('value', $('.address #postalCode').text());
        $("input[name='usr_city']").attr('value', $('.address #city').text());
        $("input[name='usr_state']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_stateName']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_phone1']").attr('value', $('.address #telephone1').text());
    },
        //START - new functions for checkout_3_0 Oliver/Persol
    updateUnregisteredCheckoutAddressAndGoPaymentStep: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        loadAddressInfo(); // added for checkout 3.0
                       // location.href = onSuccessURL; //non deve più essere indirizzato nella view succesiva 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 loadAddressInfo(); // added for checkout 3.0
                                 //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
               // form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    addSuccesIcon: function (formField) {
          
               // $(formField).parent().addClass('validCheck');

                $(formField).parent().removeClass('isNotValid');
                
                if($(formField).siblings('.address-erros-message-cont').length > 0){
                	$(formField).siblings('.address-erros-message-cont').remove();
                }
                
                if($(formField).attr('formtmoreturn') && (isOliver || isPersol) && $('.form-page-container .find-order-wrapper .form-container .input-style input#email').length  > 0){
                	if($('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').length > 0){
                		$('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').remove();
                    }
                }
                
                if (typeof formField === 'string'){
                	if(formField.includes("country")){
                    	//$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').hide();
                    }
                }else{
                    $(formField).parent().addClass('validCheck');
                }
                
                
    },

    removeSuccesIcon: function (formField) {
          
        $(formField).parent().removeClass('validCheck');
        if($(formField).hasClass('field-error-message')){
            $(formField).parent().addClass('isNotValid');
        }
        
        if($(formField).attr('formtmoreturn')){
        	$(formField).parent().addClass('isNotValid');
        }
        
        
        if (typeof formField === 'string'){
        	if(formField.includes("country")){
            	$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').show();
            }
        }
}
//END - new functions for checkout_3_0 Oliver/Persol
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////
// MiniShopCartDisplay.js (Common implementation) //
////////////////////////////////////////////////////
//console.log("MiniShopCartDisplay.js (Common implementation) loaded");

function closeMiniShopCartDropDown(){
    var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    //Start HB-12482 
    if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "auto");	
    }
  //End HB-12482 
    
    if (visiblePopup.length>0){
    	if(isPersol) {
    		if(productDisplayJS.priceSwitched){
                if (!isWishlistPage){
                    document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    if(affirmEnabled) {
                        customizeAffirmPrice();
                    }
                } else {
                    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
                    document.getElementById('offerPrice_'+ minicartAddedId).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+ minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                    $('#header').removeClass("mincartOpened")
                }
		    	productDisplayJS.priceSwitched = false;
    		}
            //START Early Access
            window.lastOfferPrice = returnLastOfferPrice();
            //END Early Access
    	}
    	else if(isOliver){
    		if(productDisplayJS.priceSwitched){
                var minicartAddedId = $("#cartDropdown .products .product").attr("data-minicart-id");
    			var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+minicartAddedId+']');
        		var div;
        		for(var i = 0; i<elements.length;i++) {
        			if(elements[i].nodeName == "DIV") {
        				div = elements[i];
        			}
        		}
        		if(div != undefined) {
        			div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        		}
	    	 	
                if (!isWishlistPage){
                    document.getElementById('listPrice_'+productParent).innerText = productDisplayJS.lastOfferPriceSaved;
                } else {
                    document.getElementById('listPrice_'+minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                }

		    	if(affirmEnabled && !isWishlistPage) {
		    		customizeAffirmPrice();
		    	}
		    	productDisplayJS.priceSwitched = false;
    		}
    		
    		//open Vm if was opened
    		if ($.cookie("isVMOpen") == "1") {
    			moveVMOverProduct();
    			vmTryThemOn();
    		}
    	}
    	productDisplayJS.lastPriceSaved =  "";
    	productDisplayJS.lastOfferPriceSaved = "";
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}
    	
    
        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }

    visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

    if (visiblePopup.length>0){
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}

        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }
    if (isOliver || isPersol) { 
        manageScrollOverlay(false);
    }

    if (isPersol){
        $('.shopperActions--monogram--added--button.remove').click();
    }
    
}

/*
//Extra events for minishopcart buttons
function bindMiniShopCartEvents(){
    $("#continueShoppingButton").on("click touchstart", function(){
        closeMiniShopCartDropDown();
        return false;
    });
}

$(document).ready(bindMiniShopCartEvents);
$(document).ajaxComplete(bindMiniShopCartEvents);
*/
/*
function repositionMiniShopCart(){
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).css("top",-($(window).scrollTop())+"px");
}

//Manage minishopcart's position on mobile
function onScrollMiniShopCart(){
    console.log("PSL::onScrollMiniShopCart()");
    var reposition = false;
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    if ($(popup).length>0){
        for (var i = 0; i < $(popup).length; i++) {
            var element = $(popup)[i];
            if (!reposition && element.clientHeight > window.innerHeight){
                reposition = true;
            }
        }
    } else {
        console.log("PSL::onScrollMiniShopCart()::No minishopcart on screen");
    }

    if (reposition){
        console.log("PSL::onScrollMiniShopCart()::Repositioning minishopcart");
        var scrollTop = $(window).scrollTop();
        $(popup).css("top",(scrollTop*(-1))+"px");
    } else {
        console.log("PSL::onScrollMiniShopCart()::No reposition needed");
    }
}

$(document.body).on('touchmove', onScrollMiniShopCart); //mobile
$(window).on('scroll', onScrollMiniShopCart);           //desktop

function repositionMiniShopCartPopup(){
    console.log("Posicionando BEGIN");
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).position({
        my: "right top",
        at: "right bottom",
        of: "#miniShopCartPopupPositionReference"
    });
    console.log("Posicionando END");
}
*/

//HB-1816 BEGIN Close MiniShopCart popup when the user clicks outside of it
$(document).click(function(event) {
    //console.log("PSL::MiniShopCartDisplay.js::Document clicked");

    // Ignore this event if preventDefault has been called.
    if (event.defaultPrevented){
        //console.log("PSL::MiniShopCartDisplay.js::event.defaultPrevented");
        return;
    }

    var isFade = ($(event.target).hasClass("quickcart--fade") || $(event.target).hasClass("minishopcartadded--fade"));

    var mouseX = event.pageX;
    var mouseY = event.pageY;

    if (mouseX != undefined && mouseY != undefined){
        //console.log("PSL::MiniShopCartDisplay.js::mouseX: " + mouseX + ", mouseY: " + mouseY);

        var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");

        if (visiblePopup.length>0){
            event.stopPropagation();
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product Added popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                if($('#page').hasClass('pdp') && brandCode == 'PO'){
                    hideHeaderTimeout.setup();
                    $('#header').css('z-index', '5') 
                }
                $(visiblePopup).find(".closeButton").click();

                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }

        visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

        if (visiblePopup.length>0){
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product List popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                $(visiblePopup).find(".closeButton").click();
                if(brandCode == 'PO' && $('#page').hasClass('pdp')){
                    hideHeaderTimeout.setup()
                }
                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }
    }
});
//HB-1816 END

function lockShoppingBagIcon(){
    $("#widget_minishopcart").addClass("isDisabled");
    $("#widget_minishopcart").attr("href-disabled", $("#widget_minishopcart").attr("href") );
    $("#widget_minishopcart").attr("onclick-disabled", $("#widget_minishopcart").attr("onclick") );
    $("#widget_minishopcart").removeAttr("href");
    $("#widget_minishopcart").removeAttr("onclick");
}

function unlockShoppingBagIcon(){
    $("#widget_minishopcart").attr("href", $("#widget_minishopcart").attr("href-disabled") );
    $("#widget_minishopcart").attr("onclick", $("#widget_minishopcart").attr("onclick-disabled") );
    $("#widget_minishopcart").removeAttr("href-disabled");
    $("#widget_minishopcart").removeAttr("onclick-disabled");
    $("#widget_minishopcart").removeClass("isDisabled");
}

$(document).ready(function(){
    unlockShoppingBagIcon();
});


////////////////////////////////////////////////////
// OOTB source code                               //
////////////////////////////////////////////////////
/**
 * @fileOverview This file provides the common functions which are specific to the Mini Shopping cart
 */

/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */

var order_updated = {
    'AjaxAddOrderItem': 'AjaxAddOrderItem',
    'AddOrderItem': 'AddOrderItem',
    'AjaxAddOrderItemWithShipingInfo': 'AjaxAddOrderItemWithShipingInfo',
    'AjaxDeleteOrderItem': 'AjaxDeleteOrderItem',
    'AjaxUpdateOrderItem': 'AjaxUpdateOrderItem',
    'AjaxUpdateOrderShippingInfo': 'AjaxUpdateOrderShippingInfo',
    'AjaxOrderCalculate': 'AjaxOrderCalculate',
    'AjaxLogoff': 'AjaxLogoff',
    'AjaxSetPendingOrder': 'AjaxSetPendingOrder',
    'AjaxUpdatePendingOrder': 'AjaxUpdatePendingOrder',
    'AjaxSingleOrderCancel': 'AjaxSingleOrderCancel',
    'AjaxUpdateRewardOption': 'AjaxUpdateRewardOption'
};

/** This variable indicates whether the mini cart drop down is updated or not. */
var dialogWidget,
    update_content = false,
    dropdownUpdated = false,
    /** This is variable indicates whether the mini cart drop down is being initialized. */
    dropdownInit = false,
    productAddedList = {};

function declareMiniShoppingCartRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea()::BEGIN");
    // ============================================
    // initialize refresh area widgets
    // ============================================

    // ============================================
    // div: MiniShoppingCart refresh area
    // Declares a new refresh controller for the Mini Shopping Cart.

    // declare render context
    wcRenderContext.declare("MiniShoppingCartContext", ["MiniShoppingCart"], { status: "init" });

    /*
    /* Refreshes the mini shopping cart.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().renderContextChangedHandler()::BEGIN");
        if (wcRenderContext.testForChangedRC("MiniShoppingCartContext", ["status"])) {
            wcRenderContext.getRenderContextProperties("MiniShoppingCartContext").deleteCartCookie = true;
            $("#MiniShoppingCart").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShoppingCartContext"));
        }
    };

    // model change
    /*
     * Refreshes the mini shopping cart.
     * If a new order item is added via an Ajax service call, set the mini shopping cart to display the new order item in the dropdown.
     * Otherwise, only refresh the contents of mini shopping cart to the updated order information.
     * This function is called when a modelChanged event is detected.
     *
     * @param {string} event The model changed event
     * @param {object} returnData The data returned from the event
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage" });
    wcTopic.subscribe(events, function(returnData) {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().wcTopic.subscribe()::BEGIN");
        var param = [];
        if (returnData.actionId == 'AddOrderItem') {
            if (returnData.data.orderItem != null && returnData.data.orderItem[0].orderItemId != null) {
                var addedOrderItemIdString = "";
                for (var i = 0; i < returnData.data.orderItem.length; i++) {
                    if (addedOrderItemIdString !== "") {
                        addedOrderItemIdString += ",";
                    }
                    addedOrderItemIdString += returnData.data.orderItem[i].orderItemId;
                }
                param.addedOrderItemId = addedOrderItemIdString;
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            } else {
                param.addedOrderItemId = returnData.data.orderItemId + "";
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            }

            if(productDisplayJS && productDisplayJS.YMALProductFlag) { //se abbiamo aggiunto un prodotto dai prodotti suggeriti a carrello
				productDisplayJS.YMALProductFlag = false;
				showDropdown = false; //no minicart
                window.location.reload();
			} else if (productDisplayJS && productDisplayJS.RMAProductFlag){
                productDisplayJS.RMAProductFlag = false;
				showDropdown = false; //no minicart
            }
            else {
                showDropdown = true;
            }
        }
        param.deleteCartCookie = true;
        if (returnData.data.addedFromSKUList != null && returnData.data.addedFromSKUList[0] != null) {
            param.addedFromSKUList = returnData.data.addedFromSKUList[0];
        }
        if(window.skipMiniCart) {
            getNumberOfItemsInCart(itemsInCartBadge);
            goDirectToCart();
        }
        else
            $("#MiniShoppingCart").refreshWidget("refresh", param);
           
    });

    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().postRefreshHandler()::BEGIN");
        //The dialog contents has changed..so destroy the old dialog with stale data..
        destroyDialog("MiniShopCartProductAdded");

        if (showDropdown) {
            update_content = true;
            //We have added item to cart..So display the drop down with item added message..
            positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
            showDropdown = false;
        }

        if (!multiSessionEnabled) {
            setTimeout(() => {
                updateCartCookie();
            }, 0);
        }

        populateProductAddedDropdown();

        if (!multiSessionEnabled) {
            setTimeout(() => {
                resetDeleteCartCookie();
            }, 0);
        }
    };

    // initialize widget
    $("#MiniShoppingCart").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });
}

function declareMiniShopCartContentsRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea()::BEGIN");
    // ============================================
    // div: MiniShopCartContents refresh area
    // Declares a new refresh controller for the Mini Shopping Cart contents

    // Declares a new render context for the Mini Shopping Cart contents.
    wcRenderContext.declare("MiniShopCartContentsContext", ["MiniShopCartContents"], { status: "init", relativeId: "", contentId: "", contentType: "" });

    /*
     * Refreshes the mini shopping cart contents since it is out of date.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function(event, data) {
        if (!dropdownUpdated) {
            wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext").fetchCartContents = true;
            dropdownUpdated = true;
            $("#MiniShopCartContents").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext"));
        }
    };

    /*
     * Indicate that the mini cart contents are out of date upon an order change action.
     * This function is called when a modelChanged event is detected.
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage", "AjaxRESTOrderLockUnlockOnBehalf": "AjaxRESTOrderLockUnlockOnBehalf" });
    wcTopic.subscribe(events, function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().wcTopic.subscribe()::BEGIN");
        dropdownUpdated = false;
    });

    /*
     * Displays and positions the mini shop cart contents.
     * This function is called after a successful refresh.
     */
    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().postRefreshHandler()::BEGIN");
        var renderContextProperties = wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext");
        positionMiniShopCartDropDown(renderContextProperties.relativeId, renderContextProperties.contentId, renderContextProperties.contentType);
        //
        // This is needed for CSR solution. When CSR and shopper are browsing the store in simultaenously in
        // different browsers and if CSR locks/unlocks the shoppers cart, the miniCart in shopper's browser will
        // NOT reflect the change unless shopper takes some order related actions (add/delete from cart).
        // So to update the miniCart status loadMiniCart() function is called here.
        // It doesn't make another server call. The data returned from the MiniCartContentsUI is used
        // to refresh the miniCart summary.
        //
        updateCartCookie();
        loadMiniCart(WCParamJS.commandContextCurrency, WCParamJS.langId);
    };

    // initialize widget
    $("#MiniShopCartContents").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });

}

/**
 * Displays the dropdown content of the mini shopping cart when the user hovers over the
 * mini shopping cart if the contents are up-to-date or retrieve the latest contents from server.
 *
 * PSL:: This OOTB function can block the minishopcart. The variable dropdownInit is true while the shopcart is loading.
 * If the user clicks the shoppingcart again while it's loading (dropdownInit variable is 'true') sometimes this flag
 * never goes back to false and the user cannot open the MSC anymore until page reload.
 * In order to solve this issue we added a function that prevents extra clicks over the shopping bag icon
 * while the minishoppingcart popup is loading (See lockShoppingBagIcon()/unlockShoppingBagIcon())
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function showMiniShopCartDropDown(relativeId, contentId, contentType) {
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::BEGIN");
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (!dropdownInit && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        dropdownInit = true;
        lockShoppingBagIcon();

        if (!dropdownUpdated) {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el IF");
            update_content = true;
            var params = {
                status: "load",
                relativeId: relativeId,
                contentId: contentId,
                contentType: contentType,
                page_view: "dropdown"
            };
            wcRenderContext.updateRenderContext("MiniShopCartContentsContext", params);
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el ELSE");
            positionMiniShopCartDropDown(relativeId, contentId, contentType);
        }
    }
}

function toggleMiniShopCartDropDown(relativeId, contentId, contentType) {
    if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')) {
        // if(!(window.mobilecheck() || window.tabletPortraitCheck()))hideHeaderTimeout.cancel();
        (dialogWidget && dialogWidget._isOpen) ? $("#page-overflow-wrapper").removeClass("overflow-hidden") : $("#page-overflow-wrapper").addClass("overflow-hidden");
    }
    //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::BEGIN");}
    if (dialogWidget && dialogWidget._isOpen) {
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.setup();
        }
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el IF");
        dialogWidget.close();
    } else {
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el ELSE");
        showMiniShopCartDropDown(relativeId, contentId, contentType);
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    }
}

/*
 * Displays the dropdown content of the mini shopping cart.
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function positionMiniShopCartDropDown(relativeId, contentId, contentType) {
    //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown()::BEGIN");
    var add_event_handlers = function(contentElement) {
        //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown().add_event_handlers()::BEGIN");
        contentElement.on("wcdialogopen", function(event) {
            //deactivate(document.getElementById("header"));
            $("#" + relativeId).addClass("selected");
        });

        contentElement.on("wcdialogclose", function(event) {
            $("#" + relativeId).removeClass("selected");
        });
    };

    // Dialog is not yet created..Create one
    if (!dialogWidget /*PSL Force dialog creation */ || true) {
        var content = $("#" + contentId);
        if (contentId === "MiniShopCartProductAdded") {
            // The content may have been hidden so show it
            $("#MiniShopCartProductAddedWrapper").removeAttr("style");
        }
        dialogWidget = content.WCDialog({
            position: {
                my: "right top",
                at: "right bottom",
                of: "#widget_minishopcart"
            },
            autoOpen: false,
            open: function() {
                // Make the element show up on top of the header elements
                dialogWidget.element.parent().css("z-index", 1);

                if (contentType == 'orderItemAdded') {
                    if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                    }else{
                        $("#MiniShopCartProductAddedWrapper").css("display", "block");
                    }
                }
            },
            appendTo: "#headerRow1",
            title: $("#" + contentId + "_ACCE_Label").html(),
            show_title: false,
            width: "360px",
            //dialogClass: "no-close",
            modal: false
        }).data("wc-WCDialog");
        add_event_handlers(content);
        update_content = false;

		/* APPLEPAY BEGIN */
		if (typeof(showApplePayButtons) == "function") {
			showApplePayButtons();
		}
        /* APPLEPAY END */

    } else {
        dialogWidget.close();
        if (update_content) {
            if (contentType == 'orderItemAdded') {
                if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                    $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                }else{
                    $("#MiniShopCartProductAddedWrapper").css("display", "block");
                }
            }
            var newContent = $("#" + contentId);
            dialogWidget.update_content("#" + contentId);
            add_event_handlers(newContent);
            update_content = false;
        }
    }

    if (Utils.get_IE_version() < 7) {
        dialogWidget.css("display", "block");
    }
    
    //Start HB-12482 
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	    $("html, body").animate({
	        scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }else if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "hidden");
    	$("html, body").animate({
	        //scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }
    //End HB-12482 
    
    dropdownInit = false;

    unlockShoppingBagIcon();
}

/*
 * Store the current mini cart information in the mini cart cookie.
 */
function updateCartCookie() {
    //Save current order information into cookie
    if ($("#currentOrderQuantity").length && $("#currentOrderAmount").length && $("#currentOrderCurrency").length && $("#currentOrderId").length && $("#currentOrderLanguage").length) {
        var cartQuantity = $("#currentOrderQuantity").val();
        var cartAmount = $("#currentOrderAmount").val();
        var cartCurrency = $("#currentOrderCurrency").val();
        var cartLanguage = $("#currentOrderLanguage").val();
        var cartOrderId = $("#currentOrderId").val();
        var currentOrderLocked = $("#currentOrderLocked").val();

        //Clear out previous cookies
        var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);
        if (orderIdCookie != null) {
            setCookie("WC_CartOrderId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
            var cartTotalCookie = getCookie("WC_CartTotal_" + orderIdCookie);
            if (cartTotalCookie != null) {
                setCookie("WC_CartTotal_" + orderIdCookie, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
        }
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, cartOrderId, {
            path: '/',
            domain: cookieDomain
        });
        if (cartOrderId !== "") {
            setCookie("WC_CartTotal_" + cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage + ";" + currentOrderLocked, {
                path: '/',
                domain: cookieDomain
            });
        }
    } else {
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, "", { path: '/', domain: cookieDomain });
    }
}

function setProductAddedList(newProductAddedList) {
    productAddedList = newProductAddedList;
}

/*
 * Populates the Product Added dropdown upon an add to cart action.
 */
function populateProductAddedDropdown() {


    var search = '"';

    var replaceStr = "'";
    for (productId in productAddedList) {
        var productDetails = productAddedList[productId];

        if ($("#MiniShopCartAddedProdName_" + productId).length && productDetails[0] != null && productDetails[0].length != 0) {
            $("#MiniShopCartAddedProdName_" + productId).html(productDetails[0]);
        }

        /* OOTB - PSL:: We disabled this code because it replaces the thumbnail with the fullimage of the catentry
        if ($("#MiniShopCartAddedProdImgSrc_" + productId).length && productDetails[1] != null && productDetails[1].length != 0) {
            $("#MiniShopCartAddedProdImgSrc_" + productId).attr("src", productDetails[1]);
            document.getElementById('MiniShopCartAddedProdImgSrc_' + productId).alt = productDetails[0];
        }
        */

        if ($("#MiniShopCartAddedProdPrice_" + productId).length && productDetails[2] != null && productDetails[2].length != 0) {
            $("#MiniShopCartAddedProdPrice_" + productId).html(productDetails[2]);
        }
        if ($("#MiniShopCartAddedProdQty_" + productId).length && productDetails[3] != null && productDetails[3].length != 0) {
            $("#MiniShopCartAddedProdQty_" + productId).html(productDetails[3]);
        }

        if ($("#MiniShopCartAddedProdAttr_" + productId).length && productDetails[4] != null && productDetails[4].length != 0) {
            $("#MiniShopCartAddedProdAttr_" + productId).html("");

            for (attrName in productDetails[4]) {
                attrValue = productDetails[4][attrName];
                if (attrValue != null && attrValue != 'undefined') {
                    attrValue = attrValue.replace(/&amp;/g, "&").replace(/&#039;/g, "'").replace(/&#034;/g, '"').replace(replaceStr, search);
                }
                document.getElementById('MiniShopCartAddedProdAttr_' + productId).innerHTML += '<div>' + attrName + ': ' + attrValue + '</div>';
            }
        }
    }
    wcTopic.publish("ProductInfo_Reset");
}

/*
 * Loads mini shop cart info upon page load.
 * @param {String} contextCurrency Current currency selected.
 * @param {String} langId Current language selected.
 */
function loadMiniCart(contextCurrency, langId) {
    var updateCart = false;
    var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);

      if (orderIdCookie != undefined && orderIdCookie === "") {
        var subtotal = document.getElementById("minishopcart_subtotal");
        var formattedSubtotal = null;
        if ($("#currentOrderAmount").length) {
            formattedSubtotal = Utils.formatCurrency($("#currentOrderAmount").val(), {
                currency: contextCurrency
            });
        }
        if (formattedSubtotal == null && $("#currentOrderAmount").length) {
            formattedSubtotal = $("#currentOrderAmount").val();
        }

        if (subtotal != null) {
            subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
        }
        var items = document.getElementById("minishopcart_total");
        if (items != null) {
            var itemsMsg = null;
            if ($("#currentOrderQuantity").length) {
                itemMsg = $("#currentOrderQuantity").val();
            }
            if (itemsMsg == null) {
                itemsMsg = "0";
            }
            items.innerHTML = "\n " + itemsMsg + "\n ";
        }
    } else if (orderIdCookie != undefined && orderIdCookie !== "") {
        var cartCookie = getCookie("WC_CartTotal_" + orderIdCookie);

        if (cartCookie != undefined && cartCookie != null && cartCookie !== "") {
            var orderInfo = cartCookie.split(";");

            if (orderInfo != null && orderInfo.length > 3) {
                if (orderInfo[2] == contextCurrency && orderInfo[3] == langId) {
                    var subtotal = document.getElementById("minishopcart_subtotal");
                    if (subtotal != null) {
                        var formattedSubtotal = null;
                        formattedSubtotal = Utils.formatCurrency(orderInfo[1].toString(), {
                            currency: contextCurrency
                        });
                        if (formattedSubtotal == null) {
                            formattedSubtotal = orderInfo[1].toString();
                        }
                        subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
                    }
                    var currentOrderLocked = false;
                    if (orderInfo[4] != null && orderInfo[4] == 'true') {
                        var currentOrderLocked = true;
                    }
                    var items = document.getElementById("minishopcart_total");
                    var lock = document.getElementById("minishopcart_lock");
                    if (items != null) {
                        var itemsMsg = orderInfo[0].toString();
                        items.innerHTML = "\n " + itemsMsg + "\n ";
                        if (currentOrderLocked) {
                            $(items).addClass("nodisplay");
                            $(lock).removeClass("nodisplay");
                        } else {
                            $(items).removeClass("nodisplay");
                            $(lock).addClass("nodisplay");
                        }
                    }
                } else {
                    updateCart = true;
                }
            } else {
                updateCart = true;
            }
        } else {
            updateCart = true;
        }
    } else {
        updateCart = true; 
    }
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (updateCart == true && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        wcRenderContext.updateRenderContext('MiniShoppingCartContext', {
            'status': 'load'
        });
    }
}


/*
 * Turn on the flag to indicate that the mini cart cookies should be refreshed.
 */
function setDeleteCartCookie() {
    setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, true, {
        path: '/',
        domain: cookieDomain
    });
}

/*
 * Check whether the mini cart cookies need to be updated or not.
 */
function checkDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != undefined && deleteCartCookieVal !== "") {
        if (deleteCartCookieVal == 'true') {
            return true;
        }
    }
    return false;
}

/*
 * Delete the flag that indicates the mini cart cookie should be refreshed.
 */
function resetDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != null) {
        setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
    }
}
wcTopic.subscribe("ProductInfo_Added", setProductAddedList);
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */



shoppingActionsServicesDeclarationJS = {

	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxCustomRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {

			if(productDisplayJS.wasEngraved && productDisplayJS.wasEngraved != null && productDisplayJS.wasEngraved != undefined) {
				var wasEngravedOrderItems = JSON.parse(sessionStorage.getItem("wasEngravedOrderItems"));
				if(checkIsNull(wasEngravedOrderItems)) {
					wasEngravedOrderItems = [];
				}
				wasEngravedOrderItems.push(serviceResponse.orderItemId[0]);
				sessionStorage.setItem("wasEngravedOrderItems", JSON.stringify(wasEngravedOrderItems));
			}

			//START Wunderkind
			if(typeof updateWkndCartValue == 'function') {
				updateWkndCartValue();
			}
			//END Wunderkind
			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            cursor_clear();
            
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END
            
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}

			//BEGIN Lens Configurator
			//update prescription with the generated orderitemsid from cart service
			if(productDisplayJS.prescription === true){
                _prescriptionObject = $.cookie("_prescriptionObject");
				if(_prescriptionObject != undefined){
                    $.ajax({
                        url: "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self",
                        method: "GET",
                        async: false,
						headers: {
							"Content-Type": "application/json",
							"Cache-Control": "no-cache, no-store, must-revalidate"
						},
						data: {
							"timestamp": Date.now()
						},
                        success: function(data) {
                                var maxOrderItemId = 0;
								var roxFrameSelected = $('#roxFrameID').val();
                                //retrieve object with roxframeId in the array orderitem and extract the orderitemsid
                                //in case there are more than one item with same catentry take the greater one
                                $.each(data.orderItem,(index,element) => {
                                    if(element.productId === roxFrameSelected && maxOrderItemId < element.orderItemId){
                                        console.log(element.orderItemId);
                                         maxOrderItemId = element.orderItemId;
                                    }
                                });
                                
                                _prescriptionObject = JSON.parse(_prescriptionObject);
                                parameters = {};
                                parameters.orderItemsId = maxOrderItemId;
                                parameters.prescriptionId = _prescriptionObject.prescriptionId;
                                
                                parameters.type = "S";
                                if (productDisplayJS.lensOptionValue === "Progressive"){
                                    parameters.type = "P";
                                }
                                
                            
                                var docStr = generateXML(parameters);
                                var xmldoc = {};
                                xmldoc.XML = docStr;
                                //asynchronous call: if the prescription hasn't be updated it will not go to the cart
                                AddPrescription(xmldoc).then(function(){
                                    console.log("prescription updated with orderitemsid"  + parameters.orderItemsId);
                                    
                                    /* remove cookie when item have been added to cart so if the same user add a new prescription
                                     both for error (more the one prescription are not allowed) or for replace the old one
                                     it will be treated as new prescription in the configurator */
                                     //$.removeCookie("_prescriptionObject");
									 $.removeCookie("_userId");
                                    goToCart2();
                                }).catch(function(){
									console.log("prescription not updated");
                                    console.log("orderitemsId used" + parameters.orderItemsId);

								});
                        
                        },
                        error: function(err) {
                            console.log("failed to updated the prescription");
                        }
                    });
                }else{
                    //it has choosen the send it later option
                    goToCart2();
                }
			}


			if(productDisplayJS.isFrameOnly){ //this if is necessary because the sunglasses still have add to cart button 
				//it has choose the frame  only option
				goToCart2();
			}

			//END
			
			wcTopic.publish('ProductAddedToCart');
			
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {
		    if(productDisplayJS && productDisplayJS.YMALProductFlag) //reset flag if add fails
				productDisplayJS.YMALProductFlag = false;
				
		    var productUPC = $('#parentProductUpc').val();
			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else if ("_API_CANT_RESOLVE_FFMCENTER" == serviceResponse.errorMessageKey) {
 		            MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
 		        } else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			 	
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                    || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
                   trackAddToCartFailure('Product', serviceResponse.errorMessage, productUPC);
                }
                else{
                   trackAddToCartFailure('Server', serviceResponse.errorMessage, productUPC); 
                }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					trackAddToCartFailure('Product', serviceResponse.errorMessageKey, productUPC);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific 
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML. 
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        
        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call. 
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *				
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /** 
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /** 
     * Displays price of the attribute selected with the JSON oject.
     * 
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}
		
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link
			    
			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);
                            

                           
                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

productDisplayJS = {
	/** Last price saved for post minicart display **/
	lastPriceSaved : "",
	lastOfferPriceSaved : "",
	priceSwitched : false,
	pst:"",
	fullPrice:"",
    /** The language ID currently in use **/
    langId: "-1",

    pst: "",
    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **;/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A map of currently selected attribute values for a catalog entry **/
    selectedAttributeValues: {},

    /** A map of HTML element ids associated with an attribute name **/
    registeredAttributeIds: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",
    
    mostSoldSize:"",
    
    /**
     * A boolean used to to determine is it from a Qick info popup or not.
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to display the price range when the catEntry is selected.
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object returned from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /**
     * stores all name and value of all swatches
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * stores all name and id of all dropdowns
     **/
    allDropdownsList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item IDs.
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item IDs in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone.
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone.
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry.
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    singleSKUProductWithoutDefiningAttribute: false,

    replaceStr001: "&#039;",
    replaceStr002: "&#034;",

    engraving : false,

    engravingText :"",

    engravingFont : "",

    prescription : false,
    lensMaterialValue : "",
    lensOptionValue : "",
    lensTypeValue : "",
    changedCatEntryId : "",

    isFrameOnly : false,

    /**
     * Prescription variables
     */
    hasPres : "",
    sizeHasPres : "",
    modelHasPres : "",
    lensId : "",
    isContactLens : false,
    YMALProductFlag : false, //true if a product is added directly from cart
    RMAProductFlag : false,
    /**
     * A boolean used to to determine if product is added using Lens Configurator
    **/
    usingLensConfigurator: false,

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        productDisplayJS.langId = langId;
        productDisplayJS.storeId = storeId;
        productDisplayJS.catalogId = catalogId;
        productDisplayJS.userType = userType;
        productDisplayJS.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        productDisplayJS.entitledItems = entitledItemArray;
    },

    
    
    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        // there are no selected attribute and no entitled item, this must be a single sku item without defining attribute
        if (selectedAttributes == null && this.entitledItems == null) {
            return entitledItemId.substring(entitledItemId.indexOf("_") + 1);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    getContactLensCatalogEntryIds: function (entitledItemId) {
        var attributeArray = [];
        var catetryIds = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        if (typeof selectedAttributes !== 'undefined') {
            for (attribute in selectedAttributes) {
                if (attribute.split("__")[1] === "right") {
                    attributeArray.push(attribute.split("__")[0] + "_|_" + selectedAttributes[attribute]);
                }
            }

            var catId = productDisplayJS.resolveSKU(attributeArray);
            if (catId != null && $('.defining-contact-lens #check-Right').prop( "checked")) {
                catetryIds.push(catId);
            } else {
                catetryIds.push(0);
            }

            var attributeArray = [];
            for (attribute in selectedAttributes) {
                if (attribute.split("__")[1] === "left") {
                    attributeArray.push(attribute.split("__")[0] + "_|_" + selectedAttributes[attribute]);
                }
            }
            var catId = productDisplayJS.resolveSKU(attributeArray);
            if (catId != null &&  $('.defining-contact-lens #check-Left').prop( "checked")) {
                catetryIds.push(catId);
            } else {
                catetryIds.push(0);
            }
        }
        return catetryIds;
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return productDisplayJS.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * disables add2cart button in case where the buyable flag is set to false
     */
    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //disable the add to cart button
        var btn = document.getElementById("add2CartBtn");
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * Set the prescription variables
     *
     * @param {boolean} hasPresc indicates if the item has prescription
     * @param {boolean} sizeHasPresc indicates if the product has prescription
     * @param {boolean} modelHasPresc indicates if the model has prescription
     */

    setHasPrescription : function (hasPresc, sizeHasPresc, modelHasPresc) {
        this.hasPres = hasPresc;
        this.sizeHasPres = sizeHasPresc;
        this.modelHasPres = modelHasPresc;
    },

    /**
     * function that show or hide the prescription size message or prescription button if has or not prescription
     */
    prescChangeSelect : function () {
        var itemInventory = getInventory(this.changedCatEntryId);
        if(wkndActive) {
            try {
                var currentSku = skus.filter((sku) => sku.uniqueID == this.changedCatEntryId);
                if(currentSku.length>0) {
                    window.wunderkind.product.sku = currentSku[0].partNumber;
                }
            } catch (error) {
                console.error(error);
            }
            
        }
        console.log("PSL::ProductDisplay.js::prescChangeSelect::changedCatEntryId::"+this.changedCatEntryId);
        console.log("PSL::ProductDisplay.js::ItemInventory::"+itemInventory);
        var roxframeIdAvailable = ($('#roxFrameID').val()!= undefined && $('#roxFrameID').val()!=  null && $('#roxFrameID').val()!=  '');
        if (itemInventory !== false){
            if (itemInventory>0){

                $("#catEntryID").val(this.changedCatEntryId); 
                if(this.hasPres === "true" || this.sizeHasPres === "true" || roxframeIdAvailable == true){
                    /*if ($("#presc-lens-info__" + this.changedCatEntryId).length) {
                        var lensJSON = JSON.parse($("#presc-lens-info__" + this.changedCatEntryId).text());
                        var merchan = lensJSON.merchandisingAssociations;
                        if(typeof merchan !== "undefined"){
                            for (var i = 0; i < merchan.length; i++){
                                if(merchan[i].associationType == "ROX"){
                                   // $("#presc--button").css("display", "block");
                                    var roxFramePrice = null;
                                    if(frameMap != undefined &&
                                        frameMap[merchan[i].uniqueID] != undefined &&
                                        frameMap[merchan[i].uniqueID].price != undefined &&
                                        frameMap[merchan[i].uniqueID].price.price != "" ){
                                            roxFramePrice = frameMap[merchan[i].uniqueID].price.price;
                                        }
                                    if(frameMap === null){
                                        $(".presc--side--button").addClass("disabledButton");
                                    } else {
                                        $(".presc--side--button").removeClass("disabledButton");
                                    } 
                                /*
                                } else {
                                    $("#presc--button").css("display", "none");
                                    $("#presc--msg--size").css("display", "block");
                                }
                            }
                        } else {
                            $("#presc--button").css("display", "none");
                            $("#presc--msg--size").css("display", "block");
                        }
                    }*/
                    $("#presc--msg--size").css("display", "none");
                    $("#roxLenses").val(this.changedCatEntryId);
                    $("#roxFrameID").val(this.changedCatEntryId);
                }
                
	     		for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
	     			if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                        $("a[data-element-id='X_Pdp_Prod_AddLens']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);//// set Partnumber in LensConfigurator analytics
	     				var upcSizeChanged = productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1];
	     			   $('#vm_box').attr('data-vm',upcSizeChanged);
                       $("a[data-element-id='X_X_VirtualMirror_Start']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
	     			   if (typeof vmUpcAvailability != 'undefined') {
                        if(!$('vm_box').hasClass('hide') && $.cookie("isVMOpen") == "1"){
                            if(vmUpcAvailability != undefined && vmUpcAvailability[upcSizeChanged] != undefined &&  vmUpcAvailability[upcSizeChanged].isAvailable()){
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').show();
                                }else{
                                    $('.container-btn-dsk').show();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").show();
                                moveVMOverProduct();
                                vmTryThemOn();  
                            }else{
                            	if (typeof vmSwitchOff === 'function') {
                                	vmSwitchOff(false);
                            	   }
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').hide();
                                }else{
                                    $('.container-btn-dsk').hide();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").hide();	     					 
                            }	     		    	 
                        }else if($.cookie("isVMOpen") != "1"){
                            if(vmUpcAvailability != undefined && vmUpcAvailability[upcSizeChanged] != undefined && vmUpcAvailability[upcSizeChanged].isAvailable()){	     		    		  
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').show();
                                }else{
                                    $('.container-btn-dsk').show();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").show();
                            }else{
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    //$('.container-btn').hide();
                                }else{
                                    //hide try them on while loading
                                    //$('.container-btn-dsk').hide();
                                    
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").hide();
                            }	 
                        }
                      }
	     		      break;
	     		    }
	     		}
            }else{
                $(".presc--side").hide();
            }
        }

    },

    /**
     * registerAttributeIds Register the ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {Object} ids Map of named HTML element ids
     *
     **/
    registerAttributeIds: function (attributeName, entitledItemId, ids) {
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds == null) {
            attributeIds = {};
            productDisplayJS.registeredAttributeIds[entitledItemId] = attributeIds;
        }

        attributeIds[productDisplayJS.removeQuotes(attributeName)] = ids;
    },

    /**
     * getAttributeIds Get the map of ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     * @return {Object} ids Map of named HTML element ids
     *
     **/
    getAttributeIds: function (attributeName, entitledItemId) {
        var ids = null;
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds != null) {
            ids = attributeIds[productDisplayJS.removeQuotes(attributeName)];
        }
        return ids;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     * @param {String} selectedAttributeDisplayValue This is optional. The attribute display value formatted with UOM
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField, selectedAttributeDisplayValue, eye) {
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr001, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr002, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr01, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr02, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.ampersandChar, productDisplayJS.ampersandEntityName);
        if (eye != null && eye != '') {
            selectedAttributes[selectedAttributeName + "__" + eye] = selectedAttributeValue;
        } else {
            selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        }

        productDisplayJS.moreInfoUrl = productDisplayJS.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        productDisplayJS.selectedAttributesList[entitledItemId] = selectedAttributes;
        if (skuImageId != undefined) {
            productDisplayJS.setSKUImageId(skuImageId);
        }
        var entitledItemJSON;
        if ($("#" + entitledItemId).length && !productDisplayJS.isPopup) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = productDisplayJS.getEntitledItemJsonObject();
        }
        productDisplayJS.setEntitledItems(entitledItemJSON);
        var attributeIds = productDisplayJS.getAttributeIds(selectedAttributeName, entitledItemId);
        if (attributeIds != null) {
            var usedFilterValue = $("#" + attributeIds.usedFilterValueId);
            if (usedFilterValue != null) {
                if (selectedAttributeDisplayValue) {
                    $(usedFilterValue).html(selectedAttributeDisplayValue);
                } else {
                    $(usedFilterValue).html(selectedAttributeValue);
                }
            }
            if (selectedAttributeValue === "") {
                $("#" + attributeIds.usedFilterId).removeClass("visible");
                var hideCurrentUsedFilters = true;
                var dropdownList = this.allDropdownsList[entitledItemId];
                for (var i in dropdownList) {
                    if (selectedAttributes[dropdownList[i].name] !== "") {
                        hideCurrentUsedFilters = false;
                        break;
                    }
                }
                if (hideCurrentUsedFilters) {
                    $("#currentUsedFilters_" + entitledItemId).addClass("hidden");
                }
            } else {
                $("#" + attributeIds.usedFilterId).addClass("visible");
                $("#currentUsedFilters_" + entitledItemId).removeClass("hidden");
                //var selectedAttributeNameId = selectedAttributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
                //$("[id='attr_" + entitledItemId + '_' + selectedAttributeNameId + "']").addClass("hidden");
            }

            //Create dropdown combo only when the product has more than one size
            if (entitledItemJSON.length>1){
                productDisplayJS.makeDropdownSelection(selectedAttributeName, selectedAttributeValue, entitledItemId);
            };
        }
    },

    /**
     * resetSelectedAttribute Resets the the selected attribute value for the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} productUrl The url of the parent product
     *
     **/
    resetSelectedAttribute: function (attributeName, entitledItemId) {
        var attributeName = attributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
        $("[id='attr_" + entitledItemId + '_' + attributeName + "']").removeClass("hidden");

        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            var selectWidget = $(attributeIds.selectAttributeValueId);
            if (selectWidget.length) {
                selectWidget.val("");
                selectWidget.Select("refresh");
            }
        }

        var dropdownList = this.allDropdownsList[entitledItemId];
        var remainingSelectedAttributes = {};

        for (var i = 0; i < dropdownList.length; i++) {
            if (dropdownList[i].name.replace(/\\'/g, "'") == attributeName.replace(/\\'/g, "'")) {
                $(dropdownList[i].node).removeClass("hidden");
                $(dropdownList[i].node).val('');
                $(dropdownList[i].node).Select("refresh");
                $(dropdownList[i].node).change();
            } else {
                for (var j = 0; j < dropdownList[i].options.length; j++) {
                    if (dropdownList[i].options[j].selected === true) {
                        remainingSelectedAttributes[dropdownList[i].name] = dropdownList[i].options[j].value;
                    }
                }
            }
        }

        var urlWithoutParams = document.location.href.split('?')[0];
        var params = "?";

        var productUrl = "";
        if ($("#ProductDisplayURL").length) {
            productUrl = $("#ProductDisplayURL").html();
        }

        var displaySKUContextData = false;
        if ($("#displaySKUContextData").length) {
            displaySKUContextData = eval('(' + $("#displaySKUContextData").html() + ')');
        }

        if (displaySKUContextData && urlWithoutParams !== productUrl) {
            for (attr in remainingSelectedAttributes) {
                if (remainingSelectedAttributes.hasOwnProperty(attr)) {
                    params += attr + '=' + remainingSelectedAttributes[attr] + '&';
                }
            }

            params = params.slice(0, -1);
            params = params.replace("\\\'", "'").replace('\\\"', '"');
            document.location.replace(productUrl + params);
        }
    },

    /**
     * setSelectedAttributeName Set the selected attribute name and make the drop-down associated with the attribute visible.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     **/
    setSelectedAttributeName: function (attributeName, entitledItemId) {
        var oldSelectedAttributeValuesId = productDisplayJS.selectedAttributeValues[entitledItemId];
        if (oldSelectedAttributeValuesId != null && oldSelectedAttributeValuesId !== "") {
            $("#" + oldSelectedAttributeValuesId).addClass("mobileHidden");
        }
        var selectedAttributeValuesId = null;
        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            selectedAttributeValuesId = attributeIds.attributeValuesId;
        }
        if (selectedAttributeValuesId != null && selectedAttributeValuesId !== "") {
            $("#" + selectedAttributeValuesId).removeClass("mobileHidden");
        }
        productDisplayJS.selectedAttributeValues[entitledItemId] = selectedAttributeValuesId;
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link productDisplayJS.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
    	var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
        var itemId = entitledItemId.split("_")[1];
        if(isPersol) {
    		productDisplayJS.lastPriceSaved = isWishlistPage ? document.getElementById('offerPrice_'+ itemId).innerText : document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
    		if (isWishlistPage){ // Wishlist
                if(typeof document.getElementById('listPrice_'+ itemId)!= 'undefined' && document.getElementById('listPrice_'+ itemId) != null){
                    productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+ itemId).innerText;
                }
            } else {
                if(typeof document.getElementById('listPrice_'+catalogEntryDetails.uniqueID)!= 'undefined' && document.getElementById('listPrice_'+catalogEntryDetails.uniqueID) != null){
                    productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
                }
            }
    	}
    	else if(isOliver) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+itemId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			productDisplayJS.lastPriceSaved = div.getElementsByClassName('price__unity')[0].innerText;
    		}
            if (!isWishlistPage){
                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+productParent).innerText;
            } else {
                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+itemId).innerText;
            }
        	
    	}
    	var productUPC = $('#parentProductUpc').val();
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close(); 
            $('#quick_cart_container').remove();  
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        productDisplayJS.setEntitledItems(entitledItemJSON);
        if (productDisplayJS.isContactLens) {
            var catalogEntryIds = productDisplayJS.getContactLensCatalogEntryIds(entitledItemId);

            if (catalogEntryIds != null && catalogEntryIds.length > 0
                    && ($('.defining-contact-lens #check-Right').prop( "checked") || $('.defining-contact-lens #check-Left').prop( "checked"))) {
                var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
                var rightQuantity = $('#qty_right').val();
                var leftQuantity = $('#qty_left').val();
                var quantitys = [rightQuantity, leftQuantity];
                productDisplayJS.AddItem2ShopCartAjax(catalogEntryIds, quantitys, customParams, productId);
                productDisplayJS.baseItemAddedToCart = true;

            } else {
                $('#second_level_category_popup').css("zIndex", '1');
                if (isCarol && $(".shopperActions").find(".WCTooltip").length == 0) {
                	MessageHelper.formErrorHandleClient('add2CartBtn', Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'));
                	pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'), 'add to cart error', productUPC);
	                $(".shopperActions").find(".WCTooltip").css("top", "+=35");
	                setTimeout(function() {
						MessageHelper.clearCurrentIdentifier();
						$(".shopperActions").find(".WCTooltip").remove();
					}, 3000);
				}
            }
        } else {
            var catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);

            if (catalogEntryId != null) {
                var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
                productDisplayJS.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
                productDisplayJS.baseItemAddedToCart = true;


            } else if (isPopup == true) {
                $('#second_level_category_popup').css("zIndex", '1');
                MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'), 'add to cart error', productUPC);
            } else {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'), 'add to cart error', productUPC);
                productDisplayJS.baseItemAddedToCart = false;
            }
        }
    },
 
    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) { 

        var productUPC = $('#parentProductUpc').val();
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        if(typeof this.storeId !== 'undefined' || this.storeId == null || this.storeId == ''){
           this.storeId = document.getElementById("storeIdHidden").value;
        }

            var token = $("#authToken").val();
     
            var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                orderId: ".",
                authToken: token /*CSRF protection */
            };
        
        
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            var itemIndex = 0;
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (isPositiveInteger(catEntryIdentifier[i]) && !isPositiveInteger(quantity[i])) {
                	if (isCarol && productDisplayJS.isContactLens) {
                		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'));
                	} else {
                    	MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    }
                    pushErrorToTealium('Product', Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'), 'add to cart error', productUPC);
                    return;
                }
                if (isPositiveInteger(catEntryIdentifier[i]) && isPositiveInteger(quantity[i])) {
                    params["catEntryId_" + (itemIndex + 1)] = catEntryIdentifier[i];
                    params["quantity_" + (itemIndex + 1)] = quantity[i];
                    itemIndex++;
                }
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'), 'add to cart error', productUPC);
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in productDisplayJS.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = productDisplayJS.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                shoppingActionsJS.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                shoppingActionsJS.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }



        if(customParams == null){
            customParams = [];
        }

        // adding engraving custom params
        customParams["engravingText"] = this.engravingText;
        customParams["engravingFont"] = this.engravingFont;
        customParams["engraving"] = this.engraving;


        // adding new prescription parameter
        if (this.prescription) {
            customParams["prescription"] = this.prescription;
            customParams["lensMaterial"] = this.lensMaterialValue;
            customParams["lensOption"] = this.lensOptionValue;
            customParams["lensType"] = this.lensTypeValue;
            customParams["lensId"] = this.lensId;
        }

        if(this.engraving && this.prescription && isPersol) {
            customParams["engraving"] = false;
            this.wasEngraved = true;
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }


        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        var addToCartEventConsumed = false;

        if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
            var catEntry = productDisplayJS.itemPriceJsonOject[params.catEntryId].catalogEntry;
            var partNumber = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            var wccParams = {};
            wccParams["partNumber"] = partNumber;
            addToCartEventConsumed = callCenterIntegrationJS.consumeAddToCartEvent(params,wccParams);
        }
        
        if(!addToCartEventConsumed) {

            wcService.invoke(ajaxShopCartService, params);
        }

        productDisplayJS.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
         
    },

    AddItem2ShopCartYMAL: function(catEntryIdentifierYMAL, quantity) {
        addCheckoutLoader();
        this.YMALProductFlag = true;
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: tealiumCart_Id
        };

        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        params.catEntryId = catEntryIdentifierYMAL;
        params.quantity = quantity;

        wcService.invoke(ajaxShopCartService, params);
    },

    AddItem2ShopCartRMA: function(catEntryIdentifier, quantity) {
        /* TODO: Before adding the shipping charge item to cart, empty out cart from any product. */
        /* TODO: Before adding products to cart, empty out cart from the shipping charge item. */
        this.RMAProductFlag = true;
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: '.'
        };

        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        params.catEntryId = catEntryIdentifier;
        params.quantity = quantity;

        wcService.invoke(ajaxShopCartService, params);

        $checkoutObj.getCartData(function(){
            renderOrderSummary();
        });
    },

    /**
     * setting engraving params
     */
    AddEngravingToCart : function(){
        if(isPersol){
            $('.bottom-scrollable-section').css('z-index', '3');
        }
        //setting engraving param to true
        this.engraving = true;

        //setting engraving text
        var monogram1 = document.getElementById("monogramText1");
        var monogram2 = document.getElementById("monogramText2");
        var monogram3 = document.getElementById("monogramText3");

        var monogramText1 = monogram1 != null ? document.getElementById("monogramText1").value : "";
        var monogramText2 = monogram2 != null ? document.getElementById("monogramText2").value : "";
        var monogramText3 = monogram3 != null ? document.getElementById("monogramText3").value : "";

        this.engravingText = monogramText1 + monogramText2 + monogramText3;

        //setting engraving font value


        var fonts = document.getElementsByName('engravingFont');
        var countFont = 0;
        for (var i = 0, length = fonts.length; i < length; i++)
        {
        countFont ++;	
         if (fonts[i].checked)
         {
              //getting checked radio button for fonts
              this.engravingFont = fonts[i].value;
              break;
         }
        }
        tealiumProducts[partNumber].Engraving = 'ZSMF|'+ this.engravingText + '|P'+countFont;
        /* WCAG MCB Begin - Focus on price to read the price with screen readers for accessible users */
        $('.namePartPriceContainer .list-price, .namePartPriceContainer .offer-price').first().focus();
        /* WCAG MCB End */
        if(isPersol && !(window.mobilecheck() || window.tabletPortraitCheck())){
            var newPrice = $('.namePartPriceContainer .offer-price').html()
            $('.shopperActions .sticky-price').html("<span class='price-sticky-separator'> &#8212; </span>"  + newPrice)
        }
    },

    /**
     * setting prescription params
     */
    AddPrescriptionToItem : function(){
        //setting prescription param to true
        this.prescription = true;

        //setting prescription values
        var lensMaterial = document.getElementById("lensMaterial");
        var lensOption = document.getElementById("lensOption");
        var lensType = document.getElementById("lensType");
        var lensId =$("#presc--lens--id");

        this.lensMaterialValue = lensMaterial != null ? document.getElementById("lensMaterial").innerHTML : "";
        this.lensOptionValue = lensOption != null ? document.getElementById("lensOption").innerHTML : "";
        this.lensTypeValue = lensType != null ? document.getElementById("lensType").innerHTML : "";
        this.lensId = lensId != null ? $("#presc--lens--id").val() : "";

    },

    //BEGIN LensConfigurator
    //setting prescription params
     AddPrescriptionToItem : function(lensMaterial,lensOption,lensType,lensId){

        //setting prescription param to true
        
        this.prescription = true;

        this.lensMaterialValue = lensMaterial;
        this.lensOptionValue = lensOption;
        this.lensTypeValue = lensType;
        this.lensId = lensId;

    },
    //END LensConfigurator
    
    /**
     * reset prescription params to null
     */
    ResetPrescription : function(){
        this.prescription = false;
        this.lensOptionValue = "";
        this.lensMaterialValue = "";
        this.lensTypeValue = "";
        this.lensId = "";
    },

    /**
     * reset engraving params to null
     */
    ResetEngraving : function(){
        this.engraving = false;
        productDisplayJS.engraving = false;
        this.engravingText = "";
        this.engravingFont = "";
    },

    /* SwatchCode start */

    /**
     * Sets the ID of the image to use for swatch.
     * @param {String} skuImageId The ID of the full image element.
     **/
    setSKUImageId: function (skuImageId) {
        productDisplayJS.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link productDisplayJS.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     *
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnailShortDesc);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },


    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     * @param {String[]} itemAngleThumbnailShortDesc An array of short description for the SKU view thumbnails.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage, itemAngleThumbnailShortDesc) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;

            var thumbnailWidgets = $("ul[id^='ProductAngleImagesAreaList']");
            if ($(thumbnailWidgets).length) {
                for (var i = 0; i < thumbnailWidgets.length; i++) {
                    if (null != thumbnailWidgets[i]) {
                        var angleThumbnail = document.createElement("li");
                        var angleThumbnailLink = document.createElement("a");
                        var angleThumbnailImg = document.createElement("img");

                        angleThumbnail.id = "productAngleLi" + prodAngleCount;

                        angleThumbnailLink.href = "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');";
                        angleThumbnailLink.id = "WC_CachedProductOnlyDisplay_links_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailLink.title = itemAngleThumbnailShortDesc[x];
                        }

                        angleThumbnailImg.src = itemAngleThumbnail[x];
                        angleThumbnailImg.id = "WC_CachedProductOnlyDisplay_images_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailImg.alt = itemAngleThumbnailShortDesc[x];
                        }

                        if (prodAngleCount == 0) {
                            $(thumbnailWidgets[i]).empty();
                        }

                        angleThumbnailLink.appendChild(angleThumbnailImg);
                        angleThumbnail.appendChild(angleThumbnailLink);
                        thumbnailWidgets[i].appendChild(angleThumbnail);
                    }
                }
            }
        }

        var displayImageArea = "";
        if (imageCount > 0) {
            displayImageArea = 'block';
        } else {
            displayImageArea = 'none';
        }
        var angleImageArea = $("div[id^='ProductAngleImagesArea']");
        if (angleImageArea.length) {
            for (var i = 0; i < angleImageArea.length; i++) {
                if (null != angleImageArea[i]) {
                    $(angleImageArea[i]).css("display", displayImageArea);
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = $(swatchArray[i]);
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = $(swatchSkuImage[i]);
            eval(swatchSkuImageElement.attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval(swatchDefaultElement.attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            $("#swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).attr("aria-checked", "false");
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        productDisplayJS.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        $("#swatch_link_" + entitledItemId + "_" + swatchAttrValue).attr("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if ($("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).css("display") == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(selectedAttributeDisplayValue);
        } else {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(swatchAttrValue);
        }
        productDisplayJS.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Make dropdown selection.
     * @param {String} selectedAttrName The name of the selected dropdown attribute.
     * @param {String} selectedAttrValue The value of the selected dropdown attribute.
     * @param {String} entitledItemId The ID of the SKU.
     **/
    makeDropdownSelection: function (selectedAttrName, selectedAttrValue, entitledItemId) {
        //Add indexOf function to arrays for IE8
        if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (obj, start) {
                for (var i = (start || 0), j = this.length; i < j; i++) {
                    if (this[i] === obj) {
                        return i;
                    }
                }
                return -1;
            };
        }

        var dropdownsToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValues = selectedAttributes[selectedAttrName];
        var dropdownList = productDisplayJS.allDropdownsList[entitledItemId];

        // finds out which dropdowns needs to be updated, add to dropdownsToUpdate array
        for (var i = 0; i < dropdownList.length; i++) {
            if (productDisplayJS.removeQuotes(dropdownList[i].name) != productDisplayJS.removeQuotes(selectedAttrName)) {
                dropdownsToUpdate.push(dropdownList[i]);
            }
        }

        //Finds out which attributes are entitled and add them to list of enabled
        var attributesToEnable = {};
        for (var x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            // Turn Attributes into object
            var attrList = {};
            for (var y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledDropdownName = y.substring(0, index);
                var entitledDropdownValue = y.substring(index + 3);

                attrList[entitledDropdownName] = entitledDropdownValue;
            }

            for (var attrName in attrList) {
                //the current entitled item has the selected attribute value
                if (productDisplayJS.removeQuotes(attrName) == productDisplayJS.removeQuotes(selectedAttrName) && (attrList[attrName] == selectedAttrValue || selectedAttrValue === '')) {
                    //go through the other attributes that are available to the selected attribute
                    for (var attrName2 in attrList) {
                        var attrName2NQ = productDisplayJS.removeQuotes(attrName2);
                        //only check the non-selected attribute
                        if (productDisplayJS.removeQuotes(attrName) != attrName2NQ) {
                            // Find all entitled items that match the current list of selected attributes other than attrName2
                            var matchSelectedAttributes = true;
                            for (var selected in selectedAttributes) {
                                if (productDisplayJS.removeQuotes(selected) != attrName2NQ) {
                                    if (selectedAttributes[selected] && selectedAttributes[selected] !== attrList[selected]) {
                                        matchSelectedAttributes = false;
                                    }
                                }
                            }

                            // Find all enabled values for the unselected attributes
                            if (matchSelectedAttributes && attrList[attrName2]) {
                                if (!attributesToEnable[attrName2NQ]) {
                                    attributesToEnable[attrName2NQ] = [];
                                }
                                if (attributesToEnable[attrName2NQ].indexOf(attrList[attrName2].replace(/^\s+|\s+$/g, '')) == -1) {
                                    attributesToEnable[attrName2NQ].push(attrList[attrName2].replace(/^\s+|\s+$/g, ''));
                                }
                            }
                        }
                    }
                }
            }
        }

        //Flag all attributes that should be enabled as enabled
        for (var i in dropdownsToUpdate) {
            var attrValues = attributesToEnable[productDisplayJS.removeQuotes(dropdownsToUpdate[i].name)];
            if (attrValues) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];
                    if (attrValues.indexOf(dropdownToUpdateOption.value.replace(/^\s+|\s+$/g, '')) != -1 || dropdownToUpdateOption.value === '') {
                        dropdownToUpdateOption.enabled = true;
                    }
                }
            }
        }

        //Set all dropdown options that are enabled to disabled = false, others to disabled = true
        for (var i in dropdownsToUpdate) {
            if (dropdownsToUpdate[i].options) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];

                    if (dropdownToUpdateOption.enabled) {
                        dropdownToUpdateOption.disabled = false;
                    } else {
                        dropdownToUpdateOption.disabled = true;
                    }

                    delete dropdownToUpdateOption.enabled;
                }

                var dropdown = $(dropdownsToUpdate[i].node);
                dropdown.Select("refresh");
            }
        }
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @param {String} swatchImg1 The path to the swatch image.
    * @param {String} swatchImg2 The path to the swatch image representing disabled state.
     **/
    addToAllSwatchsArray: function(swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue, swatchImg2) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[3] = swatchImg2;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Constructs record and add to this.allDropdownsArray.
     * @param {String} attributeName The name of the dropdown attribute.
     * @param {String} dropdownId The id of the dropdown.
     **/
    addToAllDropdownsArray: function (attributeName, dropdownId, entitledItemId) {
        var dropdownList = this.allDropdownsList[entitledItemId];
        if (dropdownList == null) {
            dropdownList = [];
        }

        var dropdownNode = productDisplayJS.findDropdownById(dropdownId);

        if (!this.existInAllDropdownsArray(attributeName, dropdownId, dropdownList)) {
            dropdownList.push({
                name: attributeName,
                id: dropdownId,
                node: dropdownNode,
                options: $(dropdownNode).find("option"),
            });
            this.allDropdownsList[entitledItemId] = dropdownList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Checks if a dropdown already exists in this.allDropdownsArray.
     * @param {String} dropdownName The name of the dropdown.
     * @param {String} dropdownId The id of the dropdown.
     * @return boolean Value indicating whether or not the specified dropdown name and value exists in the allDropdownsArray.
     */
    existInAllDropdownsArray: function (dropdownName, dropdownId, dropdownsList) {
        for (var i = 0; i < dropdownsList.length; i++) {
            if (dropdownsList[i].name == dropdownName && dropdownsList[i].id == dropdownId) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entitled SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            productDisplayJS.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param {String} selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = productDisplayJS.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[3] = attrImg2;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled
        for (x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                        swatchElement.src = swatchToUpdateImg1;
                    }
                    else {
                        swatchElement.src = swatchElement.src.replace("_disabled.png","_enabled.png");
                    }

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                        swatchElement.src = swatchToUpdateImg2;
                    }
                    else {
                        swatchElement.src = swatchElement.src.replace("_enabled.png","_disabled.png");
                    }

                    //change the title text of the swatch link
                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);


                    $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    productDisplayJS.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * Displays price of the attribute selected with the catalog entry id.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    displayPrice: function (catEntryId, productId) {
    	
    	productDisplayJS.pst = productDisplayJS.getPST();
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
        var tempString;
        var popup = productDisplayJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
        }

        if (popup == false) {
            var innerHTML = "";
            /**
             * Daniel Rilo 19/10/2018
            if (!catEntry.listPriced || catEntry.listPrice <= catEntry.offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            if (document.getElementById('price_display_' + productId)) {
                document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            } else if (document.getElementById('price_display_' + catEntryId)) {
                document.getElementById('price_display_' + catEntryId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            }

            innerHTML = "";
            */
            if (productDisplayJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            if (document.getElementById('price_display_' + productId) && innerHTML !== '') {
                $("#price_display_" + productId).html($('#price_display_' + productId).html() + '<div class="item_spacer_3px"></div><div id="priceRange_' + productId + '" class="quantity_discount">' + Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML + '</div>');
            }
        }
        //check if the engraving was before
        if(productDisplayJS.engraving){
            productDisplayJS.AddEngravingToCart();
            addPriceMonogram = true;
            priceMonogram('add');
            addPriceMonogram = false;
        }
    },

    /**
     * @param {*} measurements
     */
    getMeasurementsDisplayValue: function (measurements){
       var arrM = measurements.split(",");
       return arrM.join("-");
    },

    /**
    * Updates the product name in the NameAndPrice widget.
    *
    * @param {string} catEntryId The catentryId of the selected product
    * @param {string} productId The productId of the product shown
    */
    updateItemName: function (catEntryId, productId) {
       var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
       var modelCodeValueElement = document.querySelector("#descAttributeValue_modelCode");
       if (modelCodeValueElement != null) {
          modelCodeValueElement.innerHTML = catEntry.description[0].name;
       }

       var modelMeasurements = document.querySelector(".ItemMeasurements_"+catEntryId);

       var modelMeasurementsValueElement = document.querySelector("#descAttributeValue_modelMeasurements");
       if (modelMeasurementsValueElement != null) {
           modelMeasurementsValueElement.innerHTML = productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML);
       }
    },

    /**
     * Updates the product name in the NameAndPrice widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductName: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productName").html(catEntry.description[0].name);
        } else {
            if ($(".top > div[id^='PageHeading_']") != null) {
                $(".top > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }

            var productInfoWidgets = $("input[id^='ProductInfoName_" + productId + "']");
            if (productInfoWidgets != null) {
                for (var i = 0; i < productInfoWidgets.length; i++) {
                    if (productInfoWidgets[i] != null) {
                        $(productInfoWidgets[i]).val(catEntry.description[0].name);
                    }
                }
            }
        }
    },

    /**
     * Updates the product part number in the NameAndPrice widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductPartNumber: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productSKUValue").html(catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
        } else {
            var partnumWidgets = $("span[id^='product_SKU_" + productId + "']");
            if (partnumWidgets != null) {
                for (var i = 0; i < partnumWidgets.length; i++) {
                    if ($(partnumWidgets[i])) {
                        $(partnumWidgets[i]).html(Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
                    }
                }
            }
        }
    },

    /**
     * Updates the product short description in the ShortDescription widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductShortDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var shortDescWidgets = $("p[id^='product_shortdescription_" + productId + "']");
        if (shortDescWidgets != null) {
            for (var i = 0; i < shortDescWidgets.length; i++) {
                if (shortDescWidgets[i]) {
                    shortDescWidgets[i].innerHTML = catEntry.description[0].shortDescription;
                }
            }
        }
    },

    /**
     * Updates the product long description in the LongDescription widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductLongDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var longDescWidgets = $("p[id^='product_longdescription_" + productId + "']");
        if (longDescWidgets != null) {
            for (var i = 0; i < longDescWidgets.length; i++) {
                if (longDescWidgets[i]) {
                    longDescWidgets[i].innerHTML = catEntry.description[0].longDescription;
                }
            }
        }
    },

    /**
     * Updates the product discounts in the Discounts widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductDiscount: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var newHtml = '';
        if (typeof catEntry.discounts != 'undefined') {
            for (var i = 0; i < catEntry.discounts.length; i++) {
                if (i > 0) {
                    newHtml += '<div class="clear_float"></div><div class="item_spacer_2px"></div>';
                }
                /* catEntry.discounts[i].description comes from short description associated with the promotion.
                 * If it is blank or missing, the link text is blank, thus is not clickable or displayed.
                 */
                newHtml += '<a class="promotion" href="' + catEntry.discounts[i].url + '">' + catEntry.discounts[i].description + '</a>';
            }
        }

        var discountWidgets = $("div[id^='Discounts_']");
        if (discountWidgets != null) {
            for (var i = 0; i < discountWidgets.length; i++) {
                if (discountWidgets[i]) {
                    discountWidgets[i].innerHTML = newHtml;
                }
            }
        }
    },

    /**
     * Updates the product full image and angle images in the FullImage widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductImage: function (catEntryId, productId) {
        var newFullImage = null;
        var newAngleThumbnail = null;
        var newAngleFullImage = null;
        var newAngleThumbnailShortDesc = null;

        var skuFullImageFromService = null;
        var catEntry = null;
        if (productDisplayJS.itemPriceJsonOject[catEntryId] != null) {
            catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
        }
        if (catEntry != null) {
            skuFullImageFromService = catEntry.description[0].fullImage;
        }

        var entitledItemId = "entitledItem_" + productId;
        var imageArr = productDisplayJS.getImageForSKU(entitledItemId);
        if (imageArr != null) {
            newAngleThumbnail = imageArr[2];
            newAngleFullImage = imageArr[3];
            newAngleThumbnailShortDesc = imageArr[4];
        }

        if (catEntryId != null) {
        	if(imageArr!=null){
        	   newFullImage = imageArr[0];
        	}    
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
        } else if (productId != null && productDisplayJS.singleSKUProductWithoutDefiningAttribute) {
            newFullImage = productDisplayJS.entitledItems[0].ItemImage467;
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
            newAngleThumbnail = productDisplayJS.entitledItems[0].ItemAngleThumbnail;
            newAngleFullImage = productDisplayJS.entitledItems[0].ItemAngleFullImage;
            newAngleThumbnailShortDesc = productDisplayJS.entitledItems[0].ItemAngleThumbnailShortDesc;
        } else {
            var imageFound = false;
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (x in productDisplayJS.entitledItems) {
                var Attributes = productDisplayJS.entitledItems[x].Attributes;

                for (attribute in selectedAttributes) {
                    var matchingAttributeFound = false;
                    if (selectedAttributes[attribute] !== '') {
                        for (y in Attributes) {
                            var index = y.indexOf("_|_");
                            var entitledSwatchName = y.substring(0, index);
                            var entitledSwatchValue = y.substring(index + 3);

                            if (entitledSwatchName == attribute && entitledSwatchValue == selectedAttributes[attribute]) {
                                matchingAttributeFound = true;
                                break;
                            }
                        }

                        // No matching attributes found, so this is not the correct SKU
                        if (!matchingAttributeFound) {
                            imageFound = false;
                            break;
                        }
                        imageFound = true;
                    }
                }

                // imageFound will only be true if all attributes have been matched (so the first correct SKU)
                if (imageFound) {
                    newFullImage = productDisplayJS.entitledItems[x].ItemImage467;
                    newAngleThumbnail = productDisplayJS.entitledItems[x].ItemAngleThumbnail;
                    newAngleFullImage = productDisplayJS.entitledItems[x].ItemAngleFullImage;
                    newAngleThumbnailShortDesc = productDisplayJS.entitledItems[x].ItemAngleThumbnailShortDesc;
                    break;
                }
            }
        }

        var imgWidgets = $("img[id^='" + productDisplayJS.skuImageId + "']");
        for (var i = 0; i < imgWidgets.length; i++) {
            if (imgWidgets[i] != null && newFullImage != null) {
                //imgWidgets[i].src = newFullImage;
            }
        }

        var productImgWidgets = $("input[id^='ProductInfoImage_" + productId + "']");
        for (var i = 0; i < productImgWidgets.length; i++) {
            if (productImgWidgets[i] != null && newFullImage != null) {
                productImgWidgets[i].value = newFullImage;
            }
        }

        var prodAngleImageArea = $("div[id^='ProductAngleProdImagesArea']");
        var skuAngleImageArea = $("div[id^='ProductAngleImagesArea']");

        if (newAngleThumbnail != null && newAngleFullImage != null) {
            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (null != prodAngleImageArea[i]) {
                        $(prodAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
            productDisplayJS.changeViewImages(newAngleThumbnail, newAngleFullImage, newAngleThumbnailShortDesc);
        } else {
            var prodDisplayClass = 'block';
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (attribute in selectedAttributes) {
                if (null != selectedAttributes[attribute] && '' != selectedAttributes[attribute]) {
                    prodDisplayClass = 'none';
                }
            }

            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (prodAngleImageArea[i].length) {
                        $(prodAngleImageArea[i]).css("display", prodDisplayClass);
                    }
                }
            }

            if (skuAngleImageArea != null) {
                for (var i = 0; i < skuAngleImageArea.length; i++) {
                    if (skuAngleImageArea[i].length) {
                        $(skuAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to 'DefiningAttributes_Changed' or 'DefiningAttributes_Resolved' event.
     *
     * @param {string} productId The identifier of the product.
     * @param {string} entitledItemId The identifier of the entitled item.
     * @param {boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {boolean} displayPriceRange A boolean used to to determine whether or not to display the price range when the catEntry is selected.
     */
    notifyAttributeChange: function (productId, entitledItemId, isPopup, displayPriceRange) {
        productDisplayJS.baseCatalogEntryId = productId;
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];

        productDisplayJS.displayPriceRange = displayPriceRange;
        productDisplayJS.isPopup = isPopup;

        var catalogEntryId = null;
        if (productDisplayJS.selectedProducts[productId]) {
            catalogEntryId = productDisplayJS.getCatalogEntryIdforProduct(productDisplayJS.selectedProducts[productId]);
        } else {
            catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);
        }

        this.changedCatEntryId = catalogEntryId;
        $(".wishlist-icon-container").attr("data-catentryIdItem-wishlist",this.changedCatEntryId);// WISHLIST --set catentry id of itemsBean
        if(this.hasPres || this.sizeHasPres || this.modelHasPres){
            this.prescChangeSelect();
            $("#removeButton").click();
        }
        
        //set partnumber in #vm_box
        for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
        if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
            $("#addLenses").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]); // set Partnumber in LensConfigurator analytics
        	$('#vm_box').attr('data-vm',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
            $("a[data-element-id='X_X_VirtualMirror_Start']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                break;
            }
        }
        
        if (catalogEntryId != null) {
            wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);

            //check if the json object is already present for the catEntry.
            var catEntry = productDisplayJS.itemPriceJsonOject[catalogEntryId];

            if (catEntry != null && catEntry != undefined && !productDisplayJS.engraving) {
                productDisplayJS.publishAttributeResolvedEvent(catalogEntryId, productId);
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: productDisplayJS.storeId,
                    langId: productDisplayJS.langId,
                    catalogId: productDisplayJS.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetails",
                    actionId: "getCatalogEntryDetails",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        productDisplayJS.publishAttributeResolvedEventServiceResponse(serviceResponse, ioArgs);
                        /* START Early Access */
                        if (isVogue){
                            replacePDPMainPrice(catEntryIdSubscribe);
                            checkOfferListPrice();

                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                var earlyAccessTooltip = $(".contentRecommendationWidget[id*='X_PDP_CustomerSegment_Tooltip']");
                                if ($(".namePartPriceContainer .list-price").eq(1).text() != ""){
                                    earlyAccessTooltip.eq(1).css("left", "20px").css("top","34.7em").css("position","absolute").width("44%");
                                 }
                            }
                        }
                        /* END Early Access */
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("productDisplayJS.notifyAttributeChange: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetails", parameters);
            }
        } else {
            wcTopic.publish('DefiningAttributes_Changed', catalogEntryId, productId);
            wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            console.debug("Publishing event 'DefiningAttributes_Changed' with params: catEntryId=" + catalogEntryId + ", productId=" + productId);
        }

         //HB-10122
        if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
            var modelMeasurements = document.querySelector(".ItemMeasurements_" + catalogEntryId);

            var modelMeasurementsValueElement = document.querySelector("#featureMenu #descAttributeValue_modelMeasurements");
            if (modelMeasurementsValueElement != null) {
                modelMeasurementsValueElement.innerHTML = productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML);
            }
            $("#descriptiveAttributes #descAttributeValue_modelMeasurements").html(productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML))
            $("#tabAttr #descAttributeValue_modelMeasurements").html(productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML));
        }
    },

    /**
     * Publishes the 'DefiningAttributes_Resolved' event using the JSON object returned from the server.
     *
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    publishAttributeResolvedEventServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        productDisplayJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        productDisplayJS.publishAttributeResolvedEvent(serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID, productId);
    },

    /**
     * Publishes the 'DefiningAttributes_Resolved' event with the necessary parameters.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    publishAttributeResolvedEvent: function (catEntryId, productId) {
        if (!productDisplayJS.isPopup) {
            if (this.entitledItems) {
                for (x in this.entitledItems) {
                    var sku = this.entitledItems[x];
                    if (sku.catentry_id === catEntryId) {
                        if (sku.displaySKUContextData === 'true') {
                            if (document.location.href !== sku.seo_url) {
                                document.location.replace(sku.seo_url);
                            } else {
                                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                            }
                        } else {
                            wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                            console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                        }
                    }
                }
            } else {
                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
            }
        }
    },

    /**
     * To notify the change in quantity to other components that is subscribed to ShopperActions_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish('ShopperActions_Changed', quantity);
        console.debug("Publishing event 'ShopperActions_Changed' with params: quantity=" + quantity);
    },

    /**
     * To display attachment page.
     */
    showAttachmentPage: function (data) {
        var pageNumber = data['pageNumber'];
        var pageSize = data['pageSize'];
        pageNumber = Number(pageNumber);
        pageSize = Number(pageSize);

        setCurrentId(data["linkId"]);

        if (!submitRequest()) {
            return;
        }

        var beginIndex = pageSize * (pageNumber - 1);
        cursor_wait();
        wcRenderContext.updateRenderContext('AttachmentPagination_Context', {
            'beginIndex': beginIndex
        });
        MessageHelper.hideAndClearMessage();
    },

    /**
     * Register mouse down event
     */
    registerMouseDown: function (node) {
        $(node).on("mousedown",
            function () {
                productDisplayJS.calculateScrollingHeight(node);
            }
        );
    },

    /**
     * Calculate scrolling height.
     */
    calculateScrollingHeight: function (node) {
        var selectedNode = productDisplayJS.findDropdownById(node);
        var nodePosition = null;
        if (selectedNode) {
            nodePosition = Utils.position(selectedNode);
        } else {
            return;
        }
        var windowHeight = window.innerHeight;
        if (windowHeight - nodePosition.y > nodePosition.y) {
            var newHeight = windowHeight - nodePosition.y;
        } else {
            var newHeight = nodePosition.y;
        }
        if ($("#" + node + "_dropdown").length) {
            if (windowHeight - nodePosition.y > nodePosition.y) {
                var newHeight = windowHeight - nodePosition.y;
            } else {
                var newHeight = nodePosition.y;
            }
            var dropdownHeight = $("#" + node + "_dropdown").clientHeight;
            if (dropdownHeight > newHeight) {
                $("#" + node + "_dropdown").css("height", newHeight + "px");
            }
        } else {
            //			$("#" + node + "_dropdown").css("height", windowHeight + "px");
        }
    },

    findDropdownById: function (node) {
        var newNode = productDisplayJS.removeQuotes(node);
        var nodes = $('[id^=attrValue_]');
        var foundNode = null;

        $(nodes).each(function (key, domNode) {
            var id = productDisplayJS.removeQuotes(domNode.id);
            if (newNode === id) {
                foundNode = domNode;
            }
        });

        return foundNode;
    },

    removeQuotes: function (str) {
        if (str) {
            return str.replace(/&#039;/g, '').replace(/\\'/g, '').replace(/'/g, '');
        } else {
            return str;
        }
    },

    getPST: function(){
    	if(document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId) != null)
           return document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId).innerText;
    }
}
$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]", function (event) {
            this.blur();
            this.focus();
        });
    }
});

/*! @vimeo/player v2.10.0 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e=e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var e="undefined"!=typeof global&&"[object global]"==={}.toString.call(global);function i(e,t){return 0===e.indexOf(t.toLowerCase())?e:"".concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function s(e){return/^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e)}function l(){var e,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=t.id,r=t.url,o=n||r;if(!o)throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");if(e=o,!isNaN(parseFloat(e))&&isFinite(e)&&Math.floor(e)==e)return"https://vimeo.com/".concat(o);if(s(o))return o.replace("http:","https:");if(n)throw new TypeError("“".concat(n,"” is not a valid video id."));throw new TypeError("“".concat(o,"” is not a vimeo.com url."))}var t=void 0!==Array.prototype.indexOf,n="undefined"!=typeof window&&void 0!==window.postMessage;if(!(e||t&&n))throw new Error("Sorry, the Vimeo Player API is not available in this browser.");var o="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};!function(e){if(!e.WeakMap){var n=Object.prototype.hasOwnProperty,o=function(e,t,n){Object.defineProperty?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n};e.WeakMap=function(){function e(){if(void 0===this)throw new TypeError("Constructor WeakMap requires 'new'");if(o(this,"_id","_WeakMap"+"_"+t()+"."+t()),0<arguments.length)throw new TypeError("WeakMap iterable is not supported")}function r(e,t){if(!i(e)||!n.call(e,"_id"))throw new TypeError(t+" method called on incompatible receiver "+typeof e)}function t(){return Math.random().toString().substring(2)}return o(e.prototype,"delete",function(e){if(r(this,"delete"),!i(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)&&(delete e[this._id],!0)}),o(e.prototype,"get",function(e){if(r(this,"get"),i(e)){var t=e[this._id];return t&&t[0]===e?t[1]:void 0}}),o(e.prototype,"has",function(e){if(r(this,"has"),!i(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)}),o(e.prototype,"set",function(e,t){if(r(this,"set"),!i(e))throw new TypeError("Invalid value used as weak map key");var n=e[this._id];return n&&n[0]===e?n[1]=t:o(e,this._id,[e,t]),this}),o(e,"_polyfill",!0),e}()}function i(e){return Object(e)===e}}("undefined"!=typeof self?self:"undefined"!=typeof window?window:o);var a,f=(function(e){var t,n,r;r=function(){var t,a,n,e=Object.prototype.toString,r="undefined"!=typeof setImmediate?function(e){return setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t=function(e,t,n,r){return Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!==r})}}catch(e){t=function(e,t,n){return e[t]=n,e}}function i(e,t){n.add(e,t),a||(a=r(n.drain))}function u(e){var t,n=typeof e;return null==e||"object"!=n&&"function"!=n||(t=e.then),"function"==typeof t&&t}function c(){for(var e=0;e<this.chain.length;e++)o(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function o(e,t,n){var r,o;try{!1===t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void 0,e.msg))===n.promise?n.reject(TypeError("Promise-chain cycle")):(o=u(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}function s(e){var t=this;t.triggered||(t.triggered=!0,t.def&&(t=t.def),t.msg=e,t.state=2,0<t.chain.length&&i(c,t))}function l(e,n,r,o){for(var t=0;t<n.length;t++)!function(t){e.resolve(n[t]).then(function(e){r(t,e)},o)}(t)}function f(e){this.def=e,this.triggered=!1}function d(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function h(e){if("function"!=typeof e)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var r=new d(this);this.then=function(e,t){var n={success:"function"!=typeof e||e,failure:"function"==typeof t&&t};return n.promise=new this.constructor(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");n.resolve=e,n.reject=t}),r.chain.push(n),0!==r.state&&i(c,r),n.promise},this.catch=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){(function e(n){var r,o=this;if(!o.triggered){o.triggered=!0,o.def&&(o=o.def);try{(r=u(n))?i(function(){var t=new f(o);try{r.call(n,function(){e.apply(t,arguments)},function(){s.apply(t,arguments)})}catch(e){s.call(t,e)}}):(o.msg=n,o.state=1,0<o.chain.length&&i(c,o))}catch(e){s.call(new f(o),e)}}}).call(r,e)},function(e){s.call(r,e)})}catch(e){s.call(r,e)}}n=function(){var n,r,o;function i(e,t){this.fn=e,this.self=t,this.next=void 0}return{add:function(e,t){o=new i(e,t),r?r.next=o:n=o,r=o,o=void 0},drain:function(){var e=n;for(n=r=a=void 0;e;)e.fn.call(e.self),e=e.next}}}();var v=t({},"constructor",h,!1);return t(h.prototype=v,"__NPO__",0,!1),t(h,"resolve",function(n){return n&&"object"==typeof n&&1===n.__NPO__?n:new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");e(n)})}),t(h,"reject",function(n){return new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");t(n)})}),t(h,"all",function(t){var a=this;return"[object Array]"!=e.call(t)?a.reject(TypeError("Not an array")):0===t.length?a.resolve([]):new a(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");var r=t.length,o=Array(r),i=0;l(a,t,function(e,t){o[e]=t,++i===r&&n(o)},e)})}),t(h,"race",function(t){var r=this;return"[object Array]"!=e.call(t)?r.reject(TypeError("Not an array")):new r(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");l(r,t,function(e,t){n(t)},e)})}),h},(n=o)[t="Promise"]=n[t]||r(),e.exports&&(e.exports=n[t])}(a={exports:{}},a.exports),a.exports),d=new WeakMap;function u(e,t,n){var r=d.get(e.element)||{};t in r||(r[t]=[]),r[t].push(n),d.set(e.element,r)}function c(e,t){return(d.get(e.element)||{})[t]||[]}function h(e,t,n){var r=d.get(e.element)||{};if(!r[t])return!0;if(!n)return r[t]=[],d.set(e.element,r),!0;var o=r[t].indexOf(n);return-1!==o&&r[t].splice(o,1),d.set(e.element,r),r[t]&&0===r[t].length}var v=["autopause","autoplay","background","byline","color","controls","dnt","height","id","loop","maxheight","maxwidth","muted","playsinline","portrait","responsive","speed","texttrack","title","transparent","url","width"];function p(r){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return v.reduce(function(e,t){var n=r.getAttribute("data-vimeo-".concat(t));return(n||""===n)&&(e[t]=""===n?1:n),e},e)}function y(e,t){var n=e.html;if(!t)throw new TypeError("An element must be provided");if(null!==t.getAttribute("data-vimeo-initialized"))return t.querySelector("iframe");var r=document.createElement("div");return r.innerHTML=n,t.appendChild(r.firstChild),t.setAttribute("data-vimeo-initialized","true"),t.querySelector("iframe")}function m(i){var a=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},u=2<arguments.length?arguments[2]:void 0;return new Promise(function(t,n){if(!s(i))throw new TypeError("“".concat(i,"” is not a vimeo.com url."));var e="https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(i));for(var r in a)a.hasOwnProperty(r)&&(e+="&".concat(r,"=").concat(encodeURIComponent(a[r])));var o="XDomainRequest"in window?new XDomainRequest:new XMLHttpRequest;o.open("GET",e,!0),o.onload=function(){if(404!==o.status)if(403!==o.status)try{var e=JSON.parse(o.responseText);if(403===e.domain_status_code)return y(e,u),void n(new Error("“".concat(i,"” is not embeddable.")));t(e)}catch(e){n(e)}else n(new Error("“".concat(i,"” is not embeddable.")));else n(new Error("“".concat(i,"” was not found.")))},o.onerror=function(){var e=o.status?" (".concat(o.status,")"):"";n(new Error("There was an error fetching the embed code from Vimeo".concat(e,".")))},o.send()})}function g(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){return console.warn(e),{}}return e}function w(e,t,n){if(e.element.contentWindow&&e.element.contentWindow.postMessage){var r={method:t};void 0!==n&&(r.value=n);var o=parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/,"$1"));8<=o&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin)}}function b(n,r){var t,e=[];if((r=g(r)).event){if("error"===r.event)c(n,r.data.method).forEach(function(e){var t=new Error(r.data.message);t.name=r.data.name,e.reject(t),h(n,r.data.method,e)});e=c(n,"event:".concat(r.event)),t=r.data}else if(r.method){var o=function(e,t){var n=c(e,t);if(n.length<1)return!1;var r=n.shift();return h(e,t,r),r}(n,r.method);o&&(e.push(o),t=r.value)}e.forEach(function(e){try{if("function"==typeof e)return void e.call(n,t);e.resolve(t)}catch(e){}})}var k=new WeakMap,E=new WeakMap,Player=function(){function Player(u){var e,c=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Player),window.jQuery&&u instanceof jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A jQuery object with multiple elements was passed, using the first element."),u=u[0]),"undefined"!=typeof document&&"string"==typeof u&&(u=document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&"nodeName"in e&&e.ownerDocument&&e.ownerDocument.defaultView))throw new TypeError("You must pass either a valid element or a valid id.");var r=u.ownerDocument.defaultView;if("IFRAME"!==u.nodeName){var t=u.querySelector("iframe");t&&(u=t)}if("IFRAME"===u.nodeName&&!s(u.getAttribute("src")||""))throw new Error("The player element passed isn’t a Vimeo embed.");if(k.has(u))return k.get(u);this.element=u,this.origin="*";var o=new f(function(i,a){var e=function(e){if(s(e.origin)&&c.element.contentWindow===e.source){"*"===c.origin&&(c.origin=e.origin);var t=g(e.data);if(t&&"error"===t.event&&t.data&&"ready"===t.data.method){var n=new Error(t.data.message);return n.name=t.data.name,void a(n)}var r=t&&"ready"===t.event,o=t&&"ping"===t.method;if(r||o)return c.element.setAttribute("data-ready","true"),void i();b(c,t)}};if(r.addEventListener?r.addEventListener("message",e,!1):r.attachEvent&&r.attachEvent("onmessage",e),"IFRAME"!==c.element.nodeName){var t=p(u,n);m(l(t),t,u).then(function(e){var t,n,r,o=y(e,u);return c.element=o,c._originalElement=u,t=u,n=o,r=d.get(t),d.set(n,r),d.delete(t),k.set(c.element,c),e}).catch(a)}});return E.set(this,o),k.set(this.element,this),"IFRAME"===this.element.nodeName&&w(this,"ping"),this}var e,t,n;return e=Player,(t=[{key:"callMethod",value:function(n){var r=this,o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return new f(function(e,t){return r.ready().then(function(){u(r,n,{resolve:e,reject:t}),w(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var r=this;return new f(function(e,t){return n=i(n,"get"),r.ready().then(function(){u(r,n,{resolve:e,reject:t}),w(r,n)}).catch(t)})}},{key:"set",value:function(n,r){var o=this;return new f(function(e,t){if(n=i(n,"set"),null==r)throw new TypeError("There must be a value to set.");return o.ready().then(function(){u(o,n,{resolve:e,reject:t}),w(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(!t)throw new TypeError("You must pass a callback function.");if("function"!=typeof t)throw new TypeError("The callback must be a function.");0===c(this,"event:".concat(e)).length&&this.callMethod("addEventListener",e).catch(function(){}),u(this,"event:".concat(e),t)}},{key:"off",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(t&&"function"!=typeof t)throw new TypeError("The callback must be a function.");h(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var e=E.get(this)||new f(function(e,t){t(new Error("Unknown player. Probably unloaded."))});return f.resolve(e)}},{key:"addCuePoint",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return this.callMethod("addCuePoint",{time:e,data:t})}},{key:"removeCuePoint",value:function(e){return this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw new TypeError("You must pass a language.");return this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return this.callMethod("pause")}},{key:"play",value:function(){return this.callMethod("play")}},{key:"unload",value:function(){return this.callMethod("unload")}},{key:"destroy",value:function(){var t=this;return new f(function(e){E.delete(t),k.delete(t.element),t._originalElement&&(k.delete(t._originalElement),t._originalElement.removeAttribute("data-vimeo-initialized")),t.element&&"IFRAME"===t.element.nodeName&&t.element.parentNode&&t.element.parentNode.removeChild(t.element),e()})}},{key:"getAutopause",value:function(){return this.get("autopause")}},{key:"setAutopause",value:function(e){return this.set("autopause",e)}},{key:"getBuffered",value:function(){return this.get("buffered")}},{key:"getColor",value:function(){return this.get("color")}},{key:"setColor",value:function(e){return this.set("color",e)}},{key:"getCuePoints",value:function(){return this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return this.set("currentTime",e)}},{key:"getDuration",value:function(){return this.get("duration")}},{key:"getEnded",value:function(){return this.get("ended")}},{key:"getLoop",value:function(){return this.get("loop")}},{key:"setLoop",value:function(e){return this.set("loop",e)}},{key:"setMuted",value:function(e){return this.set("muted",e)}},{key:"getMuted",value:function(){return this.get("muted")}},{key:"getPaused",value:function(){return this.get("paused")}},{key:"getPlaybackRate",value:function(){return this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return this.get("played")}},{key:"getSeekable",value:function(){return this.get("seekable")}},{key:"getSeeking",value:function(){return this.get("seeking")}},{key:"getTextTracks",value:function(){return this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return this.get("videoId")}},{key:"getVideoTitle",value:function(){return this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return this.get("videoUrl")}},{key:"getVolume",value:function(){return this.get("volume")}},{key:"setVolume",value:function(e){return this.set("volume",e)}}])&&r(e.prototype,t),n&&r(e,n),Player}();return e||(function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:document,t=[].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),n=function(e){"console"in window&&console.error&&console.error("There was an error creating an embed: ".concat(e))};t.forEach(function(t){try{if(null!==t.getAttribute("data-vimeo-defer"))return;var e=p(t);m(l(e),e,t).then(function(e){return y(e,t)}).catch(n)}catch(e){n(e)}})}(),function(){var r=0<arguments.length&&void 0!==arguments[0]?arguments[0]:document;if(!window.VimeoPlayerResizeEmbeds_){window.VimeoPlayerResizeEmbeds_=!0;var e=function(e){if(s(e.origin)&&e.data&&"spacechange"===e.data.event)for(var t=r.querySelectorAll("iframe"),n=0;n<t.length;n++)if(t[n].contentWindow===e.source){t[n].parentElement.style.paddingBottom="".concat(e.data.data[0].bottom,"px");break}};window.addEventListener?window.addEventListener("message",e,!1):window.attachEvent&&window.attachEvent("onmessage",e)}}()),Player});

/* AJAXBUTTONS BEGIN *******************************************/
/*
Instructions:
    Create <a> or <div> tag with unique id (mandatory)
    Add class "ajaxbutton"

    MessageHelper.displayStatusMessage("Success");
    MessageHelper.displayErrorMessage("Error");

    Both functions restore launch restoreAjaxButtons();

    Note that if a component is loaded dinamically you must call at the end of the loaded jsp:
    <script>
    addAjaxButtonsEventListener();
    </script>
    or adding this:
        $(document).ajaxComplete(function(){
            addAjaxButtonsEventListener();
        });

*/
var isEdgeIE = false;
var ajaxButtonTimeOutRef;

// Add listener to all ajaxbuttons
$(document).ready(function(){
    addAjaxButtonsEventListener();

    if (isEdgeOrIExplorer()){
        isEdgeIE = true;
    }
});

function isEdgeOrIExplorer(){
    // detect IE8 and above, and Edge
    if (document.documentMode || /Edge\//.test(navigator.userAgent)) {
        return true;
    }
    return false;
}

function addAjaxButtonsEventListener(){
    var ajaxButtons = document.querySelectorAll(".ajaxbutton");
    for (var i = 0; i < ajaxButtons.length; i++) {
        ajaxButtons[i].addEventListener("click", showAjaxLoader, true);
    }
}

/**
 *  This function adds a spinner to the element that generates the event, and it should
 *  never be called directly. If you want an element to show the ajax loader, consider
 *  adding the class 'ajaxbutton' to that element
 *
 * @param {*} eventOrId This paramenter can be either the Event object generated by the clicked button
 *                  or a string that indicates the element id where we want to add the spinner
 */
function showAjaxLoader(eventOrId){
    var ERROR_ELEMENT_NOT_FOUND = "showAjaxLoader()::ajaxbutton element not found";
    var button;
    var buttonId;
    var error = false;

    if (typeof eventOrId === "object"){
        //event parameter is an Event object
        var srcElement = eventOrId.srcElement;
        while(!srcElement.classList.contains("ajaxbutton") && srcElement.tagName != "BODY"){
            srcElement = srcElement.parentElement;
        }
        if (srcElement.tagName == "BODY"){
            error = true;
        } else {
            buttonId = srcElement.id;
        }
    } else if (typeof eventOrId === "string"){
        //event parameter is a String, so we take it as elementId
        buttonId = eventOrId;
    }

    button = document.getElementById(buttonId);
    if (button == null){
        error = true;
    }

    if (error){
        console.log(ERROR_ELEMENT_NOT_FOUND);
    } else {
        var ajaxLoaderImgId = "ajaxLoaderImg_"+buttonId;
        var ajaxLoaderImgClass = "ajaxbutton__loader-image";
        var ajaxLoaderBackupId = "ajaxLoaderBackup_"+buttonId;

        if (document.getElementById(ajaxLoaderImgId) == null){
            //Add WCAG parameter
            button.setAttribute("aria-disabled", "true");
            button.setAttribute("ajaxbutton-enabled", "true");

            //Create a copy of the internal content of the button into a hidden div
            var divElement = document.createElement("div");
            divElement.setAttribute("id", ajaxLoaderBackupId);
            divElement.setAttribute("button-id", buttonId);
            //divElement.style.display = 'none';
            if(buttonId && buttonId != 'GotoCartButton2') divElement.style.visibility = "hidden"; //Use visibility hidden in order to keep ocupied space
            divElement.innerHTML = button.innerHTML;

            if (!isEdgeIE || (isPersol && buttonId && buttonId != 'GotoCartButton2')){
                button.innerHTML = "";
            }

            button.appendChild(divElement);

            //Spinner styles/image is set in CSS. Here we add the container
            divElement = document.createElement("div");
            divElement.setAttribute("id", ajaxLoaderImgId);
            divElement.setAttribute("button-id", buttonId);
            divElement.setAttribute("class", ajaxLoaderImgClass);
            button.appendChild(divElement);
        }
    }

    //If for any reason a button is not restored it will be automatically unlocked after 10sec
    ajaxButtonTimeOutRef = setTimeout(function(){restoreAjaxButtons();}, 10000);
}

/**
 * Restore an ajaxbutton to its original state
 *
 * @param {String} elementOrId
 */
function restoreAjaxButton(elementOrId){
    var ERROR_BAD_PARAMETER = "restoreAjaxButton()::Error: Bad parameter (must be an element id string or an element object)";
    var ERROR_ELEMENT_NOT_FOUND = "restoreAjaxButton()::Error: Element id not found";
    var ERROR_NO_ID = "restoreAjaxButton()::Error: Element must have an id";

    var button;
    var buttonId;

    if (elementOrId == null || (typeof elementOrId !== 'object' && typeof elementOrId !== 'string')){
        console.log(ERROR_BAD_PARAMETER);
        return;
    }

    if (typeof elementOrId === 'object') {
        button = elementOrId;
        if (typeof button.id === 'undefined'){
            console.log(ERROR_NO_ID);
            return;
        }
        buttonId = button.id;
    } else if (typeof elementOrId === 'string') {
        button = document.getElementById(elementOrId);
        if (button == null){
            console.log(ERROR_ELEMENT_NOT_FOUND);
            return;
        }
        buttonId = elementOrId;
    }

    var ajaxLoaderImgId = "ajaxLoaderImg_" + buttonId;
    var ajaxLoaderBackupId = "ajaxLoaderBackup_" + buttonId;

    //Stop all event listeners for "click" event in the capturing phase
    //button.removeEventListener("click", onclickEventBlocker, true);

    //Remove WCAG parameter
    button.removeAttribute("aria-disabled");
    button.removeAttribute("ajaxbutton-enabled");

    //Remove ajax loader container
    if (document.getElementById(ajaxLoaderImgId) != null) {
        var divElement = document.getElementById(ajaxLoaderImgId);
        divElement.parentNode.removeChild(divElement);
    }

    //Restore backup div
    if (document.getElementById(ajaxLoaderBackupId) != null) {
        var divElement = document.getElementById(ajaxLoaderBackupId);
        button.innerHTML = divElement.innerHTML;
    }
}

/**
 * Restore all ajaxbuttos to their original state
 */
function restoreAjaxButtons(){
    clearTimeout(ajaxButtonTimeOutRef);

    //Added a little timeout to ensure that the buttons restoration is always called after the showAjaxLoader
    setTimeout(function(){
        var ajaxButtons = document.querySelectorAll(".ajaxbutton");
        for (var i = 0; i < ajaxButtons.length; i++) {
            restoreAjaxButton(ajaxButtons[i]);
        }
    }, 3);
}
/* AJAXBUTTONS END *******************************************/
(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       only accounts for vertical position, not horizontal.
     */
    var $w=$(window);
    $.fn.visible = function(partial,hidden,direction,container){

        if (this.length < 1)
            return;
	
	// Set direction default to 'both'.
	direction = direction || 'both';
	    
        var $t          = this.length > 1 ? this.eq(0) : this,
						isContained = typeof container !== 'undefined' && container !== null,
						$c				  = isContained ? $(container) : $w,
						wPosition        = isContained ? $c.position() : 0,
            t           = $t.get(0),
            vpWidth     = $c.outerWidth(),
            vpHeight    = $c.outerHeight(),
            clientSize  = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = isContained ?
												rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top :
												rec.top >= 0 && rec.top < vpHeight,
                bViz = isContained ?
												rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top :
												rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = isContained ?
												rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left :
												rec.left >= 0 && rec.left <  vpWidth,
                rViz = isContained ?
												rec.right - wPosition.left > 0  && rec.right < vpWidth + wPosition.left  :
												rec.right > 0 && rec.right <= vpWidth,
                vVisible   = partial ? tViz || bViz : tViz && bViz,
                hVisible   = partial ? lViz || rViz : lViz && rViz,
		vVisible = (rec.top < 0 && rec.bottom > vpHeight) ? true : vVisible,
                hVisible = (rec.left < 0 && rec.right > vpWidth) ? true : hVisible;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var viewTop 				= isContained ? 0 : wPosition,
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $c.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                position          = $t.position(),
                _top            = position.top,
                _bottom         = _top + $t.height(),
                _left           = position.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }
    };

})(jQuery);

/*
 * Copyright (C) 2012 PrimeBox
 * 
 * This work is licensed under the Creative Commons
 * Attribution 3.0 Unported License. To view a copy
 * of this license, visit
 * http://creativecommons.org/licenses/by/3.0/.
 * 
 * Documentation available at:
 * http://www.primebox.co.uk/projects/cookie-bar/
 * 
 * When using this software you use it at your own risk. We hold
 * no responsibility for any damage caused by using this plugin
 * or the documentation provided.
 */
(function($){
	$.cookieBar = function(options,val){
		if(options=='cookies'){
			var doReturn = 'cookies';
		}else if(options=='set'){
			var doReturn = 'set';
		}else{
			var doReturn = false;
		}
		var defaults = {
			message: 'We use cookies to track usage and preferences.', //Message displayed on bar
			acceptButton: true, //Set to true to show accept/enable button
			acceptText: 'I Understand', //Text on accept/enable button
			acceptFunction: function(cookieValue){if(cookieValue!='enabled' && cookieValue!='accepted') window.location = window.location.href;}, //Function to run after accept
			declineButton: false, //Set to true to show decline/disable button
			declineText: 'Disable Cookies', //Text on decline/disable button
			declineFunction: function(cookieValue){if(cookieValue=='enabled' || cookieValue=='accepted') window.location = window.location.href;}, //Function to run after decline
			policyButton: false, //Set to true to show Privacy Policy button
			policyText: 'Privacy Policy', //Text on Privacy Policy button
			policyURL: '/privacy-policy/', //URL of Privacy Policy
			autoEnable: true, //Set to true for cookies to be accepted automatically. Banner still shows
			acceptOnContinue: false, //Set to true to accept cookies when visitor moves to another page
			acceptOnScroll: false, //Set to true to accept cookies when visitor scrolls X pixels up or down
			acceptAnyClick: false, //Set to true to accept cookies when visitor clicks anywhere on the page
			expireDays: 365, //Number of days for cookieBar cookie to be stored for
			renewOnVisit: false, //Renew the cookie upon revisit to website
			forceShow: false, //Force cookieBar to show regardless of user cookie preference
			effect: 'slide', //Options: slide, fade, hide
			element: 'body', //Element to append/prepend cookieBar to. Remember "." for class or "#" for id.
			append: false, //Set to true for cookieBar HTML to be placed at base of website. Actual position may change according to CSS
			fixed: false, //Set to true to add the class "fixed" to the cookie bar. Default CSS should fix the position
			bottom: false, //Force CSS when fixed, so bar appears at bottom of website
			zindex: '', //Can be set in CSS, although some may prefer to set here
			domain: String(window.location.hostname), //Location of privacy policy
			referrer: String(document.referrer) //Where visitor has come from
		};
		var options = $.extend(defaults,options);
		
		//Sets expiration date for cookie
		var expireDate = new Date();
		expireDate.setTime(expireDate.getTime()+(options.expireDays*86400000));
		expireDate = expireDate.toGMTString();
		
		var cookieEntry = 'cb-enabled={value}; expires='+expireDate+'; path=/';
		
		//Retrieves current cookie preference
		var i,cookieValue='',aCookie,aCookies=document.cookie.split('; ');
		for (i=0;i<aCookies.length;i++){
			aCookie = aCookies[i].split('=');
			if(aCookie[0]=='cb-enabled'){
    			cookieValue = aCookie[1];
			}
		}
		//Sets up default cookie preference if not already set
		if(cookieValue=='' && doReturn!='cookies' && options.autoEnable){
			cookieValue = 'enabled';
			document.cookie = cookieEntry.replace('{value}','enabled');
		}else if((cookieValue=='accepted' || cookieValue=='declined') && doReturn!='cookies' && options.renewOnVisit){
			document.cookie = cookieEntry.replace('{value}',cookieValue);
		}
		if(options.acceptOnContinue){
			if(options.referrer.indexOf(options.domain)>=0 && String(window.location.href).indexOf(options.policyURL)==-1 && doReturn!='cookies' && doReturn!='set' && cookieValue!='accepted' && cookieValue!='declined'){
				doReturn = 'set';
				val = 'accepted';
			}
		}
		if(doReturn=='cookies'){
			//Returns true if cookies are enabled, false otherwise
			if(cookieValue=='enabled' || cookieValue=='accepted'){
				return true;
			}else{
				return false;
			}
		}else if(doReturn=='set' && (val=='accepted' || val=='declined')){
			//Sets value of cookie to 'accepted' or 'declined'
			document.cookie = cookieEntry.replace('{value}',val);
			if(val=='accepted'){
				return true;
			}else{
				return false;
			}
		}else{
			//Sets up enable/accept button if required
			var message = options.message.replace('{policy_url}',options.policyURL);
			
			if(options.acceptButton){
                //Changed for WCAG - Miguel Castro
                var acceptButton = '<bt tabindex="0" class="cb-enable">'+options.acceptText+'</bt>';
                // var acceptButton = '<bt href="#" class="cb-enable">'+options.acceptText+'</bt>';
			}else{
				var acceptButton = '';
			}
			//Sets up disable/decline button if required
			if(options.declineButton){
				var declineButton = '<bt href="#" class="cb-disable">'+options.declineText+'</bt>';
			}else{
				var declineButton = '';
			}
			//Sets up privacy policy button if required
			if(options.policyButton){
				var policyButton = '<bt href="'+options.policyURL+'" class="cb-policy">'+options.policyText+'</bt>';
			}else{
				var policyButton = '';
			}
			//Whether to add "fixed" class to cookie bar
			if(options.fixed){
				if(options.bottom){
					var fixed = ' class="fixed bottom"';
				}else{
					var fixed = ' class="fixed"';
				}
			}else{
				var fixed = '';
			}
			if(options.zindex!=''){
				var zindex = ' style="z-index:'+options.zindex+';"';
			}else{
				var zindex = '';
			}
			
			//Displays the cookie bar if arguments met
			if(options.forceShow || cookieValue=='enabled' || cookieValue==''){
				if(options.append){
					$(options.element).append('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}else{
					$(options.element).prepend('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}
			}
			
			var removeBar = function(func){
				if(options.acceptOnScroll) $(document).off('scroll');
				if(typeof(func)==='function') func(cookieValue);
				if(options.effect=='slide'){
					$('#cookie-bar').slideUp(300,function(){$('#cookie-bar').remove();});
				}else if(options.effect=='fade'){
					$('#cookie-bar').fadeOut(300,function(){$('#cookie-bar').remove();});
				}else{
					$('#cookie-bar').hide(0,function(){$('#cookie-bar').remove();});
				}
				$(document).unbind('click',anyClick);
			};
			var cookieAccept = function(){
				document.cookie = cookieEntry.replace('{value}','accepted');
				removeBar(options.acceptFunction);
			};
			var cookieDecline = function(){
				var deleteDate = new Date();
				deleteDate.setTime(deleteDate.getTime()-(864000000));
				deleteDate = deleteDate.toGMTString();
				aCookies=document.cookie.split('; ');
				for (i=0;i<aCookies.length;i++){
					aCookie = aCookies[i].split('=');
					if(aCookie[0].indexOf('_')>=0){
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; domain='+options.domain.replace('www','')+'; path=/';
					}else{
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; path=/';
					}
				}
				document.cookie = cookieEntry.replace('{value}','declined');
				removeBar(options.declineFunction);
			};
			var anyClick = function(e){
				if(!$(e.target).hasClass('cb-policy')) cookieAccept();
			};
			
			$('#cookie-bar .cb-enable').click(function(){cookieAccept();return false;});
			$('#cookie-bar .cb-disable').click(function(){cookieDecline();return false;});
			if(options.acceptOnScroll){
				var scrollStart = $(document).scrollTop(),scrollNew,scrollDiff;
				$(document).on('scroll',function(){
					scrollNew = $(document).scrollTop();
					if(scrollNew>scrollStart){
						scrollDiff = scrollNew - scrollStart;
					}else{
						scrollDiff = scrollStart - scrollNew;
					}
					if(scrollDiff>=Math.round(options.acceptOnScroll)) cookieAccept();
				});
			}
			if(options.acceptAnyClick){
				$(document).bind('click',anyClick);
			}
		}
	};
})(jQuery);
(function(){var t,e,n,r,a,o,i,l,u,s,c,h,p,g,v,f,d,m,y,C,T,w,$,D,S=[].slice,k=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=window.jQuery||window.Zepto||window.$,t.payment={},t.payment.fn={},t.fn.payment=function(){var e,n;return n=arguments[0],e=2<=arguments.length?S.call(arguments,1):[],t.payment.fn[n].apply(this,e)},a=/(\d{1,4})/g,t.payment.cards=r=[{type:"maestro",patterns:[5018,502,503,506,56,58,639,6220,67],format:a,length:[12,13,14,15,16,17,18,19],cvcLength:[3],luhn:!0},{type:"forbrugsforeningen",patterns:[600],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"dankort",patterns:[5019],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"visa",patterns:[4],format:a,length:[13,16],cvcLength:[3],luhn:!0},{type:"mastercard",patterns:[51,52,53,54,55,22,23,24,25,26,27],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"amex",patterns:[34,37],format:/(\d{1,4})(\d{1,6})?(\d{1,5})?/,length:[15],cvcLength:[3,4],luhn:!0},{type:"dinersclub",patterns:[30,36,38,39],format:/(\d{1,4})(\d{1,6})?(\d{1,4})?/,length:[14],cvcLength:[3],luhn:!0},{type:"discover",patterns:[60,64,65,622],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"unionpay",patterns:[62,88],format:a,length:[16,17,18,19],cvcLength:[3],luhn:!1},{type:"jcb",patterns:[35],format:a,length:[16],cvcLength:[3],luhn:!0}],e=function(t){var e,n,a,o,i,l,u,s;for(t=(t+"").replace(/\D/g,""),o=0,l=r.length;l>o;o++)for(e=r[o],s=e.patterns,i=0,u=s.length;u>i;i++)if(a=s[i],n=a+"",t.substr(0,n.length)===n)return e},n=function(t){var e,n,a;for(n=0,a=r.length;a>n;n++)if(e=r[n],e.type===t)return e},p=function(t){var e,n,r,a,o,i;for(r=!0,a=0,n=(t+"").split("").reverse(),o=0,i=n.length;i>o;o++)e=n[o],e=parseInt(e,10),(r=!r)&&(e*=2),e>9&&(e-=9),a+=e;return a%10===0},h=function(t){var e;return null!=t.prop("selectionStart")&&t.prop("selectionStart")!==t.prop("selectionEnd")?!0:null!=("undefined"!=typeof document&&null!==document&&null!=(e=document.selection)?e.createRange:void 0)&&document.selection.createRange().text?!0:!1},$=function(t,e){var n,r,a,o,i,l;try{r=e.prop("selectionStart")}catch(u){o=u,r=null}return i=e.val(),e.val(t),null!==r&&e.is(":focus")?(r===i.length&&(r=t.length),i!==t&&(l=i.slice(r-1,+r+1||9e9),n=t.slice(r-1,+r+1||9e9),a=t[r],/\d/.test(a)&&l===""+a+" "&&n===" "+a&&(r+=1)),e.prop("selectionStart",r),e.prop("selectionEnd",r)):void 0},m=function(t){var e,n,r,a,o,i,l,u;for(null==t&&(t=""),r="０１２３４５６７８９",a="0123456789",i="",e=t.split(""),l=0,u=e.length;u>l;l++)n=e[l],o=r.indexOf(n),o>-1&&(n=a[o]),i+=n;return i},d=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var t;return t=n.val(),t=m(t),t=t.replace(/\D/g,""),$(t,n)})},v=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var e;return e=n.val(),e=m(e),e=t.payment.formatCardNumber(e),$(e,n)})},l=function(n){var r,a,o,i,l,u,s;return o=String.fromCharCode(n.which),!/^\d+$/.test(o)||(r=t(n.currentTarget),s=r.val(),a=e(s+o),i=(s.replace(/\D/g,"")+o).length,u=16,a&&(u=a.length[a.length.length-1]),i>=u||null!=r.prop("selectionStart")&&r.prop("selectionStart")!==s.length)?void 0:(l=a&&"amex"===a.type?/^(\d{4}|\d{4}\s\d{6})$/:/(?:^|\s)(\d{4})$/,l.test(s)?(n.preventDefault(),setTimeout(function(){return r.val(s+" "+o)})):l.test(s+o)?(n.preventDefault(),setTimeout(function(){return r.val(s+o+" ")})):void 0)},o=function(e){var n,r;return n=t(e.currentTarget),r=n.val(),8!==e.which||null!=n.prop("selectionStart")&&n.prop("selectionStart")!==r.length?void 0:/\d\s$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d\s$/,""))})):/\s\d?$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d$/,""))})):void 0},f=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var e;return e=n.val(),e=m(e),e=t.payment.formatExpiry(e),$(e,n)})},u=function(e){var n,r,a;return r=String.fromCharCode(e.which),/^\d+$/.test(r)?(n=t(e.currentTarget),a=n.val()+r,/^\d$/.test(a)&&"0"!==a&&"1"!==a?(e.preventDefault(),setTimeout(function(){return n.val("0"+a+" / ")})):/^\d\d$/.test(a)?(e.preventDefault(),setTimeout(function(){var t,e;return t=parseInt(a[0],10),e=parseInt(a[1],10),e>2&&0!==t?n.val("0"+t+" / "+e):n.val(""+a+" / ")})):void 0):void 0},s=function(e){var n,r,a;return r=String.fromCharCode(e.which),/^\d+$/.test(r)?(n=t(e.currentTarget),a=n.val(),/^\d\d$/.test(a)?n.val(""+a+" / "):void 0):void 0},c=function(e){var n,r,a;return a=String.fromCharCode(e.which),"/"===a||" "===a?(n=t(e.currentTarget),r=n.val(),/^\d$/.test(r)&&"0"!==r?n.val("0"+r+" / "):void 0):void 0},i=function(e){var n,r;return n=t(e.currentTarget),r=n.val(),8!==e.which||null!=n.prop("selectionStart")&&n.prop("selectionStart")!==r.length?void 0:/\d\s\/\s$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d\s\/\s$/,""))})):void 0},g=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var t;return t=n.val(),t=m(t),t=t.replace(/\D/g,"").slice(0,4),$(t,n)})},w=function(t){var e;return t.metaKey||t.ctrlKey?!0:32===t.which?!1:0===t.which?!0:t.which<33?!0:(e=String.fromCharCode(t.which),!!/[\d\s]/.test(e))},C=function(n){var r,a,o,i;return r=t(n.currentTarget),o=String.fromCharCode(n.which),/^\d+$/.test(o)&&!h(r)?(i=(r.val()+o).replace(/\D/g,""),a=e(i),a?i.length<=a.length[a.length.length-1]:i.length<=16):void 0},T=function(e){var n,r,a;return n=t(e.currentTarget),r=String.fromCharCode(e.which),/^\d+$/.test(r)&&!h(n)?(a=n.val()+r,a=a.replace(/\D/g,""),a.length>6?!1:void 0):void 0},y=function(e){var n,r,a;return n=t(e.currentTarget),r=String.fromCharCode(e.which),/^\d+$/.test(r)&&!h(n)?(a=n.val()+r,a.length<=4):void 0},D=function(e){var n,a,o,i,l;return n=t(e.currentTarget),l=n.val(),i=t.payment.cardType(l)||"unknown",n.hasClass(i)?void 0:(a=function(){var t,e,n;for(n=[],t=0,e=r.length;e>t;t++)o=r[t],n.push(o.type);return n}(),n.removeClass("unknown"),n.removeClass(a.join(" ")),n.addClass(i),n.toggleClass("identified","unknown"!==i),n.trigger("payment.cardType",i))},t.payment.fn.formatCardCVC=function(){return this.on("keypress",w),this.on("keypress",y),this.on("paste",g),this.on("change",g),this.on("input",g),this},t.payment.fn.formatCardExpiry=function(){return this.on("keypress",w),this.on("keypress",T),this.on("keypress",u),this.on("keypress",c),this.on("keypress",s),this.on("keydown",i),this.on("change",f),this.on("input",f),this},t.payment.fn.formatCardNumber=function(){return this.on("keypress",w),this.on("keypress",C),this.on("keypress",l),this.on("keydown",o),this.on("keyup",D),this.on("paste",v),this.on("change",v),this.on("input",v),this.on("input",D),this},t.payment.fn.restrictNumeric=function(){return this.on("keypress",w),this.on("paste",d),this.on("change",d),this.on("input",d),this},t.payment.fn.cardExpiryVal=function(){return t.payment.cardExpiryVal(t(this).val())},t.payment.cardExpiryVal=function(t){var e,n,r,a;return a=t.split(/[\s\/]+/,2),e=a[0],r=a[1],2===(null!=r?r.length:void 0)&&/^\d+$/.test(r)&&(n=(new Date).getFullYear(),n=n.toString().slice(0,2),r=n+r),e=parseInt(e,10),r=parseInt(r,10),{month:e,year:r}},t.payment.validateCardNumber=function(t){var n,r;return t=(t+"").replace(/\s+|-/g,""),/^\d+$/.test(t)?(n=e(t),n?(r=t.length,k.call(n.length,r)>=0&&(n.luhn===!1||p(t))):!1):!1},t.payment.validateCardExpiry=function(e,n){var r,a,o;return"object"==typeof e&&"month"in e&&(o=e,e=o.month,n=o.year),e&&n?(e=t.trim(e),n=t.trim(n),/^\d+$/.test(e)&&/^\d+$/.test(n)&&e>=1&&12>=e?(2===n.length&&(n=70>n?"20"+n:"19"+n),4!==n.length?!1:(a=new Date(n,e),r=new Date,a.setMonth(a.getMonth()-1),a.setMonth(a.getMonth()+1,1),a>r)):!1):!1},t.payment.validateCardCVC=function(e,r){var a,o;return e=t.trim(e),/^\d+$/.test(e)?(a=n(r),null!=a?(o=e.length,k.call(a.cvcLength,o)>=0):e.length>=3&&e.length<=4):!1},t.payment.cardType=function(t){var n;return t?(null!=(n=e(t))?n.type:void 0)||null:null},t.payment.formatCardNumber=function(n){var r,a,o,i;return n=n.replace(/\D/g,""),(r=e(n))?(o=r.length[r.length.length-1],n=n.slice(0,o),r.format.global?null!=(i=n.match(r.format))?i.join(" "):void 0:(a=r.format.exec(n),null!=a?(a.shift(),a=t.grep(a,function(t){return t}),a.join(" ")):void 0)):n},t.payment.formatExpiry=function(t){var e,n,r,a;return(n=t.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/))?(e=n[1]||"",r=n[2]||"",a=n[3]||"",a.length>0?r=" / ":" /"===r?(e=e.substring(0,1),r=""):2===e.length||r.length>0?r=" / ":1===e.length&&"0"!==e&&"1"!==e&&(e="0"+e,r=" / "),e+r+a):""}}).call(this);
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
!function(a,b){"function"==typeof define&&define.amd?define(b):"object"==typeof module&&module.exports?module.exports=b():a.numeral=b()}(this,function(){function a(a,b){this._input=a,this._value=b}var b,c,d="2.0.6",e={},f={},g={currentLocale:"en",zeroFormat:null,nullFormat:null,defaultFormat:"0,0",scalePercentBy100:!0},h={currentLocale:g.currentLocale,zeroFormat:g.zeroFormat,nullFormat:g.nullFormat,defaultFormat:g.defaultFormat,scalePercentBy100:g.scalePercentBy100};return b=function(d){var f,g,i,j;if(b.isNumeral(d))f=d.value();else if(0===d||"undefined"==typeof d)f=0;else if(null===d||c.isNaN(d))f=null;else if("string"==typeof d)if(h.zeroFormat&&d===h.zeroFormat)f=0;else if(h.nullFormat&&d===h.nullFormat||!d.replace(/[^0-9]+/g,"").length)f=null;else{for(g in e)if(j="function"==typeof e[g].regexps.unformat?e[g].regexps.unformat():e[g].regexps.unformat,j&&d.match(j)){i=e[g].unformat;break}i=i||b._.stringToNumber,f=i(d)}else f=Number(d)||null;return new a(d,f)},b.version=d,b.isNumeral=function(b){return b instanceof a},b._=c={numberToFormat:function(a,c,d){var e,g,h,i,j,k,l,m=f[b.options.currentLocale],n=!1,o=!1,p=0,q="",r=1e12,s=1e9,t=1e6,u=1e3,v="",w=!1;if(a=a||0,g=Math.abs(a),b._.includes(c,"(")?(n=!0,c=c.replace(/[\(|\)]/g,"")):(b._.includes(c,"+")||b._.includes(c,"-"))&&(j=b._.includes(c,"+")?c.indexOf("+"):0>a?c.indexOf("-"):-1,c=c.replace(/[\+|\-]/g,"")),b._.includes(c,"a")&&(e=c.match(/a(k|m|b|t)?/),e=e?e[1]:!1,b._.includes(c," a")&&(q=" "),c=c.replace(new RegExp(q+"a[kmbt]?"),""),g>=r&&!e||"t"===e?(q+=m.abbreviations.trillion,a/=r):r>g&&g>=s&&!e||"b"===e?(q+=m.abbreviations.billion,a/=s):s>g&&g>=t&&!e||"m"===e?(q+=m.abbreviations.million,a/=t):(t>g&&g>=u&&!e||"k"===e)&&(q+=m.abbreviations.thousand,a/=u)),b._.includes(c,"[.]")&&(o=!0,c=c.replace("[.]",".")),h=a.toString().split(".")[0],i=c.split(".")[1],k=c.indexOf(","),p=(c.split(".")[0].split(",")[0].match(/0/g)||[]).length,i?(b._.includes(i,"[")?(i=i.replace("]",""),i=i.split("["),v=b._.toFixed(a,i[0].length+i[1].length,d,i[1].length)):v=b._.toFixed(a,i.length,d),h=v.split(".")[0],v=b._.includes(v,".")?m.delimiters.decimal+v.split(".")[1]:"",o&&0===Number(v.slice(1))&&(v="")):h=b._.toFixed(a,0,d),q&&!e&&Number(h)>=1e3&&q!==m.abbreviations.trillion)switch(h=String(Number(h)/1e3),q){case m.abbreviations.thousand:q=m.abbreviations.million;break;case m.abbreviations.million:q=m.abbreviations.billion;break;case m.abbreviations.billion:q=m.abbreviations.trillion}if(b._.includes(h,"-")&&(h=h.slice(1),w=!0),h.length<p)for(var x=p-h.length;x>0;x--)h="0"+h;return k>-1&&(h=h.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+m.delimiters.thousands)),0===c.indexOf(".")&&(h=""),l=h+v+(q?q:""),n?l=(n&&w?"(":"")+l+(n&&w?")":""):j>=0?l=0===j?(w?"-":"+")+l:l+(w?"-":"+"):w&&(l="-"+l),l},stringToNumber:function(a){var b,c,d,e=f[h.currentLocale],g=a,i={thousand:3,million:6,billion:9,trillion:12};if(h.zeroFormat&&a===h.zeroFormat)c=0;else if(h.nullFormat&&a===h.nullFormat||!a.replace(/[^0-9]+/g,"").length)c=null;else{c=1,"."!==e.delimiters.decimal&&(a=a.replace(/\./g,"").replace(e.delimiters.decimal,"."));for(b in i)if(d=new RegExp("[^a-zA-Z]"+e.abbreviations[b]+"(?:\\)|(\\"+e.currency.symbol+")?(?:\\))?)?$"),g.match(d)){c*=Math.pow(10,i[b]);break}c*=(a.split("-").length+Math.min(a.split("(").length-1,a.split(")").length-1))%2?1:-1,a=a.replace(/[^0-9\.]+/g,""),c*=Number(a)}return c},isNaN:function(a){return"number"==typeof a&&isNaN(a)},includes:function(a,b){return-1!==a.indexOf(b)},insert:function(a,b,c){return a.slice(0,c)+b+a.slice(c)},reduce:function(a,b){if(null===this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof b)throw new TypeError(b+" is not a function");var c,d=Object(a),e=d.length>>>0,f=0;if(3===arguments.length)c=arguments[2];else{for(;e>f&&!(f in d);)f++;if(f>=e)throw new TypeError("Reduce of empty array with no initial value");c=d[f++]}for(;e>f;f++)f in d&&(c=b(c,d[f],f,d));return c},multiplier:function(a){var b=a.toString().split(".");return b.length<2?1:Math.pow(10,b[1].length)},correctionFactor:function(){var a=Array.prototype.slice.call(arguments);return a.reduce(function(a,b){var d=c.multiplier(b);return a>d?a:d},1)},toFixed:function(a,b,c,d){var e,f,g,h,i=a.toString().split("."),j=b-(d||0);return e=2===i.length?Math.min(Math.max(i[1].length,j),b):j,g=Math.pow(10,e),h=(c(a+"e+"+e)/g).toFixed(e),d>b-e&&(f=new RegExp("\\.?0{1,"+(d-(b-e))+"}$"),h=h.replace(f,"")),h}},b.options=h,b.formats=e,b.locales=f,b.locale=function(a){return a&&(h.currentLocale=a.toLowerCase()),h.currentLocale},b.localeData=function(a){if(!a)return f[h.currentLocale];if(a=a.toLowerCase(),!f[a])throw new Error("Unknown locale : "+a);return f[a]},b.reset=function(){for(var a in g)h[a]=g[a]},b.zeroFormat=function(a){h.zeroFormat="string"==typeof a?a:null},b.nullFormat=function(a){h.nullFormat="string"==typeof a?a:null},b.defaultFormat=function(a){h.defaultFormat="string"==typeof a?a:"0.0"},b.register=function(a,b,c){if(b=b.toLowerCase(),this[a+"s"][b])throw new TypeError(b+" "+a+" already registered.");return this[a+"s"][b]=c,c},b.validate=function(a,c){var d,e,f,g,h,i,j,k;if("string"!=typeof a&&(a+="",console.warn&&console.warn("Numeral.js: Value is not string. It has been co-erced to: ",a)),a=a.trim(),a.match(/^\d+$/))return!0;if(""===a)return!1;try{j=b.localeData(c)}catch(l){j=b.localeData(b.locale())}return f=j.currency.symbol,h=j.abbreviations,d=j.delimiters.decimal,e="."===j.delimiters.thousands?"\\.":j.delimiters.thousands,k=a.match(/^[^\d]+/),null!==k&&(a=a.substr(1),k[0]!==f)?!1:(k=a.match(/[^\d]+$/),null!==k&&(a=a.slice(0,-1),k[0]!==h.thousand&&k[0]!==h.million&&k[0]!==h.billion&&k[0]!==h.trillion)?!1:(i=new RegExp(e+"{2}"),a.match(/[^\d.,]/g)?!1:(g=a.split(d),g.length>2?!1:g.length<2?!!g[0].match(/^\d+.*\d$/)&&!g[0].match(i):1===g[0].length?!!g[0].match(/^\d+$/)&&!g[0].match(i)&&!!g[1].match(/^\d+$/):!!g[0].match(/^\d+.*\d$/)&&!g[0].match(i)&&!!g[1].match(/^\d+$/))))},b.fn=a.prototype={clone:function(){return b(this)},format:function(a,c){var d,f,g,i=this._value,j=a||h.defaultFormat;if(c=c||Math.round,0===i&&null!==h.zeroFormat)f=h.zeroFormat;else if(null===i&&null!==h.nullFormat)f=h.nullFormat;else{for(d in e)if(j.match(e[d].regexps.format)){g=e[d].format;break}g=g||b._.numberToFormat,f=g(i,j,c)}return f},value:function(){return this._value},input:function(){return this._input},set:function(a){return this._value=Number(a),this},add:function(a){function b(a,b,c,e){return a+Math.round(d*b)}var d=c.correctionFactor.call(null,this._value,a);return this._value=c.reduce([this._value,a],b,0)/d,this},subtract:function(a){function b(a,b,c,e){return a-Math.round(d*b)}var d=c.correctionFactor.call(null,this._value,a);return this._value=c.reduce([a],b,Math.round(this._value*d))/d,this},multiply:function(a){function b(a,b,d,e){var f=c.correctionFactor(a,b);return Math.round(a*f)*Math.round(b*f)/Math.round(f*f)}return this._value=c.reduce([this._value,a],b,1),this},divide:function(a){function b(a,b,d,e){var f=c.correctionFactor(a,b);return Math.round(a*f)/Math.round(b*f)}return this._value=c.reduce([this._value,a],b),this},difference:function(a){return Math.abs(b(this._value).subtract(a).value())}},b.register("locale","en",{delimiters:{thousands:",",decimal:"."},abbreviations:{thousand:"k",million:"m",billion:"b",trillion:"t"},ordinal:function(a){var b=a%10;return 1===~~(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th"},currency:{symbol:"$"}}),function(){b.register("format","bps",{regexps:{format:/(BPS)/,unformat:/(BPS)/},format:function(a,c,d){var e,f=b._.includes(c," BPS")?" ":"";return a=1e4*a,c=c.replace(/\s?BPS/,""),e=b._.numberToFormat(a,c,d),b._.includes(e,")")?(e=e.split(""),e.splice(-1,0,f+"BPS"),e=e.join("")):e=e+f+"BPS",e},unformat:function(a){return+(1e-4*b._.stringToNumber(a)).toFixed(15)}})}(),function(){var a={base:1e3,suffixes:["B","KB","MB","GB","TB","PB","EB","ZB","YB"]},c={base:1024,suffixes:["B","KiB","MiB","GiB","TiB","PiB","EiB","ZiB","YiB"]},d=a.suffixes.concat(c.suffixes.filter(function(b){return a.suffixes.indexOf(b)<0})),e=d.join("|");e="("+e.replace("B","B(?!PS)")+")",b.register("format","bytes",{regexps:{format:/([0\s]i?b)/,unformat:new RegExp(e)},format:function(d,e,f){var g,h,i,j,k=b._.includes(e,"ib")?c:a,l=b._.includes(e," b")||b._.includes(e," ib")?" ":"";for(e=e.replace(/\s?i?b/,""),h=0;h<=k.suffixes.length;h++)if(i=Math.pow(k.base,h),j=Math.pow(k.base,h+1),null===d||0===d||d>=i&&j>d){l+=k.suffixes[h],i>0&&(d/=i);break}return g=b._.numberToFormat(d,e,f),g+l},unformat:function(d){var e,f,g=b._.stringToNumber(d);if(g){for(e=a.suffixes.length-1;e>=0;e--){if(b._.includes(d,a.suffixes[e])){f=Math.pow(a.base,e);break}if(b._.includes(d,c.suffixes[e])){f=Math.pow(c.base,e);break}}g*=f||1}return g}})}(),function(){b.register("format","currency",{regexps:{format:/(\$)/},format:function(a,c,d){var e,f,g,h=b.locales[b.options.currentLocale],i={before:c.match(/^([\+|\-|\(|\s|\$]*)/)[0],after:c.match(/([\+|\-|\)|\s|\$]*)$/)[0]};for(c=c.replace(/\s?\$\s?/,""),e=b._.numberToFormat(a,c,d),a>=0?(i.before=i.before.replace(/[\-\(]/,""),i.after=i.after.replace(/[\-\)]/,"")):0>a&&!b._.includes(i.before,"-")&&!b._.includes(i.before,"(")&&(i.before="-"+i.before),g=0;g<i.before.length;g++)switch(f=i.before[g]){case"$":e=b._.insert(e,h.currency.symbol,g);break;case" ":e=b._.insert(e," ",g+h.currency.symbol.length-1)}for(g=i.after.length-1;g>=0;g--)switch(f=i.after[g]){case"$":e=g===i.after.length-1?e+h.currency.symbol:b._.insert(e,h.currency.symbol,-(i.after.length-(1+g)));break;case" ":e=g===i.after.length-1?e+" ":b._.insert(e," ",-(i.after.length-(1+g)+h.currency.symbol.length-1))}return e}})}(),function(){b.register("format","exponential",{regexps:{format:/(e\+|e-)/,unformat:/(e\+|e-)/},format:function(a,c,d){var e,f="number"!=typeof a||b._.isNaN(a)?"0e+0":a.toExponential(),g=f.split("e");return c=c.replace(/e[\+|\-]{1}0/,""),e=b._.numberToFormat(Number(g[0]),c,d),e+"e"+g[1]},unformat:function(a){function c(a,c,d,e){var f=b._.correctionFactor(a,c),g=a*f*(c*f)/(f*f);return g}var d=b._.includes(a,"e+")?a.split("e+"):a.split("e-"),e=Number(d[0]),f=Number(d[1]);return f=b._.includes(a,"e-")?f*=-1:f,b._.reduce([e,Math.pow(10,f)],c,1)}})}(),function(){b.register("format","ordinal",{regexps:{format:/(o)/},format:function(a,c,d){var e,f=b.locales[b.options.currentLocale],g=b._.includes(c," o")?" ":"";return c=c.replace(/\s?o/,""),g+=f.ordinal(a),e=b._.numberToFormat(a,c,d),e+g}})}(),function(){b.register("format","percentage",{regexps:{format:/(%)/,unformat:/(%)/},format:function(a,c,d){var e,f=b._.includes(c," %")?" ":"";return b.options.scalePercentBy100&&(a=100*a),c=c.replace(/\s?\%/,""),e=b._.numberToFormat(a,c,d),b._.includes(e,")")?(e=e.split(""),e.splice(-1,0,f+"%"),e=e.join("")):e=e+f+"%",e},unformat:function(a){var c=b._.stringToNumber(a);return b.options.scalePercentBy100?.01*c:c}})}(),function(){b.register("format","time",{regexps:{format:/(:)/,unformat:/(:)/},format:function(a,b,c){var d=Math.floor(a/60/60),e=Math.floor((a-60*d*60)/60),f=Math.round(a-60*d*60-60*e);return d+":"+(10>e?"0"+e:e)+":"+(10>f?"0"+f:f)},unformat:function(a){var b=a.split(":"),c=0;return 3===b.length?(c+=60*Number(b[0])*60,c+=60*Number(b[1]),c+=Number(b[2])):2===b.length&&(c+=60*Number(b[0]),c+=Number(b[1])),Number(c)}})}(),b});
/********************************************************************
*-------------------------------------------------------------------
* Licensed Materials - Property of IBM
*
* WebSphere Commerce
*
* (c) Copyright IBM Corp. 2000, 2004
*
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*-------------------------------------------------------------------*/


function getNumericInfo(currencyCode, languageID) 
{
    curkey = "(" + currencyCode + "," + languageID + ")";
    for (i = 0; i < numericInfo["curGroup"].length; i++) {
        if (numericInfo["curGroup"][i]["curKey"].indexOf(curkey) >= 0)
            return numericInfo["curGroup"][i];
    }
    
    // if not found, return default object
    return numericInfo["default"]["currency"];
}    

function isValidCurrency(currency, currencyCode, languageID)
{
  var maxFrac;

  // scientific format is not allowed, for instance, 1e-09
  var currResult = new String(trim(currency));
  if (currResult.indexOf("e") >= 0)
      return false;

  var numResult = currencyToNumber(currency,currencyCode,languageID);
  
  if(numResult < 0)
      return false;

  currResult = new String(numResult);
  if (currResult == "NaN" || currResult.indexOf("e") >= 0)
      return false;

  ninfo = getNumericInfo(currencyCode, languageID) ;

  maxFrac  = ninfo["maxFrac"];

  if ( numberOfDecimalPlaces(numResult) > maxFrac)
  {
      return false;
  }    
  else
  {
      return true;
  }

  
}// END isValidCurrency

/****************************************************************************
* Format and validate a given currency value. If no locale is provided,
* en_US is used by default.
*
* currency - The currency value to be formatted and validated.
* locale   - The locale used to determine the currency.
*
* Returns the formatted currency if successful; string "NaN" if an invalid
* currency is provided or null if an unsupported locale value was provided.
****************************************************************************/
function formatCurrency(currency, currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var minFrac;
  var maxFrac;
  var groupingSize;
  
  if ( (currency == null) || (currency == "") )	   
	return ("NaN");

  var currencyString = new String(currency);
  if ( currencyString.indexOf("-") != -1 ) 
	return ("NaN");

  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  minFrac  = ninfo["minFrac"];
  maxFrac  = ninfo["maxFrac"];
  groupingSize = ninfo["groupingSize"];
  
  return(formatNum(currency, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END formatCurrency

/****************************************************************************
* Convert a properly formatted currency value to a primative numeric value.
* If no locale is provided, en_US is used by default.
*
* currency - The currency value to be formatted and validated.
* locale   - The locale used to determine the currency.
*
* Returns a primative numeric value if successfull; string "NaN" if the
* conversion has failed or null if an unsupported locale is provided.
****************************************************************************/
function currencyToNumber(currency,  currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;

  // If no locale is specified, use en_US as default
  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  groupingSize = ninfo["groupingSize"];
  
  return(toNum(currency, thouSep, decSep,groupingSize));
  
}// END currencyToNumber

/****************************************************************************
* Convert a primative numeric value to a particular currency. If no locale
* is provided, en_US is used by default.
*
* num    - The primative numeric value to be converted to a currency.
* locale - The locale used to determine the currency.
*
* Returns a correctly formatted currency; string "NaN" if the conversion
* failed or null if an unsupported locale was provided.
****************************************************************************/
function numberToCurrency(num, currencyCode, languageID)
{
  var thouSep;
  var decSep;
  var minFrac;
  var maxFrac;
  var groupingSize;
  
  ninfo = getNumericInfo(currencyCode, languageID) ;

  thouSep    = ninfo["thouSep"];
  decSep     = ninfo["decSep"];
  minFrac  = ninfo["minFrac"];
  maxFrac  = ninfo["maxFrac"];
  groupingSize = ninfo["groupingSize"];
  
  var buffer = numericToString(num,minFrac,decSep);
  
  return(formatNum(buffer, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END numberToCurrency

/****************************************************************************
* Convert a primative numeric value to a string value. If no locale
* is provided, en_US is used by default.
*
* num       - The primative numeric value to be converted.
* locale    - The locale used to determine the format.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns a correctly formatted number of type String; string "NaN" if the
* conversion failed or null if an unsupported locale was provided.
****************************************************************************/
function numberToStr(num, languageID, decPlaces)
{
  var thouSep;
  var decSep;
  var minFrac = decPlaces;
  var maxFrac = decPlaces;
  var groupingSize;

  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep    = numericInfo[languageID]["number"]["thouSep"];
      decSep     = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep    = numericInfo["default"]["number"]["thouSep"];
    decSep     = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  // make sure it is proper form 
  var buffer = numericToString(num,minFrac,decSep);
  
  return(formatNum(buffer, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END numberToStr

/****************************************************************************
* Convert a properly formatted string to a primative numeric value.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns a primative numeric value or null if an unsupported locale is
* provided.
****************************************************************************/
function strToNumber(num, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(toNum(num, thouSep, decSep,groupingSize));
  
}// END strToNumber

/****************************************************************************
* validate a given number.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
* allowNegativeNumber - if negative number is valid (default is FALSE if this parameter omitted)
*
* Return true or false depending on whether num is a valid number for the given language
****************************************************************************/
function isValidNumber(num, languageID, allowNegativeNumber)
{
  var res = strToNumber(num, languageID);

  if (allowNegativeNumber == null || allowNegativeNumber == undefined)
      allowNegativeNumber = false;

  if ( (new String(res)) == "NaN" || (!allowNegativeNumber && res < 0 ) )
  {
      return false;
  }
  else
  {
      return true;
  }
  
}// END isValidNumber


/****************************************************************************
* Format and validate a given number.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns the formatted number of type String if successfull; Nan if an
* invalid currency is provided or null if an unsupported locale value was
* provided.
****************************************************************************/
function formatNumber(num, languageID, decPlaces)
{
  var thouSep;
  var decSep;
  var minFrac = decPlaces;
  var maxFrac = decPlaces;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(formatNum(num, thouSep, decSep, minFrac, maxFrac,groupingSize));
  
}// END formatNumber

/****************************************************************************
* Format and validate a given integer.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns the formatted integer of type String if successfull; string "NaN"
* if an invalid integer is provided or null if an unsupported locale value
* was provided.
****************************************************************************/
function formatInteger(num, languageID)
{
  var thouSep;
  var groupingSize;

  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }

  return(formatInt(num, thouSep,groupingSize));
  
}// END formatInteger

/****************************************************************************
* Format and validate a given number
*
* num       - The number to be formatted and validated.
* thouSep   - The thousand separator to be used in validation and formatting.
* decSep    - The decimal separator to be used in validation and formatting.
* decPlaces - The number of decimal places for rounding purposes.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns the formatted number of type String or string "NaN" if an invalid
* currency value was provided.
****************************************************************************/
function formatNum(num, thouSep, decSep, minFrac, maxFrac,groupingSize)
{

  var segments;
  var leftSide;     // Value to the left of the decimal place
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number
  var result = "";  // Formatted number that is returned to the user
  var buffer = "";  // Buffer used to store temporary info

  // trim the space strip out the "+" and keep the "-" of the num

  var tempNum= new String(trim(num));
  var number = new Object;
  if(tempNum.charAt(0)=="+")
  	 number = tempNum.substring(1);    	
  else if (tempNum.charAt(0)=="-") {
  	 number = tempNum.substring(1);    	
	 result += "-";
  }
  else
  	 number = tempNum;
  
  if( (number == null) || (number == "") )
    return("NaN");

  segments = number.split(decSep);

  // Determine the values on the left and right side of the decimal place
  if( (decPos = number.indexOf(decSep)) == -1)
  {
    leftSide  = segments[0];
    rightSide = null;
  }
  else if(segments.length <= 2)
  {
    if(decPos > 0)
    {
      leftSide  = segments[0];
      rightSide = segments[1];
    }
    else
    {
      leftSide  = null;
      rightSide = segments[1];
    }
  }
  else
    return("NaN");
  
  // Validate the number on the left side of the decimal place
  if(leftSide == null)
    buffer = "0";
  else
  {
    var value;
    
    segments = leftSide.split(thouSep);
    value = segments[0];
    
    if(isNaN(Number(value)))
      return("NaN");
    
    if(segments.length == 1)
      buffer = value;
    else
    {
      if(value.length <= groupingSize)
        buffer = value;
      else
        return("NaN");
        
      for(var j=1; j<segments.length; j++)
      {
        value = segments[j];
        
        if( isNaN(Number(value)) || (value.length != groupingSize) )
          return("NaN");
          
        buffer += value;
      
      }// END for
    }// END else
  }// END else
  
  // Validate the number on the right side of the decimal place
  if(rightSide != null)
  {
    if(isNaN(Number(rightSide)))
      return("NaN");
  
// allow less that the minimum fraction digits and just format properly
//    if (rightSide.length < minFrac)
//      return ("NaN");
        
    buffer += "." + rightSide;
  }
  
  // if maxFrac is null do not round the fraction digits
  if ( maxFrac == null)
	buffer = new String( Number(buffer));
  else
  {
  	// Format validated number...
  	if (buffer == Number(buffer).toString()) {
  		buffer = round(Number(buffer), maxFrac);
  	}
  }

  if(isNaN(buffer))
    return("NaN");

  segments = buffer.split(".");
  leftSide = segments[0];
  
    
  var offset;
  
  buffer = leftSide.length % groupingSize;
  
  if(buffer == 0)
    offset = groupingSize;
  else
    offset = buffer;
  
  result += leftSide.substring(0, offset);
  
  for(var k=offset; k<leftSide.length; k += groupingSize)
  {
    result += thouSep + leftSide.substring(k, k+groupingSize);
  }// END for
  
  if(maxFrac != null)
  {
    	rightSide = segments[1];

  	if(maxFrac > 0 && rightSide != null)
    	result += decSep + rightSide.substring(0, maxFrac);
  }
  else
  {
	if (segments.length == 2)
		result += decSep + rightSide;
  }
  
  return(result);
}// END formatNum

/****************************************************************************
* Format and validate a given integer
*
* num       - The number to be formatted and validated.
* thouSep   - The thousand separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns the formatted number of type String or string "NaN" if an invalid
* integer value was provided.
****************************************************************************/
function formatInt(num, thouSep, groupingSize)
{
  var number = new String(trim(num));
  var segments;
  var leftSide;     // Value to the left of the decimal place
  var result = "";  // Formatted number that is returned to the user
  var buffer = "";  // Buffer used to store temporary info
  
  // Validate the number on the left side of the decimal place
  if( (number == null) || (number == "") )
    return("NaN");
  else
  {
    var value;
    
    segments = number.split(thouSep);
    value = segments[0];

    if(isNaN(Number(value)))
      return("NaN");
    
    if(segments.length == 1)
      buffer = value;
    else
    {
      if(value.length <= groupingSize)
        buffer = value;
      else
        return("NaN");
        
      for(var j=1; j<segments.length; j++)
      {
        value = segments[j];
        
        if( isNaN(Number(value)) || (value.length != groupingSize) )
          return("NaN");
          
        buffer += value;
      
      }// END for
    }// END else
  }// END else
  
  for(var i=0; i<buffer.length; i++)
  {
    var ch = Number(buffer.charAt(i));
    
    if(isNaN(ch))
      return("NaN");
  }

  var offset;
  
  number = buffer;
  
  if((number.length % groupingSize) == 0)
    offset = groupingSize;
  else
    offset = number.length % groupingSize;
  
  result = number.substring(0, offset);
  
  for(var k=offset; k<number.length; k += groupingSize)
  {
    result += thouSep + number.substring(k, k+groupingSize);
  }// END for
  
  return(result);
}// END formatInt

/****************************************************************************
* Convert a number to a primitive numeric value
*
* num          - The number to be formatted and validated.
* thouSep      - The thousand separator to be used in validation and formatting.
* decSep       - The decimal separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns a primitive numeric value; string "NaN" if the conversion failed.
****************************************************************************/
function toNum(num, thouSep, decSep, groupingSize)
{
  var currChar;
  var buffer = "";
  var number = new String(trim(num));
  var thouHit = false;
  var decHit = false;
  var groupCount = 0;

  if( (number == null) || (number == "") )
    return("NaN");

  for(var i=0; i < number.length; i++)
  {
    currChar = number.charAt(i);
    groupCount++;

  if ( (( currChar == ' ')  && ((thouSep.charCodeAt(0) == 160) && thouSep.length == 1)) || (currChar == thouSep)  )  
  {
      if (decHit == true)
      {
          return("NaN");
      }
      if (thouHit == true)
      {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }
      }
      thouHit = true;
      groupCount = 0;
      continue;
    }
    else if(currChar == decSep)
    {   
        decHit = true;

        if (thouHit == true)
        {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }            
        }
        groupCount = 0;
        buffer += ".";
    }
     
    // Even if the decimal point is not '.' the javascript function Number() accepts '.'
    // We need the following check to prevent this
    else if ( currChar == '.')  
	return("NaN");
    else
      buffer += currChar;
  }// END for

  if (decHit == false && thouHit == true && groupCount != groupingSize)
  {
    return("NaN");
  }
  
  return(Number(buffer));
  
}// END toNum

/****************************************************************************
* Round off a primitive numeric to the given decimal places
*
* num - The number to be rounded.
* decPlaces - The number of decimal places for rounding purposes.
*
* Returns the rounder number as a String object; string "NaN" if "num" is not
* a valid number.
****************************************************************************/
function round(num, decPlaces)
{
  var decSep = ".";  // Decimal separator
  var buff;          // Buffer used to determine rounded number
  var i;             // Location of the decimal place
  
  var descrep;
  var segments;
  var leftSide;
  var rightSide;
  
  num = Number(num);

  if(isNaN(num))
    return("NaN");

  buffer = "" + Math.round(num * Math.pow(10, decPlaces)) / Math.pow(10,
                                                                   decPlaces);
  
  // Damn!! Math.round does not work correctly; so, we must double check
  // the formatting...
  i = buffer.indexOf(decSep);
  segments = buffer.split(".");

  if(i == 0)
    buffer = "0" + buffer;
  
  if(segments.length == 2)  
    descrep = decPlaces - segments[1].length;
  else
  {
    descrep = decPlaces;
    
    if(descrep > 0)
      buffer += decSep;
  }
  
  for(var j=0; j<descrep; j++)
    buffer += "0";
      
  return(buffer);
}// END round

/****************************************************************************
* Convert a primitive number into a language specific string by
* adding zeros and converting the decimal separator into the language specific
* separator
*
* This is necessary because when you convert a numeric to a string it removes the zeroes
*
* num - A primitive number
* decPlaces - The number of decimal places for rounding purposes.
* decSep - The decimal separator to replace
*
****************************************************************************/
function numericToString(num, decPlaces,decSep)
{
  var number = new String(num);
  var segments = number.split(".");
  var leftSide;     // Value to the left of the decimal place
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number
  var buffer;

  if( (number == null) || (number == "") || isNaN(Number(num)))
  {
    return("NaN");
  }

  // Replace the decimal separator with the currency-specific decimal
  // separator (there isn't a thousand separator since the number was primitive numeric)
  if( (decPos = number.indexOf(".")) == -1)
  {
    leftSide  = segments[0];
    rightSide = "";
  }
  else if(segments.length <= 2)
  {
    if(decPos > 0)
    {
      leftSide  = segments[0];
      rightSide = segments[1];
    }
    else
    {
      leftSide  = "0";
      rightSide = segments[1];
    }
  }
  else
  {
    return("NaN");
  }


  // And add zeros to end of string as required for number
  while (rightSide.length < decPlaces)
  {
    rightSide += "0";
  }

  buffer = leftSide + decSep + rightSide;

  return buffer;
}

/****************************************************************************
* Return the number of decimal places after the decimal separator
*
* This is necessary because when you convert a numeric to a string it removes the zeroes
*
* num - A primitive number
*
****************************************************************************/
function numberOfDecimalPlaces(num)
{
  var number = new String(num);
  var segments = number.split(".");
  var rightSide;    // Value to the right of the decimal place
  var decPos;       // Position of the decimal place in the given number

  if( (number == null) || (number == "") || isNaN(Number(num)))
  {
    return("NaN");
  }

  // Replace the decimal separator with the currency-specific decimal
  // separator (there isn't a thousand separator since the number was primitive numeric)
  if( (decPos = number.indexOf(".")) == -1)
  {
    return 0;
  }
  else if(segments.length <= 2)
  {
    return segments[1].length;
  }
  else
  {
    return("NaN");
  }

  
}

/****************************************************************************
* Convert a properly formatted string to a primative numeric value.
*
* num       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Returns a primative numeric value or null if an unsupported locale is
* provided.
****************************************************************************/
function strToInteger(intnum, languageID)
{
  var thouSep;
  var decSep;
  var groupingSize;
  
  // If no locale is specified, use en_US as default
  if(languageID != null && defined(numericInfo[languageID]))
  {
      thouSep = numericInfo[languageID]["number"]["thouSep"];
      decSep  = numericInfo[languageID]["number"]["decSep"];
      groupingSize = numericInfo[languageID]["number"]["groupingSize"];
  }
  else
  {
    thouSep = numericInfo["default"]["number"]["thouSep"];
    decSep  = numericInfo["default"]["number"]["decSep"];
    groupingSize = numericInfo["default"]["number"]["groupingSize"];
  }
  
  return(toIntegerNum(intnum, thouSep, decSep,groupingSize));
  
}// END strToNumber

/****************************************************************************
* validate a given Integer number.
*
* numint       - The number to be formatted and validated.
* locale    - The locale used to determine proper number formatting.
*
* Return true or false depending on whether num is a valid number for the given language
****************************************************************************/
function isValidInteger(numint, languageID)
{
  var res = strToInteger(numint, languageID);
  if ((new String(res)) == "NaN")
  {
      return false;
  }
  else
  {
      return true;
  }
  
}// END isValidInteger



/****************************************************************************
* validate and Convert an Integer number to a primitive numeric value
*
* intnum       - The integer number to be formatted and validated.
* thouSep      - The thousand separator to be used in validation and formatting.
* decSep       - The decimal separator to be used in validation and formatting.
* groupingSize - Grouping size is the number of digits between grouping
*                separators in the integer portion of a number
*
* Returns a primitive numeric value; string "NaN" if the conversion failed.
****************************************************************************/
function toIntegerNum(intnum, thouSep, decSep, groupingSize)
{
  var currChar;
  var buffer = "";
  var number = new String(trim(intnum));
  var thouHit = false;
  var decHit = false;
  var groupCount = 0;

  if( (number == null) || (number == "") )
    return("NaN");

  for(var i=0; i < number.length; i++)
  {
    currChar = number.charAt(i);
    groupCount++;

    if ( (( currChar == ' ')  && ((thouSep.charCodeAt(0) == 160) && thouSep.length == 1)) || (currChar == thouSep)  )  
    {
      
      if (thouHit == true)
      {
          if (groupCount-1 != groupingSize)
          {
              return("NaN");
          }
      }
      thouHit = true;
      groupCount = 0;
      continue;
    }
    else if(currChar == decSep)
    {           
              return("NaN");
    }
    // Even if the decimal point or thousand separator is not '.' the javascript function Number() accepts '.'
    // We need the following check to prevent this
    else if ( currChar == '.')  
	return("NaN");	
    else
      buffer += currChar;
  }// END for

  if (thouHit == true && groupCount != groupingSize)
  {
    return("NaN");
  }
  
  return(Number(buffer));
  
}// END toNum


/***********************************************************
NumberFormat Extension - 2018 Orienteed
************************************************************/
WCCurrencyJS = {
    //Set defaults to en_US
    langId : -1,            // Current languageId
    decimal : 2,            // Number of decimals in current pattern
    code : "USD",           // ISO 4217 currency codes, such as "USD" for the US dollar, "EUR" for the euro
    symbolHTML : "$",       // HTML Symbol e.g. "&pound;"
    symbolUNI : "\u0024",   // Unicode Symbol e.g. "\u00A3", "$"
    symbolPrefixed : true,  // if true, symbol is prefixed e.g. "$100.00" otherwise symbol is suffixed "100.00$"
    thouSep: ",",           // Thousands separator
    decSep: ".",            // Decimal separator
    spaceSep: false,        // true if a space exist between number and symbol e.g. "100,00 €"

    init: function(langId, decimal, code, symbolHTML){
        this.langId = langId;
        this.decimal = decimal;
        this.code = code;
        this.symbolHTML = symbolHTML;

        //TODO Set unicode symbol for remaining countries
        switch (code){
            case "GBP":
                this.symbolUNI = '\u00A3';
                break;
            case "EUR":
                this.symbolUNI = '\u20AC';
                break;
            case "USD":
                this.symbolUNI = '$';
                break;
            case "CAD":
                this.symbolUNI = 'CAD $';
                break;
            default:
                this.symbolUNI = '';
        }
        
        if(location.href.toLowerCase().includes('persol')){
        	this.symbolPrefixed = true;
        	if(langId == "-1"){
        		this.spaceSep = false;
        	}else{
        		this.spaceSep = true;
        	}
        }else{
        	switch (langId){
	            case "-1": // EN
	                this.symbolPrefixed = true;
	                this.spaceSep = false;
	                break;
	            case "-2": // FR
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-3": // DE
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-4": // IT
	                this.symbolPrefixed = true;
	                this.spaceSep = true;
	                break;
	            case "-5": // ES
	                this.symbolPrefixed = false;
	                this.spaceSep = true;
	                break;
	            case "-6": // PT
	                this.symbolPrefixed = true;
	                this.spaceSep = true;
	                break;
	        }
        }
        
        

        var numInfo = getNumericInfo(this.code, this.langId);
        this.thouSep = numInfo.thouSep;
        this.decSep = numInfo.decSep;
    },

    /**
     * @param {String} inPrice String with price e.g. something like "$ 100.00"
     *                          Must follow current store settings e.g. US -> "$1,000.00"
                                                                   e.g. ES -> "1.000,00 €"
     * @returns String without the currency "100.00" following current locale
     */
    unformat: function(price){
        var validChars = "0123456789.,";
        var inPrice = "";
        
        if(typeof price != 'undefined'){
        	 inPrice = price.trim();
        }
        
        var regexp1 = new RegExp(/^[0-9]{1,3}(,[0-9]{3})*(\.[0-9]+)?$/); //1,123,123.123
        var regexp2 = new RegExp(/^([0-9])*(\.[0-9]+)?$/); //123456.123
        var ERROR_BAD_FORMAT = "PSL::NumberFormatExt.js::unformat()::Error: Format doesn't match current store settings";
        var ERROR_EMPTY_STRING = "PSL::NumberFormatExt.js::unformat()::Error: Price string empty";

        if (inPrice == ""){
            console.log(ERROR_EMPTY_STRING);
            return null;
        }

        //Remove initial chars until the first number and remove trailing chars until the last number
        var beginIndex = -1;
        var endIndex = -1;
        for (var i=0; i<inPrice.length; i++){
            if (beginIndex == -1){
                if (validChars.includes(inPrice[i])){
                    beginIndex = i;
                }
            } else {
                if (validChars.includes(inPrice[i])){
                    endIndex = i;
                }
            }
        }

        inPrice = inPrice.slice(beginIndex, endIndex+1);

        //Convert nubber to US format
        inPrice = inPrice.replaceAll(this.decSep,"#DECSEP#").replaceAll(this.thouSep,"#THOUSEP#");
        inPrice = inPrice.replaceAll("#DECSEP#",".").replaceAll("#THOUSEP#",",");

        if (!regexp1.test(inPrice) && !regexp2.test(inPrice)){
            console.log(ERROR_BAD_FORMAT);
            return null;
        }

        //Remove the thousands separator and test again
        inPrice = inPrice.replaceAll(",","");

        var numVal = numeral(inPrice).value();

        if (numVal == null){
            console.log(ERROR_BAD_FORMAT);
            return null;
        }

        return numVal;
    },

    /**
     *
     * @param {Number} num Number to be converted
     * @param {Object} options (Optional) Object with options. E.g. WCCurrencyJS.format(1423.23, {"truncDecimals":"true"})
     *            Available options:
     *                  "truncDecimals" : "true|false(default)"
     */
    format: function(num, options){
        var ERROR_NOT_A_NUMBER = "PSL::NumberFormatExt.js::format()::Error: Parameter is not a number";

        if ($.isNumeric(num)){

            var numf = num;
            var space = "";
            if (this.spaceSep){
                space = " ";
            }

            //Generate conversion pattern in order to convert the number using numeral.js
            var pattern = "";
            if (this.thouSep != ""){
                pattern += "0,";
            }
            if (this.decSep != ""){
                pattern += "0.";
            }
            for (var i = 0; i < this.decimal; i++) {
                pattern += "0";
            }

            // Set separators for this page
            numf = numeral(numf).format(pattern);

            //if truncDecimals is true then we remove the decimals on the formatted string
            if (options != null && options.truncDecimals == "true"){
                if (numf.includes(".")){
                    numf = numf.substring(0, numf.indexOf("."));
                }
            }

            numf = numf.replaceAll(".","#DECSEP#").replaceAll(",","#THOUSEP#");
            numf = numf.replaceAll("#DECSEP#", this.decSep).replaceAll("#THOUSEP#", this.thouSep);

            if (this.symbolPrefixed){
                numf = "" + this.symbolUNI + space + numf;
            }else{
                numf = "" + numf + space + this.symbolUNI;
            }

            return numf;
        } else {
            console.log(ERROR_NOT_A_NUMBER);
            return NaN;
        }
    }
}

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

WCCurrencyJS.init(
    WCParamJS.langId,
    env_currencyDecimal,
    env_currencyCode,
    env_CurrencySymbolToFormat
);
/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
!function(a){var b=navigator.userAgent;a.HTMLPictureElement&&/ecko/.test(b)&&b.match(/rv\:(\d+)/)&&RegExp.$1<45&&addEventListener("resize",function(){var b,c=document.createElement("source"),d=function(a){var b,d,e=a.parentNode;"PICTURE"===e.nodeName.toUpperCase()?(b=c.cloneNode(),e.insertBefore(b,e.firstElementChild),setTimeout(function(){e.removeChild(b)})):(!a._pfLastSize||a.offsetWidth>a._pfLastSize)&&(a._pfLastSize=a.offsetWidth,d=a.sizes,a.sizes+=",100vw",setTimeout(function(){a.sizes=d}))},e=function(){var a,b=document.querySelectorAll("picture > img, img[srcset][sizes]");for(a=0;a<b.length;a++)d(b[a])},f=function(){clearTimeout(b),b=setTimeout(e,99)},g=a.matchMedia&&matchMedia("(orientation: landscape)"),h=function(){f(),g&&g.addListener&&g.addListener(f)};return c.srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",/^[c|i]|d$/.test(document.readyState||"")?h():document.addEventListener("DOMContentLoaded",h),f}())}(window),function(a,b,c){"use strict";function d(a){return" "===a||"	"===a||"\n"===a||"\f"===a||"\r"===a}function e(b,c){var d=new a.Image;return d.onerror=function(){A[b]=!1,ba()},d.onload=function(){A[b]=1===d.width,ba()},d.src=c,"pending"}function f(){M=!1,P=a.devicePixelRatio,N={},O={},s.DPR=P||1,Q.width=Math.max(a.innerWidth||0,z.clientWidth),Q.height=Math.max(a.innerHeight||0,z.clientHeight),Q.vw=Q.width/100,Q.vh=Q.height/100,r=[Q.height,Q.width,P].join("-"),Q.em=s.getEmValue(),Q.rem=Q.em}function g(a,b,c,d){var e,f,g,h;return"saveData"===B.algorithm?a>2.7?h=c+1:(f=b-c,e=Math.pow(a-.6,1.5),g=f*e,d&&(g+=.1*e),h=a+g):h=c>1?Math.sqrt(a*b):a,h>c}function h(a){var b,c=s.getSet(a),d=!1;"pending"!==c&&(d=r,c&&(b=s.setRes(c),s.applySetCandidate(b,a))),a[s.ns].evaled=d}function i(a,b){return a.res-b.res}function j(a,b,c){var d;return!c&&b&&(c=a[s.ns].sets,c=c&&c[c.length-1]),d=k(b,c),d&&(b=s.makeUrl(b),a[s.ns].curSrc=b,a[s.ns].curCan=d,d.res||aa(d,d.set.sizes)),d}function k(a,b){var c,d,e;if(a&&b)for(e=s.parseSet(b),a=s.makeUrl(a),c=0;c<e.length;c++)if(a===s.makeUrl(e[c].url)){d=e[c];break}return d}function l(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[s.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}function m(a,b){function c(b){var c,d=b.exec(a.substring(m));return d?(c=d[0],m+=c.length,c):void 0}function e(){var a,c,d,e,f,i,j,k,l,m=!1,o={};for(e=0;e<h.length;e++)f=h[e],i=f[f.length-1],j=f.substring(0,f.length-1),k=parseInt(j,10),l=parseFloat(j),X.test(j)&&"w"===i?((a||c)&&(m=!0),0===k?m=!0:a=k):Y.test(j)&&"x"===i?((a||c||d)&&(m=!0),0>l?m=!0:c=l):X.test(j)&&"h"===i?((d||c)&&(m=!0),0===k?m=!0:d=k):m=!0;m||(o.url=g,a&&(o.w=a),c&&(o.d=c),d&&(o.h=d),d||c||a||(o.d=1),1===o.d&&(b.has1x=!0),o.set=b,n.push(o))}function f(){for(c(T),i="",j="in descriptor";;){if(k=a.charAt(m),"in descriptor"===j)if(d(k))i&&(h.push(i),i="",j="after descriptor");else{if(","===k)return m+=1,i&&h.push(i),void e();if("("===k)i+=k,j="in parens";else{if(""===k)return i&&h.push(i),void e();i+=k}}else if("in parens"===j)if(")"===k)i+=k,j="in descriptor";else{if(""===k)return h.push(i),void e();i+=k}else if("after descriptor"===j)if(d(k));else{if(""===k)return void e();j="in descriptor",m-=1}m+=1}}for(var g,h,i,j,k,l=a.length,m=0,n=[];;){if(c(U),m>=l)return n;g=c(V),h=[],","===g.slice(-1)?(g=g.replace(W,""),e()):f()}}function n(a){function b(a){function b(){f&&(g.push(f),f="")}function c(){g[0]&&(h.push(g),g=[])}for(var e,f="",g=[],h=[],i=0,j=0,k=!1;;){if(e=a.charAt(j),""===e)return b(),c(),h;if(k){if("*"===e&&"/"===a[j+1]){k=!1,j+=2,b();continue}j+=1}else{if(d(e)){if(a.charAt(j-1)&&d(a.charAt(j-1))||!f){j+=1;continue}if(0===i){b(),j+=1;continue}e=" "}else if("("===e)i+=1;else if(")"===e)i-=1;else{if(","===e){b(),c(),j+=1;continue}if("/"===e&&"*"===a.charAt(j+1)){k=!0,j+=2;continue}}f+=e,j+=1}}}function c(a){return k.test(a)&&parseFloat(a)>=0?!0:l.test(a)?!0:"0"===a||"-0"===a||"+0"===a?!0:!1}var e,f,g,h,i,j,k=/^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,l=/^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;for(f=b(a),g=f.length,e=0;g>e;e++)if(h=f[e],i=h[h.length-1],c(i)){if(j=i,h.pop(),0===h.length)return j;if(h=h.join(" "),s.matchesMedia(h))return j}return"100vw"}b.createElement("picture");var o,p,q,r,s={},t=!1,u=function(){},v=b.createElement("img"),w=v.getAttribute,x=v.setAttribute,y=v.removeAttribute,z=b.documentElement,A={},B={algorithm:""},C="data-pfsrc",D=C+"set",E=navigator.userAgent,F=/rident/.test(E)||/ecko/.test(E)&&E.match(/rv\:(\d+)/)&&RegExp.$1>35,G="currentSrc",H=/\s+\+?\d+(e\d+)?w/,I=/(\([^)]+\))?\s*(.+)/,J=a.picturefillCFG,K="position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)",L="font-size:100%!important;",M=!0,N={},O={},P=a.devicePixelRatio,Q={px:1,"in":96},R=b.createElement("a"),S=!1,T=/^[ \t\n\r\u000c]+/,U=/^[, \t\n\r\u000c]+/,V=/^[^ \t\n\r\u000c]+/,W=/[,]+$/,X=/^\d+$/,Y=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,Z=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},$=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},_=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=$(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")+";"});return function(b,d){var e;if(!(b in N))if(N[b]=!1,d&&(e=b.match(a)))N[b]=e[1]*Q[e[2]];else try{N[b]=new Function("e",c(b))(Q)}catch(f){}return N[b]}}(),aa=function(a,b){return a.w?(a.cWidth=s.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.d,a},ba=function(a){if(t){var c,d,e,f=a||{};if(f.elements&&1===f.elements.nodeType&&("IMG"===f.elements.nodeName.toUpperCase()?f.elements=[f.elements]:(f.context=f.elements,f.elements=null)),c=f.elements||s.qsa(f.context||b,f.reevaluate||f.reselect?s.sel:s.selShort),e=c.length){for(s.setupRun(f),S=!0,d=0;e>d;d++)s.fillImg(c[d],f);s.teardownRun(f)}}};o=a.console&&console.warn?function(a){console.warn(a)}:u,G in v||(G="src"),A["image/jpeg"]=!0,A["image/gif"]=!0,A["image/png"]=!0,A["image/svg+xml"]=b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"),s.ns=("pf"+(new Date).getTime()).substr(0,9),s.supSrcset="srcset"in v,s.supSizes="sizes"in v,s.supPicture=!!a.HTMLPictureElement,s.supSrcset&&s.supPicture&&!s.supSizes&&!function(a){v.srcset="data:,a",a.src="data:,a",s.supSrcset=v.complete===a.complete,s.supPicture=s.supSrcset&&s.supPicture}(b.createElement("img")),s.supSrcset&&!s.supSizes?!function(){var a="data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",c="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",d=b.createElement("img"),e=function(){var a=d.width;2===a&&(s.supSizes=!0),q=s.supSrcset&&!s.supSizes,t=!0,setTimeout(ba)};d.onload=e,d.onerror=e,d.setAttribute("sizes","9px"),d.srcset=c+" 1w,"+a+" 9w",d.src=c}():t=!0,s.selShort="picture>img,img[srcset]",s.sel=s.selShort,s.cfg=B,s.DPR=P||1,s.u=Q,s.types=A,s.setSize=u,s.makeUrl=$(function(a){return R.href=a,R.href}),s.qsa=function(a,b){return"querySelector"in a?a.querySelectorAll(b):[]},s.matchesMedia=function(){return a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?s.matchesMedia=function(a){return!a||matchMedia(a).matches}:s.matchesMedia=s.mMQ,s.matchesMedia.apply(this,arguments)},s.mMQ=function(a){return a?_(a):!0},s.calcLength=function(a){var b=_(a,!0)||!1;return 0>b&&(b=!1),b},s.supportsType=function(a){return a?A[a]:!0},s.parseSize=$(function(a){var b=(a||"").match(I);return{media:b&&b[1],length:b&&b[2]}}),s.parseSet=function(a){return a.cands||(a.cands=m(a.srcset,a)),a.cands},s.getEmValue=function(){var a;if(!p&&(a=b.body)){var c=b.createElement("div"),d=z.style.cssText,e=a.style.cssText;c.style.cssText=K,z.style.cssText=L,a.style.cssText=L,a.appendChild(c),p=c.offsetWidth,a.removeChild(c),p=parseFloat(p,10),z.style.cssText=d,a.style.cssText=e}return p||16},s.calcListLength=function(a){if(!(a in O)||B.uT){var b=s.calcLength(n(a));O[a]=b?b:Q.width}return O[a]},s.setRes=function(a){var b;if(a){b=s.parseSet(a);for(var c=0,d=b.length;d>c;c++)aa(b[c],a.sizes)}return b},s.setRes.res=aa,s.applySetCandidate=function(a,b){if(a.length){var c,d,e,f,h,k,l,m,n,o=b[s.ns],p=s.DPR;if(k=o.curSrc||b[G],l=o.curCan||j(b,k,a[0].set),l&&l.set===a[0].set&&(n=F&&!b.complete&&l.res-.1>p,n||(l.cached=!0,l.res>=p&&(h=l))),!h)for(a.sort(i),f=a.length,h=a[f-1],d=0;f>d;d++)if(c=a[d],c.res>=p){e=d-1,h=a[e]&&(n||k!==s.makeUrl(c.url))&&g(a[e].res,c.res,p,a[e].cached)?a[e]:c;break}h&&(m=s.makeUrl(h.url),o.curSrc=m,o.curCan=h,m!==k&&s.setSrc(b,h),s.setSize(b))}},s.setSrc=function(a,b){var c;a.src=b.url,"image/svg+xml"===b.set.type&&(c=a.style.width,a.style.width=a.offsetWidth+1+"px",a.offsetWidth+1&&(a.style.width=c))},s.getSet=function(a){var b,c,d,e=!1,f=a[s.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&s.matchesMedia(c.media)&&(d=s.supportsType(c.type))){"pending"===d&&(c=d),e=c;break}return e},s.parseSets=function(a,b,d){var e,f,g,h,i=b&&"PICTURE"===b.nodeName.toUpperCase(),j=a[s.ns];(j.src===c||d.src)&&(j.src=w.call(a,"src"),j.src?x.call(a,C,j.src):y.call(a,C)),(j.srcset===c||d.srcset||!s.supSrcset||a.srcset)&&(e=w.call(a,"srcset"),j.srcset=e,h=!0),j.sets=[],i&&(j.pic=!0,l(b,j.sets)),j.srcset?(f={srcset:j.srcset,sizes:w.call(a,"sizes")},j.sets.push(f),g=(q||j.src)&&H.test(j.srcset||""),g||!j.src||k(j.src,f)||f.has1x||(f.srcset+=", "+j.src,f.cands.push({url:j.src,d:1,set:f}))):j.src&&j.sets.push({srcset:j.src,sizes:null}),j.curCan=null,j.curSrc=c,j.supported=!(i||f&&!s.supSrcset||g&&!s.supSizes),h&&s.supSrcset&&!j.supported&&(e?(x.call(a,D,e),a.srcset=""):y.call(a,D)),j.supported&&!j.srcset&&(!j.src&&a.src||a.src!==s.makeUrl(j.src))&&(null===j.src?a.removeAttribute("src"):a.src=j.src),j.parsed=!0},s.fillImg=function(a,b){var c,d=b.reselect||b.reevaluate;a[s.ns]||(a[s.ns]={}),c=a[s.ns],(d||c.evaled!==r)&&((!c.parsed||b.reevaluate)&&s.parseSets(a,a.parentNode,b),c.supported?c.evaled=r:h(a))},s.setupRun=function(){(!S||M||P!==a.devicePixelRatio)&&f()},s.supPicture?(ba=u,s.fillImg=u):!function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";f=setTimeout(e,"loading"===a?200:999),b.body&&(s.fillImgs(),c=c||d.test(a),c&&clearTimeout(f))},f=setTimeout(e,b.body?9:99),g=function(a,b){var c,d,e=function(){var f=new Date-d;b>f?c=setTimeout(e,b-f):(c=null,a())};return function(){d=new Date,c||(c=setTimeout(e,b))}},h=z.clientHeight,i=function(){M=Math.max(a.innerWidth||0,z.clientWidth)!==Q.width||z.clientHeight!==h,h=z.clientHeight,M&&s.fillImgs()};Z(a,"resize",g(i,99)),Z(b,"readystatechange",e)}(),s.picturefill=ba,s.fillImgs=ba,s.teardownRun=u,ba._=s,a.picturefillCFG={pf:s,push:function(a){var b=a.shift();"function"==typeof s[b]?s[b].apply(s,a):(B[b]=a[0],S&&s.fillImgs({reselect:!0}))}};for(;J&&J.length;)a.picturefillCFG.push(J.shift());a.picturefill=ba,"object"==typeof module&&"object"==typeof module.exports?module.exports=ba:"function"==typeof define&&define.amd&&define("picturefill",function(){return ba}),s.supPicture||(A["image/webp"]=e("image/webp","data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="))}(window,document);
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var l=new Error("Cannot find module '"+s+"'");throw l.code="MODULE_NOT_FOUND",l}var u=e[s]={exports:{}};t[s][0].call(u.exports,function(e){var n=t[s][1][e];return i(n?n:e)},u,u.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new h(16),this._normalQueue=new h(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var l;try{throw new Error}catch(u){l=u}var p=t("./schedule"),h=t("./queue"),f=t("./util");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){f.hasDevTools&&(this._trampolineEnabled=!1)},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},f.hasDevTools?(r.prototype.invokeLater=function(t,e,n){this._trampolineEnabled?i.call(this,t,e,n):this._schedule(function(){setTimeout(function(){t.call(e,n)},100)})},r.prototype.invoke=function(t,e,n){this._trampolineEnabled?o.call(this,t,e,n):this._schedule(function(){t.call(e,n)})},r.prototype.settlePromises=function(t){this._trampolineEnabled?s.call(this,t):this._schedule(function(){t._settlePromises()})}):(r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s),r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=l},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var l=n(o),u=new t(e);u._propagateFrom(this,1);var p=this._target();if(u._setBoundTo(l),l instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:p,bindingPromise:l};p._then(e,s,void 0,u,h),l._then(a,c,void 0,u,h),u._setOnCancel(l)}else u._resolveCallback(p);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var l=a._boundValue();t:for(var u=0;u<t.length;++u){var p=t[u];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(l,c)}else if("function"==typeof p){var h=o(p).call(l,c);if(h===s)return h;if(h)return o(n).call(l,c)}else if(r.isObject(c)){for(var f=i(p),_=0;_<f.length;++_){var d=f[_];if(p[d]!=c[d])continue t}return o(n).call(l,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,e){return{promise:e}}function i(){return!1}function o(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+H.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function s(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?H.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function a(){return this._onCancelField}function c(t){this._onCancelField=t}function l(){this._cancellationParent=void 0,this._onCancelField=void 0}function u(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function p(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new O(this._peekContext())}function _(t,e){if(U(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=E(t);H.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),H.notEnumerableProp(t,"__stackCleaned__",!0)}}}function d(){this._trace=void 0}function v(t,e,n,r,i){if(void 0===t&&null!==e&&J){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=C(a),l=c.length-1;l>=0;--l){var u=c[l];if(!q.test(u)){var p=u.match($);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var h=c[0],l=0;l<a.length;++l)if(a[l]===h){l>0&&(s="\n"+a[l-1]);break}}var f="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(f,!0,e)}}function y(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),m(n)}function m(t,n,r){if(at.warnings){var i,o=new N(t);if(n)r._attachExtraTrace(o);else if(at.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=E(o);o.stack=s.message+"\n"+s.stack.join("\n")}nt("warning",o)||k(o,"",!0)}}function g(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function b(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function w(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function C(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||Q.test(r),o=i&&it(r);i&&!o&&(z&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function j(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||Q.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function E(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?j(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:C(e)}}function k(t,e,n){if("undefined"!=typeof console){var r;if(H.isObject(t)){var i=t.stack;r=e+G(i,t)}else r=e+String(t);"function"==typeof V?V(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function F(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){L.throwLater(o)}"unhandledRejection"===t?nt(t,n,r)||i||k(n,"Unhandled rejection "):nt(t,r)}function T(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():H.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+x(e)+">, no stack trace)"}function x(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function P(){return"function"==typeof st}function S(t){var e=t.match(ot);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function R(t,e){if(P()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var l=S(i[c]);if(l){n=l.fileName,s=l.line;break}}for(var c=0;c<o.length;++c){var l=S(o[c]);if(l){r=l.fileName,a=l.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(it=function(t){if(M.test(t))return!0;var e=S(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function O(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);st(this,O),e>32&&this.uncycle()}var A,D,V,I=e._getDomain,L=e._async,N=t("./errors").Warning,H=t("./util"),B=t("./es5"),U=H.canAttachTrace,M=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,q=/\((?:timers\.js):\d+:\d+\)/,$=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,Q=null,G=null,z=!1,X=!(0==H.env("BLUEBIRD_DEBUG")||!H.env("BLUEBIRD_DEBUG")&&"development"!==H.env("NODE_ENV")),W=!(0==H.env("BLUEBIRD_WARNINGS")||!X&&!H.env("BLUEBIRD_WARNINGS")),K=!(0==H.env("BLUEBIRD_LONG_STACK_TRACES")||!X&&!H.env("BLUEBIRD_LONG_STACK_TRACES")),J=0!=H.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(W||!!H.env("BLUEBIRD_W_FORGOTTEN_RETURN"));e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){if(0===(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},e.prototype._notifyUnhandledRejectionIsHandled=function(){F("rejectionHandled",A,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),F("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return m(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var e=I();D="function"==typeof t?null===e?t:H.domainBind(e,t):void 0},e.onUnhandledRejectionHandled=function(t){var e=I();A="function"==typeof t?null===e?t:H.domainBind(e,t):void 0};var Y=function(){};e.longStackTraces=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!at.longStackTraces&&P()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;at.longStackTraces=!0,Y=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),L.enableTrampoline(),at.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=_,e.prototype._dereferenceTrace=d,n.activateLongStackTraces(),L.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return at.longStackTraces&&P()};var Z=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n={detail:e,cancelable:!0};B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason});var r=new CustomEvent(t.toLowerCase(),n);return!H.global.dispatchEvent(r)}}if("function"==typeof Event){var t=new Event("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n=new Event(t.toLowerCase(),{cancelable:!0});return n.detail=e,B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason}),!H.global.dispatchEvent(n)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),H.global.dispatchEvent(t),function(t,e){var n=document.createEvent("CustomEvent");return n.initCustomEvent(t.toLowerCase(),!1,!0,e),!H.global.dispatchEvent(n)}}catch(e){}return function(){return!1}}(),tt=function(){return H.isNode?function(){return process.emit.apply(process,arguments)}:H.global?function(t){var e="on"+t.toLowerCase(),n=H.global[e];return n?(n.apply(H.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),et={promiseCreated:r,promiseFulfilled:r,promiseRejected:r,promiseResolved:r,promiseCancelled:r,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:r},nt=function(t){var e=!1;try{e=tt.apply(null,arguments)}catch(n){L.throwLater(n),e=!0}var r=!1;try{r=Z(t,et[t].apply(null,arguments))}catch(n){L.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Y()),"warnings"in t){var n=t.warnings;at.warnings=!!n,J=at.warnings,H.isObject(n)&&"wForgottenReturn"in n&&(J=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!at.cancellation){if(L.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=l,e.prototype._propagateFrom=u,e.prototype._onCancel=a,e.prototype._setOnCancel=c,e.prototype._attachCancellationCallback=s,e.prototype._execute=o,rt=u,at.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!at.monitoring?(at.monitoring=!0,e.prototype._fireEvent=nt):!t.monitoring&&at.monitoring&&(at.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var rt=p,it=function(){return!1},ot=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;H.inherits(O,Error),n.CapturedTrace=O,O.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var l=c._length+1,u=r-2;u>=0;--u)e[u]._length=l,l++;return}}}},O.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=E(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(C(i.stack.split("\n"))),i=i._parent;w(r),b(r),H.notEnumerableProp(t,"stack",g(n,r)),H.notEnumerableProp(t,"__stackCleaned__",!0)}};var st=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():T(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,Q=t,G=e;var n=Error.captureStackTrace;return it=function(t){return M.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return Q=/@/,G=e,z=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(G=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?T(e):e.toString()},null):(Q=t,G=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(V=function(t){console.warn(t)},H.isNode&&process.stderr.isTTY?V=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:H.isNode||"string"!=typeof(new Error).stack||(V=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var at={warnings:W,longStackTraces:!1,cancellation:!1,monitoring:!1};return K&&e.longStackTraces(),{longStackTraces:function(){return at.longStackTraces},warnings:function(){return at.warnings},cancellation:function(){return at.cancellation},monitoring:function(){return at.monitoring},propagateFromFunction:function(){return rt},boundValueFunction:function(){return h},checkForgottenReturns:v,setBounds:R,warn:m,deprecated:y,CapturedTrace:O,fireDomEvent:Z,fireGlobalEvent:tt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return u(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,l=t("./util"),u=l.inherits,p=l.notEnumerableProp,h=r("Warning","warning"),f=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),m=0;m<y.length;++m)"function"==typeof Array.prototype[y[m]]&&(d.prototype[y[m]]=Array.prototype[y[m]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var g=0;d.prototype.toString=function(){var t=Array(4*g+1).join(" "),e="\n"+t+"AggregateError of:\n";g++,t=Array(4*g+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return g--,e},u(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:f,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:h}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},l=function(t,e,n){return t[e]=n.value,t},u=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},h=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:h,keys:a,names:a,defineProperty:l,getDescriptor:c,freeze:u,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return l.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(h.e=t,h)}function l(t){var i=this.promise,l=this.handler;if(!this.called){this.called=!0;var u=this.isFinallyHandler()?l.call(i._boundValue()):l.call(i._boundValue(),t);if(u===r)return u;if(void 0!==u){i._setReturnedNonUndefined();var f=n(u,i);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),h.e=_,h}f.isPending()&&f._attachCancellationCallback(new o(this))}return f._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),h.e=t,h):(s(this),t)}var u=t("./util"),p=e.CancellationError,h=u.errorObj,f=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,l,l)},e.prototype.tap=function(t){return this._passThrough(t,1,l)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,l);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!u.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+u.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(f(i,a,this),1,void 0,l)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=f(n[o])(t);if(r._popContext(),s===h){r._pushContext();var a=e.reject(h.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var l=this._promise=new e(r);l._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var l=t("./errors"),u=l.TypeError,p=t("./util"),h=p.errorObj,f=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=f(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=f(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=f(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=f(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===h)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),
null===o))return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new u("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){var a=t("./util");a.canEvaluate,a.tryCatch,a.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,e,n,r){this.constructor$(t),this._promise._captureStackTrace();var i=l();this._callback=null===i?e:u.domainBind(i,e),this._preservedValues=r===o?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0)}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var l=e._getDomain,u=t("./util"),p=u.tryCatch,h=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var l=this._promise,u=this._callback,f=l._boundValue();l._pushContext();var _=p(u).call(f,t,n,o),d=l._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",l),_===h)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var m=++this._totalResolved;return m>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var l=arguments[1],u=arguments[2];c=s.isArray(l)?a(t).apply(u,l):a(t).call(u,l)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&u.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new l(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=u.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),l=c.OperationalError,u=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new m("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new m("expecting a function but got "+f.classString(e))}function i(t){t!==b&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(b);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c,l=function(){return new m("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},p=function(t){return i.reject(new m(t))},h={},f=t("./util");c=f.isNode?function(){var t=process.domain;return void 0===t&&(t=null),t}:function(){return null},f.notEnumerableProp(i,"_getDomain",c);var _=t("./es5"),d=t("./async"),v=new d;_.defineProperty(i,"_async",{value:v});var y=t("./errors"),m=i.TypeError=y.TypeError;i.RangeError=y.RangeError;var g=i.CancellationError=y.CancellationError;i.TimeoutError=y.TimeoutError,i.OperationalError=y.OperationalError,i.RejectionError=y.OperationalError,i.AggregateError=y.AggregateError;var b=function(){},w={},C={},j=t("./thenables")(i,b),E=t("./promise_array")(i,b,j,p,n),k=t("./context")(i),F=k.create,T=t("./debuggability")(i,k),x=(T.CapturedTrace,t("./finally")(i,j,C)),P=t("./catch_filter")(C),S=t("./nodeback"),R=f.errorObj,O=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return p("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new m("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,P(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(T.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?p("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,w,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new E(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(b);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=O(t)(S(e,n));return r===R&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new E(t).promise()},i.cast=function(t){var e=j(t);return e instanceof i||(e=new i(b),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(b);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));return v.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(b),l=this._target(),u=l._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var p=c();if(0!==(50397184&u)){var h,_,d=l._settlePromiseCtx;0!==(33554432&u)?(_=l._rejectionHandler0,h=t):0!==(16777216&u)?(_=l._fulfillmentHandler0,h=e,l._unsetRejectionIsUnhandled()):(d=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),h=e),v.invoke(d,l,{handler:null===p?h:"function"==typeof h&&f.domainBind(p,h),promise:a,receiver:r,value:_})}else l._addCallbacks(t,e,a,r,p);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){v.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===h?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=h),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=h),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=null===i?e:f.domainBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this[s+1]=null===i?e:f.domainBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(l(),!1);var n=j(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(l());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var c=new g("late cancellation observer");r._attachExtraTrace(c),this._reject(c)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&T.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==b){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===w?n&&"number"==typeof n.length?o=O(t).apply(this._boundValue(),n):(o=R,o.e=new m("cannot .spread() a non-array: "+f.classString(n))):o=O(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===C?r._reject(n):o===R?r._rejectCallback(o.e,!1):(T.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof x&&r.isFinallyHandler()?(r.cancelPromise=t,O(e).call(r,o)===R&&t._reject(R.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof E?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=l();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():v.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?v.fatalError(t,f.isNode):void((65535&e)>0?v.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&_.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){T.deprecated("Promise.defer","new Promise");var t=new i(b);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",l),t("./method")(i,b,j,p,T),t("./bind")(i,b,j,T),t("./cancel")(i,E,p,T),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,E,j,b,v,c),i.Promise=i,i.version="3.5.5",t("./call_get.js")(i),t("./generators.js")(i,p,b,j,n,T),t("./map.js")(i,E,p,j,b,T),t("./nodeify.js")(i),t("./promisify.js")(i,b),t("./props.js")(i,E,j,p),t("./race.js")(i,b,j,p),t("./reduce.js")(i,E,p,j,b,T),t("./settle.js")(i,E,T),t("./some.js")(i,E,p),t("./timers.js")(i,b,T),t("./using.js")(i,p,j,F,b,T),t("./any.js")(i),t("./each.js")(i,b),t("./filter.js")(i,b),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(b)),T.setBounds(d.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&r._propagateFrom(t,3),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function l(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(l,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var u=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(u,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=f.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new m("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=f.inheritedDataKeys(t),c=[],l=0;l<a.length;++l){var u=a[l],p=t[u],h=r===j?!0:j(u,p,t);"function"!=typeof p||i(p)||o(t,u,e)||!r(u,p,t,h)||c.push(u,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===h&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof u&&this!==l?this[u]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var l=function(){return this}(),u=t;return"string"==typeof u&&(t=o),f.notEnumerableProp(c,"__isPromisified__",!0),c}function l(t,e,n,r,i){for(var o=new RegExp(E(e)+"$"),s=a(t,e,o,n),c=0,l=s.length;l>c;c+=2){var u=s[c],p=s[c+1],_=u+e;if(r===k)t[_]=k(u,h,u,p,e,i);else{var d=r(p,function(){return k(u,h,u,p,e,i)});f.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return f.toFastProperties(t),t}function u(t,e,n){return k(t,e,void 0,t,null,n)}var p,h={},f=t("./util"),_=t("./nodeback"),d=f.withAppended,v=f.maybeWrapAsError,y=f.canEvaluate,m=t("./errors").TypeError,g="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return f.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},E=function(t){return t.replace(/([$])/,"\\$")},k=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?h:e.context,o=!!e.multiArgs,s=u(t,n,o);return f.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new m("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=g);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=k),!f.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=f.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&f.isClass(c)&&(l(c.prototype,r,i,o,n),l(c,r,i,o,n))}return l(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=u.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return l(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),l=c.isObject,u=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),h=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=h(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var l=new e(n);void 0!==o&&l._propagateFrom(o,3);for(var u=l._fulfill,p=l._reject,h=0,f=t.length;f>h;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,p,void 0,l,null)}return l}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=h();this._fn=null===s?n:f.domainBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function l(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function u(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=_(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var h=e._getDomain,f=t("./util"),_=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;i>r;++r){var o={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(u,void 0,void 0,o,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return l(this,t,e,null)},e.reduce=function(t,e,n,r){return l(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var l=s.resolve();r=function(t){l.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36
}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,l=s.isArray,u={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=l(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(u),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==u&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(u(t)){if(t instanceof e)return t;var i=o(t);if(i===l){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return l.e=e,l}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),u=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,h=c.tryCatch(r).call(t,o,s);return p=!1,a&&h===l&&(a._rejectCallback(h.e,!0,!0),a=null),u}var c=t("./util"),l=c.errorObj,u=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var l=function(t){return u(+this).thenReturn(t)},u=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(l,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return u(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function l(t,n){function i(){if(s>=l)return u._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,l=t.length,u=new e(o);return i(),u}function u(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function h(t){return u.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function f(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,m=_.tryCatch,g={};u.prototype.data=function(){return this._data},u.prototype.promise=function(){return this._promise},u.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():g},u.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==g?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},u.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,u),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},f.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new f(t),p=0;t>p;++p){var d=o[p];if(u.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var g=r(d);g instanceof e&&(d=g._then(h,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=m(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return l(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return x.e=e,x}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function l(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function u(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function h(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function f(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return D.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function m(t){try{u(t,"isOperational",!0)}catch(e){}}function g(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return H?process.env[t]:void 0}function E(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(e){}}function k(t,e){return t.bind(e)}var F=t("./es5"),T="undefined"==typeof navigator,x={e:{}},P,S="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,R=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var l=Object.getOwnPropertyDescriptor(t,c);null!=l&&null==l.get&&null==l.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,D=/^[a-z$_][a-z$_0-9]*$/i,V=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),I=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var L="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};I=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?L(t):null}}var N="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),H="undefined"!=typeof process&&"undefined"!=typeof process.env,B={isClass:h,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:l,thrower:p,isArray:F.isArray,asArray:I,notEnumerableProp:u,isPrimitive:o,isObject:s,isError:y,canEvaluate:T,errorObj:x,tryCatch:i,inherits:R,withAppended:c,maybeWrapAsError:a,toFastProperties:f,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:V,originatesFromRejection:g,markAsOriginatingFromRejection:m,classString:w,copyDescriptors:C,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:N,hasEnvVariables:H,env:j,global:S,getNativePromise:E,domainBind:k};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(U){B.lastLineError=U}e.exports=B},{"./es5":13}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/* Begin nocache.js */

var userType = ''; /* Indicates if the user is registered 'R' or guest 'G'*/
var userInfo = ''; /* It has all the user contact information like userId, address, email, etc */
var personInfo = ''; /* It has the person information in '/person/@self' call*/
var engravingListPrice = ''; /* This variable has the engraving list price value */
var engravingPrice = ''; /* This variable has the engraving offer price value */
var engravingPriceOriginal = ''; /* This variable is a copy of the engravingPrice before check if it's registered or guest */
var engravingListPriceFormatted = ''; /* This variable has the engraving list price value formatted */
var engravingPriceFormatted = ''; /* This variable has the engraving offer price value formatted */
var engravingPriceOriginalFormatted = ''; /* This variable has the original engraving offer price value formatted */

window.addEventListener('load', (event) => {
    getUserInfo();
});

/**
 * Function that gets all person and user info and save them in global variables.
 * @param {function} callback - function to be executed at the end of this method if exist.
 */
function getUserInfo(callback) {
    var url = '/wcs/resources/store/' + WCParamJS.storeId + '/person/@self';
    getAjaxCallInfo(url, null, userinfoCallback);

    function userinfoCallback(response) {
        personInfo = response;
        if(response.userId == '-1002'){
            userType = 'G';
            if(typeof callback !== 'undefined') {
                callback();
            }
            if (document.readyState !== 'loading') {
                afterNoCacheRESTFuntion();
            } else {
                document.addEventListener('DOMContentLoaded', function () {
                    afterNoCacheRESTFuntion();
                });
            }
        } else {
            var url = '/wcs/resources/store/' + WCParamJS.storeId + '/person/'+ response.userId;
            var params = {
                "profileName": "IBM_User_Registration_Details"
            };
            getAjaxCallInfo(url, params, getUserInfoCallback);
        }
    }

    function getUserInfoCallback(response) {
        userType = response.registerType;
        userInfo = response;
        if(typeof sessionStorage['logged']=='undefined' && userType =='R')
            sessionStorage.setItem('logged', 'true');
        if(userType === 'R' ){
            if(typeof userInfo.address.phone1 !== 'undefined' && userInfo.address.phone1 != null && localStorage.encryptedUserPhoneSHA256 == null){
                let phone1Prefix = String(localStorage.prefixNumberPhone1) + String(userInfo.address.phone1); 
                if(typeof sha256 != 'undefined') {
                    if(typeof sha256(phone1Prefix) === 'object' && typeof sha256(phone1Prefix).then === 'function')
                        sha256(phone1Prefix).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );
                    else
                        localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Prefix));
                }
            }
            //BEGIN FIX - HB-11853
            if((isPersol || isOliver || isVogue) && typeof userInfo.address.email1 !== 'undefined' && userInfo.address.email1 != null && localStorage.encryptedEmailUserSHA256 == null){
                let emailUser = userInfo.address.email1;
                emailUser = emailUser.trim().toLowerCase();
                if(typeof sha256(emailUser) === 'object' && typeof sha256(emailUser).then === 'function')
                    sha256(emailUser).then(result => {  localStorage.setItem('encryptedEmailUserSHA256',result); } );
                else
                    localStorage.setItem('encryptedEmailUserSHA256',sha256(emailUser));
            }
            //END FIX - HB-11853

            if(algoliaActive) {
                aa('setAuthenticatedUserToken', userInfo.userId);
            }
        }
        if(typeof callback !== 'undefined') {
            callback();
        }
        if (document.readyState !== 'loading') {
            afterNoCacheRESTFuntion();
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                afterNoCacheRESTFuntion();
            });
        }
    }
}

/**
 * Function that returns a html showing the current address info
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {string} stateDisplayName - State Name
 * @param {string} countryDisplayName  - Country Name
 * @param {string} addressLine1 - First Address line of current address
 * @param {string} addressLine2 - Second Address line of current address
 * @param {string} addressLine3 - Third Address line of current address, only used for Carol
 *
 * @return {string} - html code with the current address info
 */
function getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2, addressLine3) {
    var html = '<div class="address">';
    if(data.lastName || data.firstName) {
        html = html + '<div class="full-name">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.firstName + ' ' + data.lastName + '<br />';
        } else {
            html = html + '<span id="firstName' + suffix + '">' + data.firstName + '</span> ' +
            '<span id="lastName' + suffix + '">' + data.lastName + '</span><br/>';
        }
        html = html + '</div>';
    }

    if(data.phone1) {
        html = html + '<div class="phone">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.phone1 + '<br />';
        } else {
            html = html + '<span id="telephone1' + suffix + '">' + data.phone1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(data.email1) {
        html = html + '<div class="email">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.email1 + '<br />';
        } else {
            html = html + '<span id="emailAddress1' + suffix + '">' + data.email1 + '</span><br />';
        }
        html = html + '</div>';
        if(isPersol || isVogue) {
            html = html + '<br />';
        }
    }

    if(addressLine1 || addressLine2 || addressLine3) {
        html = html + '<div class="full-address">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + addressLine1 + ' ' + addressLine2 + '<br />';
        } else {
            html = html + '<span id="addressLine1' + suffix + '">' + addressLine1 + '</span> ' +
            '<span id="addressLine2' + suffix + '">' + addressLine2 + '</span>';
            if(isCarol) {
                html = html + '<span id="addressLine3' + suffix + '">' + addressLine3 + '</span>';
            }
            html = html + '<br/>';
        }
        html = html + '</div>';
    }
    html = html + '<input type="hidden" name="stateCode" value="' + data.state + '">';

    if(data.city || stateDisplayName) {
        if(!stateDisplayName) {
            stateDisplayName = '';
        }
        html = html + '<div class="city">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.city + ' ' + stateDisplayName + '<br />';
        } else {
            html = html + '<span id="city' + suffix + '">' + data.city + '</span> ' +
            '<span id="stateDisplayName' + suffix + '">' + stateDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }

    if(countryDisplayName || data.zipCode) {
        html = html + '<div class="postal-code">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + countryDisplayName + ' ' + data.zipCode + '<br />';
        } else {
            html = html + '<span id="countryDisplayName' + suffix + '">' + countryDisplayName + '</span> ' +
            '<span id="postalCode' + suffix + '">' +  data.zipCode + '</span><br />';
            var tealiumOrder_ZipCode = data.zipCode;
        }
        html = html + '</div>';
    }
    html = html + '</div>';
    return html;
}

/**
 * Function that returns a html showing the current address info (used for the following countries: DE ES FR IT PL RO RU)
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {string} stateDisplayName - State Name
 * @param {string} countryDisplayName  - Country Name
 * @param {string} addressLine1 - First Address line of current address
 * @param {string} addressLine2 - Second Address line of current address
 *
 * @return {string} - html code with the current address info
 */
function getAddress_DE_ES_FR_IT_PL_RO_RU(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2) {
    var middleName = '';
    if(typeof data.middleName !== 'undefined') {
        middleName = data.middleName;
    }

    var html = '<div class="address">';
    if(data.firstName || data.lastName || middleName) {
        html = html + '<div class="full-name">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.firstName + ' ' + data.lastName + ' ' + middleName + '<br />';
        } else {
            html = html + '<span id="firstName' + suffix + '">' + data.firstName + '</span> ' +
            '<span id="middleName' + suffix + '">' + middleName + '</span> ' +
            '<span id="lastName' + suffix + '">' + data.lastName + '</span><br/>';
        }
        html = html + '</div>';
    }

    if(data.phone1) {
        html = html + '<div class="phone">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.phone1 + '<br />';
        } else {
            html = html + '<span id="telephone1' + suffix + '">' + data.phone1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(data.email1) {
        html = html + '<div class="email">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.email1 + '<br />';
        } else {
            html = html + '<span id="emailAddress1' + suffix + '">' + data.email1 + '</span><br />';
        }
        html = html + '</div>';
    }

    if(addressLine1 || addressLine2) {
        html = html + '<div class="full-address">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + addressLine1 + ' ' + addressLine2 + '<br />';
        } else {
            html = html + '<span id="addressLine1' + suffix + '">' + addressLine1 + '</span> ' +
            '<span id="addressLine2' + suffix + '">' + addressLine2 + '</span><br/>';
        }
        html = html + '</div>';
    }
    html = html + '<input type="hidden" name="stateCode" value="' + data.state + '">';

    if(data.city || data.zipCode) {
        html = html + '<div class="city">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + data.zipCode + ' ' + data.city + '<br />';
        } else {
            html = html + '<span id="postalCode' + suffix + '">' + data.zipCode + '</span> ' +
            '<span id="city' + suffix + '">' + data.city + '</span><br />';
        }
        html = html + '</div>';
    }

    if(stateDisplayName) {
        html = html + '<div class="state">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + stateDisplayName + '<br />';
        } else {
            html = html + '<span id="stateDisplayName' + suffix + '">' + stateDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }

    if(countryDisplayName) {
        html = html + '<div class="postal-code">';
        if(setAsVar && setAsVar == true) {
            var addressDisplay = addressDisplay + countryDisplayName + '<br />';
        } else {
            html = html + '<span id="countryDisplayName' + suffix + '">' + countryDisplayName + '</span><br />';
        }
        html = html + '</div>';
    }
    html = html + '</div>';
    return html;
}

/**
 * Function that make ajax calls to get the country and state names and then, pass all the information
 * to getAddress/getAddress_DE_ES_FR_IT_PL_RO_RU to build the html with all current address info
 * @param {string} suffix - this suffix is passed to prevent duplicated ids (WCAG)
 * @param {JSON} data - current address info
 * @param {*} setAsVar -
 * @param {*} cachedOnlineStoreMap -
 * @param {*} setIsOrg -
 * @param {string} elem - specific element selector
 */
function getAddressDisplay(suffix, data, setAsVar, cachedOnlineStoreMap, setIsOrg, elem) {
    //Set the country and state display name to the country and state codes respectively. This is in case the display name is not found.
    var countryDisplayName = data.country;
    var stateDisplayName = data.state;
    var contactCountryStateBean = '';
    var key1 = '', url = '', addressLine1 = '', addressLine2 = '', addressLine3 = '', contactAddressLine = '', contactAddressLineArray = [], html = '';
    var params = {};

    if(setAsVar && setAsVar == true) {
        var addressDisplay = '';
    }

    if(countryDisplayName && countryDisplayName.length <= 5) {
        /* Retrieve the country display name from the country code and
		   the state display name from the state code */
        key1 = 'store/' + WCParamJS.storeId + '/country/country_state_name+' + WCParamJS.langId + '+' + countryDisplayName + '+' +stateDisplayName;
        contactCountryStateBean = cachedOnlineStoreMap[key1];
        if (!contactCountryStateBean) {
            url = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_name';
            if(countryDisplayName){
                params["countryCode"] = countryDisplayName;
            }
            if(stateDisplayName){
                params["stateCode"] = stateDisplayName;
            }
            params["langId"] = WCParamJS.langId
            getAjaxCallInfo(url, params, getCountryInfo);
        }
    }

    /**
     * Function that receive the country info and saves the country name. Then execute the second ajax call
     * to get the state information if its needed or it continues executing insertAddressToDOM function.
     * @param {JSON} response
     */
    function getCountryInfo(response) {
        contactCountryStateBean = response;
        if(contactCountryStateBean) {
            countryDisplayName = contactCountryStateBean.countryDisplayName;
        }
        if(stateDisplayName && stateDisplayName.length <= 5 && contactCountryStateBean) {
            /* Retrieve the state display name from the state code
               This piece of code should not be needed for most cases */
            key1 = 'store/' + WCParamJS.storeId + '/country/country_state_name+' + WCParamJS.langId + '+' +stateDisplayName;
            contactCountryStateBean = cachedOnlineStoreMap[key1];
            if (!contactCountryStateBean) {
                url = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_name';
                if(stateDisplayName){
                    params["stateCode"] = stateDisplayName;
                }
                params["langId"] = WCParamJS.langId
                getAjaxCallInfo(url, params, getStateInfo);
            }
        } else {
            insertAddressToDOM();
        }

    }

    /**
     * Function that receive the state info and saves the state name and then
     * continues executing insertAddressToDOM function.
     * @param {JSON} response
     */
    function getStateInfo(response) {
        contactCountryStateBean = response;
        if(contactCountryStateBean) {
            stateDisplayName = contactCountryStateBean.stateDisplayName;
        }
        insertAddressToDOM();
    }

    /**
     * Function that saves the last info and gets the html built calling the getAddress
     * or getAddress_DE_ES_FR_IT_PL_RO_RU and inject it in the element passed
     */
    function insertAddressToDOM() {
        if(setIsOrg && setIsOrg == true) {
            addressLine1 = data.address1;
            addressLine2 = data.address2;
        } else {
            if(isCarol) {
                if(typeof data.addressLine === 'string') {
                    contactAddressLine = data.addressLine;
                    contactAddressLineArray = contactAddressLine.split(",");
                    addressLine1 = (data.addressLine[0]).replace('[','');
                    addressLine2 = (data.addressLine[1]).replace('[','');
                    addressLine3 = (data.addressLine[2]).replace('[','');
                } else {
                    addressLine1 = data.addressLine[0];
                    addressLine2 = data.addressLine[1];
                    addressLine3 = data.addressLine[2];
                }
            } else {
                addressLine1 = data.addressLine[0];
                addressLine2 = data.addressLine[1];
            }
        }

        if(countryCode == 'DE' || countryCode == 'ES' || countryCode == 'FR' || countryCode == 'IT' ||
        countryCode == 'PL' || countryCode == 'RO' || countryCode == 'RU') {
            html = getAddress_DE_ES_FR_IT_PL_RO_RU(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2);
        } else {
            if(isCarol) {
                html = getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2, addressLine3);

            } else {
                html = getAddress(suffix, data, setAsVar, stateDisplayName, countryDisplayName, addressLine1, addressLine2);
            }
        }
        $(elem).html(html);
    }
}

/**
 * This function gets all prices for engraving (for register, guest, formated prices, etc)
 * @param {function} callback - function to be executed at the end of this method if exist.
 */
function getEngravingPrice(callback) {

    var listPriceUrl = '/wcs/resources/store/' + WCParamJS.storeId + '/display_price';
    var listPriceParams = {
        "q": "byCatalogEntryIdsAndPriceRuleName",
        "catalogEntryId": engravingProductId,
        "currency": env_currencyCode,
        "checkEntitlement": "false"
    };
    if(engravingProductId){
    	getAjaxCallInfo(listPriceUrl, listPriceParams, getEngravingListPriceCallback);
    }

    /**
     * This function is a callback that saves the engraving list price
     * and makes an ajax call to get the engraving offer price
     * @param {*} response - the previous ajax call data
     */
    function getEngravingListPriceCallback(response) {
        engravingListPrice = response.resultList[0].unitPrice[0].price.value;
        if(userType === 'R') {
            engravingListPrice = 0;
        }
        var offerPriceUrl = '/wcs/resources/store/' + WCParamJS.storeId + '/price';
        var offerPriceParams = {
            "q": "byCatalogEntryIds",
            "catalogEntryId": engravingProductId,
            "currency": env_currencyCode,
            "checkEntitlement": "false"
        };
        getAjaxCallInfo(offerPriceUrl, offerPriceParams, getEngravingOfferPriceCallback);
    }

    /**
     * This function is a callback that saves the engraving offer price
     * and saves the formated prices.
     * @param {*} response - the previous ajax call data
     */
    function getEngravingOfferPriceCallback(response) {
    	if(typeof response != 'undefined') {
	        engravingPrice = engravingPriceOriginal = response.EntitledPrice[0].UnitPrice[0].price.value;
	        if(userType === 'R') {
	            engravingPrice = 0;
	        }
	        engravingListPriceFormatted = WCCurrencyJS.format(engravingListPrice);
	        engravingPriceFormatted = WCCurrencyJS.format(engravingPrice);
	        engravingPriceOriginalFormatted = WCCurrencyJS.format(engravingPriceOriginal);
	
	        if(typeof callback !== 'undefined') {
	            callback();
	        }
	
	        if (document.readyState !== 'loading') {
	            if(isPersol && $('.pdp').length > 0) {
	                shopperActionsUserCallback();
	            }
	        } else {
	            document.addEventListener('DOMContentLoaded', function () {
	                if(isPersol && $('.pdp').length > 0) {
	                    shopperActionsUserCallback();
	                }
	            });
	        }
    	}
    }

}

/**
 * Function that will be executed at the end of all ajax calls
 */
function afterNoCacheRESTFuntion() {
    if($('.GlobalLoginWidgetAlt').length > 0 && (isPersol || isVogue)){
        globalLoginSignOutCallback();
    }
    if(isCarol && userInfo !== '' && userInfo.address !== null) {
        $('.name_header').text(userInfo.address.firstName + ' ' + userInfo.address.lastName);
    }
    if(isPersol && $('.pdp').length > 0) {
        getEngravingPrice(showMonogramBlock);
    }

    if (isVogue && $("body.pdp").length>0){
        if (userType == "G"){
            $(document).ready(function(){
                $(".shopping-list-widget").hide();
            });
        } else {
            $(document).ready(function(){
                $(".shopping-list-widget").show();
                getPDPWishlistInfo();
            });
        }
    }
    if (isVogue) {
        showWishList();
    }
}

/**
 *  Function callback that gets the userType and remove adds text to monogram spans depending
 *  of userType
 *  @param {JSON} response
 */
function shopperActionsUserCallback() {
    if(!isPersol){
        if (userType === 'R') {
            var addMonogramLoyalReplace = addMonogramLoyal.replace('{0}', engravingPriceOriginalFormatted);
            var addMonogramLoyalSubtitleReplace = addMonogramLoyalSubtitle.replace('{0}', engravingPriceOriginalFormatted);
            document.querySelector('.shopperActions--monogram--title__title').innerHTML = addMonogramLoyalReplace;
            document.querySelector('.shopperActions--monogram--title__subtitle').innerHTML = addMonogramLoyalSubtitleReplace;
        } else {
            var addMonogramReplace = addMonogram.replace('{0}', engravingPriceFormatted);
            document.querySelector('.shopperActions--monogram--title__title').innerHTML = addMonogramReplace;
            document.querySelector('.shopperActions--monogram--title__subtitle').innerHTML = addMonogramSubtitle;
        }
    } 
}

/**
 * Function that inserts the userName in the globalLogin and shows it to the user
 */
function globalLoginSignOutCallback() {
    var userDisplayName = '';
    if(userInfo.address){
        if(countryCode == 'JP' || countryCode == 'KR' || countryCode == 'CN' || countryCode == 'TW') {
            userDisplayName = userInfo.address.lastName + ' ' + userInfo.address.firstName;
        } else {
            userDisplayName = userInfo.address.firstName + ' ' + userInfo.address.lastName;
        }
    }
    $('#' + LOGOUTPANEL_ID + '_signOutQuickLinkUser').text(userDisplayName);
    $('#' + LOGOUTPANEL_ID + '_signOutQuickDiv .myAccountResponsive .name').text(userDisplayName);
    $('.myAccountResponsive .firstLine').show();
}

/**
 * This function show the Add Monogram block inside PDP in Persol
 */
function showMonogramBlock() {
    if(userType === 'R') {
        $('.wishlist, .userpanel-favorites').show();
    } else {
    	if($('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span')[0] != undefined) {
    		var monogram_span = $('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span')[0].innerText;
    		if(!monogram_span.includes(engravingPriceFormatted)) {
    			$('.shopperActions--monogram--pop-up--right--wrapper--step-one--title span').append(' ('+engravingPriceFormatted+')');
    		}
	        $('.wishlist').hide();
	        $('.userpanel-favorites').css('display','flex');
    	}
    }
}

/**
 * This function show the wishlist if the user is registered
 */
function showWishList() {
    if(userType === 'R') {
        $('.wishlist').show();
        $('.userpanel-favorites').css('display','flex');
        $('.userpanel-acount').removeClass('userpanel-acount--guest');
    } else {
        $('userpanel-acount').addClass('userpanel-acount--guest');
        $('.wishlist, .userpanel-favorites').hide();        
    }
}
/* End nocache.js */
(function defineMustache(global,factory){if(typeof exports==="object"&&exports&&typeof exports.nodeName!=="string"){factory(exports)}else if(typeof define==="function"&&define.amd){define(["exports"],factory)}else{global.Mustache={};factory(global.Mustache)}})(this,function mustacheFactory(mustache){var objectToString=Object.prototype.toString;var isArray=Array.isArray||function isArrayPolyfill(object){return objectToString.call(object)==="[object Array]"};function isFunction(object){return typeof object==="function"}function typeStr(obj){return isArray(obj)?"array":typeof obj}function escapeRegExp(string){return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}function hasProperty(obj,propName){return obj!=null&&typeof obj==="object"&&propName in obj}function primitiveHasOwnProperty(primitive,propName){return primitive!=null&&typeof primitive!=="object"&&primitive.hasOwnProperty&&primitive.hasOwnProperty(propName)}var regExpTest=RegExp.prototype.test;function testRegExp(re,string){return regExpTest.call(re,string)}var nonSpaceRe=/\S/;function isWhitespace(string){return!testRegExp(nonSpaceRe,string)}var entityMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};function escapeHtml(string){return String(string).replace(/[&<>"'`=\/]/g,function fromEntityMap(s){return entityMap[s]})}var whiteRe=/\s*/;var spaceRe=/\s+/;var equalsRe=/\s*=/;var curlyRe=/\s*\}/;var tagRe=/#|\^|\/|>|\{|&|=|!/;function parseTemplate(template,tags){if(!template)return[];var lineHasNonSpace=false;var sections=[];var tokens=[];var spaces=[];var hasTag=false;var nonSpace=false;var indentation="";var tagIndex=0;function stripSpace(){if(hasTag&&!nonSpace){while(spaces.length)delete tokens[spaces.pop()]}else{spaces=[]}hasTag=false;nonSpace=false}var openingTagRe,closingTagRe,closingCurlyRe;function compileTags(tagsToCompile){if(typeof tagsToCompile==="string")tagsToCompile=tagsToCompile.split(spaceRe,2);if(!isArray(tagsToCompile)||tagsToCompile.length!==2)throw new Error("Invalid tags: "+tagsToCompile);openingTagRe=new RegExp(escapeRegExp(tagsToCompile[0])+"\\s*");closingTagRe=new RegExp("\\s*"+escapeRegExp(tagsToCompile[1]));closingCurlyRe=new RegExp("\\s*"+escapeRegExp("}"+tagsToCompile[1]))}compileTags(tags||mustache.tags);var scanner=new Scanner(template);var start,type,value,chr,token,openSection;while(!scanner.eos()){start=scanner.pos;value=scanner.scanUntil(openingTagRe);if(value){for(var i=0,valueLength=value.length;i<valueLength;++i){chr=value.charAt(i);if(isWhitespace(chr)){spaces.push(tokens.length);indentation+=chr}else{nonSpace=true;lineHasNonSpace=true;indentation+=" "}tokens.push(["text",chr,start,start+1]);start+=1;if(chr==="\n"){stripSpace();indentation="";tagIndex=0;lineHasNonSpace=false}}}if(!scanner.scan(openingTagRe))break;hasTag=true;type=scanner.scan(tagRe)||"name";scanner.scan(whiteRe);if(type==="="){value=scanner.scanUntil(equalsRe);scanner.scan(equalsRe);scanner.scanUntil(closingTagRe)}else if(type==="{"){value=scanner.scanUntil(closingCurlyRe);scanner.scan(curlyRe);scanner.scanUntil(closingTagRe);type="&"}else{value=scanner.scanUntil(closingTagRe)}if(!scanner.scan(closingTagRe))throw new Error("Unclosed tag at "+scanner.pos);if(type==">"){token=[type,value,start,scanner.pos,indentation,tagIndex,lineHasNonSpace]}else{token=[type,value,start,scanner.pos]}tagIndex++;tokens.push(token);if(type==="#"||type==="^"){sections.push(token)}else if(type==="/"){openSection=sections.pop();if(!openSection)throw new Error('Unopened section "'+value+'" at '+start);if(openSection[1]!==value)throw new Error('Unclosed section "'+openSection[1]+'" at '+start)}else if(type==="name"||type==="{"||type==="&"){nonSpace=true}else if(type==="="){compileTags(value)}}stripSpace();openSection=sections.pop();if(openSection)throw new Error('Unclosed section "'+openSection[1]+'" at '+scanner.pos);return nestTokens(squashTokens(tokens))}function squashTokens(tokens){var squashedTokens=[];var token,lastToken;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];if(token){if(token[0]==="text"&&lastToken&&lastToken[0]==="text"){lastToken[1]+=token[1];lastToken[3]=token[3]}else{squashedTokens.push(token);lastToken=token}}}return squashedTokens}function nestTokens(tokens){var nestedTokens=[];var collector=nestedTokens;var sections=[];var token,section;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];switch(token[0]){case"#":case"^":collector.push(token);sections.push(token);collector=token[4]=[];break;case"/":section=sections.pop();section[5]=token[2];collector=sections.length>0?sections[sections.length-1][4]:nestedTokens;break;default:collector.push(token)}}return nestedTokens}function Scanner(string){this.string=string;this.tail=string;this.pos=0}Scanner.prototype.eos=function eos(){return this.tail===""};Scanner.prototype.scan=function scan(re){var match=this.tail.match(re);if(!match||match.index!==0)return"";var string=match[0];this.tail=this.tail.substring(string.length);this.pos+=string.length;return string};Scanner.prototype.scanUntil=function scanUntil(re){var index=this.tail.search(re),match;switch(index){case-1:match=this.tail;this.tail="";break;case 0:match="";break;default:match=this.tail.substring(0,index);this.tail=this.tail.substring(index)}this.pos+=match.length;return match};function Context(view,parentContext){this.view=view;this.cache={".":this.view};this.parent=parentContext}Context.prototype.push=function push(view){return new Context(view,this)};Context.prototype.lookup=function lookup(name){var cache=this.cache;var value;if(cache.hasOwnProperty(name)){value=cache[name]}else{var context=this,intermediateValue,names,index,lookupHit=false;while(context){if(name.indexOf(".")>0){intermediateValue=context.view;names=name.split(".");index=0;while(intermediateValue!=null&&index<names.length){if(index===names.length-1)lookupHit=hasProperty(intermediateValue,names[index])||primitiveHasOwnProperty(intermediateValue,names[index]);intermediateValue=intermediateValue[names[index++]]}}else{intermediateValue=context.view[name];lookupHit=hasProperty(context.view,name)}if(lookupHit){value=intermediateValue;break}context=context.parent}cache[name]=value}if(isFunction(value))value=value.call(this.view);return value};function Writer(){this.cache={}}Writer.prototype.clearCache=function clearCache(){this.cache={}};Writer.prototype.parse=function parse(template,tags){var cache=this.cache;var cacheKey=template+":"+(tags||mustache.tags).join(":");var tokens=cache[cacheKey];if(tokens==null)tokens=cache[cacheKey]=parseTemplate(template,tags);return tokens};Writer.prototype.render=function render(template,view,partials,tags){var tokens=this.parse(template,tags);var context=view instanceof Context?view:new Context(view);return this.renderTokens(tokens,context,partials,template,tags)};Writer.prototype.renderTokens=function renderTokens(tokens,context,partials,originalTemplate,tags){var buffer="";var token,symbol,value;for(var i=0,numTokens=tokens.length;i<numTokens;++i){value=undefined;token=tokens[i];symbol=token[0];if(symbol==="#")value=this.renderSection(token,context,partials,originalTemplate);else if(symbol==="^")value=this.renderInverted(token,context,partials,originalTemplate);else if(symbol===">")value=this.renderPartial(token,context,partials,tags);else if(symbol==="&")value=this.unescapedValue(token,context);else if(symbol==="name")value=this.escapedValue(token,context);else if(symbol==="text")value=this.rawValue(token);if(value!==undefined)buffer+=value}return buffer};Writer.prototype.renderSection=function renderSection(token,context,partials,originalTemplate){var self=this;var buffer="";var value=context.lookup(token[1]);function subRender(template){return self.render(template,context,partials)}if(!value)return;if(isArray(value)){for(var j=0,valueLength=value.length;j<valueLength;++j){buffer+=this.renderTokens(token[4],context.push(value[j]),partials,originalTemplate)}}else if(typeof value==="object"||typeof value==="string"||typeof value==="number"){buffer+=this.renderTokens(token[4],context.push(value),partials,originalTemplate)}else if(isFunction(value)){if(typeof originalTemplate!=="string")throw new Error("Cannot use higher-order sections without the original template");value=value.call(context.view,originalTemplate.slice(token[3],token[5]),subRender);if(value!=null)buffer+=value}else{buffer+=this.renderTokens(token[4],context,partials,originalTemplate)}return buffer};Writer.prototype.renderInverted=function renderInverted(token,context,partials,originalTemplate){var value=context.lookup(token[1]);if(!value||isArray(value)&&value.length===0)return this.renderTokens(token[4],context,partials,originalTemplate)};Writer.prototype.indentPartial=function indentPartial(partial,indentation,lineHasNonSpace){var filteredIndentation=indentation.replace(/[^ \t]/g,"");var partialByNl=partial.split("\n");for(var i=0;i<partialByNl.length;i++){if(partialByNl[i].length&&(i>0||!lineHasNonSpace)){partialByNl[i]=filteredIndentation+partialByNl[i]}}return partialByNl.join("\n")};Writer.prototype.renderPartial=function renderPartial(token,context,partials,tags){if(!partials)return;var value=isFunction(partials)?partials(token[1]):partials[token[1]];if(value!=null){var lineHasNonSpace=token[6];var tagIndex=token[5];var indentation=token[4];var indentedValue=value;if(tagIndex==0&&indentation){indentedValue=this.indentPartial(value,indentation,lineHasNonSpace)}return this.renderTokens(this.parse(indentedValue,tags),context,partials,indentedValue)}};Writer.prototype.unescapedValue=function unescapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return value};Writer.prototype.escapedValue=function escapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return mustache.escape(value)};Writer.prototype.rawValue=function rawValue(token){return token[1]};mustache.name="mustache.js";mustache.version="3.1.0";mustache.tags=["{{","}}"];var defaultWriter=new Writer;mustache.clearCache=function clearCache(){return defaultWriter.clearCache()};mustache.parse=function parse(template,tags){return defaultWriter.parse(template,tags)};mustache.render=function render(template,view,partials,tags){if(typeof template!=="string"){throw new TypeError('Invalid template! Template should be a "string" '+'but "'+typeStr(template)+'" was given as the first '+"argument for mustache#render(template, view, partials)")}return defaultWriter.render(template,view,partials,tags)};mustache.to_html=function to_html(template,view,partials,send){var result=mustache.render(template,view,partials);if(isFunction(send)){send(result)}else{return result}};mustache.escape=escapeHtml;mustache.Scanner=Scanner;mustache.Context=Context;mustache.Writer=Writer;return mustache});


function assignCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy adds the current user to customer segment, specified in the activity*/
    
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
    $.ajax({
      url: espotServiceUrl,
      dataType: "html",
      async: true,
      success: function(data) {
        console.log("User added to customer segment correctly");
        /* Reload page after 1st cookie creation so that the espots related to cookie can work */
        if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
             if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
                 var redirectUrl = removeParam("promo",window.location.href);
                 window.location = redirectUrl; // Reload without promo parameter
             }else{
            	 if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
            		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
            	 }
             }	   
          }
      },
      error: function(data){
        console.log("Error adding user to customer segment");
      }
    });
}
     

     
function removeCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy removes the current user to customer segment, specified in the activity*/
 
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();

    $.ajax({
        url: espotServiceUrl,
        dataType: "html",
        success: function(data) {
          console.log("User removed to customer segment correctly");
          /* Reload page after 1st cookie creation so that the espots related to cookie can work */
          if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
            if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
              var redirectUrl = removeParam("promo",window.location.href);
              window.location = redirectUrl; // Reload without promo parameter
              }else{
            	  if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
             		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
             	 }
             }	 
           }
        },
        error: function(data){
          console.log("Error removing user to customer segment");
        }
    });
     
}

/*function activateCustomerWeek(){
        if(typeof getCookie(CustomerWeek.cookieName) == "undefined" || getCookie(CustomerWeek.cookieName) == ""){
        var date = new Date();
        date.setDate(date.getDate() + 14);
        setCookie(CustomerWeek.cookieName,CustomerWeek.cookieValue, {path:'/', domain:cookieDomain, expires:date.toUTCString()});
        customerWeekActive=true;
        
        if (typeof ct_customerWeek_cookieCheck !== "undefined") { 
          ct_customerWeek_cookieCheck(); //It's a content team function
          } 
      }
}*/


function assignCustomerSegment(segment){
  try {
      var currentDate = new Date();
      if ($("#customerSegmentJSONdata .left_espot").text().length > 0) {
        window.segmentsArray = JSON.parse($("#customerSegmentJSONdata .left_espot").text());
        if (segmentsArray != undefined && segmentsArray.length>0){ 
          var userCSegmentsList = [];
          $(segmentsArray).each(function(){
              /* segment is an optional parameter used to search for a specific segment without scrolling the whole segmentsArray */
              if (segment == undefined || this.customerSegment == segment){
              /* Check expiration date */
              this.startDate = new Date(this.startDate);
              this.endDate = new Date(this.endDate);
              if (this.startDate <= currentDate && currentDate <= this.endDate){
                  if(!(document.cookie.includes('X_WC_PR_SEGMENTS'))) {
                    var currentActiveSegment = this;
                    /* Call REST Service with all current customer segments */
                    userCSegmentsList = getUserSegments();
                    $(userCSegmentsList).each(function(){
                      var activeUserSegment = (this.segments != "") ? this.segments.replace("PST","").replaceAll("_","").toLowerCase() : "";
                      if (currentActiveSegment.customerSegment.toLowerCase() != activeUserSegment){
                        /* Set cookie with active customerSegment */
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                        /* Call the proper Web activity URL to add the customer to the promotional segment Early Access */
                        assignCustomerSegmentToUser("AddToCustomerSegment_Espot");
                      /*
                      } else {
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                      */
                      }
                    });
                  } else window.customerSegment = getCookie('X_WC_PR_SEGMENTS');
              } else if (currentDate > this.endDate && document.cookie.includes('X_WC_PR_SEGMENTS')){
                /* Delete X_WC_PR_SEGMENTS cookie */
                var customerSegment = getCookie("X_WC_PR_SEGMENTS");
                setCustomerSegmentCookie(customerSegment, this.endDate)
                /* Call the proper Web activity URL to remove the customer from the promotional segment Early Access */
                removeCustomerSegmentToUser("RemoveFromCustomerSegment_Espot");
              }
            }
          });
        }
      }
      //  Hide PDP tooltip [Replaced by Activity]
      /*
      if (document.cookie.includes('X_WC_PR_SEGMENTS')) {
        $("<style type='text/css'> #customerSegmentTooltip { display: none; } </style>").appendTo("head");
      }
      */
  } catch (e) {
    	console.error("Error in assigning customer segment",e);
    }
}

function setCustomerSegmentCookie(customerSegment, endDate){

    setCookie("X_WC_PR_SEGMENTS", customerSegment, {path:'/', domain:cookieDomain, expires: endDate});
    window.customerSegment = customerSegment;
}

/* This function gets all the customer segments active on user */

function getUserSegments(){

  var userSegments;
  var userId = getUserId();
  if (userId == "-1002") userId = setUserIdentity();
  var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/earlyaccess/" + "?userId=" + userId;

  $.ajax({
      url: url,
      method: "GET",
      async: false,
      success: function(data) {
        console.log("User customer segments retrieved correctly");
        userSegments = data;
      },
      error: function(data){
        console.log("Error retrieving user customer segments");
      }
  });
  return userSegments;
}



function closeTooltip(){
  $("#customerSegmentTooltip .closeButton").parent().hide();
}




function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}


/* WISHLIST */

function addProductToWishlist(productIdToAdd,wishlistDiv){

    var defaultWishlistExternalId = sessionStorage.defaultWishlistExternalId;

    //  When generic user, create new user Id
    var userId = getUserId();
    if (userId == "-1002") userId = setUserIdentity();

    //If default wishlist doesn't exist, create it and add item
    if (typeof defaultWishlistExternalId == "undefined" || defaultWishlistExternalId == ""){
        var wishlistData = {};
        var itemData = {};
        itemData.productId = productIdToAdd;//productDisplayJS.changedCatEntryId;
        itemData.quantityRequested = "1.0";
        wishlistData.item = itemData;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist";
        wishlistUpdateAjaxRequestOngoing = true;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "POST",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: JSON.stringify(wishlistData),
                success: function(data, textStatus, jqXHR){
                    console.log("WishList created and item added successfully:", data);
                    defaultWishlistExternalId = data.uniqueID;
                    sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;
                    //Once added item to wishlist, add it to wishlistObj
                    var addedProductIdArray = [];
                    addedProductIdArray.push(productIdToAdd);
                    var giftListItemID = data.item[0].giftListItemID;
                    retrieveWishlistProductsData(false, addedProductIdArray, giftListItemID);
                    resolve(data);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Error while creating WishList and adding item:", wishlistData);
                    console.log("Status: " + textStatus + " ; Error: " + errorThrown);
                    reject(errorThrown);
                },
                complete: function(){
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            });
        })

    } else {
        var wishlistData = {};
        var itemData = {};
        itemData.productId = productIdToAdd;
        itemData.quantityRequested = "1.0";
        wishlistData.item = itemData;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/" + defaultWishlistExternalId + "?addItem=true";
        wishlistUpdateAjaxRequestOngoing = true;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: "PUT",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: JSON.stringify(wishlistData),
                success: function(data, textStatus, jqXHR){
                    console.log("WishList updated and item added successfully:", data);
                    defaultWishlistExternalId = data.uniqueID;
                    sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;
                    //Once added item to wishlist, add it to wishlistObj
                    var addedProductIdArray = [];
                    addedProductIdArray.push(productIdToAdd);
                    var giftListItemID = data.item[0].giftListItemID;
                    retrieveWishlistProductsData(false, addedProductIdArray, giftListItemID);
                    // setWishListIconAsFavorite("${catalogEntryDetails.uniqueID}");
                    resolve(data);
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Error while updating WishList and adding item:", wishlistData);
                    console.log("Status: " + textStatus + " ; Error: " + errorThrown);
                    reject(errorThrown);
                },
                complete: function(){
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            });
        });
    }
}

function deleteProductFromWishlist(productIdToRemove,wishlistDiv){

    var wishlistUpdateAjaxRequestOngoing = false;

    if (!wishlistUpdateAjaxRequestOngoing){

        var defaultWishlistExternalId = sessionStorage.defaultWishlistExternalId;
        var wishlistObj = sessionStorage.wishlistObj;
        
        if (typeof productIdToRemove != "undefined" && productIdToRemove != "" && typeof wishlistObj != "undefined" ){
            var wishlistData = JSON.parse(wishlistObj);
            if(wishlistData[productIdToRemove] != undefined){
                var giftListItemId = wishlistData[productIdToRemove].giftListItemID;
            }

            if (typeof defaultWishlistExternalId != "undefined" && defaultWishlistExternalId != "" && giftListItemId != ""){

                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/" + defaultWishlistExternalId + "?itemId=" + giftListItemId;
                wishlistUpdateAjaxRequestOngoing = true;

                return new Promise((resolve, reject) => {            
                    $.ajax({
                        url: url,
                        type: 'DELETE',
                        success:function(data, textStatus, jqXHR){
                            console.log("Product deleted from WishList:", data);
                            //Once removed item from wishlist, remove it from wishlistObj
                            manageWishlistObject(undefined,undefined,productIdToRemove,giftListItemId,undefined);
                            var productData = JSON.parse(sessionStorage.wishlistObj);
                            var wishlistToDeleteData = {};
                            wishlistToDeleteData.isWishlistProductToDelete = true;
                            wishlistToDeleteData.productIdToRemove = productIdToRemove;
                            // If you are in the wishlist page, reload tiles without redirect
                            if ($("#page").hasClass("wishListDisplay")){
                                // If an item is removed from wishlist, render tiles again without refreshing page
                                $("#wishlist_grid .product_image[data-id=" + productIdToRemove + "]").parents("li").remove();
                                fn_plpFirstTiles(productData,undefined,true,wishlistToDeleteData);
                            }
                            resolve(data);
                        },
                        error:function(jqXHR, exception){
                            var msg = "";
                            if (jqXHR.status === 0) {
                                msg = "Not connected.\n Verify Network.";
                            } else if (jqXHR.status == 404) {
                                msg = "Requested page not found. [404]";
                            } else if (jqXHR.status == 500) {
                                msg = "Internal Server Error [500].";
                            } else if (exception === "parsererror") {
                                msg = "Requested JSON parse failed.";
                            } else if (exception === "timeout") {
                                msg = "Time out error.";
                            } else if (exception === "abort") {
                                msg = "Ajax request aborted.";
                            } else {
                                msg = "Uncaught Error.\n" + jqXHR.responseText;
                            }
                            console.log("Error while deleting product from WishList:", msg);
                            reject(msg);
                        },
                        complete:function(){
                            wishlistUpdateAjaxRequestOngoing = false;
                        }
                    });
                });
            }
        }
    }
}



function yieldToMain () {
	  return new Promise(resolve => {
	    setTimeout(resolve, 0);
	  });
 }


// Retrieve wishlist info from default wishlist 
// users can have multiple wishlists but we are just considering the default one
async function getWishlistProducts(){

    var wishlistUpdateAjaxRequestOngoing = false;

    
    await yieldToMain();
    var userId = getUserId();
    await yieldToMain();
    
    if (userId == "-1002") userId = setUserIdentity(); 

    return new Promise((resolve, reject) => {

        wishlistUpdateAjaxRequestOngoing = true;

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/wishlist/@default";
        var parameters = {};
        parameters["timestamp"] = Date.now();

        $.ajax({
            url: url,
            type: 'GET',
            async: false,
            data: parameters,
            success: function(data) {
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    }).then(function(defaultWishlistInfo){
        console.log("defaultWishlistInfo:",defaultWishlistInfo);
        if (defaultWishlistInfo==null){
            return null;
        } else {
            if (typeof defaultWishlistInfo.GiftList != "undefined"){
                defaultWishlistExternalId = defaultWishlistInfo.GiftList[0].externalIdentifier;
                sessionStorage.defaultWishlistExternalId = defaultWishlistExternalId;

                if (typeof defaultWishlistExternalId != "undefined"){
                    var wishlistProductIdsArray = [];
                    var giftListItemsArray = defaultWishlistInfo.GiftList[0].item;
                    if (giftListItemsArray.length>0){
                            /*
                            if (item.productId == productDisplayJS.changedCatEntryId){
                                setWishListIconAsFavorite("${catalogEntryDetails.uniqueID}");
                                break;
                            }
                            */
                        
                        retrieveWishlistProductsData(true, giftListItemsArray);
                        wishlistUpdateAjaxRequestOngoing = false;
                    }
                } else {
                    //Empty wishlist case
                    console.log("WishList is empty");
                    wishlistUpdateAjaxRequestOngoing = false;
                }
            } else {
                //Empty wishlist case
                console.log("WishList is empty");
                wishlistUpdateAjaxRequestOngoing = false;
            }

            if (typeof wishlistProductIdsArray == "undefined"){
                var wishlistProductIdsArray = [];
            }
        }
    }).catch(function(){
        console.log("WishList info not found");
        wishlistUpdateAjaxRequestOngoing = false;
    });
}

//Create and update JSON Object with wishlist's products info
function manageWishlistObject(wishlistProductBeansData, wishlistProductsData, removedProductId, giftListItemID, productsGiftListObj, addedProductId) {

    if (typeof wishlistProductsData != "undefined"){
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObj = JSON.parse(sessionStorage.wishlistObj);
        } else {
            var wishlistObj = {};
        }

        $.each(wishlistProductBeansData.catalogEntryView, function (index, productBean){
            $.each(wishlistProductsData.catalogEntryView, function(index, product){
                if (productBean.uniqueID == product.parentCatalogEntryID){
                    var productId = product.uniqueID;
                    wishlistObj[productId] = product;
                    wishlistObj[productId].attributes = wishlistObj[productId].attributes.concat(productBean.attributes);

                    if (typeof productsGiftListObj != "undefined"){
                        wishlistObj[productId].giftListItemID = productsGiftListObj[productId];
                    }
                    if (typeof giftListItemID != "undefined"){
                        wishlistObj[productId].giftListItemID = giftListItemID;
                    }
                }
            });
        });


        sessionStorage.setItem("wishlistObj", JSON.stringify(wishlistObj));
        setNumberWishlistProduct($('.header_wishlist_container'), undefined);//update counter
        var partNumber = wishlistProductsData.catalogEntryView[0].partNumber;
        tealiumPushWishlistAdd(wishlistObj, addedProductId, partNumber); 
        console.log("wishlistObj: ", JSON.parse(sessionStorage.wishlistObj));
    } else if(typeof removedProductId != "undefined" && removedProductId != ""){  //remove item from wishlistObj
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObj = JSON.parse(sessionStorage.wishlistObj);

            delete wishlistObj[removedProductId];

            sessionStorage.setItem("wishlistObj", JSON.stringify(wishlistObj));
            setNumberWishlistProduct($('.header_wishlist_container'));//update counter
            console.log("wishlistObj: ", JSON.parse(sessionStorage.wishlistObj));
        } 
    }
}

// This function retrieves all the wishlist products details, given the IDs array of the products 
// in the wishlist
function retrieveWishlistProductsData(isGetWishlistProducts, products, giftListItemID) {

    var productIds = [];
    var productsGiftListObj = {};

    for(var i = 0; i<products.length; i++){
        var product = products[i];
        if (!isGetWishlistProducts){
            productIds.push(product);
        } else {
            productIds.push(product.productId);
            productsGiftListObj[product.productId] = product.giftListItemID; //object with productId and giftListItemId association -> { productId : giftListItemID }
        }
    }
  
    if (productIds.length > 0) {
        // Compose service url
        var productServiceUrl =
          (isInToolkit ? "" : WCParamJS.homePageURL) +
          "/search/resources/store/" +
          WCParamJS.storeId +
          "/productview/byIds?id=" +
          productIds.join("&id=") +
          "&catalogId=" +
          WCParamJS.catalogId +
          "&responseFormat=json&langId=" +
          WCParamJS.langId +
          "&currency=" +
          WCParamJS.commandContextCurrency +
          "&profileName=LUX_findProductByIds_Details" +
          ((window.customerSegment != undefined && window.customerSegment != "") ? ("&customerSegment=" + window.customerSegment) : "")
          ;
      
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: productServiceUrl,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                data: "",
                async: false,
                success: function(data) {                   
                    resolve(data);
                },
                error: function(error) {
                    console.error(error);
                    reject(error);
                }
            });
        })
        .then(function(data){
            retrieveWishlistProductBeansData(data, giftListItemID, productsGiftListObj, products);
        });
    }
}

// We retrieve the productBeans data of the wishlist items to add more attributes (color name, badges, ecc..)
function retrieveWishlistProductBeansData(wishlistItemBeansData, giftListItemID, productsGiftListObj, addedProductId){
    
    var productBeansIds = [];

    for(var i = 0; i < wishlistItemBeansData.catalogEntryView.length; i++){
        var productBeanId = wishlistItemBeansData.catalogEntryView[i].parentCatalogEntryID;
        productBeansIds.push(productBeanId);
    }
    
    if (productBeansIds.length > 0) {
        // Compose service url
        var productServiceUrl =
          (isInToolkit ? "" : WCParamJS.homePageURL) +
          "/search/resources/store/" +
          WCParamJS.storeId +
          "/productview/byIds?id=" +
          productBeansIds.join("&id=") +
          "&catalogId=" +
          WCParamJS.catalogId +
          "&responseFormat=json&langId=" +
          WCParamJS.langId +
          "&currency=" +
          WCParamJS.commandContextCurrency +
          "&profileName=LUX_findProductByIds_Details" +
          ((window.customerSegment != undefined && window.customerSegment != "") ? ("&customerSegment=" + window.customerSegment) : "")
          ;
      
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: productServiceUrl,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                data: "",
                async: false,
                success: function(data) {                   
                    resolve(data);
                },
                error: function(error) {
                    console.error(error);
                    reject(error);
                }
            });
        })
        .then(function(data){
            manageWishlistObject(data, wishlistItemBeansData, undefined, giftListItemID, productsGiftListObj, addedProductId);
        });
    }
}

//this function manages the user's click on the wishlist icon:
//if the product is present it removes it 
//if it is not present in the wishlist it adds it
function manageWishlistAction(wishlistDiv,isCart){
    var productId = $(wishlistDiv).attr("data-catentryIdItem-wishlist");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var isPlp = $(".plp").length > 0 ? true : false;
    var isDesktop = (window.tabletPortraitCheck() || window.mobilecheck()) ? false : true;
    var wishlistTotalDiv = $('.header_wishlist_container');
    var searchedWord = $('input.searchInput').val().toLowerCase();
    var isList = $('.grid_mode').hasClass('grid_mode-one-col');

    if(productId != null && typeof productId != 'undefined'){
        if($(wishlistDiv).hasClass("wishlist_product")){
            if(!isCart){
                setNumberWishlistProduct(wishlistTotalDiv, false);
                deleteProductFromWishlist(productId,wishlistDiv);
                //delete class wishlist_product
                if(typeof wishlistDiv != 'undefined'){
                    $(wishlistDiv).removeClass("wishlist_product");
                    //fix for   HB-13632
                    $(wishlistDiv).addClass("wishlist_product_disableOnHover");
                    $(wishlistDiv).mouseleave(function(){
                        $(wishlistDiv).removeClass("wishlist_product_disableOnHover");
                    });
                    // end fix for HB-13632
                }
                if(isCart){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Cart_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                } else if(isWishlistPage){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Wishlist_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                } else if(isPlp){
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Plp_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                    //When removing a product from wishlist in PLP, change the order of the items in the carousel (wishlist products in first positions)
                    if (isDesktop){
                        var el = $('#plp_grid div[data-catentryiditem-wishlist="' + productId + '"]').parents(".plp__other-product-carousel");
                        var gridItem = $(el).parents(".grid-item");
                        var isWishlistPLPRemoved = true;
                    }
                } else {
                    tealium_data2track.push({
                        'id':'Click', 
                        'data_element_id': 'X_Pdp_Prod_RemoveWishlist',
                        'data_description': 'wishlist',
                    });
                }
            }
        }else{
            setNumberWishlistProduct(wishlistTotalDiv, true);
            addProductToWishlist(productId,wishlistDiv);
            if(typeof wishlistDiv != 'undefined'){
                if(isCart){
                    $("div[data-catentryiditem-wishlist='"+ productId +"']").addClass("wishlist_product");//add wishlist_product class if there are two same products
                }else{
                    $(wishlistDiv).addClass("wishlist_product");
                    if (isPlp && !searchedWord){
                        if (isDesktop){
                            var el = $('#plp_grid div[data-catentryiditem-wishlist="' + productId + '"]').parents(".plp__other-product-carousel");
                            if (typeof productId != "undefined" && productId != ""){
                                replaceWishlistProductImages(wishlistDiv);
                            } else {
                                console.error("Catentry default size not found");
                            }
                        }
                    }
                }
                //fix for HB-13632
                $(wishlistDiv).addClass("wishlist_product_disableOnHover");
                $(wishlistDiv).mouseleave(function(){
                    $(wishlistDiv).removeClass("wishlist_product_disableOnHover");
                });
                //end fix for HB-13632
                
            }
            if(isCart){
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Cart_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            } else if(isPlp){
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Plp_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            } else{
                tealium_data2track.push({
                    'id':'Click', 
                    'data_element_id': 'X_Pdp_Prod_AddToWishList',
                    'data_description': 'wishlist',
                    //'Click_FocusElement' : element
                });
            }
            
        }
       
    }
   
}

// When adding a color to wishlist and moving it to first position of carousel, replace and show the front image
function replaceWishlistProductImages(wishlistDiv){
    var productUniqueId = $(wishlistDiv).parent().attr("data-id");
    var imageContainer = "";
    if (isPersol){
        imageContainer = $(wishlistDiv).siblings(".product__image-container").first(); 
    } else if (isOliver) {
        imageContainer = $(wishlistDiv).siblings(".image").children().find(".image-container");
    }
    
    //Replace front image only if the product added to wishlist is not the first one in carousel
    if ($(wishlistDiv).parents(".owl-item").index() > 0){
        try {
            if (typeof $plpSearchObj != "undefined"){
                var products = $plpSearchObj.items;
                for (product in products){
                    var currItemColors = products[product];
                    for(var i = 0; i < currItemColors.length; i++) {
                        if (currItemColors[i].uniqueID == productUniqueId){
                            if(currItemColors[i] != undefined && currItemColors[i].attributes != undefined) {
                                for(var m = 0; currItemColors[i].attributes.length > m; m++) {
                                    if(currItemColors[i].attributes[m].identifier === 'MODELNAME' && currItemColors[i].attributes[m].usage === 'Descriptive' ) {
                                        var modelNameValue = currItemColors[i].attributes[m].values[0].value;
                                    }
                                }
                            }
                            var isClipon = modelNameValue.toLowerCase().includes('clip');
                            var mustacheObj = {
                                modelName: modelNameValue != undefined ? modelNameValue : '',
                                image: function () {
                                    var stringOfThumbnail = null;
                                    if (isOliver){
                                        stringOfThumbnail =  replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                    } else  {
                                        stringOfThumbnail =  replaceTileImgByDevice(currItemColors[i].thumbnail,'sclw=0.25&sclh=0.25','small');
                                    }
                                    return stringOfThumbnail;
                                },
                                imageScaled: function () {
                                    if (isOliver){
                                        // OP: scaling of 25% on mobile
                                        return replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                    } else  {
                                        // PO: scaling of 25% on mobile
                                        return replaceTileImgByDevice(currItemColors[i].thumbnail,'sclw=0.25&sclh=0.25','small');
                                    }
                                },
                                replaceImageUrl: function () {
                                    var replaceImage = null;
                                    if (currItemColors[i].thumbnail != undefined) {
                                        if (isOliver){
                                            // OP: using of OV_OpPlp
                                            if (isClipon) {
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                            }else{
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                                            }                                       
                                        } else {
                                            if (isClipon) {
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail, 'sclw=0.25&sclh=0.25', 'small');
                                            }else{
                                                replaceImage = replaceTileImgByDevice(currItemColors[i].thumbnail2,'sclw=0.25&sclh=0.25','small');
                                            }
                                        }
                                    }else{
                                        replaceImage = currItemColors[i].thumbnail;
                                    }
                                    return replaceImage;
                                },
                                replaceImageUrlScaled: function () {
                                    if (currItemColors[i].thumbnail != undefined) {
                                        if (isOliver){
                                            // OP: scaling of 25% on mobile
                                            if (isClipon) {
                                                return replaceTileImgByDevice(currItemColors[i].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                            }
                                            return replaceTileImgByDevice(currItemColors[i].thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                                        } else {
                                            // PO: scaling of 25% on mobile
                                            if (isClipon) {
                                                return replaceTileImgByDevice(currItemColors[i].thumbnail, 'sclw=0.25&sclh=0.25', 'small');
                                            }
                                            //AC: effettuate modifiche per persol anche se non indicate nel file excel
                                            return replaceTileImgByDevice(currItemColors[i].thumbnail2,'sclw=0.25&sclh=0.25','small');
                                        }
                                    }
                                    return currItemColors[i].thumbnail;
                                },
                            }
    
                            var templateHtml = $('#plpImageForWishlistTemplate').html();
                            html = Mustache.to_html(templateHtml, mustacheObj);
                            $(imageContainer).html(html);
                        }
                    }
                }
            }
        } catch (error) {
            console.error('Error in tile creation when adding product to wishlist', error);
        }
    }
}


// check PDP product is in wishist
function checkIsInWishlist(productId){

    if(typeof sessionStorage.wishlistObj != 'undefined'){
        var wishlistMap = JSON.parse(sessionStorage.wishlistObj);
        var productIdsInWishlist = Object.keys(wishlistMap);
  
        if(productIdsInWishlist.includes(productId)){
            return true;
        }else{
            return false;
        }
    
    }else{
        return false;
    }
    
  
  
  }

   /*wishlist*/
function init_wishlist_tooltip(){
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        $(".wishlist-icon-container").mouseenter(function(){
            $(this).addClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").show();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").show();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.not_wishlist_product").show();
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                }else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").show();
                }
            }
            
        }).mouseleave(function() {
            $(this).removeClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").hide();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }
            }
        }).click(function(){
            $(this).removeClass("onHover");
            if($(this).hasClass("wishlist_product")){
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.wishlist_product").hide();
                }
            }else{
                if (!isWishlistPage){
                    $(".infoMessage_popup_wishlist.wishlist_product").hide();
                    $(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                } else {
                    $(this).find(".infoMessage_popup_wishlist.not_wishlist_product").hide();
                }
            }
        });
    }
}


function wishlistProductAdd2Cart(itemId){  
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    if (isWishlistPage){
        if (isOliver || isPersol) { 
            manageScrollOverlay(true);
        }
        
        if($("#add2CartBtn").attr("disabled") == "disabled"){
            return false;
        } else {
            fn_minicartRefresh();
            lockShoppingBagIcon();
            setCurrentId("add2CartBtn");
            resetRequest();

            productDisplayJS.Add2ShopCartAjax(itemId,1, false);
            itemId = itemId.split("_")[1];
            productPageAdd2Cart(itemId);

            if(isPersol){
            /* product.PriceFull=="" it takes to not apply discount to products already have pst*/
            if(customerWeekActive && typeof getCookie(CustomerWeek.cookieName) !== "undefined" && getCookie(CustomerWeek.cookieName) != ""){
                addPromotionsToUser("AddToCustomerSegment_Espot");
            }
            }
            
            updateTealiumProductsAddToCart(tealiumProducts, true);                    
        
            if(brandCode == 'PO'){
                $(window).scrollTop(0);
                if(!$('#header').is(':visible')){
                    $('#header').slideDown();
                    $("#bannerTop").css("display", "flex");
                }
                hideHeaderTimeout.cancel();
                $('body').css('overflow', 'hidden');
                $('#header').attr('productAdded','yes');
                $('#header').addClass("mincartOpened")
                $('body, html').css('height', '100%');
                $('body').css('display', 'block'); 

            }else if(brandCode == 'OP') {
                $('#header').attr('productAdded','yes');
            }
        }
    }
}  

function showWishlistCTAloader(productId){
    var button = $('[data-id="' + productId + '"]').find('[id^="productPageAdd2Cart"]');
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
        $(button).removeClass("loaded");
        button = $('[data-id="' + productId + '"]').find('[id^="add2CartBtn"]');
        $(button).removeClass("loaded");

    }else{

        $(button).find(".bag-icon").hide();
        $(button).find(".loadpanel_loader").css("display","inline-block");

    }
}


function hideWishlistCTALoader(productId){
    var button = $('[data-id="' + productId + '"]').find('[id^="productPageAdd2Cart"]');
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
        $(button).addClass("loaded");
        button = $('[data-id="' + productId + '"]').find('[id^="add2CartBtn"]');
        $(button).addClass("loaded");

    }else{
        
        $(button).find(".bag-icon").show();
        $("div.loadpanel_loader").hide();
    }
 }

/* This function checks replaces the current image in the minicart with the STD one for the given partnumber */
function replaceImageMinicart(imges, partnumber){
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    if (isWishlistPage){
        $.each(imges, function(index,img){
        var urlImg= img.dataset['src'];
        if(urlImg != undefined){
            img.dataset['src'] = urlImg;
            img.src = urlImg;
            }
        });
    }
}


function setNumberWishlistProduct(wishlistTotalDiv, isWishlistAdd){

    if (typeof sessionStorage.wishlistObj != "undefined"){
        var jsonWishlistObj =  JSON.parse(sessionStorage.wishlistObj);
        var count = Object.keys(jsonWishlistObj).length;

        //Add red dot/counter even if wishlist service has not been called yet
        if (typeof isWishlistAdd != "undefined"){
            if (isWishlistAdd){
                ++count;
            } else {
                --count;
            }
        }

        if(count > 0){
            if(isPersol){
                $(wishlistTotalDiv).html(count);
            }
            $(wishlistTotalDiv).addClass("counter-visible");
        }else{
            $(wishlistTotalDiv).removeClass("counter-visible");
        }
    }
}


//This function shows the Email me CTAs in the wishlist page
function wishlistAvailabilityCheckCTA(wishlistObj, catentryId) {

    if (typeof wishlistObj != 'undefined' && typeof catentryId != 'undefined') {

        var productWishlistObjData = wishlistObj[catentryId]; 
        var wishlistInventoryMap = productWishlistObjData.inventory;

        console.debug("wishlistAvailabilityCheckCTA processing for catentryId: "+catentryId);
        
        var flagLimitedEdition = false;
        var flagExclusive = false;

        for(var i=0;productWishlistObjData.attributes.length>i; i++) {
            if (productWishlistObjData.attributes[i].identifier === 'LIMITED_EDITION' && productWishlistObjData.attributes[i].values[0].identifier === 'True'  ) {
                flagLimitedEdition = true;
                break;
            }
            if (productWishlistObjData.attributes[i].identifier === 'EXCLUSIVE' && productWishlistObjData.attributes[i].values[0].identifier === 'True' ) {
                flagExclusive = true;
                break;
            }
        }
            var lifecycle = wishlistInventoryMap["lifeCycle"];
            var stock = wishlistInventoryMap["stock"];
            var ranking = wishlistInventoryMap["ranking"];
            var flagComingSoon = wishlistInventoryMap["flComingSoon"] == 'true';
            
            var productPrice = productWishlistObjData.price.price;

            if (lifecycle == 'ACTIVE') {
                if (stock > 0 && ranking == 2 && !flagComingSoon && productPrice != ""){
                    //ADD 2 CART
                    if((flagExclusive  == true || flagExclusive == false ) && (flagLimitedEdition == true || flagLimitedEdition == false)) {
                        $('#add2CartBtn_' + catentryId).removeClass('hidden').show();
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }
                    
                } else if (stock == 0) {
                    if (ranking == 2) ranking = 1;
                    // COMING SOON - BE THE FIRST TO KNOW

                    if (ranking == 1 && flagComingSoon && (flagExclusive == true || flagExclusive == false ) && (flagLimitedEdition  == true|| flagLimitedEdition == false)) {
                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).removeClass('hidden').show();

                    } else if (ranking == 1 && !flagComingSoon && productPrice != "") {
                        // EMAIL ME WHEN AVAILABLE --> OLD COMING BACK SOON (OUT OF STOCK)

                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).addClass("hidden");
                        $('#outOfStock_' + catentryId).removeClass('hidden').show();

                    } else if (productPrice == "" || (ranking == 0 && !flagComingSoon && (flagExclusive == true || flagExclusive == false) && (flagLimitedEdition == true || flagLimitedEdition == false))) {
                        // SOLD OUT

                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).removeClass('hidden').show();
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }
                }
            } else if (lifecycle == 'INACT' ) {
                if (stock > 0 && ranking == 2 && !flagComingSoon && (flagExclusive == true || flagExclusive == false) && (flagLimitedEdition == true || flagLimitedEdition  == false) && productPrice != "") {
                    //ADD 2 CART

                    $('#add2CartBtn_' + catentryId).removeClass('hidden').show();
                    $('#soldOut_' + catentryId).addClass("hidden");
                    $('#outOfStock_' + catentryId).addClass("hidden");
                } else if (stock == 0) {
                    if (ranking == 2) ranking = 1;
                    if (productPrice == "" || ((ranking == 0 || ranking == 1) && !flagComingSoon)) {
                        // SOLD OUT
                        
                        $('#add2CartBtn_' + catentryId).addClass("hidden");
                        $('#soldOut_' + catentryId).removeClass('hidden').show();
                        $('#outOfStock_' + catentryId).addClass("hidden");
                    }  
                }
            }
    }
}

/* WISHLIST */

/* START - Logic moved from EarlyAccess.js */

function getUserId(){

    var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self";
  
    $.ajax({
        url: url,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function(data) {
            console.log("User id retrieved correctly");
            window.userId = data.userId;
        },
        error: function(data){
            console.log("Error retrieving user id");
        }
    });
    return userId;
  }
  
  /* With this function, the user is converted from a generic user (-1002) to a unique guest user  */
  
function setUserIdentity(){
  
    /*
    var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/guestidentity";
  
    $.ajax({
        url: url,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function(data) {
            console.log("Unique user id generated correctly");
            window.userId = data.userId;
        },
        error: function(data){
            console.log("Error generating unique user id");
        }
    });
    */
    var params = [];

    params.storeId      = WCParamJS.storeId;
    params.catalogId    = WCParamJS.catalogId;
    params.langId       = WCParamJS.langId;

    params.deleteCartCookie = true;
    params.globalLogIn = true;

    var url = getAbsoluteURL() + "AjaxOrderCalculate?";
    for (var param  in params) {
        url += param + "=" + params[param] + "&";
    }
    url += "calculationUsageId=-1&";
    url += "calculationUsageId=-2&";

    //Make the call to AjaxOrderCalculate
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false,
        success: function (data) {
            console.log("Unique user id generated correctly");
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log("Error generating unique user id");
        }
    });
    window.userId = getUserId();
    return userId;

}

function tealiumPushWishlistAdd(wishlistObj, productId, partNumber){
    var tealiumObjWishlist = {}
    var keys = Object.keys(wishlistObj);
    productId.forEach((product) => {
        var frameType = "STD";
        var category = "";
        var preorder = 0;
        var price = '';
        var priceFull = '';

        if(wishlistObj[product.productId] != undefined){
            wishlistObj[product.productId].attributes.forEach(function(attribute) {
                if(attribute.identifier == 'PRODUCTTYPE'){
                    category = attribute.values[0].value.toUpperCase();
                }
                if(attribute.identifier == 'PREORDER'){
                    preorder = 1;
                }
            });
            price = wishlistObj[product.productId].price.price;
            priceFull = wishlistObj[product.productId].price.listprice;
        }
    
        tealiumObjWishlist[product.partNumber]= {
            'Category' : category,
            'Preorder' : preorder,
            'FrameType' : frameType,
            'LensType' : 'PLANO',
            'Price' :   price,
            'PriceFull' : priceFull,
            'Engraving' : "N"
        }
    })
        
      
    tealium_data2track.push({
        'id':'ProdFavAdd', 
        'Products': tealiumObjWishlist
    });
}

/* END - Logic moved from EarlyAccess.js */


//This function loads the wishlist guest espot content by js
function returnEspotContent(espotName) {
    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName + '?langId=' + WCParamJS.langId;
    var content ='';
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return new Promise((resolve, reject) => {
        $.ajax({
            url: espotServiceUrl,
            type: 'GET',
            data: parameters,
            async: false,
            success: function(data) {
                data["MarketingSpotData"].forEach(function(msd, index) {
                    if(msd["baseMarketingSpotActivityData"] && msd["baseMarketingSpotActivityData"][0]["baseMarketingSpotDataType"] === "MarketingContent"){
                        content = msd["baseMarketingSpotActivityData"][0]["marketingContentDescription"][0]["marketingText"]; //html text
                    }
                });
                $("#guestWishlistEspotContent").val(content);
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    });
}


var badgeVisible = true;

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, firstSource) {
        'use strict';
        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert first argument to object');
        }

        var to = Object(target);
        for (var i = 1; i < arguments.length; i++) {
          var nextSource = arguments[i];
          if (nextSource === undefined || nextSource === null) {
            continue;
          }
          nextSource = Object(nextSource);

          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
        return to;
      }
    });
  }

// Global variables
var defaultSearchProfile = getUrlParameter('searchTerm') ? 'LUX_findProductsBySearchTerm' : 'LUX_findProductsByCategory_group';
var countSelectedFacets = 0, defaultOrderBy, selectedFacetsData = {}, selectedFacets = {}, originalHrefApply = '', previousFilter = {}, originalSelectedSort = "";
var tileIndex = 0;
var indexSearchPanel = 0;

//Filter & OrderBy variables
var queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true,
    numMaxofPages,
    index,
    isFacetApplied = false;

queryParams = {
    storeId: WCParamJS.storeId,
    catalogId: WCParamJS.catalogId,
    responseFormat: 'json',
    langId: WCParamJS.langId,
    currency: WCParamJS.commandContextCurrency,
    profileName: defaultSearchProfile,
    searchSource: 'E',
    isForPLP: true
};

var featuredProductHtml = "";

/* BEGIN - Workarounds for IE */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position)
          || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}
(function() {
	  function remove() { this.parentNode && this.parentNode.removeChild(this); }
	  if (!Element.prototype.remove) Element.prototype.remove = remove;
	  if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
	})();
/* END - Workarounds for IE */
columnsToShow = 4
//	Skeleton Loader variables
var $plpSearchObj = {};
$plpSearchObj.itemsPerPage = 0;		// infinite scroll page(group) size
$plpSearchObj.itemsFromServer = 0;	// how many to get from API
$plpSearchObj.viewIndex = 0;		// index of items to show in view
$plpSearchObj.lastIndex = 0;
$plpSearchObj.resultCount = 0;
$plpSearchObj.viewMoreClicked = false;
$plpSearchObj.viewMoreSearchCount = 0;
$plpSearchObj.viewMoreSearchStartIndex = 0;
$plpSearchObj.productsServiceUrl = function(searchedWord) {
	if(storeDirectory === 'PersolGR' && host !== 'localhost'){
        WCParamJS.homePageURL = "https://"+ host + "/greece";
    }
	var baseSearchURL = (isInToolkit ? '' : WCParamJS.homePageURL)+'/search/resources/store/'+WCParamJS.storeId+'/productview/';
	var searchTerm = getUrlParameter('searchTerm');
    /* START Early Access */
    if (isPersol) {
        if (window.customerSegment != undefined && window.customerSegment != ""){
            queryParams.customerSegment = window.customerSegment;
        }
    }
    /* END Early Access */
	if (searchTerm || searchedWord) {
		return baseSearchURL+'bySearchTerm/' + (searchedWord ? searchedWord : searchTerm); // Search Obtimization
	}
	return baseSearchURL+'byCategory/'+ document.querySelector('meta[name="pageId"]').getAttribute('content');
}
$plpSearchObj.lastIndexbkp = 0;

function fn_plpFirstTiles(productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch) {
	// # Load Espot contents (TOP e MIDDLE creati durante il render delle tile)
	if (typeof isWishlist == "undefined"){
        var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
    }

    if (!isWishlist){
        selectedFacetsData = {
            storeId : WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            fromPage: 'catalogEntryList',
            beginIndex: '0',
            responseFormat: 'json',
            orderBy: defaultOrderBy,
            categoryId: ""
        };
    } else {
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObjCount = Object.keys(JSON.parse(sessionStorage.wishlistObj)).length;
            var countString = "(" + wishlistObjCount + ")";
            $(".title-wishlist_count").html(countString);
            if (wishlistObjCount == 0){
                $("#box.wishlist").addClass("emptyWishlist");
                $("#empty-wishlist-container").removeClass("hidden");
                if (isOliver && $("#wishlistAppointmentEspot").length > 0) $("#wishlistAppointmentEspot").remove();
            } else {
                $("#box.wishlist").removeClass("emptyWishlist");
                $("#empty-wishlist-container").addClass("hidden");
            }
        }
    }

 
	$plpSearchObj.itemsPerPage = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 && sessionStorage.backItemsPerPage) ? parseInt(sessionStorage.backItemsPerPage) : columnsToShow*parseInt($("#rowsPerPage").val());			// infinite scroll page(group) size
	$plpSearchObj.itemsFromServer = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 & sessionStorage.itemsToLoad) ? parseInt(sessionStorage.itemsToLoad) : parseInt($("#itemsFromServer").val());					// how many to get from API
	//facet search page e plp credo
    
    if(document.querySelector('.plp') || document.querySelector('.search') || document.querySelector('.searchPanel') ) {
        // Get facets to show in filter by if it's not the Persol search
        /**
        // facets are excluded by search in Persol 
        if (!isWishlist){
            if (isOliver || isPersol) {
                $plpSearchObj.facetsForFilterBy = {};
                if ($('input#facetsForFilterBy').length){
                var facetsForFilterByArr = $('input#facetsForFilterBy').val().split(';');
                    for (var i=0;i<facetsForFilterByArr.length; i++) {
                        var facetArr = facetsForFilterByArr[i].split(':');
                        if (facetArr.length == 2) {
                            $plpSearchObj.facetsForFilterBy[facetArr[0]] = facetArr[1];
                            //queryParams['f.'+facetArr[1].substring(0,facetArr[1].indexOf('%3A'))+'.facet.mincount'] = 0;
                        }
                    }
                // Get facets to be ignored
                $plpSearchObj.facetsToBeIgnored = $('input#facetsToBeIgnored').val().split(';');
                }
            }
        }
        */

        setDefaultSortBy(defaultOrderBy, false, productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch);
        var pageElem = document.getElementById('page');
        var blockFilter = document.querySelector('.block-filter');
        var originalFilterParentElem = "";
        var facetButtonElem = document.querySelector('.plp-filter-button');

        //Different views buttons - By default, on mobile show 2 columns view; on desktop show 3 columns view
        if(!searchedWord){
            if (window.tabletPortraitCheck() || window.mobilecheck()){
                if (!isWishlist) {
                    $('.button-views.two-col-icon').addClass("active");
                    $('.grid_mode').addClass('grid_mode-two-cols');
                }
            }

            // ex --Apply facets when you click the apply button
            

            if(document.querySelector('.search-page')) {
                originalFilterParentElem = document.querySelector('#content > .search-page');
            } else {
                originalFilterParentElem = document.querySelector('#content > .plp');
            }

            if (document.querySelector(".facet__apply")) {
                originalHrefApply = document.querySelector(".facet__apply").getAttribute('data-href');
            }

            //show description before offset calculation: description can born displayed?
            if (isOliver){
                $('.description.descriptionDefault').css('display','flex');
                if (window.tabletPortraitCheck() || window.mobilecheck()) {
                    var espotHeight= $( "#contentRecommendationWidget_X_PLP_HeroBanner_X_PLP_HeroBanner").height();
                    //var textHeight =$(".descriptionDefault").height();
                    //var marginButtons= espotHeight - textHeight
                    //$('.plp-filter-view-button').css("margin-top","-"+$('.grid.product-list').css('margin-top'));
                }
            }

            // Change DOM facet button position to make it FIXED
                if (!isWishlist){
                    var class_startscroll = ".plp-filter-button_wrapper";
                    if (isPersol && document.querySelector('.search')) {
                        class_startscroll = ".searchSummaryWidget";
                    }
                    
                    var offset = $(class_startscroll).offset().top;
                    var totalOffset = offset;
                    if(window.mobilecheck() || window.tabletPortraitCheck()) {
                        totalOffset = offset + $(class_startscroll + ' .espot-plp-beans').outerHeight() + 56;
                    }
                } else {
                    if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex) {                    
                        //clean up the grid
                        $('.plp-grid-skeleton').remove();
                    }

                    //Remove extra empty <li> tags in wishlist page
                    if (isWishlist) {
                        if (typeof sessionStorage.wishlistObj != "undefined"){
                            var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                            var productsLength = Object.keys(wishlistProducts).length;

                            if (productsLength == 0){
                                if ($("#wishlist_grid li").length > 0) {
                                    $("#wishlist_grid li").remove();
                                }
                            } else {
                                for (var i=0 ;i<productsLength; i++){
                                    var wishlistLi = $("#wishlist_grid li")[i];
                                    if ($(wishlistLi).html() == ""){
                                        $(wishlistLi).remove();
                                    }
                                }
                            }
                        }
                    }
                }
                window.addEventListener('scroll', function() {
                    if (!isWishlist){
                    /** Sticky submenu in plp */
                        if (isPersol) {
                            if(window.mobilecheck() || window.tabletPortraitCheck()) {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() + $('#ci_espot__X_Header_GlobalBanner').height();
                                } else {
                                    var checkPersol = $(this).scrollTop() +1;
                                }
                            } else {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height() + $('#ci_espot__X_Header_GlobalBanner').height();
                                }
                                else {
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height();
                                }
                            }

                            var getBannerTopHeight = function () {
                                if($('#bannerTop').length && $('#bannerTop').is(":visible")) {
                                    return $('#bannerTop').height();
                                } else {
                                    return 0;
                                }
                            }

                            var offset2 = 0;
                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                offset2 = $(class_startscroll + " .espot-plp-beans").outerHeight() + 10;
                            }

                            if(checkPersol >= (offset + offset2)){
                                if(window.innerWidth >= 1024 && window.innerWidth < 1300 && window.matchMedia("(orientation: landscape)").matches){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else {
                                    $(class_startscroll).css('top', $('#header').height() + getBannerTopHeight()-1);
                                }

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).addClass('plp-filter-button_wrapper--sticky');
                                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", $(".plp-filter-button_wrapper").outerHeight() );
                                        $('.plp-wrapper-title').show();
                                        $('.plp-filter-button_wrapper--sticky').css("top",$('.ct-promo-banner').height());
                                    }else {
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", "168.8px" );
                                        var stripHeight = $('.ct-promo-banner').height();
                                        var headerHeight = $('#header').outerHeight();
                                        $('.plp-filter-button_wrapper--sticky').css("top",parseInt(stripHeight)+parseInt(headerHeight));
                                    }
                                }
                            }else{
                                $(class_startscroll).css('top', 'auto');

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).removeClass('plp-filter-button_wrapper--sticky');
                                    $('.plp-wrapper-title').hide();
                                    $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", 0 );
                                }
                            }
                        }
                    }
                    
                    var documentBottom = $(window).scrollTop()+$(window).outerHeight();
                    
                    if($(".plp-grid-skeleton").length > 0) {
                        var skeletonTop =  $(".plp-grid-skeleton").offset().top;
                        //retiver info origina plp 
                        
                        
                        if (skeletonTop <= documentBottom
                                && $plpSearchObj.viewIndex < $plpSearchObj.lastIndex
                                && !$plpSearchObj.busy) {
                            $plpSearchObj.viewMoreTiles($plpSearchObj.itemsPerPage);
                        }

                        if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex && $plpSearchObj.viewIndex!=0) {                    
                            //clean up the grid
                            $('.plp-grid-skeleton').remove();

                            //Remove extra empty <li> tags in wishlist page
                            if (isWishlist) {
                                if (typeof sessionStorage.wishlistObj != "undefined"){
                                    var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                                    var productsLength = Object.keys(wishlistProducts).length;

                                    if (productsLength == 0){
                                        if ($("#wishlist_grid li").length > 0) {
                                            $("#wishlist_grid li").remove();
                                        }
                                    } else {
                                        for (var i=0 ;i<productsLength; i++){
                                            var wishlistLi = $("#wishlist_grid li")[i];
                                            if ($(wishlistLi).html() == ""){
                                                $(wishlistLi).remove();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                //  Begin Change DOM filter position to make it FIXED
                if (!isWishlist){
                    if (isOliver){
                        document.querySelector('body').appendChild(blockFilter);
                    }
                }

                window.addEventListener('resize', function() {
                    if(!isWishlist){
                        if(window.innerWidth >= 1024 && blockFilter.parentNode !== originalFilterParentElem) {
                            facetButtonElem.classList.remove('scroll');
                        }
                        else if (window.innerWidth < 1024 && blockFilter.parentNode !== pageElem) {
                            document.querySelector('body').appendChild(blockFilter);
                        }
                    }
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if(isOliver) {
                            if (isWishlist){
                                $('#wishlist_grid .grid-item:not(.product-espot)').outerHeight("100%");
                            } else {
                                $('.grid-item:not(.product-espot)').outerHeight("100%");
                            }
                        } else if(isPersol) {
                            if(isWishlist){
                                $('.grid-item:not(.product-espot):not(.grid-item-search)').outerHeight("100%");

                            }else{
                                $('.grid-item:not(.product-espot)').height("100%");
                            }
                            
                        }
                    }
                    if(!isWishlist){
                        if(blockFilter.classList.contains('opend') && window.innerWidth >= 1024) {
                            document.querySelector('html').removeAttribute("style");
                            document.querySelector('body').removeAttribute("style");
                        } else if(blockFilter.classList.contains('opend') && window.innerWidth < 1024) {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
                    }
                }, true);
                //  End Change DOM filter position

                //Add classes to Persol if on mobile
                if (isPersol) {
                    if (window.tabletPortraitCheck() || window.mobilecheck()){
                        $('.sale_badge').addClass('submenu__subheader');
                        $('.sale_badge').addClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
                    } else {
                        $('.sale_badge').removeClass('submenu__subheader');
                        $('.sale_badge').removeClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
                    }
                }

                // deleted function --- see //START FILTER SECTION in non critical js 

        
          
        }
    }

        initButtonViewOnClick();

		



    // # X_PLP_SalesBeans
    if ($('#ci_espot__X_PLP_SalesBeans').length > 0) {

    	// Change event for select
    	$('select.select-bean').change(function(e) {
        	document.location.href = $(e.target).val();
        });

    	// Active/Select current dash button page
		var urlPage= window.location.href;
	    var splitUrl = urlPage.split("/");
	    var salesCategory = splitUrl[splitUrl.length - 1];
	    $('.nav-beans #' + decodeURI(salesCategory.split('?')[0])).addClass("active");
	    $("select option[value='"+salesCategory.split('?')[0]+"']").prop("selected",true);
	}
}

function initButtonViewOnClick(){
    // Change view when clicking on different buttons
    $('.button-views.one-col-icon').click(function() {
        columnsToShow = 1;
        $('.button-views').removeClass("active");
        $('.button-views.one-col-icon').addClass("active");
        $('.grid_mode').addClass('grid_mode-one-col');
        $('.grid_mode').removeClass('grid_mode-two-cols');
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").addClass("-one-col");
    });

    $('.button-views.two-col-icon').click(function() {
        columnsToShow = 2;
        $('.button-views').removeClass("active");
        $('.button-views.two-col-icon').addClass("active");
        $('#plp_grid.grid_mode').addClass('grid_mode-two-cols');
        $('#plp_grid.grid_mode').removeClass('grid_mode-one-col');
        $('#plp_grid.grid-item').removeAttr('style')
        $('.product--wrapper__container').removeAttr('style')
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").removeClass("-one-col");
    });
}

/**
 * @function setDefaultSortBy
 * @desc This function select the default sort by inside facet section
 *
 * @param {*} num
 */
function setDefaultSortBy(num, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    var sortElems = document.querySelectorAll('.facet__sortBy .facet__filter-button');
    for(var sortElem = 0; sortElem < sortElems.length; sortElem++) {
        if(sortElems[sortElem].getAttribute('data-facet') == num){
            sortElems[sortElem].parentElement.classList.add('selected');
            break;
        }
    }
    originalSelectedSort = document.querySelector('#facet__sortBy .facet__filter-noimg.selected');
    ajaxCallFacet(callbackSortBy, null, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch);
}

function ajaxCallFacet(callback, elem, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    
    if(typeof firstSearch != undefined){
        $plpSearchObj.firstSearch = firstSearch;
    }else{
        $plpSearchObj.firstSearch = undefined;
    }
    $plpSearchObj.viewIndex = 0;
    $plpSearchObj.lastIndex = 0;
    $plpSearchObj.resultCount = 0;
    $plpSearchObj.getData(isViewMore, function() {
        $plpSearchObj.attrValIdentifierObject = [];//object use to retrive indetifier value of attribute value
    	$plpSearchObj.busy = false;
    	createNewTileProducts(0,$plpSearchObj.itemsPerPage,searchedWord,isWishlist,false,wishlistToDeleteData);
        $plpSearchObj.itemsPerPage = columnsToShow*parseInt($("#rowsPerPage").val());
        $plpSearchObj.itemsFromServer = parseInt($("#itemsFromServer").val());
    	callback(elem);
    }, productData,searchedWord, isWishlist);
    if (typeof productData === 'undefined') {
        $plpSearchObj.busy = true;
    }
}

//function to load plp data 
$plpSearchObj.getData = function(isViewMore,callback,productData,searchedWord,isWishlist) {
	if (!isViewMore) {
		$plpSearchObj.items = {};
		$plpSearchObj.currentPage = 1;
		$plpSearchObj.viewIndex = 0;
		$plpSearchObj.lastIndex = 0;
        
        /*if (document.querySelector('.search')) {
            $("span[id^=searchTotalCount]").html($("span[id^=searchTotalCount]").html().replace(/\d/g, ''));
        }*/
		window.scrollTo(0,0);
	} else {
        $plpSearchObj.viewMoreClicked = true;
		$plpSearchObj.currentPage = Math.floor(($plpSearchObj.lastIndex||0)/$plpSearchObj.itemsFromServer)+1;
        
        var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
        
        for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
            var createDOMLi = document.createElement('li');
            if(isOliver) createDOMLi.classList.add('product');
            createDOMLi.classList.add('plp-grid-skeleton');
            ulGrid.appendChild(createDOMLi);
        }
        // 	$('.product--wrapper').height($('.product').width());
        // }
    } 
	
    if (isPersol) {
    	$('.skeleton .product--wrapper').height($('.skeleton .product-container').width() * (400/360));
    }

    $plpSearchObj.queryParams = queryParams;
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['categoryId'] = '';
    }else{
        $plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
    }
	if (selectedFacetsData["orderBy"]) {
		$plpSearchObj.queryParams['orderBy'] = selectedFacetsData["orderBy"];
	    if (isPriceOrdering()) {
	    	queryParams['profileName'] = 'LUX_findProductsByCategory';
	    } else if (isNewArrivalsOrdering() && getUrlParameter('searchTerm') == null) {
	    	queryParams['profileName'] = defaultSearchProfile+'_new_first';
	    } else {
	    	queryParams['profileName'] = defaultSearchProfile;
	    }
	} else {
		delete $plpSearchObj.queryParams['orderBy'];
    	queryParams['profileName'] = defaultSearchProfile;
	}
	if (!categoryToGroupTile()) {
		queryParams['profileName'] = 'LUX_findProductsByCategory';
	}
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['facet'] = [];
    }else{
        $plpSearchObj.queryParams['facet'] = facetArr;
    }
    

    var ajaxPLPSuccess = function(data) {
    	
    	   if(location.href.includes("facet") && !$plpSearchObj.viewMoreClicked){
           	tileIndex = 0;
           }

        $plpSearchObj.resultCount = !isWishlist ? data.recordSetTotal : Object.keys(data).length;
        var dataRecordCount = !isWishlist ? data.recordSetCount : Object.keys(data).length;
        if (dataRecordCount === 0) {
        	var dataSpellCheck = '';
        	if ($('.suggestions_container .suggestion').length > 0){
        		dataSpellCheck = $('.suggestions_container .suggestion')[0].text;
        	} else if (data.metaData){
        		dataSpellCheck = data.metaData.spellcheck[0];
        	}
        	if (dataSpellCheck){
        		$.ajax({
                    url: $plpSearchObj.productsServiceUrl(dataSpellCheck),
                    type: 'GET',
                    async: true,
                    data: $.param($plpSearchObj.queryParams,true),
                    success: ajaxPLPSuccess,
                    error: function(error) {
                    	return error;
                    }
                });
        	} else {
                if(searchedWord && typeof $plpSearchObj.firstSearch == undefined){//no result in search panel 
                    searchError(true);
                    resetSearchTile(true);//resetFeature
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(searchedWord && $plpSearchObj.firstSearch ){//no result in search panel firstsearch
                    searchError(true);
                    resetSearchTile(true);
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(isWishlist){
                    $("#wishlist_grid li .grid-item").remove(); //wishlist is empty
                }else {
                    //	Hide View More button
                    //populateUtagDataAfterAjax();
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                    if (isOliver && getUrlParameter('searchTerm') === null){
                        $('#noProducts').css('display','block');
                        //add default empty element in plp_grid for wcag
                        var createDOMProduct = document.createElement('li');
                        createDOMProduct.classList.add('grid-item');
                        createDOMProduct.setAttribute('id','dummyElement');
                        ulGrid.appendChild(createDOMProduct);
                    }

                }
                
            }
        }
        
        else if (dataRecordCount > 0) {
        	if(($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm' && $('.suggestions_container .suggestion').length > 0 && $('.suggestions_container .suggestion')[0].text.toLowerCase() != (data.catalogEntryView[0].name).toLowerCase())){
        		for (var i = 0; i < dataRecordCount; i++) {
        			if($('.suggestions_container .suggestion')[0].text.toLowerCase() == (data.catalogEntryView[i].name).toLowerCase()){
        				var shortDescription = (data.catalogEntryView[i].shortDescription);
        				$.ajax({
                            url: $plpSearchObj.productsServiceUrl(shortDescription),
                            type: 'GET',
                            async: true,
                            data: $.param($plpSearchObj.queryParams,true),
                            success: ajaxPLPSuccess,
                            error: function(error) {
                            	return error;
                            }
                        });
        				break;
        			}
        		}
        	}
            var results = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord ? data.catalogEntryView : (isWishlist ? data : data.catalogEntryGroupView); 
             // Display message when no products are shown
            $('#noProducts').css('display','none');
            //delete dummyElement in plp_grid for WCAG
            $('#dummyElement').remove();
            if(searchedWord){
                searchError(false);
                $(".title_result").hide();
                $(".redirect_result_container").css("display","flex");
                $(".redirect_result_container .redirect_result_link").show()
                $(".redirect_result_link #serched_word").html($('input:text[name=searchInput]').val());
                
            }
            /* populate items */
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord) {
                $.each(results, function(key,value) {
                    $plpSearchObj.items[(parseInt(key)+($plpSearchObj.itemsFromServer*($plpSearchObj.currentPage-1)))] = value;
                    
                });
                if(!searchedWord){
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            } else {
                //  START - Email me sorting by inventory
                function fn_sortByInventory(p) {
                    var r = 0;
                    if (p['inventory']
                            && p['inventory']['ranking']
                            && p['inventory']['flComingSoon']) {
                        r = p['inventory']['ranking'] + (p['inventory']['flComingSoon'] == 'true' ? 0.5 : 0);
                    }
                    return r; 
                }
                if (!isWishlist){
                    $.each(results,function(group,products) {
                        products.sort(function(a, b){
                            var sortedResults = fn_sortByInventory(b) - fn_sortByInventory(a);
                            return sortedResults;
                        });
                    });
                }
                //  END - Email me sorting by inventory
                Object.assign($plpSearchObj.items,results);
                if(!searchedWord){
                    //search Optimization save PLP items info 
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            }

            //  LCP
            /*
            let count = 0;
            $.each($plpSearchObj.items,function (key,value) {
                if (count == 0
                        && value[0] != undefined) {
                    var lcp = new Image();
                    if (isOliver){
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else if (isPersol) {
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail,'sclw=0.25&sclh=0.25','small');
                    }
                    return false;
                }
            });
            */

            /*populate tealiumProducts HB-5614*/
            var status = 'undefined';
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) {
                if(typeof tealiumProducts === 'undefined'){
                     tealiumProducts = {};
                }
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        var category = "";
                        if(pageType=='Wishlist'){
                        	category = getAttributeValue(value.attributes,"PRODUCTTYPE");
                        	category = category.toLowerCase();
                        	
                        	if(category.includes("sun")){
                        		category = "SUN";
                        	}
                        	if(category.includes("optical")){
                        		category = "OPTICS";
                        	}
                        	
                        	if(category.includes("accessories")){
                        		category = "ACCESSORIES"; 
                        	}
                        }else{
                        	category = getCategoryName(key ,"_")
                        }
                        
                        tealiumProduct['Category'] = category; 
                        tealiumProduct['Price'] = parseFloat(value['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value.inventory);
                        $(addProductsToTealium(value.partNumber,tealiumProduct)); // fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(e);
                    }
                });
            }
            else {
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        tealiumProduct['Category'] = getCategoryName(key ,"_");
                        tealiumProduct['Price'] = parseFloat(value[0]['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value[0]['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value[0].inventory);
                        $(addProductsToTealium(value[0].partNumber,tealiumProduct));// fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(value[0]);
                    }
                });
            }
            
            
            if(pageType=='Search'){
               var obj = {};
               obj['Search_Keyword'] = getUrlParameter('searchTerm');
               obj['Search_ResultItemsQnt'] = $plpSearchObj.resultCount;
               obj['Search_View'] = 'SERP';
               obj['Event_Source'] = 'SERP'
               pushDataToTealium(obj)
            } 
            
            if (typeof monetateQ !== 'undefined'){
                  monetateTrackPlp();
            }

            /*END 5614*/
    
            if(!searchedWord){
                if($plpSearchObj.lastIndexbkp > 0 && !$plpSearchObj.isFilterPanel){ // search Optimization  if is after search and not use filter
                    $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp
                    $plpSearchObj.lastIndex += Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex;
                }else{
                    //if apply filter 
                    $plpSearchObj.lastIndex = Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex
                    $plpSearchObj.isFilterPanel = false;
                }
 
                
            }
            
            $plpSearchObj.loading = false;
            if (typeof callback == 'function') {
            	if($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm'){
            		resetSearchTile(false,false,false);
            	}
            	callback();
            }

            /* facets are included only in PLP */
            if (!isWishlist){
                if(!searchedWord){
                    closeFilterMenu();
                    isFacetApplied = true;
                    originalSelectedSort = $('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en");
                    if(countSelectedFacets == 0) {
                        $(".facet__apply").removeClass('show');
                        document.querySelector('.facet__widget').classList.remove('active');
                        isFacetApplied = false;
                    }
                }
            }

            //	View More button
            if (!isWishlist){
                if ($plpSearchObj.resultCount-$plpSearchObj.lastIndex <= 0) {
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                } else {
                    $('.plp__view-more.button.secondary').show();
                }
            }

            if (!isViewMore) {
                /* facets are excluded by search in Persol */
                if (!searchedWord) { // SearchOptimiztion ! (isPersol && getUrlParameter('searchTerm'))
                    //	Inner function used to handle filters drawing and toggle
                    if (!isWishlist){

                        var filtersHandling = function(dataPartial,dataAll) {
                        // $plpSearchObj.attrValIdentifierObject =  createAttrValIdentifierObject(dataAll.catalogEntryGroupView);
                            drawFilters(dataAll.facetView,facetArr,parameters,$('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en"));
                            $('.facet__apply-number').text($plpSearchObj.resultCount);
                            $('.numframe').html($plpSearchObj.resultCount + ' ' + $('#frameTranslate').val());
                            $("#productsFacets li.facet__list-item li").each(function(i,e) {
                                toggleFilter(e,dataPartial);
                            });
                        };
                        //	If there are no GET parameters, then use the normal flow
                        if (facetArr.length == 0) {
                            filtersHandling(data,data);
                        } else {
                            new Promise((resolve, reject) => {
                                // else do an AJAX call to get the full facets list
                                var queryParamsAllFilters = $.extend({},$plpSearchObj.queryParams);
                                queryParamsAllFilters['facet'] = [];
                                delete queryParamsAllFilters['isForPLP'];
                                queryParamsAllFilters['isForPLPFilters'] = true;
                                $.ajax({
                                    url: $plpSearchObj.productsServiceUrl(),
                                    type: 'GET',
                                    async: true,
                                    data: $.param(queryParamsAllFilters,true),
                                    success: function(dataAll) {
                                        filtersHandling(data,dataAll);
                                        resolve(dataAll);
                                    },
                                    error: function(error) {
                                        reject(all);
                                        return error;
                                    },
                                    beforeSend: function(jqXHR, settings) {
                                        //  Security check, if true then stop the request and show 0 results
                                        if (settings.url.indexOf('TopCategoriesDisplay') > -1) {
                                            return false;
                                        }
                                    }
                                });
                            });
                        }
                    }
                }

                if (!isWishlist){
                    if(!searchedWord){
                        if(originalSelectedSort != undefined){
                            if(!(isPersol && getUrlParameter('searchTerm')) && facetArr.length == 0 && originalSelectedSort.innerText!==''){
                                setUTagData(parameters,originalSelectedSort);
                            }
                        }
                    }
                }

                if (document.querySelector('.search') ) {
                    $("span[id^=searchTotalCount] #totalCount").html("("+ $plpSearchObj.resultCount + ") " );
                }
            }
        }

        // Remove top and middle espot skeleton
        $('#plp_top_espot_skeleton').remove();
        $('#plp_middle_espot_skeleton').remove();

        //  CLS
        $('.plp-hide').show();
    };
    if (!isWishlist && typeof productData === 'undefined') {

        if(searchedWord || getUrlParameter('searchTerm') ){
            $plpSearchObj.queryParams.profileName = "LUX_findProductsBySearchTerm"
            if(isPersol){
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688668_3074457345616688669_3074457345616718183_3074457345616718182)'"; // catgoria LEnti + categorie servizi
            }else{
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688676_3074457345616714198_3074457345616714199_3074457345616688675)'"; // catgoria LEnti + categorie servizi
            }
             
            
        }else{
            $plpSearchObj.queryParams.profileName = $plpSearchObj.queryParams.profileName;
            delete $plpSearchObj.queryParams.filterQuery 
        }
        if(!isWishlist && !(searchedWord || getUrlParameter('searchTerm'))){}else{
        	$.ajax({
                url: $plpSearchObj.productsServiceUrl(searchedWord),
                type: 'GET',
                async: true,
                data: $.param($plpSearchObj.queryParams,true),
                success: ajaxPLPSuccess,
                error: function(error) {
                    return error;
                },
                beforeSend: function(jqXHR, settings) {
                    //  Security check, if true then stop the request and show 0 results
                    if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                        $plpSearchObj.resultCount = 0;

                        //	Hide View More button
                        $('.plp__view-more.button.secondary').attr('style','display:none !important');
                        if (isOliver && getUrlParameter('searchTerm') === null){
                            $('#noProducts').css('display','block');
                            //add default empty element in plp_gid for wcag
                            var createDOMProduct = document.createElement('li');
                            createDOMProduct.classList.add('grid-item');
                            createDOMProduct.setAttribute('id','dummyElement');
                            ulGrid.appendChild(createDOMProduct);
                            
                        }

                        return false;
                    }
                }
            });
        }
        
    } else {
        ajaxPLPSuccess(productData);
    }

};

/**
 * @funtion createNewTileProducts
 * @desc This function creates the new tile products with a template html
 */
function createNewTileProducts(startAt,count,searchedWord,isWishlist,isWishlistViewMoreTiles,wishlistToDeleteData,firstSearch) {
	// TEMPORARY FIX FOR HB-9977
	if(pageSection_1 == 'Accessories' && (window.tabletPortraitCheck() || window.mobilecheck())){
		count = 6;
	}
	$plpSearchObj.viewIndex = startAt+count;
    if(!searchedWord){
        //search Optimization -- save viewIndex 
        $plpSearchObj.viewIndexbkp = $plpSearchObj.viewIndex
    }
	//	Remove extra skeleton tiles
	var toShow = $plpSearchObj.lastIndex-$plpSearchObj.viewIndex;
	var toRemove = $plpSearchObj.itemsFromServer-toShow;
	
    var products = {}, i = 0;

    if (getUrlParameter('searchTerm') && $plpSearchObj.viewMoreClicked && !searchedWord) {
        var stopAt = $plpSearchObj.viewMoreSearchStartIndex+count;
        i = $plpSearchObj.viewMoreSearchStartIndex;
        if (toShow < 0) {
            // check for the end on products
            stopAt += toShow;
        }
        for (m in $plpSearchObj.items) {
            if (i>=$plpSearchObj.viewMoreSearchStartIndex && i < stopAt) {
                products[m] = $plpSearchObj.items[parseInt(m)+startAt];
            }
            i++;
        }
        $plpSearchObj.viewMoreSearchCount++;
        $plpSearchObj.viewMoreSearchStartIndex = count * $plpSearchObj.viewMoreSearchCount;
    } else {
        for (m in $plpSearchObj.items) {
            if (startAt<=i && i<startAt+count) {
                if(searchedWord){
                    if(isPersol && i <= 2){
                        products[m] = $plpSearchObj.items[m];
                    }else if(isOliver && i <= 1){
                        products[m] = $plpSearchObj.items[m];
                    }
                }else{
                    products[m] = $plpSearchObj.items[m];
                }
                
            }
            i++;
        }
    }

    // Show number of selected facets in the filter button
    if (countSelectedFacets >= 1) {
        $('.plp-filter-button').addClass('active');
    	$('.filter__button-number').text(countSelectedFacets);
    } else {
        $('.plp-filter-button').removeClass('active'); 
    }

    var tileCount = Object.keys($plpSearchObj.items).length;

    
    renderTileProducts(products, startAt, count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData);
}

/**
 * @funtion manageWishlistGuestEspot
 * @desc This function adds the sign in/register espot in the wishlist page as last tile of first grid row. This only happens when user is guest
 * */
function manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData) {
    var parentElement = ulGridChilds[0].parentNode;
    if (isPersol){
        if (productsLength > 0 && productsLength < 4) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(3).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[3]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    } else {
        if (productsLength > 0 && productsLength < 3) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(2).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[2]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    }
    if (typeof setWishlistEspotCtaClick == "function"){
        setWishlistEspotCtaClick();
    }
}

/**
 * @funtion renderTileProducts
 * @desc This function creates the new tile products with a template html
 * @param {products} products
 * @param {inventory} inventory
 */
function renderTileProducts(products,startAt,count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData) {

    var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
    var productArray = [];

  
    
    const ulGridChilds = searchedWord ? document.querySelectorAll('.search-grid-skeleton') : ((isWishlist && $('.plp-grid-skeleton').length == 0) ? document.querySelectorAll('#wishlist_grid li') : document.querySelectorAll('.plp-grid-skeleton')); //search optimization

    var productIndex = 0;
   
    var productsLength = Object.keys(products).length;

    for(var product in products) {

        if (typeof wishlistToDeleteData == "undefined" || !wishlistToDeleteData.isWishlistProductToDelete){
            var createDOMProduct = document.createElement('div');
            createDOMProduct.classList.add('grid-item');
            if(searchedWord){
                createDOMProduct.classList.add('grid-item-search');
                if(searchedWord == "X_Search_FeaturedProducts"){
                    $(".grid-item-search").parent().addClass("featured-products");
                }
            }

            var isLCPTile = startAt == 0 && productIndex == 0;
           

            if(searchedWord == "X_Search_FeaturedProducts"){
                var html = getSingleTileHtml(product, products[product].productModel, true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }else{
                var html = getSingleTileHtml(product, products[product], true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }
            
            
            $(createDOMProduct).html(html);
            ulGridChilds[productIndex].replaceChildren(createDOMProduct);
        }
        
        if (isWishlist){
            //If there is at least one product and user is guest, display sign in/register espot at last position of first grid row
            if (userType == "G" && productsLength > 0){
                if (!isWishlistViewMoreTiles || typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                    if (productIndex == productsLength - 1) {
                        if (typeof wishlistContentEspotHTML == 'undefined'){
                            returnEspotContent("X_Wishlist_Login");
                            var wishlistContentEspotHTML = $("#guestWishlistEspotContent").val();
                        }
                        if (typeof wishlistContentEspotHTML != "undefined" && wishlistContentEspotHTML != ""){
                            var espotLi = document.createElement('li');
                            espotLi.classList.add("wishlist-li");
                            var createDOMEspot = document.createElement('div');
                            createDOMEspot.classList.add('grid-item', 'wishlist-espot');
                            $(createDOMEspot).html(wishlistContentEspotHTML);
                            espotLi.appendChild(createDOMEspot);
                            if ($(".wishlist-espot").length == 0){
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            } else {
                                $(".wishlist-espot").parent().addClass("wishlist-li");
                                if ($(".wishlist-li").length > 0) {
                                    $(".wishlist-li").remove();
                                }
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            }
                        }
                    }
                }
            }


            if(typeof checkIsInWishlist === 'function'){ 
                if(checkIsInWishlist(product)){ // WISHLIST -- check if current product is in wishist
                    $("[data-id=" + product + "] .wishlist-icon-container").addClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }else{
                    $("[data-id=" + product + "] .wishlist-icon-container").removeClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }
            }
            wishlistAvailabilityCheckCTA(products, product);
        }

        if(searchedWord){
           ulGridChilds[productIndex].classList.remove("search-grid-skeleton");
           //$(".search-grid-skeleton").eq(productIndex).hide()
        }else {
            ulGridChilds[productIndex].classList.remove("plp-grid-skeleton");
            
        }

        ulGridChilds[productIndex].classList.remove("product");
        ulGridChilds[productIndex].querySelector('.square-container').classList.remove("skeleton-element");
        ulGridChilds[productIndex].querySelector('.product__wrapper-info').classList.remove("skeleton-element");
        
        
        productArray.push(createDOMProduct);
       
        removeLoader();


        
        productIndex++;
        tileIndex++;
    }


    if(searchedWord && $("#search_grid .search-grid-skeleton").length > 0){ //hide skeleton if result <3 /2
        $("#search_grid .search-grid-skeleton").hide();
    }

    if (!isWishlist){
        if(searchedWord != 'X_Search_FeaturedProducts' && searchedWord){
            var resultItemsQnt = $("#search_grid li:not(.search-grid-skeleton)").length;
            tealiumPushSearchPageReady(searchedWord,resultItemsQnt);
        }
    } else {
        init_wishlist_tooltip();
    }


  

    // Show images in IE, as Yall does not work properly
    if (!('IntersectionObserver' in window)) {
        if (typeof mokeupLazyLoad === "function") {
            mokeupLazyLoad();
        }
    }
    if(window.location.href.includes("?facet=")){
    	$('#X_PLP_TopBanner').hide();
    	$('#X_PLP_BottomBanner').hide();
    	$('#X_PLP_MiddleBanner').hide();
    	$('#X_PLP_PromoBanner').hide();
        $('#X_PLP_BottomGridBanner').hide();
        $('#X_PLP_GridBannerTop').hide();
        $('#X_PLP_GridBannerBottom').hide();
    }

    if(isEdgeOrIExplorer()){
        $('.grid.product-list').css("width","auto");
    }
    
    /**
     * Handle back button : scroll to the last product clicked by user 
    * */
    if(sessionStorage.plpTitle == pageSection_1 && sessionStorage.pageY) {
            if($plpSearchObj.viewIndex  > 16) { //middle espot non renderizzato
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY - sessionStorage.middleEspotHeight
                },0);
            }
            else {
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY
                },0);
            }
            sessionStorage.removeItem('pageY');
            sessionStorage.removeItem('plpTitle');
            sessionStorage.removeItem('itemsToLoad');
            sessionStorage.removeItem('backItemsPerPage');
            sessionStorage.removeItem('middleEspotHeight');
    }
    if(searchedWord == "X_Search_FeaturedProducts"){ // save Feautured 
        $('#search_grid li').each(function() {
            if(!$(this).hasClass("search-grid-skeleton")){
                featuredProductHtml += this.outerHTML
            }
        })
    }
    
}
/**
 * @funtion getSingleTileHtml
 * @desc This function creates a single product tile with a template html
 * @param {model} model
 * @param {product} product
*/
function getSingleTileHtml(product, model, insideGrid,productIndex=0,isLCPTile, tileIndex,searchedWord,isWishlist,isEspot) {

    var html = '';

    try {

        var listPrice = '';
        var offerPrice = '';
        var percentage = '';

        var polarized = '';
        var isPhotocromic = false;
        var isRox = false;
        var modelNameValue = "";
        var group2BadgeValue = '';
        var wishlistAddedSize = "";
        var wishlistAddedSizeNumber = "";
        var productMoco = "";
        var isPolar = false;
        var catentryIdDefaultSize = [];

        if (typeof isWishlist == "undefined"){
            var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
        }

        //var model = products[product];
        var showedProduct = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0];
        if (showedProduct.thumbnail === undefined) {
            showedProduct.thumbnail = '';
        }
        $(model).each(function (ind) {
            var currProduct = $(this)[0];
            if (isOliver) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
            } else if (isPersol) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }

            try {
                if(WCParamJS.countryCode == 'US' || WCParamJS.countryCode == 'CA'){
                    catentryIdDefaultSize[ind]= currProduct.mostSoldSize['NA'].uniqueID;
                }else if(WCParamJS.countryCode == 'JP'){
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['JP'].uniqueID;
                }else{
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['EMEA'].uniqueID;
                }
            } catch (e) {
                console.error('Error in finding default size for wishlist');
            }
        });

        if(showedProduct != undefined
                && showedProduct.attributes != undefined) {
            for(var i=0; showedProduct.attributes.length>i; i++) {
                if(showedProduct.attributes[i].identifier === 'MODELNAME' && showedProduct.attributes[i].usage === 'Descriptive' ) modelNameValue = showedProduct.attributes[i].values[0].value;
                if(showedProduct.attributes[i].identifier === 'POLARIZED' && showedProduct.attributes[i].usage === 'Descriptive' ){
                    for(var k=0; showedProduct.attributes[i].values.length > k; k++ ){
                        if(showedProduct.attributes[i].values[k].value == true || showedProduct.attributes[i].values[k].value.toLowerCase() === 'yes'){
                            polarized = showedProduct.attributes[i].name;
                        }
                    }
                }
                if(showedProduct.attributes[i].identifier === 'MOCO' && showedProduct.attributes[i].usage === 'Descriptive' ) {
                    productMoco = showedProduct.attributes[i].values[0].value;
                }

            }
            if (isWishlist){
                for(var i=0; showedProduct.attributes.length>i; i++) {
                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE" && showedProduct.attributes[i].usage === "Descriptive" ) {
                        if (typeof wishlistAddedSizeNumber == "undefined" || wishlistAddedSizeNumber == ""){
                            wishlistAddedSizeNumber = showedProduct.attributes[i].values[0].value;
                        }
                    }

                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE_DISPLAY" && showedProduct.attributes[i].usage === "Defining" ) {
                        if (typeof wishlistAddedSize == "undefined" || wishlistAddedSize == ""){
                            wishlistAddedSize = showedProduct.attributes[i].values[0].value;
                        }
                    }
                }
            }
        }

        

        var indexOtherColors = 0;
        var eachLensColor = "";
        var eachFrontColor = "";
        var isClipon = modelNameValue.toLowerCase().includes('clip');
        /*if (isClipon) {
            showedProduct.thumbnail = showedProduct.thumbnail.replace('/is/image/OliverPeoples','/extra/image/OliverPeoples/clipon').replace('_shad_fr','_shad_fr_clipon');
        }*/

        var inventoryStatus = false;
        var cbsCounter = 0;
        var csCounter = 0;
        var soCounter = 0;
        //prova
        var colorProp = "Color"
        var colorsProp = "Colors"
        //prova
        if (!(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()|| searchedWord || isWishlist)){
            $(model).each(function (ind) {
                if (!(typeof model[ind]['inventory'] === 'undefined')){
                    if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'true'){
                        csCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '0'){
                        soCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'false'){
                        cbsCounter++;
                    }
                } else return false;

                if (csCounter == model.length || cbsCounter == model.length || soCounter == model.length) {
                    inventoryStatus = true;
                    return inventoryStatus;
                }
            });
         }//else{
        //     $(model).each(function (ind) {
        //         if (!(typeof model['inventory'] === 'undefined')){
        //             if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'true'){
        //                 csCounter++;
        //             } else if (model['inventory']['ranking'] == '0'){
        //                 soCounter++;
        //             } else if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'false'){
        //                 cbsCounter++;
        //             }
        //         } else return false;

        //         if (csCounter == 1 || cbsCounter == 1 || soCounter == 1) {
        //             inventoryStatus = true;
        //             return inventoryStatus;
        //         }
        //     });
        // }

        var mustacheObj = {
            modelName: modelNameValue != undefined ? modelNameValue : '',
            inventoryStatus: inventoryStatus,
            //indexPlp:productIndex+1,
            indexPlp:tileIndex+1,
            indexSearchPanel: indexSearchPanel+1,
            isSearchPanel: function () {
                if(searchedWord != undefined) {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchFeturedProduct: function () {
                if(searchedWord == "X_Search_FeaturedProducts") {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchPageResult: function(){
                if(searchedWord == undefined && getUrlParameter('searchTerm')){
                    return true;
                }else{
                    return false;
                }
            },
            isWishlistPage: function(){
                if (isWishlist){
                    return true;
                } else {
                    return false;
                }
            },
            catentryIdDefaultSize : function(){
                return catentryIdDefaultSize[indexOtherColors];
            },
            catentryIsPresentInWishlist: function(){
                if(typeof checkIsInWishlist === 'function'){
                    return checkIsInWishlist(catentryIdDefaultSize[indexOtherColors]);
                }
            },
            image: function () {
            	var stringOfThumbnail = null;
                var backgroundColor = "";
                if (isOliver){
                    backgroundColor = "";
                    // OP: using of OV_OpPlp
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1000');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                	}
                } else  {
                    // PO: scaling of 45% on desktop
                    backgroundColor = "&bgcolor=%23f7f7f7";
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1500');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','small');
                	}
                }
                return stringOfThumbnail + backgroundColor;
            },
            imageScaled: function () {
                var backgroundColor = "";
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    var backgroundColor = "";
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                } else  {
                    // PO: scaling of 25% on mobile
                    var backgroundColor = "&bgcolor=%23f7f7f7";
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                }
            },
            thumbnail: function () {
                if (isOliver){
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                } else {
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
                }
            },
            uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
            partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[indexOtherColors]).partNumber,
            partNumberAlt: function () {
                if (!isWishlist){
                    return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
                } else {
                    return productMoco.toUpperCase();
                }
            },
            colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) && model.length > 1 ? colorsProp : colorProp,
            offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
            listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
            percentage: percentage,
            baseURL: WCParamJS.homePageURL,
            group2BadgeValue: group2BadgeValue,
            otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? [ model ] : model,
            replaceImageUrl: function () {
            	var replaceImage = null;
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        backgroundColor = "";
                        // OP: using of OV_OpPlp
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('OV_OpPlp','OV_parameters&WID').replace('WID','wid=1000');
                            }else{
                            	replaceImage = this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID').replace('WID','wid=1000');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                            }else{
                            	replaceImage = replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                            }
                    	}
                    } else {
                        var backgroundColor = "&bgcolor=%23f7f7f7";
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }else{
                            	replaceImage = this.thumbnail2.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                            }else{
    	                        // PO: scaling of 45% on desktop
    	                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
    	                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
    	                        replaceImage = replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                            }
                    	}
                    }
                }else{
                	replaceImage = this.thumbnail;
                }
                return replaceImage ;
            },
            replaceImageUrlScaled: function () {
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        
                        backgroundColor = "";
                        // OP: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                        }
                        return replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') +  backgroundColor;
                    } else {
                        backgroundColor = "&bgcolor=%23f7f7f7";
                        // PO: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                        }
                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
                        return replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                    }
                }
                return this.thumbnail;
            },
            replaceImageUrl1Tile: function () {
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else
                        //return this.thumbnail;
                        return replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','big');
                }
                return this.thumbnail;
            },
            index: function() {
                indexOtherColors++;
            },
            // Show color names under image
            printColorsName: function(){
                $(this.attributes).each(function (){
                    if ((this.identifier) === "FRONT_COLOR"){
                        eachFrontColor = ((this).values[0].identifier);
                    }
                    if ((this.identifier) === "LENS_COLOR"){
                        eachLensColor = ((this).values[0].identifier);
                    }
                })
                if ($("#categoryName").val() === 'OV_Sun') {
                    return (eachFrontColor + '/' + eachLensColor);
                } else {
                    return (eachFrontColor);
                }
            },
            printListPrice: function() {
                var product = this;
                var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
                return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            printOfferPrice: function() {
                var product = this;
                offerPrice = getPriceByCustomerSegment(product["price"]);
                return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            showListPrice: function() {
            	var product = this;
            	var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            	var offerPrice = getPriceByCustomerSegment(product["price"]);
            	if(offerPrice != '' && listPrice != ''){
	            	if(offerPrice < listPrice) {
	            		return 'showListPrice';
	            	}
            	}
            	return '';
            },
            printStatus: function() {
                return printStatus(this);
            },
            printWishlistSize: function() {
                return wishlistAddedSize;
            },
            printWishlistSizeNumber: function() {
                return wishlistAddedSizeNumber;
            },
            isWishlistSizeEmpty: function() {
                if (wishlistAddedSize == "" || typeof wishlistAddedSize == "undefined"){
                    return true;
                } else {
                    return false;
                }
            },
            printPolarBadge: function() {
                return getPolarized(this.attributes);
            },
            printTransitionBadge : function () {
                return getTransitionBadge(this.attributes);
            },
            printTopBadge: function() {
                /**
                 * Group 1 Badges Hierarchy
                 * PO Transition > Polar
                 * OP Polar
                 */
                var isPolar = getPolarized(this.attributes);
                var isTransition =  getTransitionBadge(this.attributes);
             
                if(isTransition && isPersol){
                    return isTransition;
                }
                else if(isPolar){
                    if(isOliver){
                        return "— "+isPolar+" —";
                    }else{
                        return isPolar;
                    }
                }
            },
            printBottomBadge : function(){
               return  printBadges(this.attributes);
            },
            isPreOrder : function() {
                return getPreOrderBadge(this.attributes) != undefined ;
            },
            isPrescription: function(){
                return isPrescription(this.attributes);
            },
            printSeparator: function(){
                if((printBadges(this.attributes) != "" || getPreOrderBadge(this.attributes) != undefined) && isPrescription(this.attributes,searchedWord) == true){
                    return true;
                }else{
                    return false;
                }
            },
            isFastLoadImg: function() {
                return this.indexPlp < 4
            },
            isLCPTile: isLCPTile
          }

        if(searchedWord) {
            indexSearchPanel++;
        }

        if (insideGrid && !searchedWord) {
            if(typeof tealiumProducts === 'undefined'){
                var tealiumProducts = {};
            }

            //	Tealium
            var tealiumProduct = {};
            var myPartNumber = (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0]).partNumber;
            if (isPersol){
                tealiumProduct['Sku'] = myPartNumber.replaceAll('RX_','');
            } else {
                tealiumProduct['Sku'] = myPartNumber;
            }
            tealiumProduct['ModelName'] = (modelNameValue != undefined ? modelNameValue : '').toUpperCase();
            tealiumProduct['Category'] = !isWishlist ? getSunOpticalCategoryName($("#categoryName").val()) : '';
            tealiumProduct['Price'] = offerPrice;
            tealiumProduct['PriceFull'] = listPrice;
            tealiumProduct['Brand'] = currentBrand;
            tealiumProducts[myPartNumber] = tealiumProduct;
            if(typeof pushWkndSkuInPLP == 'function' && window.wunderkind && window.wunderkind.category !== undefined)
                pushWkndSkuInPLP(tealiumProduct['Sku']);
        }

        var templateHtml = $('#plpTemplate2024').html();
        html = Mustache.to_html(templateHtml, mustacheObj);
        

    } catch (error) {
        console.error('Error in tile creation',error);
    }

    return html;
}



/**
* Opens the search bar when the search icon is clicked.
* Change the tabindex value to every focusable element into the search.
*/
function openSearchBar(element){
    //hideHeaderTimeout.cancel();
    var searchPanel = $('.header__search-wrapper');
    changeTabIndex($('.header__search-wrapper'));
    searchPanel.hasClass("opend") ? searchPanel.removeClass('opend') : searchPanel.addClass('opend');
    searchPanel.removeClass("hidden-panel");
    $('.search--fade').show();
    history.pushState({}, '') // added state in chronology To close the panel when the back button is clicked
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","hidden");
    }
    
    $("body").css("overflow","hidden");
    $("#page").css("overflow","hidden");
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        loadHeaderEspot("X_Search_FeaturedProducts"); // load Feature Products
    }

    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").addClass("searchPanelIsOpen");

    if(isOliver){
        tealium_data2track.push({
            'id':'Click', 
            'data_element_id': 'MainNav_Search_Open',
            'Click_FocusElement' : element
        });
    }
 
    
};

function closeSearchBar() {
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        if($(".searchPanel .search_panel_container").hasClass("active")){
            $(".searchPanel .search_panel_container").removeClass("active");
            $(".searchPanel .search_panel_container").focusout();
            window.history.go(-1);
            if(isPersol){
            	$('.header_wishlist').show(); 
                $("#logo").hide();
            }
        }

    }else{
        $('.header__search-wrapper').removeClass('opend');
        $('.search--fade').hide();
        window.history.go(-1);// delete the state added at opening
        if($plpSearchObj.itemsbkp != undefined){
            //search Optimization --retrieve info on the plp that was being navigated
            $plpSearchObj.items =  $plpSearchObj.itemsbkp;
            $plpSearchObj.busy = false;
            $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp;
            $plpSearchObj.viewIndex = $plpSearchObj.viewIndexbkp ;
        }
    }
    
   
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","auto");
    }
    $("body").css("overflow","auto");
    $("#page").css("overflow","auto");

    resetSearchTile(true,true,false);
    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").removeClass("searchPanelIsOpen");

    if(isOliver){
        setTimeout(function() {
            $('.header__search-wrapper').addClass("hidden-panel"); //HB-12925 Overlay fade effect when close panel
        }, 600);
    }
};


window.onpopstate = function() { //interface is fired when the active history entry changes while the user navigates the session history.
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        var searchPanel = $(".searchPanel .search_panel_container");
        if(searchPanel.hasClass("active")){
            closeSearchBar();
        }
    }else{
        var searchPanel = $('.header__search-wrapper');
        if(searchPanel.hasClass("opend")){
            closeSearchBar();
        }
    }     
  };






function getUrlParameter(paramName) {
    var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    } else {
       return decodeURI(results[1]) || 0;
    }
}

/**
 * @function callbackSortBy
 * @desc callback function for default sort by
 */
function callbackSortBy(elem){
    if(elem) {
        checkFacetsAndSearch($(elem));
    }
    $('.facet__apply-number').text($plpSearchObj.resultCount);

}

function isNewArrivalsOrdering() {
	return selectedFacetsData["orderBy"] === '8';
}

function isPriceOrdering() {
	return selectedFacetsData["orderBy"] === '3' || selectedFacetsData["orderBy"] === '4';
}

function categoryToGroupTile() {
	if ($('input#notGroupTile').val() == 1)
		return false;

	return true;
}





function resetSearchTile(reloadFeaturedProducts,resetInputButton,resetSuggestion){
    if(reloadFeaturedProducts){
        if( !(window.tabletPortraitCheck() || window.mobilecheck()) && $(".searchPanel .featured-products").length == 0 ){
            $("#search_grid").html(featuredProductHtml);
        } 
        $(".title_result").show();
        $(".redirect_result_container").css("display","none");
    }else{
        $("#search_grid .search-grid-skeleton").show();
        $('#search_grid li').each(function() {
            $(".redirect_result_container .redirect_result_link").css("display","none");
            if(!$(this).hasClass("search-grid-skeleton")){
                 $(this).empty(); // elimina il contenuto 
                 $(this).append('<div class="grid-item">' +
                                    '<div class="product">' +
                                        '<div class="product--wrapper">' +
                                            '<div class="product--wrapper__container">' +
                                                '<div class="plp__other-product-carousel new-plp">' +
                                                    '<div class="square-container skeleton-element">' +
                                                        '<div class="square-content">' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="product__wrapper-info skeleton-element">' +
                                                        '<a class="lower-tile-container ">' +
                                                        '</a>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
                 $(this).addClass("search-grid-skeleton");
                 $(this).removeClass("featured-products");
                
                 
            }
         });
    }
    if(resetInputButton){
        $('input:text[name=searchInput]').val("");
        $(".searchPanel .delete-input-icon").hide();
    }
    if(resetSuggestion){
        $("#search_UsefulLinks").show();
        $("#search_popular").show();
        $(".searchPanel .suggestions_container").empty();
        $(".searchPanel .suggestions_container").hide();
        searchError(false);
    }

    removeLoader();
    
}

function updateSearchTermHistoryCookieAndRedirect(updatedSearchTerm, redirectURL){
	
	this.updateSearchTermHistoryCookie(updatedSearchTerm);
    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
    
}

function fn_startSearch() {
    var searchTimeout;
    indexSearchPanel = 0;
    var dInput = $('input:text[name=searchInput]').val().toLowerCase();
    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
        if(dInput.length >= 2){
        	$plpSearchObj.search = true;
            resetSearchTile();
            const promise2 = Promise.resolve(printAutoSuggestions(dInput));
            const promise3 = new Promise((resolve, reject) => {
                setTimeout(resolve, 500, 'Success');
            });
            const promise1 = Promise.resolve(fn_plpFirstTiles(undefined,dInput,undefined,undefined,true));
            Promise.all([promise1,promise2, promise3]).then((values) => {
                if(values[1].suggestionView[0].entry.length > 0 && ($(".error_search_message").is(":visible") || $('.title_result').is(":visible") || $('#search_grid .square-container.skeleton-element').is(":visible")) ){
                    searchError(false);
                    resetSearchTile(false,false,false);
                    fn_plpFirstTiles(undefined,values[1].suggestionView[0].entry[0].name);
                }else if( (!$(".error_search_message").is(":visible") || !$('.title_result').is(":visible")) ){
                    searchError(false);
                }else{
                    searchError(true);
                    resetSearchTile(true,false,false); 
                }
            });
        }
    }else{
        if(dInput.length >= 2){
            printAutoSuggestions(dInput);
        } 
    }
    if(dInput.length > 0){
        if(dInput.length < 2){
            resetSearchTile(true,false,true);
        }
       // $(".searchPanel .delete-input-icon").show();
    }else if(dInput == 0){
        resetSearchTile(true,true,true);
    }
}

function tealiumPushSearchPageReady(dInput,resultItemsQnt) {
    console.log("TEALIUM::tealiumPushSearchPageReady function invoked");
    if(typeof tealium_data2track !== 'undefined' && !mobilecheck()) {
        var trackData = {};
        trackData['id'] = 'SearchPageReady';
        trackData['Search_Keyword'] = dInput.toLowerCase();
        trackData['Search_KeywordActual'] = '';
        trackData['Search_Type'] = 'text';
        trackData['Search_ResultItemsQnt'] = resultItemsQnt; 
        trackData['Search_FacetValues_String'] = "";
        trackData['Search_View'] = "SERB"
        tealium_data2track.push(trackData);
    }
}


function goToSearchPage(input){
    var searchType = ""
    if(input != undefined){
        var dInput = input  
        searchType = "suggested"
       
    }else {
        var dInput = $('input:text[name=searchInput]').val();
        searchType = "text"
        
    }
    var typeResult = checkTileEditorialProduct(numItems,numEditorials);
    if(dInput.length > 0){
        updateSearchTermHistoryCookie(dInput);
        var baseSearchPage = (isInToolkit ? '' : WCParamJS.homePageURL +"/")+'SearchDisplay?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&design=' + typeResult + '&searchTerm=' + dInput +'&Search_Type='+ searchType;   
        location.href = baseSearchPage;
    }
   
}

/**
function printAutoSuggestions(dInput){
    dInput = dInput.replaceAll("’","'");
    $(".searchPanel .suggestions_container").empty();//clean suggestion div 
    var searchHistory = getSearchTermsCookie();
    var limit = 10 - searchHistory.length; //total suggestions + history search = 10

    if(searchHistory.length > 0){ //check for research already done
        searchHistory.forEach(function (term) { 
            historySearchDiv = '<div><a class="search-history" onclick=" goToSearchPage(\''+ term.replace("-","").replace(" ","") +'\')" data-element-id="SearchPanel_Results_query">' + term.replace("%27","'")+ '</a></div>';
            $(".searchPanel .suggestions_container").append(historySearchDiv);//print the latest research
        }) 
    }
    queryAutoSuggestions = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        responseFormat: 'json',
        langId: WCParamJS.langId,
        categoryId: WCParamJS.categoryId,
        limit: limit
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: (isInToolkit ? '' : WCParamJS.homePageURL) +"/search/resources/store/" + WCParamJS.storeId  + "/sitecontent/productSuggestionsBySearchTerm/"+ dInput ,
            type: 'GET',
            async: true,
            data: queryAutoSuggestions,
            success: function(data){
                var suggestionDiv = "";
                if(data.suggestionView && data.suggestionView[0].entry.length > 0){
                    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#search_UsefulLinks").hide();
                        $("#search_popular").hide();
                        
                    }else{
                        tealiumPushSearchPageReady(dInput,limit);
                    }
                    searchError(false);
                    $(".searchPanel .suggestions_container").show();
                    var searchTerms = [];
                    for (var i = 0; i < data.suggestionView[0].entry.length; i++) {
                    	var isPresent = false;
                    	var temporaryTerm = data.suggestionView[0].entry[i].name;
                		for (var j = 0; j < searchTerms.length; j++) {
                		//check if the result name has been already shown
                    		if (temporaryTerm === searchTerms[j]){
                    			isPresent = true;
                    		}
                    	}
                    	if(!isPresent){
                    		var spanTerm = data.suggestionView[0].entry[i].name.replace(dInput.toLowerCase(),"<span class='serched-word'>" + dInput.toLowerCase() +"</span>" );
                            suggestionDiv = '<div><a class="suggestion" onclick="goToSearchPage(\'' + data.suggestionView[0].entry[i].name.replace("'","%27") + '\')">' + spanTerm.toLowerCase() + '</a></div>';
                            $(".searchPanel .suggestions_container").append(suggestionDiv);//print suggestions
                    	}
                    	searchTerms.push(data.suggestionView[0].entry[i].name);
                    }
                }
                else if (data.metaData){
                	dInput = data.metaData.spellcheck[0];
                	printAutoSuggestions(dInput);
                }
                else if(!(searchHistory.length > 0 && data.suggestionView && data.suggestionView[0].entry.length > 0)){
                    if((window.tabletPortraitCheck() || window.mobilecheck())){
                        searchError(true);
                        tealiumPushSearchPageReady(dInput,'0');
                    }
                    $(".suggestions_container").hide();
                    $("#search_UsefulLinks").show();
                    $("#search_popular").show();
                    
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);  
                reject(error);
            }
        });
    });

    

}
*/ 

var inputTimer = null;

function loadHeaderEspot(espotName) {

    // If espot div is not present, skip the loading
    if ($("#" + espotName).length == 0) return;
  
    // Get product, if present
    let products = {};
    let contents = [];
  
    // Compose service url
    var espotServiceUrl =
      WCParamJS.urlPrefixForHTTPS +
      "/wcs/resources/store/" +
      WCParamJS.storeId +
      "/espot/" +
      espotName +
      "?langId=" +
      WCParamJS.langId;
  
    return new Promise((resolve, reject) => {
  
      $.getJSON(espotServiceUrl, function (data) {
        products = {};
        contents = [];
        //con la risposta del servizio mi creo due array di oggetti di prodotti e contenuti
        data["MarketingSpotData"].forEach(function (msd, index) {
          if (msd["baseMarketingSpotActivityData"]) {
            var savedActivityPriority;
            msd["baseMarketingSpotActivityData"].every(function (bmspd, index) {
              if (
                typeof savedActivityPriority != "undefined" &&
                savedActivityPriority != bmspd["activityPriority"]
              ) {
                return false;
              }
              savedActivityPriority = bmspd["activityPriority"];
              if (bmspd["baseMarketingSpotDataType"] === "CatalogEntry") {
                // controllo che sia un prodotto
                var productsobj = {
                  product: bmspd["baseMarketingSpotActivityName"],
                  productId: bmspd["productId"]
                };
                //prendo le info sul modello
                var isProductPresent =
                  productsobj["product"].length > 0 &&
                  productsobj["productId"].length > 0;
                  if (isProductPresent) {
                    products[productsobj["productId"]] = productsobj;
                }
              } else if (
                bmspd["baseMarketingSpotDataType"] === "MarketingContent"
              ) {
                // controllo che sia un contenuto
                bmspd["marketingContentDescription"].forEach(function (mkd, index) {
                  if(typeof mkd["marketingText"] != 'undefined'){
                    contents.push(
                        mkd["marketingText"].replaceAll(
                          "[fullPathHomeURL]",
                          WCParamJS.homePageURL
                        )
                      ); //metto nell array di contenuto tutti i contenuti
                  }  
                });
              }
              return true;
            });
          }
        });
  
      }).done(function(data) {
  
        if (Object.keys(products).length > 0) {
  
          getProductsModelHeader(products,function() {
            if(espotName=="X_Search_FeaturedProducts"){
              renderTileProducts(products,0,0,0,espotName);
            }else{
                if( typeof espotCallback == 'function'){
                    espotCallback(products, contents, espotName);
                }
            }
            
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error(error)
          });
  
        } else {
            if( typeof espotCallback == 'function'){
                espotCallback(products, contents, espotName)
            }
        }
  
        resolve(data);
    }).fail(function(error) {
      reject(error);
    });
  
    });
  
  }

  function getProductsModelHeader(products,callback) {

    var productIds = [];
    $.each(products,function(k,v) {
      productIds.push(k);
    });
  
    // Compose service url
    var productServiceUrl =
      (isInToolkit ? "" : WCParamJS.homePageURL) +
      "/search/resources/store/" +
      WCParamJS.storeId +
      "/productview/byIds?id=" +
      productIds.join("&id=") +
      "&storeId=" +
      WCParamJS.storeId +
      "&catalogId=" +
      WCParamJS.catalogId +
      "&responseFormat=json&langId=" +
      WCParamJS.langId +
      "&currency=" +
      WCParamJS.commandContextCurrency +
      "&profileName=LUX_findProductByIds_Details" +
      "&isForDDM=true"
      ;
  
    return new Promise((resolve, reject) => {
      $.getJSON(productServiceUrl, function (data) {
        var productModel = data["catalogEntryView"];
  
        // To align objects with those expected by Mustache
        productModel.forEach(function (m, index) {
          m["modelCode"] = m.partNumber.split('__')[0];
          products[m["uniqueID"]]["productModel"] = m;
        });
  
        if (typeof callback === 'function') {
          callback();
        }
  
      }).done(function(data) {
        resolve(data);
      }).fail(function(error) {
        reject(error);
      });
    });
    
  }
  /** 
  function updateSearchTermHistoryCookie(updatedSearchTerm){
    // Set the expiration date to one month from the current date
    var expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    var cookieKey = "searchTermHistory";
    var cookieValue = "|" + updatedSearchTerm;
    var searchTermHistoryCookie = getCookie(cookieKey);
    if( searchTermHistoryCookie != undefined && searchTermHistoryCookie != 'undefined') {
        var termsArray = searchTermHistoryCookie.split("|");
        if(!termsArray.includes(cookieValue.replace("|",""))){
            cookieValue = getCookie(cookieKey) + cookieValue;
        }
        
    }
    setCookie(cookieKey, cookieValue,{path:'/', domain:cookieDomain, expires: expirationDate});
}


function getSearchTermsCookie(){
    var searchHistoryCookie = getCookie("searchTermHistory");
    var theLastTerms=[];
    if( searchHistoryCookie != undefined && searchHistoryCookie != 'undefined') {
        var termsArray = searchHistoryCookie.split("|");
        var count = 0; 
        for(var i = termsArray.length - 3; i < termsArray.length; i++) {
            if(termsArray[i] != undefined && termsArray[i] != "" && termsArray[i] != 'undefined'){
                theLastTerms[count]= termsArray[i];
                count++;
            }
        }
    }
    return theLastTerms.reverse();
}
**/

function searchError(show){
    if(show){
        var searchedWord = $('input:text[name=searchInput]').val();
        $(".error_search_message #error_word").html(searchedWord);
        $(".error_search_message").show();
        $(".error-search-icon").show();
        $(".input-icon").hide();
    }else{
        $(".error_search_message").hide();
        $(".error-search-icon").hide();
        $(".input-icon").show();
    }
    
}



/**
 * @funtion getStatus 
 * @desc get Product Status (Available, SoldOut, Out-of-stock, etc.) based on inventory informations
 */
function getStatus(inventoryStatus) {
    //var flComingSoon = inventoryStatus.flComingSoon;
    var ranking = inventoryStatus.ranking;
    var status = "";

    switch(ranking) {
        case "0" : {
            status =  "SoldOut";
            break;
        }
        case "1" : {//Coming Soon & Coming Back Soon
            status = "Out-of-stock";  
            break;
        }
        case "2" : {
            status = "Available";
            break;
        } 
        default : {
            status= "/";
        }
    }
    return status;
}

//remove loader as soon as image is displayed
function removeLoader(){
    var articleImages = document.querySelectorAll(".image-container.main > picture >  img");
    var imageSkeleton = '';
    articleImages.forEach(function(img) {
        img.addEventListener('load', function() {
            imageSkeleton = $(img).closest(".image-container");
            $(imageSkeleton).removeClass("skeleton-element");
        });       
    });
}

function clearSearchPanelEditorial(){
	while ($('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length != 0){
		$('#search_hits .ais-Hits .ais-Hits-item.is-editorial')[$('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length-1].remove()
	}
}



// ex --- $plpSearchObj.countData

$.getScript("https://cdn.jsdelivr.net/npm/algoliasearch@4");
$.getScript("https://cdn.jsdelivr.net/npm/instantsearch.js@4.60.0/dist/instantsearch.production.min.js");
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}


function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}


function setUTagData(parameters,sorting) {
    var filtersApplied = [];
    var sortingByApplied = '';
    var resultsNumber = $('.facet__apply-number').text();
    for(var index in parameters){
        if(parameters[index].includes('facet=')){
            var facet = parameters[index].replace('facet=', '').replaceAll(' ', '_');
            var facetElement = $("button[data-facet='"+facet+"']");
            var facetCategory = $(facetElement).attr("data-facet-category").replace(" ", "_");
            var facetValue = $(facetElement).attr("data-facet-name");
            filtersApplied += (facetCategory + '=' + facetValue + "|");

            var sortBySelected = $("[data-facet-group='sortBy']").parent('.selected').find(".facet__filter-radio");
            var sortByValue = $(sortBySelected).attr("data-facet-name");
            sortingByApplied = sortByValue;
        }
    }
    var facetValues = filtersApplied  + 'sorting=' + sortingByApplied;
    var tealiumObj = {
        'id': 'Event',
        'Event_Source': 'SERP',
        'Search_View': 'SERP',
        'Search_ResultItemsQnt': resultsNumber,
        'Search_FacetValues_String': facetValues,
        'Events_SearchFiltering':'1'
    };
    tealium_data2track.push(tealiumObj);
}



function loadRelatedJS(content) {
	if (content.includes("op-badge"))
		espotBadge("op-badge", 1000);
	if (content.includes("po-badge"))
		espotPOBadge("po-badge", 1000);
}


function espotPoCustomCursor() {
    if ($(window).width() > 1024) {
        // CUSTOM CURSOR SET MOUSE ENTER/LEAVE
        $('.editorial-content-custom-cursor').on({
            mouseenter: function() {
                EditorialCursor.initCursor($(this).data('cursor-editorial'));
            },
            mouseleave: function() {
                EditorialCursor.deleteCursor();
            }
        });
    }
}

/**
 * @function drawFilters
 * @desc Funtion that draws filters using Mustache
 * @param {object} facetView - data for filters to be drawed
 */

function drawFilters(facetView,facetArr,parameters,originalSelectedSort) {
	var facetViewNew = filtersHandler(facetView);
    var templateHtml = $('#plpFiltersTmpl').html();
    var html = Mustache.to_html(templateHtml, facetViewNew);
    $('#productsFacets > div:not(#section_SORT_BY):not(.sortBy_separator)').remove();
    $('#productsFacets').append(html);
    // remove IS_ROXABLE filter
    if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'US' && WCParamJS.countryCode.toUpperCase() != 'UK'){
        $("li").find("[data-facet-name='IS_ROXABLE']").parent().remove()
    }    
    
	return new Promise((resolve, reject) => {
        var newParam = Object.assign({}, $plpSearchObj.queryParams);
        newParam["langId"] = "-1";
        delete newParam['isForPLP'];
        newParam['isForPLPFilters'] = true;
        $.ajax({
            url: $plpSearchObj.productsServiceUrl(),
            type: 'GET',
            async: true,
            data: newParam,
            success: function(data) {
                var filterEN = filtersHandler(data.facetView);
                for(var i = 0; i < facetViewNew.length; i++){
                    let facet = filterEN.find(f => f.value === facetViewNew[i].value);
                    // $("[data-facet-category='"+facetViewNew[i].name+"']").attr("data-facet-category-en",facet.name);
                    for(var j = 0; j < facetViewNew[i].entry.length;j++){
                        //assigning as "id" the EN label of the facet
                        $("[data-facet-name='" + facetViewNew[i].entry[j].label + "']").parent().find('img').attr("class", "facet_" + facet.entry[j].label.replace(" ", "_").toLowerCase());
                    }
                }
                resolve(data);
            },
            error: function(error) {
                reject(error);
                return error;
            },
            complete: function(){
                checkForPreviousFilters();
                if (facetArr.length > 0) {
                    //ajaxCallCount(setUTagData, null, false, parameters);
                    setUTagData(parameters,originalSelectedSort);
                }
            }
        });
    });
}


/**
 * @function filtersHandler
 * @desc Funtion that selects which filter we have to show and handles them
 * @param {*} facetView data for filters to be drawed
 */
function filtersHandler(facetView) {
    var facetViewNew = [];
    var specialFacetView = { name: $('#filterByLabel').val(), entry: [], extendedData: { attridentifier: "FILTER_BY", propertyvalue: 'filterBy'}, clearAll : true};
    for (var key in facetView) {
        var facetIdentifier = facetView[key].extendedData ? facetView[key].extendedData.attridentifier : null;
        if (facetIdentifier == undefined) {
            facetIdentifier = facetView[key].name ?  facetView[key].name.replace(/ /g, '_').toUpperCase() : "";
        }
        if ($plpSearchObj.facetsForFilterBy[facetIdentifier] !== undefined) {
        	var facet = facetView[key];
            for (var e in facet.entry) {
            	var entry = $.extend({},facet.entry[e]);
            	if (entry.value
            			&& entry.value.toLowerCase().includes($plpSearchObj.facetsForFilterBy[facetIdentifier].toLowerCase()) ) {
            		if (facetIdentifier === 'IS_ROXABLE' && $plpSearchObj.facetsForFilterBy[facetIdentifier] === 'True'
            			&& (WCParamJS.countryCode.toUpperCase() == 'DE' || WCParamJS.countryCode.toUpperCase() == 'US' || WCParamJS.countryCode.toUpperCase() == 'UK')) {
            			entry.label = $("#filterIsRoxable").val();
            		} else if (facetIdentifier === 'RANGE' && $plpSearchObj.facetsForFilterBy[facetIdentifier] === 'Collaboration') {
            			entry.label = $("#filterCollaboration").val();
                        entry.isprova = false;
            		} else if (facetIdentifier === 'RANGE' && $plpSearchObj.facetsForFilterBy[facetIdentifier] === 'Icona') {
            			entry.label = $("#filterIcon").val();
            		} else if(facetIdentifier === 'HIGH_PRESCRIPTION'&& $plpSearchObj.facetsForFilterBy[facetIdentifier] === 'True'
                    && (WCParamJS.countryCode.toUpperCase() == 'DE' || WCParamJS.countryCode.toUpperCase() == 'US' || WCParamJS.countryCode.toUpperCase() == 'UK')){
                        entry.label = $("#filterHighPrescription").val();
                    } 
                    else {
            			entry.label = facetView[key].name;
                        
                       
            		}
            		specialFacetView.entry.push(entry);
            	}
            }
        } else
        	// remove facets to be ignored
        	if (!$plpSearchObj.facetsToBeIgnored.includes(facetIdentifier)) {
                var facet = facetView[key];
                for (var e in facet.entry) {
                    var entry = facet.entry[e];
                    if(facetIdentifier === 'GEO_FIT' || facetIdentifier === 'FRAME_FIT'){
                        entry.isCheckboxFliter = true;
                        var storetexName =  entry.label.toUpperCase();
                        storetexName = storetexName.replaceAll(" ","_");
                        storetexName = storetexName + "_PLP";
                        storetexName = storetexName.replaceAll("É","E");
                        storetexName = storetexName.replaceAll("À","A");
                        storetexName = storetexName.replaceAll("Á","A");
                        var description = $('#'+storetexName).val();
                        if(description != undefined){
                            entry.storetexName = $('#'+storetexName).val();
                        }else{
                            entry.storetexName = "";
                        }
                        if( facetIdentifier === 'FRAME_FIT'){
                            entry.isFrameFit = true;
                        }else{
                            entry.isFrameFit = false;
                        }
                       // var identifierKey = facetIdentifier +'_'+ entry.label.toString().toLowerCase(); 
                       // entry.identifierAttrVal = $plpSearchObj.attrValIdentifierObject[identifierKey];
                    }else if(facetIdentifier === 'MODEL_SIZE_DISPLAY_PLP'){
						entry.isSizeFilter = true;
					}
                    
                }

        		facetViewNew.push(facetView[key]);
        	}
    }
    facetViewNew.unshift(specialFacetView);

    return facetViewNew;
}


/**
 * @function toggleFilter
 * @desc This function checks every facet and adds or removes the disabled class when the filter count is 0 or more
 */
function toggleFilter(elem,data) {
    var facetElem;
    var facetCount = 0;
    var facetValues = Object.keys(data.facetView).map(function(e) {
    	return data.facetView[e];
    });
    for (var i in facetValues) {
        var facet = data.facetView[i];
        var facetEntries = facet.entry && Object.keys(facet.entry).map(function(e) {
        	return facet.entry[e];
        });
    	for (var j in facetEntries) {
            var facetEntry = facet.entry[j];
            if (facetEntry.extendedData
            		&& $(elem).attr('id').includes("facet_" + facetEntry.extendedData.uniqueId)) {
                facetElem = $(elem)[0];
                facetCount = facetEntry.count;
                break;
            }
        }
    }
    if (facetElem !== undefined) {
        if(facetElem !== null){
            if(facetCount === '0' && !facetElem.classList.contains('selected')) {
                facetElem.classList.remove('selected');
                facetElem.classList.add('disabled');
            } else if(facetCount !== '0' && facetElem.classList.contains('disabled')) {
                facetElem.classList.remove('disabled');
            }
        }
    } else {
        $(elem)[0].classList.add('disabled');
    }
}


function getProductModel(productId) {

	var model;

	// Compose service url
	var productServiceUrl = WCParamJS.urlPrefixForHTTPS + "/search/resources/store/" + WCParamJS.storeId + "/productview/byId/" + productId + "?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + "&profileName=LUX_findProductByIds_Details&isForPLP=true";

	// Call service
    return new Promise((resolve, reject) => {
        $.getJSON(productServiceUrl, function(data) {
            model = data["catalogEntryView"];
            // To align objects with those expected by Mustache
            model.forEach(function(m, index) {
                m["modelCode"] = m["mfPartNumber_ntk"];
            });
        }).done(function(data) {
            resolve(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() ? model[0] : model);
        }).fail(function(error) {
            reject(error);
        });
    });
  
}



/**
 * @function checkForPreviousFilters
 * @desc Function that checks for previous filters and selects them in the menu
 */
function checkForPreviousFilters() {
    countSelectedFacets = 0;
    var params = getUrlFacets();
        //Check for previous filters
        if(params) {
            for(var key in params) {
                var facetElement = $("button[data-facet='"+params[key]+"']");
                if(facetElement.length == 0){
                    facetElement = $("label[data-facet='"+params[key]+"']");
                    $(facetElement).parent().children('input').prop('checked', true);
                }
                facetElement.parent().addClass("selected");
                if(key.includes("facet_") || key.includes("facetName_") || key.includes("orderBy")) {
                    selectedFacets[params[key]] = facetElement.attr('data-facet-name-en');
                    previousFilter[key] = params[key];
                    countSelectedFacets++;
                }
            }
            // Show number of selected facets in the filter button
            if (countSelectedFacets >= 1) {
            	$('.filter__button-number').addClass('active');
            	$('.filter__button-number').text(countSelectedFacets);
            } else {
            	$('.filter__button-number').removeClass('active');
            }

                //count how many filters are selected and update the counter for each facet
                $('#productsFacets > div:not(#section_SORT_BY)').each(function() {
                    var selectedCount = $(this).find('.facet__options').find('li.selected').length;

                    setFacetsCounters($(this).find('.facet__title .facet_counter'), selectedCount);
                });
        }
}




/**
 * @funtion getUrlParams
 * @desc This function gets all the URL params as a object
 */
function getUrlFacets() {
    var params = {};
    var i = 1;
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        if (key.includes('facet')) {
            params["facet_"+i] = value;
        }
        i++;
    });
    return params;
}


$plpSearchObj.viewMoreTiles = function(howMany){
    if (!$plpSearchObj.busy) {
       if (isOliver) {
            $("#plp_grid").css("padding-bottom","2.5rem");
       } 
       setTimeout(function(){
           $plpSearchObj.busy = false;
           createNewTileProducts($plpSearchObj.viewIndex,howMany);
           if (isOliver) {
                $("#plp_grid").css("padding-bottom","");
           }
       },500);
       $plpSearchObj.busy = true;
    }
};


function espotPOBadge(badgeId, animationDuration) {

	var badgeCookie = getCookie(badgeId + 'CalloutCookie');
	if (badgeCookie) return;

	if (window.tabletPortraitCheck() || window.mobilecheck()) {
		// Mobile - Vertical axis
		$('.' + badgeId).animate({ opacity: "1", top: "95px" }, animationDuration);

		document.addEventListener("scroll", function() {
			var badgeCookie = getCookie(badgeId + 'CalloutCookie');
			if (badgeCookie) return;

			if (!badgeVisible && document.documentElement.scrollTop <= 100) {
				badgeVisible = true;
				$('.' + badgeId).stop().animate({ opacity: "1", top: "95px" }, animationDuration);
			}

			var topHide = $('div.grid-item').first().offset().top - 200;
			if (badgeVisible && document.documentElement.scrollTop >= topHide) {
				badgeVisible = false;
				$('.' + badgeId).stop().animate({ opacity: "0", top: "-150px" }, animationDuration);
			}
		});

		$('.' + badgeId + '-close a').click(function() {
			$('.' + badgeId).stop().animate({ opacity: "0", top: "-150px" }, animationDuration);
			setCookie(badgeId + 'CalloutCookie', true, {expires: 1});
		});

	} else {
		// Descktop - Horizontal axis
		$('.' + badgeId).animate({ opacity: "1", right: "50px" }, animationDuration);

		document.addEventListener("scroll", function() {
			var badgeCookie = getCookie(badgeId + 'CalloutCookie');
			if (badgeCookie) return;
 
			var topHide = $('div.grid-item').first().offset().top - 300;
			if (!badgeVisible && document.documentElement.scrollTop <= topHide) {
				badgeVisible = true;
				$('.' + badgeId).stop().animate({ opacity: "1", right: "50px" }, animationDuration);
			}


			if (badgeVisible && document.documentElement.scrollTop >= topHide) {
				badgeVisible = false;
				$('.' + badgeId).stop().animate({ opacity: "0", right: "-550px" }, animationDuration);
			}
		});

		$('.' + badgeId + '-close a').click(function() {
			$('.' + badgeId).stop().animate({ opacity: "0", right: "-550px" }, animationDuration);
			setCookie(badgeId + 'CalloutCookie', true, {expires: 1});
		});
	}
}


function espotBadge(badgeId, animationDuration) {

	var badgeCookie = getCookie(badgeId + 'CalloutCookie');
	if (badgeCookie) return;

	if (window.tabletPortraitCheck() || window.mobilecheck()) {
		// Mobile - Vertical axis
		$('#' + badgeId).animate({ opacity: "1", top: "50px" }, animationDuration);

		document.addEventListener("scroll", function() {
			var badgeCookie = getCookie(badgeId + 'CalloutCookie');
			if (badgeCookie) return;

			if (!badgeVisible && document.documentElement.scrollTop <= 100) {
				badgeVisible = true;
				$('#' + badgeId).stop().animate({ opacity: "1", top: "50px" }, animationDuration);
			}

			var topHide = $('div.grid-item').first().offset().top - 200;
			if (badgeVisible && document.documentElement.scrollTop >= topHide) {
				badgeVisible = false;
				$('#' + badgeId).stop().animate({ opacity: "0", top: "-150px" }, animationDuration);
			}
		});

		$('.' + badgeId + '-close a').click(function() {
			$('#' + badgeId).stop().animate({ opacity: "0", top: "-150px" }, animationDuration);
			setCookie(badgeId + 'CalloutCookie', true, {expires: 1});
		});

	} else {
		// Desktop - Horizontal axis
		$('#' + badgeId).animate({ opacity: "1", right: "50px" }, animationDuration);

		document.addEventListener("scroll", function() {
			var badgeCookie = getCookie(badgeId + 'CalloutCookie');
			if (badgeCookie) return;

			var topHide = $('div.grid-item').first().offset().top - 300;
			if (!badgeVisible && document.documentElement.scrollTop <= topHide) {
				badgeVisible = true;
				$('#' + badgeId).stop().animate({ opacity: "1", right: "50px" }, animationDuration);
			}


			if (badgeVisible && document.documentElement.scrollTop >= topHide) {
				badgeVisible = false;
				$('#' + badgeId).stop().animate({ opacity: "0", right: "-550px" }, animationDuration);
			}
		});

		$('.' + badgeId + '-close a').click(function() {
			$('#' + badgeId).stop().animate({ opacity: "0", right: "-550px" }, animationDuration);
			setCookie(badgeId + 'CalloutCookie', true, {expires: 1});
		});
	}
}

function initDashButtonScrollPLP(){
    var scrollContainer = $('.espot-plp-beans');

    manageHorizontalDeskstopScroll(scrollContainer,false);

    $(".plp-filter-button_wrapper .next-arrow").on("click", function() { // manage arrow click dashbutton
            var scrollStep = $(window).width() / 2; //scrolleft half the screen width 
        $(scrollContainer).animate({
            scrollLeft: "+=" + scrollStep
        }, "slow",function(){

            dashButtonCheckArrow(true);
        });
    })

    
    $(".plp-filter-button_wrapper .prev-arrow").on("click", function() { // manage arrow click dashbutton
        var scrollStep = $(window).width() / 2; //scrolleft half the screen width 
    $(scrollContainer).animate({
        scrollLeft: "-=" + scrollStep
    }, "slow",function(){

        dashButtonCheckArrow(true);
    });
})

    scrollContainer.on("scroll", function() {
            dashButtonCheckArrow(true);
    });


}



function manageHorizontalDeskstopScroll(scrollContainer,isPLPOtherColorCarousel) {

    if (!window.tabletPortraitCheck() || !window.mobilecheck()){
        const sliders = scrollContainer;

        sliders.each(function() {
            let isDown = false;
            let startX;
            let scrollLeft;
            let drag = false;

            const slider = $(this);

            if(isPLPOtherColorCarousel){
                slider.find(".image-container").click(function(element) {
                    const clickedElement = $(element.currentTarget);
                    var clickEventData =  clickedElement ;
                
                    // Scatena manualmente l'evento mouseup sull'elemento genitore (slider)
                    slider.trigger('mouseup',clickEventData);
                });
            }

            slider.on('mousedown', (e) => {
                isDown = true;
                slider.addClass('active');
                startX = e.pageX - slider.offset().left;
                scrollLeft = slider.scrollLeft();
                drag = false;
            });

            slider.on('mouseleave', () => {
                isDown = false;
                slider.removeClass('active');
            });

            slider.on('mouseup', (event, elemetClicked) => {
                isDown = false;
                slider.removeClass('active');
                if(isPLPOtherColorCarousel){
                    if (drag) {
                        console.log("no-click");
                    } else {
                        console.log("ClickFunziona");
                        if(elemetClicked){
                            changeSlickSlide(elemetClicked);
                        }
                        
                    }
                }     
            });

            slider.on('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offset().left;
                const walk = (x - startX) * 1;
                slider.scrollLeft(scrollLeft - walk);
                console.log(walk);
                drag = true;
            });
        });

        
    }

    if(!isPLPOtherColorCarousel){
        dashButtonCheckArrow();// check if show arrow
    }
    
}


function dashButtonCheckArrow(afterScroll){

    var container = $('.espot-plp-beans');
    var contentWidth = $(".espot-plp-beans  .nav-beans").outerWidth();
    if(afterScroll){
        if (Math.round(container.scrollLeft()) == 0){
            $(".plp-filter-button_wrapper .prev-arrow").addClass("arrow-disable");
            $(".plp-filter-button_wrapper .next-arrow").removeClass("arrow-disable");
        }else if (Math.round(container.scrollLeft()) >= Math.round(contentWidth - container.width())) {
          $(".plp-filter-button_wrapper .next-arrow").addClass("arrow-disable");
          $(".plp-filter-button_wrapper .prev-arrow").removeClass("arrow-disable");
        }else{
            $(".plp-filter-button_wrapper .next-arrow").removeClass("arrow-disable");
            $(".plp-filter-button_wrapper .prev-arrow").removeClass("arrow-disable");
        }
    }else{
        if(contentWidth >= container.width()){
            $(".plp-filter-button_wrapper .next-arrow").removeClass("arrow-disable");
        } 
    }

}


function getCurrentPagePLP(){

    var categoryName = $("#categoryName").val();
    var highPrescriptionFilter = $("#filtersContainer [data-facet-name-en='" + "Strong Prescription" +"']").attr("data-facet");
    if(window.location.href.toString().includes(highPrescriptionFilter)){// if include High PrescriptionFilter
        $( ".espot-plp-beans .nav-beans li" ).each(function(i,tile) {
			if(isPersol){
				$(tile).removeClass("nav-bean--active");
			}else if(isOliver){
				$(tile).removeClass("ct-active");
			}
            
        });
		if(isPersol){
			$( ".espot-plp-beans .nav-beans #HighPrescription" ).addClass("nav-bean--active");
		}else if(isOliver){
			$(".espot-plp-beans .nav-beans .strong_prescription_filter" ).addClass("ct-active");
			$(".espot-plp-beans .nav-beans .strong_prescription_filter" ).addClass("ct-active");
		}
        
    }else{    
        $( ".espot-plp-beans .nav-beans li" ).each(function(i,tile) {
			if(isPersol){
				if($(tile).data("category-name") == categoryName){
					$(tile).addClass("nav-bean--active");
				}else{
					$(tile).removeClass("nav-bean--active");
				}
			}else if(isOliver){
				if($(tile).data("ct-category") == categoryName){
					$(tile).addClass("ct-active");
				}else{
					$(tile).removeClass("ct-active");
				}
			}
           
        });
    }  

}

function manageScrollBehaviourPLP(){  
    var topBannerHidden  = isPersol ?  ($('.ct-promo-bannerTop').height() == 0 || $('.ct-promo-bannerTop').length == 0 ) : ( $('#headerRow1').height() == 0 || $('#headerRow1').length == 0); //check if there is promo banner at top of the page
    if(topBannerHidden){
         $("[data-espot-name='X_Nav_InfoBanner'] .ct-info-strip").addClass("noHeaderInfo");
        $('.plp-filter-button').addClass("noHeaderInfoStickyButton");
    }
    if(isPersol){
        if((window.tabletPortraitCheck() || window.mobilecheck())){
            var topStickyButton = 8 + parseFloat($('.plp-filter-button').css("margin-top"));
        }else{
            var topStickyButton = 24 + parseFloat($('.plp-filter-button').css("margin-top"));
        }
    }else if(isOliver){
        if((window.tabletPortraitCheck() || window.mobilecheck())){
            var topStickyButton = 16;
        }else{
            var topStickyButton = 40;
        }
        
    }
    var lastScrollTop = 0;
    var filterButtonOriginalTop = $('.plp-filter-view-button').offset().top + parseFloat($('.plp-filter-button').css("margin-top") ); // height "filter&sort" parent
    window.addEventListener('scroll', function(){
        if(lastScrollTop < $(this).scrollTop()){ //if user scroll down
            if($(this).scrollTop() >= filterButtonOriginalTop - topStickyButton){ //if user scroll more than  "filter&sort" button 
                $('.plp-filter-button').addClass("sticky-filter-button");
            }
            $('#header').removeClass("sticky-header");
        }else if(lastScrollTop > $(this).scrollTop()){
            if(($(this).scrollTop() > 0)){ //if user scroll down 
                var actualTopButton = parseFloat($('.plp-filter-button').css("top").replace("px", "")) + parseFloat($('.plp-filter-button').css("margin-top").replace("px", ""))
                if($(this).scrollTop() <= (filterButtonOriginalTop - actualTopButton)){ // the user scrolls to the actual button position. From bottom to top.
                        $('.plp-filter-button').removeClass("sticky-filter-button");
                    }
                    $('#header').addClass("sticky-header");
                            
            }else{
                $('.plp-filter-button').removeClass("sticky-filter-button");
                $('#header').removeClass("sticky-header");
            }			
        }

        lastScrollTop = $(this).scrollTop();

    });

    
}
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        // If any child element receives focus within the slider we need to pause the autoplay
        _.$slider
            .off('focus.slick blur.slick')
            .on(
                'focus.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    setTimeout(function() {
                        if( _.options.pauseOnFocus ) {
                            if ($sf.is(':focus')) {
                                _.focussed = true;
                                _.autoPlay();
                            }
                        }
                    }, 0);
                }
            ).on(
                'blur.slick',
                '*',
                function(event) {
                    var $sf = $(this);

                    // When a blur occurs on any elements within the slider we become unfocused
                    if( _.options.pauseOnFocus ) {
                        _.focussed = false;
                        _.autoPlay();
                    }
                }
            );
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, swipeTarget, centerOffset;

        centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
        swipeTarget = (_.swipeLeft * -1) + centerOffset;

        if (_.options.swipeToSlide === true) {

            _.$slideTrack.find('.slick-slide').each(function(index, slide) {

                var slideOuterWidth, slideOffset, slideRightBoundary;
                slideOuterWidth = $(slide).outerWidth();
                slideOffset = slide.offsetLeft;
                if (_.options.centerMode !== true) {
                    slideOffset += (slideOuterWidth / 2);
                }

                slideRightBoundary = slideOffset + (slideOuterWidth);

                if (swipeTarget < slideRightBoundary) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));
